
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6056"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6056"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i9BKe", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $2726d886f4171354$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $2726d886f4171354$export$cc3e2d3244e01b7f);
"use strict";
var $2726d886f4171354$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    ExtensionType2["ShapeBuilder"] = "shape-builder";
    ExtensionType2["Batcher"] = "batcher";
    return ExtensionType2;
})($2726d886f4171354$export$4f037c6ec2da4eeb || {});
const $2726d886f4171354$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $2726d886f4171354$export$ba4241979983e013 = (ext, defaultPriority)=>$2726d886f4171354$var$normalizeExtension(ext).priority ?? defaultPriority;
const $2726d886f4171354$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */ remove (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */ add (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b.value, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    },
    /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */ mixin (Target, ...sources) {
        for (const source of sources)Object.defineProperties(Target.prototype, Object.getOwnPropertyDescriptors(source));
    }
};

});

parcelRegister("7QYPQ", function(module, exports) {
module.exports = Promise.all([
    import("13nTW"),
    import("dCEEN")
]).then(()=>parcelRequire('gFyHJ'));

});

parcelRegister("54sBz", function(module, exports) {
module.exports = Promise.all([
    import("13nTW"),
    import("5zD7l")
]).then(()=>parcelRequire('danRq'));

});

parcelRegister("7dx1H", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $7h8HJ = parcelRequire("7h8HJ");

var $lLQso = parcelRequire("lLQso");

var $jXXId = parcelRequire("jXXId");

var $jMNJq = parcelRequire("jMNJq");

var $8xl7d = parcelRequire("8xl7d");

var $aQPld = parcelRequire("aQPld");

var $hNatJ = parcelRequire("hNatJ");
parcelRequire("8QN7n");

"use strict";
(0, $i9BKe.extensions).add((0, $7h8HJ.AlphaMask), (0, $lLQso.ColorMask), (0, $jXXId.StencilMask), (0, $hNatJ.VideoSource), (0, $aQPld.ImageSource), (0, $8xl7d.CanvasSource), (0, $jMNJq.BufferImageSource));

});
parcelRegister("7h8HJ", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $90469dbfa4a0e350$export$3c32667be409917c);

var $i9BKe = parcelRequire("i9BKe");

var $4rhnu = parcelRequire("4rhnu");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $90469dbfa4a0e350$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.inverse = false;
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $4rhnu.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        if (!this.inverse) (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $4rhnu.Sprite);
    }
}
$90469dbfa4a0e350$export$3c32667be409917c.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});
parcelRegister("4rhnu", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $2ddac34a8a6af484$export$3075603db8e6204c);

var $a32F4 = parcelRequire("a32F4");

var $bLlTJ = parcelRequire("bLlTJ");

var $f8J9J = parcelRequire("f8J9J");

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
class $2ddac34a8a6af484$export$3075603db8e6204c extends (0, $b9FQU.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $bLlTJ.Texture).EMPTY){
        if (options instanceof (0, $bLlTJ.Texture)) options = {
            texture: options
        };
        const { texture: texture = (0, $bLlTJ.Texture).EMPTY, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "sprite";
        /** @internal */ this.batched = true;
        this._visualBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (texture.defaultAnchor) this.anchor = texture.defaultAnchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $bLlTJ.Texture)) return new $2ddac34a8a6af484$export$3075603db8e6204c(source);
        return new $2ddac34a8a6af484$export$3075603db8e6204c((0, $bLlTJ.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $bLlTJ.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        if (this._width) this._setWidth(this._width, this._texture.orig.width);
        if (this._height) this._setHeight(this._height, this._texture.orig.height);
        this.onViewUpdate();
    }
    /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */ get texture() {
        return this._texture;
    }
    /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */ get visualBounds() {
        (0, $f8J9J.updateQuadBounds)(this._visualBounds, this._anchor, this._texture);
        return this._visualBounds;
    }
    /**
   * @deprecated
   * @ignore
   */ get sourceBounds() {
        (0, $kXq8E.deprecation)("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead.");
        return this.visualBounds;
    }
    /** @private */ updateBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const bounds = this._bounds;
        const { width: width, height: height } = texture.orig;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._visualBounds = null;
        this._bounds = null;
        this._anchor = null;
        this._gpuData = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
        this._width = value;
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
        this._height = value;
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this._texture.orig.width);
        height !== void 0 && this._setHeight(height, this._texture.orig.height);
    }
}

});
parcelRegister("a32F4", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $702ea64f2b15c76d$export$3755aaad3fd42e52);
"use strict";
class $702ea64f2b15c76d$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */ clone(observer) {
        return new $702ea64f2b15c76d$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
    }
    /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("bLlTJ", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $dd4e44a750d6d26c$export$5431306cf43de24a);

var $3vRz3 = parcelRequire("3vRz3");

var $2RwkA = parcelRequire("2RwkA");

var $fM4Mk = parcelRequire("fM4Mk");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $2coCi = parcelRequire("2coCi");

var $jMNJq = parcelRequire("jMNJq");

var $iA5fe = parcelRequire("iA5fe");

var $jNN6Y = parcelRequire("jNN6Y");
"use strict";
class $dd4e44a750d6d26c$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param {TextureOptions} options - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate, dynamic: dynamic } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $aGJhg.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $fM4Mk.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /**
     * Set to true if you plan on modifying the uvs of this texture.
     * When this is the case, sprites and other objects using the texture will
     * make sure to listen for changes to the uvs and update their vertices accordingly.
     */ this.dynamic = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $iA5fe.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.dynamic = dynamic || false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $jNN6Y.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $2RwkA.groupD8).add(rotate, (0, $2RwkA.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $iA5fe.TextureSource)({
        label: "EMPTY"
    })
});
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY.destroy = (0, $2coCi.NOOP);
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    source: new (0, $jMNJq.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE.destroy = (0, $2coCi.NOOP);

});
parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("2RwkA", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $99d48e5a2f9844ff$export$b7bb6a2a8d203102);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $99d48e5a2f9844ff$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $99d48e5a2f9844ff$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $99d48e5a2f9844ff$var$rotationCayley = [];
const $99d48e5a2f9844ff$var$rotationMatrices = [];
const $99d48e5a2f9844ff$var$signum = Math.sign;
function $99d48e5a2f9844ff$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $99d48e5a2f9844ff$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _uy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _vx = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$vy[j]);
            const _vy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($99d48e5a2f9844ff$var$ux[k] === _ux && $99d48e5a2f9844ff$var$uy[k] === _uy && $99d48e5a2f9844ff$var$vx[k] === _vx && $99d48e5a2f9844ff$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $eY4rt.Matrix)();
        mat.set($99d48e5a2f9844ff$var$ux[i], $99d48e5a2f9844ff$var$uy[i], $99d48e5a2f9844ff$var$vx[i], $99d48e5a2f9844ff$var$vy[i], 0, 0);
        $99d48e5a2f9844ff$var$rotationMatrices.push(mat);
    }
}
$99d48e5a2f9844ff$var$init();
const $99d48e5a2f9844ff$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$99d48e5a2f9844ff$var$ux[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$99d48e5a2f9844ff$var$uy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$99d48e5a2f9844ff$var$vx[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$99d48e5a2f9844ff$var$vy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.S;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.E;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SE;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NE;
        return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $99d48e5a2f9844ff$var$rotationMatrices[$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};

});
parcelRegister("eY4rt", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85);

var $aWW4e = parcelRequire("aWW4e");

var $1HooC = parcelRequire("1HooC");
"use strict";
class $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /**
     * Array representation of the matrix.
     * Only populated when `toArray()` is called.
     * @default null
     * @see {@link Matrix.toArray} For filling this array
     */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $aWW4e.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */ static get IDENTITY() {
        return $fd3f7bfaf4af3d85$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */ static get shared() {
        return $fd3f7bfaf4af3d85$var$tempMatrix.identity();
    }
}
const $fd3f7bfaf4af3d85$var$tempMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
const $fd3f7bfaf4af3d85$var$identityMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();

});
parcelRegister("aWW4e", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $635707f32e142ac4$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $635707f32e142ac4$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $635707f32e142ac4$export$870617f62e3187f1);
"use strict";
const $635707f32e142ac4$export$59ed0a0a5de1084b = Math.PI * 2;
const $635707f32e142ac4$export$3f91627dc85c5d57 = 180 / Math.PI;
const $635707f32e142ac4$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("1HooC", function(module, exports) {

$parcel$export(module.exports, "Point", () => $fdaff9f788d94485$export$baf26146a414f24a);
"use strict";
class $fdaff9f788d94485$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /**
     * Position of the point on the x axis
     * @example
     * ```ts
     * // Set x position
     * const point = new Point();
     * point.x = 100;
     *
     * // Use in calculations
     * const width = rightPoint.x - leftPoint.x;
     * ```
     */ this.x = 0;
        /**
     * Position of the point on the y axis
     * @example
     * ```ts
     * // Set y position
     * const point = new Point();
     * point.y = 200;
     *
     * // Use in calculations
     * const height = bottomPoint.y - topPoint.y;
     * ```
     */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */ clone() {
        return new $fdaff9f788d94485$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */ static get shared() {
        $fdaff9f788d94485$var$tempPoint.x = 0;
        $fdaff9f788d94485$var$tempPoint.y = 0;
        return $fdaff9f788d94485$var$tempPoint;
    }
}
const $fdaff9f788d94485$var$tempPoint = new $fdaff9f788d94485$export$baf26146a414f24a();

});



parcelRegister("fM4Mk", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $55a82579353c67d9$export$4617fb02663045ef);

var $1HooC = parcelRequire("1HooC");
"use strict";
const $55a82579353c67d9$var$tempPoints = [
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)()
];
class $55a82579353c67d9$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Rectangle(0, 0, 100, 100);
     * console.log(shape.type); // 'rectangle'
     *
     * // Use in type guards
     * if (shape.type === 'rectangle') {
     *     console.log(shape.width, shape.height);
     * }
     * ```
     * @readonly
     * @default 'rectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */ get left() {
        return this.x;
    }
    /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */ get right() {
        return this.x + this.width;
    }
    /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */ get top() {
        return this.y;
    }
    /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */ get bottom() {
        return this.y + this.height;
    }
    /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */ static get EMPTY() {
        return new $55a82579353c67d9$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $55a82579353c67d9$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const outerLeft = _x - strokeWidthOuter;
        const outerRight = _x + width + strokeWidthOuter;
        const outerTop = _y - strokeWidthOuter;
        const outerBottom = _y + height + strokeWidthOuter;
        const innerLeft = _x + strokeWidthInner;
        const innerRight = _x + width - strokeWidthInner;
        const innerTop = _y + strokeWidthInner;
        const innerBottom = _y + height - strokeWidthInner;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $55a82579353c67d9$var$tempPoints[0].set(other.left, other.top);
        const lb = $55a82579353c67d9$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $55a82579353c67d9$var$tempPoints[2].set(other.right, other.top);
        const rb = $55a82579353c67d9$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */ getBounds(out) {
        out || (out = new $55a82579353c67d9$export$4617fb02663045ef());
        out.copyFrom(this);
        return out;
    }
    /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(container.containsRect(empty)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */ containsRect(other) {
        if (this.width <= 0 || this.height <= 0) return false;
        const x1 = other.x;
        const y1 = other.y;
        const x2 = other.x + other.width;
        const y2 = other.y + other.height;
        return x1 >= this.x && x1 < this.x + this.width && y1 >= this.y && y1 < this.y + this.height && x2 >= this.x && x2 < this.x + this.width && y2 >= this.y && y2 < this.y + this.height;
    }
    /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */ set(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        return this;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("aGJhg", function(module, exports) {

$parcel$export(module.exports, "uid", () => $aa9685d46d70e8a7$export$e2a22331486dcca0);
"use strict";
const $aa9685d46d70e8a7$var$uidCache = {
    default: -1
};
function $aa9685d46d70e8a7$export$e2a22331486dcca0(name = "default") {
    if ($aa9685d46d70e8a7$var$uidCache[name] === void 0) $aa9685d46d70e8a7$var$uidCache[name] = -1;
    return ++$aa9685d46d70e8a7$var$uidCache[name];
}
function $aa9685d46d70e8a7$export$220409b686c277d0() {
    for(const key in $aa9685d46d70e8a7$var$uidCache)delete $aa9685d46d70e8a7$var$uidCache[key];
}

});

parcelRegister("kXq8E", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $86481ab6f435a4d7$export$dc79da96439604f0);
$parcel$export(module.exports, "v8_3_4", () => $86481ab6f435a4d7$export$e88af00f5d3e8bcc);
$parcel$export(module.exports, "deprecation", () => $86481ab6f435a4d7$export$afd31d834b512e89);
"use strict";
const $86481ab6f435a4d7$var$warnings = {};
const $86481ab6f435a4d7$export$dc79da96439604f0 = "8.0.0";
const $86481ab6f435a4d7$export$e88af00f5d3e8bcc = "8.3.4";
function $86481ab6f435a4d7$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($86481ab6f435a4d7$var$warnings[message]) return;
    let stack = new Error().stack;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (console.groupCollapsed) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
            console.warn(stack);
        }
    }
    $86481ab6f435a4d7$var$warnings[message] = true;
}

});

parcelRegister("2coCi", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $342f4d0330a1a110$export$5702a91a6f42969f);
"use strict";
const $342f4d0330a1a110$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("jMNJq", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $38c8a704e7d4a191$export$1872462350fcb7cd);

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $38c8a704e7d4a191$export$1872462350fcb7cd extends (0, $iA5fe.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$38c8a704e7d4a191$export$1872462350fcb7cd.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iA5fe", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $50e6ce3cf0e8b717$export$8498e6a2e655d3d8);

var $3vRz3 = parcelRequire("3vRz3");

var $NbSCN = parcelRequire("NbSCN");

var $dr868 = parcelRequire("dr868");

var $aGJhg = parcelRequire("aGJhg");

var $aFPUT = parcelRequire("aFPUT");
"use strict";
const $50e6ce3cf0e8b717$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** unique id for this Texture source */ this.uid = (0, $aGJhg.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @internal
     */ this.uploadMethodId = "unknown";
        /** @internal */ this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     */ this.sampleCount = 1;
        /** The number of mip levels to generate for this texture. this is  overridden if autoGenerateMipmaps is true */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $aFPUT.TextureStyle)((0, $dr868.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution || (resolution = this._resolution);
        width || (width = this.width);
        height || (height = this.height);
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $NbSCN.isPow2)(this.pixelWidth) && (0, $NbSCN.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $50e6ce3cf0e8b717$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $50e6ce3cf0e8b717$export$8498e6a2e655d3d8 = $50e6ce3cf0e8b717$var$_TextureSource;

});
parcelRegister("NbSCN", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $445bbf816b14b66c$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $445bbf816b14b66c$export$eb50b9c078eb6ae7);
"use strict";
function $445bbf816b14b66c$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $445bbf816b14b66c$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $445bbf816b14b66c$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("dr868", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $c5dcc841d9b9a11e$export$801feaffb936a09d);
"use strict";
function $c5dcc841d9b9a11e$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("aFPUT", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $46d9af7c4b00e80a$var$idHash = /* @__PURE__ */ Object.create(null);
function $46d9af7c4b00e80a$var$createResourceIdFromString(value) {
    const id = $46d9af7c4b00e80a$var$idHash[value];
    if (id === void 0) $46d9af7c4b00e80a$var$idHash[value] = (0, $aGJhg.uid)("resource");
    return id;
}
const $46d9af7c4b00e80a$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        /** @internal */ this._resourceType = "textureSampler";
        /** @internal */ this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link TextureStyle#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link TextureStyle#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     */ this._maxAnisotropy = 1;
        /**
     * Has the style been destroyed?
     * @readonly
     */ this.destroyed = false;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this.emit("change", this);
        this._sharedResourceId = null;
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $46d9af7c4b00e80a$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $46d9af7c4b00e80a$var$_TextureStyle.defaultOptions = {
    addressMode: "clamp-to-edge",
    scaleMode: "linear"
};
let $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5 = $46d9af7c4b00e80a$var$_TextureStyle;

});



parcelRegister("jNN6Y", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $707e20d60f27daa2$export$dbea3135e9da48cb);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $707e20d60f27daa2$var$tempMat = new (0, $eY4rt.Matrix)();
class $707e20d60f27daa2$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $eY4rt.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this.texture === value) return;
        this._texture?.removeListener("update", this.update, this);
        this._texture = value;
        this._texture.addListener("update", this.update, this);
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $707e20d60f27daa2$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($707e20d60f27daa2$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset / texBase._resolution;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = this.clampOffset / texBase.pixelWidth;
        this.uClampOffset[1] = this.clampOffset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("f8J9J", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $67aa708353891905$export$558ce66aa5723f1d);
"use strict";
function $67aa708353891905$export$558ce66aa5723f1d(bounds, anchor, texture) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});

parcelRegister("b9FQU", function(module, exports) {

$parcel$export(module.exports, "ViewContainer", () => $950433d02344dbbb$export$19fb617b96998849);

var $7wtv9 = parcelRequire("7wtv9");

var $eicwU = parcelRequire("eicwU");
"use strict";
class $950433d02344dbbb$export$19fb617b96998849 extends (0, $eicwU.Container) {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(options){
        super(options);
        /** @internal */ this.canBundle = true;
        /** @internal */ this.allowChildren = false;
        /** @internal */ this._roundPixels = 0;
        /** @internal */ this._lastUsed = -1;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        this._bounds = new (0, $7wtv9.Bounds)(0, 1, 0, 0);
        this._boundsDirty = true;
    }
    /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this.updateBounds();
        this._boundsDirty = false;
        return this._bounds;
    }
    /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const bounds = this.bounds;
        const { x: x, y: y } = point;
        return x >= bounds.minX && x <= bounds.maxX && y >= bounds.minY && y <= bounds.maxY;
    }
    /** @private */ onViewUpdate() {
        this._didViewChangeTick++;
        this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
    }
    destroy(options) {
        super.destroy(options);
        this._bounds = null;
        for(const key in this._gpuData)this._gpuData[key].destroy?.();
        this._gpuData = null;
    }
    /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */ collectRenderablesSimple(instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        renderPipes.blendMode.setBlendMode(this, this.groupBlendMode, instructionSet);
        const rp = renderPipes;
        rp[this.renderPipeId].addRenderable(this, instructionSet);
        this.didViewUpdate = false;
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
    }
}

});
parcelRegister("7wtv9", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $0b15abb3a529f09f$export$c4e9d269599ab4b4);

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $0b15abb3a529f09f$var$defaultMatrix = new (0, $eY4rt.Matrix)();
class $0b15abb3a529f09f$export$c4e9d269599ab4b4 {
    /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */ constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X coordinate of the bounds.
     * Represents the leftmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set left edge
     * bounds.minX = 100;
     * ```
     * @default Infinity
     */ this.minX = Infinity;
        /**
     * The minimum Y coordinate of the bounds.
     * Represents the topmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set top edge
     * bounds.minY = 100;
     * ```
     * @default Infinity
     */ this.minY = Infinity;
        /**
     * The maximum X coordinate of the bounds.
     * Represents the rightmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set right edge
     * bounds.maxX = 200;
     * // Get width
     * const width = bounds.maxX - bounds.minX;
     * ```
     * @default -Infinity
     */ this.maxX = -Infinity;
        /**
     * The maximum Y coordinate of the bounds.
     * Represents the bottommost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set bottom edge
     * bounds.maxY = 200;
     * // Get height
     * const height = bounds.maxY - bounds.minY;
     * ```
     * @default -Infinity
     */ this.maxY = -Infinity;
        /**
     * The transformation matrix applied to this bounds object.
     * Used when calculating bounds with transforms.
     * @example
     * ```ts
     * const bounds = new Bounds();
     *
     * // Apply translation matrix
     * bounds.matrix = new Matrix()
     *     .translate(100, 100);
     *
     * // Combine transformations
     * bounds.matrix = new Matrix()
     *     .translate(50, 50)
     *     .rotate(Math.PI / 4)
     *     .scale(2, 2);
     *
     * // Use in bounds calculations
     * bounds.addFrame(0, 0, 100, 100); // Uses current matrix
     * bounds.addFrame(0, 0, 100, 100, customMatrix); // Override matrix
     * ```
     * @advanced
     */ this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $fM4Mk.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */ fitBounds(left, right, top, bottom) {
        if (this.minX < left) this.minX = left;
        if (this.maxX > right) this.maxX = right;
        if (this.minY < top) this.minY = top;
        if (this.maxY > bottom) this.maxY = bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */ clone() {
        return new $0b15abb3a529f09f$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */ get left() {
        return this.minX;
    }
    /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */ get right() {
        return this.maxX;
    }
    /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */ get top() {
        return this.minY;
    }
    /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */ get bottom() {
        return this.maxY;
    }
    /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */ get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */ toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
    /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */ copyFrom(bounds) {
        this.minX = bounds.minX;
        this.minY = bounds.minY;
        this.maxX = bounds.maxX;
        this.maxY = bounds.maxY;
        return this;
    }
}

});

parcelRegister("eicwU", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $8a2b4ed6f59ce4dc$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $8a2b4ed6f59ce4dc$export$83db162b74637ea);
$parcel$export(module.exports, "Container", () => $8a2b4ed6f59ce4dc$export$42a852a2b6b56249);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $j1i7q = parcelRequire("j1i7q");

var $i9BKe = parcelRequire("i9BKe");

var $eY4rt = parcelRequire("eY4rt");

var $aWW4e = parcelRequire("aWW4e");

var $a32F4 = parcelRequire("a32F4");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $hUCK4 = parcelRequire("hUCK4");

var $61KiY = parcelRequire("61KiY");

var $9atlQ = parcelRequire("9atlQ");

var $236jP = parcelRequire("236jP");

var $49nq9 = parcelRequire("49nq9");

var $apXS2 = parcelRequire("apXS2");

var $kkVML = parcelRequire("kkVML");

var $3hzRR = parcelRequire("3hzRR");

var $8ifkW = parcelRequire("8ifkW");

var $kEqoj = parcelRequire("kEqoj");

var $ggvKl = parcelRequire("ggvKl");

var $82jXu = parcelRequire("82jXu");

var $g5iYs = parcelRequire("g5iYs");

var $1pFbO = parcelRequire("1pFbO");

var $gIPW8 = parcelRequire("gIPW8");
"use strict";
const $8a2b4ed6f59ce4dc$var$defaultSkew = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultPivot = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultScale = new (0, $a32F4.ObservablePoint)(null, 1, 1);
const $8a2b4ed6f59ce4dc$var$defaultOrigin = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5 = 1;
const $8a2b4ed6f59ce4dc$export$e4801e7edc7582f = 2;
const $8a2b4ed6f59ce4dc$export$83db162b74637ea = 4;
const $8a2b4ed6f59ce4dc$export$8363b5079568fbee = 8;
class $8a2b4ed6f59ce4dc$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options = {}){
        super();
        /**
     * unique id for this container
     * @internal
     */ this.uid = (0, $aGJhg.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // the render group this container owns
        /** @private */ this.renderGroup = null;
        // the render group this container belongs to
        /** @private */ this.parentRenderGroup = null;
        // the index of the container in the render group
        /** @private */ this.parentRenderGroupIndex = 0;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container. Each child must be a Container or extend from it.
     *
     * The array is read-only, but its contents can be modified using Container methods.
     * @example
     * ```ts
     * // Access children
     * const firstChild = container.children[0];
     * const lastChild = container.children[container.children.length - 1];
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding children
     * @see {@link Container#removeChild} For removing children
     */ this.children = [];
        /**
     * The display object container that contains this display object.
     * This represents the parent-child relationship in the display tree.
     * @example
     * ```ts
     * // Basic parent access
     * const parent = sprite.parent;
     *
     * // Walk up the tree
     * let current = sprite;
     * while (current.parent) {
     *     console.log('Level up:', current.parent.constructor.name);
     *     current = current.parent;
     * }
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding to a parent
     * @see {@link Container#removeChild} For removing from parent
     */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /** @internal */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * This matrix represents the local transformation without any parent influence.
     * @example
     * ```ts
     * // Basic transform access
     * const localMatrix = sprite.localTransform;
     * console.log(localMatrix.toString());
     * ```
     * @readonly
     * @see {@link Container#worldTransform} For global transform
     * @see {@link Container#groupTransform} For render group transform
     */ this.localTransform = new (0, $eY4rt.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     * @advanced
     */ this.relativeGroupTransform = new (0, $eY4rt.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     * @advanced
     */ this.groupTransform = this.relativeGroupTransform;
        /**
     * Whether this object has been destroyed. If true, the object should no longer be used.
     * After an object is destroyed, all of its functionality is disabled and references are removed.
     * @example
     * ```ts
     * // Cleanup with destroy
     * sprite.destroy();
     * console.log(sprite.destroyed); // true
     * ```
     * @default false
     * @see {@link Container#destroy} For destroying objects
     */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     */ this._position = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     */ this._scale = $8a2b4ed6f59ce4dc$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     */ this._pivot = $8a2b4ed6f59ce4dc$var$defaultPivot;
        /**
     * The origin point around which the container rotates and scales.
     * Unlike pivot, changing origin will not move the container's position.
     * @private
     */ this._origin = $8a2b4ed6f59ce4dc$var$defaultOrigin;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     */ this._skew = $8a2b4ed6f59ce4dc$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        /** @internal */ this.localColor = 16777215;
        /** @internal */ this.localAlpha = 1;
        /** @internal */ this.groupAlpha = 1;
        // A
        /** @internal */ this.groupColor = 16777215;
        // BGR
        /** @internal */ this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /** @internal */ this.localBlendMode = "inherit";
        /** @internal */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = not renderable, 1 = renderable) 0b001
     * @internal
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /** @internal */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the containe is modified
     * eg children added, removed etc
     * @ignore
     */ this._didContainerChangeTick = 0;
        /**
     * A value that increments each time the container view is modified
     * eg texture swap, geometry change etc
     * @ignore
     */ this._didViewChangeTick = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        this.effects = [];
        (0, $gIPW8.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */ static mixin(source) {
        (0, $kXq8E.deprecation)("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead.");
        (0, $i9BKe.extensions).mixin($8a2b4ed6f59ce4dc$export$42a852a2b6b56249, source);
    }
    // = 'default';
    /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */ set _didChangeId(value) {
        this._didViewChangeTick = value >> 12 & 4095;
        this._didContainerChangeTick = value & 4095;
    }
    /** @ignore */ get _didChangeId() {
        return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
    }
    /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */ addChild(...children) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (renderGroup) renderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        if (renderGroup) renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        this._didViewChangeTick++;
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this._didViewChangeTick++;
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            else if (this.parentRenderGroup) this.parentRenderGroup.removeChild(child);
            if (child.parentRenderLayer) child.parentRenderLayer.detach(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didContainerChangeTick++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.parentRenderGroup) this.parentRenderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (!!this.renderGroup === value) return;
        if (value) this.enableRenderGroup();
        else this.disableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */ get isRenderGroup() {
        return !!this.renderGroup;
    }
    /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */ enableRenderGroup() {
        if (this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        this.renderGroup = (0, $61KiY.BigPool).get((0, $1pFbO.RenderGroup), this);
        this.groupTransform = (0, $eY4rt.Matrix).IDENTITY;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /**
   * This will disable the render group for this container.
   * @advanced
   */ disableRenderGroup() {
        if (!this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        (0, $61KiY.BigPool).return(this.renderGroup);
        this.renderGroup = null;
        this.groupTransform = this.relativeGroupTransform;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.renderGroup && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $eY4rt.Matrix)());
        if (this.renderGroup) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
        else if (this.parentRenderGroup) this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform);
        return this._worldTransform;
    }
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   *
   * // Rotate around center with origin
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Rotate around center with origin
   * sprite.origin.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */ get angle() {
        return this.rotation * (0, $aWW4e.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $aWW4e.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) {
            this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
            if (this._origin !== $8a2b4ed6f59ce4dc$var$defaultOrigin) (0, $hUCK4.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */ get skew() {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        if (typeof value === "string") value = parseFloat(value);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * @experimental
   * The origin point around which the container rotates and scales without affecting its position.
   * Unlike pivot, changing the origin will not move the container's position.
   * @example
   * ```ts
   * // Rotate around center point
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   *
   * // Reset origin
   * container.origin.set(0, 0);
   * ```
   */ get origin() {
        if (this._origin === $8a2b4ed6f59ce4dc$var$defaultOrigin) this._origin = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._origin;
    }
    set origin(value) {
        if (this._origin === $8a2b4ed6f59ce4dc$var$defaultOrigin) {
            this._origin = new (0, $a32F4.ObservablePoint)(this, 0, 0);
            if (this._pivot !== $8a2b4ed6f59ce4dc$var$defaultPivot) (0, $hUCK4.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._origin.set(value) : this._origin.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   *  @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, size.width);
        height !== void 0 && this._setHeight(height, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        this.origin.set(typeof opts.originX === "number" ? opts.originX : this.origin.x, typeof opts.originY === "number" ? opts.originY : this.origin.y);
        return this;
    }
    /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        const localTransformChangeId = this._didContainerChangeTick;
        if (this._didLocalTransformChangeId === localTransformChangeId) return;
        this._didLocalTransformChangeId = localTransformChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const origin = this._origin;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        const ox = -origin._x;
        const oy = -origin._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c) + (ox * lt.a + oy * lt.c) - ox * sx;
        lt.ty = position._y - (px * lt.b + py * lt.d) + (ox * lt.b + oy * lt.d) - oy * sy;
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $a2eTA.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */ get tint() {
        return (0, $8ifkW.bgr2rgb)(this.localColor);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 2 : 0;
        if ((this.localDisplayStatus & 2) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 0 : 4;
        if ((this.localDisplayStatus & 4) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /**
   * Whether or not the object should be rendered.
   * @advanced
   */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        let oldChildren;
        if (this.children.length) oldChildren = this.removeChildren(0, this.children.length);
        this.removeFromParent();
        this.parent = null;
        this._maskEffect = null;
        this._filterEffect = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._origin = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        if (destroyChildren && oldChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
        this.renderGroup?.destroy();
        this.renderGroup = null;
    }
}
(0, $i9BKe.extensions).mixin($8a2b4ed6f59ce4dc$export$42a852a2b6b56249, (0, $236jP.childrenHelperMixin), (0, $3hzRR.getFastGlobalBoundsMixin), (0, $g5iYs.toLocalGlobalMixin), (0, $ggvKl.onRenderMixin), (0, $kEqoj.measureMixin), (0, $apXS2.effectsMixin), (0, $kkVML.findMixin), (0, $82jXu.sortMixin), (0, $j1i7q.cullingMixin), (0, $9atlQ.cacheAsTextureMixin), (0, $8ifkW.getGlobalMixin), (0, $49nq9.collectRenderablesMixin));

});
parcelRegister("a2eTA", function(module, exports) {

$parcel$export(module.exports, "Color", () => $f6a94f8017837c10$export$892596cec99bc70e);

var $erZA3 = parcelRequire("erZA3");

var $lCM3s = parcelRequire("lCM3s");
"use strict";
(0, $erZA3.extend)([
    (0, $lCM3s.default)
]);
const $f6a94f8017837c10$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */ get red() {
        return this._components[0];
    }
    /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */ get green() {
        return this._components[1];
    }
    /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */ get blue() {
        return this._components[2];
    }
    /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */ get alpha() {
        return this._components[3];
    }
    /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._value = this._cloneSource(value);
            this._normalize(this._value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */ toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */ toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out || (out = this._arrayRgba);
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */ toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $erZA3.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Static shared Color instance used for utility operations. This is a singleton color object
 * that can be reused to avoid creating unnecessary Color instances.
 * > [!IMPORTANT] You should be careful when using this shared instance, as it is mutable and can be
 * > changed by any code that uses it.
 * >
 * > It is best used for one-off color operations or temporary transformations.
 * > For persistent colors, create your own Color instance instead.
 * @example
 * ```ts
 * import { Color } from 'pixi.js';
 *
 * // Use shared instance for one-off color operations
 * Color.shared.setValue(0xff0000);
 * const redHex = Color.shared.toHex();     // "#ff0000"
 * const redRgb = Color.shared.toRgbArray(); // [1, 0, 0]
 *
 * // Temporary color transformations
 * const colorNumber = Color.shared
 *     .setValue('#ff0000')     // Set to red
 *     .setAlpha(0.5)          // Make semi-transparent
 *     .premultiply(0.8)       // Apply premultiplication
 *     .toNumber();            // Convert to number
 *
 * // Chain multiple operations
 * const result = Color.shared
 *     .setValue(someColor)
 *     .multiply(tintColor)
 *     .toPremultiplied(alpha);
 * ```
 * @remarks
 * - This is a shared instance - be careful about multiple code paths using it simultaneously
 * - Use for temporary color operations to avoid allocating new Color instances
 * - The value is preserved between operations, so reset if needed
 * - For persistent colors, create your own Color instance instead
 */ $f6a94f8017837c10$var$_Color.shared = new $f6a94f8017837c10$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $f6a94f8017837c10$var$_Color._temp = new $f6a94f8017837c10$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$f6a94f8017837c10$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $f6a94f8017837c10$export$892596cec99bc70e = $f6a94f8017837c10$var$_Color;

});
parcelRegister("erZA3", function(module, exports) {

$parcel$export(module.exports, "colord", () => $482ad42e73ee00b6$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $482ad42e73ee00b6$export$8b58be045bf06082);
var $482ad42e73ee00b6$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $482ad42e73ee00b6$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $482ad42e73ee00b6$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $482ad42e73ee00b6$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $482ad42e73ee00b6$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $482ad42e73ee00b6$var$a = function(r) {
    return {
        r: $482ad42e73ee00b6$var$e(r.r, 0, 255),
        g: $482ad42e73ee00b6$var$e(r.g, 0, 255),
        b: $482ad42e73ee00b6$var$e(r.b, 0, 255),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$o = function(r) {
    return {
        r: $482ad42e73ee00b6$var$n(r.r),
        g: $482ad42e73ee00b6$var$n(r.g),
        b: $482ad42e73ee00b6$var$n(r.b),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$i = /^#([0-9a-f]{3,8})$/i, $482ad42e73ee00b6$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $482ad42e73ee00b6$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $482ad42e73ee00b6$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $482ad42e73ee00b6$var$g = function(r) {
    return {
        h: $482ad42e73ee00b6$var$u(r.h),
        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
        l: $482ad42e73ee00b6$var$e(r.l, 0, 100),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$d = function(r) {
    return {
        h: $482ad42e73ee00b6$var$n(r.h),
        s: $482ad42e73ee00b6$var$n(r.s),
        l: $482ad42e73ee00b6$var$n(r.l),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$f = function(r) {
    var t, n, e;
    return $482ad42e73ee00b6$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $482ad42e73ee00b6$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $482ad42e73ee00b6$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $482ad42e73ee00b6$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$y = {
    string: [
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$v.exec(r) || $482ad42e73ee00b6$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $482ad42e73ee00b6$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $482ad42e73ee00b6$var$l.exec(t) || $482ad42e73ee00b6$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $482ad42e73ee00b6$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($482ad42e73ee00b6$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $482ad42e73ee00b6$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $482ad42e73ee00b6$var$t(n) && $482ad42e73ee00b6$var$t(e) && $482ad42e73ee00b6$var$t(u) ? $482ad42e73ee00b6$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(e) || !$482ad42e73ee00b6$var$t(u)) return null;
                var i = $482ad42e73ee00b6$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $482ad42e73ee00b6$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(a) || !$482ad42e73ee00b6$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $482ad42e73ee00b6$var$u(r.h),
                        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
                        v: $482ad42e73ee00b6$var$e(r.v, 0, 100),
                        a: $482ad42e73ee00b6$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $482ad42e73ee00b6$var$b(h);
            },
            "hsv"
        ]
    ]
}, $482ad42e73ee00b6$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$var$x = function(r) {
    return "string" == typeof r ? $482ad42e73ee00b6$var$N(r.trim(), $482ad42e73ee00b6$var$y.string) : "object" == typeof r && null !== r ? $482ad42e73ee00b6$var$N(r, $482ad42e73ee00b6$var$y.object) : [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$export$f61ac8b6f1f46202 = function(r) {
    return $482ad42e73ee00b6$var$x(r)[1];
}, $482ad42e73ee00b6$var$M = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: $482ad42e73ee00b6$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $482ad42e73ee00b6$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $482ad42e73ee00b6$var$$ = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $482ad42e73ee00b6$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $482ad42e73ee00b6$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $482ad42e73ee00b6$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $482ad42e73ee00b6$var$n($482ad42e73ee00b6$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $482ad42e73ee00b6$var$s($482ad42e73ee00b6$var$n(255 * a)) : "", "#" + $482ad42e73ee00b6$var$s(t) + $482ad42e73ee00b6$var$s(e) + $482ad42e73ee00b6$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $482ad42e73ee00b6$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $482ad42e73ee00b6$var$h(this.rgba), {
            h: $482ad42e73ee00b6$var$n(r.h),
            s: $482ad42e73ee00b6$var$n(r.s),
            v: $482ad42e73ee00b6$var$n(r.v),
            a: $482ad42e73ee00b6$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $482ad42e73ee00b6$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $482ad42e73ee00b6$var$c(this.rgba);
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $482ad42e73ee00b6$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $482ad42e73ee00b6$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $482ad42e73ee00b6$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $482ad42e73ee00b6$export$4d30ed660ff08d0 ? r : new $482ad42e73ee00b6$export$4d30ed660ff08d0(r);
}, $482ad42e73ee00b6$var$S = [], $482ad42e73ee00b6$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $482ad42e73ee00b6$var$S.indexOf(r) < 0 && (r($482ad42e73ee00b6$export$4d30ed660ff08d0, $482ad42e73ee00b6$var$y), $482ad42e73ee00b6$var$S.push(r));
    });
}, $482ad42e73ee00b6$export$4385e60b38654f68 = function() {
    return new $482ad42e73ee00b6$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("lCM3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf1f6e6e10c0717$export$2e2bcd8739ae039);
function $4bf1f6e6e10c0717$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("j1i7q", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $b5b40e006e048a91$export$dce76d4f0fd249ed);
"use strict";
const $b5b40e006e048a91$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("hUCK4", function(module, exports) {

$parcel$export(module.exports, "warn", () => $ffdcd240d931c2ea$export$c106dd0671a0fc2d);
"use strict";
let $ffdcd240d931c2ea$var$warnCount = 0;
const $ffdcd240d931c2ea$var$maxWarnings = 500;
function $ffdcd240d931c2ea$export$c106dd0671a0fc2d(...args) {
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) return;
    $ffdcd240d931c2ea$var$warnCount++;
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});

parcelRegister("61KiY", function(module, exports) {

$parcel$export(module.exports, "BigPool", () => $9483424e2013bba4$export$8249372279066210);

var $5Xsoh = parcelRequire("5Xsoh");
"use strict";
class $9483424e2013bba4$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $5Xsoh.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
}
const $9483424e2013bba4$export$8249372279066210 = new $9483424e2013bba4$export$866836a21808b71c();

});
parcelRegister("5Xsoh", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $ce33839780b5f2f3$export$14963ee5c8637e11);
"use strict";
class $ce33839780b5f2f3$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else item = new this._classType();
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */ get totalUsed() {
        return this._count - this._index;
    }
    /** clears the pool - mainly used for debugging! */ clear() {
        this._pool.length = 0;
        this._index = 0;
    }
}

});


parcelRegister("9atlQ", function(module, exports) {

$parcel$export(module.exports, "cacheAsTextureMixin", () => $a8b261c324971086$export$9660f593b1298e75);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $a8b261c324971086$export$9660f593b1298e75 = {
    get isCachedAsTexture () {
        return !!this.renderGroup?.isCachedAsTexture;
    },
    cacheAsTexture (val1) {
        if (typeof val1 === "boolean" && val1 === false) this.disableRenderGroup();
        else {
            this.enableRenderGroup();
            this.renderGroup.enableCacheAsTexture(val1 === true ? {} : val1);
        }
    },
    updateCacheTexture () {
        this.renderGroup?.updateCacheTexture();
    },
    get cacheAsBitmap () {
        return this.isCachedAsTexture;
    },
    set cacheAsBitmap (val){
        (0, $kXq8E.deprecation)("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead.");
        this.cacheAsTexture(val);
    }
};

});

parcelRegister("236jP", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $0d8e0eeab3189cd3$export$64cca9f0c2df174a);

var $33PVi = parcelRequire("33PVi");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $0d8e0eeab3189cd3$export$64cca9f0c2df174a = {
    allowChildren: true,
    removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                removed.push(child);
                child.parent = null;
            }
            (0, $33PVi.removeItems)(this.children, beginIndex, end);
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.removeChildren(removed);
            for(let i = 0; i < removed.length; ++i){
                const child = removed[i];
                child.parentRenderLayer?.detach(child);
                this.emit("childRemoved", child, this, i);
                removed[i].emit("removed", this);
            }
            if (removed.length > 0) this._didViewChangeTick++;
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    addChildAt (child, index) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (child.parent === this && currentIndex === index) return child;
            if (currentIndex !== -1) child.parent.children.splice(currentIndex, 1);
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        this._didContainerChangeTick++;
    },
    removeFromParent () {
        this.parent?.removeChild(this);
    },
    reparentChild (...child) {
        if (child.length === 1) return this.reparentChildAt(child[0], this.children.length);
        child.forEach((c)=>this.reparentChildAt(c, this.children.length));
        return child[0];
    },
    reparentChildAt (child, index) {
        if (child.parent === this) {
            this.setChildIndex(child, index);
            return child;
        }
        const childMat = child.worldTransform.clone();
        child.removeFromParent();
        this.addChildAt(child, index);
        const newMatrix = this.worldTransform.clone();
        newMatrix.invert();
        childMat.prepend(newMatrix);
        child.setFromMatrix(childMat);
        return child;
    },
    replaceChild (oldChild, newChild) {
        oldChild.updateLocalTransform();
        this.addChildAt(newChild, this.getChildIndex(oldChild));
        newChild.setFromMatrix(oldChild.localTransform);
        newChild.updateLocalTransform();
        this.removeChild(oldChild);
    }
};

});
parcelRegister("33PVi", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $cefc366e7023560b$export$8d47c0e1ce445404);
"use strict";
function $cefc366e7023560b$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("49nq9", function(module, exports) {

$parcel$export(module.exports, "collectRenderablesMixin", () => $0a36b694a408d29d$export$e50be97f8cd670d0);
"use strict";
const $0a36b694a408d29d$export$e50be97f8cd670d0 = {
    collectRenderables (instructionSet, renderer, currentLayer) {
        if (this.parentRenderLayer && this.parentRenderLayer !== currentLayer || this.globalDisplayStatus < 7 || !this.includeInBuild) return;
        if (this.sortableChildren) this.sortChildren();
        if (this.isSimple) this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        else if (this.renderGroup) renderer.renderPipes.renderGroup.addRenderGroup(this.renderGroup, instructionSet);
        else this.collectRenderablesWithEffects(instructionSet, renderer, currentLayer);
    },
    collectRenderablesSimple (instructionSet, renderer, currentLayer) {
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
    },
    collectRenderablesWithEffects (instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        for(let i = 0; i < this.effects.length; i++){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.push(effect, this, instructionSet);
        }
        this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        for(let i = this.effects.length - 1; i >= 0; i--){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.pop(effect, this, instructionSet);
        }
    }
};

});

parcelRegister("apXS2", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $1d59e812d2000ae8$export$eec5e288a9d02a7c);

var $aWIPo = parcelRequire("aWIPo");

var $dZmDL = parcelRequire("dZmDL");
"use strict";
const $1d59e812d2000ae8$export$eec5e288a9d02a7c = {
    _maskEffect: null,
    _maskOptions: {
        inverse: false
    },
    _filterEffect: null,
    effects: [],
    _markStructureAsChanged () {
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
    },
    addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    set mask (value){
        const effect = this._maskEffect;
        if (effect?.mask === value) return;
        if (effect) {
            this.removeEffect(effect);
            (0, $dZmDL.MaskEffectManager).returnMaskEffect(effect);
            this._maskEffect = null;
        }
        if (value === null || value === void 0) return;
        this._maskEffect = (0, $dZmDL.MaskEffectManager).getMaskEffect(value);
        this.addEffect(this._maskEffect);
    },
    get mask () {
        return this._maskEffect?.mask;
    },
    setMask (options) {
        this._maskOptions = {
            ...this._maskOptions,
            ...options
        };
        if (options.mask) this.mask = options.mask;
        this._markStructureAsChanged();
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        const effect = this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        value;
        const hasFilters = value?.length > 0;
        const hadFilters = effect.filters?.length > 0;
        const didChange = hasFilters !== hadFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        effect.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) this.addEffect(effect);
            else {
                this.removeEffect(effect);
                effect.filters = value ?? null;
            }
        }
    },
    get filters () {
        return this._filterEffect?.filters;
    },
    set filterArea (value){
        this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        this._filterEffect.filterArea = value;
    },
    get filterArea () {
        return this._filterEffect?.filterArea;
    }
};

});
parcelRegister("aWIPo", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $573d66e12a5f4185$export$d66c06ffe23037ab);
"use strict";
class $573d66e12a5f4185$export$d66c06ffe23037ab {
    constructor(){
        /** the pipe that knows how to handle this effect */ this.pipe = "filter";
        /** the priority of this effect */ this.priority = 1;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("dZmDL", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManager", () => $f40a37c299623cb8$export$1eb319167fe02d04);

var $i9BKe = parcelRequire("i9BKe");

var $61KiY = parcelRequire("61KiY");
"use strict";
class $f40a37c299623cb8$export$3b0749bf144d4b29 {
    constructor(){
        /** @private */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $61KiY.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $61KiY.BigPool).return(effect);
    }
}
const $f40a37c299623cb8$export$1eb319167fe02d04 = new $f40a37c299623cb8$export$3b0749bf144d4b29();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).MaskEffect, $f40a37c299623cb8$export$1eb319167fe02d04._effectClasses);

});


parcelRegister("kkVML", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $1ce16328dd0c7b09$export$468b0762e1bfbd64);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $1ce16328dd0c7b09$export$468b0762e1bfbd64 = {
    label: null,
    get name () {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("3hzRR", function(module, exports) {

$parcel$export(module.exports, "getFastGlobalBoundsMixin", () => $af7175d9cdd285e4$export$993f17c9646405e3);

var $eY4rt = parcelRequire("eY4rt");

var $7wtv9 = parcelRequire("7wtv9");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
const $af7175d9cdd285e4$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $af7175d9cdd285e4$export$993f17c9646405e3 = {
    getFastGlobalBounds (factorRenderLayers, bounds) {
        bounds || (bounds = new (0, $7wtv9.Bounds)());
        bounds.clear();
        this._getGlobalBoundsRecursive(!!factorRenderLayers, bounds, this.parentRenderLayer);
        if (!bounds.isValid) bounds.set(0, 0, 0, 0);
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        bounds.applyMatrix(renderGroup.worldTransform);
        return bounds;
    },
    _getGlobalBoundsRecursive (factorRenderLayers, bounds, currentLayer) {
        let localBounds = bounds;
        if (factorRenderLayers && this.parentRenderLayer && this.parentRenderLayer !== currentLayer) return;
        if (this.localDisplayStatus !== 7 || !this.measurable) return;
        const manageEffects = !!this.effects.length;
        if (this.renderGroup || manageEffects) localBounds = (0, $5tmC8.boundsPool).get().clear();
        if (this.boundsArea) bounds.addRect(this.boundsArea, this.worldTransform);
        else {
            if (this.renderPipeId) {
                const viewBounds = this.bounds;
                localBounds.addFrame(viewBounds.minX, viewBounds.minY, viewBounds.maxX, viewBounds.maxY, this.groupTransform);
            }
            const children = this.children;
            for(let i = 0; i < children.length; i++)children[i]._getGlobalBoundsRecursive(factorRenderLayers, localBounds, currentLayer);
        }
        if (manageEffects) {
            let advanced = false;
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            for(let i = 0; i < this.effects.length; i++)if (this.effects[i].addBounds) {
                if (!advanced) {
                    advanced = true;
                    localBounds.applyMatrix(renderGroup.worldTransform);
                }
                this.effects[i].addBounds(localBounds, true);
            }
            if (advanced) {
                localBounds.applyMatrix(renderGroup.worldTransform.copyTo($af7175d9cdd285e4$var$tempMatrix).invert());
                bounds.addBounds(localBounds, this.relativeGroupTransform);
            }
            bounds.addBounds(localBounds);
            (0, $5tmC8.boundsPool).return(localBounds);
        } else if (this.renderGroup) {
            bounds.addBounds(localBounds, this.relativeGroupTransform);
            (0, $5tmC8.boundsPool).return(localBounds);
        }
    }
};

});
parcelRegister("5tmC8", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $aaa7ee585a7b6ebc$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $aaa7ee585a7b6ebc$export$9194656040c1dc42);

var $eY4rt = parcelRequire("eY4rt");

var $5Xsoh = parcelRequire("5Xsoh");

var $7wtv9 = parcelRequire("7wtv9");
"use strict";
const $aaa7ee585a7b6ebc$export$3849005ba4dacf72 = new (0, $5Xsoh.Pool)((0, $eY4rt.Matrix));
const $aaa7ee585a7b6ebc$export$9194656040c1dc42 = new (0, $5Xsoh.Pool)((0, $7wtv9.Bounds));

});


parcelRegister("8ifkW", function(module, exports) {

$parcel$export(module.exports, "bgr2rgb", () => $cff3716760fd205e$export$110f9f26b10ddb4a);
$parcel$export(module.exports, "getGlobalMixin", () => $cff3716760fd205e$export$c7c22dc0c465d95a);

var $iskjc = parcelRequire("iskjc");

var $5tmC8 = parcelRequire("5tmC8");

var $4KYBZ = parcelRequire("4KYBZ");
"use strict";
function $cff3716760fd205e$export$110f9f26b10ddb4a(color) {
    return ((color & 255) << 16) + (color & 65280) + (color >> 16 & 255);
}
const $cff3716760fd205e$export$c7c22dc0c465d95a = {
    getGlobalAlpha (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return this.renderGroup.worldAlpha;
            if (this.parentRenderGroup) return this.parentRenderGroup.worldAlpha * this.alpha;
            return this.alpha;
        }
        let alpha = this.alpha;
        let current = this.parent;
        while(current){
            alpha *= current.alpha;
            current = current.parent;
        }
        return alpha;
    },
    getGlobalTransform (matrix, skipUpdate) {
        if (skipUpdate) return matrix.copyFrom(this.worldTransform);
        this.updateLocalTransform();
        const parentTransform = (0, $iskjc.updateTransformBackwards)(this, (0, $5tmC8.matrixPool).get().identity());
        matrix.appendFrom(this.localTransform, parentTransform);
        (0, $5tmC8.matrixPool).return(parentTransform);
        return matrix;
    },
    getGlobalTint (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return $cff3716760fd205e$export$110f9f26b10ddb4a(this.renderGroup.worldColor);
            if (this.parentRenderGroup) return $cff3716760fd205e$export$110f9f26b10ddb4a((0, $4KYBZ.multiplyColors)(this.localColor, this.parentRenderGroup.worldColor));
            return this.tint;
        }
        let color = this.localColor;
        let parent = this.parent;
        while(parent){
            color = (0, $4KYBZ.multiplyColors)(color, parent.localColor);
            parent = parent.parent;
        }
        return $cff3716760fd205e$export$110f9f26b10ddb4a(color);
    }
};

});
parcelRegister("iskjc", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $b2563854990e287d$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $b2563854990e287d$export$2022bc48a49dd6d2);

var $eY4rt = parcelRequire("eY4rt");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $b2563854990e287d$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $5tmC8.matrixPool).get().identity();
            parentTransform = $b2563854990e287d$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $eY4rt.Matrix).IDENTITY;
    $b2563854990e287d$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $5tmC8.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $b2563854990e287d$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $5tmC8.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        if (target.bounds) {
            bounds.matrix = worldTransform;
            bounds.addBounds(target.bounds);
        }
        for(let i = 0; i < target.children.length; i++)$b2563854990e287d$var$_getGlobalBounds(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $5tmC8.matrixPool).return(worldTransform);
}
function $b2563854990e287d$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $b2563854990e287d$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});

parcelRegister("4KYBZ", function(module, exports) {

$parcel$export(module.exports, "multiplyColors", () => $d2dd747da74b9c5e$export$a82a3ae2e3118160);

var $3N6bV = parcelRequire("3N6bV");
"use strict";
const $d2dd747da74b9c5e$var$WHITE_BGR = 16777215;
function $d2dd747da74b9c5e$export$a82a3ae2e3118160(localBGRColor, parentBGRColor) {
    if (localBGRColor === $d2dd747da74b9c5e$var$WHITE_BGR) return parentBGRColor;
    if (parentBGRColor === $d2dd747da74b9c5e$var$WHITE_BGR) return localBGRColor;
    return (0, $3N6bV.multiplyHexColors)(localBGRColor, parentBGRColor);
}

});
parcelRegister("3N6bV", function(module, exports) {

$parcel$export(module.exports, "multiplyHexColors", () => $038267701630e9a0$export$815d7ea0395de72c);
"use strict";
function $038267701630e9a0$export$815d7ea0395de72c(color1, color2) {
    if (color1 === 16777215 || !color2) return color2;
    if (color2 === 16777215 || !color1) return color1;
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 * r2 / 255 | 0;
    const g = g1 * g2 / 255 | 0;
    const b = b1 * b2 / 255 | 0;
    return (r << 16) + (g << 8) + b;
}

});



parcelRegister("kEqoj", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $4a6a8e8422db6a2e$export$285e6e72e8e62f0);

var $eY4rt = parcelRequire("eY4rt");

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");

var $j68wk = parcelRequire("j68wk");

var $lK289 = parcelRequire("lK289");
"use strict";
const $4a6a8e8422db6a2e$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $4a6a8e8422db6a2e$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $7wtv9.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didViewChangeTick) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didViewChangeTick;
        }
        (0, $lK289.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $j68wk.getLocalBounds)(this, localBoundsCacheData.localBounds, $4a6a8e8422db6a2e$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    getBounds (skipUpdate, bounds) {
        return (0, $iskjc.getGlobalBounds)(this, skipUpdate, bounds || new (0, $7wtv9.Bounds)());
    }
};

});
parcelRegister("j68wk", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $653ce529dcaa332d$export$ffaf4f504c4c5c9c);

var $eY4rt = parcelRequire("eY4rt");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $653ce529dcaa332d$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $eY4rt.Matrix).IDENTITY);
    $653ce529dcaa332d$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $653ce529dcaa332d$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            bounds.addBounds(target.bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$653ce529dcaa332d$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    (0, $5tmC8.matrixPool).return(relativeTransform);
}

});

parcelRegister("lK289", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $6ac8d139665df8ac$export$fd5aadbd3827bcf1);
"use strict";
function $6ac8d139665df8ac$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const uid = child.uid;
        const didChange = (child._didViewChangeTick & 65535) << 16 | child._didContainerChangeTick & 65535;
        const index = previousData.index;
        if (previousData.data[index] !== uid || previousData.data[index + 1] !== didChange) {
            previousData.data[previousData.index] = uid;
            previousData.data[previousData.index + 1] = didChange;
            previousData.didChange = true;
        }
        previousData.index = index + 2;
        if (child.children.length) $6ac8d139665df8ac$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("ggvKl", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $63981d12ee78567e$export$2a5246d1114cb81d);
"use strict";
const $63981d12ee78567e$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("82jXu", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $8864252dd84a6b69$export$eb4acdd9f4781aed);
"use strict";
const $8864252dd84a6b69$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    sortDirty: false,
    sortableChildren: false,
    get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
    },
    sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($8864252dd84a6b69$var$sortChildren);
    }
};
function $8864252dd84a6b69$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("g5iYs", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $6a95391942e887de$export$38fa7a987602e8dd);

var $1HooC = parcelRequire("1HooC");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
const $6a95391942e887de$export$38fa7a987602e8dd = {
    getGlobalPosition (point = new (0, $1HooC.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    toGlobal (position, point, skipUpdate = false) {
        const globalMatrix = this.getGlobalTransform((0, $5tmC8.matrixPool).get(), skipUpdate);
        point = globalMatrix.apply(position, point);
        (0, $5tmC8.matrixPool).return(globalMatrix);
        return point;
    },
    toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        const globalMatrix = this.getGlobalTransform((0, $5tmC8.matrixPool).get(), skipUpdate);
        point = globalMatrix.applyInverse(position, point);
        (0, $5tmC8.matrixPool).return(globalMatrix);
        return point;
    }
};

});

parcelRegister("1pFbO", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $5a621eb8e375b2c4$export$94d273f8d74f2a5);

var $eY4rt = parcelRequire("eY4rt");

var $dK5Jn = parcelRequire("dK5Jn");

var $3Xbp7 = parcelRequire("3Xbp7");
"use strict";
class $5a621eb8e375b2c4$export$94d273f8d74f2a5 {
    constructor(){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this.worldTransform = new (0, $eY4rt.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        this.gcTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $dK5Jn.InstructionSet)();
        this._onRenderContainers = [];
        /**
     * Indicates if the cached texture needs to be updated.
     * @default true
     */ this.textureNeedsUpdate = true;
        /**
     * Indicates if the container should be cached as a texture.
     * @default false
     */ this.isCachedAsTexture = false;
        this._matrixDirty = 7;
    }
    init(root) {
        this.root = root;
        if (root._onRender) this.addOnRender(root);
        root.didChange = true;
        const children = root.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child._updateFlags = 15;
            this.addChild(child);
        }
    }
    enableCacheAsTexture(options = {}) {
        this.textureOptions = options;
        this.isCachedAsTexture = true;
        this.textureNeedsUpdate = true;
    }
    disableCacheAsTexture() {
        this.isCachedAsTexture = false;
        if (this.texture) {
            (0, $3Xbp7.TexturePool).returnTexture(this.texture);
            this.texture = null;
        }
    }
    updateCacheTexture() {
        this.textureNeedsUpdate = true;
    }
    reset() {
        this.renderGroupChildren.length = 0;
        for(const i in this.childrenToUpdate){
            const childrenAtDepth = this.childrenToUpdate[i];
            childrenAtDepth.list.fill(null);
            childrenAtDepth.index = 0;
        }
        this.childrenRenderablesToUpdate.index = 0;
        this.childrenRenderablesToUpdate.list.fill(null);
        this.root = null;
        this.updateTick = 0;
        this.structureDidChange = true;
        this._onRenderContainers.length = 0;
        this.renderGroupParent = null;
        this.disableCacheAsTexture();
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        child.parentRenderGroup = this;
        child.updateTick = -1;
        if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
        else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
        child.didChange = true;
        this.onChildUpdate(child);
        if (child.renderGroup) {
            this.addRenderGroupChild(child.renderGroup);
            return;
        }
        if (child._onRender) this.addOnRender(child);
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) {
            if (!child.renderGroup) this.removeOnRender(child);
        }
        child.parentRenderGroup = null;
        if (child.renderGroup) {
            this._removeRenderGroupChild(child.renderGroup);
            return;
        }
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    removeChildren(children) {
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    updateRenderable(renderable) {
        if (renderable.globalDisplayStatus < 7) return;
        this.instructionSet.renderPipes[renderable.renderPipeId].updateRenderable(renderable);
        renderable.didViewUpdate = false;
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender(renderer) {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender(renderer);
    }
    destroy() {
        this.disableCacheAsTexture();
        this.renderGroupParent = null;
        this.root = null;
        this.childrenRenderablesToUpdate = null;
        this.childrenToUpdate = null;
        this.renderGroupChildren = null;
        this._onRenderContainers = null;
        this.instructionSet = null;
    }
    getChildren(out = []) {
        const children = this.root.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    _getChildren(container, out = []) {
        out.push(container);
        if (container.renderGroup) return out;
        const children = container.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    invalidateMatrices() {
        this._matrixDirty = 7;
    }
    /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */ get inverseWorldTransform() {
        if ((this._matrixDirty & 1) === 0) return this._inverseWorldTransform;
        this._matrixDirty &= -2;
        this._inverseWorldTransform || (this._inverseWorldTransform = new (0, $eY4rt.Matrix)());
        return this._inverseWorldTransform.copyFrom(this.worldTransform).invert();
    }
    /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */ get textureOffsetInverseTransform() {
        if ((this._matrixDirty & 2) === 0) return this._textureOffsetInverseTransform;
        this._matrixDirty &= -3;
        this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new (0, $eY4rt.Matrix)());
        return this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(-this._textureBounds.x, -this._textureBounds.y);
    }
    /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */ get inverseParentTextureTransform() {
        if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
        this._matrixDirty &= -5;
        const parentCacheAsTexture = this._parentCacheAsTextureRenderGroup;
        if (parentCacheAsTexture) {
            this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new (0, $eY4rt.Matrix)());
            return this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(parentCacheAsTexture.inverseWorldTransform).translate(-parentCacheAsTexture._textureBounds.x, -parentCacheAsTexture._textureBounds.y);
        }
        return this.worldTransform;
    }
    /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */ get cacheToLocalTransform() {
        if (!this._parentCacheAsTextureRenderGroup) return null;
        return this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform;
    }
}

});
parcelRegister("dK5Jn", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $a69ff318b1fa7c86$export$2946bd01f10dd922);

var $aGJhg = parcelRequire("aGJhg");
"use strict";
class $a69ff318b1fa7c86$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $aGJhg.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
        this.renderables = [];
        /** used by the garbage collector to track when the instruction set was last used */ this.gcTick = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});

parcelRegister("3Xbp7", function(module, exports) {

$parcel$export(module.exports, "TexturePool", () => $0b9fa50ced13ccd0$export$686d8ddcd5ee6cd2);

var $NbSCN = parcelRequire("NbSCN");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");

var $aFPUT = parcelRequire("aFPUT");
"use strict";
let $0b9fa50ced13ccd0$var$count = 0;
class $0b9fa50ced13ccd0$export$f5c6a2d8ed21d1d {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */ constructor(textureOptions){
        this._poolKeyHash = /* @__PURE__ */ Object.create(null);
        this._texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this.textureStyle = new (0, $aFPUT.TextureStyle)(this.textureOptions);
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   */ createTexture(pixelWidth, pixelHeight, antialias) {
        const textureSource = new (0, $iA5fe.TextureSource)({
            ...this.textureOptions,
            width: pixelWidth,
            height: pixelHeight,
            resolution: 1,
            antialias: antialias,
            autoGarbageCollect: false
        });
        return new (0, $bLlTJ.Texture)({
            source: textureSource,
            label: `texturePool_${$0b9fa50ced13ccd0$var$count++}`
        });
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @returns The new render texture.
   */ getOptimalTexture(frameWidth, frameHeight, resolution = 1, antialias) {
        let po2Width = Math.ceil(frameWidth * resolution - 1e-6);
        let po2Height = Math.ceil(frameHeight * resolution - 1e-6);
        po2Width = (0, $NbSCN.nextPow2)(po2Width);
        po2Height = (0, $NbSCN.nextPow2)(po2Height);
        const key = (po2Width << 17) + (po2Height << 1) + (antialias ? 1 : 0);
        if (!this._texturePool[key]) this._texturePool[key] = [];
        let texture = this._texturePool[key].pop();
        if (!texture) texture = this.createTexture(po2Width, po2Height, antialias);
        texture.source._resolution = resolution;
        texture.source.width = po2Width / resolution;
        texture.source.height = po2Height / resolution;
        texture.source.pixelWidth = po2Width;
        texture.source.pixelHeight = po2Height;
        texture.frame.x = 0;
        texture.frame.y = 0;
        texture.frame.width = frameWidth;
        texture.frame.height = frameHeight;
        texture.updateUvs();
        this._poolKeyHash[texture.uid] = key;
        return texture;
    }
    /**
   * Gets extra texture of the same size as input renderTexture
   * @param texture - The texture to check what size it is.
   * @param antialias - Whether to use antialias.
   * @returns A texture that is a power of two
   */ getSameSizeTexture(texture, antialias = false) {
        const source = texture.source;
        return this.getOptimalTexture(texture.width, texture.height, source._resolution, antialias);
    }
    /**
   * Place a render texture back into the pool. Optionally reset the style of the texture to the default texture style.
   * useful if you modified the style of the texture after getting it from the pool.
   * @param renderTexture - The renderTexture to free
   * @param resetStyle - Whether to reset the style of the texture to the default texture style
   */ returnTexture(renderTexture, resetStyle = false) {
        const key = this._poolKeyHash[renderTexture.uid];
        if (resetStyle) renderTexture.source.style = this.textureStyle;
        this._texturePool[key].push(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(const i in this._texturePool){
            const textures = this._texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this._texturePool = {};
    }
}
const $0b9fa50ced13ccd0$export$686d8ddcd5ee6cd2 = new $0b9fa50ced13ccd0$export$f5c6a2d8ed21d1d();

});


parcelRegister("gIPW8", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $83c57e61d47d996f$export$59d0441a278e5935);
"use strict";
function $83c57e61d47d996f$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});




parcelRegister("jzlb7", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $cd1eadd0f2fb679c$export$12af48852c6ac574);

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");
"use strict";
const $cd1eadd0f2fb679c$var$tempBounds = new (0, $7wtv9.Bounds)();
function $cd1eadd0f2fb679c$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $cd1eadd0f2fb679c$var$tempBounds;
    mask.measurable = true;
    (0, $iskjc.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("4vXk0", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $6df4144b7f405909$export$7416ac774b1f1a33);

var $j68wk = parcelRequire("j68wk");

var $5tmC8 = parcelRequire("5tmC8");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $6df4144b7f405909$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $5tmC8.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $5tmC8.matrixPool).get().identity();
    const relativeMask = $6df4144b7f405909$var$getMatrixRelativeToParent(mask, localRoot, tempMatrix);
    (0, $j68wk.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $5tmC8.matrixPool).return(tempMatrix);
    (0, $5tmC8.boundsPool).return(boundsToMask);
}
function $6df4144b7f405909$var$getMatrixRelativeToParent(target, root, matrix) {
    if (!target) {
        (0, $hUCK4.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $6df4144b7f405909$var$getMatrixRelativeToParent(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});


parcelRegister("lLQso", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $2625cf12b5a3b5e5$export$1e2a2c76374c2542);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
class $2625cf12b5a3b5e5$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$2625cf12b5a3b5e5$export$1e2a2c76374c2542.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("jXXId", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $e8890ea82735e7dd$export$abd85894695764cb);

var $i9BKe = parcelRequire("i9BKe");

var $eicwU = parcelRequire("eicwU");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $e8890ea82735e7dd$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $eicwU.Container);
    }
}
$e8890ea82735e7dd$export$abd85894695764cb.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("8xl7d", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $adfc96265c7ca69d$export$ca65ccf5708c6a0c);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $adfc96265c7ca69d$export$ca65ccf5708c6a0c extends (0, $iA5fe.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $iCGeI.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity && "style" in this.resource) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
    /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */ get context2D() {
        return this._context2D || (this._context2D = this.resource.getContext("2d"));
    }
}
$adfc96265c7ca69d$export$ca65ccf5708c6a0c.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iCGeI", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $bfbe44ab70ab7a53$export$d988306fa84f7b44);

var $9OKiP = parcelRequire("9OKiP");
"use strict";
let $bfbe44ab70ab7a53$var$currentAdapter = (0, $9OKiP.BrowserAdapter);
const $bfbe44ab70ab7a53$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $bfbe44ab70ab7a53$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $bfbe44ab70ab7a53$var$currentAdapter = adapter;
    }
};

});
parcelRegister("9OKiP", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $ed1c5172c2eee607$export$e467cc3399500025);
"use strict";
const $ed1c5172c2eee607$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("aQPld", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $ac4c5539d7b1f960$export$280e9a68c3ffd919);

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $ac4c5539d7b1f960$export$280e9a68c3ffd919 extends (0, $iA5fe.TextureSource) {
    constructor(options){
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
}
$ac4c5539d7b1f960$export$280e9a68c3ffd919.extension = (0, $i9BKe.ExtensionType).TextureSource;

});

parcelRegister("hNatJ", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $4dc351acd421ceef$export$f3a17123d80000c5);

var $i9BKe = parcelRequire("i9BKe");

var $4J7WL = parcelRequire("4J7WL");

var $7blVu = parcelRequire("7blVu");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
const $4dc351acd421ceef$var$_VideoSource = class _VideoSource extends (0, $iA5fe.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $4J7WL.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        this.alphaMode = await (0, $7blVu.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        if (!this.isValid) this._mediaReady();
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlay);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement;
    }
};
$4dc351acd421ceef$var$_VideoSource.extension = (0, $i9BKe.ExtensionType).TextureSource;
/** The default options for video sources. */ $4dc351acd421ceef$var$_VideoSource.defaultOptions = {
    ...(0, $iA5fe.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $4dc351acd421ceef$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $4dc351acd421ceef$export$f3a17123d80000c5 = $4dc351acd421ceef$var$_VideoSource;

});
parcelRegister("4J7WL", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $2bf8d15685054100$export$39c54bcc89dcee11);

var $cQMLP = parcelRequire("cQMLP");

var $bJH8Y = parcelRequire("bJH8Y");
"use strict";
const $2bf8d15685054100$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method {@link Ticker#start|start}
     * automatically when a listener is added.
     * @example
     * ```ts
     * // Default behavior (manual start)
     * const ticker = new Ticker();
     * ticker.autoStart = false;
     * ticker.add(() => {
     *     // Won't run until ticker.start() is called
     * });
     *
     * // Auto-start behavior
     * const autoTicker = new Ticker();
     * autoTicker.autoStart = true;
     * autoTicker.add(() => {
     *     // Runs immediately when added
     * });
     * ```
     * @default false
     * @see {@link Ticker#start} For manually starting the ticker
     * @see {@link Ticker#stop} For manually stopping the ticker
     */ this.autoStart = false;
        /**
     * Scalar time value from last frame to this frame.
     * Used for frame-based animations and updates.
     *
     * This value is capped by setting {@link Ticker#minFPS|minFPS}
     * and is scaled with {@link Ticker#speed|speed}.
     * > [!NOTE] The cap may be exceeded by scaling.
     * @example
     * ```ts
     * // Basic animation
     * ticker.add((ticker) => {
     *     // Rotate sprite by 0.1 radians per frame, scaled by deltaTime
     *     sprite.rotation += 0.1 * ticker.deltaTime;
     * });
     * ```
     */ this.deltaTime = 1;
        /**
     * The last time {@link Ticker#update|update} was invoked.
     * Used for calculating time deltas between frames.
     *
     * This value is also reset internally outside of invoking
     * update, but only when a new animation frame is requested.
     *
     * If the platform supports DOMHighResTimeStamp,
     * this value will have a precision of 1 µs.
     * @example
     * ```ts
     * // Basic timing check
     * ticker.add(() => {
     *     const timeSinceStart = performance.now() - ticker.lastTime;
     *     console.log(`Time running: ${timeSinceStart}ms`);
     * });
     * ```
     */ this.lastTime = -1;
        /**
     * Factor of current {@link Ticker#deltaTime|deltaTime}.
     * Used to scale time for slow motion or fast-forward effects.
     * @example
     * ```ts
     * // Basic speed adjustment
     * ticker.speed = 0.5; // Half speed (slow motion)
     * ticker.speed = 2.0; // Double speed (fast forward)
     *
     * // Temporary speed changes
     * function slowMotion() {
     *     const normalSpeed = ticker.speed;
     *     ticker.speed = 0.2;
     *     setTimeout(() => {
     *         ticker.speed = normalSpeed;
     *     }, 1000);
     * }
     * ```
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     *
     * `true` if {@link Ticker#start|start} has been called.
     * `false` if {@link Ticker#stop|Stop} has been called.
     *
     * While `false`, this value may change to `true` in the
     * event of {@link Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     * @example
     * ```ts
     * // Check ticker state
     * const ticker = new Ticker();
     * console.log(ticker.started); // false
     *
     * // Start and verify
     * ticker.start();
     * console.log(ticker.started); // true
     * ```
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $bJH8Y.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /** Conditionally cancels a pending animation frame. */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @example
   * ```ts
   * // Basic update handler
   * ticker.add((ticker) => {
   *     // Update every frame
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   * });
   *
   * // With specific context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   *
   * // With priority
   * ticker.add(
   *     (ticker) => {
   *         // Runs before normal priority updates
   *         physics.update(ticker.deltaTime);
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#addOnce} For one-time handlers
   * @see {@link Ticker#remove} For removing handlers
   */ add(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */ addOnce(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on minFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps);
        const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on maxFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frame rate in frames per millisecond.
 * Used for converting deltaTime to a scalar time delta.
 * @example
 * ```ts
 * // Default is 0.06 (60 FPS)
 * console.log(Ticker.targetFPMS); // 0.06
 *
 * // Calculate target frame duration
 * const frameDuration = 1 / Ticker.targetFPMS; // ≈ 16.67ms
 *
 * // Use in custom timing calculations
 * const deltaTime = elapsedMS * Ticker.targetFPMS;
 * ```
 * @remarks
 * - Default is 0.06 (equivalent to 60 FPS)
 * - Used in deltaTime calculations
 * - Affects all ticker instances
 * @default 0.06
 * @see {@link Ticker#deltaTime} For time scaling
 * @see {@link Ticker#FPS} For actual frame rate
 */ $2bf8d15685054100$var$_Ticker.targetFPMS = 0.06;
let $2bf8d15685054100$export$39c54bcc89dcee11 = $2bf8d15685054100$var$_Ticker;

});
parcelRegister("cQMLP", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $d091949369ecd400$export$688aaf132ba9b379);
"use strict";
var $d091949369ecd400$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($d091949369ecd400$export$688aaf132ba9b379 || {});

});

parcelRegister("bJH8Y", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $44ffb68c45a667a2$export$579021a5759a260f);
"use strict";
class $44ffb68c45a667a2$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("7blVu", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $1603b82fc2121ba0$export$8df68d58aae31877);
"use strict";
let $1603b82fc2121ba0$var$promise;
async function $1603b82fc2121ba0$export$8df68d58aae31877() {
    $1603b82fc2121ba0$var$promise ?? ($1603b82fc2121ba0$var$promise = (async ()=>{
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $1603b82fc2121ba0$var$promise;
}

});


parcelRegister("8QN7n", function(module, exports) {

var $2IhKp = parcelRequire("2IhKp");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $da9f248d33f9f2f1$var$sources = [];
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).TextureSource, $da9f248d33f9f2f1$var$sources);
function $da9f248d33f9f2f1$export$688bcf31fbf7eb15(options = {}) {
    return $da9f248d33f9f2f1$var$textureSourceFrom(options);
}
function $da9f248d33f9f2f1$var$textureSourceFrom(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $da9f248d33f9f2f1$var$sources.length; i++){
        const Source = $da9f248d33f9f2f1$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $da9f248d33f9f2f1$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $2IhKp.Cache).has(resource)) return (0, $2IhKp.Cache).get(resource);
    const texture = new (0, $bLlTJ.Texture)({
        source: $da9f248d33f9f2f1$var$textureSourceFrom(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $2IhKp.Cache).has(resource)) (0, $2IhKp.Cache).remove(resource);
    });
    if (!skipCache) (0, $2IhKp.Cache).set(resource, texture);
    return texture;
}
function $da9f248d33f9f2f1$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $2IhKp.Cache).get(id);
    else if (id instanceof (0, $iA5fe.TextureSource)) return new (0, $bLlTJ.Texture)({
        source: id
    });
    return $da9f248d33f9f2f1$export$3b748ed6327ec85b(id, skipCache);
}
(0, $bLlTJ.Texture).from = $da9f248d33f9f2f1$export$4266177d9730bb1;
(0, $iA5fe.TextureSource).from = $da9f248d33f9f2f1$var$textureSourceFrom;

});
parcelRegister("2IhKp", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3d19110becfaeec3$export$94affb487e701bf2);

var $hUCK4 = parcelRequire("hUCK4");

var $3CHiv = parcelRequire("3CHiv");
"use strict";
class $3d19110becfaeec3$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $3CHiv.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $hUCK4.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /**
   * All loader parsers registered
   * @advanced
   */ get parsers() {
        return this._parsers;
    }
}
const $3d19110becfaeec3$export$94affb487e701bf2 = new $3d19110becfaeec3$var$CacheClass();

});
parcelRegister("3CHiv", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $93954259b3f62d4e$export$b01be8e180bf3d9b);
"use strict";
const $93954259b3f62d4e$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("4RJM2", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $8PDkK = parcelRequire("8PDkK");
"use strict";
(0, $i9BKe.extensions).add((0, $8PDkK.spritesheetAsset));

});
parcelRegister("8PDkK", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $a322641177c54ad8$export$46dcda4f1cdd80fe);

var $iEtN5 = parcelRequire("iEtN5");

var $8kCsw = parcelRequire("8kCsw");

var $5Oad7 = parcelRequire("5Oad7");

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");

var $lzfZe = parcelRequire("lzfZe");

var $58WFl = parcelRequire("58WFl");
"use strict";
const $a322641177c54ad8$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $a322641177c54ad8$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[`${asset.cachePrefix}${key}`] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $lzfZe.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $a322641177c54ad8$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $a322641177c54ad8$export$46dcda4f1cdd80fe = {
    extension: (0, $i9BKe.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $58WFl.Spritesheet),
        getCacheableAssets: (keys, asset)=>$a322641177c54ad8$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        extension: {
            type: (0, $i9BKe.ExtensionType).ResolveParser,
            name: "resolveSpritesheet"
        },
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $a322641177c54ad8$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $i9BKe.ExtensionType).LoadParser,
            priority: (0, $iEtN5.LoaderParserPriority).Normal,
            name: "spritesheetLoader"
        },
        async testParse (asset, options) {
            return (0, $lzfZe.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename, textureOptions: // if user need to use custom filename (not from jsonFile.meta.image)
            textureOptions, cachePrefix: // if user need to set texture options on texture
            cachePrefix } = options?.data ?? {};
            let basePath = (0, $lzfZe.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $bLlTJ.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $5Oad7.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    {
                        src: imagePath,
                        data: textureOptions
                    }
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $58WFl.Spritesheet)({
                texture: texture.source,
                data: asset,
                cachePrefix: cachePrefix
            });
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $5Oad7.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            textureOptions: textureOptions,
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("iEtN5", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $29ed14ceb032dea6$export$820ed6348c4f2750);
"use strict";
var $29ed14ceb032dea6$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($29ed14ceb032dea6$export$820ed6348c4f2750 || {});

});

parcelRegister("8kCsw", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $23cc1cafdfe05125$export$8b4c839865b08288);

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $8F3vm = parcelRequire("8F3vm");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $23cc1cafdfe05125$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $3CHiv.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $hUCK4.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $hUCK4.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $3CHiv.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: loadParser } = asset;
            const srcsToUse = (0, $3CHiv.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $8F3vm.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        loadParser = src2.loadParser ?? loadParser;
                        formattedAsset = {
                            ...formattedAsset,
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: loadParser
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $4DmkB.isSingleItem)(bundleIds);
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $4DmkB.isSingleItem)(keys);
        keys = (0, $3CHiv.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[i];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $lzfZe.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.format = format ?? formattedAsset.format ?? $23cc1cafdfe05125$export$4bb0ea38086a2ed5(formattedAsset.src);
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $23cc1cafdfe05125$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $23cc1cafdfe05125$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("lzfZe", function(module, exports) {

$parcel$export(module.exports, "path", () => $3c67d20d89e3898c$export$bb654e07daaf8c3a);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
function $3c67d20d89e3898c$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $3c67d20d89e3898c$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $3c67d20d89e3898c$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $3c67d20d89e3898c$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($3c67d20d89e3898c$var$escapeRegExp(find), "g"), replace);
}
function $3c67d20d89e3898c$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $3c67d20d89e3898c$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */ toPosix (path2) {
        return $3c67d20d89e3898c$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ getProtocol (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $3c67d20d89e3898c$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $iCGeI.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $3c67d20d89e3898c$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */ normalize (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $3c67d20d89e3898c$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ isAbsolute (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $3c67d20d89e3898c$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */ dirname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ rootname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */ basename (path2, ext) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (ext) $3c67d20d89e3898c$var$assertPath(ext);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */ extname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */ parse (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("8F3vm", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $fde1bf5bcf60c2d9$export$738117acc6638004);
"use strict";
function $fde1bf5bcf60c2d9$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $fde1bf5bcf60c2d9$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $fde1bf5bcf60c2d9$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $fde1bf5bcf60c2d9$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("4DmkB", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $f373b2ad881b3255$export$16a80d27953452d4);
"use strict";
const $f373b2ad881b3255$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("5Oad7", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $273b4a26d8a43536$export$f57b97ef8be10dda);
"use strict";
const $273b4a26d8a43536$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("58WFl", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $9c38ec259f91df14$export$674d2eb4debbef0c);

var $fM4Mk = parcelRequire("fM4Mk");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $9c38ec259f91df14$var$_Spritesheet = class _Spritesheet {
    /** @ignore */ constructor(optionsOrTexture, arg1){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        let options = optionsOrTexture;
        if (optionsOrTexture?.source instanceof (0, $iA5fe.TextureSource)) options = {
            texture: optionsOrTexture,
            data: arg1
        };
        const { texture: texture, data: data, cachePrefix: cachePrefix = "" } = options;
        this.cachePrefix = cachePrefix;
        this._texture = texture instanceof (0, $bLlTJ.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $fM4Mk.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $fM4Mk.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $bLlTJ.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/**
 * The maximum number of Textures to build per process.
 * @advanced
 */ $9c38ec259f91df14$var$_Spritesheet.BATCH_SIZE = 1e3;
let $9c38ec259f91df14$export$674d2eb4debbef0c = $9c38ec259f91df14$var$_Spritesheet;

});



parcelRegister("3UUq4", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $453fded98f054a94$export$58ab3ed211eed562);

var $a2eTA = parcelRequire("a2eTA");

var $aEImn = parcelRequire("aEImn");

var $eicwU = parcelRequire("eicwU");

var $cJHPn = parcelRequire("cJHPn");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");


var $hFYOq = parcelRequire("hFYOq");

var $gtbjr = parcelRequire("gtbjr");

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $453fded98f054a94$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $453fded98f054a94$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** @internal */ this.uid = (0, $aGJhg.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$453fded98f054a94$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $aEImn.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $eicwU.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $a2eTA.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $hFYOq.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $a2eTA.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $a2eTA.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $gtbjr.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $cJHPn.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $453fded98f054a94$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $453fded98f054a94$export$58ab3ed211eed562 = $453fded98f054a94$var$_AbstractRenderer;

});
parcelRegister("aEImn", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $326e7279631cea1a$export$3b30260a318c769f);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $326e7279631cea1a$var$environments = [];
(0, $i9BKe.extensions).handleByNamedList((0, $i9BKe.ExtensionType).Environment, $326e7279631cea1a$var$environments);
async function $326e7279631cea1a$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $326e7279631cea1a$var$environments.length; i++){
        const env = $326e7279631cea1a$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $326e7279631cea1a$export$72225172dd907279(add) {
    return $326e7279631cea1a$export$3b30260a318c769f(!add);
}

});

parcelRegister("cJHPn", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $d88536e9c61409d6$export$70c0711f29adc5cf);
"use strict";
let $d88536e9c61409d6$var$unsafeEval;
function $d88536e9c61409d6$export$70c0711f29adc5cf() {
    if (typeof $d88536e9c61409d6$var$unsafeEval === "boolean") return $d88536e9c61409d6$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $d88536e9c61409d6$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $d88536e9c61409d6$var$unsafeEval = false;
    }
    return $d88536e9c61409d6$var$unsafeEval;
}

});

parcelRegister("hFYOq", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $bdcaad22b468ed1b$export$6c4d37c7f376a1de);
"use strict";
var $bdcaad22b468ed1b$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($bdcaad22b468ed1b$export$6c4d37c7f376a1de || {});

});

parcelRegister("gtbjr", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $299af1a7d2dd4105$export$ff5f2fe687fe3979);
"use strict";
class $299af1a7d2dd4105$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("bZc23", function(module, exports) {
module.exports = Promise.all([
    import("5JNhf"),
    import("aNM0B")
]).then(()=>parcelRequire('aIpib'));

});

parcelRegister("fp48r", function(module, exports) {
module.exports = Promise.all([
    import("5JNhf"),
    import("7EYKF")
]).then(()=>parcelRequire('kpxDv'));

});

parcelRegister("gVtOu", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $eaa9a2f5d114568e$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $eaa9a2f5d114568e$export$5fba6e443d2fb64);

var $i9BKe = parcelRequire("i9BKe");

var $7hfrt = parcelRequire("7hfrt");
"use strict";
class $eaa9a2f5d114568e$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $7hfrt.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $eaa9a2f5d114568e$export$918f3e4d2b801859.extension = (0, $i9BKe.ExtensionType).Application;
class $eaa9a2f5d114568e$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $7hfrt.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $eaa9a2f5d114568e$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("7hfrt", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $6c3dc1ec0fb181c1$export$a4ad2735b021c132);

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $6c3dc1ec0fb181c1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $6c3dc1ec0fb181c1$export$a4ad2735b021c132 = "8.11.0";

});


parcelRegister("axl5b", function(module, exports) {

$parcel$export(module.exports, "BitmapFontManager", () => $906f35d9788bb217$export$d2ee57cdc0e1ed7f);

var $2IhKp = parcelRequire("2IhKp");

var $kXq8E = parcelRequire("kXq8E");

var $hUCK4 = parcelRequire("hUCK4");

var $wLFHs = parcelRequire("wLFHs");

var $eKNW7 = parcelRequire("eKNW7");

var $5Jnul = parcelRequire("5Jnul");

var $hzhPt = parcelRequire("hzhPt");

var $6ch13 = parcelRequire("6ch13");
"use strict";
let $906f35d9788bb217$var$fontCount = 0;
class $906f35d9788bb217$var$BitmapFontManagerClass {
    constructor(){
        /**
     * This character set includes all the letters in the alphabet (both lower- and upper- case).
     * @type {string[][]}
     * @example
     * BitmapFont.from('ExampleFont', style, { chars: BitmapFont.ALPHA })
     */ this.ALPHA = [
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            " "
        ];
        /**
     * This character set includes all decimal digits (from 0 to 9).
     * @type {string[][]}
     * @example
     * BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
     */ this.NUMERIC = [
            [
                "0",
                "9"
            ]
        ];
        /**
     * This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
     * @type {string[][]}
     */ this.ALPHANUMERIC = [
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            [
                "0",
                "9"
            ],
            " "
        ];
        /**
     * This character set consists of all the ASCII table.
     * @type {string[][]}
     * @see http://www.asciitable.com/
     */ this.ASCII = [
            [
                " ",
                "~"
            ]
        ];
        /** Default options for installing a new BitmapFont. */ this.defaultOptions = {
            chars: this.ALPHANUMERIC,
            resolution: 1,
            padding: 4,
            skipKerning: false,
            textureStyle: null
        };
    }
    /**
   * Get a font for the specified text and style.
   * @param text - The text to get the font for
   * @param style - The style to use
   */ getFont(text, style) {
        let fontFamilyKey = `${style.fontFamily}-bitmap`;
        let overrideFill = true;
        if (style._fill.fill && !style._stroke) {
            fontFamilyKey += style._fill.fill.styleKey;
            overrideFill = false;
        } else if (style._stroke || style.dropShadow) {
            let key = style.styleKey;
            key = key.substring(0, key.lastIndexOf("-"));
            fontFamilyKey = `${key}-bitmap`;
            overrideFill = false;
        }
        if (!(0, $2IhKp.Cache).has(fontFamilyKey)) {
            const fnt = new (0, $5Jnul.DynamicBitmapFont)({
                style: style,
                overrideFill: overrideFill,
                overrideSize: true,
                ...this.defaultOptions
            });
            $906f35d9788bb217$var$fontCount++;
            if ($906f35d9788bb217$var$fontCount > 50) (0, $hUCK4.warn)("BitmapText", `You have dynamically created ${$906f35d9788bb217$var$fontCount} bitmap fonts, this can be inefficient. Try pre installing your font styles using \`BitmapFont.install({name:"style1", style})\``);
            fnt.once("destroy", ()=>{
                $906f35d9788bb217$var$fontCount--;
                (0, $2IhKp.Cache).remove(fontFamilyKey);
            });
            (0, $2IhKp.Cache).set(fontFamilyKey, fnt);
        }
        const dynamicFont = (0, $2IhKp.Cache).get(fontFamilyKey);
        dynamicFont.ensureCharacters?.(text);
        return dynamicFont;
    }
    /**
   * Get the layout of a text for the specified style.
   * @param text - The text to get the layout for
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */ getLayout(text, style, trimEnd = true) {
        const bitmapFont = this.getFont(text, style);
        const segments = (0, $wLFHs.CanvasTextMetrics).graphemeSegmenter(text);
        return (0, $hzhPt.getBitmapTextLayout)(segments, style, bitmapFont, trimEnd);
    }
    /**
   * Measure the text using the specified style.
   * @param text - The text to measure
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */ measureText(text, style, trimEnd = true) {
        return this.getLayout(text, style, trimEnd);
    }
    // eslint-disable-next-line max-len
    install(...args) {
        let options = args[0];
        if (typeof options === "string") {
            options = {
                name: options,
                style: args[1],
                chars: args[2]?.chars,
                resolution: args[2]?.resolution,
                padding: args[2]?.padding,
                skipKerning: args[2]?.skipKerning
            };
            (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFontManager.install(name, style, options) is deprecated, use BitmapFontManager.install({name, style, ...options})");
        }
        const name = options?.name;
        if (!name) throw new Error("[BitmapFontManager] Property `name` is required.");
        options = {
            ...this.defaultOptions,
            ...options
        };
        const textStyle = options.style;
        const style = textStyle instanceof (0, $eKNW7.TextStyle) ? textStyle : new (0, $eKNW7.TextStyle)(textStyle);
        const overrideFill = style._fill.fill !== null && style._fill.fill !== void 0;
        const font = new (0, $5Jnul.DynamicBitmapFont)({
            style: style,
            overrideFill: overrideFill,
            skipKerning: options.skipKerning,
            padding: options.padding,
            resolution: options.resolution,
            overrideSize: false,
            textureStyle: options.textureStyle
        });
        const flatChars = (0, $6ch13.resolveCharacters)(options.chars);
        font.ensureCharacters(flatChars.join(""));
        (0, $2IhKp.Cache).set(`${name}-bitmap`, font);
        font.once("destroy", ()=>(0, $2IhKp.Cache).remove(`${name}-bitmap`));
        return font;
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */ uninstall(name) {
        const cacheKey = `${name}-bitmap`;
        const font = (0, $2IhKp.Cache).get(cacheKey);
        if (font) font.destroy();
    }
}
const $906f35d9788bb217$export$d2ee57cdc0e1ed7f = new $906f35d9788bb217$var$BitmapFontManagerClass();

});
parcelRegister("wLFHs", function(module, exports) {

$parcel$export(module.exports, "CanvasTextMetrics", () => $3648baf7179c08cc$export$b12f6bdc825d944f);

var $iCGeI = parcelRequire("iCGeI");

var $fI0NC = parcelRequire("fI0NC");
"use strict";
const $3648baf7179c08cc$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
const $3648baf7179c08cc$var$_CanvasTextMetrics = class _CanvasTextMetrics {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _CanvasTextMetrics._experimentalLetterSpacingSupported;
        if (result === void 0) {
            const proto = (0, $iCGeI.DOMAdapter).get().getCanvasRenderingContext2D().prototype;
            result = _CanvasTextMetrics._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {FontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties){
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */ static measureText(text = " ", style, canvas = _CanvasTextMetrics._canvas, wordWrap = style.wordWrap) {
        const font = (0, $fI0NC.fontStringFromTextStyle)(style);
        const fontProperties = _CanvasTextMetrics.measureFont(font);
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
        }
        const context = _CanvasTextMetrics.__context;
        context.font = font;
        const outputText = wordWrap ? _CanvasTextMetrics._wordWrap(text, style, canvas) : text;
        const lines = outputText.split(/(?:\r\n|\r|\n)/);
        const lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _CanvasTextMetrics._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        const strokeWidth = style._stroke?.width || 0;
        let width = maxLineWidth + strokeWidth;
        if (style.dropShadow) width += style.dropShadow.distance;
        const lineHeight = style.lineHeight || fontProperties.fontSize;
        let height = Math.max(lineHeight, fontProperties.fontSize + strokeWidth) + (lines.length - 1) * (lineHeight + style.leading);
        if (style.dropShadow) height += style.dropShadow.distance;
        const measurements = new _CanvasTextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
        return measurements;
    }
    static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = false;
        if (_CanvasTextMetrics.experimentalLetterSpacingSupported) {
            if (_CanvasTextMetrics.experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        const metrics = context.measureText(text);
        let metricWidth = metrics.width;
        const actualBoundingBoxLeft = -metrics.actualBoundingBoxLeft;
        const actualBoundingBoxRight = metrics.actualBoundingBoxRight;
        let boundsWidth = actualBoundingBoxRight - actualBoundingBoxLeft;
        if (metricWidth > 0) {
            if (useExperimentalLetterSpacing) {
                metricWidth -= letterSpacing;
                boundsWidth -= letterSpacing;
            } else {
                const val = (_CanvasTextMetrics.graphemeSegmenter(text).length - 1) * letterSpacing;
                metricWidth += val;
                boundsWidth += val;
            }
        }
        return Math.max(metricWidth, boundsWidth);
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static _wordWrap(text, style, canvas = _CanvasTextMetrics._canvas) {
        const context = canvas.getContext("2d", $3648baf7179c08cc$var$contextSettings);
        let width = 0;
        let line = "";
        let lines = "";
        const cache = /* @__PURE__ */ Object.create(null);
        const { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style;
        const collapseSpaces = _CanvasTextMetrics._collapseSpaces(whiteSpace);
        const collapseNewlines = _CanvasTextMetrics._collapseNewlines(whiteSpace);
        let canPrependSpaces = !collapseSpaces;
        const wordWrapWidth = style.wordWrapWidth + letterSpacing;
        const tokens = _CanvasTextMetrics._tokenize(text);
        for(let i = 0; i < tokens.length; i++){
            let token = tokens[i];
            if (_CanvasTextMetrics._isNewline(token)) {
                if (!collapseNewlines) {
                    lines += _CanvasTextMetrics._addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = "";
                    width = 0;
                    continue;
                }
                token = " ";
            }
            if (collapseSpaces) {
                const currIsBreakingSpace = _CanvasTextMetrics.isBreakingSpace(token);
                const lastIsBreakingSpace = _CanvasTextMetrics.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            const tokenWidth = _CanvasTextMetrics._getFromCache(token, letterSpacing, cache, context);
            if (tokenWidth > wordWrapWidth) {
                if (line !== "") {
                    lines += _CanvasTextMetrics._addLine(line);
                    line = "";
                    width = 0;
                }
                if (_CanvasTextMetrics.canBreakWords(token, style.breakWords)) {
                    const characters = _CanvasTextMetrics.wordWrapSplit(token);
                    for(let j = 0; j < characters.length; j++){
                        let char = characters[j];
                        let lastChar = char;
                        let k = 1;
                        while(characters[j + k]){
                            const nextChar = characters[j + k];
                            if (!_CanvasTextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) char += nextChar;
                            else break;
                            lastChar = nextChar;
                            k++;
                        }
                        j += k - 1;
                        const characterWidth = _CanvasTextMetrics._getFromCache(char, letterSpacing, cache, context);
                        if (characterWidth + width > wordWrapWidth) {
                            lines += _CanvasTextMetrics._addLine(line);
                            canPrependSpaces = false;
                            line = "";
                            width = 0;
                        }
                        line += char;
                        width += characterWidth;
                    }
                } else {
                    if (line.length > 0) {
                        lines += _CanvasTextMetrics._addLine(line);
                        line = "";
                        width = 0;
                    }
                    const isLastToken = i === tokens.length - 1;
                    lines += _CanvasTextMetrics._addLine(token, !isLastToken);
                    canPrependSpaces = false;
                    line = "";
                    width = 0;
                }
            } else {
                if (tokenWidth + width > wordWrapWidth) {
                    canPrependSpaces = false;
                    lines += _CanvasTextMetrics._addLine(line);
                    line = "";
                    width = 0;
                }
                if (line.length > 0 || !_CanvasTextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                    line += token;
                    width += tokenWidth;
                }
            }
        }
        lines += _CanvasTextMetrics._addLine(line, false);
        return lines;
    }
    /**
   * Convenience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */ static _addLine(line, newLine = true) {
        line = _CanvasTextMetrics._trimRight(line);
        line = newLine ? `${line}
` : line;
        return line;
    }
    /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */ static _getFromCache(key, letterSpacing, cache, context) {
        let width = cache[key];
        if (typeof width !== "number") {
            width = _CanvasTextMetrics._measureText(key, letterSpacing, context) + letterSpacing;
            cache[key] = width;
        }
        return width;
    }
    /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */ static _collapseSpaces(whiteSpace) {
        return whiteSpace === "normal" || whiteSpace === "pre-line";
    }
    /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */ static _collapseNewlines(whiteSpace) {
        return whiteSpace === "normal";
    }
    /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */ static _trimRight(text) {
        if (typeof text !== "string") return "";
        for(let i = text.length - 1; i >= 0; i--){
            const char = text[i];
            if (!_CanvasTextMetrics.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    }
    /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */ static _isNewline(char) {
        if (typeof char !== "string") return false;
        return _CanvasTextMetrics._newlines.includes(char.charCodeAt(0));
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        if (typeof char !== "string") return false;
        return _CanvasTextMetrics._breakingSpaces.includes(char.charCodeAt(0));
    }
    /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */ static _tokenize(text) {
        const tokens = [];
        let token = "";
        if (typeof text !== "string") return tokens;
        for(let i = 0; i < text.length; i++){
            const char = text[i];
            const nextChar = text[i + 1];
            if (_CanvasTextMetrics.isBreakingSpace(char, nextChar) || _CanvasTextMetrics._isNewline(char)) {
                if (token !== "") {
                    tokens.push(token);
                    token = "";
                }
                if (char === "\r" && nextChar === "\n") {
                    tokens.push("\r\n");
                    i++;
                } else tokens.push(char);
                continue;
            }
            token += char;
        }
        if (token !== "") tokens.push(token);
        return tokens;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _CanvasTextMetrics.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_CanvasTextMetrics._fonts[font]) return _CanvasTextMetrics._fonts[font];
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const metrics = context.measureText(_CanvasTextMetrics.METRICS_STRING + _CanvasTextMetrics.BASELINE_SYMBOL);
        const properties = {
            ascent: metrics.actualBoundingBoxAscent,
            descent: metrics.actualBoundingBoxDescent,
            fontSize: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
        };
        _CanvasTextMetrics._fonts[font] = properties;
        return properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        if (font) delete _CanvasTextMetrics._fonts[font];
        else _CanvasTextMetrics._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_CanvasTextMetrics.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                const context = c.getContext("2d", $3648baf7179c08cc$var$contextSettings);
                if (context?.measureText) {
                    _CanvasTextMetrics.__canvas = c;
                    return c;
                }
                canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            } catch (_cx) {
                canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            }
            canvas.width = canvas.height = 10;
            _CanvasTextMetrics.__canvas = canvas;
        }
        return _CanvasTextMetrics.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        if (!_CanvasTextMetrics.__context) _CanvasTextMetrics.__context = _CanvasTextMetrics._canvas.getContext("2d", $3648baf7179c08cc$var$contextSettings);
        return _CanvasTextMetrics.__context;
    }
};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.METRICS_STRING = "|\xC9q\xC5";
/** Baseline symbol for calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.BASELINE_SYMBOL = "M";
/** Baseline multiplier for calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.BASELINE_MULTIPLIER = 1.4;
/** Height multiplier for setting height of canvas to calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.HEIGHT_MULTIPLIER = 2;
/**
 * A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
 * such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
 * or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
 * The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
 * PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
 * If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
 * you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
 * or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
 * relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter === "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>{
            const segments = segmenter.segment(s);
            const result = [];
            let i = 0;
            for (const segment of segments)result[i++] = segment.segment;
            return result;
        };
    }
    return (s)=>[
            ...s
        ];
})();
/**
 * New rendering behavior for letter-spacing which uses Chrome's new native API. This will
 * lead to more accurate letter-spacing results because it does not try to manually draw
 * each character. However, this Chrome API is experimental and may not serve all cases yet.
 * @see TextMetrics.experimentalLetterSpacingSupported
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.experimentalLetterSpacing = false;
/** Cache of {@link TextMetrics.FontMetrics} objects. */ $3648baf7179c08cc$var$_CanvasTextMetrics._fonts = {};
/** Cache of new line chars. */ $3648baf7179c08cc$var$_CanvasTextMetrics._newlines = [
    10,
    // line feed
    13
];
/** Cache of breaking spaces. */ $3648baf7179c08cc$var$_CanvasTextMetrics._breakingSpaces = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
let $3648baf7179c08cc$export$b12f6bdc825d944f = $3648baf7179c08cc$var$_CanvasTextMetrics;

});
parcelRegister("fI0NC", function(module, exports) {

$parcel$export(module.exports, "fontStringFromTextStyle", () => $432516f32dcd2061$export$b7b5edb82ac3fc66);
"use strict";
const $432516f32dcd2061$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
];
function $432516f32dcd2061$export$b7b5edb82ac3fc66(style) {
    const fontSizeString = typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize;
    let fontFamilies = style.fontFamily;
    if (!Array.isArray(style.fontFamily)) fontFamilies = style.fontFamily.split(",");
    for(let i = fontFamilies.length - 1; i >= 0; i--){
        let fontFamily = fontFamilies[i].trim();
        if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$432516f32dcd2061$var$genericFontFamilies.includes(fontFamily)) fontFamily = `"${fontFamily}"`;
        fontFamilies[i] = fontFamily;
    }
    return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
}

});


parcelRegister("eKNW7", function(module, exports) {

$parcel$export(module.exports, "TextStyle", () => $d76c68b7f9f9bbea$export$1df879243bf2e42d);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $kXq8E = parcelRequire("kXq8E");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");

var $8aC7P = parcelRequire("8aC7P");

var $6mQKv = parcelRequire("6mQKv");

var $6XitK = parcelRequire("6XitK");
"use strict";
const $d76c68b7f9f9bbea$var$_TextStyle = class _TextStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(style = {}){
        super();
        $d76c68b7f9f9bbea$var$convertV7Tov8Style(style);
        const fullStyle = {
            ..._TextStyle.defaultTextStyle,
            ...style
        };
        for(const key in fullStyle){
            const thisKey = key;
            this[thisKey] = fullStyle[key];
        }
        this.update();
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   * @type {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(value) {
        this._align = value;
        this.update();
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(value) {
        this._breakWords = value;
        this.update();
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(value) {
        if (value !== null && typeof value === "object") this._dropShadow = this._createProxy({
            ..._TextStyle.defaultDropShadow,
            ...value
        });
        else this._dropShadow = value ? this._createProxy({
            ..._TextStyle.defaultDropShadow
        }) : null;
        this.update();
    }
    /** The font family, can be a single font name, or a list of names where the first is the preferred font. */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        this._fontFamily = value;
        this.update();
    }
    /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(value) {
        if (typeof value === "string") this._fontSize = parseInt(value, 10);
        else this._fontSize = value;
        this.update();
    }
    /**
   * The font style.
   * @type {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        this._fontStyle = value.toLowerCase();
        this.update();
    }
    /**
   * The font variant.
   * @type {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(value) {
        this._fontVariant = value;
        this.update();
    }
    /**
   * The font weight.
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        this._fontWeight = value;
        this.update();
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(value) {
        this._leading = value;
        this.update();
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        this._letterSpacing = value;
        this.update();
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(value) {
        this._lineHeight = value;
        this.update();
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   * > [!NOTE] This will NOT affect the positioning or bounds of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(value) {
        this._padding = value;
        this.update();
    }
    /**
   * An optional filter or array of filters to apply to the text, allowing for advanced visual effects.
   * These filters will be applied to the text as it is created, resulting in faster rendering for static text
   * compared to applying the filter directly to the text object (which would be applied at run time).
   * @default null
   */ get filters() {
        return this._filters;
    }
    set filters(value) {
        this._filters = value;
        this.update();
    }
    /**
   * Trim transparent borders from the text texture.
   * > [!IMPORTANT] PERFORMANCE WARNING:
   * > This is a costly operation as it requires scanning pixel alpha values.
   * > Avoid using `trim: true` for dynamic text, as it could significantly impact performance.
   */ get trim() {
        return this._trim;
    }
    set trim(value) {
        this._trim = value;
        this.update();
    }
    /**
   * The baseline of the text that is rendered.
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(value) {
        this._textBaseline = value;
        this.update();
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @type {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(value) {
        this._whiteSpace = value;
        this.update();
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(value) {
        this._wordWrap = value;
        this.update();
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(value) {
        this._wordWrapWidth = value;
        this.update();
    }
    /**
   * The fill style that will be used to color the text.
   * This can be:
   * - A color string like 'red', '#00FF00', or 'rgba(255,0,0,0.5)'
   * - A hex number like 0xff0000 for red
   * - A FillStyle object with properties like { color: 0xff0000, alpha: 0.5 }
   * - A FillGradient for gradient fills
   * - A FillPattern for pattern/texture fills
   *
   * When using a FillGradient, vertical gradients (angle of 90 degrees) are applied per line of text,
   * while gradients at any other angle are spread across the entire text body as a whole.
   * @example
   * // Vertical gradient applied per line
   * const verticalGradient = new FillGradient(0, 0, 0, 1)
   *     .addColorStop(0, 0xff0000)
   *     .addColorStop(1, 0x0000ff);
   *
   * const text = new Text({
   *     text: 'Line 1\nLine 2',
   *     style: { fill: verticalGradient }
   * });
   *
   * To manage the gradient in a global scope, set the textureSpace property of the FillGradient to 'global'.
   * @type {string|number|FillStyle|FillGradient|FillPattern}
   */ get fill() {
        return this._originalFill;
    }
    set fill(value) {
        if (value === this._originalFill) return;
        this._originalFill = value;
        if (this._isFillStyle(value)) this._originalFill = this._createProxy({
            ...(0, $8aC7P.GraphicsContext).defaultFillStyle,
            ...value
        }, ()=>{
            this._fill = (0, $6mQKv.toFillStyle)({
                ...this._originalFill
            }, (0, $8aC7P.GraphicsContext).defaultFillStyle);
        });
        this._fill = (0, $6mQKv.toFillStyle)(value === 0 ? "black" : value, (0, $8aC7P.GraphicsContext).defaultFillStyle);
        this.update();
    }
    /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */ get stroke() {
        return this._originalStroke;
    }
    set stroke(value) {
        if (value === this._originalStroke) return;
        this._originalStroke = value;
        if (this._isFillStyle(value)) this._originalStroke = this._createProxy({
            ...(0, $8aC7P.GraphicsContext).defaultStrokeStyle,
            ...value
        }, ()=>{
            this._stroke = (0, $6mQKv.toStrokeStyle)({
                ...this._originalStroke
            }, (0, $8aC7P.GraphicsContext).defaultStrokeStyle);
        });
        this._stroke = (0, $6mQKv.toStrokeStyle)(value, (0, $8aC7P.GraphicsContext).defaultStrokeStyle);
        this.update();
    }
    _generateKey() {
        this._styleKey = (0, $6XitK.generateTextStyleKey)(this);
        return this._styleKey;
    }
    update() {
        this._styleKey = null;
        this.emit("update", this);
    }
    /** Resets all properties to the default values */ reset() {
        const defaultStyle = _TextStyle.defaultTextStyle;
        for(const key in defaultStyle)this[key] = defaultStyle[key];
    }
    /** @internal */ get styleKey() {
        return this._styleKey || this._generateKey();
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */ clone() {
        return new _TextStyle({
            align: this.align,
            breakWords: this.breakWords,
            dropShadow: this._dropShadow ? {
                ...this._dropShadow
            } : null,
            fill: this._fill,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontVariant: this.fontVariant,
            fontWeight: this.fontWeight,
            leading: this.leading,
            letterSpacing: this.letterSpacing,
            lineHeight: this.lineHeight,
            padding: this.padding,
            stroke: this._stroke,
            textBaseline: this.textBaseline,
            whiteSpace: this.whiteSpace,
            wordWrap: this.wordWrap,
            wordWrapWidth: this.wordWrapWidth,
            filters: this._filters ? [
                ...this._filters
            ] : void 0
        });
    }
    /**
   * Returns the final padding for the text style, taking into account any filters applied.
   * Used internally for correct measurements
   * @internal
   * @returns {number} The final padding for the text style.
   */ _getFinalPadding() {
        let filterPadding = 0;
        if (this._filters) for(let i = 0; i < this._filters.length; i++)filterPadding += this._filters[i].padding;
        return Math.max(this._padding, filterPadding);
    }
    /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroy the text style and its textures
   * textStyle.destroy({ texture: true, textureSource: true });
   * textStyle.destroy(true);
   */ destroy(options = false) {
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fill?.texture) this._fill.texture.destroy(destroyTextureSource);
            if (this._originalFill?.texture) this._originalFill.texture.destroy(destroyTextureSource);
            if (this._stroke?.texture) this._stroke.texture.destroy(destroyTextureSource);
            if (this._originalStroke?.texture) this._originalStroke.texture.destroy(destroyTextureSource);
        }
        this._fill = null;
        this._stroke = null;
        this.dropShadow = null;
        this._originalStroke = null;
        this._originalFill = null;
    }
    _createProxy(value, cb) {
        return new Proxy(value, {
            set: (target, property, newValue)=>{
                target[property] = newValue;
                cb?.(property, newValue);
                this.update();
                return true;
            }
        });
    }
    _isFillStyle(value) {
        return (value ?? null) !== null && !((0, $a2eTA.Color).isColorLike(value) || value instanceof (0, $gwwtL.FillGradient) || value instanceof (0, $ktCpi.FillPattern));
    }
};
/**
 * Default drop shadow settings used when enabling drop shadows on text.
 * These values are used as the base configuration when drop shadows are enabled without specific settings.
 * @example
 * ```ts
 * // Customize default settings globally
 * TextStyle.defaultDropShadow.alpha = 0.5;    // 50% opacity for all shadows
 * TextStyle.defaultDropShadow.blur = 2;       // 2px blur for all shadows
 * TextStyle.defaultDropShadow.color = 'blue'; // Blue shadows by default
 * ```
 */ $d76c68b7f9f9bbea$var$_TextStyle.defaultDropShadow = {
    alpha: 1,
    angle: Math.PI / 6,
    blur: 0,
    color: "black",
    distance: 5
};
/**
 * Default text style settings used when creating new text objects.
 * These values serve as the base configuration and can be customized globally.
 * @example
 * ```ts
 * // Customize default text style globally
 * TextStyle.defaultTextStyle.fontSize = 16;
 * TextStyle.defaultTextStyle.fill = 0x333333;
 * TextStyle.defaultTextStyle.fontFamily = ['Arial', 'Helvetica', 'sans-serif'];
 * ```
 */ $d76c68b7f9f9bbea$var$_TextStyle.defaultTextStyle = {
    align: "left",
    breakWords: false,
    dropShadow: null,
    fill: "black",
    fontFamily: "Arial",
    fontSize: 26,
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    leading: 0,
    letterSpacing: 0,
    lineHeight: 0,
    padding: 0,
    stroke: null,
    textBaseline: "alphabetic",
    trim: false,
    whiteSpace: "pre",
    wordWrap: false,
    wordWrapWidth: 100
};
let $d76c68b7f9f9bbea$export$1df879243bf2e42d = $d76c68b7f9f9bbea$var$_TextStyle;
function $d76c68b7f9f9bbea$var$convertV7Tov8Style(style) {
    const oldStyle = style;
    if (typeof oldStyle.dropShadow === "boolean" && oldStyle.dropShadow) {
        const defaults = $d76c68b7f9f9bbea$export$1df879243bf2e42d.defaultDropShadow;
        style.dropShadow = {
            alpha: oldStyle.dropShadowAlpha ?? defaults.alpha,
            angle: oldStyle.dropShadowAngle ?? defaults.angle,
            blur: oldStyle.dropShadowBlur ?? defaults.blur,
            color: oldStyle.dropShadowColor ?? defaults.color,
            distance: oldStyle.dropShadowDistance ?? defaults.distance
        };
    }
    if (oldStyle.strokeThickness !== void 0) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "strokeThickness is now a part of stroke");
        const color = oldStyle.stroke;
        let obj = {};
        if ((0, $a2eTA.Color).isColorLike(color)) obj.color = color;
        else if (color instanceof (0, $gwwtL.FillGradient) || color instanceof (0, $ktCpi.FillPattern)) obj.fill = color;
        else if (Object.hasOwnProperty.call(color, "color") || Object.hasOwnProperty.call(color, "fill")) obj = color;
        else throw new Error("Invalid stroke value.");
        style.stroke = {
            ...obj,
            width: oldStyle.strokeThickness
        };
    }
    if (Array.isArray(oldStyle.fillGradientStops)) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "gradient fill is now a fill pattern: `new FillGradient(...)`");
        let fontSize;
        if (style.fontSize == null) style.fontSize = $d76c68b7f9f9bbea$export$1df879243bf2e42d.defaultTextStyle.fontSize;
        else if (typeof style.fontSize === "string") fontSize = parseInt(style.fontSize, 10);
        else fontSize = style.fontSize;
        const gradientFill = new (0, $gwwtL.FillGradient)({
            start: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: (fontSize || 0) * 1.7
            }
        });
        const fills = oldStyle.fillGradientStops.map((color)=>(0, $a2eTA.Color).shared.setValue(color).toNumber());
        fills.forEach((number, index)=>{
            const ratio = index / (fills.length - 1);
            gradientFill.addColorStop(ratio, number);
        });
        style.fill = {
            fill: gradientFill
        };
    }
}

});
parcelRegister("gwwtL", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $339e160815705dba$export$722a6ea8c60ca86);

var $a2eTA = parcelRequire("a2eTA");

var $iCGeI = parcelRequire("iCGeI");

var $eY4rt = parcelRequire("eY4rt");

var $aQPld = parcelRequire("aQPld");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $dr868 = parcelRequire("dr868");
"use strict";
const $339e160815705dba$var$emptyColorStops = [
    {
        offset: 0,
        color: "white"
    },
    {
        offset: 1,
        color: "black"
    }
];
const $339e160815705dba$var$_FillGradient = class _FillGradient {
    constructor(...args){
        /**
     * Unique identifier for this gradient instance
     * @internal
     */ this.uid = (0, $aGJhg.uid)("fillGradient");
        /** Type of gradient - currently only supports 'linear' */ this.type = "linear";
        /** Array of color stops defining the gradient */ this.colorStops = [];
        let options = $339e160815705dba$var$ensureGradientOptions(args);
        const defaults = options.type === "radial" ? _FillGradient.defaultRadialOptions : _FillGradient.defaultLinearOptions;
        options = {
            ...defaults,
            ...(0, $dr868.definedProps)(options)
        };
        this._textureSize = options.textureSize;
        this._wrapMode = options.wrapMode;
        if (options.type === "radial") {
            this.center = options.center;
            this.outerCenter = options.outerCenter ?? this.center;
            this.innerRadius = options.innerRadius;
            this.outerRadius = options.outerRadius;
            this.scale = options.scale;
            this.rotation = options.rotation;
        } else {
            this.start = options.start;
            this.end = options.end;
        }
        this.textureSpace = options.textureSpace;
        this.type = options.type;
        options.colorStops.forEach((stop)=>{
            this.addColorStop(stop.offset, stop.color);
        });
    }
    /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */ addColorStop(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: (0, $a2eTA.Color).shared.setValue(color).toHexa()
        });
        return this;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildLinearGradient() {
        if (this.texture) return;
        let { x: x0, y: y0 } = this.start;
        let { x: x1, y: y1 } = this.end;
        let dx = x1 - x0;
        let dy = y1 - y0;
        const flip = dx < 0 || dy < 0;
        if (this._wrapMode === "clamp-to-edge") {
            if (dx < 0) {
                const temp = x0;
                x0 = x1;
                x1 = temp;
                dx *= -1;
            }
            if (dy < 0) {
                const temp = y0;
                y0 = y1;
                y1 = temp;
                dy *= -1;
            }
        }
        const colorStops = this.colorStops.length ? this.colorStops : $339e160815705dba$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $339e160815705dba$var$getCanvas(defaultSize, 1);
        const gradient = !flip ? context.createLinearGradient(0, 0, this._textureSize, 0) : context.createLinearGradient(this._textureSize, 0, 0, 0);
        $339e160815705dba$var$addColorStops(gradient, colorStops);
        context.fillStyle = gradient;
        context.fillRect(0, 0, defaultSize, 1);
        this.texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        const m = new (0, $eY4rt.Matrix)();
        m.scale(dist / defaultSize, 1);
        m.rotate(angle);
        m.translate(x0, y0);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildGradient() {
        if (this.type === "linear") this.buildLinearGradient();
        else this.buildRadialGradient();
    }
    /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildRadialGradient() {
        if (this.texture) return;
        const colorStops = this.colorStops.length ? this.colorStops : $339e160815705dba$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $339e160815705dba$var$getCanvas(defaultSize, defaultSize);
        const { x: x0, y: y0 } = this.center;
        const { x: x1, y: y1 } = this.outerCenter;
        const r0 = this.innerRadius;
        const r1 = this.outerRadius;
        const ox = x1 - r1;
        const oy = y1 - r1;
        const scale = defaultSize / (r1 * 2);
        const cx = (x0 - ox) * scale;
        const cy = (y0 - oy) * scale;
        const gradient = context.createRadialGradient(cx, cy, r0 * scale, (x1 - ox) * scale, (y1 - oy) * scale, r1 * scale);
        $339e160815705dba$var$addColorStops(gradient, colorStops);
        context.fillStyle = colorStops[colorStops.length - 1].color;
        context.fillRect(0, 0, defaultSize, defaultSize);
        context.fillStyle = gradient;
        context.translate(cx, cy);
        context.rotate(this.rotation);
        context.scale(1, this.scale);
        context.translate(-cx, -cy);
        context.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const m = new (0, $eY4rt.Matrix)();
        m.scale(1 / scale, 1 / scale);
        m.translate(ox, oy);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /**
   * Gets a unique key representing the current state of the gradient.
   * Used internally for caching.
   * @returns Unique string key
   */ get styleKey() {
        return this.uid;
    }
    destroy() {
        this.texture?.destroy(true);
        this.texture = null;
    }
};
/** Default options for creating a gradient fill */ $339e160815705dba$var$_FillGradient.defaultLinearOptions = {
    start: {
        x: 0,
        y: 0
    },
    end: {
        x: 0,
        y: 1
    },
    colorStops: [],
    textureSpace: "local",
    type: "linear",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
/** Default options for creating a radial gradient fill */ $339e160815705dba$var$_FillGradient.defaultRadialOptions = {
    center: {
        x: 0.5,
        y: 0.5
    },
    innerRadius: 0,
    outerRadius: 0.5,
    colorStops: [],
    scale: 1,
    textureSpace: "local",
    type: "radial",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
let $339e160815705dba$export$722a6ea8c60ca86 = $339e160815705dba$var$_FillGradient;
function $339e160815705dba$var$addColorStops(gradient, colorStops) {
    for(let i = 0; i < colorStops.length; i++){
        const stop = colorStops[i];
        gradient.addColorStop(stop.offset, stop.color);
    }
}
function $339e160815705dba$var$getCanvas(width, height) {
    const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(width, height);
    const context = canvas.getContext("2d");
    return {
        canvas: canvas,
        context: context
    };
}
function $339e160815705dba$var$ensureGradientOptions(args) {
    let options = args[0] ?? {};
    if (typeof options === "number" || args[1]) {
        (0, $kXq8E.deprecation)("8.5.2", `use options object instead`);
        options = {
            type: "linear",
            start: {
                x: args[0],
                y: args[1]
            },
            end: {
                x: args[2],
                y: args[3]
            },
            textureSpace: args[4],
            textureSize: args[5] ?? $339e160815705dba$export$722a6ea8c60ca86.defaultLinearOptions.textureSize
        };
    }
    return options;
}

});

parcelRegister("ktCpi", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $e9923e9fec04a606$export$3d1378c7410cd8e);

var $eY4rt = parcelRequire("eY4rt");

var $aGJhg = parcelRequire("aGJhg");
"use strict";
const $e9923e9fec04a606$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $e9923e9fec04a606$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        /**
     * unique id for this fill pattern
     * @internal
     */ this.uid = (0, $aGJhg.uid)("fillPattern");
        /** The transform matrix applied to the pattern */ this.transform = new (0, $eY4rt.Matrix)();
        this._styleKey = null;
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeV;
        }
    }
    /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */ setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        this._styleKey = null;
    }
    /**
   * Gets a unique key representing the current state of the pattern.
   * Used internally for caching.
   * @returns Unique string key
   */ get styleKey() {
        if (this._styleKey) return this._styleKey;
        this._styleKey = `fill-pattern-${this.uid}-${this.texture.uid}-${this.transform.toArray().join("-")}`;
        return this._styleKey;
    }
}

});

parcelRegister("8aC7P", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $5d1287b36eb70f7f$export$cde35afe8b5f985);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $1HooC = parcelRequire("1HooC");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $7wtv9 = parcelRequire("7wtv9");

var $c9xxq = parcelRequire("c9xxq");

var $6ph3G = parcelRequire("6ph3G");

var $6mQKv = parcelRequire("6mQKv");
"use strict";
const $5d1287b36eb70f7f$var$tmpPoint = new (0, $1HooC.Point)();
const $5d1287b36eb70f7f$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $5d1287b36eb70f7f$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments);
        /**
     * unique id for this graphics context
     * @internal
     */ this.uid = (0, $aGJhg.uid)("graphicsContext");
        /** @internal */ this.dirty = true;
        /** The batch mode for this graphics context. It can be 'auto', 'batch', or 'no-batch'. */ this.batchMode = "auto";
        /** @internal */ this.instructions = [];
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        this._transform = new (0, $eY4rt.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $6mQKv.toStrokeStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint ? (0, $a2eTA.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $1HooC.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $6mQKv.toStrokeStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $6ph3G.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $5d1287b36eb70f7f$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($5d1287b36eb70f7f$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this._activePath.clear();
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        if (this.dirty) return;
        this.emit("update", this, 16);
        this.dirty = true;
        this._boundsDirty = true;
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const alignment = data.style.alignment;
                const outerPadding = data.style.width * (1 - alignment);
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - outerPadding, _bounds.minY - outerPadding, _bounds.maxX + outerPadding, _bounds.maxY + outerPadding);
            }
        }
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $5d1287b36eb70f7f$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else {
                    const strokeStyle = style;
                    hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, strokeStyle.width, strokeStyle.alignment);
                }
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        this._stateStack.length = 0;
        this._transform = null;
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local"
};
/** The default stroke style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local",
    /** If the stroke is a pixel line. */ pixelLine: false
};
let $5d1287b36eb70f7f$export$cde35afe8b5f985 = $5d1287b36eb70f7f$var$_GraphicsContext;

});
parcelRegister("c9xxq", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $0663b1de1906f348$export$7e54506375634c19);

var $1HooC = parcelRequire("1HooC");

var $aGJhg = parcelRequire("aGJhg");

var $hUCK4 = parcelRequire("hUCK4");

var $b2eG6 = parcelRequire("b2eG6");

var $ein11 = parcelRequire("ein11");
"use strict";
class $0663b1de1906f348$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */ constructor(instructions, signed = false){
        this.instructions = [];
        /** unique id for this graphics path */ this.uid = (0, $aGJhg.uid)("graphicsPath");
        this._dirty = true;
        this.checkForHoles = signed;
        if (typeof instructions === "string") (0, $b2eG6.parseSVGPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $ein11.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius || (innerRadius = radius / 2);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $0663b1de1906f348$export$7e54506375634c19();
        newGraphicsPath2D.checkForHoles = this.checkForHoles;
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $0663b1de1906f348$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $0663b1de1906f348$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $0663b1de1906f348$var$adjustTransform(data[2], matrix);
                    break;
                default:
                    (0, $hUCK4.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $0663b1de1906f348$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("b2eG6", function(module, exports) {

$parcel$export(module.exports, "parseSVGPath", () => $aa8e6738d1d86e9a$export$33813e954ab16e32);

var $8DJYa = parcelRequire("8DJYa");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $aa8e6738d1d86e9a$export$33813e954ab16e32(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($8DJYa)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], // First control point
                data[3], data[4], // Second control point
                lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], // First control point
                lastX + data[3], lastY + data[4], // Second control point
                lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "Z":
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $hUCK4.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("8DJYa", function(module, exports) {
module.exports = $64a59fcc91535eb3$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $64a59fcc91535eb3$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $64a59fcc91535eb3$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $64a59fcc91535eb3$var$parse(path) {
    var data = [];
    path.replace($64a59fcc91535eb3$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $64a59fcc91535eb3$var$parseValues(args);
        // overloaded moveTo
        if (type == 'm' && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = 'l';
            command = command == 'm' ? 'l' : 'L';
        }
        while(true){
            if (args.length == $64a59fcc91535eb3$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $64a59fcc91535eb3$var$length[type]) throw new Error('malformed path data');
            data.push([
                command
            ].concat(args.splice(0, $64a59fcc91535eb3$var$length[type])));
        }
    });
    return data;
}
var $64a59fcc91535eb3$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $64a59fcc91535eb3$var$parseValues(args) {
    var numbers = args.match($64a59fcc91535eb3$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("ein11", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $664ff60a6792361f$export$148534a3c727230b);

var $h7nJT = parcelRequire("h7nJT");

var $9hswb = parcelRequire("9hswb");

var $hbpIN = parcelRequire("hbpIN");

var $fM4Mk = parcelRequire("fM4Mk");

var $7u40a = parcelRequire("7u40a");

var $7wtv9 = parcelRequire("7wtv9");

var $lI2iN = parcelRequire("lI2iN");

var $eRV6E = parcelRequire("eRV6E");

var $aiLPr = parcelRequire("aiLPr");

var $boMdH = parcelRequire("boMdH");

var $jjbCG = parcelRequire("jjbCG");

var $9ad7k = parcelRequire("9ad7k");
"use strict";
const $664ff60a6792361f$var$tempRectangle = new (0, $fM4Mk.Rectangle)();
class $664ff60a6792361f$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
        this.signed = graphicsPath2D.checkForHoles;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $aiLPr.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $boMdH.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $jjbCG.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $lI2iN.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $eRV6E.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        const shapePrimitives = this.shapePrimitives;
        const start = shapePrimitives.length;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        if (path.checkForHoles && shapePrimitives.length - start > 1) {
            let mainShape = null;
            for(let i = start; i < shapePrimitives.length; i++){
                const shapePrimitive = shapePrimitives[i];
                if (shapePrimitive.shape.type === "polygon") {
                    const polygon = shapePrimitive.shape;
                    const mainPolygon = mainShape?.shape;
                    if (mainPolygon && mainPolygon.containsPolygon(polygon)) {
                        mainShape.holes || (mainShape.holes = []);
                        mainShape.holes.push(shapePrimitive);
                        shapePrimitives.copyWithin(i, i + 1);
                        shapePrimitives.length--;
                        i--;
                    } else mainShape = shapePrimitive;
                }
            }
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $fM4Mk.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $h7nJT.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $hbpIN.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = startAngle - i * delta;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $9ad7k.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $9ad7k.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $9hswb.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $7u40a.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $hbpIN.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $hbpIN.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (lastShape.transform && !lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($664ff60a6792361f$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("h7nJT", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $f9e7c5f8c3846477$export$c89a927ffc67e6fa);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $f9e7c5f8c3846477$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks.
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Circle(0, 0, 50);
     * console.log(shape.type); // 'circle'
     *
     * // Use in type guards
     * if (shape.type === 'circle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @remarks
     * - Used for shape type checking
     * - More efficient than instanceof
     * - Read-only property
     * @readonly
     * @default 'circle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     * @see {@link ShapePrimitive} For shape interface
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */ clone() {
        return new $f9e7c5f8c3846477$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, width, alignment = 0.5) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const radius = this.radius;
        const outerWidth = (1 - alignment) * width;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance <= radius + outerWidth && distance > radius - (width - outerWidth);
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("9hswb", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $985c1ca392a56bd1$export$80b0269ab108fa11);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $985c1ca392a56bd1$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Ellipse(0, 0, 50, 25);
     * console.log(shape.type); // 'ellipse'
     *
     * // Use in type guards
     * if (shape.type === 'ellipse') {
     *     console.log(shape.halfWidth, shape.halfHeight);
     * }
     * ```
     * @readonly
     * @default 'ellipse'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */ clone() {
        return new $985c1ca392a56bd1$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const strokeOuterWidth = strokeWidth * (1 - alignment);
        const strokeInnerWidth = strokeWidth - strokeOuterWidth;
        const innerHorizontal = halfWidth - strokeInnerWidth;
        const innerVertical = halfHeight - strokeInnerWidth;
        const outerHorizontal = halfWidth + strokeOuterWidth;
        const outerVertical = halfHeight + strokeOuterWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerHorizontal * innerHorizontal) + normalizedY * normalizedY / (innerVertical * innerVertical);
        const outerEllipse = normalizedX * normalizedX / (outerHorizontal * outerHorizontal) + normalizedY * normalizedY / (outerVertical * outerVertical);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x - this.halfWidth;
        out.y = this.y - this.halfHeight;
        out.width = this.halfWidth * 2;
        out.height = this.halfHeight * 2;
        return out;
    }
    /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("hbpIN", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $11dc5aebdc9b56ee$export$7d31b617c820d435);

var $kXq8E = parcelRequire("kXq8E");

var $4sAiw = parcelRequire("4sAiw");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
let $11dc5aebdc9b56ee$var$tempRect;
let $11dc5aebdc9b56ee$var$tempRect2;
class $11dc5aebdc9b56ee$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Polygon([0, 0, 100, 0, 50, 100]);
     * console.log(shape.type); // 'polygon'
     *
     * // Use in type guards
     * if (shape.type === 'polygon') {
     *     // TypeScript knows this is a Polygon
     *     console.log(shape.points.length);
     * }
     * ```
     * @readonly
     * @default 'polygon'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */ isClockwise() {
        let area = 0;
        const points = this.points;
        const length = points.length;
        for(let i = 0; i < length; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % length];
            const y2 = points[(i + 3) % length];
            area += (x2 - x1) * (y2 + y1);
        }
        return area < 0;
    }
    /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */ containsPolygon(polygon) {
        const thisBounds = this.getBounds($11dc5aebdc9b56ee$var$tempRect);
        const otherBounds = polygon.getBounds($11dc5aebdc9b56ee$var$tempRect2);
        if (!thisBounds.containsRect(otherBounds)) return false;
        const points = polygon.points;
        for(let i = 0; i < points.length; i += 2){
            const x = points[i];
            const y = points[i + 1];
            if (!this.contains(x, y)) return false;
        }
        return true;
    }
    /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */ clone() {
        const points = this.points.slice();
        const polygon = new $11dc5aebdc9b56ee$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const strokeWidthSquared = strokeWidth * strokeWidth;
        const rightWidthSquared = strokeWidthSquared * (1 - alignment);
        const leftWidthSquared = strokeWidthSquared - rightWidthSquared;
        const { points: points } = this;
        const iterationLength = points.length - (this.closePath ? 0 : 2);
        for(let i = 0; i < iterationLength; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSquared = (0, $4sAiw.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            const sign = Math.sign((x2 - x1) * (y - y1) - (y2 - y1) * (x - x1));
            if (distanceSquared <= (sign < 0 ? leftWidthSquared : rightWidthSquared)) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the last X coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastX} instead.
   */ get x() {
        (0, $kXq8E.deprecation)("8.11.0", "Polygon.lastX is deprecated, please use Polygon.lastX instead.");
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastY} instead.
   */ get y() {
        (0, $kXq8E.deprecation)("8.11.0", "Polygon.y is deprecated, please use Polygon.lastY instead.");
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.x); // 0
   * ```
   * @readonly
   * @returns The x-coordinate of the first vertex
   * @see {@link Polygon.startY} For first Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startX() {
        return this.points[0];
    }
    /**
   * Get the first Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.y); // 0
   * ```
   * @readonly
   * @returns The y-coordinate of the first vertex
   * @see {@link Polygon.startX} For first X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startY() {
        return this.points[1];
    }
}

});
parcelRegister("4sAiw", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $95fee67952e97042$export$db32ff20ff695a);
"use strict";
function $95fee67952e97042$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("7u40a", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $019041c7bdb3bf3e$export$d55ab2e3dc5a4263);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $019041c7bdb3bf3e$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, strokeWidthInner, strokeWidthOuter)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - strokeWidthInner && distance <= radius + strokeWidthOuter;
};
class $019041c7bdb3bf3e$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new RoundedRectangle(0, 0, 100, 100, 20);
     * console.log(shape.type); // 'roundedRectangle'
     *
     * // Use in type guards
     * if (shape.type === 'roundedRectangle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @readonly
     * @default 'roundedRectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $019041c7bdb3bf3e$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */ strokeContains(pX, pY, strokeWidth, alignment = 0.5) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - strokeWidthOuter && pX <= x + strokeWidthInner || pX >= rightBound - strokeWidthInner && pX <= rightBound + strokeWidthOuter) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - strokeWidthOuter && pY <= y + strokeWidthInner || pY >= bottomBound - strokeWidthInner && pY <= bottomBound + strokeWidthOuter) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter) || pX < innerX && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("lI2iN", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $4a51fd8da05fe222$export$7dab5eac414ecba2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $4a51fd8da05fe222$var$RECURSION_LIMIT = 8;
const $4a51fd8da05fe222$var$FLT_EPSILON = 11920929e-14;
const $4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON = 1;
const $4a51fd8da05fe222$var$curveAngleToleranceEpsilon = 0.01;
const $4a51fd8da05fe222$var$mAngleTolerance = 0;
const $4a51fd8da05fe222$var$mCuspLimit = 0;
function $4a51fd8da05fe222$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $4a51fd8da05fe222$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $4a51fd8da05fe222$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $4a51fd8da05fe222$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON && d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $4a51fd8da05fe222$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $4a51fd8da05fe222$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});
parcelRegister("hFzkv", function(module, exports) {

$parcel$export(module.exports, "GraphicsContextSystem", () => $119fb8487ef4f791$export$f2f3ca33e4c65172);

var $i9BKe = parcelRequire("i9BKe");

var $beJMG = parcelRequire("beJMG");

var $5RxDh = parcelRequire("5RxDh");

var $dK5Jn = parcelRequire("dK5Jn");

var $kXq8E = parcelRequire("kXq8E");

var $61KiY = parcelRequire("61KiY");

var $1mKkK = parcelRequire("1mKkK");
"use strict";
class $119fb8487ef4f791$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
}
class $119fb8487ef4f791$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.instructions = new (0, $dK5Jn.InstructionSet)();
    }
    init(maxTextures) {
        this.batcher = new (0, $5RxDh.DefaultBatcher)({
            maxTextures: maxTextures
        });
        this.instructions.reset();
    }
    /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */ get geometry() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_3_4), "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead.");
        return this.batcher.geometry;
    }
}
const $119fb8487ef4f791$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(renderer){
        // the root context batches, used to either make a batch or geometry
        // all graphics use this as a base
        this._gpuContextHash = {};
        // used for non-batchable graphics
        this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
        renderer.renderableGC.addManagedHash(this, "_gpuContextHash");
        renderer.renderableGC.addManagedHash(this, "_graphicsDataContextHash");
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        return this._graphicsDataContextHash[context.uid] || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        let gpuContext = this._gpuContextHash[context.uid] || this._initContext(context);
        if (context.dirty) {
            if (gpuContext) this._cleanGraphicsContextData(context);
            else gpuContext = this._initContext(context);
            (0, $1mKkK.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            else gpuContext.isBatchable = true;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        return this._gpuContextHash[context.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $61KiY.BigPool).get($119fb8487ef4f791$export$9b6a6c5b37fc8f49, {
            maxTextures: this._renderer.limits.maxBatchableTextures
        });
        const { batches: batches, geometryData: geometryData } = this._gpuContextHash[context.uid];
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = graphicsData.batcher;
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = batcher.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $beJMG.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count, this._renderer.limits.maxBatchableTextures);
        }
        this._graphicsDataContextHash[context.uid] = graphicsData;
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $119fb8487ef4f791$export$e3e348c254036d55();
        gpuContext.context = context;
        this._gpuContextHash[context.uid] = gpuContext;
        context.on("destroy", this.onGraphicsContextDestroy, this);
        return this._gpuContextHash[context.uid];
    }
    onGraphicsContextDestroy(context) {
        this._cleanGraphicsContextData(context);
        context.off("destroy", this.onGraphicsContextDestroy, this);
        this._gpuContextHash[context.uid] = null;
    }
    _cleanGraphicsContextData(context) {
        const gpuContext = this._gpuContextHash[context.uid];
        if (!gpuContext.isBatchable) {
            if (this._graphicsDataContextHash[context.uid]) {
                (0, $61KiY.BigPool).return(this.getContextRenderData(context));
                this._graphicsDataContextHash[context.uid] = null;
            }
        }
        if (gpuContext.batches) gpuContext.batches.forEach((batch)=>{
            (0, $61KiY.BigPool).return(batch);
        });
    }
    destroy() {
        for(const i in this._gpuContextHash)if (this._gpuContextHash[i]) this.onGraphicsContextDestroy(this._gpuContextHash[i].context);
    }
};
/** @ignore */ $119fb8487ef4f791$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem,
        (0, $i9BKe.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $119fb8487ef4f791$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $119fb8487ef4f791$export$f2f3ca33e4c65172 = $119fb8487ef4f791$var$_GraphicsContextSystem;

});
parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});
parcelRegister("awcfo", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $6cadf620a92ebba7$export$6f452ee382def63c);
"use strict";
class $6cadf620a92ebba7$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        if (currentResource) resource.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   */ _touch(tick) {
        const resources = this.resources;
        for(const i in resources)resources[i]._touched = tick;
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange(resource) {
        this._dirty = true;
        if (resource.destroyed) {
            const resources = this.resources;
            for(const i in resources)if (resources[i] === resource) resources[i] = null;
        } else this._updateKey();
    }
}

});


parcelRegister("5RxDh", function(module, exports) {

$parcel$export(module.exports, "DefaultBatcher", () => $122ab179875de631$export$34bf80542893bcb);

var $i9BKe = parcelRequire("i9BKe");

var $4rmMq = parcelRequire("4rmMq");

var $6Ogkc = parcelRequire("6Ogkc");

var $bBMVz = parcelRequire("bBMVz");
"use strict";
let $122ab179875de631$var$defaultShader = null;
const $122ab179875de631$var$_DefaultBatcher = class _DefaultBatcher extends (0, $4rmMq.Batcher) {
    constructor(options){
        super(options);
        this.geometry = new (0, $6Ogkc.BatchGeometry)();
        this.name = _DefaultBatcher.extension.name;
        /** The size of one attribute. 1 = 32 bit. x, y, u, v, color, textureIdAndRound -> total = 6 */ this.vertexSize = 6;
        $122ab179875de631$var$defaultShader ?? ($122ab179875de631$var$defaultShader = new (0, $bBMVz.DefaultShader)(options.maxTextures));
        this.shader = $122ab179875de631$var$defaultShader;
    }
    /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packAttributes(element, float32View, uint32View, index, textureId) {
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const { positions: positions, uvs: uvs } = element;
        const argb = element.color;
        const offset = element.attributeOffset;
        const end = offset + element.attributeSize;
        for(let i = offset; i < end; i++){
            const i2 = i * 2;
            const x = positions[i2];
            const y = positions[i2 + 1];
            float32View[index++] = a * x + c * y + tx;
            float32View[index++] = d * y + b * x + ty;
            float32View[index++] = uvs[i2];
            float32View[index++] = uvs[i2 + 1];
            uint32View[index++] = argb;
            uint32View[index++] = textureIdAndRound;
        }
    }
    /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packQuadAttributes(element, float32View, uint32View, index, textureId) {
        const texture = element.texture;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const bounds = element.bounds;
        const w0 = bounds.maxX;
        const w1 = bounds.minX;
        const h0 = bounds.maxY;
        const h1 = bounds.minY;
        const uvs = texture.uvs;
        const argb = element.color;
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        float32View[index + 0] = a * w1 + c * h1 + tx;
        float32View[index + 1] = d * h1 + b * w1 + ty;
        float32View[index + 2] = uvs.x0;
        float32View[index + 3] = uvs.y0;
        uint32View[index + 4] = argb;
        uint32View[index + 5] = textureIdAndRound;
        float32View[index + 6] = a * w0 + c * h1 + tx;
        float32View[index + 7] = d * h1 + b * w0 + ty;
        float32View[index + 8] = uvs.x1;
        float32View[index + 9] = uvs.y1;
        uint32View[index + 10] = argb;
        uint32View[index + 11] = textureIdAndRound;
        float32View[index + 12] = a * w0 + c * h0 + tx;
        float32View[index + 13] = d * h0 + b * w0 + ty;
        float32View[index + 14] = uvs.x2;
        float32View[index + 15] = uvs.y2;
        uint32View[index + 16] = argb;
        uint32View[index + 17] = textureIdAndRound;
        float32View[index + 18] = a * w1 + c * h0 + tx;
        float32View[index + 19] = d * h0 + b * w1 + ty;
        float32View[index + 20] = uvs.x3;
        float32View[index + 21] = uvs.y3;
        uint32View[index + 22] = argb;
        uint32View[index + 23] = textureIdAndRound;
    }
};
/** @ignore */ $122ab179875de631$var$_DefaultBatcher.extension = {
    type: [
        (0, $i9BKe.ExtensionType).Batcher
    ],
    name: "default"
};
let $122ab179875de631$export$34bf80542893bcb = $122ab179875de631$var$_DefaultBatcher;

});
parcelRegister("4rmMq", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $71f140885a3d3890$export$704b12ddc1dacdd2);

var $aGJhg = parcelRequire("aGJhg");

var $aaUE3 = parcelRequire("aaUE3");

var $kXq8E = parcelRequire("kXq8E");

var $1tfR4 = parcelRequire("1tfR4");

var $eN26f = parcelRequire("eN26f");

var $1EHMq = parcelRequire("1EHMq");

var $bRzRK = parcelRequire("bRzRK");
"use strict";
class $71f140885a3d3890$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.textures = new (0, $bRzRK.BatchTextureArray)();
        this.blendMode = "normal";
        this.topology = "triangle-strip";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
    }
}
const $71f140885a3d3890$var$batchPool = [];
let $71f140885a3d3890$var$batchPoolIndex = 0;
function $71f140885a3d3890$var$getBatchFromPool() {
    return $71f140885a3d3890$var$batchPoolIndex > 0 ? $71f140885a3d3890$var$batchPool[--$71f140885a3d3890$var$batchPoolIndex] : new $71f140885a3d3890$export$33b107562567fc47();
}
function $71f140885a3d3890$var$returnBatchToPool(batch) {
    $71f140885a3d3890$var$batchPool[$71f140885a3d3890$var$batchPoolIndex++] = batch;
}
let $71f140885a3d3890$var$BATCH_TICK = 0;
const $71f140885a3d3890$var$_Batcher = class _Batcher {
    constructor(options){
        /** unique id for this batcher */ this.uid = (0, $aGJhg.uid)("batcher");
        /** Indicates whether the batch data has been modified and needs updating. */ this.dirty = true;
        /** The current index of the batch being processed. */ this.batchIndex = 0;
        /** An array of all batches created during the current rendering process. */ this.batches = [];
        this._elements = [];
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        if (!options.maxTextures) {
            (0, $kXq8E.deprecation)("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options");
            options.maxTextures = (0, $1EHMq.getMaxTexturesPerBatch)();
        }
        const { maxTextures: maxTextures, attributesInitialSize: attributesInitialSize, indicesInitialSize: indicesInitialSize } = options;
        this.attributeBuffer = new (0, $aaUE3.ViewableBuffer)(attributesInitialSize * 4);
        this.indexBuffer = new Uint16Array(indicesInitialSize);
        this.maxTextures = maxTextures;
    }
    begin() {
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        for(let i = 0; i < this.batchIndex; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batchIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject._indexStart = this.indexSize;
        batchableObject._attributeStart = this.attributeSize;
        batchableObject._batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.attributeSize * this.vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject._batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject._textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        const attributeBuffer = this.attributeBuffer;
        if (batchableObject.packAsQuad) this.packQuadAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
        else this.packAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        if (!elements[this.elementStart]) return;
        let batch = $71f140885a3d3890$var$getBatchFromPool();
        let textureBatch = batch.textures;
        textureBatch.clear();
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $eN26f.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        let topology = firstElement.topology;
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const indexBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        const maxTextures = this.maxTextures;
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $eN26f.getAdjustedBlendModeBlend)(element.blendMode, source);
            const breakRequired = blendMode !== adjustedBlendMode || topology !== element.topology;
            if (source._batchTick === $71f140885a3d3890$var$BATCH_TICK && !breakRequired) {
                element._textureId = source._textureBindLocation;
                size += element.indexSize;
                if (element.packAsQuad) {
                    this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                } else {
                    this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                }
                element._batch = batch;
                continue;
            }
            source._batchTick = $71f140885a3d3890$var$BATCH_TICK;
            if (textureBatch.count >= maxTextures || breakRequired) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                topology = element.topology;
                batch = $71f140885a3d3890$var$getBatchFromPool();
                textureBatch = batch.textures;
                textureBatch.clear();
                ++$71f140885a3d3890$var$BATCH_TICK;
            }
            element._textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element._batch = batch;
            size += element.indexSize;
            if (element.packAsQuad) {
                this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            } else {
                this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            }
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action);
            start = size;
            ++$71f140885a3d3890$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, topology, instructionSet, action) {
        batch.gpuBindGroup = null;
        batch.bindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.topology = topology;
        batch.start = indexStart;
        batch.size = indexSize;
        ++$71f140885a3d3890$var$BATCH_TICK;
        this.batches[this.batchIndex++] = batch;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $aaUE3.ViewableBuffer)(newSize);
        (0, $1tfR4.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $1tfR4.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    packQuadIndex(indexBuffer, index, indicesOffset) {
        indexBuffer[index] = indicesOffset + 0;
        indexBuffer[index + 1] = indicesOffset + 1;
        indexBuffer[index + 2] = indicesOffset + 2;
        indexBuffer[index + 3] = indicesOffset + 0;
        indexBuffer[index + 4] = indicesOffset + 2;
        indexBuffer[index + 5] = indicesOffset + 3;
    }
    packIndex(element, indexBuffer, index, indicesOffset) {
        const indices = element.indices;
        const size = element.indexSize;
        const indexOffset = element.indexOffset;
        const attributeOffset = element.attributeOffset;
        for(let i = 0; i < size; i++)indexBuffer[index++] = indicesOffset + indices[i + indexOffset] - attributeOffset;
    }
    destroy() {
        for(let i = 0; i < this.batches.length; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batches = null;
        for(let i = 0; i < this._elements.length; i++)this._elements[i]._batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$71f140885a3d3890$var$_Batcher.defaultOptions = {
    maxTextures: null,
    attributesInitialSize: 4,
    indicesInitialSize: 6
};
let $71f140885a3d3890$export$704b12ddc1dacdd2 = $71f140885a3d3890$var$_Batcher;

});
parcelRegister("aaUE3", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $d6aafa25b0389ff9$export$4fdbf0662aa3047a);
"use strict";
class $d6aafa25b0389ff9$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this.uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("1tfR4", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $3976cf47510ef1a5$export$c691b0c42debe682);
"use strict";
function $3976cf47510ef1a5$export$c691b0c42debe682(sourceBuffer, destinationBuffer) {
    const lengthDouble = sourceBuffer.byteLength / 8 | 0;
    const sourceFloat64View = new Float64Array(sourceBuffer, 0, lengthDouble);
    const destinationFloat64View = new Float64Array(destinationBuffer, 0, lengthDouble);
    destinationFloat64View.set(sourceFloat64View);
    const remainingBytes = sourceBuffer.byteLength - lengthDouble * 8;
    if (remainingBytes > 0) {
        const sourceUint8View = new Uint8Array(sourceBuffer, lengthDouble * 8, remainingBytes);
        const destinationUint8View = new Uint8Array(destinationBuffer, lengthDouble * 8, remainingBytes);
        destinationUint8View.set(sourceUint8View);
    }
}

});

parcelRegister("eN26f", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $3b017cb7131d92fc$export$ab2fc5cf3fe899fe);

var $eE5Ke = parcelRequire("eE5Ke");
"use strict";
function $3b017cb7131d92fc$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $eE5Ke.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});
parcelRegister("eE5Ke", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $16526f00f7b0e2b9$export$c250b85d73a91bdf);
"use strict";
const $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $16526f00f7b0e2b9$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["INVERSE_MASK_ACTIVE"] = 3] = "INVERSE_MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 4] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 5] = "NONE";
    return STENCIL_MODES2;
})($16526f00f7b0e2b9$export$c250b85d73a91bdf || {});

});


parcelRegister("1EHMq", function(module, exports) {

$parcel$export(module.exports, "getMaxTexturesPerBatch", () => $b5d07f8bc89d7387$export$313b92466c30ee73);

var $ckKKH = parcelRequire("ckKKH");

var $awsWF = parcelRequire("awsWF");
"use strict";
let $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = null;
function $b5d07f8bc89d7387$export$313b92466c30ee73() {
    if ($b5d07f8bc89d7387$var$maxTexturesPerBatchCache) return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
    const gl = (0, $ckKKH.getTestContext)();
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = (0, $awsWF.checkMaxIfStatementsInShader)($b5d07f8bc89d7387$var$maxTexturesPerBatchCache, gl);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
}

});
parcelRegister("ckKKH", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $a517f2c0dcfb1c3f$export$f034b2d55f8df08b);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $a517f2c0dcfb1c3f$var$context;
function $a517f2c0dcfb1c3f$export$f034b2d55f8df08b() {
    if (!$a517f2c0dcfb1c3f$var$context || $a517f2c0dcfb1c3f$var$context?.isContextLost()) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        $a517f2c0dcfb1c3f$var$context = canvas.getContext("webgl", {});
    }
    return $a517f2c0dcfb1c3f$var$context;
}

});

parcelRegister("awsWF", function(module, exports) {

$parcel$export(module.exports, "checkMaxIfStatementsInShader", () => $717b67827b6a1bc1$export$fb6ad4e758d74cc0);
"use strict";
const $717b67827b6a1bc1$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join("\n");
function $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i){
        if (i > 0) src += "\nelse ";
        if (i < maxIfs - 1) src += `if(test == ${i}.0){}`;
    }
    return src;
}
function $717b67827b6a1bc1$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    try {
        while(true){
            const fragmentSrc = $717b67827b6a1bc1$var$fragTemplate.replace(/%forloop%/gi, $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs));
            gl.shaderSource(shader, fragmentSrc);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
            else break;
        }
    } finally{
        gl.deleteShader(shader);
    }
    return maxIfs;
}

});


parcelRegister("bRzRK", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $a96c3003620e8697$export$aa760e0febf1a758);
"use strict";
class $a96c3003620e8697$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("6Ogkc", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $ec424808c68c925d$export$449e8d355fd68e43);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");

var $cOnev = parcelRequire("cOnev");
"use strict";
const $ec424808c68c925d$var$placeHolderBufferData = new Float32Array(1);
const $ec424808c68c925d$var$placeHolderIndexData = new Uint32Array(1);
class $ec424808c68c925d$export$449e8d355fd68e43 extends (0, $cOnev.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});
parcelRegister("lvEAL", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $9841377a483d1ce7$export$a143d493d941bafc);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
class $9841377a483d1ce7$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** @internal */ this._updateID = 1;
        this._dataInt32 = null;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        /**
     * Has the buffer been destroyed?
     * @readonly
     */ this.destroyed = false;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size ?? (size = data?.byteLength);
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    get dataInt32() {
        if (!this._dataInt32) this._dataInt32 = new Int32Array(this.data.buffer);
        return this._dataInt32;
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $1UZ6r.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $1UZ6r.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $1UZ6r.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        this._dataInt32 = null;
        if (!oldData || oldData.length !== value.length) {
            if (!this.shrinkToFit && oldData && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $aGJhg.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Destroys the buffer */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("1UZ6r", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $f4c8f2641f61e66f$export$f8deb2be8632fd10);
"use strict";
var $f4c8f2641f61e66f$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($f4c8f2641f61e66f$export$f8deb2be8632fd10 || {});

});


parcelRegister("cOnev", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $f72e7cebaee4d192$export$2db6c17465f94a2);

var $3vRz3 = parcelRequire("3vRz3");

var $7wtv9 = parcelRequire("7wtv9");

var $aGJhg = parcelRequire("aGJhg");

var $lvEAL = parcelRequire("lvEAL");

var $zwuDY = parcelRequire("zwuDY");

var $dYcXX = parcelRequire("dYcXX");
"use strict";
function $f72e7cebaee4d192$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $lvEAL.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $zwuDY.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $f72e7cebaee4d192$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options = {}){
        super();
        /** The unique id of the geometry. */ this.uid = (0, $aGJhg.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        this.buffers = [];
        this.attributes = {};
        if (attributes) for(const i in attributes)this.addAttribute(i, attributes[i]);
        this.instanceCount = options.instanceCount ?? 1;
        if (indexBuffer) this.addIndex(indexBuffer);
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */ addAttribute(name, attributeOption) {
        const attribute = $f72e7cebaee4d192$var$ensureIsAttribute(attributeOption);
        const bufferIndex = this.buffers.indexOf(attribute.buffer);
        if (bufferIndex === -1) {
            this.buffers.push(attribute.buffer);
            attribute.buffer.on("update", this.onBufferUpdate, this);
            attribute.buffer.on("change", this.onBufferUpdate, this);
        }
        this.attributes[name] = attribute;
    }
    /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */ addIndex(indexBuffer) {
        this.indexBuffer = (0, $zwuDY.ensureIsBuffer)(indexBuffer, true);
        this.buffers.push(this.indexBuffer);
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $dYcXX.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("zwuDY", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $c27f8a68b3d31b3f$export$e02adcb3cf335e03);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
function $c27f8a68b3d31b3f$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $lvEAL.Buffer))) {
        let usage = index ? (0, $1UZ6r.BufferUsage).INDEX : (0, $1UZ6r.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $lvEAL.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("dYcXX", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $547d4a1f0305efcb$export$ca8be28ec6402f29);
"use strict";
function $547d4a1f0305efcb$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});



parcelRegister("bBMVz", function(module, exports) {

$parcel$export(module.exports, "DefaultShader", () => $5546e8c9dd716d36$export$5ee16216350ebcbc);

var $3JBHn = parcelRequire("3JBHn");

var $cNnNT = parcelRequire("cNnNT");

var $ikSZA = parcelRequire("ikSZA");

var $kSpdC = parcelRequire("kSpdC");

var $10zIa = parcelRequire("10zIa");

var $5iDyo = parcelRequire("5iDyo");
"use strict";
class $5546e8c9dd716d36$export$5ee16216350ebcbc extends (0, $5iDyo.Shader) {
    constructor(maxTextures){
        const glProgram = (0, $3JBHn.compileHighShaderGlProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBitGl),
                (0, $ikSZA.generateTextureBatchBitGl)(maxTextures),
                (0, $kSpdC.roundPixelsBitGl)
            ]
        });
        const gpuProgram = (0, $3JBHn.compileHighShaderGpuProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBit),
                (0, $ikSZA.generateTextureBatchBit)(maxTextures),
                (0, $kSpdC.roundPixelsBit)
            ]
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                batchSamplers: (0, $10zIa.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
    }
}

});
parcelRegister("3JBHn", function(module, exports) {

$parcel$export(module.exports, "compileHighShaderGpuProgram", () => $52144493f15d3fff$export$af9d352c01aa9018);
$parcel$export(module.exports, "compileHighShaderGlProgram", () => $52144493f15d3fff$export$477b8252c7ecdf2);

var $fK92B = parcelRequire("fK92B");

var $6j7wq = parcelRequire("6j7wq");

var $i8pLT = parcelRequire("i8pLT");

var $jOJh1 = parcelRequire("jOJh1");

var $8hMvn = parcelRequire("8hMvn");
"use strict";
function $52144493f15d3fff$export$af9d352c01aa9018({ bits: bits, name: name }) {
    const source = (0, $i8pLT.compileHighShader)({
        template: {
            fragment: (0, $jOJh1.fragmentGPUTemplate),
            vertex: (0, $jOJh1.vertexGPUTemplate)
        },
        bits: [
            (0, $8hMvn.globalUniformsBit),
            ...bits
        ]
    });
    return (0, $6j7wq.GpuProgram).from({
        name: name,
        vertex: {
            source: source.vertex,
            entryPoint: "main"
        },
        fragment: {
            source: source.fragment,
            entryPoint: "main"
        }
    });
}
function $52144493f15d3fff$export$477b8252c7ecdf2({ bits: bits, name: name }) {
    return new (0, $fK92B.GlProgram)({
        name: name,
        ...(0, $i8pLT.compileHighShaderGl)({
            template: {
                vertex: (0, $jOJh1.vertexGlTemplate),
                fragment: (0, $jOJh1.fragmentGlTemplate)
            },
            bits: [
                (0, $8hMvn.globalUniformsBitGl),
                ...bits
            ]
        })
    });
}

});
parcelRegister("fK92B", function(module, exports) {

$parcel$export(module.exports, "GlProgram", () => $5a1cd4acf4c2252d$export$64881d9ea0a969d7);

var $9kWs1 = parcelRequire("9kWs1");

var $c1vp1 = parcelRequire("c1vp1");

var $iCp49 = parcelRequire("iCp49");

var $67Nsh = parcelRequire("67Nsh");

var $3Hbxe = parcelRequire("3Hbxe");

var $aUAMu = parcelRequire("aUAMu");

var $500fb = parcelRequire("500fb");
"use strict";
const $5a1cd4acf4c2252d$var$processes = {
    stripVersion: // strips any version headers..
    $500fb.stripVersion,
    ensurePrecision: // adds precision string if not already present
    $67Nsh.ensurePrecision,
    addProgramDefines: // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
    $iCp49.addProgramDefines,
    setProgramName: // add the program name to the shader
    $aUAMu.setProgramName,
    insertVersion: // add the version string to the shader header
    $3Hbxe.insertVersion
};
const $5a1cd4acf4c2252d$var$programCache = /* @__PURE__ */ Object.create(null);
const $5a1cd4acf4c2252d$var$_GlProgram = class _GlProgram {
    /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */ constructor(options){
        options = {
            ..._GlProgram.defaultOptions,
            ...options
        };
        const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
        const preprocessorOptions = {
            stripVersion: isES300,
            ensurePrecision: {
                requestedFragmentPrecision: options.preferredFragmentPrecision,
                requestedVertexPrecision: options.preferredVertexPrecision,
                maxSupportedVertexPrecision: "highp",
                maxSupportedFragmentPrecision: (0, $c1vp1.getMaxFragmentPrecision)()
            },
            setProgramName: {
                name: options.name
            },
            addProgramDefines: isES300,
            insertVersion: isES300
        };
        let fragment = options.fragment;
        let vertex = options.vertex;
        Object.keys($5a1cd4acf4c2252d$var$processes).forEach((processKey)=>{
            const processOptions = preprocessorOptions[processKey];
            fragment = $5a1cd4acf4c2252d$var$processes[processKey](fragment, processOptions, true);
            vertex = $5a1cd4acf4c2252d$var$processes[processKey](vertex, processOptions, false);
        });
        this.fragment = fragment;
        this.vertex = vertex;
        this.transformFeedbackVaryings = options.transformFeedbackVaryings;
        this._key = (0, $9kWs1.createIdFromString)(`${this.vertex}:${this.fragment}`, "gl-program");
    }
    /** destroys the program */ destroy() {
        this.fragment = null;
        this.vertex = null;
        this._attributeData = null;
        this._uniformData = null;
        this._uniformBlockData = null;
        this.transformFeedbackVaryings = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex}:${options.fragment}`;
        if (!$5a1cd4acf4c2252d$var$programCache[key]) $5a1cd4acf4c2252d$var$programCache[key] = new _GlProgram(options);
        return $5a1cd4acf4c2252d$var$programCache[key];
    }
};
/** The default options used by the program. */ $5a1cd4acf4c2252d$var$_GlProgram.defaultOptions = {
    preferredVertexPrecision: "highp",
    preferredFragmentPrecision: "mediump"
};
let $5a1cd4acf4c2252d$export$64881d9ea0a969d7 = $5a1cd4acf4c2252d$var$_GlProgram;

});
parcelRegister("9kWs1", function(module, exports) {

$parcel$export(module.exports, "createIdFromString", () => $0601e88d616c38d4$export$1e452c36dfe36a93);
"use strict";
const $0601e88d616c38d4$var$idCounts = /* @__PURE__ */ Object.create(null);
const $0601e88d616c38d4$var$idHash = /* @__PURE__ */ Object.create(null);
function $0601e88d616c38d4$export$1e452c36dfe36a93(value, groupId) {
    let id = $0601e88d616c38d4$var$idHash[value];
    if (id === void 0) {
        if ($0601e88d616c38d4$var$idCounts[groupId] === void 0) $0601e88d616c38d4$var$idCounts[groupId] = 1;
        $0601e88d616c38d4$var$idHash[value] = id = $0601e88d616c38d4$var$idCounts[groupId]++;
    }
    return id;
}

});

parcelRegister("c1vp1", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $e905b7e6e5b75a20$export$428c38e64838140);

var $ckKKH = parcelRequire("ckKKH");
"use strict";
let $e905b7e6e5b75a20$var$maxFragmentPrecision;
function $e905b7e6e5b75a20$export$428c38e64838140() {
    if (!$e905b7e6e5b75a20$var$maxFragmentPrecision) {
        $e905b7e6e5b75a20$var$maxFragmentPrecision = "mediump";
        const gl = (0, $ckKKH.getTestContext)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $e905b7e6e5b75a20$var$maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
            }
        }
    }
    return $e905b7e6e5b75a20$var$maxFragmentPrecision;
}

});

parcelRegister("iCp49", function(module, exports) {

$parcel$export(module.exports, "addProgramDefines", () => $ab141df14b998d07$export$fba00ea8bc676dd1);
"use strict";
function $ab141df14b998d07$export$fba00ea8bc676dd1(src, isES300, isFragment) {
    if (isES300) return src;
    if (isFragment) {
        src = src.replace("out vec4 finalColor;", "");
        return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
    }
    return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}

});

parcelRegister("67Nsh", function(module, exports) {

$parcel$export(module.exports, "ensurePrecision", () => $bda6ccefc0c5ab42$export$899bdffb1b617f8b);
"use strict";
function $bda6ccefc0c5ab42$export$899bdffb1b617f8b(src, options, isFragment) {
    const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
    if (src.substring(0, 9) !== "precision") {
        let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
        if (precision === "highp" && maxSupportedPrecision !== "highp") precision = "mediump";
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("3Hbxe", function(module, exports) {

$parcel$export(module.exports, "insertVersion", () => $82be6e3df1c54b73$export$df5409633d2e06a0);
"use strict";
function $82be6e3df1c54b73$export$df5409633d2e06a0(src, isES300) {
    if (!isES300) return src;
    return `#version 300 es
${src}`;
}

});

parcelRegister("aUAMu", function(module, exports) {

$parcel$export(module.exports, "setProgramName", () => $de2ea14e21161fdc$export$fcd35f5a80d5e29b);
"use strict";
const $de2ea14e21161fdc$var$fragmentNameCache = {};
const $de2ea14e21161fdc$var$VertexNameCache = {};
function $de2ea14e21161fdc$export$fcd35f5a80d5e29b(src, { name: name = `pixi-program` }, isFragment = true) {
    name = name.replace(/\s+/g, "-");
    name += isFragment ? "-fragment" : "-vertex";
    const nameCache = isFragment ? $de2ea14e21161fdc$var$fragmentNameCache : $de2ea14e21161fdc$var$VertexNameCache;
    if (nameCache[name]) {
        nameCache[name]++;
        name += `-${nameCache[name]}`;
    } else nameCache[name] = 1;
    if (src.indexOf("#define SHADER_NAME") !== -1) return src;
    const shaderName = `#define SHADER_NAME ${name}`;
    return `${shaderName}
${src}`;
}

});

parcelRegister("500fb", function(module, exports) {

$parcel$export(module.exports, "stripVersion", () => $d98e8e318b45168f$export$f71406e7a553e9e5);
"use strict";
function $d98e8e318b45168f$export$f71406e7a553e9e5(src, isES300) {
    if (!isES300) return src;
    return src.replace("#version 300 es", "");
}

});


parcelRegister("6j7wq", function(module, exports) {

$parcel$export(module.exports, "GpuProgram", () => $8e9bc14aafd75f61$export$b7a31a3cdd61870);

var $9kWs1 = parcelRequire("9kWs1");

var $7j3L3 = parcelRequire("7j3L3");

var $ceyhm = parcelRequire("ceyhm");

var $eebg6 = parcelRequire("eebg6");

var $gwiyt = parcelRequire("gwiyt");

var $ftyd4 = parcelRequire("ftyd4");
"use strict";
const $8e9bc14aafd75f61$var$programCache = /* @__PURE__ */ Object.create(null);
class $8e9bc14aafd75f61$export$b7a31a3cdd61870 {
    /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */ constructor(options){
        /** @internal */ this._layoutKey = 0;
        /** @internal */ this._attributeLocationsKey = 0;
        const { fragment: fragment, vertex: vertex, layout: layout, gpuLayout: gpuLayout, name: name } = options;
        this.name = name;
        this.fragment = fragment;
        this.vertex = vertex;
        if (fragment.source === vertex.source) {
            const structsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = structsAndGroups;
        } else {
            const vertexStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(vertex.source);
            const fragmentStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = (0, $ftyd4.removeStructAndGroupDuplicates)(vertexStructsAndGroups, fragmentStructsAndGroups);
        }
        this.layout = layout ?? (0, $gwiyt.generateLayoutHash)(this.structsAndGroups);
        this.gpuLayout = gpuLayout ?? (0, $eebg6.generateGpuLayoutGroups)(this.structsAndGroups);
        this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
        this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
        this._generateProgramKey();
    }
    // TODO maker this pure
    _generateProgramKey() {
        const { vertex: vertex, fragment: fragment } = this;
        const bigKey = vertex.source + fragment.source + vertex.entryPoint + fragment.entryPoint;
        this._layoutKey = (0, $9kWs1.createIdFromString)(bigKey, "program");
    }
    get attributeData() {
        this._attributeData ?? (this._attributeData = (0, $7j3L3.extractAttributesFromGpuProgram)(this.vertex));
        return this._attributeData;
    }
    /** destroys the program */ destroy() {
        this.gpuLayout = null;
        this.layout = null;
        this.structsAndGroups = null;
        this.fragment = null;
        this.vertex = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
        if (!$8e9bc14aafd75f61$var$programCache[key]) $8e9bc14aafd75f61$var$programCache[key] = new $8e9bc14aafd75f61$export$b7a31a3cdd61870(options);
        return $8e9bc14aafd75f61$var$programCache[key];
    }
}

});
parcelRegister("7j3L3", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGpuProgram", () => $a83de38b8d80c92b$export$b0efe5f01c53f69f);

var $kavUV = parcelRequire("kavUV");
"use strict";
const $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES = {
    f32: "float32",
    "vec2<f32>": "float32x2",
    "vec3<f32>": "float32x3",
    "vec4<f32>": "float32x4",
    vec2f: "float32x2",
    vec3f: "float32x3",
    vec4f: "float32x4",
    i32: "sint32",
    "vec2<i32>": "sint32x2",
    "vec3<i32>": "sint32x3",
    "vec4<i32>": "sint32x4",
    u32: "uint32",
    "vec2<u32>": "uint32x2",
    "vec3<u32>": "uint32x3",
    "vec4<u32>": "uint32x4",
    bool: "uint32",
    "vec2<bool>": "uint32x2",
    "vec3<bool>": "uint32x3",
    "vec4<bool>": "uint32x4"
};
function $a83de38b8d80c92b$export$b0efe5f01c53f69f({ source: source, entryPoint: entryPoint }) {
    const results = {};
    const mainVertStart = source.indexOf(`fn ${entryPoint}`);
    if (mainVertStart !== -1) {
        const arrowFunctionStart = source.indexOf("->", mainVertStart);
        if (arrowFunctionStart !== -1) {
            const functionArgsSubstring = source.substring(mainVertStart, arrowFunctionStart);
            const inputsRegex = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|$)/g;
            let match;
            while((match = inputsRegex.exec(functionArgsSubstring)) !== null){
                const format = $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
                results[match[2]] = {
                    location: parseInt(match[1], 10),
                    format: format,
                    stride: (0, $kavUV.getAttributeInfoFromFormat)(format).stride,
                    offset: 0,
                    instance: false,
                    start: 0
                };
            }
        }
    }
    return results;
}

});
parcelRegister("kavUV", function(module, exports) {

$parcel$export(module.exports, "getAttributeInfoFromFormat", () => $b94249370f97e371$export$4da509c30cc6be33);
"use strict";
const $b94249370f97e371$var$attributeFormatData = {
    uint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    uint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    sint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    sint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    unorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    unorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    snorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    snorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    uint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    uint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    sint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    sint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    unorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    unorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    snorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    snorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    float16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    float16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    float32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    float32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    float32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    float32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    uint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    uint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    uint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    uint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    sint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    sint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    sint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    sint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    }
};
function $b94249370f97e371$export$4da509c30cc6be33(format) {
    return $b94249370f97e371$var$attributeFormatData[format] ?? $b94249370f97e371$var$attributeFormatData.float32;
}

});


parcelRegister("ceyhm", function(module, exports) {

$parcel$export(module.exports, "extractStructAndGroups", () => $ea3e5b1ac2f96ec2$export$368e99a200562975);
"use strict";
function $ea3e5b1ac2f96ec2$export$368e99a200562975(wgsl) {
    const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
    const groupPattern = /@group\((\d+)\)/;
    const bindingPattern = /@binding\((\d+)\)/;
    const namePattern = /var(<[^>]+>)? (\w+)/;
    const typePattern = /:\s*(\w+)/;
    const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
    const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
    const structName = /struct\s+(\w+)/;
    const groups = wgsl.match(linePattern)?.map((item)=>({
            group: parseInt(item.match(groupPattern)[1], 10),
            binding: parseInt(item.match(bindingPattern)[1], 10),
            name: item.match(namePattern)[2],
            isUniform: item.match(namePattern)[1] === "<uniform>",
            type: item.match(typePattern)[1]
        }));
    if (!groups) return {
        groups: [],
        structs: []
    };
    const structs = wgsl.match(structPattern)?.map((struct)=>{
        const name = struct.match(structName)[1];
        const members = struct.match(structMemberPattern).reduce((acc, member)=>{
            const [name2, type] = member.split(":");
            acc[name2.trim()] = type.trim();
            return acc;
        }, {});
        if (!members) return null;
        return {
            name: name,
            members: members
        };
    }).filter(({ name: name })=>groups.some((group)=>group.type === name)) ?? [];
    return {
        groups: groups,
        structs: structs
    };
}

});

parcelRegister("eebg6", function(module, exports) {

$parcel$export(module.exports, "generateGpuLayoutGroups", () => $6d1e03a3e3cda982$export$950011c0dc347495);

var $aR3rf = parcelRequire("aR3rf");
"use strict";
function $6d1e03a3e3cda982$export$950011c0dc347495({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = [];
        if (group.isUniform) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).VERTEX | (0, $aR3rf.ShaderStage).FRAGMENT,
            buffer: {
                type: "uniform"
            }
        });
        else if (group.type === "sampler") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            sampler: {
                type: "filtering"
            }
        });
        else if (group.type === "texture_2d") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            }
        });
    }
    return layout;
}

});
parcelRegister("aR3rf", function(module, exports) {

$parcel$export(module.exports, "ShaderStage", () => $06e6106f9171a2e8$export$34a0cafc5a97ef31);
"use strict";
var $06e6106f9171a2e8$export$34a0cafc5a97ef31 = /* @__PURE__ */ ((ShaderStage2)=>{
    ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
    ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
    ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
    return ShaderStage2;
})($06e6106f9171a2e8$export$34a0cafc5a97ef31 || {});

});


parcelRegister("gwiyt", function(module, exports) {

$parcel$export(module.exports, "generateLayoutHash", () => $292f21f6c3cd9e17$export$6a0f9650f9d4f875);
"use strict";
function $292f21f6c3cd9e17$export$6a0f9650f9d4f875({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = {};
        layout[group.group][group.name] = group.binding;
    }
    return layout;
}

});

parcelRegister("ftyd4", function(module, exports) {

$parcel$export(module.exports, "removeStructAndGroupDuplicates", () => $f605447e20cc6f1a$export$5f344e20ddfaa2d6);
"use strict";
function $f605447e20cc6f1a$export$5f344e20ddfaa2d6(vertexStructsAndGroups, fragmentStructsAndGroups) {
    const structNameSet = /* @__PURE__ */ new Set();
    const dupeGroupKeySet = /* @__PURE__ */ new Set();
    const structs = [
        ...vertexStructsAndGroups.structs,
        ...fragmentStructsAndGroups.structs
    ].filter((struct)=>{
        if (structNameSet.has(struct.name)) return false;
        structNameSet.add(struct.name);
        return true;
    });
    const groups = [
        ...vertexStructsAndGroups.groups,
        ...fragmentStructsAndGroups.groups
    ].filter((group)=>{
        const key = `${group.name}-${group.binding}`;
        if (dupeGroupKeySet.has(key)) return false;
        dupeGroupKeySet.add(key);
        return true;
    });
    return {
        structs: structs,
        groups: groups
    };
}

});


parcelRegister("i8pLT", function(module, exports) {

$parcel$export(module.exports, "compileHighShader", () => $9ef573d9dfae5a48$export$86219fd7a1c584d2);
$parcel$export(module.exports, "compileHighShaderGl", () => $9ef573d9dfae5a48$export$ff7039b165d48f97);

var $9zLXd = parcelRequire("9zLXd");

var $jJet4 = parcelRequire("jJet4");

var $ak3Em = parcelRequire("ak3Em");

var $9hCqF = parcelRequire("9hCqF");

var $9Zsfg = parcelRequire("9Zsfg");
"use strict";
const $9ef573d9dfae5a48$var$cacheMap = /* @__PURE__ */ Object.create(null);
const $9ef573d9dfae5a48$var$bitCacheMap = /* @__PURE__ */ new Map();
let $9ef573d9dfae5a48$var$CACHE_UID = 0;
function $9ef573d9dfae5a48$export$86219fd7a1c584d2({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    const { vertex: vertex, fragment: fragment } = $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits);
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$export$ff7039b165d48f97({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(template.vertex, template.fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits) {
    const vertexFragments = bits.map((shaderBit)=>shaderBit.vertex).filter((v)=>!!v);
    const fragmentFragments = bits.map((shaderBit)=>shaderBit.fragment).filter((v)=>!!v);
    let compiledVertex = (0, $ak3Em.compileInputs)(vertexFragments, template.vertex, true);
    compiledVertex = (0, $9hCqF.compileOutputs)(vertexFragments, compiledVertex);
    const compiledFragment = (0, $ak3Em.compileInputs)(fragmentFragments, template.fragment, true);
    return {
        vertex: compiledVertex,
        fragment: compiledFragment
    };
}
function $9ef573d9dfae5a48$var$generateCacheId(template, bits) {
    return bits.map((highFragment)=>{
        if (!$9ef573d9dfae5a48$var$bitCacheMap.has(highFragment)) $9ef573d9dfae5a48$var$bitCacheMap.set(highFragment, $9ef573d9dfae5a48$var$CACHE_UID++);
        return $9ef573d9dfae5a48$var$bitCacheMap.get(highFragment);
    }).sort((a, b)=>a - b).join("-") + template.vertex + template.fragment;
}
function $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits) {
    const vertexParts = (0, $jJet4.compileHooks)(vertex);
    const fragmentParts = (0, $jJet4.compileHooks)(fragment);
    bits.forEach((shaderBit)=>{
        (0, $9zLXd.addBits)(shaderBit.vertex, vertexParts, shaderBit.name);
        (0, $9zLXd.addBits)(shaderBit.fragment, fragmentParts, shaderBit.name);
    });
    return {
        vertex: (0, $9Zsfg.injectBits)(vertex, vertexParts),
        fragment: (0, $9Zsfg.injectBits)(fragment, fragmentParts)
    };
}

});
parcelRegister("9zLXd", function(module, exports) {

$parcel$export(module.exports, "addBits", () => $c36d60e017699465$export$38c21fb192fe3d9);

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $c36d60e017699465$export$38c21fb192fe3d9(srcParts, parts, name) {
    if (srcParts) for(const i in srcParts){
        const id = i.toLocaleLowerCase();
        const part = parts[id];
        if (part) {
            let sanitisedPart = srcParts[i];
            if (i === "header") sanitisedPart = sanitisedPart.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "");
            if (name) part.push(`//----${name}----//`);
            part.push(sanitisedPart);
        } else (0, $hUCK4.warn)(`${i} placement hook does not exist in shader`);
    }
}

});

parcelRegister("jJet4", function(module, exports) {

$parcel$export(module.exports, "compileHooks", () => $e10d3f89fc808d5a$export$17705ba43ca63936);
"use strict";
const $e10d3f89fc808d5a$var$findHooksRx = /\{\{(.*?)\}\}/g;
function $e10d3f89fc808d5a$export$17705ba43ca63936(programSrc) {
    const parts = {};
    const partMatches = programSrc.match($e10d3f89fc808d5a$var$findHooksRx)?.map((hook)=>hook.replace(/[{()}]/g, "")) ?? [];
    partMatches.forEach((hook)=>{
        parts[hook] = [];
    });
    return parts;
}

});

parcelRegister("ak3Em", function(module, exports) {

$parcel$export(module.exports, "compileInputs", () => $76be63c34b98a2b0$export$aa47df9391ef0455);
"use strict";
function $76be63c34b98a2b0$var$extractInputs(fragmentSource, out) {
    let match;
    const regex = /@in\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $76be63c34b98a2b0$export$aa47df9391ef0455(fragments, template, sort = false) {
    const results = [];
    $76be63c34b98a2b0$var$extractInputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $76be63c34b98a2b0$var$extractInputs(fragment.header, results);
    });
    const mainInput = results;
    if (sort) mainInput.sort();
    const finalString = mainInput.map((inValue, i)=>`       @location(${i}) ${inValue},`).join("\n");
    let cleanedString = template.replace(/@in\s+[^;]+;\s*/g, "");
    cleanedString = cleanedString.replace("{{in}}", `
${finalString}
`);
    return cleanedString;
}

});

parcelRegister("9hCqF", function(module, exports) {

$parcel$export(module.exports, "compileOutputs", () => $eeb3f3dfbb29bd14$export$ae19cc473c7ab18);
"use strict";
function $eeb3f3dfbb29bd14$var$extractOutputs(fragmentSource, out) {
    let match;
    const regex = /@out\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $eeb3f3dfbb29bd14$var$extractVariableName(value) {
    const regex = /\b(\w+)\s*:/g;
    const match = regex.exec(value);
    return match ? match[1] : "";
}
function $eeb3f3dfbb29bd14$var$stripVariable(value) {
    const regex = /@.*?\s+/g;
    return value.replace(regex, "");
}
function $eeb3f3dfbb29bd14$export$ae19cc473c7ab18(fragments, template) {
    const results = [];
    $eeb3f3dfbb29bd14$var$extractOutputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $eeb3f3dfbb29bd14$var$extractOutputs(fragment.header, results);
    });
    let index = 0;
    const mainStruct = results.sort().map((inValue)=>{
        if (inValue.indexOf("builtin") > -1) return inValue;
        return `@location(${index++}) ${inValue}`;
    }).join(",\n");
    const mainStart = results.sort().map((inValue)=>`       var ${$eeb3f3dfbb29bd14$var$stripVariable(inValue)};`).join("\n");
    const mainEnd = `return VSOutput(
            ${results.sort().map((inValue)=>` ${$eeb3f3dfbb29bd14$var$extractVariableName(inValue)}`).join(",\n")});`;
    let compiledCode = template.replace(/@out\s+[^;]+;\s*/g, "");
    compiledCode = compiledCode.replace("{{struct}}", `
${mainStruct}
`);
    compiledCode = compiledCode.replace("{{start}}", `
${mainStart}
`);
    compiledCode = compiledCode.replace("{{return}}", `
${mainEnd}
`);
    return compiledCode;
}

});

parcelRegister("9Zsfg", function(module, exports) {

$parcel$export(module.exports, "injectBits", () => $650fee7fffdacf4b$export$83c47c7340456c75);
"use strict";
function $650fee7fffdacf4b$export$83c47c7340456c75(templateSrc, fragmentParts) {
    let out = templateSrc;
    for(const i in fragmentParts){
        const parts = fragmentParts[i];
        const toInject = parts.join("\n");
        if (toInject.length) out = out.replace(`{{${i}}}`, `//-----${i} START-----//
${parts.join("\n")}
//----${i} FINISH----//`);
        else out = out.replace(`{{${i}}}`, "");
    }
    return out;
}

});


parcelRegister("jOJh1", function(module, exports) {

$parcel$export(module.exports, "vertexGPUTemplate", () => $f723d8c01fbb4e07$export$61ecfa8d2718163a);
$parcel$export(module.exports, "fragmentGPUTemplate", () => $f723d8c01fbb4e07$export$922d1073ee2ef930);
$parcel$export(module.exports, "vertexGlTemplate", () => $f723d8c01fbb4e07$export$99b0f79e15be8ede);
$parcel$export(module.exports, "fragmentGlTemplate", () => $f723d8c01fbb4e07$export$3f7784dd6a13ff5a);
"use strict";
const $f723d8c01fbb4e07$export$61ecfa8d2718163a = /* wgsl */ `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`;
const $f723d8c01fbb4e07$export$922d1073ee2ef930 = /* wgsl */ `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`;
const $f723d8c01fbb4e07$export$99b0f79e15be8ede = /* glsl */ `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`;
const $f723d8c01fbb4e07$export$3f7784dd6a13ff5a = /* glsl */ `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`;

});

parcelRegister("8hMvn", function(module, exports) {

$parcel$export(module.exports, "globalUniformsBit", () => $d20cb1ce683ff173$export$435d64b3a14c5a51);
$parcel$export(module.exports, "globalUniformsBitGl", () => $d20cb1ce683ff173$export$38608853d4735d51);
"use strict";
const $d20cb1ce683ff173$export$435d64b3a14c5a51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* wgsl */ `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    }
};
const $d20cb1ce683ff173$export$320b7a2ae65b2f3a = {
    name: "global-uniforms-ubo-bit",
    vertex: {
        header: /* glsl */ `
          uniform globalUniforms {
            mat3 uProjectionMatrix;
            mat3 uWorldTransformMatrix;
            vec4 uWorldColorAlpha;
            vec2 uResolution;
          };
        `
    }
};
const $d20cb1ce683ff173$export$38608853d4735d51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* glsl */ `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    }
};

});


parcelRegister("cNnNT", function(module, exports) {

$parcel$export(module.exports, "colorBit", () => $39898bd73b5669c2$export$a62becfe5fe4ad2);
$parcel$export(module.exports, "colorBitGl", () => $39898bd73b5669c2$export$93189e9821cf4459);
"use strict";
const $39898bd73b5669c2$export$a62becfe5fe4ad2 = {
    name: "color-bit",
    vertex: {
        header: /* wgsl */ `
            @in aColor: vec4<f32>;
        `,
        main: /* wgsl */ `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    }
};
const $39898bd73b5669c2$export$93189e9821cf4459 = {
    name: "color-bit",
    vertex: {
        header: /* glsl */ `
            in vec4 aColor;
        `,
        main: /* glsl */ `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    }
};

});

parcelRegister("ikSZA", function(module, exports) {

$parcel$export(module.exports, "generateTextureBatchBit", () => $da5fa72bb41a0724$export$aff2d36945cda647);
$parcel$export(module.exports, "generateTextureBatchBitGl", () => $da5fa72bb41a0724$export$204e46d9a7a4f835);
"use strict";
const $da5fa72bb41a0724$var$textureBatchBitGpuCache = {};
function $da5fa72bb41a0724$var$generateBindingSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) {
        src.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;");
        src.push("@group(1) @binding(1) var textureSampler1: sampler;");
    } else {
        let bindingIndex = 0;
        for(let i = 0; i < maxTextures; i++){
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSource${i + 1}: texture_2d<f32>;`);
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSampler${i + 1}: sampler;`);
        }
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$var$generateSampleSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) src.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
    else {
        src.push("switch vTextureId {");
        for(let i = 0; i < maxTextures; i++){
            if (i === maxTextures - 1) src.push(`  default:{`);
            else src.push(`  case ${i}:{`);
            src.push(`      outColor = textureSampleGrad(textureSource${i + 1}, textureSampler${i + 1}, vUV, uvDx, uvDy);`);
            src.push(`      break;}`);
        }
        src.push(`}`);
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$aff2d36945cda647(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
        },
        fragment: {
            header: `
                @in @interpolate(flat) vTextureId: u32;

                ${$da5fa72bb41a0724$var$generateBindingSrc(maxTextures)}
            `,
            main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${$da5fa72bb41a0724$var$generateSampleSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures];
}
const $da5fa72bb41a0724$var$textureBatchBitGlCache = {};
function $da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures) {
    const src = [];
    for(let i = 0; i < maxTextures; i++){
        if (i > 0) src.push("else");
        if (i < maxTextures - 1) src.push(`if(vTextureId < ${i}.5)`);
        src.push("{");
        src.push(`	outColor = texture(uTextures[${i}], vUV);`);
        src.push("}");
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$204e46d9a7a4f835(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
        },
        fragment: {
            header: `
                in float vTextureId;

                uniform sampler2D uTextures[${maxTextures}];

            `,
            main: `

                ${$da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures];
}

});

parcelRegister("kSpdC", function(module, exports) {

$parcel$export(module.exports, "roundPixelsBit", () => $2b55e281ef9e6651$export$22150169726f7b1);
$parcel$export(module.exports, "roundPixelsBitGl", () => $2b55e281ef9e6651$export$222909710f39cc5);
"use strict";
const $2b55e281ef9e6651$export$22150169726f7b1 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* wgsl */ `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};
const $2b55e281ef9e6651$export$222909710f39cc5 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* glsl */ `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};

});

parcelRegister("10zIa", function(module, exports) {

$parcel$export(module.exports, "getBatchSamplersUniformGroup", () => $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe);

var $cryyq = parcelRequire("cryyq");
"use strict";
const $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash = {};
function $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe(maxTextures) {
    let batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures];
    if (batchSamplersUniformGroup) return batchSamplersUniformGroup;
    const sampleValues = new Int32Array(maxTextures);
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures] = new (0, $cryyq.UniformGroup)({
        uTextures: {
            value: sampleValues,
            type: `i32`,
            size: maxTextures
        }
    }, {
        isStatic: true
    });
    return batchSamplersUniformGroup;
}

});
parcelRegister("cryyq", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5);

var $aGJhg = parcelRequire("aGJhg");

var $9kWs1 = parcelRequire("9kWs1");

var $jhfqN = parcelRequire("jhfqN");

var $ezKtQ = parcelRequire("ezKtQ");
"use strict";
const $9136c1ea7e89e2b5$var$_UniformGroup = class _UniformGroup {
    /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */ constructor(uniformStructures, options){
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("uniform");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "uniformGroup";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /** used ito identify if this is a uniform group */ this.isUniformGroup = true;
        /**
     * used to flag if this Uniform groups data is different from what it has stored in its buffer / on the GPU
     * @internal
     */ this._dirtyId = 0;
        // implementing the interface - UniformGroup are not destroyed
        this.destroyed = false;
        options = {
            ..._UniformGroup.defaultOptions,
            ...options
        };
        this.uniformStructures = uniformStructures;
        const uniforms = {};
        for(const i in uniformStructures){
            const uniformData = uniformStructures[i];
            uniformData.name = i;
            uniformData.size = uniformData.size ?? 1;
            if (!(0, $jhfqN.UNIFORM_TYPES_MAP)[uniformData.type]) throw new Error(`Uniform type ${uniformData.type} is not supported. Supported uniform types are: ${(0, $jhfqN.UNIFORM_TYPES_VALUES).join(", ")}`);
            uniformData.value ?? (uniformData.value = (0, $ezKtQ.getDefaultUniformValue)(uniformData.type, uniformData.size));
            uniforms[i] = uniformData.value;
        }
        this.uniforms = uniforms;
        this._dirtyId = 1;
        this.ubo = options.ubo;
        this.isStatic = options.isStatic;
        this._signature = (0, $9kWs1.createIdFromString)(Object.keys(uniforms).map((i)=>`${i}-${uniformStructures[i].type}`).join("-"), "uniform-group");
    }
    /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */ update() {
        this._dirtyId++;
    }
};
/** The default options used by the uniform group. */ $9136c1ea7e89e2b5$var$_UniformGroup.defaultOptions = {
    /** if true the UniformGroup is handled as an Uniform buffer object. */ ubo: false,
    /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */ isStatic: false
};
let $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5 = $9136c1ea7e89e2b5$var$_UniformGroup;

});
parcelRegister("jhfqN", function(module, exports) {

$parcel$export(module.exports, "UNIFORM_TYPES_VALUES", () => $d4900ea566bb062d$export$94ae83f3c0da5990);
$parcel$export(module.exports, "UNIFORM_TYPES_MAP", () => $d4900ea566bb062d$export$97ddd6675231876e);
"use strict";
const $d4900ea566bb062d$export$94ae83f3c0da5990 = [
    "f32",
    "i32",
    "vec2<f32>",
    "vec3<f32>",
    "vec4<f32>",
    "mat2x2<f32>",
    "mat3x3<f32>",
    "mat4x4<f32>",
    "mat3x2<f32>",
    "mat4x2<f32>",
    "mat2x3<f32>",
    "mat4x3<f32>",
    "mat2x4<f32>",
    "mat3x4<f32>",
    "vec2<i32>",
    "vec3<i32>",
    "vec4<i32>"
];
const $d4900ea566bb062d$export$97ddd6675231876e = $d4900ea566bb062d$export$94ae83f3c0da5990.reduce((acc, type)=>{
    acc[type] = true;
    return acc;
}, {});

});

parcelRegister("ezKtQ", function(module, exports) {

$parcel$export(module.exports, "getDefaultUniformValue", () => $aa11a20cb06f2781$export$7febdb6905805c3d);
"use strict";
function $aa11a20cb06f2781$export$7febdb6905805c3d(type, size) {
    switch(type){
        case "f32":
            return 0;
        case "vec2<f32>":
            return new Float32Array(2 * size);
        case "vec3<f32>":
            return new Float32Array(3 * size);
        case "vec4<f32>":
            return new Float32Array(4 * size);
        case "mat2x2<f32>":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3x3<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4x4<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});



parcelRegister("5iDyo", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $26072a826565afe8$export$462bb059fed9d9e5);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $fK92B = parcelRequire("fK92B");

var $awcfo = parcelRequire("awcfo");

var $6j7wq = parcelRequire("6j7wq");

var $2bK9z = parcelRequire("2bK9z");

var $cryyq = parcelRequire("cryyq");
"use strict";
class $26072a826565afe8$export$462bb059fed9d9e5 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options){
        super();
        /** A unique identifier for the shader */ this.uid = (0, $aGJhg.uid)("shader");
        /**
     * A record of the uniform groups and resources used by the shader.
     * This is used by WebGL renderer to sync uniform data.
     * @internal
     */ this._uniformBindMap = /* @__PURE__ */ Object.create(null);
        this._ownedBindGroups = [];
        let { gpuProgram: gpuProgram, glProgram: glProgram, groups: groups, resources: resources, compatibleRenderers: compatibleRenderers, groupMap: groupMap } = options;
        this.gpuProgram = gpuProgram;
        this.glProgram = glProgram;
        if (compatibleRenderers === void 0) {
            compatibleRenderers = 0;
            if (gpuProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGPU;
            if (glProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGL;
        }
        this.compatibleRenderers = compatibleRenderers;
        const nameHash = {};
        if (!resources && !groups) resources = {};
        if (resources && groups) throw new Error("[Shader] Cannot have both resources and groups");
        else if (!gpuProgram && groups && !groupMap) throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
        else if (!gpuProgram && groups && groupMap) {
            for(const i in groupMap)for(const j in groupMap[i]){
                const uniformName = groupMap[i][j];
                nameHash[uniformName] = {
                    group: i,
                    binding: j,
                    name: uniformName
                };
            }
        } else if (gpuProgram && groups && !groupMap) {
            const groupData = gpuProgram.structsAndGroups.groups;
            groupMap = {};
            groupData.forEach((data)=>{
                groupMap[data.group] = groupMap[data.group] || {};
                groupMap[data.group][data.binding] = data.name;
                nameHash[data.name] = data;
            });
        } else if (resources) {
            groups = {};
            groupMap = {};
            if (gpuProgram) {
                const groupData = gpuProgram.structsAndGroups.groups;
                groupData.forEach((data)=>{
                    groupMap[data.group] = groupMap[data.group] || {};
                    groupMap[data.group][data.binding] = data.name;
                    nameHash[data.name] = data;
                });
            }
            let bindTick = 0;
            for(const i in resources){
                if (nameHash[i]) continue;
                if (!groups[99]) {
                    groups[99] = new (0, $awcfo.BindGroup)();
                    this._ownedBindGroups.push(groups[99]);
                }
                nameHash[i] = {
                    group: 99,
                    binding: bindTick,
                    name: i
                };
                groupMap[99] = groupMap[99] || {};
                groupMap[99][bindTick] = i;
                bindTick++;
            }
            for(const i in resources){
                const name = i;
                let value = resources[i];
                if (!value.source && !value._resourceType) value = new (0, $cryyq.UniformGroup)(value);
                const data = nameHash[name];
                if (data) {
                    if (!groups[data.group]) {
                        groups[data.group] = new (0, $awcfo.BindGroup)();
                        this._ownedBindGroups.push(groups[data.group]);
                    }
                    groups[data.group].setResource(value, data.binding);
                }
            }
        }
        this.groups = groups;
        this._uniformBindMap = groupMap;
        this.resources = this._buildResourceAccessor(groups, nameHash);
    }
    /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */ addResource(name, groupIndex, bindIndex) {
        var _a, _b;
        (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
        (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
        if (!this.groups[groupIndex]) {
            this.groups[groupIndex] = new (0, $awcfo.BindGroup)();
            this._ownedBindGroups.push(this.groups[groupIndex]);
        }
    }
    _buildResourceAccessor(groups, nameHash) {
        const uniformsOut = {};
        for(const i in nameHash){
            const data = nameHash[i];
            Object.defineProperty(uniformsOut, data.name, {
                get () {
                    return groups[data.group].getResource(data.binding);
                },
                set (value) {
                    groups[data.group].setResource(value, data.binding);
                }
            });
        }
        return uniformsOut;
    }
    /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */ destroy(destroyPrograms = false) {
        this.emit("destroy", this);
        if (destroyPrograms) {
            this.gpuProgram?.destroy();
            this.glProgram?.destroy();
        }
        this.gpuProgram = null;
        this.glProgram = null;
        this.removeAllListeners();
        this._uniformBindMap = null;
        this._ownedBindGroups.forEach((bindGroup)=>{
            bindGroup.destroy();
        });
        this._ownedBindGroups = null;
        this.resources = null;
        this.groups = null;
    }
    static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $6j7wq.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $fK92B.GlProgram).from(gl);
        return new $26072a826565afe8$export$462bb059fed9d9e5({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
}

});
parcelRegister("2bK9z", function(module, exports) {

$parcel$export(module.exports, "RendererType", () => $d9ac1633e306ebfe$export$2ca8315eebe81c3d);
"use strict";
var $d9ac1633e306ebfe$export$2ca8315eebe81c3d = /* @__PURE__ */ ((RendererType2)=>{
    RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
    RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
    RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
    return RendererType2;
})($d9ac1633e306ebfe$export$2ca8315eebe81c3d || {});

});




parcelRegister("1mKkK", function(module, exports) {

$parcel$export(module.exports, "buildContextBatches", () => $2ba674c6e42be2fb$export$e3c00f31a053d231);

var $i9BKe = parcelRequire("i9BKe");

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");

var $kVCUp = parcelRequire("kVCUp");

var $9Co9Q = parcelRequire("9Co9Q");

var $bLlTJ = parcelRequire("bLlTJ");

var $61KiY = parcelRequire("61KiY");

var $xZ5a3 = parcelRequire("xZ5a3");

var $dY2iR = parcelRequire("dY2iR");

var $46SPq = parcelRequire("46SPq");

var $7pahp = parcelRequire("7pahp");

var $ei7YJ = parcelRequire("ei7YJ");

var $7DIxn = parcelRequire("7DIxn");

var $iAUCq = parcelRequire("iAUCq");

var $34u7a = parcelRequire("34u7a");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $2ba674c6e42be2fb$export$ab760b0d495e92a1 = {};
(0, $i9BKe.extensions).handleByMap((0, $i9BKe.ExtensionType).ShapeBuilder, $2ba674c6e42be2fb$export$ab760b0d495e92a1);
(0, $i9BKe.extensions).add((0, $7DIxn.buildRectangle), (0, $ei7YJ.buildPolygon), (0, $iAUCq.buildTriangle), (0, $dY2iR.buildCircle), (0, $dY2iR.buildEllipse), (0, $dY2iR.buildRoundedRectangle));
const $2ba674c6e42be2fb$var$tempRect = new (0, $fM4Mk.Rectangle)();
const $2ba674c6e42be2fb$var$tempTextureMatrix = new (0, $eY4rt.Matrix)();
function $2ba674c6e42be2fb$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $2ba674c6e42be2fb$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $2ba674c6e42be2fb$var$addShapePathToGeometryData(hole.shapePath, style, true, batches, geometryData);
            if (hole) shapePath.shapePrimitives[shapePath.shapePrimitives.length - 1].holes = hole.shapePath.shapePrimitives;
            $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData);
        }
    }
}
function $2ba674c6e42be2fb$var$addTextureToGeometryData(data, batches, geometryData) {
    const points = [];
    const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1.rectangle;
    const rect = $2ba674c6e42be2fb$var$tempRect;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    if (!build.build(rect, points)) return;
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const texture = data.image;
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.attributeOffset = vertOffset;
    graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
    graphicsBatch.baseColor = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix, holes: holes })=>{
        const points = [];
        const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1[shape.type];
        if (!build.build(shape, points)) return;
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        let topology = "triangle-list";
        if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
        if (!isStroke) {
            if (holes) {
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $2ba674c6e42be2fb$var$getHoleArrays(holes);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $2E1jb.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            if (!lineStyle.pixelLine) (0, $46SPq.buildLine)(points, lineStyle, false, close, vertices, indices);
            else {
                (0, $7pahp.buildPixelLine)(points, close, vertices, indices);
                topology = "line-list";
            }
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $bLlTJ.Texture).WHITE) {
            const textureMatrix = (0, $34u7a.generateTextureMatrix)($2ba674c6e42be2fb$var$tempTextureMatrix, style, shape, matrix);
            (0, $kVCUp.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $kVCUp.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.attributeOffset = vertOffset;
        graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
        graphicsBatch.baseColor = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        graphicsBatch.topology = topology;
        batches.push(graphicsBatch);
    });
}
function $2ba674c6e42be2fb$var$getHoleArrays(holePrimitives) {
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $2ba674c6e42be2fb$export$ab760b0d495e92a1[holePrimitive.type];
        if (holeBuilder.build(holePrimitive, holePoints)) holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("kVCUp", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $1606ccc0770732ec$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $1606ccc0770732ec$export$580e3d8462b9fe52);
"use strict";
function $1606ccc0770732ec$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $1606ccc0770732ec$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("9Co9Q", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $74e682a1604b3625$export$cbe36b8a8d6e3d3);
"use strict";
function $74e682a1604b3625$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset || (offset = 0);
    stride || (stride = 2);
    size || (size = vertices.length / stride - offset);
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("xZ5a3", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $3f80d08e0b9378c5$export$91d2a08bbf21546b);

var $eY4rt = parcelRequire("eY4rt");

var $3N6bV = parcelRequire("3N6bV");
"use strict";
const $3f80d08e0b9378c5$var$identityMatrix = new (0, $eY4rt.Matrix)();
class $3f80d08e0b9378c5$export$91d2a08bbf21546b {
    constructor(){
        this.packAsQuad = false;
        this.batcherName = "default";
        this.topology = "triangle-list";
        this.applyTransform = true;
        this.roundPixels = 0;
        this._batcher = null;
        this._batch = null;
    }
    get uvs() {
        return this.geometryData.uvs;
    }
    get positions() {
        return this.geometryData.vertices;
    }
    get indices() {
        return this.geometryData.indices;
    }
    get blendMode() {
        if (this.renderable && this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    get color() {
        const rgb = this.baseColor;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        const renderable = this.renderable;
        if (renderable) return (0, $3N6bV.multiplyHexColors)(bgr, renderable.groupColor) + (this.alpha * renderable.groupAlpha * 255 << 24);
        return bgr + (this.alpha * 255 << 24);
    }
    get transform() {
        return this.renderable?.groupTransform || $3f80d08e0b9378c5$var$identityMatrix;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.attributeOffset = this.attributeOffset;
        gpuBuffer.attributeSize = this.attributeSize;
        gpuBuffer.baseColor = this.baseColor;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
        gpuBuffer.topology = this.topology;
    }
    reset() {
        this.applyTransform = true;
        this.renderable = null;
        this.topology = "triangle-list";
    }
}

});

parcelRegister("dY2iR", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $791ed7b81fe09d67$export$a3541b2d8ecbfcf2);
$parcel$export(module.exports, "buildEllipse", () => $791ed7b81fe09d67$export$d35b00c6ec9534ca);
$parcel$export(module.exports, "buildRoundedRectangle", () => $791ed7b81fe09d67$export$4b54fce47d2ae7f4);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $791ed7b81fe09d67$export$a3541b2d8ecbfcf2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "circle"
    },
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            rx = ry = circle.radius;
            if (rx <= 0) return false;
            x = circle.x;
            y = circle.y;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            if (rx <= 0 || ry <= 0) return false;
            x = ellipse.x;
            y = ellipse.y;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (dx < 0 || dy < 0) return false;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return false;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return true;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};
const $791ed7b81fe09d67$export$d35b00c6ec9534ca = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "ellipse"
    }
};
const $791ed7b81fe09d67$export$4b54fce47d2ae7f4 = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "roundedRectangle"
    }
};

});

parcelRegister("46SPq", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $9fc8551677af3cf1$export$45986ccf08e93b0b);

var $1HooC = parcelRequire("1HooC");

var $d1s7O = parcelRequire("d1s7O");

var $168p3 = parcelRequire("168p3");
"use strict";
function $9fc8551677af3cf1$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $9fc8551677af3cf1$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $9fc8551677af3cf1$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, indices) {
    const eps = (0, $d1s7O.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $168p3.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $1HooC.Point)(points[0], points[1]);
    const lastPoint = new (0, $1HooC.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $d1s7O.curveEps) * (0, $d1s7O.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("d1s7O", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $5f88c52b3933a72f$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $5f88c52b3933a72f$export$51a946149243709);
"use strict";
const $5f88c52b3933a72f$export$7159a7c43f12984 = 1e-4;
const $5f88c52b3933a72f$export$51a946149243709 = 1e-4;

});

parcelRegister("168p3", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $19281094736c08bb$export$38856eae80d480e1);
"use strict";
function $19281094736c08bb$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("7pahp", function(module, exports) {

$parcel$export(module.exports, "buildPixelLine", () => $1882f668f31d317e$export$44c058937667e9f0);

var $d1s7O = parcelRequire("d1s7O");
"use strict";
function $1882f668f31d317e$export$44c058937667e9f0(points, closed, vertices, indices) {
    const eps = (0, $d1s7O.closePointEps);
    if (points.length === 0) return;
    const fx = points[0];
    const fy = points[1];
    const lx = points[points.length - 2];
    const ly = points[points.length - 1];
    const closePath = closed || Math.abs(fx - lx) < eps && Math.abs(fy - ly) < eps;
    const verts = vertices;
    const length = points.length / 2;
    const indexStart = verts.length / 2;
    for(let i = 0; i < length; i++){
        verts.push(points[i * 2]);
        verts.push(points[i * 2 + 1]);
    }
    for(let i = 0; i < length - 1; i++)indices.push(indexStart + i, indexStart + i + 1);
    if (closePath) indices.push(indexStart + length - 1, indexStart);
}

});

parcelRegister("ei7YJ", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $7f823fd9a95a0bf4$export$4c2d12f7b210f357);

var $i9BKe = parcelRequire("i9BKe");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $7f823fd9a95a0bf4$var$emptyArray = [];
const $7f823fd9a95a0bf4$export$4c2d12f7b210f357 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "polygon"
    },
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $2E1jb.triangulateWithHoles)(points, $7f823fd9a95a0bf4$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("2E1jb", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $0c79f6b53084d415$export$5a241bf9c2c3d94b);

var $e9PUX = parcelRequire("e9PUX");
"use strict";
function $0c79f6b53084d415$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, $e9PUX.earcut)(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("e9PUX", function(module, exports) {

$parcel$export(module.exports, "earcut", () => $04328aff3292927e$export$71a1409458eaaf0d);

var $2jYVZ = parcelRequire("2jYVZ");

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $04328aff3292927e$export$71a1409458eaaf0d = (0, $2jYVZ.default).default || (0, $2jYVZ.default);

});
parcelRegister("2jYVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b0c9f6ca9bef72e$export$2e2bcd8739ae039);
function $1b0c9f6ca9bef72e$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $1b0c9f6ca9bef72e$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $1b0c9f6ca9bef72e$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $1b0c9f6ca9bef72e$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $1b0c9f6ca9bef72e$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $1b0c9f6ca9bef72e$var$equals(last, last.next)) {
        $1b0c9f6ca9bef72e$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $1b0c9f6ca9bef72e$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($1b0c9f6ca9bef72e$var$equals(p, p.next) || $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) === 0)) {
            $1b0c9f6ca9bef72e$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $1b0c9f6ca9bef72e$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) : $1b0c9f6ca9bef72e$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $1b0c9f6ca9bef72e$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $1b0c9f6ca9bef72e$var$earcutLinked($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $1b0c9f6ca9bef72e$var$cureLocalIntersections($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles);
                $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $1b0c9f6ca9bef72e$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $1b0c9f6ca9bef72e$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $1b0c9f6ca9bef72e$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $1b0c9f6ca9bef72e$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $1b0c9f6ca9bef72e$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$intersects(a, p, p.next, b) && $1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $1b0c9f6ca9bef72e$var$removeNode(p);
            $1b0c9f6ca9bef72e$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $1b0c9f6ca9bef72e$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $1b0c9f6ca9bef72e$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $1b0c9f6ca9bef72e$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $1b0c9f6ca9bef72e$var$filterPoints(a, a.next);
                c = $1b0c9f6ca9bef72e$var$filterPoints(c, c.next);
                // run earcut on each half
                $1b0c9f6ca9bef72e$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $1b0c9f6ca9bef72e$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($1b0c9f6ca9bef72e$var$getLeftmost(list));
    }
    queue.sort($1b0c9f6ca9bef72e$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $1b0c9f6ca9bef72e$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $1b0c9f6ca9bef72e$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $1b0c9f6ca9bef72e$var$eliminateHole(hole, outerNode) {
    const bridge = $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $1b0c9f6ca9bef72e$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $1b0c9f6ca9bef72e$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $1b0c9f6ca9bef72e$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($1b0c9f6ca9bef72e$var$equals(hole, p)) return p;
    do {
        if ($1b0c9f6ca9bef72e$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $1b0c9f6ca9bef72e$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($1b0c9f6ca9bef72e$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p) {
    return $1b0c9f6ca9bef72e$var$area(m.prev, m, p.prev) < 0 && $1b0c9f6ca9bef72e$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $1b0c9f6ca9bef72e$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $1b0c9f6ca9bef72e$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $1b0c9f6ca9bef72e$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $1b0c9f6ca9bef72e$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $1b0c9f6ca9bef72e$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $1b0c9f6ca9bef72e$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a) && $1b0c9f6ca9bef72e$var$middleInside(a, b) && // locally visible
    ($1b0c9f6ca9bef72e$var$area(a.prev, a, b.prev) || $1b0c9f6ca9bef72e$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) > 0 && $1b0c9f6ca9bef72e$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $1b0c9f6ca9bef72e$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $1b0c9f6ca9bef72e$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $1b0c9f6ca9bef72e$var$intersects(p1, q1, p2, q2) {
    const o1 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, p2));
    const o2 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, q2));
    const o3 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, p1));
    const o4 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $1b0c9f6ca9bef72e$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $1b0c9f6ca9bef72e$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $1b0c9f6ca9bef72e$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $1b0c9f6ca9bef72e$var$locallyInside(a, b) {
    return $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) < 0 ? $1b0c9f6ca9bef72e$var$area(a, b, a.next) >= 0 && $1b0c9f6ca9bef72e$var$area(a, a.prev, b) >= 0 : $1b0c9f6ca9bef72e$var$area(a, b, a.prev) < 0 || $1b0c9f6ca9bef72e$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $1b0c9f6ca9bef72e$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $1b0c9f6ca9bef72e$var$splitPolygon(a, b) {
    const a2 = $1b0c9f6ca9bef72e$var$createNode(a.i, a.x, a.y), b2 = $1b0c9f6ca9bef72e$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $1b0c9f6ca9bef72e$var$insertNode(i, x, y, last) {
    const p = $1b0c9f6ca9bef72e$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $1b0c9f6ca9bef72e$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $1b0c9f6ca9bef72e$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $1b0c9f6ca9bef72e$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $1b0c9f6ca9bef72e$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}

});




parcelRegister("7DIxn", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $1d4b4832ec6feb5d$export$cbe813d11f2192b2);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $1d4b4832ec6feb5d$export$cbe813d11f2192b2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "rectangle"
    },
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width > 0 && height > 0)) return false;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("iAUCq", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $14f13b7de979604e$export$8eb75cb9f614d270);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $14f13b7de979604e$export$8eb75cb9f614d270 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "triangle"
    },
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("34u7a", function(module, exports) {

$parcel$export(module.exports, "generateTextureMatrix", () => $72972982d23c75da$export$1e9b9e463121b388);

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");

var $gwwtL = parcelRequire("gwwtL");
"use strict";
const $72972982d23c75da$var$tempTextureMatrix = new (0, $eY4rt.Matrix)();
const $72972982d23c75da$var$tempRect = new (0, $fM4Mk.Rectangle)();
function $72972982d23c75da$export$1e9b9e463121b388(out, style, shape, matrix) {
    const textureMatrix = style.matrix ? out.copyFrom(style.matrix).invert() : out.identity();
    if (style.textureSpace === "local") {
        const bounds = shape.getBounds($72972982d23c75da$var$tempRect);
        if (style.width) bounds.pad(style.width);
        const { x: tx, y: ty } = bounds;
        const sx = 1 / bounds.width;
        const sy = 1 / bounds.height;
        const mTx = -tx * sx;
        const mTy = -ty * sy;
        const a1 = textureMatrix.a;
        const b1 = textureMatrix.b;
        const c1 = textureMatrix.c;
        const d1 = textureMatrix.d;
        textureMatrix.a *= sx;
        textureMatrix.b *= sx;
        textureMatrix.c *= sy;
        textureMatrix.d *= sy;
        textureMatrix.tx = mTx * a1 + mTy * c1 + textureMatrix.tx;
        textureMatrix.ty = mTx * b1 + mTy * d1 + textureMatrix.ty;
    } else {
        textureMatrix.translate(style.texture.frame.x, style.texture.frame.y);
        textureMatrix.scale(1 / style.texture.source.width, 1 / style.texture.source.height);
    }
    const sourceStyle = style.texture.source.style;
    if (!(style.fill instanceof (0, $gwwtL.FillGradient)) && sourceStyle.addressMode === "clamp-to-edge") {
        sourceStyle.addressMode = "repeat";
        sourceStyle.update();
    }
    if (matrix) textureMatrix.append($72972982d23c75da$var$tempTextureMatrix.copyFrom(matrix).invert());
    return textureMatrix;
}

});




parcelRegister("eRV6E", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $39a9db3afcc2f789$export$d53ce9debfe7a6c2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $39a9db3afcc2f789$var$RECURSION_LIMIT = 8;
const $39a9db3afcc2f789$var$FLT_EPSILON = 11920929e-14;
const $39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON = 1;
const $39a9db3afcc2f789$var$curveAngleToleranceEpsilon = 0.01;
const $39a9db3afcc2f789$var$mAngleTolerance = 0;
function $39a9db3afcc2f789$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $39a9db3afcc2f789$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $39a9db3afcc2f789$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $39a9db3afcc2f789$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $39a9db3afcc2f789$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($39a9db3afcc2f789$var$mAngleTolerance < $39a9db3afcc2f789$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $39a9db3afcc2f789$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $39a9db3afcc2f789$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $39a9db3afcc2f789$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("aiLPr", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $4598c98f5bbae757$export$ed8eebdc6998f0f6);
"use strict";
function $4598c98f5bbae757$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps || (steps = Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI))));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("boMdH", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $35a2eb588826e37c$export$d46b7933b415e02f);

var $aiLPr = parcelRequire("aiLPr");
"use strict";
function $35a2eb588826e37c$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $aiLPr.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("jjbCG", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $d859b1787749b4c9$export$71ccaa6dca53075e);

var $lI2iN = parcelRequire("lI2iN");
"use strict";
const $d859b1787749b4c9$var$TAU = Math.PI * 2;
const $d859b1787749b4c9$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $d859b1787749b4c9$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $d859b1787749b4c9$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $d859b1787749b4c9$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $d859b1787749b4c9$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $d859b1787749b4c9$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $d859b1787749b4c9$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $d859b1787749b4c9$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $d859b1787749b4c9$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $d859b1787749b4c9$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $d859b1787749b4c9$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $d859b1787749b4c9$var$out);
    let { ang1: ang1, ang2: ang2 } = $d859b1787749b4c9$var$out;
    const { centerX: centerX, centerY: centerY } = $d859b1787749b4c9$var$out;
    let ratio = Math.abs(ang2) / ($d859b1787749b4c9$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $d859b1787749b4c9$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $d859b1787749b4c9$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $d859b1787749b4c9$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $d859b1787749b4c9$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $lI2iN.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("9ad7k", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $9769dc3699a7c802$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $9769dc3699a7c802$export$cf503f371c53af9e);
"use strict";
function $9769dc3699a7c802$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $9769dc3699a7c802$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("6ph3G", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $ff733ce48c045e93$export$2cc2aaca18109aab);

var $hUCK4 = parcelRequire("hUCK4");

var $c9xxq = parcelRequire("c9xxq");

var $lwWDT = parcelRequire("lwWDT");

var $66BsB = parcelRequire("66BsB");

var $cEiD3 = parcelRequire("cEiD3");
"use strict";
function $ff733ce48c045e93$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        defs: {},
        path: new (0, $c9xxq.GraphicsPath)()
    };
    (0, $lwWDT.parseSVGDefinitions)(svg, session);
    const children = svg.children;
    const { fillStyle: fillStyle, strokeStyle: strokeStyle } = (0, $cEiD3.parseSVGStyle)(svg, session);
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.nodeName.toLowerCase() === "defs") continue;
        $ff733ce48c045e93$var$renderChildren(child, session, fillStyle, strokeStyle);
    }
    return graphicsContext;
}
function $ff733ce48c045e93$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = (0, $cEiD3.parseSVGStyle)(svg, session);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    const noStyle = !fillStyle && !strokeStyle;
    if (noStyle) fillStyle = {
        color: 0
    };
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            d = svg.getAttribute("d");
            if (svg.getAttribute("fill-rule") === "evenodd") (0, $hUCK4.warn)("SVG Evenodd fill rule not supported, your svg may render incorrectly");
            graphicsPath = new (0, $c9xxq.GraphicsPath)(d, true);
            session.context.path(graphicsPath);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "circle":
            cx = (0, $66BsB.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $66BsB.parseSVGFloatAttribute)(svg, "cy", 0);
            r = (0, $66BsB.parseSVGFloatAttribute)(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "rect":
            x = (0, $66BsB.parseSVGFloatAttribute)(svg, "x", 0);
            y = (0, $66BsB.parseSVGFloatAttribute)(svg, "y", 0);
            width = (0, $66BsB.parseSVGFloatAttribute)(svg, "width", 0);
            height = (0, $66BsB.parseSVGFloatAttribute)(svg, "height", 0);
            rx = (0, $66BsB.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $66BsB.parseSVGFloatAttribute)(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "ellipse":
            cx = (0, $66BsB.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $66BsB.parseSVGFloatAttribute)(svg, "cy", 0);
            rx = (0, $66BsB.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $66BsB.parseSVGFloatAttribute)(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "line":
            x1 = (0, $66BsB.parseSVGFloatAttribute)(svg, "x1", 0);
            y1 = (0, $66BsB.parseSVGFloatAttribute)(svg, "y1", 0);
            x2 = (0, $66BsB.parseSVGFloatAttribute)(svg, "x2", 0);
            y2 = (0, $66BsB.parseSVGFloatAttribute)(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "g":
        case "svg":
            break;
        default:
            (0, $hUCK4.warn)(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    if (noStyle) fillStyle = null;
    for(let i = 0; i < children.length; i++)$ff733ce48c045e93$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}

});
parcelRegister("lwWDT", function(module, exports) {

$parcel$export(module.exports, "parseSVGDefinitions", () => $2ade0f5beda11c2d$export$d578aced17ea3023);

var $a2eTA = parcelRequire("a2eTA");

var $hUCK4 = parcelRequire("hUCK4");

var $gwwtL = parcelRequire("gwwtL");

var $66BsB = parcelRequire("66BsB");
"use strict";
function $2ade0f5beda11c2d$export$d578aced17ea3023(svg, session) {
    const definitions = svg.querySelectorAll("defs");
    for(let i = 0; i < definitions.length; i++){
        const definition = definitions[i];
        for(let j = 0; j < definition.children.length; j++){
            const child = definition.children[j];
            switch(child.nodeName.toLowerCase()){
                case "lineargradient":
                    session.defs[child.id] = $2ade0f5beda11c2d$var$parseLinearGradient(child);
                    break;
                case "radialgradient":
                    session.defs[child.id] = $2ade0f5beda11c2d$var$parseRadialGradient(child);
                    break;
                default:
                    break;
            }
        }
    }
}
function $2ade0f5beda11c2d$var$parseLinearGradient(child) {
    const x0 = (0, $66BsB.parseSVGFloatAttribute)(child, "x1", 0);
    const y0 = (0, $66BsB.parseSVGFloatAttribute)(child, "y1", 0);
    const x1 = (0, $66BsB.parseSVGFloatAttribute)(child, "x2", 1);
    const y1 = (0, $66BsB.parseSVGFloatAttribute)(child, "y2", 0);
    const gradientUnit = child.getAttribute("gradientUnits") || "objectBoundingBox";
    const gradient = new (0, $gwwtL.FillGradient)(x0, y0, x1, y1, gradientUnit === "objectBoundingBox" ? "local" : "global");
    for(let k = 0; k < child.children.length; k++){
        const stop = child.children[k];
        const offset = (0, $66BsB.parseSVGFloatAttribute)(stop, "offset", 0);
        const color = (0, $a2eTA.Color).shared.setValue(stop.getAttribute("stop-color")).toNumber();
        gradient.addColorStop(offset, color);
    }
    return gradient;
}
function $2ade0f5beda11c2d$var$parseRadialGradient(_child) {
    (0, $hUCK4.warn)("[SVG Parser] Radial gradients are not yet supported");
    return new (0, $gwwtL.FillGradient)(0, 0, 1, 0);
}

});
parcelRegister("66BsB", function(module, exports) {

$parcel$export(module.exports, "parseSVGFloatAttribute", () => $30452626b79fbc29$export$dd264bbf059b1af7);
"use strict";
function $30452626b79fbc29$export$dd264bbf059b1af7(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}

});


parcelRegister("cEiD3", function(module, exports) {

$parcel$export(module.exports, "parseSVGStyle", () => $4fc848fee6ca709e$export$394301fd4b48c7bc);

var $a2eTA = parcelRequire("a2eTA");

var $iK8wH = parcelRequire("iK8wH");
"use strict";
const $4fc848fee6ca709e$export$d1c537faaad576dd = {
    // Fill properties
    fill: {
        type: "paint",
        default: 0
    },
    // Fill color/gradient
    "fill-opacity": {
        type: "number",
        default: 1
    },
    // Fill transparency
    // Stroke properties
    stroke: {
        type: "paint",
        default: 0
    },
    // Stroke color/gradient
    "stroke-width": {
        type: "number",
        default: 1
    },
    // Width of stroke
    "stroke-opacity": {
        type: "number",
        default: 1
    },
    // Stroke transparency
    "stroke-linecap": {
        type: "string",
        default: "butt"
    },
    // End cap style: butt, round, square
    "stroke-linejoin": {
        type: "string",
        default: "miter"
    },
    // Join style: miter, round, bevel
    "stroke-miterlimit": {
        type: "number",
        default: 10
    },
    // Limit on miter join sharpness
    "stroke-dasharray": {
        type: "string",
        default: "none"
    },
    // Dash pattern
    "stroke-dashoffset": {
        type: "number",
        default: 0
    },
    // Offset for dash pattern
    // Global properties
    opacity: {
        type: "number",
        default: 1
    }
};
function $4fc848fee6ca709e$export$394301fd4b48c7bc(svg, session) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    const result = {
        strokeStyle: strokeStyle,
        fillStyle: fillStyle,
        useFill: false,
        useStroke: false
    };
    for(const key in $4fc848fee6ca709e$export$d1c537faaad576dd){
        const attribute = svg.getAttribute(key);
        if (attribute) $4fc848fee6ca709e$var$parseAttribute(session, result, key, attribute.trim());
    }
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i].trim();
            const [key, value] = stylePart.split(":");
            if ($4fc848fee6ca709e$export$d1c537faaad576dd[key]) $4fc848fee6ca709e$var$parseAttribute(session, result, key, value.trim());
        }
    }
    return {
        strokeStyle: result.useStroke ? strokeStyle : null,
        fillStyle: result.useFill ? fillStyle : null,
        useFill: result.useFill,
        useStroke: result.useStroke
    };
}
function $4fc848fee6ca709e$var$parseAttribute(session, result, id, value) {
    switch(id){
        case "stroke":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $iK8wH.extractSvgUrlId)(value);
                    result.strokeStyle.fill = session.defs[id2];
                } else result.strokeStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                result.useStroke = true;
            }
            break;
        case "stroke-width":
            result.strokeStyle.width = Number(value);
            break;
        case "fill":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $iK8wH.extractSvgUrlId)(value);
                    result.fillStyle.fill = session.defs[id2];
                } else result.fillStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                result.useFill = true;
            }
            break;
        case "fill-opacity":
            result.fillStyle.alpha = Number(value);
            break;
        case "stroke-opacity":
            result.strokeStyle.alpha = Number(value);
            break;
        case "opacity":
            result.fillStyle.alpha = Number(value);
            result.strokeStyle.alpha = Number(value);
            break;
    }
}

});
parcelRegister("iK8wH", function(module, exports) {

$parcel$export(module.exports, "extractSvgUrlId", () => $bfccbd4b202a8863$export$c7c899a4a04107c);
"use strict";
function $bfccbd4b202a8863$export$c7c899a4a04107c(url) {
    const match = url.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
    return match ? match[1] : "";
}

});



parcelRegister("6mQKv", function(module, exports) {

$parcel$export(module.exports, "toFillStyle", () => $ee0f76cca9221b48$export$b254764c5530994a);
$parcel$export(module.exports, "toStrokeStyle", () => $ee0f76cca9221b48$export$64975ed44b74a62b);

var $a2eTA = parcelRequire("a2eTA");

var $bLlTJ = parcelRequire("bLlTJ");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");
"use strict";
function $ee0f76cca9221b48$var$isColorLike(value) {
    return (0, $a2eTA.Color).isColorLike(value);
}
function $ee0f76cca9221b48$var$isFillPattern(value) {
    return value instanceof (0, $ktCpi.FillPattern);
}
function $ee0f76cca9221b48$var$isFillGradient(value) {
    return value instanceof (0, $gwwtL.FillGradient);
}
function $ee0f76cca9221b48$var$isTexture(value) {
    return value instanceof (0, $bLlTJ.Texture);
}
function $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle) {
    const temp = (0, $a2eTA.Color).shared.setValue(value ?? 0);
    fill.color = temp.toNumber();
    fill.alpha = temp.alpha === 1 ? defaultStyle.alpha : temp.alpha;
    fill.texture = (0, $bLlTJ.Texture).WHITE;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleTexture(fill, value, defaultStyle) {
    fill.texture = value;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle) {
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle) {
    value.buildGradient();
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    fill.textureSpace = value.textureSpace;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillObject(value, defaultStyle) {
    const style = {
        ...defaultStyle,
        ...value
    };
    const color = (0, $a2eTA.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    return style;
}
function $ee0f76cca9221b48$export$b254764c5530994a(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    const fill = {};
    const objectStyle = value;
    if ($ee0f76cca9221b48$var$isColorLike(value)) return $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isTexture(value)) return $ee0f76cca9221b48$var$handleTexture(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillPattern(value)) return $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillGradient(value)) return $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillPattern(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillPattern(objectStyle, objectStyle.fill, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillGradient(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillGradient(objectStyle, objectStyle.fill, defaultStyle);
    return $ee0f76cca9221b48$var$handleFillObject(objectStyle, defaultStyle);
}
function $ee0f76cca9221b48$export$64975ed44b74a62b(value, defaultStyle) {
    const { width: width, alignment: alignment, miterLimit: miterLimit, cap: cap, join: join, pixelLine: pixelLine, ...rest } = defaultStyle;
    const fill = $ee0f76cca9221b48$export$b254764c5530994a(value, rest);
    if (!fill) return null;
    return {
        width: width,
        alignment: alignment,
        miterLimit: miterLimit,
        cap: cap,
        join: join,
        pixelLine: pixelLine,
        ...fill
    };
}

});


parcelRegister("6XitK", function(module, exports) {

$parcel$export(module.exports, "generateTextStyleKey", () => $9b4def45185a5f6c$export$8a3681e2b47964bb);

var $a2eTA = parcelRequire("a2eTA");
"use strict";
const $9b4def45185a5f6c$var$valuesToIterateForKeys = [
    "align",
    "breakWords",
    "cssOverrides",
    "fontVariant",
    "fontWeight",
    "leading",
    "letterSpacing",
    "lineHeight",
    "padding",
    "textBaseline",
    "trim",
    "whiteSpace",
    "wordWrap",
    "wordWrapWidth",
    "fontFamily",
    "fontStyle",
    "fontSize"
];
function $9b4def45185a5f6c$export$8a3681e2b47964bb(style) {
    const key = [];
    let index = 0;
    for(let i = 0; i < $9b4def45185a5f6c$var$valuesToIterateForKeys.length; i++){
        const prop = `_${$9b4def45185a5f6c$var$valuesToIterateForKeys[i]}`;
        key[index++] = style[prop];
    }
    index = $9b4def45185a5f6c$var$addFillStyleKey(style._fill, key, index);
    index = $9b4def45185a5f6c$var$addStokeStyleKey(style._stroke, key, index);
    index = $9b4def45185a5f6c$var$addDropShadowKey(style.dropShadow, key, index);
    index = $9b4def45185a5f6c$var$addFiltersKey(style.filters, key, index);
    return key.join("-");
}
function $9b4def45185a5f6c$var$addFiltersKey(filters, key, index) {
    if (!filters) return index;
    for (const filter of filters)key[index++] = filter.uid;
    return index;
}
function $9b4def45185a5f6c$var$addFillStyleKey(fillStyle, key, index) {
    if (!fillStyle) return index;
    key[index++] = fillStyle.color;
    key[index++] = fillStyle.alpha;
    key[index++] = fillStyle.fill?.styleKey;
    return index;
}
function $9b4def45185a5f6c$var$addStokeStyleKey(strokeStyle, key, index) {
    if (!strokeStyle) return index;
    index = $9b4def45185a5f6c$var$addFillStyleKey(strokeStyle, key, index);
    key[index++] = strokeStyle.width;
    key[index++] = strokeStyle.alignment;
    key[index++] = strokeStyle.cap;
    key[index++] = strokeStyle.join;
    key[index++] = strokeStyle.miterLimit;
    return index;
}
function $9b4def45185a5f6c$var$addDropShadowKey(dropShadow, key, index) {
    if (!dropShadow) return index;
    key[index++] = dropShadow.alpha;
    key[index++] = dropShadow.angle;
    key[index++] = dropShadow.blur;
    key[index++] = dropShadow.distance;
    key[index++] = (0, $a2eTA.Color).shared.setValue(dropShadow.color).toNumber();
    return index;
}

});


parcelRegister("5Jnul", function(module, exports) {

$parcel$export(module.exports, "DynamicBitmapFont", () => $8f5ec95844dc935f$export$bce21273d0a2e6c7);

var $a2eTA = parcelRequire("a2eTA");

var $fM4Mk = parcelRequire("fM4Mk");

var $6RGCN = parcelRequire("6RGCN");

var $aQPld = parcelRequire("aQPld");

var $bLlTJ = parcelRequire("bLlTJ");

var $aFPUT = parcelRequire("aFPUT");

var $kXq8E = parcelRequire("kXq8E");

var $wLFHs = parcelRequire("wLFHs");

var $fI0NC = parcelRequire("fI0NC");

var $4JkiF = parcelRequire("4JkiF");

var $eKNW7 = parcelRequire("eKNW7");

var $hlNkG = parcelRequire("hlNkG");
"use strict";
const $8f5ec95844dc935f$var$_DynamicBitmapFont = class _DynamicBitmapFont extends (0, $hlNkG.AbstractBitmapFont) {
    /**
   * @param options - The options for the dynamic bitmap font.
   */ constructor(options){
        super();
        /**
     * this is a resolution modifier for the font size..
     * texture resolution will also be used to scale texture according to its font size also
     */ this.resolution = 1;
        /** The pages of the font. */ this.pages = [];
        this._padding = 0;
        this._measureCache = /* @__PURE__ */ Object.create(null);
        this._currentChars = [];
        this._currentX = 0;
        this._currentY = 0;
        this._currentMaxCharHeight = 0;
        this._currentPageIndex = -1;
        this._skipKerning = false;
        const dynamicOptions = {
            ..._DynamicBitmapFont.defaultOptions,
            ...options
        };
        this._textureSize = dynamicOptions.textureSize;
        this._mipmap = dynamicOptions.mipmap;
        const style = dynamicOptions.style.clone();
        if (dynamicOptions.overrideFill) {
            style._fill.color = 16777215;
            style._fill.alpha = 1;
            style._fill.texture = (0, $bLlTJ.Texture).WHITE;
            style._fill.fill = null;
        }
        this.applyFillAsTint = dynamicOptions.overrideFill;
        const requestedFontSize = style.fontSize;
        style.fontSize = this.baseMeasurementFontSize;
        const font = (0, $fI0NC.fontStringFromTextStyle)(style);
        if (dynamicOptions.overrideSize) {
            if (style._stroke) style._stroke.width *= this.baseRenderedFontSize / requestedFontSize;
        } else style.fontSize = this.baseRenderedFontSize = requestedFontSize;
        this._style = style;
        this._skipKerning = dynamicOptions.skipKerning ?? false;
        this.resolution = dynamicOptions.resolution ?? 1;
        this._padding = dynamicOptions.padding ?? 4;
        if (dynamicOptions.textureStyle) this._textureStyle = dynamicOptions.textureStyle instanceof (0, $aFPUT.TextureStyle) ? dynamicOptions.textureStyle : new (0, $aFPUT.TextureStyle)(dynamicOptions.textureStyle);
        this.fontMetrics = (0, $wLFHs.CanvasTextMetrics).measureFont(font);
        this.lineHeight = style.lineHeight || this.fontMetrics.fontSize || style.fontSize;
    }
    ensureCharacters(chars) {
        const charList = (0, $wLFHs.CanvasTextMetrics).graphemeSegmenter(chars).filter((char)=>!this._currentChars.includes(char)).filter((char, index, self)=>self.indexOf(char) === index);
        if (!charList.length) return;
        this._currentChars = [
            ...this._currentChars,
            ...charList
        ];
        let pageData;
        if (this._currentPageIndex === -1) pageData = this._nextPage();
        else pageData = this.pages[this._currentPageIndex];
        let { canvas: canvas, context: context } = pageData.canvasAndContext;
        let textureSource = pageData.texture.source;
        const style = this._style;
        let currentX = this._currentX;
        let currentY = this._currentY;
        let currentMaxCharHeight = this._currentMaxCharHeight;
        const fontScale = this.baseRenderedFontSize / this.baseMeasurementFontSize;
        const padding = this._padding * fontScale;
        let skipTexture = false;
        const maxTextureWidth = canvas.width / this.resolution;
        const maxTextureHeight = canvas.height / this.resolution;
        for(let i = 0; i < charList.length; i++){
            const char = charList[i];
            const metrics = (0, $wLFHs.CanvasTextMetrics).measureText(char, style, canvas, false);
            metrics.lineHeight = metrics.height;
            const width = metrics.width * fontScale;
            const textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
            const height = metrics.height * fontScale;
            const paddedWidth = textureGlyphWidth + padding * 2;
            const paddedHeight = height + padding * 2;
            skipTexture = false;
            if (char !== "\n" && char !== "\r" && char !== "	" && char !== " ") {
                skipTexture = true;
                currentMaxCharHeight = Math.ceil(Math.max(paddedHeight, currentMaxCharHeight));
            }
            if (currentX + paddedWidth > maxTextureWidth) {
                currentY += currentMaxCharHeight;
                currentMaxCharHeight = paddedHeight;
                currentX = 0;
                if (currentY + currentMaxCharHeight > maxTextureHeight) {
                    textureSource.update();
                    const pageData2 = this._nextPage();
                    canvas = pageData2.canvasAndContext.canvas;
                    context = pageData2.canvasAndContext.context;
                    textureSource = pageData2.texture.source;
                    currentX = 0;
                    currentY = 0;
                    currentMaxCharHeight = 0;
                }
            }
            const xAdvance = width / fontScale - (style.dropShadow?.distance ?? 0) - (style._stroke?.width ?? 0);
            this.chars[char] = {
                id: char.codePointAt(0),
                xOffset: -this._padding,
                yOffset: -this._padding,
                xAdvance: xAdvance,
                kerning: {}
            };
            if (skipTexture) {
                this._drawGlyph(context, metrics, currentX + padding, currentY + padding, fontScale, style);
                const px = textureSource.width * fontScale;
                const py = textureSource.height * fontScale;
                const frame = new (0, $fM4Mk.Rectangle)(currentX / px * textureSource.width, currentY / py * textureSource.height, paddedWidth / px * textureSource.width, paddedHeight / py * textureSource.height);
                this.chars[char].texture = new (0, $bLlTJ.Texture)({
                    source: textureSource,
                    frame: frame
                });
                currentX += Math.ceil(paddedWidth);
            }
        }
        textureSource.update();
        this._currentX = currentX;
        this._currentY = currentY;
        this._currentMaxCharHeight = currentMaxCharHeight;
        this._skipKerning && this._applyKerning(charList, context);
    }
    /**
   * @deprecated since 8.0.0
   * The map of base page textures (i.e., sheets of glyphs).
   */ get pageTextures() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
        return this.pages;
    }
    _applyKerning(newChars, context) {
        const measureCache = this._measureCache;
        for(let i = 0; i < newChars.length; i++){
            const first = newChars[i];
            for(let j = 0; j < this._currentChars.length; j++){
                const second = this._currentChars[j];
                let c1 = measureCache[first];
                if (!c1) c1 = measureCache[first] = context.measureText(first).width;
                let c2 = measureCache[second];
                if (!c2) c2 = measureCache[second] = context.measureText(second).width;
                let total = context.measureText(first + second).width;
                let amount = total - (c1 + c2);
                if (amount) this.chars[first].kerning[second] = amount;
                total = context.measureText(first + second).width;
                amount = total - (c1 + c2);
                if (amount) this.chars[second].kerning[first] = amount;
            }
        }
    }
    _nextPage() {
        this._currentPageIndex++;
        const textureResolution = this.resolution;
        const canvasAndContext = (0, $6RGCN.CanvasPool).getOptimalCanvasAndContext(this._textureSize, this._textureSize, textureResolution);
        this._setupContext(canvasAndContext.context, this._style, textureResolution);
        const resolution = textureResolution * (this.baseRenderedFontSize / this.baseMeasurementFontSize);
        const texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvasAndContext.canvas,
                resolution: resolution,
                alphaMode: "premultiply-alpha-on-upload",
                autoGenerateMipmaps: this._mipmap
            })
        });
        if (this._textureStyle) texture.source.style = this._textureStyle;
        const pageData = {
            canvasAndContext: canvasAndContext,
            texture: texture
        };
        this.pages[this._currentPageIndex] = pageData;
        return pageData;
    }
    // canvas style!
    _setupContext(context, style, resolution) {
        style.fontSize = this.baseRenderedFontSize;
        context.scale(resolution, resolution);
        context.font = (0, $fI0NC.fontStringFromTextStyle)(style);
        style.fontSize = this.baseMeasurementFontSize;
        context.textBaseline = style.textBaseline;
        const stroke = style._stroke;
        const strokeThickness = stroke?.width ?? 0;
        if (stroke) {
            context.lineWidth = strokeThickness;
            context.lineJoin = stroke.join;
            context.miterLimit = stroke.miterLimit;
            context.strokeStyle = (0, $4JkiF.getCanvasFillStyle)(stroke, context);
        }
        if (style._fill) context.fillStyle = (0, $4JkiF.getCanvasFillStyle)(style._fill, context);
        if (style.dropShadow) {
            const shadowOptions = style.dropShadow;
            const rgb = (0, $a2eTA.Color).shared.setValue(shadowOptions.color).toArray();
            const dropShadowBlur = shadowOptions.blur * resolution;
            const dropShadowDistance = shadowOptions.distance * resolution;
            context.shadowColor = `rgba(${rgb[0] * 255},${rgb[1] * 255},${rgb[2] * 255},${shadowOptions.alpha})`;
            context.shadowBlur = dropShadowBlur;
            context.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
            context.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance;
        } else {
            context.shadowColor = "black";
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        }
    }
    _drawGlyph(context, metrics, x, y, fontScale, style) {
        const char = metrics.text;
        const fontProperties = metrics.fontProperties;
        const stroke = style._stroke;
        const strokeThickness = (stroke?.width ?? 0) * fontScale;
        const tx = x + strokeThickness / 2;
        const ty = y - strokeThickness / 2;
        const descent = fontProperties.descent * fontScale;
        const lineHeight = metrics.lineHeight * fontScale;
        let removeShadow = false;
        if (style.stroke && strokeThickness) {
            removeShadow = true;
            context.strokeText(char, tx, ty + lineHeight - descent);
        }
        const { shadowBlur: shadowBlur, shadowOffsetX: shadowOffsetX, shadowOffsetY: shadowOffsetY } = context;
        if (style._fill) {
            if (removeShadow) {
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            context.fillText(char, tx, ty + lineHeight - descent);
        }
        if (removeShadow) {
            context.shadowBlur = shadowBlur;
            context.shadowOffsetX = shadowOffsetX;
            context.shadowOffsetY = shadowOffsetY;
        }
    }
    destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { canvasAndContext: canvasAndContext, texture: texture } = this.pages[i];
            (0, $6RGCN.CanvasPool).returnCanvasAndContext(canvasAndContext);
            texture.destroy(true);
        }
        this.pages = null;
    }
};
$8f5ec95844dc935f$var$_DynamicBitmapFont.defaultOptions = {
    textureSize: 512,
    style: new (0, $eKNW7.TextStyle)(),
    mipmap: true
};
let $8f5ec95844dc935f$export$bce21273d0a2e6c7 = $8f5ec95844dc935f$var$_DynamicBitmapFont;

});
parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();

});

parcelRegister("4JkiF", function(module, exports) {

$parcel$export(module.exports, "getCanvasFillStyle", () => $70d03c252755e3f8$export$c31af9427fa8602b);

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $bLlTJ = parcelRequire("bLlTJ");

var $hUCK4 = parcelRequire("hUCK4");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");
"use strict";
const $70d03c252755e3f8$var$PRECISION = 1e5;
function $70d03c252755e3f8$export$c31af9427fa8602b(fillStyle, context, textMetrics, padding = 0) {
    if (fillStyle.texture === (0, $bLlTJ.Texture).WHITE && !fillStyle.fill) return (0, $a2eTA.Color).shared.setValue(fillStyle.color).setAlpha(fillStyle.alpha ?? 1).toHexa();
    else if (!fillStyle.fill) {
        const pattern = context.createPattern(fillStyle.texture.source.resource, "repeat");
        const tempMatrix = fillStyle.matrix.copyTo((0, $eY4rt.Matrix).shared);
        tempMatrix.scale(fillStyle.texture.frame.width, fillStyle.texture.frame.height);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $ktCpi.FillPattern)) {
        const fillPattern = fillStyle.fill;
        const pattern = context.createPattern(fillPattern.texture.source.resource, "repeat");
        const tempMatrix = fillPattern.transform.copyTo((0, $eY4rt.Matrix).shared);
        tempMatrix.scale(fillPattern.texture.frame.width, fillPattern.texture.frame.height);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $gwwtL.FillGradient)) {
        const fillGradient = fillStyle.fill;
        const isLinear = fillGradient.type === "linear";
        const isLocal = fillGradient.textureSpace === "local";
        let width = 1;
        let height = 1;
        if (isLocal && textMetrics) {
            width = textMetrics.width + padding;
            height = textMetrics.height + padding;
        }
        let gradient;
        let isNearlyVertical = false;
        if (isLinear) {
            const { start: start, end: end } = fillGradient;
            gradient = context.createLinearGradient(start.x * width, start.y * height, end.x * width, end.y * height);
            isNearlyVertical = Math.abs(end.x - start.x) < Math.abs((end.y - start.y) * 0.1);
        } else {
            const { center: center, innerRadius: innerRadius, outerCenter: outerCenter, outerRadius: outerRadius } = fillGradient;
            gradient = context.createRadialGradient(center.x * width, center.y * height, innerRadius * width, outerCenter.x * width, outerCenter.y * height, outerRadius * width);
        }
        if (isNearlyVertical && isLocal && textMetrics) {
            const ratio = textMetrics.lineHeight / height;
            for(let i = 0; i < textMetrics.lines.length; i++){
                const start = (i * textMetrics.lineHeight + padding / 2) / height;
                fillGradient.colorStops.forEach((stop)=>{
                    const globalStop = start + stop.offset * ratio;
                    gradient.addColorStop(// fix to 5 decimal places to avoid floating point precision issues
                    Math.floor(globalStop * $70d03c252755e3f8$var$PRECISION) / $70d03c252755e3f8$var$PRECISION, (0, $a2eTA.Color).shared.setValue(stop.color).toHex());
                });
            }
        } else fillGradient.colorStops.forEach((stop)=>{
            gradient.addColorStop(stop.offset, (0, $a2eTA.Color).shared.setValue(stop.color).toHex());
        });
        return gradient;
    }
    (0, $hUCK4.warn)("FillStyle not recognised", fillStyle);
    return "red";
}

});

parcelRegister("hlNkG", function(module, exports) {

$parcel$export(module.exports, "AbstractBitmapFont", () => $5d74af76d429a42b$export$70779aee6e4c1309);

var $3vRz3 = parcelRequire("3vRz3");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
class $5d74af76d429a42b$export$70779aee6e4c1309 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments);
        /** The map of characters by character code. */ this.chars = /* @__PURE__ */ Object.create(null);
        /**
     * The line-height of the font face in pixels.
     * @type {number}
     */ this.lineHeight = 0;
        /**
     * The name of the font face
     * @type {string}
     */ this.fontFamily = "";
        /** The metrics of the font face. */ this.fontMetrics = {
            fontSize: 0,
            ascent: 0,
            descent: 0
        };
        /**
     * The offset of the font face from the baseline.
     * @type {number}
     */ this.baseLineOffset = 0;
        /** The range and type of the distance field for this font. */ this.distanceField = {
            type: "none",
            range: 0
        };
        /** The map of base page textures (i.e., sheets of glyphs). */ this.pages = [];
        /** should the fill for this font be applied as a tint to the text. */ this.applyFillAsTint = true;
        /** The size of the font face in pixels. */ this.baseMeasurementFontSize = 100;
        this.baseRenderedFontSize = 100;
    }
    /**
   * The name of the font face.
   * @deprecated since 8.0.0 Use `fontFamily` instead.
   */ get font() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.font is deprecated, please use BitmapFont.fontFamily instead.");
        return this.fontFamily;
    }
    /**
   * The map of base page textures (i.e., sheets of glyphs).
   * @deprecated since 8.0.0 Use `pages` instead.
   */ get pageTextures() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
        return this.pages;
    }
    /**
   * The size of the font face in pixels.
   * @deprecated since 8.0.0 Use `fontMetrics.fontSize` instead.
   */ get size() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.size is deprecated, please use BitmapFont.fontMetrics.fontSize instead.");
        return this.fontMetrics.fontSize;
    }
    /**
   * The kind of distance field for this font or "none".
   * @deprecated since 8.0.0 Use `distanceField.type` instead.
   */ get distanceFieldRange() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.distanceFieldRange is deprecated, please use BitmapFont.distanceField.range instead.");
        return this.distanceField.range;
    }
    /**
   * The range of the distance field in pixels.
   * @deprecated since 8.0.0 Use `distanceField.range` instead.
   */ get distanceFieldType() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.distanceFieldType is deprecated, please use BitmapFont.distanceField.type instead.");
        return this.distanceField.type;
    }
    destroy(destroyTextures = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        for(const i in this.chars)this.chars[i].texture?.destroy();
        this.chars = null;
        if (destroyTextures) {
            this.pages.forEach((page)=>page.texture.destroy(true));
            this.pages = null;
        }
    }
}

});


parcelRegister("hzhPt", function(module, exports) {

$parcel$export(module.exports, "getBitmapTextLayout", () => $a05acbad40de1576$export$beeb37b3e20d3ee4);
"use strict";
function $a05acbad40de1576$export$beeb37b3e20d3ee4(chars, style, font, trimEnd) {
    const layoutData = {
        width: 0,
        height: 0,
        offsetY: 0,
        scale: style.fontSize / font.baseMeasurementFontSize,
        lines: [
            {
                width: 0,
                charPositions: [],
                spaceWidth: 0,
                spacesIndex: [],
                chars: []
            }
        ]
    };
    layoutData.offsetY = font.baseLineOffset;
    let currentLine = layoutData.lines[0];
    let previousChar = null;
    let firstWord = true;
    const currentWord = {
        spaceWord: false,
        width: 0,
        start: 0,
        index: 0,
        // use index to not modify the array as we use it a lot!
        positions: [],
        chars: []
    };
    const nextWord = (word)=>{
        const start = currentLine.width;
        for(let j = 0; j < currentWord.index; j++){
            const position = word.positions[j];
            currentLine.chars.push(word.chars[j]);
            currentLine.charPositions.push(position + start);
        }
        currentLine.width += word.width;
        firstWord = false;
        currentWord.width = 0;
        currentWord.index = 0;
        currentWord.chars.length = 0;
    };
    const nextLine = ()=>{
        let index = currentLine.chars.length - 1;
        if (trimEnd) {
            let lastChar = currentLine.chars[index];
            while(lastChar === " "){
                currentLine.width -= font.chars[lastChar].xAdvance;
                lastChar = currentLine.chars[--index];
            }
        }
        layoutData.width = Math.max(layoutData.width, currentLine.width);
        currentLine = {
            width: 0,
            charPositions: [],
            chars: [],
            spaceWidth: 0,
            spacesIndex: []
        };
        firstWord = true;
        layoutData.lines.push(currentLine);
        layoutData.height += font.lineHeight;
    };
    const scale = font.baseMeasurementFontSize / style.fontSize;
    const adjustedLetterSpacing = style.letterSpacing * scale;
    const adjustedWordWrapWidth = style.wordWrapWidth * scale;
    const breakWords = style.wordWrap && style.breakWords;
    const checkIsOverflow = (lineWidth)=>lineWidth - adjustedLetterSpacing > adjustedWordWrapWidth;
    for(let i = 0; i < chars.length + 1; i++){
        let char;
        const isEnd = i === chars.length;
        if (!isEnd) char = chars[i];
        const charData = font.chars[char] || font.chars[" "];
        const isSpace = /(?:\s)/.test(char);
        const isWordBreak = isSpace || char === "\r" || char === "\n" || isEnd;
        if (isWordBreak) {
            const addWordToNextLine = !firstWord && style.wordWrap && checkIsOverflow(currentLine.width + currentWord.width);
            if (addWordToNextLine) {
                nextLine();
                nextWord(currentWord);
                if (!isEnd) currentLine.charPositions.push(0);
            } else {
                currentWord.start = currentLine.width;
                nextWord(currentWord);
                if (!isEnd) currentLine.charPositions.push(0);
            }
            if (char === "\r" || char === "\n") {
                if (currentLine.width !== 0) nextLine();
            } else if (!isEnd) {
                const spaceWidth = charData.xAdvance + (charData.kerning[previousChar] || 0) + adjustedLetterSpacing;
                currentLine.width += spaceWidth;
                currentLine.spaceWidth = spaceWidth;
                currentLine.spacesIndex.push(currentLine.charPositions.length);
                currentLine.chars.push(char);
            }
        } else {
            const kerning = charData.kerning[previousChar] || 0;
            const nextCharWidth = charData.xAdvance + kerning + adjustedLetterSpacing;
            const addWordToNextLine = breakWords && checkIsOverflow(currentLine.width + currentWord.width + nextCharWidth);
            if (addWordToNextLine) {
                nextWord(currentWord);
                nextLine();
            }
            currentWord.positions[currentWord.index++] = currentWord.width + kerning;
            currentWord.chars.push(char);
            currentWord.width += nextCharWidth;
        }
        previousChar = char;
    }
    nextLine();
    if (style.align === "center") $a05acbad40de1576$var$alignCenter(layoutData);
    else if (style.align === "right") $a05acbad40de1576$var$alignRight(layoutData);
    else if (style.align === "justify") $a05acbad40de1576$var$alignJustify(layoutData);
    return layoutData;
}
function $a05acbad40de1576$var$alignCenter(measurementData) {
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        const offset = measurementData.width / 2 - line.width / 2;
        for(let j = 0; j < line.charPositions.length; j++)line.charPositions[j] += offset;
    }
}
function $a05acbad40de1576$var$alignRight(measurementData) {
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        const offset = measurementData.width - line.width;
        for(let j = 0; j < line.charPositions.length; j++)line.charPositions[j] += offset;
    }
}
function $a05acbad40de1576$var$alignJustify(measurementData) {
    const width = measurementData.width;
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        let indy = 0;
        let spaceIndex = line.spacesIndex[indy++];
        let offset = 0;
        const totalSpaces = line.spacesIndex.length;
        const newSpaceWidth = (width - line.width) / totalSpaces;
        const spaceWidth = newSpaceWidth;
        for(let j = 0; j < line.charPositions.length; j++){
            if (j === spaceIndex) {
                spaceIndex = line.spacesIndex[indy++];
                offset += spaceWidth;
            }
            line.charPositions[j] += offset;
        }
    }
}

});

parcelRegister("6ch13", function(module, exports) {

$parcel$export(module.exports, "resolveCharacters", () => $6068e3267b929dcc$export$221291e5031b03d8);
"use strict";
function $6068e3267b929dcc$export$221291e5031b03d8(chars) {
    if (chars === "") return [];
    if (typeof chars === "string") chars = [
        chars
    ];
    const result = [];
    for(let i = 0, j = chars.length; i < j; i++){
        const item = chars[i];
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
            if (item[0].length === 0 || item[1].length === 0) throw new Error("[BitmapFont]: Invalid character delimiter.");
            const startCode = item[0].charCodeAt(0);
            const endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error("[BitmapFont]: Invalid character range.");
            for(let i2 = startCode, j2 = endCode; i2 <= j2; i2++)result.push(String.fromCharCode(i2));
        } else result.push(...Array.from(item));
    }
    if (result.length === 0) throw new Error("[BitmapFont]: Empty set when resolving characters.");
    return result;
}

});


parcelRegister("3cebA", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $1b5e4ef3a1ed4a4a$export$29d3e417456abdad);

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");

var $8aC7P = parcelRequire("8aC7P");
"use strict";
class $1b5e4ef3a1ed4a4a$export$29d3e417456abdad extends (0, $b9FQU.ViewContainer) {
    /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $8aC7P.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        /** @internal */ this.renderPipeId = "graphics";
        if (!context) this._context = this._ownedContext = new (0, $8aC7P.GraphicsContext)();
        else this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.didViewUpdate = true;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        this._context.off("update", this.onViewUpdate, this);
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */ get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */ updateBounds() {}
    /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */ clone(deep = false) {
        if (deep) return new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        if (color !== void 0) fillStyle.color = color;
        if (alpha !== void 0) fillStyle.alpha = alpha;
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});

parcelRegister("f9zuU", function(module, exports) {

$parcel$export(module.exports, "CanvasTextGenerator", () => $53ece033e8053a02$export$bb54b62b519176d5);

var $a2eTA = parcelRequire("a2eTA");

var $fM4Mk = parcelRequire("fM4Mk");

var $6RGCN = parcelRequire("6RGCN");

var $ha93z = parcelRequire("ha93z");

var $wLFHs = parcelRequire("wLFHs");

var $fI0NC = parcelRequire("fI0NC");

var $4JkiF = parcelRequire("4JkiF");
"use strict";
const $53ece033e8053a02$var$tempRect = new (0, $fM4Mk.Rectangle)();
class $53ece033e8053a02$var$CanvasTextGeneratorClass {
    /**
   * Creates a canvas with the specified text rendered to it.
   *
   * Generates a canvas of appropriate size, renders the text with the provided style,
   * and returns both the canvas/context and a Rectangle representing the text bounds.
   *
   * When trim is enabled in the style, the frame will represent the bounds of the
   * non-transparent pixels, which can be smaller than the full canvas.
   * @param options - The options for generating the text canvas
   * @param options.text - The text to render
   * @param options.style - The style to apply to the text
   * @param options.resolution - The resolution of the canvas (defaults to 1)
   * @param options.padding
   * @returns An object containing the canvas/context and the frame (bounds) of the text
   */ getCanvasAndContext(options) {
        const { text: text, style: style, resolution: resolution = 1 } = options;
        const padding = style._getFinalPadding();
        const measured = (0, $wLFHs.CanvasTextMetrics).measureText(text || " ", style);
        const width = Math.ceil(Math.ceil(Math.max(1, measured.width) + padding * 2) * resolution);
        const height = Math.ceil(Math.ceil(Math.max(1, measured.height) + padding * 2) * resolution);
        const canvasAndContext = (0, $6RGCN.CanvasPool).getOptimalCanvasAndContext(width, height);
        this._renderTextToCanvas(text, style, padding, resolution, canvasAndContext);
        const frame = style.trim ? (0, $ha93z.getCanvasBoundingBox)({
            canvas: canvasAndContext.canvas,
            width: width,
            height: height,
            resolution: 1,
            output: $53ece033e8053a02$var$tempRect
        }) : $53ece033e8053a02$var$tempRect.set(0, 0, width, height);
        return {
            canvasAndContext: canvasAndContext,
            frame: frame
        };
    }
    /**
   * Returns a canvas and context to the pool.
   *
   * This should be called when you're done with the canvas to allow reuse
   * and prevent memory leaks.
   * @param canvasAndContext - The canvas and context to return to the pool
   */ returnCanvasAndContext(canvasAndContext) {
        (0, $6RGCN.CanvasPool).returnCanvasAndContext(canvasAndContext);
    }
    /**
   * Renders text to its canvas, and updates its texture.
   * @param text - The text to render
   * @param style - The style of the text
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render the text to
   */ _renderTextToCanvas(text, style, padding, resolution, canvasAndContext) {
        const { canvas: canvas, context: context } = canvasAndContext;
        const font = (0, $fI0NC.fontStringFromTextStyle)(style);
        const measured = (0, $wLFHs.CanvasTextMetrics).measureText(text || " ", style);
        const lines = measured.lines;
        const lineHeight = measured.lineHeight;
        const lineWidths = measured.lineWidths;
        const maxLineWidth = measured.maxLineWidth;
        const fontProperties = measured.fontProperties;
        const height = canvas.height;
        context.resetTransform();
        context.scale(resolution, resolution);
        context.textBaseline = style.textBaseline;
        if (style._stroke?.width) {
            const strokeStyle = style._stroke;
            context.lineWidth = strokeStyle.width;
            context.miterLimit = strokeStyle.miterLimit;
            context.lineJoin = strokeStyle.join;
            context.lineCap = strokeStyle.cap;
        }
        context.font = font;
        let linePositionX;
        let linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * resolution;
            if (isShadowPass) {
                context.fillStyle = "black";
                context.strokeStyle = "black";
                const shadowOptions = style.dropShadow;
                const dropShadowColor = shadowOptions.color;
                const dropShadowAlpha = shadowOptions.alpha;
                context.shadowColor = (0, $a2eTA.Color).shared.setValue(dropShadowColor).setAlpha(dropShadowAlpha).toRgbaString();
                const dropShadowBlur = shadowOptions.blur * resolution;
                const dropShadowDistance = shadowOptions.distance * resolution;
                context.shadowBlur = dropShadowBlur;
                context.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
                context.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance + dsOffsetShadow;
            } else {
                context.fillStyle = style._fill ? (0, $4JkiF.getCanvasFillStyle)(style._fill, context, measured) : null;
                if (style._stroke?.width) {
                    const padding2 = style._stroke.width * style._stroke.alignment;
                    context.strokeStyle = (0, $4JkiF.getCanvasFillStyle)(style._stroke, context, measured, padding2);
                }
                context.shadowColor = "black";
            }
            let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
            if (lineHeight - fontProperties.fontSize < 0) linePositionYShift = 0;
            const strokeWidth = style._stroke?.width ?? 0;
            for(let i2 = 0; i2 < lines.length; i2++){
                linePositionX = strokeWidth / 2;
                linePositionY = strokeWidth / 2 + i2 * lineHeight + fontProperties.ascent + linePositionYShift;
                if (style.align === "right") linePositionX += maxLineWidth - lineWidths[i2];
                else if (style.align === "center") linePositionX += (maxLineWidth - lineWidths[i2]) / 2;
                if (style._stroke?.width) this._drawLetterSpacing(lines[i2], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText, true);
                if (style._fill !== void 0) this._drawLetterSpacing(lines[i2], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText);
            }
        }
    }
    /**
   * Render the text with letter-spacing.
   *
   * This method handles rendering text with the correct letter spacing, using either:
   * 1. Native letter spacing if supported by the browser
   * 2. Manual letter spacing calculation if not natively supported
   *
   * For manual letter spacing, it calculates the position of each character
   * based on its width and the desired spacing.
   * @param text - The text to draw
   * @param style - The text style to apply
   * @param canvasAndContext - The canvas and context to draw to
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Whether to render the stroke (true) or fill (false)
   * @private
   */ _drawLetterSpacing(text, style, canvasAndContext, x, y, isStroke = false) {
        const { context: context } = canvasAndContext;
        const letterSpacing = style.letterSpacing;
        let useExperimentalLetterSpacing = false;
        if ((0, $wLFHs.CanvasTextMetrics).experimentalLetterSpacingSupported) {
            if ((0, $wLFHs.CanvasTextMetrics).experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        if (letterSpacing === 0 || useExperimentalLetterSpacing) {
            if (isStroke) context.strokeText(text, x, y);
            else context.fillText(text, x, y);
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $wLFHs.CanvasTextMetrics).graphemeSegmenter(text);
        let previousWidth = context.measureText(text).width;
        let currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            if (isStroke) context.strokeText(currentChar, currentPosition, y);
            else context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = context.measureText(textStr).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            previousWidth = currentWidth;
        }
    }
}
const $53ece033e8053a02$export$bb54b62b519176d5 = new $53ece033e8053a02$var$CanvasTextGeneratorClass();

});
parcelRegister("ha93z", function(module, exports) {

$parcel$export(module.exports, "getCanvasBoundingBox", () => $c7f22f786b0aa888$export$550eedf6c679837d);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
let $c7f22f786b0aa888$var$_internalCanvas = null;
let $c7f22f786b0aa888$var$_internalContext = null;
function $c7f22f786b0aa888$var$ensureInternalCanvas(width, height) {
    if (!$c7f22f786b0aa888$var$_internalCanvas) {
        $c7f22f786b0aa888$var$_internalCanvas = (0, $iCGeI.DOMAdapter).get().createCanvas(256, 128);
        $c7f22f786b0aa888$var$_internalContext = $c7f22f786b0aa888$var$_internalCanvas.getContext("2d", {
            willReadFrequently: true
        });
        $c7f22f786b0aa888$var$_internalContext.globalCompositeOperation = "copy";
        $c7f22f786b0aa888$var$_internalContext.globalAlpha = 1;
    }
    if ($c7f22f786b0aa888$var$_internalCanvas.width < width || $c7f22f786b0aa888$var$_internalCanvas.height < height) {
        $c7f22f786b0aa888$var$_internalCanvas.width = (0, $NbSCN.nextPow2)(width);
        $c7f22f786b0aa888$var$_internalCanvas.height = (0, $NbSCN.nextPow2)(height);
    }
}
function $c7f22f786b0aa888$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $c7f22f786b0aa888$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $c7f22f786b0aa888$export$550eedf6c679837d(...args) {
    let options = args[0];
    if (!options.canvas) options = {
        canvas: args[0],
        resolution: args[1]
    };
    const { canvas: canvas } = options;
    const resolution = Math.min(options.resolution ?? 1, 1);
    const width = options.width ?? canvas.width;
    const height = options.height ?? canvas.height;
    let output = options.output;
    $c7f22f786b0aa888$var$ensureInternalCanvas(width, height);
    if (!$c7f22f786b0aa888$var$_internalContext) throw new TypeError("Failed to get canvas 2D context");
    $c7f22f786b0aa888$var$_internalContext.drawImage(canvas, 0, 0, width, height, 0, 0, width * resolution, height * resolution);
    const imageData = $c7f22f786b0aa888$var$_internalContext.getImageData(0, 0, width, height);
    const data = imageData.data;
    let left = 0;
    let top = 0;
    let right = width - 1;
    let bottom = height - 1;
    while(top < height && $c7f22f786b0aa888$var$checkRow(data, width, top))++top;
    if (top === height) return (0, $fM4Mk.Rectangle).EMPTY;
    while($c7f22f786b0aa888$var$checkRow(data, width, bottom))--bottom;
    while($c7f22f786b0aa888$var$checkColumn(data, width, left, top, bottom))++left;
    while($c7f22f786b0aa888$var$checkColumn(data, width, right, top, bottom))--right;
    ++right;
    ++bottom;
    $c7f22f786b0aa888$var$_internalContext.globalCompositeOperation = "source-over";
    $c7f22f786b0aa888$var$_internalContext.strokeRect(left, top, right - left, bottom - top);
    $c7f22f786b0aa888$var$_internalContext.globalCompositeOperation = "copy";
    output ?? (output = new (0, $fM4Mk.Rectangle)());
    output.set(left / resolution, top / resolution, (right - left) / resolution, (bottom - top) / resolution);
    return output;
}

});


parcelRegister("logJB", function(module, exports) {

$parcel$export(module.exports, "Spine", () => (parcelRequire("1ovqM")).Spine);
$parcel$export(module.exports, "SpineTexture", () => (parcelRequire("1Dkiw")).SpineTexture);
parcelRequire("7sAun");
parcelRequire("5EnMZ");
parcelRequire("9e8rD");
parcelRequire("9inJy");

var $1ng6v = parcelRequire("1ng6v");

var $1ovqM = parcelRequire("1ovqM");

var $k9fTk = parcelRequire("k9fTk");

var $1Dkiw = parcelRequire("1Dkiw");
parcelRequire("6DlDK");

});
parcelRegister("7sAun", function(module, exports) {
if (typeof window !== "undefined" && window.PIXI) {
    const prevRequire = window.require;
    window.require = (x)=>{
        if (prevRequire) return prevRequire(x);
        else if (x.startsWith("@pixi/") || x.startsWith("pixi.js")) return window.PIXI;
    };
}

});

parcelRegister("5EnMZ", function(module, exports) {
parcelRequire("iuB9z");
var $dofl4 = parcelRequire("dofl4");
var $iCGeI = parcelRequire("iCGeI");
var $i9BKe = parcelRequire("i9BKe");
var $iEtN5 = parcelRequire("iEtN5");
var $lzfZe = parcelRequire("lzfZe");
var $iA5fe = parcelRequire("iA5fe");

var $1Dkiw = parcelRequire("1Dkiw");
parcelRequire("6DlDK");
var $cQp1s = parcelRequire("cQp1s");
const $5cb694dd388eebdd$var$spineTextureAtlasLoader = {
    extension: (0, $i9BKe.ExtensionType).Asset,
    loader: {
        extension: {
            type: (0, $i9BKe.ExtensionType).LoadParser,
            priority: (0, $iEtN5.LoaderParserPriority).Normal,
            name: "spineTextureAtlasLoader"
        },
        test (url) {
            return (0, $dofl4.checkExtension)(url, ".atlas");
        },
        async load (url) {
            const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
            const txt = await response.text();
            return txt;
        },
        testParse (asset, options) {
            const isExtensionRight = (0, $dofl4.checkExtension)(options.src, ".atlas");
            const isString = typeof asset === "string";
            return Promise.resolve(isExtensionRight && isString);
        },
        unload (atlas) {
            atlas.dispose();
        },
        async parse (asset, options, loader) {
            const metadata = options.data || {};
            let basePath = (0, $lzfZe.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            const retval = new (0, $cQp1s.TextureAtlas)(asset);
            if (metadata.images instanceof (0, $iA5fe.TextureSource) || typeof metadata.images === "string") {
                const pixiTexture = metadata.images;
                metadata.images = {};
                metadata.images[retval.pages[0].name] = pixiTexture;
            }
            const textureLoadingPromises = [];
            for (const page of retval.pages){
                const pageName = page.name;
                const providedPage = metadata?.images ? metadata.images[pageName] : void 0;
                if (providedPage instanceof (0, $iA5fe.TextureSource)) page.setTexture((0, $1Dkiw.SpineTexture).from(providedPage));
                else {
                    const url = providedPage ?? (0, $lzfZe.path).normalize([
                        ...basePath.split((0, $lzfZe.path).sep),
                        pageName
                    ].join((0, $lzfZe.path).sep));
                    const assetsToLoadIn = {
                        src: url,
                        data: {
                            ...metadata.imageMetadata,
                            alphaMode: page.pma ? "premultiplied-alpha" : "premultiply-alpha-on-upload"
                        }
                    };
                    const pixiPromise = loader.load(assetsToLoadIn).then((texture)=>{
                        page.setTexture((0, $1Dkiw.SpineTexture).from(texture.source));
                    });
                    textureLoadingPromises.push(pixiPromise);
                }
            }
            await Promise.all(textureLoadingPromises);
            return retval;
        }
    }
};
(0, $i9BKe.extensions).add($5cb694dd388eebdd$var$spineTextureAtlasLoader);

});
parcelRegister("iuB9z", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => (parcelRequire("i9BKe")).ExtensionType);
$parcel$export(module.exports, "Application", () => (parcelRequire("bja9j")).Application);
$parcel$export(module.exports, "Assets", () => (parcelRequire("9Gm4h")).Assets);
$parcel$export(module.exports, "Cache", () => (parcelRequire("2IhKp")).Cache);
$parcel$export(module.exports, "LoaderParserPriority", () => (parcelRequire("iEtN5")).LoaderParserPriority);
$parcel$export(module.exports, "checkExtension", () => (parcelRequire("dofl4")).checkExtension);
$parcel$export(module.exports, "Color", () => (parcelRequire("a2eTA")).Color);
$parcel$export(module.exports, "DOMAdapter", () => (parcelRequire("iCGeI")).DOMAdapter);
$parcel$export(module.exports, "DEG_TO_RAD", () => (parcelRequire("aWW4e")).DEG_TO_RAD);
$parcel$export(module.exports, "Point", () => (parcelRequire("1HooC")).Point);
$parcel$export(module.exports, "Batcher", () => (parcelRequire("4rmMq")).Batcher);
$parcel$export(module.exports, "compileHighShaderGlProgram", () => (parcelRequire("3JBHn")).compileHighShaderGlProgram);
$parcel$export(module.exports, "compileHighShaderGpuProgram", () => (parcelRequire("3JBHn")).compileHighShaderGpuProgram);
$parcel$export(module.exports, "colorBit", () => (parcelRequire("cNnNT")).colorBit);
$parcel$export(module.exports, "colorBitGl", () => (parcelRequire("cNnNT")).colorBitGl);
$parcel$export(module.exports, "generateTextureBatchBit", () => (parcelRequire("ikSZA")).generateTextureBatchBit);
$parcel$export(module.exports, "generateTextureBatchBitGl", () => (parcelRequire("ikSZA")).generateTextureBatchBitGl);
$parcel$export(module.exports, "roundPixelsBit", () => (parcelRequire("kSpdC")).roundPixelsBit);
$parcel$export(module.exports, "roundPixelsBitGl", () => (parcelRequire("kSpdC")).roundPixelsBitGl);
$parcel$export(module.exports, "getBatchSamplersUniformGroup", () => (parcelRequire("10zIa")).getBatchSamplersUniformGroup);
$parcel$export(module.exports, "Buffer", () => (parcelRequire("lvEAL")).Buffer);
$parcel$export(module.exports, "BufferUsage", () => (parcelRequire("1UZ6r")).BufferUsage);
$parcel$export(module.exports, "Geometry", () => (parcelRequire("cOnev")).Geometry);
$parcel$export(module.exports, "Shader", () => (parcelRequire("5iDyo")).Shader);
$parcel$export(module.exports, "CanvasSource", () => (parcelRequire("8xl7d")).CanvasSource);
$parcel$export(module.exports, "TextureSource", () => (parcelRequire("iA5fe")).TextureSource);
$parcel$export(module.exports, "Texture", () => (parcelRequire("bLlTJ")).Texture);
$parcel$export(module.exports, "Container", () => (parcelRequire("eicwU")).Container);
$parcel$export(module.exports, "collectAllRenderables", () => (parcelRequire("3WPIH")).collectAllRenderables);
$parcel$export(module.exports, "Graphics", () => (parcelRequire("3cebA")).Graphics);
$parcel$export(module.exports, "AnimatedSprite", () => (parcelRequire("aV5iD")).AnimatedSprite);
$parcel$export(module.exports, "TilingSprite", () => (parcelRequire("7EPSr")).TilingSprite);
$parcel$export(module.exports, "Sprite", () => (parcelRequire("4rhnu")).Sprite);
$parcel$export(module.exports, "BitmapFont", () => (parcelRequire("fl08K")).BitmapFont);
$parcel$export(module.exports, "BitmapText", () => (parcelRequire("a32IU")).BitmapText);
$parcel$export(module.exports, "Text", () => (parcelRequire("gc0ip")).Text);
$parcel$export(module.exports, "ViewContainer", () => (parcelRequire("b9FQU")).ViewContainer);
$parcel$export(module.exports, "Spritesheet", () => (parcelRequire("58WFl")).Spritesheet);
$parcel$export(module.exports, "Ticker", () => (parcelRequire("4J7WL")).Ticker);
$parcel$export(module.exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3vRz3")))));
$parcel$export(module.exports, "path", () => (parcelRequire("lzfZe")).path);
$parcel$export(module.exports, "extensions", () => (parcelRequire("i9BKe")).extensions);

var $iA8uc = parcelRequire("iA8uc");

var $gNJFA = parcelRequire("gNJFA");

var $i9BKe = parcelRequire("i9BKe");
parcelRequire("7dx1H");
parcelRequire("4RJM2");













































var $bja9j = parcelRequire("bja9j");



var $9Gm4h = parcelRequire("9Gm4h");


var $2IhKp = parcelRequire("2IhKp");











var $iEtN5 = parcelRequire("iEtN5");













var $dofl4 = parcelRequire("dofl4");





var $a2eTA = parcelRequire("a2eTA");





























var $iCGeI = parcelRequire("iCGeI");



















































var $aWW4e = parcelRequire("aWW4e");




var $1HooC = parcelRequire("1HooC");



















var $4rmMq = parcelRequire("4rmMq");






var $3JBHn = parcelRequire("3JBHn");









var $cNnNT = parcelRequire("cNnNT");

var $ikSZA = parcelRequire("ikSZA");



var $kSpdC = parcelRequire("kSpdC");






























var $10zIa = parcelRequire("10zIa");




















































































var $lvEAL = parcelRequire("lvEAL");


var $1UZ6r = parcelRequire("1UZ6r");





var $cOnev = parcelRequire("cOnev");













var $5iDyo = parcelRequire("5iDyo");




















var $8xl7d = parcelRequire("8xl7d");



var $iA5fe = parcelRequire("iA5fe");


var $bLlTJ = parcelRequire("bLlTJ");









var $8QN7n = parcelRequire("8QN7n");

























var $eicwU = parcelRequire("eicwU");









var $3WPIH = parcelRequire("3WPIH");



























var $3cebA = parcelRequire("3cebA");















































var $aV5iD = parcelRequire("aV5iD");






var $7EPSr = parcelRequire("7EPSr");







var $4rhnu = parcelRequire("4rhnu");







var $fl08K = parcelRequire("fl08K");


var $a32IU = parcelRequire("a32IU");



































var $gc0ip = parcelRequire("gc0ip");






var $b9FQU = parcelRequire("b9FQU");

var $58WFl = parcelRequire("58WFl");



var $4J7WL = parcelRequire("4J7WL");










var $3vRz3 = parcelRequire("3vRz3");














var $lzfZe = parcelRequire("lzfZe");




"use strict";
(0, $i9BKe.extensions).add((0, $iA8uc.browserExt), (0, $gNJFA.webworkerExt));

});
parcelRegister("iA8uc", function(module, exports) {

$parcel$export(module.exports, "browserExt", () => $c220e1d99a2da004$export$a6aad6334ef58a1c);

var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $c220e1d99a2da004$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("7QYPQ"));
    }
};

});

parcelRegister("gNJFA", function(module, exports) {

$parcel$export(module.exports, "webworkerExt", () => $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8);

var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("54sBz"));
    }
};

});

parcelRegister("bja9j", function(module, exports) {

$parcel$export(module.exports, "Application", () => $2202931bfc9ee5c9$export$16975c34e60e1e61);

var $i9BKe = parcelRequire("i9BKe");

var $lmtTM = parcelRequire("lmtTM");

var $eicwU = parcelRequire("eicwU");

var $gVtOu = parcelRequire("gVtOu");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $2202931bfc9ee5c9$var$_Application = class _Application {
    /** @ignore */ constructor(...args){
        /**
     * The root display container for your application.
     * All visual elements should be added to this container or its children.
     * @example
     * ```js
     * // Create a sprite and add it to the stage
     * const sprite = Sprite.from('image.png');
     * app.stage.addChild(sprite);
     *
     * // Create a container for grouping objects
     * const container = new Container();
     * app.stage.addChild(container);
     * ```
     */ this.stage = new (0, $eicwU.Container)();
        if (args[0] !== void 0) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */ async init(options) {
        options = {
            ...options
        };
        this.renderer = await (0, $lmtTM.autoDetectRenderer)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */ get view() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @internal
 */ $2202931bfc9ee5c9$var$_Application._plugins = [];
let $2202931bfc9ee5c9$export$16975c34e60e1e61 = $2202931bfc9ee5c9$var$_Application;
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).Application, $2202931bfc9ee5c9$export$16975c34e60e1e61._plugins);
(0, $i9BKe.extensions).add((0, $gVtOu.ApplicationInitHook));

});
parcelRegister("lmtTM", function(module, exports) {

$parcel$export(module.exports, "autoDetectRenderer", () => $bf7ca24d384e2f55$export$3583b92ab8150eb6);

var $jknZI = parcelRequire("jknZI");

var $3MeAf = parcelRequire("3MeAf");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
const $bf7ca24d384e2f55$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];


async function $bf7ca24d384e2f55$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $bf7ca24d384e2f55$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $bf7ca24d384e2f55$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $3MeAf.isWebGPUSupported)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("bZc23"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $jknZI.isWebGLSupported)(options.failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("fp48r"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            finalOptions = {
                ...options
            };
            throw new Error("CanvasRenderer is not yet implemented");
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}

});
parcelRegister("jknZI", function(module, exports) {

$parcel$export(module.exports, "isWebGLSupported", () => $21de405eafa0c0bb$export$83dc396b76015322);

var $iCGeI = parcelRequire("iCGeI");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
let $21de405eafa0c0bb$var$_isWebGLSupported;
function $21de405eafa0c0bb$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($21de405eafa0c0bb$var$_isWebGLSupported !== void 0) return $21de405eafa0c0bb$var$_isWebGLSupported;
    $21de405eafa0c0bb$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $iCGeI.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (_e) {
            return false;
        }
    })();
    return $21de405eafa0c0bb$var$_isWebGLSupported;
}

});

parcelRegister("3MeAf", function(module, exports) {

$parcel$export(module.exports, "isWebGPUSupported", () => $7cb4832c2de4c977$export$216169f30082c873);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $7cb4832c2de4c977$var$_isWebGPUSupported;
async function $7cb4832c2de4c977$export$216169f30082c873(options = {}) {
    if ($7cb4832c2de4c977$var$_isWebGPUSupported !== void 0) return $7cb4832c2de4c977$var$_isWebGPUSupported;
    $7cb4832c2de4c977$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $iCGeI.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (_e) {
            return false;
        }
    })();
    return $7cb4832c2de4c977$var$_isWebGPUSupported;
}

});



parcelRegister("9Gm4h", function(module, exports) {

$parcel$export(module.exports, "Assets", () => $f4e4ce59fcdafcd2$export$c8eca95e306f7116);

var $i9BKe = parcelRequire("i9BKe");

var $5ilA5 = parcelRequire("5ilA5");

var $hUCK4 = parcelRequire("hUCK4");

var $8z5x8 = parcelRequire("8z5x8");

var $2IhKp = parcelRequire("2IhKp");

var $bAT0b = parcelRequire("bAT0b");

var $jFxOf = parcelRequire("jFxOf");

var $cIKeV = parcelRequire("cIKeV");

var $h6G9W = parcelRequire("h6G9W");

var $22lcm = parcelRequire("22lcm");

var $f5yRY = parcelRequire("f5yRY");

var $fYq25 = parcelRequire("fYq25");

var $5sc0S = parcelRequire("5sc0S");

var $30kAw = parcelRequire("30kAw");

var $eOARC = parcelRequire("eOARC");

var $13zV0 = parcelRequire("13zV0");

var $geSSO = parcelRequire("geSSO");

var $ckjdh = parcelRequire("ckjdh");

var $qPdOe = parcelRequire("qPdOe");

var $iiAQE = parcelRequire("iiAQE");

var $7ESOd = parcelRequire("7ESOd");

var $8kCsw = parcelRequire("8kCsw");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $f4e4ce59fcdafcd2$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $8kCsw.Resolver)();
        this.loader = new (0, $5sc0S.Loader)();
        this.cache = (0, $2IhKp.Cache);
        this._backgroundLoader = new (0, $8z5x8.BackgroundLoader)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    /**
   * Initializes the Assets class with configuration options. While not required,
   * calling this before loading assets is recommended to set up default behaviors.
   * @param options - Configuration options for the Assets system
   * @example
   * ```ts
   * // Basic initialization (optional as Assets.load will call this automatically)
   * await Assets.init();
   *
   * // With CDN configuration
   * await Assets.init({
   *     basePath: 'https://my-cdn.com/assets/',
   *     defaultSearchParams: { version: '1.0.0' }
   * });
   *
   * // With manifest and preferences
   * await Assets.init({
   *     manifest: {
   *         bundles: [{
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'hero',
   *                     src: 'hero.{png,webp}',
   *                     data: { scaleMode: SCALE_MODES.NEAREST }
   *                 },
   *                 {
   *                     alias: 'map',
   *                     src: 'map.json'
   *                 }
   *             ]
   *         }]
   *     },
   *     // Optimize for device capabilities
   *     texturePreference: {
   *         resolution: window.devicePixelRatio,
   *         format: ['webp', 'png']
   *     },
   *     // Set global preferences
   *     preferences: {
   *         crossOrigin: 'anonymous',
   *     }
   * });
   *
   * // Load assets after initialization
   * const heroTexture = await Assets.load('hero');
   * ```
   * @remarks
   * - Can be called only once; subsequent calls will be ignored with a warning
   * - Format detection runs automatically unless `skipDetections` is true
   * - The manifest can be a URL to a JSON file or an inline object
   * @see {@link AssetInitOptions} For all available initialization options
   * @see {@link AssetsManifest} For manifest format details
   */ async init(options = {}) {
        if (this._initialized) {
            (0, $hUCK4.warn)("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        const formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
    }
    /**
   * Registers assets with the Assets resolver. This method maps keys (aliases) to asset sources,
   * allowing you to load assets using friendly names instead of direct URLs.
   * @param assets - The unresolved assets to add to the resolver
   * @example
   * ```ts
   * // Basic usage - single asset
   * Assets.add({
   *     alias: 'myTexture',
   *     src: 'assets/texture.png'
   * });
   * const texture = await Assets.load('myTexture');
   *
   * // Multiple aliases for the same asset
   * Assets.add({
   *     alias: ['hero', 'player'],
   *     src: 'hero.png'
   * });
   * const hero1 = await Assets.load('hero');
   * const hero2 = await Assets.load('player'); // Same texture
   *
   * // Multiple format support
   * Assets.add({
   *     alias: 'character',
   *     src: 'character.{webp,png}' // Will choose best format
   * });
   * Assets.add({
   *     alias: 'character',
   *     src: ['character.webp', 'character.png'], // Explicitly specify formats
   * });
   *
   * // With texture options
   * Assets.add({
   *     alias: 'sprite',
   *     src: 'sprite.png',
   *     data: { scaleMode: 'nearest' }
   * });
   *
   * // Multiple assets at once
   * Assets.add([
   *     { alias: 'bg', src: 'background.png' },
   *     { alias: 'music', src: 'music.mp3' },
   *     { alias: 'spritesheet', src: 'sheet.json', data: { ignoreMultiPack: false } }
   * ]);
   * ```
   * @remarks
   * - Assets are resolved when loaded, not when added
   * - Multiple formats use the best available format for the browser
   * - Adding with same alias overwrites previous definition
   * - The `data` property is passed to the asset loader
   * @see {@link Resolver} For details on asset resolution
   * @see {@link LoaderParser} For asset-specific data options
   * @advanced
   */ add(assets) {
        this.resolver.add(assets);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $4DmkB.isSingleItem)(urls);
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>{
            if (typeof url !== "string") {
                const aliases = this.resolver.getAlias(url);
                if (aliases.some((alias)=>!this.resolver.hasKey(alias))) this.add(url);
                return Array.isArray(aliases) ? aliases[0] : aliases;
            }
            if (!this.resolver.hasKey(url)) this.add({
                alias: url,
                src: url
            });
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * Registers a bundle of assets that can be loaded as a group. Bundles are useful for organizing
   * assets into logical groups, such as game levels or UI screens.
   * @param bundleId - Unique identifier for the bundle
   * @param assets - Assets to include in the bundle
   * @example
   * ```ts
   * // Add a bundle using array format
   * Assets.addBundle('animals', [
   *     { alias: 'bunny', src: 'bunny.png' },
   *     { alias: 'chicken', src: 'chicken.png' },
   *     { alias: 'thumper', src: 'thumper.png' },
   * ]);
   *
   * // Add a bundle using object format
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * // Add a bundle with advanced options
   * Assets.addBundle('ui', [
   *     {
   *         alias: 'button',
   *         src: 'button.{webp,png}',
   *         data: { scaleMode: 'nearest' }
   *     },
   *     {
   *         alias: ['logo', 'brand'],  // Multiple aliases
   *         src: 'logo.svg',
   *         data: { resolution: 2 }
   *     }
   * ]);
   *
   * // Load the bundle
   * await Assets.loadBundle('animals');
   *
   * // Use the loaded assets
   * const bunny = Sprite.from('bunny');
   * const chicken = Sprite.from('chicken');
   * ```
   * @remarks
   * - Bundle IDs must be unique
   * - Assets in bundles are not loaded until `loadBundle` is called
   * - Bundles can be background loaded using `backgroundLoadBundle`
   * - Assets in bundles can be loaded individually using their aliases
   * @see {@link Assets.loadBundle} For loading bundles
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Loads a bundle or multiple bundles of assets. Bundles are collections of related assets
   * that can be loaded together.
   * @param bundleIds - Single bundle ID or array of bundle IDs to load
   * @param onProgress - Optional callback for load progress (0.0 to 1.0)
   * @returns Promise that resolves with the loaded bundle assets
   * @example
   * ```ts
   * // Define bundles in your manifest
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}', // use an array of individual assets
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * // Initialize with manifest
   * await Assets.init({ manifest });
   *
   * // Or add bundles programmatically
   * Assets.addBundle('load-screen', [...]);
   * Assets.loadBundle('load-screen');
   *
   * // Load a single bundle
   * await Assets.loadBundle('load-screen');
   * const bg = Sprite.from('background'); // Uses alias from bundle
   *
   * // Load multiple bundles
   * await Assets.loadBundle([
   *     'load-screen',
   *     'game-screen'
   * ]);
   *
   * // Load with progress tracking
   * await Assets.loadBundle('game-screen', (progress) => {
   *     console.log(`Loading: ${Math.round(progress * 100)}%`);
   * });
   * ```
   * @remarks
   * - Bundle assets are cached automatically
   * - Bundles can be pre-loaded using `backgroundLoadBundle`
   * - Assets in bundles can be accessed by their aliases
   * - Progress callback receives values from 0.0 to 1.0
   * @throws {Error} If the bundle ID doesn't exist in the manifest
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let count = 0;
        let total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        };
        const promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            total += Object.keys(resolveResult).length;
            return this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiates background loading of assets. This allows assets to be loaded passively while other operations
   * continue, making them instantly available when needed later.
   *
   * Background loading is useful for:
   * - Preloading game levels while in a menu
   * - Loading non-critical assets during gameplay
   * - Reducing visible loading screens
   * @param urls - Single URL/alias or array of URLs/aliases to load in the background
   * @example
   * ```ts
   * // Basic background loading
   * Assets.backgroundLoad('images/level2-assets.png');
   *
   * // Background load multiple assets
   * Assets.backgroundLoad([
   *     'images/sprite1.png',
   *     'images/sprite2.png',
   *     'images/background.png'
   * ]);
   *
   * // Later, when you need the assets
   * const textures = await Assets.load([
   *     'images/sprite1.png',
   *     'images/sprite2.png'
   * ]); // Resolves immediately if background loading completed
   * ```
   * @remarks
   * - Background loading happens one asset at a time to avoid blocking the main thread
   * - Loading can be interrupted safely by calling `Assets.load()`
   * - Assets are cached as they complete loading
   * - No progress tracking is available for background loading
   */ async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiates background loading of asset bundles. Similar to backgroundLoad but works with
   * predefined bundles of assets.
   *
   * Perfect for:
   * - Preloading level bundles during gameplay
   * - Loading UI assets during splash screens
   * - Preparing assets for upcoming game states
   * @param bundleIds - Single bundle ID or array of bundle IDs to load in the background
   * @example
   * ```ts
   * // Define bundles in your manifest
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *               name: 'home',
   *               assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/home-bg.png',
   *                 },
   *                 {
   *                     alias: 'logo',
   *                     src: 'images/logo.png',
   *                 }
   *              ]
   *            },
   *            {
   *             name: 'level-1',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/level1/bg.png',
   *                 },
   *                 {
   *                     alias: 'sprites',
   *                     src: 'images/level1/sprites.json'
   *                 }
   *             ]
   *         }]
   *     }
   * });
   *
   * // Load the home screen assets right away
   * await Assets.loadBundle('home');
   * showHomeScreen();
   *
   * // Start background loading while showing home screen
   * Assets.backgroundLoadBundle('level-1');
   *
   * // When player starts level, load completes faster
   * await Assets.loadBundle('level-1');
   * hideHomeScreen();
   * startLevel();
   * ```
   * @remarks
   * - Bundle assets are loaded one at a time
   * - Loading can be interrupted safely by calling `Assets.loadBundle()`
   * - Assets are cached as they complete loading
   * - Requires bundles to be registered via manifest or `addBundle`
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.loadBundle} For immediate bundle loading
   * @see {@link AssetsManifest} For manifest format details
   */ async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   * @internal
   */ reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $2IhKp.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $2IhKp.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = [
            ...new Set(Object.values(resolveResults))
        ];
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            keys.forEach((key)=>{
                out[key] = asset;
            });
            (0, $2IhKp.Cache).set(keys, asset);
        });
        return out;
    }
    /**
   * Unloads assets and releases them from memory. This method ensures proper cleanup of
   * loaded assets when they're no longer needed.
   * @param urls - Single URL/alias or array of URLs/aliases to unload
   * @example
   * ```ts
   * // Unload a single asset
   * await Assets.unload('images/sprite.png');
   *
   * // Unload using an alias
   * await Assets.unload('hero'); // Unloads the asset registered with 'hero' alias
   *
   * // Unload multiple assets
   * await Assets.unload([
   *     'images/background.png',
   *     'images/character.png',
   *     'hero'
   * ]);
   *
   * // Unload and handle creation of new instances
   * await Assets.unload('hero');
   * const newHero = await Assets.load('hero'); // Will load fresh from source
   * ```
   * @remarks
   * > [!WARNING]
   * > Make sure assets aren't being used before unloading:
   * > - Remove sprites using the texture
   * > - Clear any references to the asset
   * > - Textures will be destroyed and can't be used after unloading
   * @throws {Error} If the asset is not found in cache
   */ async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Unloads all assets in a bundle. Use this to free memory when a bundle's assets
   * are no longer needed, such as when switching game levels.
   * @param bundleIds - Single bundle ID or array of bundle IDs to unload
   * @example
   * ```ts
   * // Define and load a bundle
   * Assets.addBundle('level-1', {
   *     background: 'level1/bg.png',
   *     sprites: 'level1/sprites.json',
   *     music: 'level1/music.mp3'
   * });
   *
   * // Load the bundle
   * const level1 = await Assets.loadBundle('level-1');
   *
   * // Use the assets
   * const background = Sprite.from(level1.background);
   *
   * // When done with the level, unload everything
   * await Assets.unloadBundle('level-1');
   * // background sprite is now invalid!
   *
   * // Unload multiple bundles
   * await Assets.unloadBundle([
   *     'level-1',
   *     'level-2',
   *     'ui-elements'
   * ]);
   * ```
   * @remarks
   * > [!WARNING]
   * > - All assets in the bundle will be destroyed
   * > - Bundle needs to be reloaded to use assets again
   * > - Make sure no sprites or other objects are using the assets
   * @throws {Error} If the bundle is not found
   * @see {@link Assets.addBundle} For adding bundles
   * @see {@link Assets.loadBundle} For loading bundles
   */ async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $2IhKp.Cache).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        if (options.preferredFormats) formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ];
        for (const detection of options.detections){
            if (options.skipDetections || await detection.test()) formats = await detection.add(formats);
            else if (!options.skipDetections) formats = await detection.remove(formats);
        }
        formats = formats.filter((format, index)=>formats.indexOf(format) === index);
        return formats;
    }
    /**
   * All the detection parsers currently added to the Assets class.
   * @advanced
   */ get detections() {
        return this._detections;
    }
    /**
   * Sets global preferences for asset loading behavior. This method configures how assets
   * are loaded and processed across all parsers.
   * @param preferences - Asset loading preferences
   * @example
   * ```ts
   * // Basic preferences
   * Assets.setPreferences({
   *     crossOrigin: 'anonymous',
   *     parseAsGraphicsContext: false
   * });
   * ```
   * @remarks
   * Preferences are applied to all compatible parsers and affect future asset loading.
   * Common preferences include:
   * - `crossOrigin`: CORS setting for loaded assets
   * - `preferWorkers`: Whether to use web workers for loading textures
   * - `preferCreateImageBitmap`: Use `createImageBitmap` for texture creation. Turning this off will use the `Image` constructor instead.
   * @see {@link AssetsPreferences} For all available preferences
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $f4e4ce59fcdafcd2$export$c8eca95e306f7116 = new $f4e4ce59fcdafcd2$export$137d4dd907afac85();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).LoadParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.loader.parsers).handleByList((0, $i9BKe.ExtensionType).ResolveParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $i9BKe.ExtensionType).CacheParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.cache.parsers).handleByList((0, $i9BKe.ExtensionType).DetectionParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.detections);
(0, $i9BKe.extensions).add((0, $bAT0b.cacheTextureArray), (0, $cIKeV.detectDefaults), (0, $jFxOf.detectAvif), (0, $fYq25.detectWebp), (0, $h6G9W.detectMp4), (0, $22lcm.detectOgv), (0, $f5yRY.detectWebm), (0, $30kAw.loadJson), (0, $eOARC.loadTxt), (0, $13zV0.loadWebFont), (0, $geSSO.loadSvg), (0, $ckjdh.loadTextures), (0, $qPdOe.loadVideoTextures), (0, $5ilA5.loadBitmapFont), (0, $5ilA5.bitmapFontCachePlugin), (0, $7ESOd.resolveTextureUrl), (0, $iiAQE.resolveJsonUrl));
const $f4e4ce59fcdafcd2$var$assetKeyMap = {
    loader: (0, $i9BKe.ExtensionType).LoadParser,
    resolver: (0, $i9BKe.ExtensionType).ResolveParser,
    cache: (0, $i9BKe.ExtensionType).CacheParser,
    detection: (0, $i9BKe.ExtensionType).DetectionParser
};
(0, $i9BKe.extensions).handle((0, $i9BKe.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($f4e4ce59fcdafcd2$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $i9BKe.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($f4e4ce59fcdafcd2$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $i9BKe.extensions).remove(ref[key]));
});

});
parcelRegister("5ilA5", function(module, exports) {

$parcel$export(module.exports, "bitmapFontCachePlugin", () => $67f0360d0045775d$export$778a313228f06f6c);
$parcel$export(module.exports, "loadBitmapFont", () => $67f0360d0045775d$export$402edee29ac8bed4);

var $iEtN5 = parcelRequire("iEtN5");

var $5Oad7 = parcelRequire("5Oad7");

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lzfZe = parcelRequire("lzfZe");

var $fl08K = parcelRequire("fl08K");

var $isMCe = parcelRequire("isMCe");

var $hsuiF = parcelRequire("hsuiF");
"use strict";
const $67f0360d0045775d$var$validExtensions = [
    ".xml",
    ".fnt"
];
const $67f0360d0045775d$export$778a313228f06f6c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheBitmapFont"
    },
    test: (asset)=>asset instanceof (0, $fl08K.BitmapFont),
    getCacheableAssets (keys, asset) {
        const out = {};
        keys.forEach((key)=>{
            out[key] = asset;
            out[`${key}-bitmap`] = asset;
        });
        out[`${asset.fontFamily}-bitmap`] = asset;
        return out;
    }
};
const $67f0360d0045775d$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Normal
    },
    name: "loadBitmapFont",
    test (url) {
        return $67f0360d0045775d$var$validExtensions.includes((0, $lzfZe.path).extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $isMCe.bitmapFontTextParser).test(data) || (0, $hsuiF.bitmapFontXMLStringParser).test(data);
    },
    async parse (asset, data, loader) {
        const bitmapFontData = (0, $isMCe.bitmapFontTextParser).test(asset) ? (0, $isMCe.bitmapFontTextParser).parse(asset) : (0, $hsuiF.bitmapFontXMLStringParser).parse(asset);
        const { src: src } = data;
        const { pages: pages } = bitmapFontData;
        const textureUrls = [];
        const textureOptions = bitmapFontData.distanceField ? {
            scaleMode: "linear",
            alphaMode: "premultiply-alpha-on-upload",
            autoGenerateMipmaps: false,
            resolution: 1
        } : {};
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $lzfZe.path).join((0, $lzfZe.path).dirname(src), pageFile);
            imagePath = (0, $5Oad7.copySearchParams)(imagePath, src);
            textureUrls.push({
                src: imagePath,
                data: textureOptions
            });
        }
        const loadedTextures = await loader.load(textureUrls);
        const textures = textureUrls.map((url)=>loadedTextures[url.src]);
        const bitmapFont = new (0, $fl08K.BitmapFont)({
            data: bitmapFontData,
            textures: textures
        }, src);
        return bitmapFont;
    },
    async load (url, _options) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        return await response.text();
    },
    async unload (bitmapFont, _resolvedAsset, loader) {
        await Promise.all(bitmapFont.pages.map((page)=>loader.unload(page.texture.source._sourceOrigin)));
        bitmapFont.destroy();
    }
};

});
parcelRegister("fl08K", function(module, exports) {

$parcel$export(module.exports, "BitmapFont", () => $e203ca19ce7419c5$export$17957a09927cadc7);

var $fM4Mk = parcelRequire("fM4Mk");

var $bLlTJ = parcelRequire("bLlTJ");

var $hlNkG = parcelRequire("hlNkG");

var $axl5b = parcelRequire("axl5b");
"use strict";
class $e203ca19ce7419c5$export$17957a09927cadc7 extends (0, $hlNkG.AbstractBitmapFont) {
    constructor(options, url){
        super();
        const { textures: textures, data: data } = options;
        Object.keys(data.pages).forEach((key)=>{
            const pageData = data.pages[parseInt(key, 10)];
            const texture = textures[pageData.id];
            this.pages.push({
                texture: texture
            });
        });
        Object.keys(data.chars).forEach((key)=>{
            const charData = data.chars[key];
            const { frame: textureFrame, source: textureSource } = textures[charData.page];
            const frameReal = new (0, $fM4Mk.Rectangle)(charData.x + textureFrame.x, charData.y + textureFrame.y, charData.width, charData.height);
            const texture = new (0, $bLlTJ.Texture)({
                source: textureSource,
                frame: frameReal
            });
            this.chars[key] = {
                id: key.codePointAt(0),
                xOffset: charData.xOffset,
                yOffset: charData.yOffset,
                xAdvance: charData.xAdvance,
                kerning: charData.kerning ?? {},
                texture: texture
            };
        });
        this.baseRenderedFontSize = data.fontSize;
        this.baseMeasurementFontSize = data.fontSize;
        this.fontMetrics = {
            ascent: 0,
            descent: 0,
            fontSize: data.fontSize
        };
        this.baseLineOffset = data.baseLineOffset;
        this.lineHeight = data.lineHeight;
        this.fontFamily = data.fontFamily;
        this.distanceField = data.distanceField ?? {
            type: "none",
            range: 0
        };
        this.url = url;
    }
    /** Destroys the BitmapFont object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { texture: texture } = this.pages[i];
            texture.destroy(true);
        }
        this.pages = null;
    }
    /**
   * Generates and installs a bitmap font with the specified options.
   * The font will be cached and available for use in BitmapText objects.
   * @param options - Setup options for font generation
   * @returns Installed font instance
   * @example
   * ```ts
   * // Install a basic font
   * BitmapFont.install({
   *     name: 'Title',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 32,
   *         fill: '#ffffff'
   *     }
   * });
   *
   * // Install with advanced options
   * BitmapFont.install({
   *     name: 'Custom',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 24,
   *         fill: '#00ff00',
   *         stroke: { color: '#000000', width: 2 }
   *     },
   *     chars: [['a', 'z'], ['A', 'Z'], ['0', '9']],
   *     resolution: 2,
   *     padding: 4,
   *     textureStyle: {
   *         scaleMode: 'nearest'
   *     }
   * });
   * ```
   */ static install(options) {
        (0, $axl5b.BitmapFontManager).install(options);
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * This frees up memory and resources associated with the font.
   * @param name - The name of the bitmap font to uninstall
   * @example
   * ```ts
   * // Remove a font when it's no longer needed
   * BitmapFont.uninstall('MyCustomFont');
   *
   * // Clear multiple fonts
   * ['Title', 'Heading', 'Body'].forEach(BitmapFont.uninstall);
   * ```
   */ static uninstall(name) {
        (0, $axl5b.BitmapFontManager).uninstall(name);
    }
}

});

parcelRegister("isMCe", function(module, exports) {

$parcel$export(module.exports, "bitmapFontTextParser", () => $2e97ab653ff7bb1e$export$4c1815a0944ccac0);
"use strict";
const $2e97ab653ff7bb1e$export$4c1815a0944ccac0 = {
    test (data) {
        return typeof data === "string" && data.startsWith("info face=");
    },
    parse (txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0];
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            const itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("=");
                const key = split[0];
                const strValue = split[1].replace(/"/gm, "");
                const floatValue = parseFloat(strValue);
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const [info] = rawData.info;
        const [common] = rawData.common;
        const [distanceField] = rawData.distanceField ?? [];
        if (distanceField) font.distanceField = {
            range: parseInt(distanceField.distanceRange, 10),
            type: distanceField.fieldType
        };
        font.fontSize = parseInt(info.size, 10);
        font.fontFamily = info.face;
        font.lineHeight = parseInt(common.lineHeight, 10);
        const page = rawData.page;
        for(let i = 0; i < page.length; i++)font.pages.push({
            id: parseInt(page[i].id, 10) || 0,
            file: page[i].file
        });
        const map = {};
        font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
        const char = rawData.char;
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.id, 10);
            let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            font.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.page, 10) || 0,
                x: parseInt(charNode.x, 10),
                y: parseInt(charNode.y, 10),
                width: parseInt(charNode.width, 10),
                height: parseInt(charNode.height, 10),
                xOffset: parseInt(charNode.xoffset, 10),
                yOffset: parseInt(charNode.yoffset, 10),
                xAdvance: parseInt(charNode.xadvance, 10),
                kerning: {}
            };
        }
        const kerning = rawData.kerning || [];
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].first, 10);
            const second = parseInt(kerning[i].second, 10);
            const amount = parseInt(kerning[i].amount, 10);
            font.chars[map[second]].kerning[map[first]] = amount;
        }
        return font;
    }
};

});

parcelRegister("hsuiF", function(module, exports) {

$parcel$export(module.exports, "bitmapFontXMLStringParser", () => $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16);

var $iCGeI = parcelRequire("iCGeI");

var $KAE8q = parcelRequire("KAE8q");
"use strict";
const $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16 = {
    test (data) {
        if (typeof data === "string" && data.includes("<font>")) return (0, $KAE8q.bitmapFontXMLParser).test((0, $iCGeI.DOMAdapter).get().parseXML(data));
        return false;
    },
    parse (data) {
        return (0, $KAE8q.bitmapFontXMLParser).parse((0, $iCGeI.DOMAdapter).get().parseXML(data));
    }
};

});
parcelRegister("KAE8q", function(module, exports) {

$parcel$export(module.exports, "bitmapFontXMLParser", () => $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3);
"use strict";
const $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3 = {
    test (data) {
        const xml = data;
        return typeof xml !== "string" && "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    },
    parse (xml) {
        const data = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const info = xml.getElementsByTagName("info")[0];
        const common = xml.getElementsByTagName("common")[0];
        const distanceField = xml.getElementsByTagName("distanceField")[0];
        if (distanceField) data.distanceField = {
            type: distanceField.getAttribute("fieldType"),
            range: parseInt(distanceField.getAttribute("distanceRange"), 10)
        };
        const page = xml.getElementsByTagName("page");
        const char = xml.getElementsByTagName("char");
        const kerning = xml.getElementsByTagName("kerning");
        data.fontSize = parseInt(info.getAttribute("size"), 10);
        data.fontFamily = info.getAttribute("face");
        data.lineHeight = parseInt(common.getAttribute("lineHeight"), 10);
        for(let i = 0; i < page.length; i++)data.pages.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        const map = {};
        data.baseLineOffset = data.lineHeight - parseInt(common.getAttribute("base"), 10);
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.getAttribute("id"), 10);
            let letter = charNode.getAttribute("letter") ?? charNode.getAttribute("char") ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            data.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.getAttribute("page"), 10) || 0,
                x: parseInt(charNode.getAttribute("x"), 10),
                y: parseInt(charNode.getAttribute("y"), 10),
                width: parseInt(charNode.getAttribute("width"), 10),
                height: parseInt(charNode.getAttribute("height"), 10),
                // render deets..
                xOffset: parseInt(charNode.getAttribute("xoffset"), 10),
                yOffset: parseInt(charNode.getAttribute("yoffset"), 10),
                // + baseLineOffset,
                xAdvance: parseInt(charNode.getAttribute("xadvance"), 10),
                kerning: {}
            };
        }
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].getAttribute("first"), 10);
            const second = parseInt(kerning[i].getAttribute("second"), 10);
            const amount = parseInt(kerning[i].getAttribute("amount"), 10);
            data.chars[map[second]].kerning[map[first]] = amount;
        }
        return data;
    }
};

});



parcelRegister("8z5x8", function(module, exports) {

$parcel$export(module.exports, "BackgroundLoader", () => $1adc37b2cea8de16$export$1949379a83b843d5);
"use strict";
class $1adc37b2cea8de16$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    /**
   * Adds assets to the background loading queue. Assets are loaded one at a time to minimize
   * performance impact.
   * @param assetUrls - Array of resolved assets to load in the background
   * @example
   * ```ts
   * // Add assets to background load queue
   * backgroundLoader.add([
   *     { src: 'images/level1/bg.png' },
   *     { src: 'images/level1/characters.json' }
   * ]);
   *
   * // Assets will load sequentially in the background
   * // The loader automatically pauses when high-priority loads occur
   * // e.g. Assets.load() is called
   * ```
   * @remarks
   * - Assets are loaded one at a time to minimize performance impact
   * - Loading automatically pauses when Assets.load() is called
   * - No progress tracking is available for background loading
   * - Assets are cached as they complete loading
   * @internal
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    /**
   * Controls the active state of the background loader. When active, the loader will
   * continue processing its queue. When inactive, loading is paused.
   * @returns Whether the background loader is currently active
   * @example
   * ```ts
   * // Pause background loading
   * backgroundLoader.active = false;
   *
   * // Resume background loading
   * backgroundLoader.active = true;
   *
   * // Check current state
   * console.log(backgroundLoader.active); // true/false
   *
   * // Common use case: Pause during intensive operations
   * backgroundLoader.active = false;  // Pause background loading
   * ... // Perform high-priority tasks
   * backgroundLoader.active = true;   // Resume background loading
   * ```
   * @remarks
   * - Setting to true resumes loading immediately
   * - Setting to false pauses after current asset completes
   * - Background loading is automatically paused during `Assets.load()`
   * - Assets already being loaded will complete even when set to false
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}

});

parcelRegister("bAT0b", function(module, exports) {

$parcel$export(module.exports, "cacheTextureArray", () => $df4c0fb70a898168$export$407b4625a915919d);

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $df4c0fb70a898168$export$407b4625a915919d = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheTextureArray"
    },
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $bLlTJ.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};

});

parcelRegister("jFxOf", function(module, exports) {

$parcel$export(module.exports, "detectAvif", () => $ca5df6e874c0bc98$export$a60d2d4a3c570783);

var $i9BKe = parcelRequire("i9BKe");

var $dHzPG = parcelRequire("dHzPG");
"use strict";
const $ca5df6e874c0bc98$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $dHzPG.testImageFormat)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};

});
parcelRegister("dHzPG", function(module, exports) {

$parcel$export(module.exports, "testImageFormat", () => $36c6a70b0c6633f6$export$7c459e568e7cea2c);
"use strict";
async function $36c6a70b0c6633f6$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(true);
        };
        image.onerror = ()=>{
            resolve(false);
        };
        image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch (_e) {
            return false;
        }
        return true;
    }
    return false;
}

});


parcelRegister("cIKeV", function(module, exports) {

$parcel$export(module.exports, "detectDefaults", () => $c65eb9bc0713cb5d$export$b106d7c2de3b4d89);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $c65eb9bc0713cb5d$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $c65eb9bc0713cb5d$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$c65eb9bc0713cb5d$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$c65eb9bc0713cb5d$var$imageFormats.includes(f))
};

});

parcelRegister("h6G9W", function(module, exports) {

$parcel$export(module.exports, "detectMp4", () => $8c93018bb9bae76f$export$7726d83fee274e25);

var $i9BKe = parcelRequire("i9BKe");

var $eSIgD = parcelRequire("eSIgD");
"use strict";
const $8c93018bb9bae76f$export$7726d83fee274e25 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $eSIgD.testVideoFormat)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};

});
parcelRegister("eSIgD", function(module, exports) {

$parcel$export(module.exports, "testVideoFormat", () => $2ba590fe27c747f9$export$7a571c147b03abb1);
"use strict";
const $2ba590fe27c747f9$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $2ba590fe27c747f9$export$7a571c147b03abb1(mimeType) {
    if ($2ba590fe27c747f9$var$inWorker) return false;
    const video = document.createElement("video");
    return video.canPlayType(mimeType) !== "";
}

});


parcelRegister("22lcm", function(module, exports) {

$parcel$export(module.exports, "detectOgv", () => $dfa8be665f85221f$export$5a1da481121f806a);

var $i9BKe = parcelRequire("i9BKe");

var $eSIgD = parcelRequire("eSIgD");
"use strict";
const $dfa8be665f85221f$export$5a1da481121f806a = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $eSIgD.testVideoFormat)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};

});

parcelRegister("f5yRY", function(module, exports) {

$parcel$export(module.exports, "detectWebm", () => $64abecc9a39a8c54$export$a041d698a1896657);

var $i9BKe = parcelRequire("i9BKe");

var $eSIgD = parcelRequire("eSIgD");
"use strict";
const $64abecc9a39a8c54$export$a041d698a1896657 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $eSIgD.testVideoFormat)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};

});

parcelRegister("fYq25", function(module, exports) {

$parcel$export(module.exports, "detectWebp", () => $c494cf4c5ea6913a$export$d19529a9ed9823d4);

var $i9BKe = parcelRequire("i9BKe");

var $dHzPG = parcelRequire("dHzPG");
"use strict";
const $c494cf4c5ea6913a$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $dHzPG.testImageFormat)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};

});

parcelRegister("5sc0S", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $be4c9d6031b69343$export$3b0d6d7590275603);

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $be4c9d6031b69343$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [];
        this._parsersValidated = false;
        /**
     * All loader parsers registered
     * @type {assets.LoaderParser[]}
     */ this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        /** Cache loading promises that ae currently active */ this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.loadParser) {
                parser = this._parserHash[data.loadParser];
                if (!parser) (0, $hUCK4.warn)(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    (0, $hUCK4.warn)(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgress) {
        if (!this._parsersValidated) this._validateParsers();
        let count = 0;
        const assets = {};
        const singleAsset = (0, $4DmkB.isSingleItem)(assetsToLoadIn);
        const assetsToLoad = (0, $3CHiv.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item,
                data: {}
            }));
        const total = assetsToLoad.length;
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
                assets[asset.src] = await this.promiseCache[url].promise;
                if (onProgress) onProgress(++count / total);
            } catch (e) {
                delete this.promiseCache[url];
                delete assets[asset.src];
                throw new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $3CHiv.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url];
                await loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>{
            if (!parser.name) (0, $hUCK4.warn)(`[Assets] loadParser should have a name`);
            else if (hash[parser.name]) (0, $hUCK4.warn)(`[Assets] loadParser name conflict "${parser.name}"`);
            return {
                ...hash,
                [parser.name]: parser
            };
        }, {});
    }
}

});

parcelRegister("30kAw", function(module, exports) {

$parcel$export(module.exports, "loadJson", () => $c569a63b2f914437$export$e7c8553478f3aac7);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $c569a63b2f914437$var$validJSONExtension = ".json";
const $c569a63b2f914437$var$validJSONMIME = "application/json";
const $c569a63b2f914437$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $c569a63b2f914437$var$validJSONMIME) || (0, $dofl4.checkExtension)(url, $c569a63b2f914437$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const json = await response.json();
        return json;
    }
};

});
parcelRegister("lXxYk", function(module, exports) {

$parcel$export(module.exports, "checkDataUrl", () => $d89e452ad91824ca$export$7ff8b059fb914323);
"use strict";
function $d89e452ad91824ca$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}

});

parcelRegister("dofl4", function(module, exports) {

$parcel$export(module.exports, "checkExtension", () => $8f487e3828a5ee92$export$fd0180357b95b812);

var $lzfZe = parcelRequire("lzfZe");
"use strict";
function $8f487e3828a5ee92$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $lzfZe.path).extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}

});


parcelRegister("eOARC", function(module, exports) {

$parcel$export(module.exports, "loadTxt", () => $779da4c964b62347$export$3835b7ee6dbebde8);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $779da4c964b62347$var$validTXTExtension = ".txt";
const $779da4c964b62347$var$validTXTMIME = "text/plain";
const $779da4c964b62347$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadTxt"
    },
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $779da4c964b62347$var$validTXTMIME) || (0, $dofl4.checkExtension)(url, $779da4c964b62347$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const txt = await response.text();
        return txt;
    }
};

});

parcelRegister("13zV0", function(module, exports) {

$parcel$export(module.exports, "loadWebFont", () => $0568dcd95d86dd78$export$129ed93ad26b0298);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $2IhKp = parcelRequire("2IhKp");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $0568dcd95d86dd78$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $0568dcd95d86dd78$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $0568dcd95d86dd78$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $0568dcd95d86dd78$export$c461ca8f39d93d9b(url) {
    const ext = (0, $lzfZe.path).extname(url);
    const name = (0, $lzfZe.path).basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $0568dcd95d86dd78$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $0568dcd95d86dd78$var$encodeURIWhenNeeded(uri) {
    if ($0568dcd95d86dd78$var$validURICharactersRegex.test(uri)) return uri;
    return encodeURI(uri);
}
const $0568dcd95d86dd78$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $0568dcd95d86dd78$var$validFontMIMEs) || (0, $dofl4.checkExtension)(url, $0568dcd95d86dd78$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $iCGeI.DOMAdapter).get().getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $0568dcd95d86dd78$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$0568dcd95d86dd78$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url(${$0568dcd95d86dd78$var$encodeURIWhenNeeded(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            (0, $2IhKp.Cache).set(`${name}-and-url`, {
                url: url,
                fontFaces: fontFaces
            });
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        (0, $hUCK4.warn)("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>{
            (0, $2IhKp.Cache).remove(`${t.family}-and-url`);
            (0, $iCGeI.DOMAdapter).get().getFontFaceSet().delete(t);
        });
    }
};

});

parcelRegister("geSSO", function(module, exports) {

$parcel$export(module.exports, "loadSvg", () => $258a91d856307e86$export$b6a2e78b63791dfa);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");

var $8aC7P = parcelRequire("8aC7P");

var $e80R6 = parcelRequire("e80R6");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");

var $jAkJt = parcelRequire("jAkJt");
"use strict";
const $258a91d856307e86$var$validSVGExtension = ".svg";
const $258a91d856307e86$var$validSVGMIME = "image/svg+xml";
const $258a91d856307e86$export$b6a2e78b63791dfa = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadSVG"
    },
    name: "loadSVG",
    config: {
        crossOrigin: "anonymous",
        parseAsGraphicsContext: false
    },
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $258a91d856307e86$var$validSVGMIME) || (0, $dofl4.checkExtension)(url, $258a91d856307e86$var$validSVGExtension);
    },
    async load (url, asset, loader) {
        if (asset.data?.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) return $258a91d856307e86$var$loadAsGraphics(url);
        return $258a91d856307e86$var$loadAsTexture(url, asset, loader, this.config.crossOrigin);
    },
    unload (asset) {
        asset.destroy(true);
    }
};
async function $258a91d856307e86$var$loadAsTexture(url, asset, loader, crossOrigin) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const image = new Image();
    image.src = blobUrl;
    image.crossOrigin = crossOrigin;
    await image.decode();
    URL.revokeObjectURL(blobUrl);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const resolution = asset.data?.resolution || (0, $e80R6.getResolutionOfUrl)(url);
    const width = asset.data?.width ?? image.width;
    const height = asset.data?.height ?? image.height;
    canvas.width = width * resolution;
    canvas.height = height * resolution;
    context.drawImage(image, 0, 0, width * resolution, height * resolution);
    const { parseAsGraphicsContext: _p, ...rest } = asset.data ?? {};
    const base = new (0, $aQPld.ImageSource)({
        resource: canvas,
        alphaMode: "premultiply-alpha-on-upload",
        resolution: resolution,
        ...rest
    });
    return (0, $jAkJt.createTexture)(base, loader, url);
}
async function $258a91d856307e86$var$loadAsGraphics(url) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const svgSource = await response.text();
    const context = new (0, $8aC7P.GraphicsContext)();
    context.svg(svgSource);
    return context;
}

});
parcelRegister("e80R6", function(module, exports) {

$parcel$export(module.exports, "getResolutionOfUrl", () => $69836a01b04ce50b$export$8695ab2f322d2637);

var $8kCsw = parcelRequire("8kCsw");
"use strict";
function $69836a01b04ce50b$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $8kCsw.Resolver).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}

});

parcelRegister("jAkJt", function(module, exports) {

$parcel$export(module.exports, "createTexture", () => $703462f38e5d63e3$export$37b981a8c575f415);

var $bLlTJ = parcelRequire("bLlTJ");

var $hUCK4 = parcelRequire("hUCK4");

var $2IhKp = parcelRequire("2IhKp");
"use strict";
function $703462f38e5d63e3$export$37b981a8c575f415(source, loader, url) {
    source.label = url;
    source._sourceOrigin = url;
    const texture = new (0, $bLlTJ.Texture)({
        source: source,
        label: url
    });
    const unload = ()=>{
        delete loader.promiseCache[url];
        if ((0, $2IhKp.Cache).has(url)) (0, $2IhKp.Cache).remove(url);
    };
    texture.source.once("destroy", ()=>{
        if (loader.promiseCache[url]) {
            (0, $hUCK4.warn)("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
            unload();
        }
    });
    texture.once("destroy", ()=>{
        if (!source.destroyed) {
            (0, $hUCK4.warn)("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
            unload();
        }
    });
    return texture;
}

});


parcelRegister("ckjdh", function(module, exports) {

$parcel$export(module.exports, "loadTextures", () => $7390591d087b0cdb$export$897b113ee8307cd0);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");

var $e80R6 = parcelRequire("e80R6");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $1nTSS = parcelRequire("1nTSS");

var $iEtN5 = parcelRequire("iEtN5");

var $jAkJt = parcelRequire("jAkJt");
"use strict";
const $7390591d087b0cdb$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $7390591d087b0cdb$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $7390591d087b0cdb$export$c614e6247302006d(url, asset) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return asset?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, {
        premultiplyAlpha: "none"
    }) : createImageBitmap(imageBlob);
}
const $7390591d087b0cdb$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).High,
        name: "loadTextures"
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $7390591d087b0cdb$var$validImageMIMEs) || (0, $dofl4.checkExtension)(url, $7390591d087b0cdb$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $1nTSS.WorkerManager).isImageBitmapSupported()) src = await (0, $1nTSS.WorkerManager).loadImageBitmap(url, asset);
            else src = await $7390591d087b0cdb$export$c614e6247302006d(url, asset);
        } else src = await new Promise((resolve, reject)=>{
            src = new Image();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else {
                src.onload = ()=>{
                    resolve(src);
                };
                src.onerror = reject;
            }
        });
        const base = new (0, $aQPld.ImageSource)({
            resource: src,
            alphaMode: "premultiply-alpha-on-upload",
            resolution: asset.data?.resolution || (0, $e80R6.getResolutionOfUrl)(url),
            ...asset.data
        });
        return (0, $jAkJt.createTexture)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};

});
parcelRegister("1nTSS", function(module, exports) {

$parcel$export(module.exports, "WorkerManager", () => $778464c1601fd395$export$bcff6015853c67ce);

var $l4P2n = parcelRequire("l4P2n");

var $55Igy = parcelRequire("55Igy");
"use strict";
let $778464c1601fd395$var$UUID = 0;
let $778464c1601fd395$var$MAX_WORKERS;
class $778464c1601fd395$var$WorkerManagerClass {
    constructor(){
        this._initialized = false;
        this._createdWorkers = 0;
        this._workerPool = [];
        this._queue = [];
        this._resolveHash = {};
    }
    isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const { worker: worker } = new (0, $l4P2n.default)();
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                (0, $l4P2n.default).revokeObjectURL();
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    loadImageBitmap(src, asset) {
        return this._run("loadImageBitmap", [
            src,
            asset?.data?.alphaMode
        ]);
    }
    async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    _getWorker() {
        if ($778464c1601fd395$var$MAX_WORKERS === void 0) $778464c1601fd395$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this._workerPool.pop();
        if (!worker && this._createdWorkers < $778464c1601fd395$var$MAX_WORKERS) {
            this._createdWorkers++;
            worker = new (0, $55Igy.default)().worker;
            worker.addEventListener("message", (event)=>{
                this._complete(event.data);
                this._returnWorker(event.target);
                this._next();
            });
        }
        return worker;
    }
    _returnWorker(worker) {
        this._workerPool.push(worker);
    }
    _complete(data) {
        if (data.error !== void 0) this._resolveHash[data.uuid].reject(data.error);
        else this._resolveHash[data.uuid].resolve(data.data);
        this._resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this._queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this._next();
        return promise;
    }
    _next() {
        if (!this._queue.length) return;
        const worker = this._getWorker();
        if (!worker) return;
        const toDo = this._queue.pop();
        const id = toDo.id;
        this._resolveHash[$778464c1601fd395$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $778464c1601fd395$var$UUID++,
            id: id
        });
    }
}
const $778464c1601fd395$export$bcff6015853c67ce = new $778464c1601fd395$var$WorkerManagerClass();

});
parcelRegister("l4P2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a21140edc3f77d8$export$2e2bcd8739ae039);
const $9a21140edc3f77d8$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    const WHITE_PNG = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=\";\n    async function checkImageBitmap() {\n      try {\n        if (typeof createImageBitmap !== \"function\")\n          return false;\n        const response = await fetch(WHITE_PNG);\n        const imageBlob = await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n        return imageBitmap.width === 1 && imageBitmap.height === 1;\n      } catch (_e) {\n        return false;\n      }\n    }\n    void checkImageBitmap().then((result) => {\n      self.postMessage(result);\n    });\n\n})();\n";
let $9a21140edc3f77d8$var$WORKER_URL = null;
class $9a21140edc3f77d8$export$2e2bcd8739ae039 {
    constructor(){
        if (!$9a21140edc3f77d8$var$WORKER_URL) $9a21140edc3f77d8$var$WORKER_URL = URL.createObjectURL(new Blob([
            $9a21140edc3f77d8$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($9a21140edc3f77d8$var$WORKER_URL);
    }
}
$9a21140edc3f77d8$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($9a21140edc3f77d8$var$WORKER_URL) {
        URL.revokeObjectURL($9a21140edc3f77d8$var$WORKER_URL);
        $9a21140edc3f77d8$var$WORKER_URL = null;
    }
};

});

parcelRegister("55Igy", function(module, exports) {

$parcel$export(module.exports, "default", () => $361d1ede8b4541ed$export$2e2bcd8739ae039);
const $361d1ede8b4541ed$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    async function loadImageBitmap(url, alphaMode) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      return alphaMode === \"premultiplied-alpha\" ? createImageBitmap(imageBlob, { premultiplyAlpha: \"none\" }) : createImageBitmap(imageBlob);\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n";
let $361d1ede8b4541ed$var$WORKER_URL = null;
class $361d1ede8b4541ed$export$2e2bcd8739ae039 {
    constructor(){
        if (!$361d1ede8b4541ed$var$WORKER_URL) $361d1ede8b4541ed$var$WORKER_URL = URL.createObjectURL(new Blob([
            $361d1ede8b4541ed$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($361d1ede8b4541ed$var$WORKER_URL);
    }
}
$361d1ede8b4541ed$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($361d1ede8b4541ed$var$WORKER_URL) {
        URL.revokeObjectURL($361d1ede8b4541ed$var$WORKER_URL);
        $361d1ede8b4541ed$var$WORKER_URL = null;
    }
};

});



parcelRegister("qPdOe", function(module, exports) {

$parcel$export(module.exports, "loadVideoTextures", () => $170b999e73028fac$export$68fa0976ba667d63);

var $i9BKe = parcelRequire("i9BKe");

var $hNatJ = parcelRequire("hNatJ");

var $7blVu = parcelRequire("7blVu");

var $e80R6 = parcelRequire("e80R6");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $jAkJt = parcelRequire("jAkJt");
"use strict";
const $170b999e73028fac$var$validVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogg",
    ".ogv",
    ".h264",
    ".avi",
    ".mov"
];
const $170b999e73028fac$var$validVideoMIMEs = $170b999e73028fac$var$validVideoExtensions.map((ext)=>`video/${ext.substring(1)}`);
function $170b999e73028fac$export$c47cb7c63271266e(element, url, crossorigin) {
    if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = $170b999e73028fac$export$292083da55c5b406(url);
    else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
}
function $170b999e73028fac$export$856bfbe81968ff62(element) {
    return new Promise((resolve, reject)=>{
        element.addEventListener("canplaythrough", loaded);
        element.addEventListener("error", error);
        element.load();
        function loaded() {
            cleanup();
            resolve();
        }
        function error(err) {
            cleanup();
            reject(err);
        }
        function cleanup() {
            element.removeEventListener("canplaythrough", loaded);
            element.removeEventListener("error", error);
        }
    });
}
function $170b999e73028fac$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc || (loc = globalThis.location);
    const parsedUrl = new URL(url, document.baseURI);
    if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}
const $170b999e73028fac$export$68fa0976ba667d63 = {
    name: "loadVideo",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        name: "loadVideo"
    },
    test (url) {
        const isValidDataUrl = (0, $lXxYk.checkDataUrl)(url, $170b999e73028fac$var$validVideoMIMEs);
        const isValidExtension = (0, $dofl4.checkExtension)(url, $170b999e73028fac$var$validVideoExtensions);
        return isValidDataUrl || isValidExtension;
    },
    async load (url, asset, loader) {
        const options = {
            ...(0, $hNatJ.VideoSource).defaultOptions,
            resolution: asset.data?.resolution || (0, $e80R6.getResolutionOfUrl)(url),
            alphaMode: asset.data?.alphaMode || await (0, $7blVu.detectVideoAlphaMode)(),
            ...asset.data
        };
        const videoElement = document.createElement("video");
        const attributeMap = {
            preload: options.autoLoad !== false ? "auto" : void 0,
            "webkit-playsinline": options.playsinline !== false ? "" : void 0,
            playsinline: options.playsinline !== false ? "" : void 0,
            muted: options.muted === true ? "" : void 0,
            loop: options.loop === true ? "" : void 0,
            autoplay: options.autoPlay !== false ? "" : void 0
        };
        Object.keys(attributeMap).forEach((key)=>{
            const value = attributeMap[key];
            if (value !== void 0) videoElement.setAttribute(key, value);
        });
        if (options.muted === true) videoElement.muted = true;
        $170b999e73028fac$export$c47cb7c63271266e(videoElement, url, options.crossorigin);
        const sourceElement = document.createElement("source");
        let mime;
        if (url.startsWith("data:")) mime = url.slice(5, url.indexOf(";"));
        else if (!url.startsWith("blob:")) {
            const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
            mime = (0, $hNatJ.VideoSource).MIME_TYPES[ext] || `video/${ext}`;
        }
        sourceElement.src = url;
        if (mime) sourceElement.type = mime;
        return new Promise((resolve)=>{
            const onCanPlay = async ()=>{
                const base = new (0, $hNatJ.VideoSource)({
                    ...options,
                    resource: videoElement
                });
                videoElement.removeEventListener("canplay", onCanPlay);
                if (asset.data.preload) await $170b999e73028fac$export$856bfbe81968ff62(videoElement);
                resolve((0, $jAkJt.createTexture)(base, loader, url));
            };
            if (options.preload && !options.autoPlay) videoElement.load();
            videoElement.addEventListener("canplay", onCanPlay);
            videoElement.appendChild(sourceElement);
        });
    },
    unload (texture) {
        texture.destroy(true);
    }
};

});

parcelRegister("iiAQE", function(module, exports) {

$parcel$export(module.exports, "resolveJsonUrl", () => $7c85897abf6bc2d6$export$2b5cca0b89cb089c);

var $i9BKe = parcelRequire("i9BKe");

var $8kCsw = parcelRequire("8kCsw");

var $7ESOd = parcelRequire("7ESOd");
"use strict";
const $7c85897abf6bc2d6$export$2b5cca0b89cb089c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        priority: -2,
        name: "resolveJson"
    },
    test: (value)=>(0, $8kCsw.Resolver).RETINA_PREFIX.test(value) && value.endsWith(".json"),
    parse: (0, $7ESOd.resolveTextureUrl).parse
};

});
parcelRegister("7ESOd", function(module, exports) {

$parcel$export(module.exports, "resolveTextureUrl", () => $f9f0a4a658d5e519$export$cc356fa83de02bea);

var $i9BKe = parcelRequire("i9BKe");

var $ckjdh = parcelRequire("ckjdh");

var $8kCsw = parcelRequire("8kCsw");
"use strict";
const $f9f0a4a658d5e519$export$cc356fa83de02bea = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        name: "resolveTexture"
    },
    test: (0, $ckjdh.loadTextures).test,
    parse: (value)=>({
            resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};

});



parcelRegister("3WPIH", function(module, exports) {

$parcel$export(module.exports, "collectAllRenderables", () => $5f0ef6cadfc5a363$export$d0ce49decf05e61d);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
function $5f0ef6cadfc5a363$export$d0ce49decf05e61d(container, instructionSet, rendererOrPipes) {
    (0, $kXq8E.deprecation)("8.7.0", "Please use container.collectRenderables instead.");
    const renderer = rendererOrPipes.renderPipes ? rendererOrPipes : rendererOrPipes.batch.renderer;
    return container.collectRenderables(instructionSet, renderer, null);
}

});

parcelRegister("aV5iD", function(module, exports) {

$parcel$export(module.exports, "AnimatedSprite", () => $84361de765a4dfd8$export$dae599798687ad3c);

var $bLlTJ = parcelRequire("bLlTJ");

var $cQMLP = parcelRequire("cQMLP");

var $4J7WL = parcelRequire("4J7WL");

var $4rhnu = parcelRequire("4rhnu");
"use strict";
class $84361de765a4dfd8$export$dae599798687ad3c extends (0, $4rhnu.Sprite) {
    /** @ignore */ constructor(...args){
        let options = args[0];
        if (Array.isArray(args[0])) options = {
            textures: args[0],
            autoUpdate: args[1]
        };
        const { animationSpeed: animationSpeed = 1, autoPlay: autoPlay = false, autoUpdate: autoUpdate = true, loop: loop = true, onComplete: onComplete = null, onFrameChange: onFrameChange = null, onLoop: onLoop = null, textures: textures, updateAnchor: updateAnchor = false, ...rest } = options;
        const [firstFrame] = textures;
        super({
            ...rest,
            texture: firstFrame instanceof (0, $bLlTJ.Texture) ? firstFrame : firstFrame.texture
        });
        this._textures = null;
        this._durations = null;
        this._autoUpdate = autoUpdate;
        this._isConnectedToTicker = false;
        this.animationSpeed = animationSpeed;
        this.loop = loop;
        this.updateAnchor = updateAnchor;
        this.onComplete = onComplete;
        this.onFrameChange = onFrameChange;
        this.onLoop = onLoop;
        this._currentTime = 0;
        this._playing = false;
        this._previousFrame = null;
        this.textures = textures;
        if (autoPlay) this.play();
    }
    /**
   * Stops the animation playback and freezes the current frame.
   * Does not reset the current frame or animation progress.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *         Texture.from('walk3.png')
   *     ],
   *     autoPlay: true
   * });
   *
   * // Stop at current frame
   * sprite.stop();
   *
   * // Stop at specific frame
   * sprite.gotoAndStop(1); // Stops at second frame
   *
   * // Stop and reset
   * sprite.stop();
   * sprite.currentFrame = 0;
   *
   * // Stop with completion check
   * if (sprite.playing) {
   *     sprite.stop();
   *     sprite.onComplete?.();
   * }
   * ```
   * @see {@link AnimatedSprite#play} For starting playback
   * @see {@link AnimatedSprite#gotoAndStop} For stopping at a specific frame
   * @see {@link AnimatedSprite#playing} For checking play state
   */ stop() {
        if (!this._playing) return;
        this._playing = false;
        if (this._autoUpdate && this._isConnectedToTicker) {
            (0, $4J7WL.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    }
    /**
   * Starts or resumes the animation playback.
   * If the animation was previously stopped, it will continue from where it left off.
   * @example
   * ```ts
   * // Basic playback
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *     ],
   *     autoPlay: false
   * });
   * sprite.play();
   *
   * // Play after stopping
   * sprite.stop();
   * sprite.currentFrame = 0; // Reset to start
   * sprite.play(); // Play from beginning
   *
   * // Play with auto-update disabled
   * sprite.autoUpdate = false;
   * sprite.play();
   * app.ticker.add(() => {
   *     sprite.update(app.ticker); // Manual updates
   * });
   * ```
   * @see {@link AnimatedSprite#stop} For stopping playback
   * @see {@link AnimatedSprite#gotoAndPlay} For playing from a specific frame
   * @see {@link AnimatedSprite#playing} For checking play state
   */ play() {
        if (this._playing) return;
        this._playing = true;
        if (this._autoUpdate && !this._isConnectedToTicker) {
            (0, $4J7WL.Ticker).shared.add(this.update, this, (0, $cQMLP.UPDATE_PRIORITY).HIGH);
            this._isConnectedToTicker = true;
        }
    }
    /**
   * Stops the AnimatedSprite and sets it to a specific frame.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *         Texture.from('walk3.png'),
   *     ]
   * });
   *
   * // Go to specific frames
   * sprite.gotoAndStop(0);  // First frame
   * sprite.gotoAndStop(2);  // Third frame
   *
   * // Jump to last frame
   * sprite.gotoAndStop(sprite.totalFrames - 1);
   * ```
   * @param frameNumber - Frame index to stop at (0-based)
   * @throws {Error} If frameNumber is out of bounds
   * @see {@link AnimatedSprite#gotoAndPlay} For going to a frame and playing
   * @see {@link AnimatedSprite#currentFrame} For getting/setting current frame
   * @see {@link AnimatedSprite#totalFrames} For total number of frames
   */ gotoAndStop(frameNumber) {
        this.stop();
        this.currentFrame = frameNumber;
    }
    /**
   * Goes to a specific frame and begins playing the AnimatedSprite from that point.
   * Combines frame navigation and playback start in one operation.
   * @example
   * ```ts
   * // Start from specific frame
   * sprite.gotoAndPlay(1); // Starts playing from second frame
   * ```
   * @param frameNumber - Frame index to start playing from (0-based)
   * @throws {Error} If frameNumber is out of bounds
   * @see {@link AnimatedSprite#gotoAndStop} For going to a frame without playing
   * @see {@link AnimatedSprite#play} For playing from current frame
   * @see {@link AnimatedSprite#currentFrame} For getting/setting current frame
   */ gotoAndPlay(frameNumber) {
        this.currentFrame = frameNumber;
        this.play();
    }
    /**
   * Updates the object transform for rendering. This method handles animation timing, frame updates,
   * and manages looping behavior.
   * @example
   * ```ts
   * // Create an animated sprite with manual updates
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('frame1.png'),
   *         Texture.from('frame2.png'),
   *         Texture.from('frame3.png')
   *     ],
   *     autoUpdate: false // Disable automatic updates
   * });
   *
   * // Manual update with app ticker
   * app.ticker.add((ticker) => {
   *     sprite.update(ticker);
   * });
   * ```
   * @param ticker - The ticker to use for updating the animation timing
   * @see {@link AnimatedSprite#autoUpdate} For controlling automatic updates
   * @see {@link AnimatedSprite#animationSpeed} For controlling animation speed
   * @see {@link Ticker} For timing system details
   */ update(ticker) {
        if (!this._playing) return;
        const deltaTime = ticker.deltaTime;
        const elapsed = this.animationSpeed * deltaTime;
        const previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1e3;
            while(lag < 0){
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            const sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while(lag >= this._durations[this.currentFrame]){
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) this.onComplete();
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) this.onComplete();
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame || this.animationSpeed < 0 && this.currentFrame > previousFrame) this.onLoop();
            }
            this._updateTexture();
        }
    }
    /** Updates the displayed texture to match the current frame index. */ _updateTexture() {
        const currentFrame = this.currentFrame;
        if (this._previousFrame === currentFrame) return;
        this._previousFrame = currentFrame;
        this.texture = this._textures[currentFrame];
        if (this.updateAnchor && this.texture.defaultAnchor) this.anchor.copyFrom(this.texture.defaultAnchor);
        if (this.onFrameChange) this.onFrameChange(this.currentFrame);
    }
    /**
   * Stops the AnimatedSprite and destroys it.
   * @example
   * ```ts
   * // Destroy the sprite when done
   * sprite.destroy();
   * ```
   */ destroy() {
        this.stop();
        super.destroy();
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of frame ids.
   * Uses texture frames from the cache to create an animation sequence.
   * @example
   * ```ts
   * // Create from frame IDs
   * const frameIds = [
   *     'walk_001.png',
   *     'walk_002.png',
   *     'walk_003.png'
   * ];
   *
   * const walkingAnimation = AnimatedSprite.fromFrames(frameIds);
   * walkingAnimation.play();
   * ```
   * @param frames - The array of frame ids to use for the animation
   * @returns A new animated sprite using the frames
   * @see {@link Texture.from} For texture creation from frames
   * @see {@link Spritesheet} For loading spritesheets
   */ static fromFrames(frames) {
        const textures = [];
        for(let i = 0; i < frames.length; ++i)textures.push((0, $bLlTJ.Texture).from(frames[i]));
        return new $84361de765a4dfd8$export$dae599798687ad3c(textures);
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of image urls.
   * Each image will be used as a frame in the animation.
   * @example
   * ```ts
   * // Create from image URLs
   * const images = [
   *     'assets/walk1.png',
   *     'assets/walk2.png',
   *     'assets/walk3.png'
   * ];
   *
   * const walkingSprite = AnimatedSprite.fromImages(images);
   * walkingSprite.play();
   * ```
   * @param images - The array of image urls to use as frames
   * @returns A new animated sprite using the images as frames
   * @see {@link Assets} For asset loading and management
   * @see {@link Texture.from} For texture creation from images
   */ static fromImages(images) {
        const textures = [];
        for(let i = 0; i < images.length; ++i)textures.push((0, $bLlTJ.Texture).from(images[i]));
        return new $84361de765a4dfd8$export$dae599798687ad3c(textures);
    }
    /**
   * The total number of frames in the AnimatedSprite. This is the same as number of textures
   * assigned to the AnimatedSprite.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('frame1.png'),
   *         Texture.from('frame2.png'),
   *         Texture.from('frame3.png')
   *     ]
   * });
   *
   * // Get total frames
   * console.log(sprite.totalFrames); // Outputs: 3
   *
   * // Use with frame navigation
   * sprite.gotoAndStop(sprite.totalFrames - 1); // Go to last frame
   * ```
   * @readonly
   * @see {@link AnimatedSprite#currentFrame} For the current frame index
   * @see {@link AnimatedSprite#textures} For the array of textures
   * @returns {number} The total number of frames
   */ get totalFrames() {
        return this._textures.length;
    }
    /**
   * The array of textures or frame objects used for the animation sequence.
   * Can be set to either an array of Textures or an array of FrameObjects with custom timing.
   * @example
   * ```ts
   * // Update textures at runtime
   * sprite.textures = [
   *     Texture.from('run1.png'),
   *     Texture.from('run2.png')
   * ];
   *
   * // Use custom frame timing
   * sprite.textures = [
   *     { texture: Texture.from('explosion1.png'), time: 100 },
   *     { texture: Texture.from('explosion2.png'), time: 200 },
   *     { texture: Texture.from('explosion3.png'), time: 300 }
   * ];
   *
   * // Use with spritesheet
   * const sheet = await Assets.load('animations.json');
   * sprite.textures = sheet.animations['walk'];
   * ```
   * @type {AnimatedSpriteFrames}
   * @see {@link FrameObject} For frame timing options
   * @see {@link Spritesheet} For loading from spritesheets
   */ get textures() {
        return this._textures;
    }
    set textures(value) {
        if (value[0] instanceof (0, $bLlTJ.Texture)) {
            this._textures = value;
            this._durations = null;
        } else {
            this._textures = [];
            this._durations = [];
            for(let i = 0; i < value.length; i++){
                this._textures.push(value[i].texture);
                this._durations.push(value[i].time);
            }
        }
        this._previousFrame = null;
        this.gotoAndStop(0);
        this._updateTexture();
    }
    /**
   * Gets or sets the current frame index of the animation.
   * When setting, the value will be clamped between 0 and totalFrames - 1.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *         Texture.from('walk3.png')
   *     ]
   * });
   *
   * // Get current frame
   * console.log(sprite.currentFrame); // 0
   *
   * // Set specific frame
   * sprite.currentFrame = 1; // Show second frame
   *
   * // Use with frame callbacks
   * sprite.onFrameChange = (frame) => {
   *     console.log(`Now showing frame: ${frame}`);
   * };
   * sprite.currentFrame = 2;
   * ```
   * @throws {Error} If attempting to set a frame index out of bounds
   * @see {@link AnimatedSprite#totalFrames} For the total number of frames
   * @see {@link AnimatedSprite#gotoAndPlay} For playing from a specific frame
   * @see {@link AnimatedSprite#gotoAndStop} For stopping at a specific frame
   */ get currentFrame() {
        let currentFrame = Math.floor(this._currentTime) % this._textures.length;
        if (currentFrame < 0) currentFrame += this._textures.length;
        return currentFrame;
    }
    set currentFrame(value) {
        if (value < 0 || value > this.totalFrames - 1) throw new Error(`[AnimatedSprite]: Invalid frame index value ${value}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
        const previousFrame = this.currentFrame;
        this._currentTime = value;
        if (previousFrame !== this.currentFrame) this._updateTexture();
    }
    /**
   * Indicates if the AnimatedSprite is currently playing.
   * This is a read-only property that reflects the current playback state.
   * @example
   * ```ts
   * // Check if animation is playing
   * console.log('Playing:', sprite.playing); // true
   *
   * // Use with play control
   * if (!sprite.playing) {
   *     sprite.play();
   * }
   * ```
   * @readonly
   * @returns {boolean} True if the animation is currently playing
   * @see {@link AnimatedSprite#play} For starting playback
   * @see {@link AnimatedSprite#stop} For stopping playback
   * @see {@link AnimatedSprite#loop} For controlling looping behavior
   */ get playing() {
        return this._playing;
    }
    /**
   * Controls whether the animation automatically updates using the shared ticker.
   * When enabled, the animation will update on each frame. When disabled, you must
   * manually call update() to advance the animation.
   * @example
   * ```ts
   * // Create sprite with auto-update disabled
   * const sprite = new AnimatedSprite({
   *     textures: [],
   *     autoUpdate: false
   * });
   *
   * // Manual update with app ticker
   * app.ticker.add((ticker) => {
   *     sprite.update(ticker);
   * });
   *
   * // Enable auto-update later
   * sprite.autoUpdate = true;
   * ```
   * @default true
   * @see {@link AnimatedSprite#update} For manual animation updates
   * @see {@link Ticker} For the timing system
   */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            if (!this._autoUpdate && this._isConnectedToTicker) {
                (0, $4J7WL.Ticker).shared.remove(this.update, this);
                this._isConnectedToTicker = false;
            } else if (this._autoUpdate && !this._isConnectedToTicker && this._playing) {
                (0, $4J7WL.Ticker).shared.add(this.update, this);
                this._isConnectedToTicker = true;
            }
        }
    }
}

});

parcelRegister("7EPSr", function(module, exports) {

$parcel$export(module.exports, "TilingSprite", () => $0b2b3e92e9228a58$export$db8370cd1ebcc819);

var $2IhKp = parcelRequire("2IhKp");

var $a32F4 = parcelRequire("a32F4");

var $bLlTJ = parcelRequire("bLlTJ");

var $kXq8E = parcelRequire("kXq8E");

var $hUCK4 = parcelRequire("hUCK4");

var $9lqkG = parcelRequire("9lqkG");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
const $0b2b3e92e9228a58$var$_TilingSprite = class _TilingSprite extends (0, $b9FQU.ViewContainer) {
    constructor(...args){
        let options = args[0] || {};
        if (options instanceof (0, $bLlTJ.Texture)) options = {
            texture: options
        };
        if (args.length > 1) {
            (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "use new TilingSprite({ texture, width:100, height:100 }) instead");
            options.width = args[1];
            options.height = args[2];
        }
        options = {
            ..._TilingSprite.defaultOptions,
            ...options
        };
        const { texture: texture, anchor: anchor, tilePosition: tilePosition, tileScale: tileScale, tileRotation: tileRotation, width: width, height: height, applyAnchorToTexture: applyAnchorToTexture, roundPixels: roundPixels, ...rest } = options ?? {};
        super({
            label: "TilingSprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "tilingSprite";
        /** @advanced */ this.batched = true;
        this.allowChildren = false;
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        this.applyAnchorToTexture = applyAnchorToTexture;
        this.texture = texture;
        this._width = width ?? texture.width;
        this._height = height ?? texture.height;
        this._tileTransform = new (0, $9lqkG.Transform)({
            observer: {
                _onUpdate: ()=>this.onViewUpdate()
            }
        });
        if (anchor) this.anchor = anchor;
        this.tilePosition = tilePosition;
        this.tileScale = tileScale;
        this.tileRotation = tileRotation;
        this.roundPixels = roundPixels ?? false;
    }
    /**
   * Creates a new tiling sprite based on a source texture or image path.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create a new tiling sprite from an image path
   * const pattern = TilingSprite.from('pattern.png');
   * pattern.width = 300; // Set the width of the tiling area
   * pattern.height = 200; // Set the height of the tiling area
   *
   * // Create from options
   * const texture = Texture.from('pattern.png');
   * const pattern = TilingSprite.from(texture, {
   *     width: 300,
   *     height: 200,
   *     tileScale: { x: 0.5, y: 0.5 }
   * });
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image or a texture
   * @param options - Additional options for the tiling sprite
   * @returns A new tiling sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */ static from(source, options = {}) {
        if (typeof source === "string") return new _TilingSprite({
            texture: (0, $2IhKp.Cache).get(source),
            ...options
        });
        return new _TilingSprite({
            texture: source,
            ...options
        });
    }
    /**
   * @see {@link TilingSpriteOptions.applyAnchorToTexture}
   * @deprecated since 8.0.0
   * @advanced
   */ get uvRespectAnchor() {
        (0, $hUCK4.warn)("uvRespectAnchor is deprecated, please use applyAnchorToTexture instead");
        return this.applyAnchorToTexture;
    }
    /** @advanced */ set uvRespectAnchor(value) {
        (0, $hUCK4.warn)("uvRespectAnchor is deprecated, please use applyAnchorToTexture instead");
        this.applyAnchorToTexture = value;
    }
    /**
   * Changes frame clamping in corresponding textureMatrix
   * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
   * @default 0.5
   * @type {number}
   * @advanced
   */ get clampMargin() {
        return this._texture.textureMatrix.clampMargin;
    }
    /** @advanced */ set clampMargin(value) {
        this._texture.textureMatrix.clampMargin = value;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The offset of the tiling texture.
   * Used to scroll or position the repeated pattern.
   * @example
   * ```ts
   * // Offset the tiling pattern by 100 pixels in both x and y directions
   * tilingSprite.tilePosition = { x: 100, y: 100 };
   * ```
   * @default {x: 0, y: 0}
   */ get tilePosition() {
        return this._tileTransform.position;
    }
    set tilePosition(value) {
        this._tileTransform.position.copyFrom(value);
    }
    /**
   * Scale of the tiling texture.
   * Affects the size of each repeated instance of the texture.
   * @example
   * ```ts
   * // Scale the texture by 1.5 in both x and y directions
   * tilingSprite.tileScale = { x: 1.5, y: 1.5 };
   * ```
   * @default {x: 1, y: 1}
   */ get tileScale() {
        return this._tileTransform.scale;
    }
    set tileScale(value) {
        typeof value === "number" ? this._tileTransform.scale.set(value) : this._tileTransform.scale.copyFrom(value);
    }
    set tileRotation(value) {
        this._tileTransform.rotation = value;
    }
    /**
   * Rotation of the tiling texture in radians.
   * This controls the rotation applied to the texture before tiling.
   * @example
   * ```ts
   * // Rotate the texture by 45 degrees (in radians)
   * tilingSprite.tileRotation = Math.PI / 4; // 45 degrees
   * ```
   * @default 0
   */ get tileRotation() {
        return this._tileTransform.rotation;
    }
    /**
   * The transform object that controls the tiling texture's position, scale, and rotation.
   * This transform is independent of the sprite's own transform properties.
   * @example
   * ```ts
   * // Access transform properties directly
   * sprite.tileTransform.position.set(100, 50);
   * sprite.tileTransform.scale.set(2);
   * sprite.tileTransform.rotation = Math.PI / 4;
   *
   * // Create smooth scrolling animation
   * app.ticker.add(() => {
   *     sprite.tileTransform.position.x += 1;
   *     sprite.tileTransform.rotation += 0.01;
   * });
   *
   * // Reset transform
   * sprite.tileTransform.position.set(0);
   * sprite.tileTransform.scale.set(1);
   * sprite.tileTransform.rotation = 0;
   * ```
   * @returns {Transform} The transform object for the tiling texture
   * @see {@link Transform} For transform operations
   * @see {@link TilingSprite#tilePosition} For position control
   * @see {@link TilingSprite#tileScale} For scale control
   * @see {@link TilingSprite#tileRotation} For rotation control
   * @advanced
   */ get tileTransform() {
        return this._tileTransform;
    }
    set texture(value) {
        value || (value = (0, $bLlTJ.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        this.onViewUpdate();
    }
    /**
   * The texture to use for tiling.
   * This is the image that will be repeated across the sprite.
   * @example
   * ```ts
   * // Use a texture from the asset cache
   * tilingSprite.texture = Texture.from('assets/pattern.png');
   * ```
   * @default Texture.WHITE
   */ get texture() {
        return this._texture;
    }
    /**
   * The width of the tiling area. This defines how wide the area is that the texture will be tiled across.
   * @example
   * ```ts
   * // Create a tiling sprite
   * const sprite = new TilingSprite({
   *     texture: Texture.from('pattern.png'),
   *     width: 500,
   *     height: 300
   * });
   *
   * // Adjust width dynamically
   * sprite.width = 800; // Expands tiling area
   *
   * // Update on resize
   * window.addEventListener('resize', () => {
   *     sprite.width = app.screen.width;
   * });
   * ```
   * @see {@link TilingSprite#setSize} For setting both width and height efficiently
   * @see {@link TilingSprite#height} For setting height
   */ set width(value) {
        this._width = value;
        this.onViewUpdate();
    }
    get width() {
        return this._width;
    }
    set height(value) {
        this._height = value;
        this.onViewUpdate();
    }
    /**
   * The height of the tiling area. This defines how tall the area is that the texture will be tiled across.
   * @example
   * ```ts
   * // Create a tiling sprite
   * const sprite = new TilingSprite({
   *     texture: Texture.from('pattern.png'),
   *     width: 500,
   *     height: 300
   * });
   *
   * // Adjust width dynamically
   * sprite.height = 800; // Expands tiling area
   *
   * // Update on resize
   * window.addEventListener('resize', () => {
   *     sprite.height = app.screen.height;
   * });
   * ```
   * @see {@link TilingSprite#setSize} For setting both width and height efficiently
   * @see {@link TilingSprite#width} For setting width
   */ get height() {
        return this._height;
    }
    /**
   * Sets the size of the TilingSprite to the specified width and height.
   * This is faster than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set specific dimensions
   * sprite.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size (square)
   * sprite.setSize(400); // Width: 400, Height: 400
   *
   * // Set size using object
   * sprite.setSize({
   *     width: 500,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number for uniform sizing or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link TilingSprite#width} For setting width only
   * @see {@link TilingSprite#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        }
        this._width = value;
        this._height = height ?? value;
        this.onViewUpdate();
    }
    /**
   * Retrieves the size of the TilingSprite as a {@link Size} object.
   * This method is more efficient than getting width and height separately as it only allocates one object.
   * @example
   * ```ts
   * // Get basic size
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the TilingSprite
   * @see {@link TilingSprite#width} For getting just the width
   * @see {@link TilingSprite#height} For getting just the height
   * @see {@link TilingSprite#setSize} For setting both width and height efficiently
   */ getSize(out) {
        out || (out = {});
        out.width = this._width;
        out.height = this._height;
        return out;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const width = this._width;
        const height = this._height;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Takes into account the anchor offset when determining boundaries.
   * @example
   * ```ts
   * // Create a tiling sprite
   * const sprite = new TilingSprite({
   *     texture: Texture.from('pattern.png'),
   *     width: 200,
   *     height: 100,
   *     anchor: 0.5 // Center anchor
   * });
   *
   * // Basic point check
   * const contains = sprite.containsPoint({ x: 50, y: 25 });
   * console.log('Point is inside:', contains);
   *
   * // Check with different anchors
   * sprite.anchor.set(0); // Top-left anchor
   * console.log('Contains point:', sprite.containsPoint({ x: 150, y: 75 }));
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the sprite's bounds
   * @see {@link TilingSprite#toLocal} For converting global coordinates to local
   * @see {@link TilingSprite#anchor} For understanding boundary calculations
   */ containsPoint(point) {
        const width = this._width;
        const height = this._height;
        const x1 = -width * this._anchor._x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this._anchor._y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * tilingSprite.destroy();
   * tilingSprite.destroy(true);
   * tilingSprite.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        super.destroy(options);
        this._anchor = null;
        this._tileTransform = null;
        this._bounds = null;
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
    }
};
/**
 * Default options used when creating a TilingSprite instance.
 * These values are used as fallbacks when specific options are not provided.
 * @example
 * ```ts
 * // Override default options globally
 * TilingSprite.defaultOptions.texture = Texture.from('defaultPattern.png');
 * TilingSprite.defaultOptions.tileScale = { x: 2, y: 2 };
 *
 * // Create sprite using default options
 * const sprite = new TilingSprite();
 * // Will use defaultPattern.png and scale 2x
 * ```
 * @type {TilingSpriteOptions}
 * @see {@link TilingSpriteOptions} For all available options
 * @see {@link TilingSprite.from} For creating sprites with custom options
 * @see {@link Texture.EMPTY} For the default empty texture
 */ $0b2b3e92e9228a58$var$_TilingSprite.defaultOptions = {
    /** The texture to use for the sprite. */ texture: (0, $bLlTJ.Texture).EMPTY,
    /** The anchor point of the sprite */ anchor: {
        x: 0,
        y: 0
    },
    /** The offset of the image that is being tiled. */ tilePosition: {
        x: 0,
        y: 0
    },
    /** Scaling of the image that is being tiled. */ tileScale: {
        x: 1,
        y: 1
    },
    /** The rotation of the image that is being tiled. */ tileRotation: 0,
    /**
   * Flags whether the tiling pattern should originate from the origin instead of the top-left corner in
   * local space.
   *
   * This will make the texture coordinates assigned to each vertex dependent on the value of the anchor. Without
   * this, the top-left corner always gets the (0, 0) texture coordinate.
   * @default false
   */ applyAnchorToTexture: false
};
let $0b2b3e92e9228a58$export$db8370cd1ebcc819 = $0b2b3e92e9228a58$var$_TilingSprite;

});
parcelRegister("9lqkG", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $9c1f5ada102ff062$export$563a914cafbdc389);

var $eY4rt = parcelRequire("eY4rt");

var $a32F4 = parcelRequire("a32F4");
"use strict";
class $9c1f5ada102ff062$export$563a914cafbdc389 {
    /**
   * @param options - Options for the transform.
   * @param options.matrix - The matrix to use.
   * @param options.observer - The observer to use.
   */ constructor({ matrix: matrix, observer: observer } = {}){
        this.dirty = true;
        this._matrix = matrix ?? new (0, $eY4rt.Matrix)();
        this.observer = observer;
        this.position = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        this.scale = new (0, $a32F4.ObservablePoint)(this, 1, 1);
        this.pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        this.skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        this._rotation = 0;
        this._cx = 1;
        this._sx = 0;
        this._cy = 0;
        this._sy = 1;
    }
    /**
   * The transformation matrix computed from the transform's properties.
   * Combines position, scale, rotation, skew, and pivot into a single matrix.
   * @example
   * ```ts
   * // Get current matrix
   * const matrix = transform.matrix;
   * console.log(matrix.toString());
   * ```
   * @readonly
   * @see {@link Matrix} For matrix operations
   * @see {@link Transform.setFromMatrix} For setting transform from matrix
   */ get matrix() {
        const lt = this._matrix;
        if (!this.dirty) return lt;
        lt.a = this._cx * this.scale.x;
        lt.b = this._sx * this.scale.x;
        lt.c = this._cy * this.scale.y;
        lt.d = this._sy * this.scale.y;
        lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
        lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
        this.dirty = false;
        return lt;
    }
    /**
   * Called when a value changes.
   * @param point
   * @internal
   */ _onUpdate(point) {
        this.dirty = true;
        if (point === this.skew) this.updateSkew();
        this.observer?._onUpdate(this);
    }
    /** Called when the skew or the rotation changes. */ updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew.y);
        this._sx = Math.sin(this._rotation + this.skew.y);
        this._cy = -Math.sin(this._rotation - this.skew.x);
        this._sy = Math.cos(this._rotation - this.skew.x);
        this.dirty = true;
    }
    toString() {
        return `[pixi.js/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
    }
    /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @example
   * ```ts
   * // Basic matrix decomposition
   * const transform = new Transform();
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * transform.setFromMatrix(matrix);
   * console.log(transform.position.x); // 100
   * console.log(transform.rotation); // ~0.785 (π/4)
   * ```
   * @param matrix - The matrix to decompose
   * @see {@link Matrix#decompose} For the decomposition logic
   * @see {@link Transform#matrix} For getting the current matrix
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
        this.dirty = true;
    }
    /**
   * The rotation of the object in radians.
   * @example
   * ```ts
   * // Basic rotation
   * transform.rotation = Math.PI / 4; // 45 degrees
   *
   * // Rotate around pivot point
   * transform.pivot.set(50, 50);
   * transform.rotation = Math.PI; // 180 degrees around pivot
   *
   * // Animate rotation
   * app.ticker.add(() => {
   *     transform.rotation += 0.1;
   * });
   * ```
   * @see {@link Transform#pivot} For rotation point
   * @see {@link Transform#skew} For skew effects
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this.skew);
        }
    }
}

});


parcelRegister("a32IU", function(module, exports) {

$parcel$export(module.exports, "BitmapText", () => $9f552024a4b3e098$export$ae0da96467efdba0);

var $hUCK4 = parcelRequire("hUCK4");

var $j9OVc = parcelRequire("j9OVc");

var $eKNW7 = parcelRequire("eKNW7");

var $axl5b = parcelRequire("axl5b");
"use strict";
class $9f552024a4b3e098$export$ae0da96467efdba0 extends (0, $j9OVc.AbstractText) {
    constructor(...args){
        var _a;
        const options = (0, $j9OVc.ensureTextOptions)(args, "BitmapText");
        options.style ?? (options.style = options.style || {});
        (_a = options.style).fill ?? (_a.fill = 16777215);
        super(options, (0, $eKNW7.TextStyle));
        /** @internal */ this.renderPipeId = "bitmapText";
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const bitmapMeasurement = (0, $axl5b.BitmapFontManager).measureText(this.text, this._style);
        const scale = bitmapMeasurement.scale;
        const offset = bitmapMeasurement.offsetY * scale;
        let width = bitmapMeasurement.width * scale;
        let height = bitmapMeasurement.height * scale;
        const stroke = this._style._stroke;
        if (stroke) {
            width += stroke.width;
            height += stroke.width;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * (height + offset);
        bounds.maxY = bounds.minY + height;
    }
    /**
   * The resolution / device pixel ratio for text rendering.
   * Unlike other text types, BitmapText resolution is managed by the BitmapFont.
   * Individual resolution changes are not supported.
   * @example
   * ```ts
   * // ❌ Incorrect: Setting resolution directly (will trigger warning)
   * const text = new BitmapText({
   *     text: 'Hello',
   *     resolution: 2 // This will be ignored
   * });
   *
   * // ✅ Correct: Set resolution when installing the font
   * BitmapFont.install({
   *     name: 'MyFont',
   *     style: {
   *         fontFamily: 'Arial',
   *     },
   *     resolution: 2 // Resolution is set here
   * });
   *
   * const text = new BitmapText({
   *     text: 'Hello',
   *     style: {
   *         fontFamily: 'MyFont' // Uses font's resolution
   *     }
   * });
   * ```
   * @default 1
   * @see {@link BitmapFont.install} For setting font resolution
   * @throws {Warning} When attempting to change resolution directly
   * @readonly
   */ set resolution(value) {
        if (value !== null) (0, $hUCK4.warn)(// eslint-disable-next-line max-len
        "[BitmapText] dynamically updating the resolution is not supported. Resolution should be managed by the BitmapFont.");
    }
    get resolution() {
        return this._resolution;
    }
}

});
parcelRegister("j9OVc", function(module, exports) {

$parcel$export(module.exports, "AbstractText", () => $7e36113173fcb92e$export$daf74670712de91);
$parcel$export(module.exports, "ensureTextOptions", () => $7e36113173fcb92e$export$8ddfb4f614f8ed86);

var $a32F4 = parcelRequire("a32F4");

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
class $7e36113173fcb92e$export$daf74670712de91 extends (0, $b9FQU.ViewContainer) {
    constructor(options, styleClass){
        const { text: text, resolution: resolution, style: style, anchor: anchor, width: width, height: height, roundPixels: roundPixels, ...rest } = options;
        super({
            ...rest
        });
        /** @internal */ this.batched = true;
        /** @internal */ this._resolution = null;
        /** @internal */ this._autoResolution = true;
        /** @internal */ this._didTextUpdate = true;
        this._styleClass = styleClass;
        this.text = text ?? "";
        this.style = style;
        this.resolution = resolution ?? null;
        this.allowChildren = false;
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * The anchor point of the text that controls the origin point for positioning and rotation.
   * Can be a number (same value for x/y) or a PointData object.
   * - (0,0) is top-left
   * - (0.5,0.5) is center
   * - (1,1) is bottom-right
   * ```ts
   * // Set anchor to center
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: 0.5 // Same as { x: 0.5, y: 0.5 }
   * });
   * // Set anchor to top-left
   * const text2 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 0, y: 0 } // Top-left corner
   * });
   * // Set anchor to bottom-right
   * const text3 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 1, y: 1 } // Bottom-right corner
   * });
   * ```
   * @default { x: 0, y: 0 }
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new Text({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new Text({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new Text({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */ set text(value) {
        value = value.toString();
        if (this._text === value) return;
        this._text = value;
        this.onViewUpdate();
    }
    get text() {
        return this._text;
    }
    /**
   * The resolution/device pixel ratio for rendering.
   * Higher values result in sharper text at the cost of performance.
   * Set to null for auto-resolution based on device.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     resolution: 2 // High DPI for sharper text
   * });
   * const autoResText = new Text({
   *     text: 'Auto Resolution',
   *     resolution: null // Use device's pixel ratio
   * });
   * ```
   * @default null
   */ set resolution(value) {
        this._autoResolution = value === null;
        this._resolution = value;
        this.onViewUpdate();
    }
    get resolution() {
        return this._resolution;
    }
    get style() {
        return this._style;
    }
    /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * Supports canvas text styles, HTML text styles, and bitmap text styles.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * const htmlText = new HTMLText({
   *     text: 'HTML Styled Text',
   *     style: {
   *         fontSize: '20px',
   *         fill: 'blue',
   *         fontFamily: 'Verdana',
   *     }
   * });
   * const bitmapText = new BitmapText({
   *     text: 'Bitmap Styled Text',
   *     style: {
   *         fontName: 'Arial',
   *         fontSize: 32,
   *     }
   * })
   *
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */ set style(style) {
        style || (style = {});
        this._style?.off("update", this.onViewUpdate, this);
        if (style instanceof this._styleClass) this._style = style;
        else this._style = new this._styleClass(style);
        this._style.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * texture.width = 200;
   * console.log(texture.scale.x); // Scale adjusted to match width
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this.bounds.width;
    }
    set width(value) {
        this._setWidth(value, this.bounds.width);
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * texture.height = 200;
   * console.log(texture.scale.y); // Scale adjusted to match height
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this.bounds.height;
    }
    set height(value) {
        this._setHeight(value, this.bounds.height);
    }
    /**
   * Retrieves the size of the Text as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     style: { fontSize: 24 }
   * });
   * const size = text.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * text.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Text#width} For getting just the width
   * @see {@link Text#height} For getting just the height
   * @see {@link Text#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this.bounds.width;
        out.height = Math.abs(this.scale.y) * this.bounds.height;
        return out;
    }
    /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const text = new Text({
   *    text: 'Hello Pixi!',
   *    style: { fontSize: 24 }
   * });
   * text.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * text.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * text.setSize({
   *     width: 200,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Text#width} For setting width only
   * @see {@link Text#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this.bounds.width);
        height !== void 0 && this._setHeight(height, this.bounds.height);
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the text's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = text.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the text's bounds
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const width = this.bounds.width;
        const height = this.bounds.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this.anchor.y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /** @internal */ onViewUpdate() {
        if (!this.didViewUpdate) this._didTextUpdate = true;
        super.onViewUpdate();
    }
    /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroys the text and its style
   * text.destroy({ style: true, texture: true, textureSource: true });
   * text.destroy(true);
   * text.destroy() // Destroys the text, but not its style
   */ destroy(options = false) {
        super.destroy(options);
        this.owner = null;
        this._bounds = null;
        this._anchor = null;
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._text = null;
    }
}
function $7e36113173fcb92e$export$8ddfb4f614f8ed86(args, name) {
    let options = args[0] ?? {};
    if (typeof options === "string" || args[1]) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), `use new ${name}({ text: "hi!", style }) instead`);
        options = {
            text: options,
            style: args[1]
        };
    }
    return options;
}

});


parcelRegister("gc0ip", function(module, exports) {

$parcel$export(module.exports, "Text", () => $dd84afd4ef9f1e09$export$5f1af8db9871e1d6);

var $aFPUT = parcelRequire("aFPUT");

var $j9OVc = parcelRequire("j9OVc");

var $f9zuU = parcelRequire("f9zuU");

var $wLFHs = parcelRequire("wLFHs");

var $eKNW7 = parcelRequire("eKNW7");
"use strict";
class $dd84afd4ef9f1e09$export$5f1af8db9871e1d6 extends (0, $j9OVc.AbstractText) {
    constructor(...args){
        const options = (0, $j9OVc.ensureTextOptions)(args, "Text");
        super(options, (0, $eKNW7.TextStyle));
        /** @internal */ this.renderPipeId = "text";
        if (options.textureStyle) this.textureStyle = options.textureStyle instanceof (0, $aFPUT.TextureStyle) ? options.textureStyle : new (0, $aFPUT.TextureStyle)(options.textureStyle);
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        let width = 0;
        let height = 0;
        if (this._style.trim) {
            const { frame: frame, canvasAndContext: canvasAndContext } = (0, $f9zuU.CanvasTextGenerator).getCanvasAndContext({
                text: this.text,
                style: this._style,
                resolution: 1
            });
            (0, $f9zuU.CanvasTextGenerator).returnCanvasAndContext(canvasAndContext);
            width = frame.width;
            height = frame.height;
        } else {
            const canvasMeasurement = (0, $wLFHs.CanvasTextMetrics).measureText(this._text, this._style);
            width = canvasMeasurement.width;
            height = canvasMeasurement.height;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});


parcelRegister("1Dkiw", function(module, exports) {

$parcel$export(module.exports, "SpineTexture", () => $2bf0d855f974fd37$export$4b650a138b41f744);
parcelRequire("iuB9z");
var $bLlTJ = parcelRequire("bLlTJ");
parcelRequire("6DlDK");
var $8FokI = parcelRequire("8FokI");
var $66uC2 = parcelRequire("66uC2");
var $2bf0d855f974fd37$var$__defProp = Object.defineProperty;
var $2bf0d855f974fd37$var$__defNormalProp = (obj, key, value)=>key in obj ? $2bf0d855f974fd37$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2bf0d855f974fd37$var$__publicField = (obj, key, value)=>{
    $2bf0d855f974fd37$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $2bf0d855f974fd37$var$_SpineTexture = class _SpineTexture extends (0, $66uC2.Texture) {
    constructor(image){
        super(image.resource);
        $2bf0d855f974fd37$var$__publicField(this, "texture");
        this.texture = (0, $bLlTJ.Texture).from(image);
    }
    static from(texture) {
        if (_SpineTexture.textureMap.has(texture)) return _SpineTexture.textureMap.get(texture);
        return new _SpineTexture(texture);
    }
    setFilters(minFilter, magFilter) {
        const style = this.texture.source.style;
        style.minFilter = _SpineTexture.toPixiTextureFilter(minFilter);
        style.magFilter = _SpineTexture.toPixiTextureFilter(magFilter);
        this.texture.source.autoGenerateMipmaps = _SpineTexture.toPixiMipMap(minFilter);
        this.texture.source.updateMipmaps();
    }
    setWraps(uWrap, vWrap) {
        const style = this.texture.source.style;
        style.addressModeU = _SpineTexture.toPixiTextureWrap(uWrap);
        style.addressModeV = _SpineTexture.toPixiTextureWrap(vWrap);
    }
    dispose() {
        this.texture.destroy();
    }
    static toPixiMipMap(filter) {
        switch(filter){
            case (0, $66uC2.TextureFilter).Nearest:
            case (0, $66uC2.TextureFilter).Linear:
                return false;
            case (0, $66uC2.TextureFilter).MipMapNearestLinear:
            case (0, $66uC2.TextureFilter).MipMapNearestNearest:
            case (0, $66uC2.TextureFilter).MipMapLinearLinear:
            case (0, $66uC2.TextureFilter).MipMapLinearNearest:
                return true;
            default:
                throw new Error(`Unknown texture filter: ${String(filter)}`);
        }
    }
    static toPixiTextureFilter(filter) {
        switch(filter){
            case (0, $66uC2.TextureFilter).Nearest:
            case (0, $66uC2.TextureFilter).MipMapNearestLinear:
            case (0, $66uC2.TextureFilter).MipMapNearestNearest:
                return "nearest";
            case (0, $66uC2.TextureFilter).Linear:
            case (0, $66uC2.TextureFilter).MipMapLinearLinear:
            case (0, $66uC2.TextureFilter).MipMapLinearNearest:
                return "linear";
            default:
                throw new Error(`Unknown texture filter: ${String(filter)}`);
        }
    }
    static toPixiTextureWrap(wrap) {
        switch(wrap){
            case (0, $66uC2.TextureWrap).ClampToEdge:
                return "clamp-to-edge";
            case (0, $66uC2.TextureWrap).MirroredRepeat:
                return "mirror-repeat";
            case (0, $66uC2.TextureWrap).Repeat:
                return "repeat";
            default:
                throw new Error(`Unknown texture wrap: ${String(wrap)}`);
        }
    }
    static toPixiBlending(blend) {
        switch(blend){
            case (0, $8FokI.BlendMode).Normal:
                return "normal";
            case (0, $8FokI.BlendMode).Additive:
                return "add";
            case (0, $8FokI.BlendMode).Multiply:
                return "multiply";
            case (0, $8FokI.BlendMode).Screen:
                return "screen";
            default:
                throw new Error(`Unknown blendMode: ${String(blend)}`);
        }
    }
};
$2bf0d855f974fd37$var$__publicField($2bf0d855f974fd37$var$_SpineTexture, "textureMap", /* @__PURE__ */ new Map());
let $2bf0d855f974fd37$export$4b650a138b41f744 = $2bf0d855f974fd37$var$_SpineTexture;

});
parcelRegister("6DlDK", function(module, exports) {
$parcel$export(module.exports, "AnimationState", () => (parcelRequire("1RIMy")).AnimationState);
$parcel$export(module.exports, "AnimationStateData", () => (parcelRequire("1LYJi")).AnimationStateData);
$parcel$export(module.exports, "AtlasAttachmentLoader", () => (parcelRequire("2mGUN")).AtlasAttachmentLoader);
$parcel$export(module.exports, "Physics", () => (parcelRequire("5iLFL")).Physics);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("5iLFL")).Skeleton);
$parcel$export(module.exports, "SkeletonBinary", () => (parcelRequire("d34nV")).SkeletonBinary);
$parcel$export(module.exports, "SkeletonBounds", () => (parcelRequire("yE81C")).SkeletonBounds);
$parcel$export(module.exports, "SkeletonClipping", () => (parcelRequire("kvLvw")).SkeletonClipping);
$parcel$export(module.exports, "SkeletonData", () => (parcelRequire("d4Xjx")).SkeletonData);
$parcel$export(module.exports, "SkeletonJson", () => (parcelRequire("ePHEE")).SkeletonJson);
$parcel$export(module.exports, "BlendMode", () => (parcelRequire("8FokI")).BlendMode);
$parcel$export(module.exports, "Texture", () => (parcelRequire("66uC2")).Texture);
$parcel$export(module.exports, "TextureFilter", () => (parcelRequire("66uC2")).TextureFilter);
$parcel$export(module.exports, "TextureWrap", () => (parcelRequire("66uC2")).TextureWrap);
$parcel$export(module.exports, "TextureAtlas", () => (parcelRequire("cQp1s")).TextureAtlas);
$parcel$export(module.exports, "Color", () => (parcelRequire("1Yup6")).Color);
$parcel$export(module.exports, "Vector2", () => (parcelRequire("1Yup6")).Vector2);
$parcel$export(module.exports, "ClippingAttachment", () => (parcelRequire("hePJB")).ClippingAttachment);
$parcel$export(module.exports, "MeshAttachment", () => (parcelRequire("5ot6H")).MeshAttachment);
$parcel$export(module.exports, "PathAttachment", () => (parcelRequire("46qOI")).PathAttachment);
$parcel$export(module.exports, "RegionAttachment", () => (parcelRequire("8wKGy")).RegionAttachment);
parcelRequire("hevjK");
parcelRequire("1RIMy");
parcelRequire("1LYJi");
parcelRequire("2mGUN");
parcelRequire("5yGPE");
parcelRequire("1S7b2");
parcelRequire("dTqn7");
parcelRequire("kPy2S");
parcelRequire("2jWXd");
parcelRequire("gfyKS");
parcelRequire("kYVpx");
parcelRequire("2eT9h");
parcelRequire("dQ0tU");
parcelRequire("1Wvqv");
parcelRequire("5iLFL");
parcelRequire("d34nV");
parcelRequire("yE81C");
parcelRequire("kvLvw");
parcelRequire("d4Xjx");
parcelRequire("ePHEE");
parcelRequire("9UdTx");
parcelRequire("2OSyh");
parcelRequire("8FokI");
parcelRequire("66uC2");
parcelRequire("cQp1s");
parcelRequire("hpxEh");
parcelRequire("3jtmM");
parcelRequire("aaTAm");
parcelRequire("d5XqA");
parcelRequire("1Yup6");
parcelRequire("1Y2C7");
parcelRequire("5a4jk");
parcelRequire("lA4oi");
parcelRequire("6LxqM");
parcelRequire("hePJB");
parcelRequire("5ot6H");
parcelRequire("46qOI");
parcelRequire("hxr00");
parcelRequire("8wKGy");

});
parcelRegister("hevjK", function(module, exports) {

$parcel$export(module.exports, "Animation", () => $c8bc0977b55afb3a$export$c35d437ae5945fcd);
$parcel$export(module.exports, "MixBlend", () => $c8bc0977b55afb3a$export$ccab779a50275a35);
$parcel$export(module.exports, "MixDirection", () => $c8bc0977b55afb3a$export$52fc338c0bb328ba);
$parcel$export(module.exports, "Timeline", () => $c8bc0977b55afb3a$export$e6a97ba2cae5bb94);
$parcel$export(module.exports, "RotateTimeline", () => $c8bc0977b55afb3a$export$b7ecb8f68b3e130b);
$parcel$export(module.exports, "TranslateTimeline", () => $c8bc0977b55afb3a$export$eb93bf27829ae703);
$parcel$export(module.exports, "TranslateXTimeline", () => $c8bc0977b55afb3a$export$cf49491eb4394eca);
$parcel$export(module.exports, "TranslateYTimeline", () => $c8bc0977b55afb3a$export$6540b7ba297d3e41);
$parcel$export(module.exports, "ScaleTimeline", () => $c8bc0977b55afb3a$export$be544e22f6ad7737);
$parcel$export(module.exports, "ScaleXTimeline", () => $c8bc0977b55afb3a$export$407a9cf4df59ebda);
$parcel$export(module.exports, "ScaleYTimeline", () => $c8bc0977b55afb3a$export$cc13ceba88ef3794);
$parcel$export(module.exports, "ShearTimeline", () => $c8bc0977b55afb3a$export$4da82436a1a0d773);
$parcel$export(module.exports, "ShearXTimeline", () => $c8bc0977b55afb3a$export$2392b1c4c21acaf8);
$parcel$export(module.exports, "ShearYTimeline", () => $c8bc0977b55afb3a$export$f65148e1d95352fd);
$parcel$export(module.exports, "InheritTimeline", () => $c8bc0977b55afb3a$export$7582beb1c1258b21);
$parcel$export(module.exports, "RGBATimeline", () => $c8bc0977b55afb3a$export$84cf3a3e225bcbdc);
$parcel$export(module.exports, "RGBTimeline", () => $c8bc0977b55afb3a$export$e179fb669ddccfa9);
$parcel$export(module.exports, "AlphaTimeline", () => $c8bc0977b55afb3a$export$2211be7c5ccde97b);
$parcel$export(module.exports, "RGBA2Timeline", () => $c8bc0977b55afb3a$export$6fc6620d97c53689);
$parcel$export(module.exports, "RGB2Timeline", () => $c8bc0977b55afb3a$export$a12960afd309a230);
$parcel$export(module.exports, "AttachmentTimeline", () => $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d);
$parcel$export(module.exports, "DeformTimeline", () => $c8bc0977b55afb3a$export$6968d40e5689ad6b);
$parcel$export(module.exports, "EventTimeline", () => $c8bc0977b55afb3a$export$4f4bca996c586084);
$parcel$export(module.exports, "DrawOrderTimeline", () => $c8bc0977b55afb3a$export$ece1f7c41d051e83);
$parcel$export(module.exports, "IkConstraintTimeline", () => $c8bc0977b55afb3a$export$73d125cd89dead44);
$parcel$export(module.exports, "TransformConstraintTimeline", () => $c8bc0977b55afb3a$export$a7a393c2ad815ac7);
$parcel$export(module.exports, "PathConstraintPositionTimeline", () => $c8bc0977b55afb3a$export$7ce7e67fd9cc52ed);
$parcel$export(module.exports, "PathConstraintSpacingTimeline", () => $c8bc0977b55afb3a$export$17ee50c08a07e62b);
$parcel$export(module.exports, "PathConstraintMixTimeline", () => $c8bc0977b55afb3a$export$ea67b41755485038);
$parcel$export(module.exports, "PhysicsConstraintInertiaTimeline", () => $c8bc0977b55afb3a$export$8d7d2ed36692a76a);
$parcel$export(module.exports, "PhysicsConstraintStrengthTimeline", () => $c8bc0977b55afb3a$export$92ee7da35e84339e);
$parcel$export(module.exports, "PhysicsConstraintDampingTimeline", () => $c8bc0977b55afb3a$export$cd77a164f9089126);
$parcel$export(module.exports, "PhysicsConstraintMassTimeline", () => $c8bc0977b55afb3a$export$cc37bc88e0605a66);
$parcel$export(module.exports, "PhysicsConstraintWindTimeline", () => $c8bc0977b55afb3a$export$3e123ca078024d61);
$parcel$export(module.exports, "PhysicsConstraintGravityTimeline", () => $c8bc0977b55afb3a$export$f321d2d075d42a88);
$parcel$export(module.exports, "PhysicsConstraintMixTimeline", () => $c8bc0977b55afb3a$export$e3ce1f2c0b6ae580);
$parcel$export(module.exports, "PhysicsConstraintResetTimeline", () => $c8bc0977b55afb3a$export$956f20308bfd17e0);
$parcel$export(module.exports, "SequenceTimeline", () => $c8bc0977b55afb3a$export$2687f324e8496672);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $5a4jk = parcelRequire("5a4jk");

var $1Yup6 = parcelRequire("1Yup6");

var $2nRvY = parcelRequire("2nRvY");
class $c8bc0977b55afb3a$export$c35d437ae5945fcd {
    /** The animation's name, which is unique across all animations in the skeleton. */ name;
    timelines = [];
    timelineIds = new (0, $1Yup6.StringSet)();
    /** The duration of the animation in seconds, which is the highest time of all keys in the timeline. */ duration;
    constructor(name, timelines, duration){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
        this.setTimelines(timelines);
        this.duration = duration;
    }
    setTimelines(timelines) {
        if (!timelines) throw new Error("timelines cannot be null.");
        this.timelines = timelines;
        this.timelineIds.clear();
        for(var i = 0; i < timelines.length; i++)this.timelineIds.addAll(timelines[i].getPropertyIds());
    }
    hasTimeline(ids) {
        for(let i = 0; i < ids.length; i++)if (this.timelineIds.contains(ids[i])) return true;
        return false;
    }
    /** Applies all the animation's timelines to the specified skeleton.
     *
     * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}.
     * @param loop If true, the animation repeats after {@link #getDuration()}.
     * @param events May be null to ignore fired events. */ apply(skeleton, lastTime, time, loop, events, alpha, blend, direction) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (loop && this.duration != 0) {
            time %= this.duration;
            if (lastTime > 0) lastTime %= this.duration;
        }
        let timelines = this.timelines;
        for(let i = 0, n = timelines.length; i < n; i++)timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
    }
}
var $c8bc0977b55afb3a$export$ccab779a50275a35;
(function(MixBlend) {
    /** Transitions from the setup value to the timeline value (the current value is not used). Before the first key, the setup
     * value is set. */ MixBlend[MixBlend["setup"] = 0] = "setup";
    /** Transitions from the current value to the timeline value. Before the first key, transitions from the current value to
     * the setup value. Timelines which perform instant transitions, such as {@link DrawOrderTimeline} or
     * {@link AttachmentTimeline}, use the setup value before the first key.
     *
     * `first` is intended for the first animations applied, not for animations layered on top of those. */ MixBlend[MixBlend["first"] = 1] = "first";
    /** Transitions from the current value to the timeline value. No change is made before the first key (the current value is
     * kept until the first key).
     *
     * `replace` is intended for animations layered on top of others, not for the first animations applied. */ MixBlend[MixBlend["replace"] = 2] = "replace";
    /** Transitions from the current value to the current value plus the timeline value. No change is made before the first key
     * (the current value is kept until the first key).
     *
     * `add` is intended for animations layered on top of others, not for the first animations applied. Properties
     * keyed by additive animations must be set manually or by another animation before applying the additive animations, else
     * the property values will increase continually. */ MixBlend[MixBlend["add"] = 3] = "add";
})($c8bc0977b55afb3a$export$ccab779a50275a35 || ($c8bc0977b55afb3a$export$ccab779a50275a35 = {}));
var $c8bc0977b55afb3a$export$52fc338c0bb328ba;
(function(MixDirection) {
    MixDirection[MixDirection["mixIn"] = 0] = "mixIn";
    MixDirection[MixDirection["mixOut"] = 1] = "mixOut";
})($c8bc0977b55afb3a$export$52fc338c0bb328ba || ($c8bc0977b55afb3a$export$52fc338c0bb328ba = {}));
const $c8bc0977b55afb3a$var$Property = {
    rotate: 0,
    x: 1,
    y: 2,
    scaleX: 3,
    scaleY: 4,
    shearX: 5,
    shearY: 6,
    inherit: 7,
    rgb: 8,
    alpha: 9,
    rgb2: 10,
    attachment: 11,
    deform: 12,
    event: 13,
    drawOrder: 14,
    ikConstraint: 15,
    transformConstraint: 16,
    pathConstraintPosition: 17,
    pathConstraintSpacing: 18,
    pathConstraintMix: 19,
    physicsConstraintInertia: 20,
    physicsConstraintStrength: 21,
    physicsConstraintDamping: 22,
    physicsConstraintMass: 23,
    physicsConstraintWind: 24,
    physicsConstraintGravity: 25,
    physicsConstraintMix: 26,
    physicsConstraintReset: 27,
    sequence: 28
};
class $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    propertyIds;
    frames;
    constructor(frameCount, propertyIds){
        this.propertyIds = propertyIds;
        this.frames = (0, $1Yup6.Utils).newFloatArray(frameCount * this.getFrameEntries());
    }
    getPropertyIds() {
        return this.propertyIds;
    }
    getFrameEntries() {
        return 1;
    }
    getFrameCount() {
        return this.frames.length / this.getFrameEntries();
    }
    getDuration() {
        return this.frames[this.frames.length - this.getFrameEntries()];
    }
    static search1(frames, time) {
        let n = frames.length;
        for(let i = 1; i < n; i++)if (frames[i] > time) return i - 1;
        return n - 1;
    }
    static search(frames, time, step) {
        let n = frames.length;
        for(let i = step; i < n; i += step)if (frames[i] > time) return i - step;
        return n - step;
    }
}
class $c8bc0977b55afb3a$export$4094e7414845f78f extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    curves;
    constructor(frameCount, bezierCount, propertyIds){
        super(frameCount, propertyIds);
        this.curves = (0, $1Yup6.Utils).newFloatArray(frameCount + bezierCount * 18 /*BEZIER_SIZE*/ );
        this.curves[frameCount - 1] = 1 /*STEPPED*/ ;
    }
    /** Sets the specified key frame to linear interpolation. */ setLinear(frame) {
        this.curves[frame] = 0 /*LINEAR*/ ;
    }
    /** Sets the specified key frame to stepped interpolation. */ setStepped(frame) {
        this.curves[frame] = 1 /*STEPPED*/ ;
    }
    /** Shrinks the storage for Bezier curves, for use when <code>bezierCount</code> (specified in the constructor) was larger
     * than the actual number of Bezier curves. */ shrink(bezierCount) {
        let size = this.getFrameCount() + bezierCount * 18 /*BEZIER_SIZE*/ ;
        if (this.curves.length > size) {
            let newCurves = (0, $1Yup6.Utils).newFloatArray(size);
            (0, $1Yup6.Utils).arrayCopy(this.curves, 0, newCurves, 0, size);
            this.curves = newCurves;
        }
    }
    /** Stores the segments for the specified Bezier curve. For timelines that modify multiple values, there may be more than
     * one curve per frame.
     * @param bezier The ordinal of this Bezier curve for this timeline, between 0 and <code>bezierCount - 1</code> (specified
     *           in the constructor), inclusive.
     * @param frame Between 0 and <code>frameCount - 1</code>, inclusive.
     * @param value The index of the value for this frame that this curve is used for.
     * @param time1 The time for the first key.
     * @param value1 The value for the first key.
     * @param cx1 The time for the first Bezier handle.
     * @param cy1 The value for the first Bezier handle.
     * @param cx2 The time of the second Bezier handle.
     * @param cy2 The value for the second Bezier handle.
     * @param time2 The time for the second key.
     * @param value2 The value for the second key. */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        let curves = this.curves;
        let i = this.getFrameCount() + bezier * 18 /*BEZIER_SIZE*/ ;
        if (value == 0) curves[frame] = 2 /*BEZIER*/  + i;
        let tmpx = (time1 - cx1 * 2 + cx2) * 0.03, tmpy = (value1 - cy1 * 2 + cy2) * 0.03;
        let dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006, dddy = ((cy1 - cy2) * 3 - value1 + value2) * 0.006;
        let ddx = tmpx * 2 + dddx, ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667, dy = (cy1 - value1) * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx, y = value1 + dy;
        for(let n = i + 18 /*BEZIER_SIZE*/ ; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    /** Returns the Bezier interpolated value for the specified time.
     * @param frameIndex The index into {@link #getFrames()} for the values of the frame before <code>time</code>.
     * @param valueOffset The offset from <code>frameIndex</code> to the value this curve is used for.
     * @param i The index of the Bezier segments. See {@link #getCurveType(int)}. */ getBezierValue(time, frameIndex, valueOffset, i) {
        let curves = this.curves;
        if (curves[i] > time) {
            let x = this.frames[frameIndex], y = this.frames[frameIndex + valueOffset];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        let n = i + 18 /*BEZIER_SIZE*/ ;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            let x = curves[i - 2], y = curves[i - 1];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        frameIndex += this.getFrameEntries();
        let x = curves[n - 2], y = curves[n - 1];
        return y + (time - x) / (this.frames[frameIndex] - x) * (this.frames[frameIndex + valueOffset] - y);
    }
}
class $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, propertyId){
        super(frameCount, bezierCount, [
            propertyId
        ]);
    }
    getFrameEntries() {
        return 2 /*ENTRIES*/ ;
    }
    /** Sets the time and value for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, value) {
        frame <<= 1;
        this.frames[frame] = time;
        this.frames[frame + 1 /*VALUE*/ ] = value;
    }
    /** Returns the interpolated value for the specified time. */ getCurveValue(time) {
        let frames = this.frames;
        let i = frames.length - 2;
        for(let ii = 2; ii <= i; ii += 2)if (frames[ii] > time) {
            i = ii - 2;
            break;
        }
        let curveType = this.curves[i >> 1];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i], value = frames[i + 1 /*VALUE*/ ];
                return value + (time - before) / (frames[i + 2 /*ENTRIES*/ ] - before) * (frames[i + 2 /*ENTRIES*/  + 1 /*VALUE*/ ] - value);
            case 1 /*STEPPED*/ :
                return frames[i + 1 /*VALUE*/ ];
        }
        return this.getBezierValue(time, i, 1 /*VALUE*/ , curveType - 2 /*BEZIER*/ );
    }
    getRelativeValue(time, alpha, blend, current, setup) {
        if (time < this.frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    return setup;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        let value = this.getCurveValue(time);
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                return setup + value * alpha;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                value += setup - current;
        }
        return current + value * alpha;
    }
    getAbsoluteValue(time, alpha, blend, current, setup) {
        if (time < this.frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    return setup;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        let value = this.getCurveValue(time);
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) return setup + (value - setup) * alpha;
        return current + (value - current) * alpha;
    }
    getAbsoluteValue2(time, alpha, blend, current, setup, value) {
        if (time < this.frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    return setup;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) return setup + (value - setup) * alpha;
        return current + (value - current) * alpha;
    }
    getScaleValue(time, alpha, blend, direction, current, setup) {
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    return setup;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        let value = this.getCurveValue(time) * setup;
        if (alpha == 1) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) return current + value - setup;
            return value;
        }
        // Mixing out uses sign of setup or current pose, else use sign of key.
        if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                return setup + (Math.abs(value) * (0, $1Yup6.MathUtils).signum(setup) - setup) * alpha;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                return current + (Math.abs(value) * (0, $1Yup6.MathUtils).signum(current) - current) * alpha;
        }
        else {
            let s = 0;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    s = Math.abs(setup) * (0, $1Yup6.MathUtils).signum(value);
                    return s + (value - s) * alpha;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    s = Math.abs(current) * (0, $1Yup6.MathUtils).signum(value);
                    return s + (value - s) * alpha;
            }
        }
        return current + (value - setup) * alpha;
    }
}
class $c8bc0977b55afb3a$export$d380b930c0f765ae extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** @param bezierCount The maximum number of Bezier curves. See {@link #shrink(int)}.
     * @param propertyIds Unique identifiers for the properties the timeline modifies. */ constructor(frameCount, bezierCount, propertyId1, propertyId2){
        super(frameCount, bezierCount, [
            propertyId1,
            propertyId2
        ]);
    }
    getFrameEntries() {
        return 3 /*ENTRIES*/ ;
    }
    /** Sets the time and values for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, value1, value2) {
        frame *= 3 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*VALUE1*/ ] = value1;
        this.frames[frame + 2 /*VALUE2*/ ] = value2;
    }
}
class $c8bc0977b55afb3a$export$b7ecb8f68b3e130b extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.rotate + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.rotation = this.getRelativeValue(time, alpha, blend, bone.rotation, bone.data.rotation);
    }
}
class $c8bc0977b55afb3a$export$eb93bf27829ae703 extends $c8bc0977b55afb3a$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.x + "|" + boneIndex, $c8bc0977b55afb3a$var$Property.y + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.x = bone.data.x;
                    bone.y = bone.data.y;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.x += (bone.data.x - bone.x) * alpha;
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        let x = 0, y = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.x = bone.data.x + x * alpha;
                bone.y = bone.data.y + y * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.x += x * alpha;
                bone.y += y * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$cf49491eb4394eca extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.x + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.x = this.getRelativeValue(time, alpha, blend, bone.x, bone.data.x);
    }
}
class $c8bc0977b55afb3a$export$6540b7ba297d3e41 extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.y + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.y = this.getRelativeValue(time, alpha, blend, bone.y, bone.data.y);
    }
}
class $c8bc0977b55afb3a$export$be544e22f6ad7737 extends $c8bc0977b55afb3a$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.scaleX + "|" + boneIndex, $c8bc0977b55afb3a$var$Property.scaleY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.scaleX = bone.data.scaleX;
                    bone.scaleY = bone.data.scaleY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        let x, y;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        x *= bone.data.scaleX;
        y *= bone.data.scaleY;
        if (alpha == 1) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) {
                bone.scaleX += x - bone.data.scaleX;
                bone.scaleY += y - bone.data.scaleY;
            } else {
                bone.scaleX = x;
                bone.scaleY = y;
            }
        } else {
            let bx = 0, by = 0;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bx = bone.data.scaleX;
                    by = bone.data.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $1Yup6.MathUtils).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $1Yup6.MathUtils).signum(by) - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $1Yup6.MathUtils).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $1Yup6.MathUtils).signum(by) - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $1Yup6.MathUtils).signum(x);
                    by = Math.abs(bone.data.scaleY) * (0, $1Yup6.MathUtils).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    bx = Math.abs(bone.scaleX) * (0, $1Yup6.MathUtils).signum(x);
                    by = Math.abs(bone.scaleY) * (0, $1Yup6.MathUtils).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
        }
    }
}
class $c8bc0977b55afb3a$export$407a9cf4df59ebda extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.scaleX + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.scaleX = this.getScaleValue(time, alpha, blend, direction, bone.scaleX, bone.data.scaleX);
    }
}
class $c8bc0977b55afb3a$export$cc13ceba88ef3794 extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.scaleY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.scaleY = this.getScaleValue(time, alpha, blend, direction, bone.scaleY, bone.data.scaleY);
    }
}
class $c8bc0977b55afb3a$export$4da82436a1a0d773 extends $c8bc0977b55afb3a$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.shearX + "|" + boneIndex, $c8bc0977b55afb3a$var$Property.shearY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.shearX = bone.data.shearX;
                    bone.shearY = bone.data.shearY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        let x = 0, y = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.shearX = bone.data.shearX + x * alpha;
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.shearX += x * alpha;
                bone.shearY += y * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$2392b1c4c21acaf8 extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.shearX + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.shearX = this.getRelativeValue(time, alpha, blend, bone.shearX, bone.data.shearX);
    }
}
class $c8bc0977b55afb3a$export$f65148e1d95352fd extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.shearY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.shearY = this.getRelativeValue(time, alpha, blend, bone.shearY, bone.data.shearY);
    }
}
class $c8bc0977b55afb3a$export$7582beb1c1258b21 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    boneIndex = 0;
    constructor(frameCount, boneIndex){
        super(frameCount, [
            $c8bc0977b55afb3a$var$Property.inherit + "|" + boneIndex
        ]);
        this.boneIndex = boneIndex;
    }
    getFrameEntries() {
        return 2 /*ENTRIES*/ ;
    }
    /** Sets the transform mode for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, inherit) {
        frame *= 2 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*INHERIT*/ ] = inherit;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) bone.inherit = bone.data.inherit;
            return;
        }
        let frames = this.frames;
        if (time < frames[0]) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup || blend == $c8bc0977b55afb3a$export$ccab779a50275a35.first) bone.inherit = bone.data.inherit;
            return;
        }
        bone.inherit = this.frames[$c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 2 /*ENTRIES*/ ) + 1 /*INHERIT*/ ];
    }
}
class $c8bc0977b55afb3a$export$84cf3a3e225bcbdc extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.alpha + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 5 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b, a) {
        frame *= 5 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*A*/ ] = a;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let color = slot.color;
        if (time < frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    color.setFromColor(setup);
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 5 /*ENTRIES*/ );
        let curveType = this.curves[i / 5 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                let t = (time - before) / (frames[i + 5 /*ENTRIES*/ ] - before);
                r += (frames[i + 5 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 5 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 5 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                a += (frames[i + 5 /*ENTRIES*/  + 4 /*A*/ ] - a) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                a = this.getBezierValue(time, i, 4 /*A*/ , curveType + 54 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) color.set(r, g, b, a);
        else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) color.setFromColor(slot.data.color);
            color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
        }
    }
}
class $c8bc0977b55afb3a$export$e179fb669ddccfa9 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 4 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b) {
        frame <<= 2;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let color = slot.color;
        if (time < frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    color.r = setup.r;
                    color.g = setup.g;
                    color.b = setup.b;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    color.r += (setup.r - color.r) * alpha;
                    color.g += (setup.g - color.g) * alpha;
                    color.b += (setup.b - color.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 4 /*ENTRIES*/ );
        let curveType = this.curves[i >> 2];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                let t = (time - before) / (frames[i + 4 /*ENTRIES*/ ] - before);
                r += (frames[i + 4 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 4 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 4 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            color.r = r;
            color.g = g;
            color.b = b;
        } else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
                let setup = slot.data.color;
                color.r = setup.r;
                color.g = setup.g;
                color.b = setup.b;
            }
            color.r += (r - color.r) * alpha;
            color.g += (g - color.g) * alpha;
            color.b += (b - color.b) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$2211be7c5ccde97b extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.alpha + "|" + slotIndex);
        this.slotIndex = slotIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let color = slot.color;
        if (time < this.frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    color.a = setup.a;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    color.a += (setup.a - color.a) * alpha;
            }
            return;
        }
        let a = this.getCurveValue(time);
        if (alpha == 1) color.a = a;
        else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) color.a = slot.data.color.a;
            color.a += (a - color.a) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$6fc6620d97c53689 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.alpha + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.rgb2 + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 8 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, a, r2, g2, b2) {
        frame <<= 3;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*A*/ ] = a;
        this.frames[frame + 5 /*R2*/ ] = r2;
        this.frames[frame + 6 /*G2*/ ] = g2;
        this.frames[frame + 7 /*B2*/ ] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let light = slot.color, dark = slot.darkColor;
        if (time < frames[0]) {
            let setupLight = slot.data.color, setupDark = slot.data.darkColor;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    light.setFromColor(setupLight);
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0, r2 = 0, g2 = 0, b2 = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 8 /*ENTRIES*/ );
        let curveType = this.curves[i >> 3];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                r2 = frames[i + 5 /*R2*/ ];
                g2 = frames[i + 6 /*G2*/ ];
                b2 = frames[i + 7 /*B2*/ ];
                let t = (time - before) / (frames[i + 8 /*ENTRIES*/ ] - before);
                r += (frames[i + 8 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 8 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 8 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                a += (frames[i + 8 /*ENTRIES*/  + 4 /*A*/ ] - a) * t;
                r2 += (frames[i + 8 /*ENTRIES*/  + 5 /*R2*/ ] - r2) * t;
                g2 += (frames[i + 8 /*ENTRIES*/  + 6 /*G2*/ ] - g2) * t;
                b2 += (frames[i + 8 /*ENTRIES*/  + 7 /*B2*/ ] - b2) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                r2 = frames[i + 5 /*R2*/ ];
                g2 = frames[i + 6 /*G2*/ ];
                b2 = frames[i + 7 /*B2*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                a = this.getBezierValue(time, i, 4 /*A*/ , curveType + 54 - 2 /*BEZIER*/ );
                r2 = this.getBezierValue(time, i, 5 /*R2*/ , curveType + 72 - 2 /*BEZIER*/ );
                g2 = this.getBezierValue(time, i, 6 /*G2*/ , curveType + 90 - 2 /*BEZIER*/ );
                b2 = this.getBezierValue(time, i, 7 /*B2*/ , curveType + 108 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            light.set(r, g, b, a);
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
                light.setFromColor(slot.data.color);
                let setupDark = slot.data.darkColor;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$a12960afd309a230 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.rgb2 + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 7 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, r2, g2, b2) {
        frame *= 7 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*R2*/ ] = r2;
        this.frames[frame + 5 /*G2*/ ] = g2;
        this.frames[frame + 6 /*B2*/ ] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let light = slot.color, dark = slot.darkColor;
        if (time < frames[0]) {
            let setupLight = slot.data.color, setupDark = slot.data.darkColor;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    light.r = setupLight.r;
                    light.g = setupLight.g;
                    light.b = setupLight.b;
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    light.r += (setupLight.r - light.r) * alpha;
                    light.g += (setupLight.g - light.g) * alpha;
                    light.b += (setupLight.b - light.b) * alpha;
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0, r2 = 0, g2 = 0, b2 = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 7 /*ENTRIES*/ );
        let curveType = this.curves[i / 7 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                r2 = frames[i + 4 /*R2*/ ];
                g2 = frames[i + 5 /*G2*/ ];
                b2 = frames[i + 6 /*B2*/ ];
                let t = (time - before) / (frames[i + 7 /*ENTRIES*/ ] - before);
                r += (frames[i + 7 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 7 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 7 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                r2 += (frames[i + 7 /*ENTRIES*/  + 4 /*R2*/ ] - r2) * t;
                g2 += (frames[i + 7 /*ENTRIES*/  + 5 /*G2*/ ] - g2) * t;
                b2 += (frames[i + 7 /*ENTRIES*/  + 6 /*B2*/ ] - b2) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                r2 = frames[i + 4 /*R2*/ ];
                g2 = frames[i + 5 /*G2*/ ];
                b2 = frames[i + 6 /*B2*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                r2 = this.getBezierValue(time, i, 4 /*R2*/ , curveType + 54 - 2 /*BEZIER*/ );
                g2 = this.getBezierValue(time, i, 5 /*G2*/ , curveType + 72 - 2 /*BEZIER*/ );
                b2 = this.getBezierValue(time, i, 6 /*B2*/ , curveType + 90 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            light.r = r;
            light.g = g;
            light.b = b;
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
                let setupLight = slot.data.color, setupDark = slot.data.darkColor;
                light.r = setupLight.r;
                light.g = setupLight.g;
                light.b = setupLight.b;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.r += (r - light.r) * alpha;
            light.g += (g - light.g) * alpha;
            light.b += (b - light.b) * alpha;
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    slotIndex = 0;
    /** The attachment name for each key frame. May contain null values to clear the attachment. */ attachmentNames;
    constructor(frameCount, slotIndex){
        super(frameCount, [
            $c8bc0977b55afb3a$var$Property.attachment + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
        this.attachmentNames = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the attachment name for the specified key frame. */ setFrame(frame, time, attachmentName) {
        this.frames[frame] = time;
        this.attachmentNames[frame] = attachmentName;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup || blend == $c8bc0977b55afb3a$export$ccab779a50275a35.first) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        this.setAttachment(skeleton, slot, this.attachmentNames[$c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(this.frames, time)]);
    }
    setAttachment(skeleton, slot, attachmentName) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
    }
}
class $c8bc0977b55afb3a$export$6968d40e5689ad6b extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    /** The attachment that will be deformed. */ attachment;
    /** The vertices for each key frame. */ vertices;
    constructor(frameCount, bezierCount, slotIndex, attachment){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.deform + "|" + slotIndex + "|" + attachment.id
        ]);
        this.slotIndex = slotIndex;
        this.attachment = attachment;
        this.vertices = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the vertices for the specified key frame.
     * @param vertices Vertex positions for an unweighted VertexAttachment, or deform offsets if it has weights. */ setFrame(frame, time, vertices) {
        this.frames[frame] = time;
        this.vertices[frame] = vertices;
    }
    /** @param value1 Ignored (0 is used for a deform timeline).
     * @param value2 Ignored (1 is used for a deform timeline). */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        let curves = this.curves;
        let i = this.getFrameCount() + bezier * 18 /*BEZIER_SIZE*/ ;
        if (value == 0) curves[frame] = 2 /*BEZIER*/  + i;
        let tmpx = (time1 - cx1 * 2 + cx2) * 0.03, tmpy = cy2 * 0.03 - cy1 * 0.06;
        let dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006, dddy = (cy1 - cy2 + 0.33333333) * 0.018;
        let ddx = tmpx * 2 + dddx, ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667, dy = cy1 * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx, y = dy;
        for(let n = i + 18 /*BEZIER_SIZE*/ ; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    getCurvePercent(time, frame) {
        let curves = this.curves;
        let i = curves[frame];
        switch(i){
            case 0 /*LINEAR*/ :
                let x = this.frames[frame];
                return (time - x) / (this.frames[frame + this.getFrameEntries()] - x);
            case 1 /*STEPPED*/ :
                return 0;
        }
        i -= 2 /*BEZIER*/ ;
        if (curves[i] > time) {
            let x = this.frames[frame];
            return curves[i + 1] * (time - x) / (curves[i] - x);
        }
        let n = i + 18 /*BEZIER_SIZE*/ ;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            let x = curves[i - 2], y = curves[i - 1];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        let x1 = curves[n - 2], y = curves[n - 1];
        return y + (1 - y) * (time - x1) / (this.frames[frame + this.getFrameEntries()] - x1);
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let slotAttachment = slot.getAttachment();
        if (!slotAttachment) return;
        if (!(slotAttachment instanceof (0, $5a4jk.VertexAttachment)) || slotAttachment.timelineAttachment != this.attachment) return;
        let deform = slot.deform;
        if (deform.length == 0) blend = $c8bc0977b55afb3a$export$ccab779a50275a35.setup;
        let vertices = this.vertices;
        let vertexCount = vertices[0].length;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    deform.length = 0;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    if (alpha == 1) {
                        deform.length = 0;
                        return;
                    }
                    deform.length = vertexCount;
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions.
                        let setupVertices = vertexAttachment.vertices;
                        for(var i = 0; i < vertexCount; i++)deform[i] += (setupVertices[i] - deform[i]) * alpha;
                    } else {
                        // Weighted deform offsets.
                        alpha = 1 - alpha;
                        for(var i = 0; i < vertexCount; i++)deform[i] *= alpha;
                    }
            }
            return;
        }
        deform.length = vertexCount;
        if (time >= frames[frames.length - 1]) {
            let lastVertices = vertices[frames.length - 1];
            if (alpha == 1) {
                if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) {
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] - setupVertices[i];
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i];
                } else (0, $1Yup6.Utils).arrayCopy(lastVertices, 0, deform, 0, vertexCount);
            } else switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    {
                        let vertexAttachment = slotAttachment;
                        if (!vertexAttachment.bones) {
                            // Unweighted vertex positions, with alpha.
                            let setupVertices = vertexAttachment.vertices;
                            for(let i = 0; i < vertexCount; i++){
                                let setup = setupVertices[i];
                                deform[i] = setup + (lastVertices[i] - setup) * alpha;
                            }
                        } else // Weighted deform offsets, with alpha.
                        for(let i = 0; i < vertexCount; i++)deform[i] = lastVertices[i] * alpha;
                        break;
                    }
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - deform[i]) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - setupVertices[i]) * alpha;
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] * alpha;
            }
            return;
        }
        // Interpolate between the previous frame and the current frame.
        let frame = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(frames, time);
        let percent = this.getCurvePercent(time, frame);
        let prevVertices = vertices[frame];
        let nextVertices = vertices[frame + 1];
        if (alpha == 1) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) {
                let vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    // Unweighted vertex positions, with alpha.
                    let setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] += prev + (nextVertices[i] - prev) * percent - setupVertices[i];
                    }
                } else // Weighted deform offsets, with alpha.
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += prev + (nextVertices[i] - prev) * percent;
                }
            } else for(let i = 0; i < vertexCount; i++){
                let prev = prevVertices[i];
                deform[i] = prev + (nextVertices[i] - prev) * percent;
            }
        } else switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                {
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++){
                            let prev = prevVertices[i], setup = setupVertices[i];
                            deform[i] = setup + (prev + (nextVertices[i] - prev) * percent - setup) * alpha;
                        }
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] = (prev + (nextVertices[i] - prev) * percent) * alpha;
                    }
                    break;
                }
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent - deform[i]) * alpha;
                }
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                let vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    // Unweighted vertex positions, with alpha.
                    let setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] += (prev + (nextVertices[i] - prev) * percent - setupVertices[i]) * alpha;
                    }
                } else // Weighted deform offsets, with alpha.
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent) * alpha;
                }
        }
    }
}
class $c8bc0977b55afb3a$export$4f4bca996c586084 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        "" + $c8bc0977b55afb3a$var$Property.event
    ];
    /** The event for each key frame. */ events;
    constructor(frameCount){
        super(frameCount, $c8bc0977b55afb3a$export$4f4bca996c586084.propertyIds);
        this.events = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the event for the specified key frame. */ setFrame(frame, event) {
        this.frames[frame] = event.time;
        this.events[frame] = event;
    }
    /** Fires events for frames > `lastTime` and <= `time`. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (!firedEvents) return;
        let frames = this.frames;
        let frameCount = this.frames.length;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frameCount - 1]) return;
        if (time < frames[0]) return;
        let i = 0;
        if (lastTime < frames[0]) i = 0;
        else {
            i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(frames, lastTime) + 1;
            let frameTime = frames[i];
            while(i > 0){
                if (frames[i - 1] != frameTime) break;
                i--;
            }
        }
        for(; i < frameCount && time >= frames[i]; i++)firedEvents.push(this.events[i]);
    }
}
class $c8bc0977b55afb3a$export$ece1f7c41d051e83 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        "" + $c8bc0977b55afb3a$var$Property.drawOrder
    ];
    /** The draw order for each key frame. See {@link #setFrame(int, float, int[])}. */ drawOrders;
    constructor(frameCount){
        super(frameCount, $c8bc0977b55afb3a$export$ece1f7c41d051e83.propertyIds);
        this.drawOrders = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the draw order for the specified key frame.
     * @param drawOrder For each slot in {@link Skeleton#slots}, the index of the new draw order. May be null to use setup pose
     *           draw order. */ setFrame(frame, time, drawOrder) {
        this.frames[frame] = time;
        this.drawOrders[frame] = drawOrder;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) (0, $1Yup6.Utils).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup || blend == $c8bc0977b55afb3a$export$ccab779a50275a35.first) (0, $1Yup6.Utils).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        let idx = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(this.frames, time);
        let drawOrderToSetupIndex = this.drawOrders[idx];
        if (!drawOrderToSetupIndex) (0, $1Yup6.Utils).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
        else {
            let drawOrder = skeleton.drawOrder;
            let slots = skeleton.slots;
            for(let i = 0, n = drawOrderToSetupIndex.length; i < n; i++)drawOrder[i] = slots[drawOrderToSetupIndex[i]];
        }
    }
}
class $c8bc0977b55afb3a$export$73d125cd89dead44 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** The index of the IK constraint in {@link Skeleton#getIkConstraints()} that will be changed when this timeline is applied */ constraintIndex = 0;
    constructor(frameCount, bezierCount, ikConstraintIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.ikConstraint + "|" + ikConstraintIndex
        ]);
        this.constraintIndex = ikConstraintIndex;
    }
    getFrameEntries() {
        return 6 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, mix, softness, bend direction, compress, and stretch for the specified key frame. */ setFrame(frame, time, mix, softness, bendDirection, compress, stretch) {
        frame *= 6 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*MIX*/ ] = mix;
        this.frames[frame + 2 /*SOFTNESS*/ ] = softness;
        this.frames[frame + 3 /*BEND_DIRECTION*/ ] = bendDirection;
        this.frames[frame + 4 /*COMPRESS*/ ] = compress ? 1 : 0;
        this.frames[frame + 5 /*STRETCH*/ ] = stretch ? 1 : 0;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.ikConstraints[this.constraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.mix = constraint.data.mix;
                    constraint.softness = constraint.data.softness;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
                    constraint.softness += (constraint.data.softness - constraint.softness) * alpha;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
            }
            return;
        }
        let mix = 0, softness = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 6 /*ENTRIES*/ );
        let curveType = this.curves[i / 6 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                mix = frames[i + 1 /*MIX*/ ];
                softness = frames[i + 2 /*SOFTNESS*/ ];
                let t = (time - before) / (frames[i + 6 /*ENTRIES*/ ] - before);
                mix += (frames[i + 6 /*ENTRIES*/  + 1 /*MIX*/ ] - mix) * t;
                softness += (frames[i + 6 /*ENTRIES*/  + 2 /*SOFTNESS*/ ] - softness) * t;
                break;
            case 1 /*STEPPED*/ :
                mix = frames[i + 1 /*MIX*/ ];
                softness = frames[i + 2 /*SOFTNESS*/ ];
                break;
            default:
                mix = this.getBezierValue(time, i, 1 /*MIX*/ , curveType - 2 /*BEZIER*/ );
                softness = this.getBezierValue(time, i, 2 /*SOFTNESS*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
            constraint.mix = constraint.data.mix + (mix - constraint.data.mix) * alpha;
            constraint.softness = constraint.data.softness + (softness - constraint.data.softness) * alpha;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
                constraint.bendDirection = constraint.data.bendDirection;
                constraint.compress = constraint.data.compress;
                constraint.stretch = constraint.data.stretch;
            } else {
                constraint.bendDirection = frames[i + 3 /*BEND_DIRECTION*/ ];
                constraint.compress = frames[i + 4 /*COMPRESS*/ ] != 0;
                constraint.stretch = frames[i + 5 /*STRETCH*/ ] != 0;
            }
        } else {
            constraint.mix += (mix - constraint.mix) * alpha;
            constraint.softness += (softness - constraint.softness) * alpha;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixIn) {
                constraint.bendDirection = frames[i + 3 /*BEND_DIRECTION*/ ];
                constraint.compress = frames[i + 4 /*COMPRESS*/ ] != 0;
                constraint.stretch = frames[i + 5 /*STRETCH*/ ] != 0;
            }
        }
    }
}
class $c8bc0977b55afb3a$export$a7a393c2ad815ac7 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** The index of the transform constraint slot in {@link Skeleton#transformConstraints} that will be changed. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, transformConstraintIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.transformConstraint + "|" + transformConstraintIndex
        ]);
        this.constraintIndex = transformConstraintIndex;
    }
    getFrameEntries() {
        return 7 /*ENTRIES*/ ;
    }
    /** The time in seconds, rotate mix, translate mix, scale mix, and shear mix for the specified key frame. */ setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY) {
        let frames = this.frames;
        frame *= 7 /*ENTRIES*/ ;
        frames[frame] = time;
        frames[frame + 1 /*ROTATE*/ ] = mixRotate;
        frames[frame + 2 /*X*/ ] = mixX;
        frames[frame + 3 /*Y*/ ] = mixY;
        frames[frame + 4 /*SCALEX*/ ] = mixScaleX;
        frames[frame + 5 /*SCALEY*/ ] = mixScaleY;
        frames[frame + 6 /*SHEARY*/ ] = mixShearY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.transformConstraints[this.constraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            let data = constraint.data;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.mixRotate = data.mixRotate;
                    constraint.mixX = data.mixX;
                    constraint.mixY = data.mixY;
                    constraint.mixScaleX = data.mixScaleX;
                    constraint.mixScaleY = data.mixScaleY;
                    constraint.mixShearY = data.mixShearY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.mixRotate += (data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (data.mixY - constraint.mixY) * alpha;
                    constraint.mixScaleX += (data.mixScaleX - constraint.mixScaleX) * alpha;
                    constraint.mixScaleY += (data.mixScaleY - constraint.mixScaleY) * alpha;
                    constraint.mixShearY += (data.mixShearY - constraint.mixShearY) * alpha;
            }
            return;
        }
        let rotate, x, y, scaleX, scaleY, shearY;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 7 /*ENTRIES*/ );
        let curveType = this.curves[i / 7 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                scaleX = frames[i + 4 /*SCALEX*/ ];
                scaleY = frames[i + 5 /*SCALEY*/ ];
                shearY = frames[i + 6 /*SHEARY*/ ];
                let t = (time - before) / (frames[i + 7 /*ENTRIES*/ ] - before);
                rotate += (frames[i + 7 /*ENTRIES*/  + 1 /*ROTATE*/ ] - rotate) * t;
                x += (frames[i + 7 /*ENTRIES*/  + 2 /*X*/ ] - x) * t;
                y += (frames[i + 7 /*ENTRIES*/  + 3 /*Y*/ ] - y) * t;
                scaleX += (frames[i + 7 /*ENTRIES*/  + 4 /*SCALEX*/ ] - scaleX) * t;
                scaleY += (frames[i + 7 /*ENTRIES*/  + 5 /*SCALEY*/ ] - scaleY) * t;
                shearY += (frames[i + 7 /*ENTRIES*/  + 6 /*SHEARY*/ ] - shearY) * t;
                break;
            case 1 /*STEPPED*/ :
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                scaleX = frames[i + 4 /*SCALEX*/ ];
                scaleY = frames[i + 5 /*SCALEY*/ ];
                shearY = frames[i + 6 /*SHEARY*/ ];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1 /*ROTATE*/ , curveType - 2 /*BEZIER*/ );
                x = this.getBezierValue(time, i, 2 /*X*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 3 /*Y*/ , curveType + 36 - 2 /*BEZIER*/ );
                scaleX = this.getBezierValue(time, i, 4 /*SCALEX*/ , curveType + 54 - 2 /*BEZIER*/ );
                scaleY = this.getBezierValue(time, i, 5 /*SCALEY*/ , curveType + 72 - 2 /*BEZIER*/ );
                shearY = this.getBezierValue(time, i, 6 /*SHEARY*/ , curveType + 90 - 2 /*BEZIER*/ );
        }
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
            let data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
            constraint.mixScaleX = data.mixScaleX + (scaleX - data.mixScaleX) * alpha;
            constraint.mixScaleY = data.mixScaleY + (scaleY - data.mixScaleY) * alpha;
            constraint.mixShearY = data.mixShearY + (shearY - data.mixShearY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
            constraint.mixScaleX += (scaleX - constraint.mixScaleX) * alpha;
            constraint.mixScaleY += (scaleY - constraint.mixScaleY) * alpha;
            constraint.mixShearY += (shearY - constraint.mixShearY) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$7ce7e67fd9cc52ed extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    /** The index of the path constraint in {@link Skeleton#getPathConstraints()} that will be changed when this timeline is
     * applied. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.pathConstraintPosition + "|" + pathConstraintIndex);
        this.constraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.constraintIndex];
        if (constraint.active) constraint.position = this.getAbsoluteValue(time, alpha, blend, constraint.position, constraint.data.position);
    }
}
class $c8bc0977b55afb3a$export$17ee50c08a07e62b extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    /** The index of the path constraint in {@link Skeleton#getPathConstraints()} that will be changed when this timeline is
     * applied. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.pathConstraintSpacing + "|" + pathConstraintIndex);
        this.constraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.constraintIndex];
        if (constraint.active) constraint.spacing = this.getAbsoluteValue(time, alpha, blend, constraint.spacing, constraint.data.spacing);
    }
}
class $c8bc0977b55afb3a$export$ea67b41755485038 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** The index of the path constraint in {@link Skeleton#getPathConstraints()} that will be changed when this timeline is
     * applied. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.pathConstraintMix + "|" + pathConstraintIndex
        ]);
        this.constraintIndex = pathConstraintIndex;
    }
    getFrameEntries() {
        return 4 /*ENTRIES*/ ;
    }
    setFrame(frame, time, mixRotate, mixX, mixY) {
        let frames = this.frames;
        frame <<= 2;
        frames[frame] = time;
        frames[frame + 1 /*ROTATE*/ ] = mixRotate;
        frames[frame + 2 /*X*/ ] = mixX;
        frames[frame + 3 /*Y*/ ] = mixY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.constraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.mixRotate = constraint.data.mixRotate;
                    constraint.mixX = constraint.data.mixX;
                    constraint.mixY = constraint.data.mixY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.mixRotate += (constraint.data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (constraint.data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (constraint.data.mixY - constraint.mixY) * alpha;
            }
            return;
        }
        let rotate, x, y;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 4 /*ENTRIES*/ );
        let curveType = this.curves[i >> 2];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                let t = (time - before) / (frames[i + 4 /*ENTRIES*/ ] - before);
                rotate += (frames[i + 4 /*ENTRIES*/  + 1 /*ROTATE*/ ] - rotate) * t;
                x += (frames[i + 4 /*ENTRIES*/  + 2 /*X*/ ] - x) * t;
                y += (frames[i + 4 /*ENTRIES*/  + 3 /*Y*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1 /*ROTATE*/ , curveType - 2 /*BEZIER*/ );
                x = this.getBezierValue(time, i, 2 /*X*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 3 /*Y*/ , curveType + 36 - 2 /*BEZIER*/ );
        }
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
            let data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$292849cf7640fcfe extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    /** The index of the physics constraint in {@link Skeleton#getPhysicsConstraints()} that will be changed when this timeline
     * is applied, or -1 if all physics constraints in the skeleton will be changed. */ constraintIndex = 0;
    /** @param physicsConstraintIndex -1 for all physics constraints in the skeleton. */ constructor(frameCount, bezierCount, physicsConstraintIndex, property){
        super(frameCount, bezierCount, property + "|" + physicsConstraintIndex);
        this.constraintIndex = physicsConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint;
        if (this.constraintIndex == -1) {
            const value = time >= this.frames[0] ? this.getCurveValue(time) : 0;
            for (const constraint of skeleton.physicsConstraints)if (constraint.active && this.global(constraint.data)) this.set(constraint, this.getAbsoluteValue2(time, alpha, blend, this.get(constraint), this.setup(constraint), value));
        } else {
            constraint = skeleton.physicsConstraints[this.constraintIndex];
            if (constraint.active) this.set(constraint, this.getAbsoluteValue(time, alpha, blend, this.get(constraint), this.setup(constraint)));
        }
    }
}
class $c8bc0977b55afb3a$export$8d7d2ed36692a76a extends $c8bc0977b55afb3a$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $c8bc0977b55afb3a$var$Property.physicsConstraintInertia);
    }
    setup(constraint) {
        return constraint.data.inertia;
    }
    get(constraint) {
        return constraint.inertia;
    }
    set(constraint, value) {
        constraint.inertia = value;
    }
    global(constraint) {
        return constraint.inertiaGlobal;
    }
}
class $c8bc0977b55afb3a$export$92ee7da35e84339e extends $c8bc0977b55afb3a$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $c8bc0977b55afb3a$var$Property.physicsConstraintStrength);
    }
    setup(constraint) {
        return constraint.data.strength;
    }
    get(constraint) {
        return constraint.strength;
    }
    set(constraint, value) {
        constraint.strength = value;
    }
    global(constraint) {
        return constraint.strengthGlobal;
    }
}
class $c8bc0977b55afb3a$export$cd77a164f9089126 extends $c8bc0977b55afb3a$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $c8bc0977b55afb3a$var$Property.physicsConstraintDamping);
    }
    setup(constraint) {
        return constraint.data.damping;
    }
    get(constraint) {
        return constraint.damping;
    }
    set(constraint, value) {
        constraint.damping = value;
    }
    global(constraint) {
        return constraint.dampingGlobal;
    }
}
class $c8bc0977b55afb3a$export$cc37bc88e0605a66 extends $c8bc0977b55afb3a$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $c8bc0977b55afb3a$var$Property.physicsConstraintMass);
    }
    setup(constraint) {
        return 1 / constraint.data.massInverse;
    }
    get(constraint) {
        return 1 / constraint.massInverse;
    }
    set(constraint, value) {
        constraint.massInverse = 1 / value;
    }
    global(constraint) {
        return constraint.massGlobal;
    }
}
class $c8bc0977b55afb3a$export$3e123ca078024d61 extends $c8bc0977b55afb3a$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $c8bc0977b55afb3a$var$Property.physicsConstraintWind);
    }
    setup(constraint) {
        return constraint.data.wind;
    }
    get(constraint) {
        return constraint.wind;
    }
    set(constraint, value) {
        constraint.wind = value;
    }
    global(constraint) {
        return constraint.windGlobal;
    }
}
class $c8bc0977b55afb3a$export$f321d2d075d42a88 extends $c8bc0977b55afb3a$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $c8bc0977b55afb3a$var$Property.physicsConstraintGravity);
    }
    setup(constraint) {
        return constraint.data.gravity;
    }
    get(constraint) {
        return constraint.gravity;
    }
    set(constraint, value) {
        constraint.gravity = value;
    }
    global(constraint) {
        return constraint.gravityGlobal;
    }
}
class $c8bc0977b55afb3a$export$e3ce1f2c0b6ae580 extends $c8bc0977b55afb3a$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $c8bc0977b55afb3a$var$Property.physicsConstraintMix);
    }
    setup(constraint) {
        return constraint.data.mix;
    }
    get(constraint) {
        return constraint.mix;
    }
    set(constraint, value) {
        constraint.mix = value;
    }
    global(constraint) {
        return constraint.mixGlobal;
    }
}
class $c8bc0977b55afb3a$export$956f20308bfd17e0 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        $c8bc0977b55afb3a$var$Property.physicsConstraintReset.toString()
    ];
    /** The index of the physics constraint in {@link Skeleton#getPhysicsConstraints()} that will be reset when this timeline is
    * applied, or -1 if all physics constraints in the skeleton will be reset. */ constraintIndex;
    /** @param physicsConstraintIndex -1 for all physics constraints in the skeleton. */ constructor(frameCount, physicsConstraintIndex){
        super(frameCount, $c8bc0977b55afb3a$export$956f20308bfd17e0.propertyIds);
        this.constraintIndex = physicsConstraintIndex;
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive. */ setFrame(frame, time) {
        this.frames[frame] = time;
    }
    /** Resets the physics constraint when frames > <code>lastTime</code> and <= <code>time</code>. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint;
        if (this.constraintIndex != -1) {
            constraint = skeleton.physicsConstraints[this.constraintIndex];
            if (!constraint.active) return;
        }
        const frames = this.frames;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, [], alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frames.length - 1]) return;
        if (time < frames[0]) return;
        if (lastTime < frames[0] || time >= frames[$c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(frames, lastTime) + 1]) {
            if (constraint != null) constraint.reset();
            else {
                for (const constraint of skeleton.physicsConstraints)if (constraint.active) constraint.reset();
            }
        }
    }
}
class $c8bc0977b55afb3a$export$2687f324e8496672 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    static ENTRIES = 3;
    static MODE = 1;
    static DELAY = 2;
    slotIndex;
    attachment;
    constructor(frameCount, slotIndex, attachment){
        super(frameCount, [
            $c8bc0977b55afb3a$var$Property.sequence + "|" + slotIndex + "|" + attachment.sequence.id
        ]);
        this.slotIndex = slotIndex;
        this.attachment = attachment;
    }
    getFrameEntries() {
        return $c8bc0977b55afb3a$export$2687f324e8496672.ENTRIES;
    }
    getSlotIndex() {
        return this.slotIndex;
    }
    getAttachment() {
        return this.attachment;
    }
    /** Sets the time, mode, index, and frame time for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time Seconds between frames. */ setFrame(frame, time, mode, index, delay) {
        let frames = this.frames;
        frame *= $c8bc0977b55afb3a$export$2687f324e8496672.ENTRIES;
        frames[frame] = time;
        frames[frame + $c8bc0977b55afb3a$export$2687f324e8496672.MODE] = mode | index << 4;
        frames[frame + $c8bc0977b55afb3a$export$2687f324e8496672.DELAY] = delay;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let slotAttachment = slot.attachment;
        let attachment = this.attachment;
        if (slotAttachment != attachment) {
            if (!(slotAttachment instanceof (0, $5a4jk.VertexAttachment)) || slotAttachment.timelineAttachment != attachment) return;
        }
        if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) slot.sequenceIndex = -1;
            return;
        }
        let frames = this.frames;
        if (time < frames[0]) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup || blend == $c8bc0977b55afb3a$export$ccab779a50275a35.first) slot.sequenceIndex = -1;
            return;
        }
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, $c8bc0977b55afb3a$export$2687f324e8496672.ENTRIES);
        let before = frames[i];
        let modeAndIndex = frames[i + $c8bc0977b55afb3a$export$2687f324e8496672.MODE];
        let delay = frames[i + $c8bc0977b55afb3a$export$2687f324e8496672.DELAY];
        if (!this.attachment.sequence) return;
        let index = modeAndIndex >> 4, count = this.attachment.sequence.regions.length;
        let mode = (0, $2nRvY.SequenceModeValues)[modeAndIndex & 0xf];
        if (mode != (0, $2nRvY.SequenceMode).hold) {
            index += (time - before) / delay + 0.00001 | 0;
            switch(mode){
                case (0, $2nRvY.SequenceMode).once:
                    index = Math.min(count - 1, index);
                    break;
                case (0, $2nRvY.SequenceMode).loop:
                    index %= count;
                    break;
                case (0, $2nRvY.SequenceMode).pingpong:
                    {
                        let n = (count << 1) - 2;
                        index = n == 0 ? 0 : index % n;
                        if (index >= count) index = n - index;
                        break;
                    }
                case (0, $2nRvY.SequenceMode).onceReverse:
                    index = Math.max(count - 1 - index, 0);
                    break;
                case (0, $2nRvY.SequenceMode).loopReverse:
                    index = count - 1 - index % count;
                    break;
                case (0, $2nRvY.SequenceMode).pingpongReverse:
                    {
                        let n = (count << 1) - 2;
                        index = n == 0 ? 0 : (index + count - 1) % n;
                        if (index >= count) index = n - index;
                    }
            }
        }
        slot.sequenceIndex = index;
    }
}

});
parcelRegister("5a4jk", function(module, exports) {

$parcel$export(module.exports, "Attachment", () => $3c213aed73167a71$export$71e4db985cfcf9e3);
$parcel$export(module.exports, "VertexAttachment", () => $3c213aed73167a71$export$66d3a0c3be55e044);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");
class $3c213aed73167a71$export$71e4db985cfcf9e3 {
    name;
    constructor(name){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
}
class $3c213aed73167a71$export$66d3a0c3be55e044 extends $3c213aed73167a71$export$71e4db985cfcf9e3 {
    static nextID = 0;
    /** The unique ID for this attachment. */ id = $3c213aed73167a71$export$66d3a0c3be55e044.nextID++;
    /** The bones which affect the {@link #getVertices()}. The array entries are, for each vertex, the number of bones affecting
     * the vertex followed by that many bone indices, which is the index of the bone in {@link Skeleton#bones}. Will be null
     * if this attachment has no weights. */ bones = null;
    /** The vertex positions in the bone's coordinate system. For a non-weighted attachment, the values are `x,y`
     * entries for each vertex. For a weighted attachment, the values are `x,y,weight` entries for each bone affecting
     * each vertex. */ vertices = [];
    /** The maximum number of world vertex values that can be output by
     * {@link #computeWorldVertices()} using the `count` parameter. */ worldVerticesLength = 0;
    /** Timelines for the timeline attachment are also applied to this attachment.
     * May be null if no attachment-specific timelines should be applied. */ timelineAttachment = this;
    constructor(name){
        super(name);
    }
    /** Transforms the attachment's local {@link #vertices} to world coordinates. If the slot's {@link Slot#deform} is
     * not empty, it is used to deform the vertices.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide.
     * @param start The index of the first {@link #vertices} value to transform. Each vertex has 2 values, x and y.
     * @param count The number of world vertex values to output. Must be <= {@link #worldVerticesLength} - `start`.
     * @param worldVertices The output world vertices. Must have a length >= `offset` + `count` *
     *           `stride` / 2.
     * @param offset The `worldVertices` index to begin writing values.
     * @param stride The number of `worldVertices` entries between the value pairs written. */ computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        count = offset + (count >> 1) * stride;
        let skeleton = slot.bone.skeleton;
        let deformArray = slot.deform;
        let vertices = this.vertices;
        let bones = this.bones;
        if (!bones) {
            if (deformArray.length > 0) vertices = deformArray;
            let bone = slot.bone;
            let x = bone.worldX;
            let y = bone.worldY;
            let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
            for(let v = start, w = offset; w < count; v += 2, w += stride){
                let vx = vertices[v], vy = vertices[v + 1];
                worldVertices[w] = vx * a + vy * b + x;
                worldVertices[w + 1] = vx * c + vy * d + y;
            }
            return;
        }
        let v = 0, skip = 0;
        for(let i = 0; i < start; i += 2){
            let n = bones[v];
            v += n + 1;
            skip += n;
        }
        let skeletonBones = skeleton.bones;
        if (deformArray.length == 0) for(let w = offset, b = skip * 3; w < count; w += stride){
            let wx = 0, wy = 0;
            let n = bones[v++];
            n += v;
            for(; v < n; v++, b += 3){
                let bone = skeletonBones[bones[v]];
                let vx = vertices[b], vy = vertices[b + 1], weight = vertices[b + 2];
                wx += (vx * bone.a + vy * bone.b + bone.worldX) * weight;
                wy += (vx * bone.c + vy * bone.d + bone.worldY) * weight;
            }
            worldVertices[w] = wx;
            worldVertices[w + 1] = wy;
        }
        else {
            let deform = deformArray;
            for(let w = offset, b = skip * 3, f = skip << 1; w < count; w += stride){
                let wx = 0, wy = 0;
                let n = bones[v++];
                n += v;
                for(; v < n; v++, b += 3, f += 2){
                    let bone = skeletonBones[bones[v]];
                    let vx = vertices[b] + deform[f], vy = vertices[b + 1] + deform[f + 1], weight = vertices[b + 2];
                    wx += (vx * bone.a + vy * bone.b + bone.worldX) * weight;
                    wy += (vx * bone.c + vy * bone.d + bone.worldY) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
    }
    /** Does not copy id (generated) or name (set on construction). **/ copyTo(attachment) {
        if (this.bones) {
            attachment.bones = new Array(this.bones.length);
            (0, $1Yup6.Utils).arrayCopy(this.bones, 0, attachment.bones, 0, this.bones.length);
        } else attachment.bones = null;
        if (this.vertices) {
            attachment.vertices = (0, $1Yup6.Utils).newFloatArray(this.vertices.length);
            (0, $1Yup6.Utils).arrayCopy(this.vertices, 0, attachment.vertices, 0, this.vertices.length);
        }
        attachment.worldVerticesLength = this.worldVerticesLength;
        attachment.timelineAttachment = this.timelineAttachment;
    }
}

});
parcelRegister("1Yup6", function(module, exports) {

$parcel$export(module.exports, "StringSet", () => $1702fa998ec22e58$export$1a41fd2ab8394c46);
$parcel$export(module.exports, "Color", () => $1702fa998ec22e58$export$892596cec99bc70e);
$parcel$export(module.exports, "MathUtils", () => $1702fa998ec22e58$export$6a7ef315a0d1ef07);
$parcel$export(module.exports, "Utils", () => $1702fa998ec22e58$export$d2ca453b913dcdea);
$parcel$export(module.exports, "Pool", () => $1702fa998ec22e58$export$14963ee5c8637e11);
$parcel$export(module.exports, "Vector2", () => $1702fa998ec22e58$export$c977b3e384af9ae1);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $1702fa998ec22e58$export$270182061f11fa81 {
    array = new Array();
    add(value) {
        let contains = this.contains(value);
        this.array[value | 0] = value | 0;
        return !contains;
    }
    contains(value) {
        return this.array[value | 0] != undefined;
    }
    remove(value) {
        this.array[value | 0] = undefined;
    }
    clear() {
        this.array.length = 0;
    }
}
class $1702fa998ec22e58$export$1a41fd2ab8394c46 {
    entries = {};
    size = 0;
    add(value) {
        let contains = this.entries[value];
        this.entries[value] = true;
        if (!contains) {
            this.size++;
            return true;
        }
        return false;
    }
    addAll(values) {
        let oldSize = this.size;
        for(var i = 0, n = values.length; i < n; i++)this.add(values[i]);
        return oldSize != this.size;
    }
    contains(value) {
        return this.entries[value];
    }
    clear() {
        this.entries = {};
        this.size = 0;
    }
}
class $1702fa998ec22e58$export$892596cec99bc70e {
    r;
    g;
    b;
    a;
    static WHITE = new $1702fa998ec22e58$export$892596cec99bc70e(1, 1, 1, 1);
    static RED = new $1702fa998ec22e58$export$892596cec99bc70e(1, 0, 0, 1);
    static GREEN = new $1702fa998ec22e58$export$892596cec99bc70e(0, 1, 0, 1);
    static BLUE = new $1702fa998ec22e58$export$892596cec99bc70e(0, 0, 1, 1);
    static MAGENTA = new $1702fa998ec22e58$export$892596cec99bc70e(1, 0, 1, 1);
    constructor(r = 0, g = 0, b = 0, a = 0){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    set(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this.clamp();
    }
    setFromColor(c) {
        this.r = c.r;
        this.g = c.g;
        this.b = c.b;
        this.a = c.a;
        return this;
    }
    setFromString(hex) {
        hex = hex.charAt(0) == '#' ? hex.substr(1) : hex;
        this.r = parseInt(hex.substr(0, 2), 16) / 255;
        this.g = parseInt(hex.substr(2, 2), 16) / 255;
        this.b = parseInt(hex.substr(4, 2), 16) / 255;
        this.a = hex.length != 8 ? 1 : parseInt(hex.substr(6, 2), 16) / 255;
        return this;
    }
    add(r, g, b, a) {
        this.r += r;
        this.g += g;
        this.b += b;
        this.a += a;
        return this.clamp();
    }
    clamp() {
        if (this.r < 0) this.r = 0;
        else if (this.r > 1) this.r = 1;
        if (this.g < 0) this.g = 0;
        else if (this.g > 1) this.g = 1;
        if (this.b < 0) this.b = 0;
        else if (this.b > 1) this.b = 1;
        if (this.a < 0) this.a = 0;
        else if (this.a > 1) this.a = 1;
        return this;
    }
    static rgba8888ToColor(color, value) {
        color.r = ((value & 0xff000000) >>> 24) / 255;
        color.g = ((value & 0x00ff0000) >>> 16) / 255;
        color.b = ((value & 0x0000ff00) >>> 8) / 255;
        color.a = (value & 0x000000ff) / 255;
    }
    static rgb888ToColor(color, value) {
        color.r = ((value & 0x00ff0000) >>> 16) / 255;
        color.g = ((value & 0x0000ff00) >>> 8) / 255;
        color.b = (value & 0x000000ff) / 255;
    }
    toRgb888() {
        const hex = (x)=>("0" + (x * 255).toString(16)).slice(-2);
        return Number("0x" + hex(this.r) + hex(this.g) + hex(this.b));
    }
    static fromString(hex, color = new $1702fa998ec22e58$export$892596cec99bc70e()) {
        return color.setFromString(hex);
    }
}
class $1702fa998ec22e58$export$6a7ef315a0d1ef07 {
    static PI = 3.1415927;
    static PI2 = $1702fa998ec22e58$export$6a7ef315a0d1ef07.PI * 2;
    static invPI2 = 1 / $1702fa998ec22e58$export$6a7ef315a0d1ef07.PI2;
    static radiansToDegrees = 180 / $1702fa998ec22e58$export$6a7ef315a0d1ef07.PI;
    static radDeg = $1702fa998ec22e58$export$6a7ef315a0d1ef07.radiansToDegrees;
    static degreesToRadians = $1702fa998ec22e58$export$6a7ef315a0d1ef07.PI / 180;
    static degRad = $1702fa998ec22e58$export$6a7ef315a0d1ef07.degreesToRadians;
    static clamp(value, min, max) {
        if (value < min) return min;
        if (value > max) return max;
        return value;
    }
    static cosDeg(degrees) {
        return Math.cos(degrees * $1702fa998ec22e58$export$6a7ef315a0d1ef07.degRad);
    }
    static sinDeg(degrees) {
        return Math.sin(degrees * $1702fa998ec22e58$export$6a7ef315a0d1ef07.degRad);
    }
    static atan2Deg(y, x) {
        return Math.atan2(y, x) * $1702fa998ec22e58$export$6a7ef315a0d1ef07.degRad;
    }
    static signum(value) {
        return value > 0 ? 1 : value < 0 ? -1 : 0;
    }
    static toInt(x) {
        return x > 0 ? Math.floor(x) : Math.ceil(x);
    }
    static cbrt(x) {
        let y = Math.pow(Math.abs(x), 1 / 3);
        return x < 0 ? -y : y;
    }
    static randomTriangular(min, max) {
        return $1702fa998ec22e58$export$6a7ef315a0d1ef07.randomTriangularWith(min, max, (min + max) * 0.5);
    }
    static randomTriangularWith(min, max, mode) {
        let u = Math.random();
        let d = max - min;
        if (u <= (mode - min) / d) return min + Math.sqrt(u * d * (mode - min));
        return max - Math.sqrt((1 - u) * d * (max - mode));
    }
    static isPowerOfTwo(value) {
        return value && (value & value - 1) === 0;
    }
}
class $1702fa998ec22e58$export$b0cc4f9860136880 {
    apply(start, end, a) {
        return start + (end - start) * this.applyInternal(a);
    }
}
class $1702fa998ec22e58$export$ce28d653ec559ee extends $1702fa998ec22e58$export$b0cc4f9860136880 {
    power = 2;
    constructor(power){
        super();
        this.power = power;
    }
    applyInternal(a) {
        if (a <= 0.5) return Math.pow(a * 2, this.power) / 2;
        return Math.pow((a - 1) * 2, this.power) / (this.power % 2 == 0 ? -2 : 2) + 1;
    }
}
class $1702fa998ec22e58$export$4834f341f53dca5c extends $1702fa998ec22e58$export$ce28d653ec559ee {
    constructor(power){
        super(power);
    }
    applyInternal(a) {
        return Math.pow(a - 1, this.power) * (this.power % 2 == 0 ? -1 : 1) + 1;
    }
}
class $1702fa998ec22e58$export$d2ca453b913dcdea {
    static SUPPORTS_TYPED_ARRAYS = typeof Float32Array !== "undefined";
    static arrayCopy(source, sourceStart, dest, destStart, numElements) {
        for(let i = sourceStart, j = destStart; i < sourceStart + numElements; i++, j++)dest[j] = source[i];
    }
    static arrayFill(array, fromIndex, toIndex, value) {
        for(let i = fromIndex; i < toIndex; i++)array[i] = value;
    }
    static setArraySize(array, size, value = 0) {
        let oldSize = array.length;
        if (oldSize == size) return array;
        array.length = size;
        if (oldSize < size) for(let i = oldSize; i < size; i++)array[i] = value;
        return array;
    }
    static ensureArrayCapacity(array, size, value = 0) {
        if (array.length >= size) return array;
        return $1702fa998ec22e58$export$d2ca453b913dcdea.setArraySize(array, size, value);
    }
    static newArray(size, defaultValue) {
        let array = new Array(size);
        for(let i = 0; i < size; i++)array[i] = defaultValue;
        return array;
    }
    static newFloatArray(size) {
        if ($1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS) return new Float32Array(size);
        else {
            let array = new Array(size);
            for(let i = 0; i < array.length; i++)array[i] = 0;
            return array;
        }
    }
    static newShortArray(size) {
        if ($1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS) return new Int16Array(size);
        else {
            let array = new Array(size);
            for(let i = 0; i < array.length; i++)array[i] = 0;
            return array;
        }
    }
    static toFloatArray(array) {
        return $1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS ? new Float32Array(array) : array;
    }
    static toSinglePrecision(value) {
        return $1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS ? Math.fround(value) : value;
    }
    // This function is used to fix WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
    static webkit602BugfixHelper(alpha, blend) {}
    static contains(array, element, identity = true) {
        for(var i = 0; i < array.length; i++)if (array[i] == element) return true;
        return false;
    }
    static enumValue(type, name) {
        return type[name[0].toUpperCase() + name.slice(1)];
    }
}
class $1702fa998ec22e58$export$d19db7c5e7bdee05 {
    static logBones(skeleton) {
        for(let i = 0; i < skeleton.bones.length; i++){
            let bone = skeleton.bones[i];
            console.log(bone.data.name + ", " + bone.a + ", " + bone.b + ", " + bone.c + ", " + bone.d + ", " + bone.worldX + ", " + bone.worldY);
        }
    }
}
class $1702fa998ec22e58$export$14963ee5c8637e11 {
    items = new Array();
    instantiator;
    constructor(instantiator){
        this.instantiator = instantiator;
    }
    obtain() {
        return this.items.length > 0 ? this.items.pop() : this.instantiator();
    }
    free(item) {
        if (item.reset) item.reset();
        this.items.push(item);
    }
    freeAll(items) {
        for(let i = 0; i < items.length; i++)this.free(items[i]);
    }
    clear() {
        this.items.length = 0;
    }
}
class $1702fa998ec22e58$export$c977b3e384af9ae1 {
    x;
    y;
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    length() {
        let x = this.x;
        let y = this.y;
        return Math.sqrt(x * x + y * y);
    }
    normalize() {
        let len = this.length();
        if (len != 0) {
            this.x /= len;
            this.y /= len;
        }
        return this;
    }
}
class $1702fa998ec22e58$export$ab19517904b64359 {
    maxDelta = 0.064;
    framesPerSecond = 0;
    delta = 0;
    totalTime = 0;
    lastTime = Date.now() / 1000;
    frameCount = 0;
    frameTime = 0;
    update() {
        let now = Date.now() / 1000;
        this.delta = now - this.lastTime;
        this.frameTime += this.delta;
        this.totalTime += this.delta;
        if (this.delta > this.maxDelta) this.delta = this.maxDelta;
        this.lastTime = now;
        this.frameCount++;
        if (this.frameTime > 1) {
            this.framesPerSecond = this.frameCount / this.frameTime;
            this.frameTime = 0;
            this.frameCount = 0;
        }
    }
}
class $1702fa998ec22e58$export$a88e0a4e9fe51345 {
    values;
    addedValues = 0;
    lastValue = 0;
    mean = 0;
    dirty = true;
    constructor(windowSize = 32){
        this.values = new Array(windowSize);
    }
    hasEnoughData() {
        return this.addedValues >= this.values.length;
    }
    addValue(value) {
        if (this.addedValues < this.values.length) this.addedValues++;
        this.values[this.lastValue++] = value;
        if (this.lastValue > this.values.length - 1) this.lastValue = 0;
        this.dirty = true;
    }
    getMean() {
        if (this.hasEnoughData()) {
            if (this.dirty) {
                let mean = 0;
                for(let i = 0; i < this.values.length; i++)mean += this.values[i];
                this.mean = mean / this.values.length;
                this.dirty = false;
            }
            return this.mean;
        }
        return 0;
    }
}

});


parcelRegister("2nRvY", function(module, exports) {

$parcel$export(module.exports, "Sequence", () => $1bc73da5d49cda90$export$edde1bcb1b2b310e);
$parcel$export(module.exports, "SequenceMode", () => $1bc73da5d49cda90$export$2d839466c6120eb9);
$parcel$export(module.exports, "SequenceModeValues", () => $1bc73da5d49cda90$export$3d518da8d966a9f5);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");
class $1bc73da5d49cda90$export$edde1bcb1b2b310e {
    static _nextID = 0;
    id = $1bc73da5d49cda90$export$edde1bcb1b2b310e.nextID();
    regions;
    start = 0;
    digits = 0;
    /** The index of the region to show for the setup pose. */ setupIndex = 0;
    constructor(count){
        this.regions = new Array(count);
    }
    copy() {
        let copy = new $1bc73da5d49cda90$export$edde1bcb1b2b310e(this.regions.length);
        (0, $1Yup6.Utils).arrayCopy(this.regions, 0, copy.regions, 0, this.regions.length);
        copy.start = this.start;
        copy.digits = this.digits;
        copy.setupIndex = this.setupIndex;
        return copy;
    }
    apply(slot, attachment) {
        let index = slot.sequenceIndex;
        if (index == -1) index = this.setupIndex;
        if (index >= this.regions.length) index = this.regions.length - 1;
        let region = this.regions[index];
        if (attachment.region != region) {
            attachment.region = region;
            attachment.updateRegion();
        }
    }
    getPath(basePath, index) {
        let result = basePath;
        let frame = (this.start + index).toString();
        for(let i = this.digits - frame.length; i > 0; i--)result += "0";
        result += frame;
        return result;
    }
    static nextID() {
        return $1bc73da5d49cda90$export$edde1bcb1b2b310e._nextID++;
    }
}
var $1bc73da5d49cda90$export$2d839466c6120eb9;
(function(SequenceMode) {
    SequenceMode[SequenceMode["hold"] = 0] = "hold";
    SequenceMode[SequenceMode["once"] = 1] = "once";
    SequenceMode[SequenceMode["loop"] = 2] = "loop";
    SequenceMode[SequenceMode["pingpong"] = 3] = "pingpong";
    SequenceMode[SequenceMode["onceReverse"] = 4] = "onceReverse";
    SequenceMode[SequenceMode["loopReverse"] = 5] = "loopReverse";
    SequenceMode[SequenceMode["pingpongReverse"] = 6] = "pingpongReverse";
})($1bc73da5d49cda90$export$2d839466c6120eb9 || ($1bc73da5d49cda90$export$2d839466c6120eb9 = {}));
const $1bc73da5d49cda90$export$3d518da8d966a9f5 = [
    $1bc73da5d49cda90$export$2d839466c6120eb9.hold,
    $1bc73da5d49cda90$export$2d839466c6120eb9.once,
    $1bc73da5d49cda90$export$2d839466c6120eb9.loop,
    $1bc73da5d49cda90$export$2d839466c6120eb9.pingpong,
    $1bc73da5d49cda90$export$2d839466c6120eb9.onceReverse,
    $1bc73da5d49cda90$export$2d839466c6120eb9.loopReverse,
    $1bc73da5d49cda90$export$2d839466c6120eb9.pingpongReverse
];

});


parcelRegister("1RIMy", function(module, exports) {

$parcel$export(module.exports, "AnimationState", () => $15bd7a75a398401c$export$d0f7a26c90cc1562);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $hevjK = parcelRequire("hevjK");

var $1Yup6 = parcelRequire("1Yup6");
class $15bd7a75a398401c$export$d0f7a26c90cc1562 {
    static _emptyAnimation = new (0, $hevjK.Animation)("<empty>", [], 0);
    static emptyAnimation() {
        return $15bd7a75a398401c$export$d0f7a26c90cc1562._emptyAnimation;
    }
    /** The AnimationStateData to look up mix durations. */ data;
    /** The list of tracks that currently have animations, which may contain null entries. */ tracks = new Array();
    /** Multiplier for the delta time when the animation state is updated, causing time for all animations and mixes to play slower
     * or faster. Defaults to 1.
     *
     * See TrackEntry {@link TrackEntry#timeScale} for affecting a single animation. */ timeScale = 1;
    unkeyedState = 0;
    events = new Array();
    listeners = new Array();
    queue = new $15bd7a75a398401c$export$2fc6338444a158e6(this);
    propertyIDs = new (0, $1Yup6.StringSet)();
    animationsChanged = false;
    trackEntryPool = new (0, $1Yup6.Pool)(()=>new $15bd7a75a398401c$export$6fd48f25bc0ee658());
    constructor(data){
        this.data = data;
    }
    /** Increments each track entry {@link TrackEntry#trackTime()}, setting queued animations as current if needed. */ update(delta) {
        delta *= this.timeScale;
        let tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            let current = tracks[i];
            if (!current) continue;
            current.animationLast = current.nextAnimationLast;
            current.trackLast = current.nextTrackLast;
            let currentDelta = delta * current.timeScale;
            if (current.delay > 0) {
                current.delay -= currentDelta;
                if (current.delay > 0) continue;
                currentDelta = -current.delay;
                current.delay = 0;
            }
            let next = current.next;
            if (next) {
                // When the next entry's delay is passed, change to the next entry, preserving leftover time.
                let nextTime = current.trackLast - next.delay;
                if (nextTime >= 0) {
                    next.delay = 0;
                    next.trackTime += current.timeScale == 0 ? 0 : (nextTime / current.timeScale + delta) * next.timeScale;
                    current.trackTime += currentDelta;
                    this.setCurrent(i, next, true);
                    while(next.mixingFrom){
                        next.mixTime += delta;
                        next = next.mixingFrom;
                    }
                    continue;
                }
            } else if (current.trackLast >= current.trackEnd && !current.mixingFrom) {
                tracks[i] = null;
                this.queue.end(current);
                this.clearNext(current);
                continue;
            }
            if (current.mixingFrom && this.updateMixingFrom(current, delta)) {
                // End mixing from entries once all have completed.
                let from = current.mixingFrom;
                current.mixingFrom = null;
                if (from) from.mixingTo = null;
                while(from){
                    this.queue.end(from);
                    from = from.mixingFrom;
                }
            }
            current.trackTime += currentDelta;
        }
        this.queue.drain();
    }
    /** Returns true when all mixing from entries are complete. */ updateMixingFrom(to, delta) {
        let from = to.mixingFrom;
        if (!from) return true;
        let finished = this.updateMixingFrom(from, delta);
        from.animationLast = from.nextAnimationLast;
        from.trackLast = from.nextTrackLast;
        // The from entry was applied at least once and the mix is complete.
        if (to.nextTrackLast != -1 && to.mixTime >= to.mixDuration) {
            // Mixing is complete for all entries before the from entry or the mix is instantaneous.
            if (from.totalAlpha == 0 || to.mixDuration == 0) {
                to.mixingFrom = from.mixingFrom;
                if (from.mixingFrom != null) from.mixingFrom.mixingTo = to;
                to.interruptAlpha = from.interruptAlpha;
                this.queue.end(from);
            }
            return finished;
        }
        from.trackTime += delta * from.timeScale;
        to.mixTime += delta;
        return false;
    }
    /** Poses the skeleton using the track entry animations. There are no side effects other than invoking listeners, so the
     * animation state can be applied to multiple skeletons to pose them identically.
     * @returns True if any animations were applied. */ apply(skeleton) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (this.animationsChanged) this._animationsChanged();
        let events = this.events;
        let tracks = this.tracks;
        let applied = false;
        for(let i = 0, n = tracks.length; i < n; i++){
            let current = tracks[i];
            if (!current || current.delay > 0) continue;
            applied = true;
            let blend = i == 0 ? (0, $hevjK.MixBlend).first : current.mixBlend;
            // Apply mixing from entries first.
            let alpha = current.alpha;
            if (current.mixingFrom) alpha *= this.applyMixingFrom(current, skeleton, blend);
            else if (current.trackTime >= current.trackEnd && !current.next) alpha = 0;
            let attachments = alpha >= current.alphaAttachmentThreshold;
            // Apply current entry.
            let animationLast = current.animationLast, animationTime = current.getAnimationTime(), applyTime = animationTime;
            let applyEvents = events;
            if (current.reverse) {
                applyTime = current.animation.duration - applyTime;
                applyEvents = null;
            }
            let timelines = current.animation.timelines;
            let timelineCount = timelines.length;
            if (i == 0 && alpha == 1 || blend == (0, $hevjK.MixBlend).add) {
                if (i == 0) attachments = true;
                for(let ii = 0; ii < timelineCount; ii++){
                    // Fixes issue #302 on IOS9 where mix, blend sometimes became undefined and caused assets
                    // to sometimes stop rendering when using color correction, as their RGBA values become NaN.
                    // (https://github.com/pixijs/pixi-spine/issues/302)
                    (0, $1Yup6.Utils).webkit602BugfixHelper(alpha, blend);
                    var timeline = timelines[ii];
                    if (timeline instanceof (0, $hevjK.AttachmentTimeline)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, attachments);
                    else timeline.apply(skeleton, animationLast, applyTime, applyEvents, alpha, blend, (0, $hevjK.MixDirection).mixIn);
                }
            } else {
                let timelineMode = current.timelineMode;
                let shortestRotation = current.shortestRotation;
                let firstFrame = !shortestRotation && current.timelinesRotation.length != timelineCount << 1;
                if (firstFrame) current.timelinesRotation.length = timelineCount << 1;
                for(let ii = 0; ii < timelineCount; ii++){
                    let timeline = timelines[ii];
                    let timelineBlend = timelineMode[ii] == $15bd7a75a398401c$export$89027c4cc247cc19 ? blend : (0, $hevjK.MixBlend).setup;
                    if (!shortestRotation && timeline instanceof (0, $hevjK.RotateTimeline)) this.applyRotateTimeline(timeline, skeleton, applyTime, alpha, timelineBlend, current.timelinesRotation, ii << 1, firstFrame);
                    else if (timeline instanceof (0, $hevjK.AttachmentTimeline)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, attachments);
                    else {
                        // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
                        (0, $1Yup6.Utils).webkit602BugfixHelper(alpha, blend);
                        timeline.apply(skeleton, animationLast, applyTime, applyEvents, alpha, timelineBlend, (0, $hevjK.MixDirection).mixIn);
                    }
                }
            }
            this.queueEvents(current, animationTime);
            events.length = 0;
            current.nextAnimationLast = animationTime;
            current.nextTrackLast = current.trackTime;
        }
        // Set slots attachments to the setup pose, if needed. This occurs if an animation that is mixing out sets attachments so
        // subsequent timelines see any deform, but the subsequent timelines don't set an attachment (eg they are also mixing out or
        // the time is before the first key).
        var setupState = this.unkeyedState + $15bd7a75a398401c$export$be88f4235204622a;
        var slots = skeleton.slots;
        for(var i = 0, n = skeleton.slots.length; i < n; i++){
            var slot = slots[i];
            if (slot.attachmentState == setupState) {
                var attachmentName = slot.data.attachmentName;
                slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
            }
        }
        this.unkeyedState += 2; // Increasing after each use avoids the need to reset attachmentState for every slot.
        this.queue.drain();
        return applied;
    }
    applyMixingFrom(to, skeleton, blend) {
        let from = to.mixingFrom;
        if (from.mixingFrom) this.applyMixingFrom(from, skeleton, blend);
        let mix = 0;
        if (to.mixDuration == 0) {
            mix = 1;
            if (blend == (0, $hevjK.MixBlend).first) blend = (0, $hevjK.MixBlend).setup;
        } else {
            mix = to.mixTime / to.mixDuration;
            if (mix > 1) mix = 1;
            if (blend != (0, $hevjK.MixBlend).first) blend = from.mixBlend;
        }
        let attachments = mix < from.mixAttachmentThreshold, drawOrder = mix < from.mixDrawOrderThreshold;
        let timelines = from.animation.timelines;
        let timelineCount = timelines.length;
        let alphaHold = from.alpha * to.interruptAlpha, alphaMix = alphaHold * (1 - mix);
        let animationLast = from.animationLast, animationTime = from.getAnimationTime(), applyTime = animationTime;
        let events = null;
        if (from.reverse) applyTime = from.animation.duration - applyTime;
        else if (mix < from.eventThreshold) events = this.events;
        if (blend == (0, $hevjK.MixBlend).add) for(let i = 0; i < timelineCount; i++)timelines[i].apply(skeleton, animationLast, applyTime, events, alphaMix, blend, (0, $hevjK.MixDirection).mixOut);
        else {
            let timelineMode = from.timelineMode;
            let timelineHoldMix = from.timelineHoldMix;
            let shortestRotation = from.shortestRotation;
            let firstFrame = !shortestRotation && from.timelinesRotation.length != timelineCount << 1;
            if (firstFrame) from.timelinesRotation.length = timelineCount << 1;
            from.totalAlpha = 0;
            for(let i = 0; i < timelineCount; i++){
                let timeline = timelines[i];
                let direction = (0, $hevjK.MixDirection).mixOut;
                let timelineBlend;
                let alpha = 0;
                switch(timelineMode[i]){
                    case $15bd7a75a398401c$export$89027c4cc247cc19:
                        if (!drawOrder && timeline instanceof (0, $hevjK.DrawOrderTimeline)) continue;
                        timelineBlend = blend;
                        alpha = alphaMix;
                        break;
                    case $15bd7a75a398401c$export$9f55c59c79ce7630:
                        timelineBlend = (0, $hevjK.MixBlend).setup;
                        alpha = alphaMix;
                        break;
                    case $15bd7a75a398401c$export$61db7ea55ff2bc4f:
                        timelineBlend = blend;
                        alpha = alphaHold;
                        break;
                    case $15bd7a75a398401c$export$83263fba6795a4f7:
                        timelineBlend = (0, $hevjK.MixBlend).setup;
                        alpha = alphaHold;
                        break;
                    default:
                        timelineBlend = (0, $hevjK.MixBlend).setup;
                        let holdMix = timelineHoldMix[i];
                        alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
                        break;
                }
                from.totalAlpha += alpha;
                if (!shortestRotation && timeline instanceof (0, $hevjK.RotateTimeline)) this.applyRotateTimeline(timeline, skeleton, applyTime, alpha, timelineBlend, from.timelinesRotation, i << 1, firstFrame);
                else if (timeline instanceof (0, $hevjK.AttachmentTimeline)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, timelineBlend, attachments && alpha >= from.alphaAttachmentThreshold);
                else {
                    // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
                    (0, $1Yup6.Utils).webkit602BugfixHelper(alpha, blend);
                    if (drawOrder && timeline instanceof (0, $hevjK.DrawOrderTimeline) && timelineBlend == (0, $hevjK.MixBlend).setup) direction = (0, $hevjK.MixDirection).mixIn;
                    timeline.apply(skeleton, animationLast, applyTime, events, alpha, timelineBlend, direction);
                }
            }
        }
        if (to.mixDuration > 0) this.queueEvents(from, animationTime);
        this.events.length = 0;
        from.nextAnimationLast = animationTime;
        from.nextTrackLast = from.trackTime;
        return mix;
    }
    applyAttachmentTimeline(timeline, skeleton, time, blend, attachments) {
        var slot = skeleton.slots[timeline.slotIndex];
        if (!slot.bone.active) return;
        if (time < timeline.frames[0]) {
            if (blend == (0, $hevjK.MixBlend).setup || blend == (0, $hevjK.MixBlend).first) this.setAttachment(skeleton, slot, slot.data.attachmentName, attachments);
        } else this.setAttachment(skeleton, slot, timeline.attachmentNames[(0, $hevjK.Timeline).search1(timeline.frames, time)], attachments);
        // If an attachment wasn't set (ie before the first frame or attachments is false), set the setup attachment later.
        if (slot.attachmentState <= this.unkeyedState) slot.attachmentState = this.unkeyedState + $15bd7a75a398401c$export$be88f4235204622a;
    }
    setAttachment(skeleton, slot, attachmentName, attachments) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
        if (attachments) slot.attachmentState = this.unkeyedState + $15bd7a75a398401c$export$eed19b551669af14;
    }
    applyRotateTimeline(timeline, skeleton, time, alpha, blend, timelinesRotation, i, firstFrame) {
        if (firstFrame) timelinesRotation[i] = 0;
        if (alpha == 1) {
            timeline.apply(skeleton, 0, time, null, 1, blend, (0, $hevjK.MixDirection).mixIn);
            return;
        }
        let bone = skeleton.bones[timeline.boneIndex];
        if (!bone.active) return;
        let frames = timeline.frames;
        let r1 = 0, r2 = 0;
        if (time < frames[0]) switch(blend){
            case (0, $hevjK.MixBlend).setup:
                bone.rotation = bone.data.rotation;
            default:
                return;
            case (0, $hevjK.MixBlend).first:
                r1 = bone.rotation;
                r2 = bone.data.rotation;
        }
        else {
            r1 = blend == (0, $hevjK.MixBlend).setup ? bone.data.rotation : bone.rotation;
            r2 = bone.data.rotation + timeline.getCurveValue(time);
        }
        // Mix between rotations using the direction of the shortest route on the first frame while detecting crosses.
        let total = 0, diff = r2 - r1;
        diff -= Math.ceil(diff / 360 - 0.5) * 360;
        if (diff == 0) total = timelinesRotation[i];
        else {
            let lastTotal = 0, lastDiff = 0;
            if (firstFrame) {
                lastTotal = 0;
                lastDiff = diff;
            } else {
                lastTotal = timelinesRotation[i];
                lastDiff = timelinesRotation[i + 1];
            }
            let loops = lastTotal - lastTotal % 360;
            total = diff + loops;
            let current = diff >= 0, dir = lastTotal >= 0;
            if (Math.abs(lastDiff) <= 90 && (0, $1Yup6.MathUtils).signum(lastDiff) != (0, $1Yup6.MathUtils).signum(diff)) {
                if (Math.abs(lastTotal - loops) > 180) {
                    total += 360 * (0, $1Yup6.MathUtils).signum(lastTotal);
                    dir = current;
                } else if (loops != 0) total -= 360 * (0, $1Yup6.MathUtils).signum(lastTotal);
                else dir = current;
            }
            if (dir != current) total += 360 * (0, $1Yup6.MathUtils).signum(lastTotal);
            timelinesRotation[i] = total;
        }
        timelinesRotation[i + 1] = diff;
        bone.rotation = r1 + total * alpha;
    }
    queueEvents(entry, animationTime) {
        let animationStart = entry.animationStart, animationEnd = entry.animationEnd;
        let duration = animationEnd - animationStart;
        let trackLastWrapped = entry.trackLast % duration;
        // Queue events before complete.
        let events = this.events;
        let i = 0, n = events.length;
        for(; i < n; i++){
            let event = events[i];
            if (event.time < trackLastWrapped) break;
            if (event.time > animationEnd) continue; // Discard events outside animation start/end.
            this.queue.event(entry, event);
        }
        // Queue complete if completed a loop iteration or the animation.
        let complete = false;
        if (entry.loop) {
            if (duration == 0) complete = true;
            else {
                const cycles = Math.floor(entry.trackTime / duration);
                complete = cycles > 0 && cycles > Math.floor(entry.trackLast / duration);
            }
        } else complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
        if (complete) this.queue.complete(entry);
        // Queue events after complete.
        for(; i < n; i++){
            let event = events[i];
            if (event.time < animationStart) continue; // Discard events outside animation start/end.
            this.queue.event(entry, event);
        }
    }
    /** Removes all animations from all tracks, leaving skeletons in their current pose.
     *
     * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
     * rather than leaving them in their current pose. */ clearTracks() {
        let oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++)this.clearTrack(i);
        this.tracks.length = 0;
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    /** Removes all animations from the track, leaving skeletons in their current pose.
     *
     * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
     * rather than leaving them in their current pose. */ clearTrack(trackIndex) {
        if (trackIndex >= this.tracks.length) return;
        let current = this.tracks[trackIndex];
        if (!current) return;
        this.queue.end(current);
        this.clearNext(current);
        let entry = current;
        while(true){
            let from = entry.mixingFrom;
            if (!from) break;
            this.queue.end(from);
            entry.mixingFrom = null;
            entry.mixingTo = null;
            entry = from;
        }
        this.tracks[current.trackIndex] = null;
        this.queue.drain();
    }
    setCurrent(index, current, interrupt) {
        let from = this.expandToIndex(index);
        this.tracks[index] = current;
        current.previous = null;
        if (from) {
            if (interrupt) this.queue.interrupt(from);
            current.mixingFrom = from;
            from.mixingTo = current;
            current.mixTime = 0;
            // Store the interrupted mix percentage.
            if (from.mixingFrom && from.mixDuration > 0) current.interruptAlpha *= Math.min(1, from.mixTime / from.mixDuration);
            from.timelinesRotation.length = 0; // Reset rotation for mixing out, in case entry was mixed in.
        }
        this.queue.start(current);
    }
    /** Sets an animation by name.
      *
      * See {@link #setAnimationWith()}. */ setAnimation(trackIndex, animationName, loop = false) {
        let animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error("Animation not found: " + animationName);
        return this.setAnimationWith(trackIndex, animation, loop);
    }
    /** Sets the current animation for a track, discarding any queued animations. If the formerly current track entry was never
     * applied to a skeleton, it is replaced (not mixed from).
     * @param loop If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
     *           duration. In either case {@link TrackEntry#trackEnd} determines when the track is cleared.
     * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ setAnimationWith(trackIndex, animation, loop = false) {
        if (!animation) throw new Error("animation cannot be null.");
        let interrupt = true;
        let current = this.expandToIndex(trackIndex);
        if (current) {
            if (current.nextTrackLast == -1) {
                // Don't mix from an entry that was never applied.
                this.tracks[trackIndex] = current.mixingFrom;
                this.queue.interrupt(current);
                this.queue.end(current);
                this.clearNext(current);
                current = current.mixingFrom;
                interrupt = false;
            } else this.clearNext(current);
        }
        let entry = this.trackEntry(trackIndex, animation, loop, current);
        this.setCurrent(trackIndex, entry, interrupt);
        this.queue.drain();
        return entry;
    }
    /** Queues an animation by name.
     *
     * See {@link #addAnimationWith()}. */ addAnimation(trackIndex, animationName, loop = false, delay = 0) {
        let animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error("Animation not found: " + animationName);
        return this.addAnimationWith(trackIndex, animation, loop, delay);
    }
    /** Adds an animation to be played after the current or last queued animation for a track. If the track is empty, it is
     * equivalent to calling {@link #setAnimationWith()}.
     * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
     *           minus any mix duration (from the {@link AnimationStateData}) plus the specified `delay` (ie the mix
     *           ends at (`delay` = 0) or before (`delay` < 0) the previous track entry duration). If the
     *           previous entry is looping, its next loop completion is used instead of its duration.
     * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ addAnimationWith(trackIndex, animation, loop = false, delay = 0) {
        if (!animation) throw new Error("animation cannot be null.");
        let last = this.expandToIndex(trackIndex);
        if (last) while(last.next)last = last.next;
        let entry = this.trackEntry(trackIndex, animation, loop, last);
        if (!last) {
            this.setCurrent(trackIndex, entry, true);
            this.queue.drain();
            if (delay < 0) delay = 0;
        } else {
            last.next = entry;
            entry.previous = last;
            if (delay <= 0) delay = Math.max(delay + last.getTrackComplete() - entry.mixDuration, 0);
        }
        entry.delay = delay;
        return entry;
    }
    /** Sets an empty animation for a track, discarding any queued animations, and sets the track entry's
     * {@link TrackEntry#mixduration}. An empty animation has no timelines and serves as a placeholder for mixing in or out.
     *
     * Mixing out is done by setting an empty animation with a mix duration using either {@link #setEmptyAnimation()},
     * {@link #setEmptyAnimations()}, or {@link #addEmptyAnimation()}. Mixing to an empty animation causes
     * the previous animation to be applied less and less over the mix duration. Properties keyed in the previous animation
     * transition to the value from lower tracks or to the setup pose value if no lower tracks key the property. A mix duration of
     * 0 still mixes out over one frame.
     *
     * Mixing in is done by first setting an empty animation, then adding an animation using
     * {@link #addAnimation()} and on the returned track entry, set the
     * {@link TrackEntry#setMixDuration()}. Mixing from an empty animation causes the new animation to be applied more and
     * more over the mix duration. Properties keyed in the new animation transition from the value from lower tracks or from the
     * setup pose value if no lower tracks key the property to the value keyed in the new animation. */ setEmptyAnimation(trackIndex, mixDuration = 0) {
        let entry = this.setAnimationWith(trackIndex, $15bd7a75a398401c$export$d0f7a26c90cc1562.emptyAnimation(), false);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Adds an empty animation to be played after the current or last queued animation for a track, and sets the track entry's
     * {@link TrackEntry#mixDuration}. If the track is empty, it is equivalent to calling
     * {@link #setEmptyAnimation()}.
     *
     * See {@link #setEmptyAnimation()}.
     * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
     *           minus any mix duration plus the specified `delay` (ie the mix ends at (`delay` = 0) or
     *           before (`delay` < 0) the previous track entry duration). If the previous entry is looping, its next
     *           loop completion is used instead of its duration.
     * @return A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ addEmptyAnimation(trackIndex, mixDuration = 0, delay = 0) {
        let entry = this.addAnimationWith(trackIndex, $15bd7a75a398401c$export$d0f7a26c90cc1562.emptyAnimation(), false, delay);
        if (delay <= 0) entry.delay = Math.max(entry.delay + entry.mixDuration - mixDuration, 0);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Sets an empty animation for every track, discarding any queued animations, and mixes to it over the specified mix
      * duration. */ setEmptyAnimations(mixDuration = 0) {
        let oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++){
            let current = this.tracks[i];
            if (current) this.setEmptyAnimation(current.trackIndex, mixDuration);
        }
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    expandToIndex(index) {
        if (index < this.tracks.length) return this.tracks[index];
        (0, $1Yup6.Utils).ensureArrayCapacity(this.tracks, index + 1, null);
        this.tracks.length = index + 1;
        return null;
    }
    /** @param last May be null. */ trackEntry(trackIndex, animation, loop, last) {
        let entry = this.trackEntryPool.obtain();
        entry.reset();
        entry.trackIndex = trackIndex;
        entry.animation = animation;
        entry.loop = loop;
        entry.holdPrevious = false;
        entry.reverse = false;
        entry.shortestRotation = false;
        entry.eventThreshold = 0;
        entry.alphaAttachmentThreshold = 0;
        entry.mixAttachmentThreshold = 0;
        entry.mixDrawOrderThreshold = 0;
        entry.animationStart = 0;
        entry.animationEnd = animation.duration;
        entry.animationLast = -1;
        entry.nextAnimationLast = -1;
        entry.delay = 0;
        entry.trackTime = 0;
        entry.trackLast = -1;
        entry.nextTrackLast = -1;
        entry.trackEnd = Number.MAX_VALUE;
        entry.timeScale = 1;
        entry.alpha = 1;
        entry.mixTime = 0;
        entry.mixDuration = !last ? 0 : this.data.getMix(last.animation, animation);
        entry.interruptAlpha = 1;
        entry.totalAlpha = 0;
        entry.mixBlend = (0, $hevjK.MixBlend).replace;
        return entry;
    }
    /** Removes the {@link TrackEntry#getNext() next entry} and all entries after it for the specified entry. */ clearNext(entry) {
        let next = entry.next;
        while(next){
            this.queue.dispose(next);
            next = next.next;
        }
        entry.next = null;
    }
    _animationsChanged() {
        this.animationsChanged = false;
        this.propertyIDs.clear();
        let tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            let entry = tracks[i];
            if (!entry) continue;
            while(entry.mixingFrom)entry = entry.mixingFrom;
            do {
                if (!entry.mixingTo || entry.mixBlend != (0, $hevjK.MixBlend).add) this.computeHold(entry);
                entry = entry.mixingTo;
            }while (entry);
        }
    }
    computeHold(entry) {
        let to = entry.mixingTo;
        let timelines = entry.animation.timelines;
        let timelinesCount = entry.animation.timelines.length;
        let timelineMode = entry.timelineMode;
        timelineMode.length = timelinesCount;
        let timelineHoldMix = entry.timelineHoldMix;
        timelineHoldMix.length = 0;
        let propertyIDs = this.propertyIDs;
        if (to && to.holdPrevious) {
            for(let i = 0; i < timelinesCount; i++)timelineMode[i] = propertyIDs.addAll(timelines[i].getPropertyIds()) ? $15bd7a75a398401c$export$83263fba6795a4f7 : $15bd7a75a398401c$export$61db7ea55ff2bc4f;
            return;
        }
        outer: for(let i = 0; i < timelinesCount; i++){
            let timeline = timelines[i];
            let ids = timeline.getPropertyIds();
            if (!propertyIDs.addAll(ids)) timelineMode[i] = $15bd7a75a398401c$export$89027c4cc247cc19;
            else if (!to || timeline instanceof (0, $hevjK.AttachmentTimeline) || timeline instanceof (0, $hevjK.DrawOrderTimeline) || timeline instanceof (0, $hevjK.EventTimeline) || !to.animation.hasTimeline(ids)) timelineMode[i] = $15bd7a75a398401c$export$9f55c59c79ce7630;
            else {
                for(let next = to.mixingTo; next; next = next.mixingTo){
                    if (next.animation.hasTimeline(ids)) continue;
                    if (entry.mixDuration > 0) {
                        timelineMode[i] = $15bd7a75a398401c$export$68479a2ca54edfe5;
                        timelineHoldMix[i] = next;
                        continue outer;
                    }
                    break;
                }
                timelineMode[i] = $15bd7a75a398401c$export$83263fba6795a4f7;
            }
        }
    }
    /** Returns the track entry for the animation currently playing on the track, or null if no animation is currently playing. */ getCurrent(trackIndex) {
        if (trackIndex >= this.tracks.length) return null;
        return this.tracks[trackIndex];
    }
    /** Adds a listener to receive events for all track entries. */ addListener(listener) {
        if (!listener) throw new Error("listener cannot be null.");
        this.listeners.push(listener);
    }
    /** Removes the listener added with {@link #addListener()}. */ removeListener(listener) {
        let index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
    }
    /** Removes all listeners added with {@link #addListener()}. */ clearListeners() {
        this.listeners.length = 0;
    }
    /** Discards all listener notifications that have not yet been delivered. This can be useful to call from an
     * {@link AnimationStateListener} when it is known that further notifications that may have been already queued for delivery
     * are not wanted because new animations are being set. */ clearListenerNotifications() {
        this.queue.clear();
    }
}
class $15bd7a75a398401c$export$6fd48f25bc0ee658 {
    /** The animation to apply for this track entry. */ animation = null;
    previous = null;
    /** The animation queued to start after this animation, or null. `next` makes up a linked list. */ next = null;
    /** The track entry for the previous animation when mixing from the previous animation to this animation, or null if no
     * mixing is currently occuring. When mixing from multiple animations, `mixingFrom` makes up a linked list. */ mixingFrom = null;
    /** The track entry for the next animation when mixing from this animation to the next animation, or null if no mixing is
     * currently occuring. When mixing to multiple animations, `mixingTo` makes up a linked list. */ mixingTo = null;
    /** The listener for events generated by this track entry, or null.
     *
     * A track entry returned from {@link AnimationState#setAnimation()} is already the current animation
     * for the track, so the track entry listener {@link AnimationStateListener#start()} will not be called. */ listener = null;
    /** The index of the track where this track entry is either current or queued.
     *
     * See {@link AnimationState#getCurrent()}. */ trackIndex = 0;
    /** If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
     * duration. */ loop = false;
    /** If true, when mixing from the previous animation to this animation, the previous animation is applied as normal instead
     * of being mixed out.
     *
     * When mixing between animations that key the same property, if a lower track also keys that property then the value will
     * briefly dip toward the lower track value during the mix. This happens because the first animation mixes from 100% to 0%
     * while the second animation mixes from 0% to 100%. Setting `holdPrevious` to true applies the first animation
     * at 100% during the mix so the lower track value is overwritten. Such dipping does not occur on the lowest track which
     * keys the property, only when a higher track also keys the property.
     *
     * Snapping will occur if `holdPrevious` is true and this animation does not key all the same properties as the
     * previous animation. */ holdPrevious = false;
    reverse = false;
    shortestRotation = false;
    /** When the mix percentage ({@link #mixTime} / {@link #mixDuration}) is less than the
     * `eventThreshold`, event timelines are applied while this animation is being mixed out. Defaults to 0, so event
     * timelines are not applied while this animation is being mixed out. */ eventThreshold = 0;
    /** When the mix percentage ({@link #mixtime} / {@link #mixDuration}) is less than the
     * `attachmentThreshold`, attachment timelines are applied while this animation is being mixed out. Defaults to
     * 0, so attachment timelines are not applied while this animation is being mixed out. */ mixAttachmentThreshold = 0;
    /** When {@link #getAlpha()} is greater than <code>alphaAttachmentThreshold</code>, attachment timelines are applied.
     * Defaults to 0, so attachment timelines are always applied. */ alphaAttachmentThreshold = 0;
    /** When the mix percentage ({@link #getMixTime()} / {@link #getMixDuration()}) is less than the
     * <code>mixDrawOrderThreshold</code>, draw order timelines are applied while this animation is being mixed out. Defaults to
     * 0, so draw order timelines are not applied while this animation is being mixed out. */ mixDrawOrderThreshold = 0;
    /** Seconds when this animation starts, both initially and after looping. Defaults to 0.
     *
     * When changing the `animationStart` time, it often makes sense to set {@link #animationLast} to the same
     * value to prevent timeline keys before the start time from triggering. */ animationStart = 0;
    /** Seconds for the last frame of this animation. Non-looping animations won't play past this time. Looping animations will
     * loop back to {@link #animationStart} at this time. Defaults to the animation {@link Animation#duration}. */ animationEnd = 0;
    /** The time in seconds this animation was last applied. Some timelines use this for one-time triggers. Eg, when this
     * animation is applied, event timelines will fire all events between the `animationLast` time (exclusive) and
     * `animationTime` (inclusive). Defaults to -1 to ensure triggers on frame 0 happen the first time this animation
     * is applied. */ animationLast = 0;
    nextAnimationLast = 0;
    /** Seconds to postpone playing the animation. When this track entry is the current track entry, `delay`
     * postpones incrementing the {@link #trackTime}. When this track entry is queued, `delay` is the time from
     * the start of the previous animation to when this track entry will become the current track entry (ie when the previous
     * track entry {@link TrackEntry#trackTime} >= this track entry's `delay`).
     *
     * {@link #timeScale} affects the delay. */ delay = 0;
    /** Current time in seconds this track entry has been the current track entry. The track time determines
     * {@link #animationTime}. The track time can be set to start the animation at a time other than 0, without affecting
     * looping. */ trackTime = 0;
    trackLast = 0;
    nextTrackLast = 0;
    /** The track time in seconds when this animation will be removed from the track. Defaults to the highest possible float
     * value, meaning the animation will be applied until a new animation is set or the track is cleared. If the track end time
     * is reached, no other animations are queued for playback, and mixing from any previous animations is complete, then the
     * properties keyed by the animation are set to the setup pose and the track is cleared.
     *
     * It may be desired to use {@link AnimationState#addEmptyAnimation()} rather than have the animation
     * abruptly cease being applied. */ trackEnd = 0;
    /** Multiplier for the delta time when this track entry is updated, causing time for this animation to pass slower or
     * faster. Defaults to 1.
     *
     * {@link #mixTime} is not affected by track entry time scale, so {@link #mixDuration} may need to be adjusted to
     * match the animation speed.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, assuming time scale to be 1. If
     * the time scale is not 1, the delay may need to be adjusted.
     *
     * See AnimationState {@link AnimationState#timeScale} for affecting all animations. */ timeScale = 0;
    /** Values < 1 mix this animation with the skeleton's current pose (usually the pose resulting from lower tracks). Defaults
     * to 1, which overwrites the skeleton's current pose with this animation.
     *
     * Typically track 0 is used to completely pose the skeleton, then alpha is used on higher tracks. It doesn't make sense to
     * use alpha on track 0 if the skeleton pose is from the last frame render. */ alpha = 0;
    /** Seconds from 0 to the {@link #getMixDuration()} when mixing from the previous animation to this animation. May be
     * slightly more than `mixDuration` when the mix is complete. */ mixTime = 0;
    /** Seconds for mixing from the previous animation to this animation. Defaults to the value provided by AnimationStateData
     * {@link AnimationStateData#getMix()} based on the animation before this animation (if any).
     *
     * A mix duration of 0 still mixes out over one frame to provide the track entry being mixed out a chance to revert the
     * properties it was animating.
     *
     * The `mixDuration` can be set manually rather than use the value from
     * {@link AnimationStateData#getMix()}. In that case, the `mixDuration` can be set for a new
     * track entry only before {@link AnimationState#update(float)} is first called.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, not a mix duration set
     * afterward. */ _mixDuration = 0;
    interruptAlpha = 0;
    totalAlpha = 0;
    get mixDuration() {
        return this._mixDuration;
    }
    set mixDuration(mixDuration) {
        this._mixDuration = mixDuration;
    }
    setMixDurationWithDelay(mixDuration, delay) {
        this._mixDuration = mixDuration;
        if (delay <= 0) {
            if (this.previous != null) delay = Math.max(delay + this.previous.getTrackComplete() - mixDuration, 0);
            else delay = 0;
        }
        this.delay = delay;
    }
    /** Controls how properties keyed in the animation are mixed with lower tracks. Defaults to {@link MixBlend#replace}, which
     * replaces the values from the lower tracks with the animation values. {@link MixBlend#add} adds the animation values to
     * the values from the lower tracks.
     *
     * The `mixBlend` can be set for a new track entry only before {@link AnimationState#apply()} is first
     * called. */ mixBlend = (0, $hevjK.MixBlend).replace;
    timelineMode = new Array();
    timelineHoldMix = new Array();
    timelinesRotation = new Array();
    reset() {
        this.next = null;
        this.previous = null;
        this.mixingFrom = null;
        this.mixingTo = null;
        this.animation = null;
        this.listener = null;
        this.timelineMode.length = 0;
        this.timelineHoldMix.length = 0;
        this.timelinesRotation.length = 0;
    }
    /** Uses {@link #trackTime} to compute the `animationTime`, which is between {@link #animationStart}
     * and {@link #animationEnd}. When the `trackTime` is 0, the `animationTime` is equal to the
     * `animationStart` time. */ getAnimationTime() {
        if (this.loop) {
            let duration = this.animationEnd - this.animationStart;
            if (duration == 0) return this.animationStart;
            return this.trackTime % duration + this.animationStart;
        }
        return Math.min(this.trackTime + this.animationStart, this.animationEnd);
    }
    setAnimationLast(animationLast) {
        this.animationLast = animationLast;
        this.nextAnimationLast = animationLast;
    }
    /** Returns true if at least one loop has been completed.
     *
     * See {@link AnimationStateListener#complete()}. */ isComplete() {
        return this.trackTime >= this.animationEnd - this.animationStart;
    }
    /** Resets the rotation directions for mixing this entry's rotate timelines. This can be useful to avoid bones rotating the
     * long way around when using {@link #alpha} and starting animations on other tracks.
     *
     * Mixing with {@link MixBlend#replace} involves finding a rotation between two others, which has two possible solutions:
     * the short way or the long way around. The two rotations likely change over time, so which direction is the short or long
     * way also changes. If the short way was always chosen, bones would flip to the other side when that direction became the
     * long way. TrackEntry chooses the short way the first time it is applied and remembers that direction. */ resetRotationDirections() {
        this.timelinesRotation.length = 0;
    }
    getTrackComplete() {
        let duration = this.animationEnd - this.animationStart;
        if (duration != 0) {
            if (this.loop) return duration * (1 + (this.trackTime / duration | 0)); // Completion of next loop.
            if (this.trackTime < duration) return duration; // Before duration.
        }
        return this.trackTime; // Next update.
    }
    /** Returns true if this track entry has been applied at least once.
     * <p>
     * See {@link AnimationState#apply(Skeleton)}. */ wasApplied() {
        return this.nextTrackLast != -1;
    }
    /** Returns true if there is a {@link #getNext()} track entry and it will become the current track entry during the next
     * {@link AnimationState#update(float)}. */ isNextReady() {
        return this.next != null && this.nextTrackLast - this.next.delay >= 0;
    }
}
class $15bd7a75a398401c$export$2fc6338444a158e6 {
    objects = [];
    drainDisabled = false;
    animState;
    constructor(animState){
        this.animState = animState;
    }
    start(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.start);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    interrupt(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.interrupt);
        this.objects.push(entry);
    }
    end(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.end);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    dispose(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.dispose);
        this.objects.push(entry);
    }
    complete(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.complete);
        this.objects.push(entry);
    }
    event(entry, event) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.event);
        this.objects.push(entry);
        this.objects.push(event);
    }
    drain() {
        if (this.drainDisabled) return;
        this.drainDisabled = true;
        let objects = this.objects;
        let listeners = this.animState.listeners;
        for(let i = 0; i < objects.length; i += 2){
            let type = objects[i];
            let entry = objects[i + 1];
            switch(type){
                case $15bd7a75a398401c$export$3d7865934588d77e.start:
                    if (entry.listener && entry.listener.start) entry.listener.start(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.start) listener.start(entry);
                    }
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.interrupt:
                    if (entry.listener && entry.listener.interrupt) entry.listener.interrupt(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.interrupt) listener.interrupt(entry);
                    }
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.end:
                    if (entry.listener && entry.listener.end) entry.listener.end(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.end) listener.end(entry);
                    }
                // Fall through.
                case $15bd7a75a398401c$export$3d7865934588d77e.dispose:
                    if (entry.listener && entry.listener.dispose) entry.listener.dispose(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.dispose) listener.dispose(entry);
                    }
                    this.animState.trackEntryPool.free(entry);
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.complete:
                    if (entry.listener && entry.listener.complete) entry.listener.complete(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.complete) listener.complete(entry);
                    }
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.event:
                    let event = objects[i++ + 2];
                    if (entry.listener && entry.listener.event) entry.listener.event(entry, event);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.event) listener.event(entry, event);
                    }
                    break;
            }
        }
        this.clear();
        this.drainDisabled = false;
    }
    clear() {
        this.objects.length = 0;
    }
}
var $15bd7a75a398401c$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["start"] = 0] = "start";
    EventType[EventType["interrupt"] = 1] = "interrupt";
    EventType[EventType["end"] = 2] = "end";
    EventType[EventType["dispose"] = 3] = "dispose";
    EventType[EventType["complete"] = 4] = "complete";
    EventType[EventType["event"] = 5] = "event";
})($15bd7a75a398401c$export$3d7865934588d77e || ($15bd7a75a398401c$export$3d7865934588d77e = {}));
class $15bd7a75a398401c$export$31af0cf42be5a74d {
    start(entry) {}
    interrupt(entry) {}
    end(entry) {}
    dispose(entry) {}
    complete(entry) {}
    event(entry, event) {}
}
const $15bd7a75a398401c$export$89027c4cc247cc19 = 0;
const $15bd7a75a398401c$export$9f55c59c79ce7630 = 1;
const $15bd7a75a398401c$export$61db7ea55ff2bc4f = 2;
const $15bd7a75a398401c$export$83263fba6795a4f7 = 3;
const $15bd7a75a398401c$export$68479a2ca54edfe5 = 4;
const $15bd7a75a398401c$export$be88f4235204622a = 1;
const $15bd7a75a398401c$export$eed19b551669af14 = 2;

});

parcelRegister("1LYJi", function(module, exports) {

$parcel$export(module.exports, "AnimationStateData", () => $14a949d916e0f278$export$90d7167cc0605975);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores mix (crossfade) durations to be applied when {@link AnimationState} animations are changed. */ class $14a949d916e0f278$export$90d7167cc0605975 {
    /** The SkeletonData to look up animations when they are specified by name. */ skeletonData;
    animationToMixTime = {};
    /** The mix duration to use when no mix duration has been defined between two animations. */ defaultMix = 0;
    constructor(skeletonData){
        if (!skeletonData) throw new Error("skeletonData cannot be null.");
        this.skeletonData = skeletonData;
    }
    /** Sets a mix duration by animation name.
     *
     * See {@link #setMixWith()}. */ setMix(fromName, toName, duration) {
        let from = this.skeletonData.findAnimation(fromName);
        if (!from) throw new Error("Animation not found: " + fromName);
        let to = this.skeletonData.findAnimation(toName);
        if (!to) throw new Error("Animation not found: " + toName);
        this.setMixWith(from, to, duration);
    }
    /** Sets the mix duration when changing from the specified animation to the other.
     *
     * See {@link TrackEntry#mixDuration}. */ setMixWith(from, to, duration) {
        if (!from) throw new Error("from cannot be null.");
        if (!to) throw new Error("to cannot be null.");
        let key = from.name + "." + to.name;
        this.animationToMixTime[key] = duration;
    }
    /** Returns the mix duration to use when changing from the specified animation to the other, or the {@link #defaultMix} if
      * no mix duration has been set. */ getMix(from, to) {
        let key = from.name + "." + to.name;
        let value = this.animationToMixTime[key];
        return value === undefined ? this.defaultMix : value;
    }
}

});

parcelRegister("2mGUN", function(module, exports) {

$parcel$export(module.exports, "AtlasAttachmentLoader", () => $1b8eecdee9c89b5e$export$2ff9add835475d95);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $6LxqM = parcelRequire("6LxqM");

var $hePJB = parcelRequire("hePJB");

var $5ot6H = parcelRequire("5ot6H");

var $46qOI = parcelRequire("46qOI");

var $hxr00 = parcelRequire("hxr00");

var $8wKGy = parcelRequire("8wKGy");
class $1b8eecdee9c89b5e$export$2ff9add835475d95 {
    atlas;
    constructor(atlas){
        this.atlas = atlas;
    }
    loadSequence(name, basePath, sequence) {
        let regions = sequence.regions;
        for(let i = 0, n = regions.length; i < n; i++){
            let path = sequence.getPath(basePath, i);
            let region = this.atlas.findRegion(path);
            if (region == null) throw new Error("Region not found in atlas: " + path + " (sequence: " + name + ")");
            regions[i] = region;
        }
    }
    newRegionAttachment(skin, name, path, sequence) {
        let attachment = new (0, $8wKGy.RegionAttachment)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            let region = this.atlas.findRegion(path);
            if (!region) throw new Error("Region not found in atlas: " + path + " (region attachment: " + name + ")");
            attachment.region = region;
        }
        return attachment;
    }
    newMeshAttachment(skin, name, path, sequence) {
        let attachment = new (0, $5ot6H.MeshAttachment)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            let region = this.atlas.findRegion(path);
            if (!region) throw new Error("Region not found in atlas: " + path + " (mesh attachment: " + name + ")");
            attachment.region = region;
        }
        return attachment;
    }
    newBoundingBoxAttachment(skin, name) {
        return new (0, $6LxqM.BoundingBoxAttachment)(name);
    }
    newPathAttachment(skin, name) {
        return new (0, $46qOI.PathAttachment)(name);
    }
    newPointAttachment(skin, name) {
        return new (0, $hxr00.PointAttachment)(name);
    }
    newClippingAttachment(skin, name) {
        return new (0, $hePJB.ClippingAttachment)(name);
    }
}

});
parcelRegister("6LxqM", function(module, exports) {

$parcel$export(module.exports, "BoundingBoxAttachment", () => $4ed11088ab57e209$export$9538c439c6b85ad2);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");

var $5a4jk = parcelRequire("5a4jk");
class $4ed11088ab57e209$export$9538c439c6b85ad2 extends (0, $5a4jk.VertexAttachment) {
    color = new (0, $1Yup6.Color)(1, 1, 1, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $4ed11088ab57e209$export$9538c439c6b85ad2(this.name);
        this.copyTo(copy);
        copy.color.setFromColor(this.color);
        return copy;
    }
}

});

parcelRegister("hePJB", function(module, exports) {

$parcel$export(module.exports, "ClippingAttachment", () => $c8cbdfdbe3e3034c$export$838805e22b9b55f1);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");

var $5a4jk = parcelRequire("5a4jk");
class $c8cbdfdbe3e3034c$export$838805e22b9b55f1 extends (0, $5a4jk.VertexAttachment) {
    /** Clipping is performed between the clipping polygon's slot and the end slot. Returns null if clipping is done until the end of
     * the skeleton's rendering. */ endSlot = null;
    // Nonessential.
    /** The color of the clipping polygon as it was in Spine. Available only when nonessential data was exported. Clipping polygons
     * are not usually rendered at runtime. */ color = new (0, $1Yup6.Color)(0.2275, 0.2275, 0.8078, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $c8cbdfdbe3e3034c$export$838805e22b9b55f1(this.name);
        this.copyTo(copy);
        copy.endSlot = this.endSlot;
        copy.color.setFromColor(this.color);
        return copy;
    }
}

});

parcelRegister("5ot6H", function(module, exports) {

$parcel$export(module.exports, "MeshAttachment", () => $3ed5c5afaf00d170$export$3f1c1692adfcf3e2);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $cQp1s = parcelRequire("cQp1s");

var $1Yup6 = parcelRequire("1Yup6");

var $5a4jk = parcelRequire("5a4jk");
class $3ed5c5afaf00d170$export$3f1c1692adfcf3e2 extends (0, $5a4jk.VertexAttachment) {
    region = null;
    /** The name of the texture region for this attachment. */ path;
    /** The UV pair for each vertex, normalized within the texture region. */ regionUVs = [];
    /** The UV pair for each vertex, normalized within the entire texture.
     *
     * See {@link #updateUVs}. */ uvs = [];
    /** Triplets of vertex indices which describe the mesh's triangulation. */ triangles = [];
    /** The color to tint the mesh. */ color = new (0, $1Yup6.Color)(1, 1, 1, 1);
    /** The width of the mesh's image. Available only when nonessential data was exported. */ width = 0;
    /** The height of the mesh's image. Available only when nonessential data was exported. */ height = 0;
    /** The number of entries at the beginning of {@link #vertices} that make up the mesh hull. */ hullLength = 0;
    /** Vertex index pairs describing edges for controling triangulation. Mesh triangles will never cross edges. Only available if
     * nonessential data was exported. Triangulation is not performed at runtime. */ edges = [];
    parentMesh = null;
    sequence = null;
    tempColor = new (0, $1Yup6.Color)(0, 0, 0, 0);
    constructor(name, path){
        super(name);
        this.path = path;
    }
    /** Calculates {@link #uvs} using the {@link #regionUVs} and region. Must be called if the region, the region's properties, or
     * the {@link #regionUVs} are changed. */ updateRegion() {
        if (!this.region) throw new Error("Region not set.");
        let regionUVs = this.regionUVs;
        if (!this.uvs || this.uvs.length != regionUVs.length) this.uvs = (0, $1Yup6.Utils).newFloatArray(regionUVs.length);
        let uvs = this.uvs;
        let n = this.uvs.length;
        let u = this.region.u, v = this.region.v, width = 0, height = 0;
        if (this.region instanceof (0, $cQp1s.TextureAtlasRegion)) {
            let region = this.region, page = region.page;
            let textureWidth = page.width, textureHeight = page.height;
            switch(region.degrees){
                case 90:
                    u -= (region.originalHeight - region.offsetY - region.height) / textureWidth;
                    v -= (region.originalWidth - region.offsetX - region.width) / textureHeight;
                    width = region.originalHeight / textureWidth;
                    height = region.originalWidth / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + regionUVs[i + 1] * width;
                        uvs[i + 1] = v + (1 - regionUVs[i]) * height;
                    }
                    return;
                case 180:
                    u -= (region.originalWidth - region.offsetX - region.width) / textureWidth;
                    v -= region.offsetY / textureHeight;
                    width = region.originalWidth / textureWidth;
                    height = region.originalHeight / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + (1 - regionUVs[i]) * width;
                        uvs[i + 1] = v + (1 - regionUVs[i + 1]) * height;
                    }
                    return;
                case 270:
                    u -= region.offsetY / textureWidth;
                    v -= region.offsetX / textureHeight;
                    width = region.originalHeight / textureWidth;
                    height = region.originalWidth / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + (1 - regionUVs[i + 1]) * width;
                        uvs[i + 1] = v + regionUVs[i] * height;
                    }
                    return;
            }
            u -= region.offsetX / textureWidth;
            v -= (region.originalHeight - region.offsetY - region.height) / textureHeight;
            width = region.originalWidth / textureWidth;
            height = region.originalHeight / textureHeight;
        } else if (!this.region) {
            u = v = 0;
            width = height = 1;
        } else {
            width = this.region.u2 - u;
            height = this.region.v2 - v;
        }
        for(let i = 0; i < n; i += 2){
            uvs[i] = u + regionUVs[i] * width;
            uvs[i + 1] = v + regionUVs[i + 1] * height;
        }
    }
    /** The parent mesh if this is a linked mesh, else null. A linked mesh shares the {@link #bones}, {@link #vertices},
     * {@link #regionUVs}, {@link #triangles}, {@link #hullLength}, {@link #edges}, {@link #width}, and {@link #height} with the
     * parent mesh, but may have a different {@link #name} or {@link #path} (and therefore a different texture). */ getParentMesh() {
        return this.parentMesh;
    }
    /** @param parentMesh May be null. */ setParentMesh(parentMesh) {
        this.parentMesh = parentMesh;
        if (parentMesh) {
            this.bones = parentMesh.bones;
            this.vertices = parentMesh.vertices;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
            this.regionUVs = parentMesh.regionUVs;
            this.triangles = parentMesh.triangles;
            this.hullLength = parentMesh.hullLength;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
        }
    }
    copy() {
        if (this.parentMesh) return this.newLinkedMesh();
        let copy = new $3ed5c5afaf00d170$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        this.copyTo(copy);
        copy.regionUVs = new Array(this.regionUVs.length);
        (0, $1Yup6.Utils).arrayCopy(this.regionUVs, 0, copy.regionUVs, 0, this.regionUVs.length);
        copy.uvs = this.uvs instanceof Float32Array ? (0, $1Yup6.Utils).newFloatArray(this.uvs.length) : new Array(this.uvs.length);
        (0, $1Yup6.Utils).arrayCopy(this.uvs, 0, copy.uvs, 0, this.uvs.length);
        copy.triangles = new Array(this.triangles.length);
        (0, $1Yup6.Utils).arrayCopy(this.triangles, 0, copy.triangles, 0, this.triangles.length);
        copy.hullLength = this.hullLength;
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        // Nonessential.
        if (this.edges) {
            copy.edges = new Array(this.edges.length);
            (0, $1Yup6.Utils).arrayCopy(this.edges, 0, copy.edges, 0, this.edges.length);
        }
        copy.width = this.width;
        copy.height = this.height;
        return copy;
    }
    computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        super.computeWorldVertices(slot, start, count, worldVertices, offset, stride);
    }
    /** Returns a new mesh with the {@link #parentMesh} set to this mesh's parent mesh, if any, else to this mesh. **/ newLinkedMesh() {
        let copy = new $3ed5c5afaf00d170$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        copy.timelineAttachment = this.timelineAttachment;
        copy.setParentMesh(this.parentMesh ? this.parentMesh : this);
        if (copy.region != null) copy.updateRegion();
        return copy;
    }
}

});
parcelRegister("cQp1s", function(module, exports) {

$parcel$export(module.exports, "TextureAtlas", () => $959dc053f9cefaa3$export$1ffc3159823e6649);
$parcel$export(module.exports, "TextureAtlasRegion", () => $959dc053f9cefaa3$export$6c0770e21c633916);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $66uC2 = parcelRequire("66uC2");

var $1Yup6 = parcelRequire("1Yup6");
class $959dc053f9cefaa3$export$1ffc3159823e6649 {
    pages = new Array();
    regions = new Array();
    constructor(atlasText){
        let reader = new $959dc053f9cefaa3$var$TextureAtlasReader(atlasText);
        let entry = new Array(4);
        let pageFields = {};
        pageFields["size"] = (page)=>{
            page.width = parseInt(entry[1]);
            page.height = parseInt(entry[2]);
        };
        pageFields["format"] = ()=>{
        // page.format = Format[tuple[0]]; we don't need format in WebGL
        };
        pageFields["filter"] = (page)=>{
            page.minFilter = (0, $1Yup6.Utils).enumValue((0, $66uC2.TextureFilter), entry[1]);
            page.magFilter = (0, $1Yup6.Utils).enumValue((0, $66uC2.TextureFilter), entry[2]);
        };
        pageFields["repeat"] = (page)=>{
            if (entry[1].indexOf('x') != -1) page.uWrap = (0, $66uC2.TextureWrap).Repeat;
            if (entry[1].indexOf('y') != -1) page.vWrap = (0, $66uC2.TextureWrap).Repeat;
        };
        pageFields["pma"] = (page)=>{
            page.pma = entry[1] == "true";
        };
        var regionFields = {};
        regionFields["xy"] = (region)=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
        };
        regionFields["size"] = (region)=>{
            region.width = parseInt(entry[1]);
            region.height = parseInt(entry[2]);
        };
        regionFields["bounds"] = (region)=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
            region.width = parseInt(entry[3]);
            region.height = parseInt(entry[4]);
        };
        regionFields["offset"] = (region)=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
        };
        regionFields["orig"] = (region)=>{
            region.originalWidth = parseInt(entry[1]);
            region.originalHeight = parseInt(entry[2]);
        };
        regionFields["offsets"] = (region)=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
            region.originalWidth = parseInt(entry[3]);
            region.originalHeight = parseInt(entry[4]);
        };
        regionFields["rotate"] = (region)=>{
            let value = entry[1];
            if (value == "true") region.degrees = 90;
            else if (value != "false") region.degrees = parseInt(value);
        };
        regionFields["index"] = (region)=>{
            region.index = parseInt(entry[1]);
        };
        let line = reader.readLine();
        // Ignore empty lines before first entry.
        while(line && line.trim().length == 0)line = reader.readLine();
        // Header entries.
        while(true){
            if (!line || line.trim().length == 0) break;
            if (reader.readEntry(entry, line) == 0) break; // Silently ignore all header fields.
            line = reader.readLine();
        }
        // Page and region entries.
        let page = null;
        let names = null;
        let values = null;
        while(true){
            if (line === null) break;
            if (line.trim().length == 0) {
                page = null;
                line = reader.readLine();
            } else if (!page) {
                page = new $959dc053f9cefaa3$export$1a5db136de4137c2(line.trim());
                while(true){
                    if (reader.readEntry(entry, line = reader.readLine()) == 0) break;
                    let field = pageFields[entry[0]];
                    if (field) field(page);
                }
                this.pages.push(page);
            } else {
                let region = new $959dc053f9cefaa3$export$6c0770e21c633916(page, line);
                while(true){
                    let count = reader.readEntry(entry, line = reader.readLine());
                    if (count == 0) break;
                    let field = regionFields[entry[0]];
                    if (field) field(region);
                    else {
                        if (!names) names = [];
                        if (!values) values = [];
                        names.push(entry[0]);
                        let entryValues = [];
                        for(let i = 0; i < count; i++)entryValues.push(parseInt(entry[i + 1]));
                        values.push(entryValues);
                    }
                }
                if (region.originalWidth == 0 && region.originalHeight == 0) {
                    region.originalWidth = region.width;
                    region.originalHeight = region.height;
                }
                if (names && names.length > 0 && values && values.length > 0) {
                    region.names = names;
                    region.values = values;
                    names = null;
                    values = null;
                }
                region.u = region.x / page.width;
                region.v = region.y / page.height;
                if (region.degrees == 90) {
                    region.u2 = (region.x + region.height) / page.width;
                    region.v2 = (region.y + region.width) / page.height;
                } else {
                    region.u2 = (region.x + region.width) / page.width;
                    region.v2 = (region.y + region.height) / page.height;
                }
                this.regions.push(region);
            }
        }
    }
    findRegion(name) {
        for(let i = 0; i < this.regions.length; i++){
            if (this.regions[i].name == name) return this.regions[i];
        }
        return null;
    }
    setTextures(assetManager, pathPrefix = "") {
        for (let page of this.pages)page.setTexture(assetManager.get(pathPrefix + page.name));
    }
    dispose() {
        for(let i = 0; i < this.pages.length; i++)this.pages[i].texture?.dispose();
    }
}
class $959dc053f9cefaa3$var$TextureAtlasReader {
    lines;
    index = 0;
    constructor(text){
        this.lines = text.split(/\r\n|\r|\n/);
    }
    readLine() {
        if (this.index >= this.lines.length) return null;
        return this.lines[this.index++];
    }
    readEntry(entry, line) {
        if (!line) return 0;
        line = line.trim();
        if (line.length == 0) return 0;
        let colon = line.indexOf(':');
        if (colon == -1) return 0;
        entry[0] = line.substr(0, colon).trim();
        for(let i = 1, lastMatch = colon + 1;; i++){
            let comma = line.indexOf(',', lastMatch);
            if (comma == -1) {
                entry[i] = line.substr(lastMatch).trim();
                return i;
            }
            entry[i] = line.substr(lastMatch, comma - lastMatch).trim();
            lastMatch = comma + 1;
            if (i == 4) return 4;
        }
    }
}
class $959dc053f9cefaa3$export$1a5db136de4137c2 {
    name;
    minFilter = (0, $66uC2.TextureFilter).Nearest;
    magFilter = (0, $66uC2.TextureFilter).Nearest;
    uWrap = (0, $66uC2.TextureWrap).ClampToEdge;
    vWrap = (0, $66uC2.TextureWrap).ClampToEdge;
    texture = null;
    width = 0;
    height = 0;
    pma = false;
    regions = new Array();
    constructor(name){
        this.name = name;
    }
    setTexture(texture) {
        this.texture = texture;
        texture.setFilters(this.minFilter, this.magFilter);
        texture.setWraps(this.uWrap, this.vWrap);
        for (let region of this.regions)region.texture = texture;
    }
}
class $959dc053f9cefaa3$export$6c0770e21c633916 extends (0, $66uC2.TextureRegion) {
    page;
    name;
    x = 0;
    y = 0;
    offsetX = 0;
    offsetY = 0;
    originalWidth = 0;
    originalHeight = 0;
    index = 0;
    degrees = 0;
    names = null;
    values = null;
    constructor(page, name){
        super();
        this.page = page;
        this.name = name;
        page.regions.push(this);
    }
}

});
parcelRegister("66uC2", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $471b0ca0afe71980$export$5431306cf43de24a);
$parcel$export(module.exports, "TextureFilter", () => $471b0ca0afe71980$export$f389c48fc54053be);
$parcel$export(module.exports, "TextureWrap", () => $471b0ca0afe71980$export$522a1d31bfb74ba3);
$parcel$export(module.exports, "TextureRegion", () => $471b0ca0afe71980$export$e7d46317c6b644d1);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $471b0ca0afe71980$export$5431306cf43de24a {
    _image;
    constructor(image){
        this._image = image;
    }
    getImage() {
        return this._image;
    }
}
var $471b0ca0afe71980$export$f389c48fc54053be;
(function(TextureFilter) {
    TextureFilter[TextureFilter["Nearest"] = 9728] = "Nearest";
    TextureFilter[TextureFilter["Linear"] = 9729] = "Linear";
    TextureFilter[TextureFilter["MipMap"] = 9987] = "MipMap";
    TextureFilter[TextureFilter["MipMapNearestNearest"] = 9984] = "MipMapNearestNearest";
    TextureFilter[TextureFilter["MipMapLinearNearest"] = 9985] = "MipMapLinearNearest";
    TextureFilter[TextureFilter["MipMapNearestLinear"] = 9986] = "MipMapNearestLinear";
    TextureFilter[TextureFilter["MipMapLinearLinear"] = 9987] = "MipMapLinearLinear"; // WebGLRenderingContext.LINEAR_MIPMAP_LINEAR
})($471b0ca0afe71980$export$f389c48fc54053be || ($471b0ca0afe71980$export$f389c48fc54053be = {}));
var $471b0ca0afe71980$export$522a1d31bfb74ba3;
(function(TextureWrap) {
    TextureWrap[TextureWrap["MirroredRepeat"] = 33648] = "MirroredRepeat";
    TextureWrap[TextureWrap["ClampToEdge"] = 33071] = "ClampToEdge";
    TextureWrap[TextureWrap["Repeat"] = 10497] = "Repeat"; // WebGLRenderingContext.REPEAT
})($471b0ca0afe71980$export$522a1d31bfb74ba3 || ($471b0ca0afe71980$export$522a1d31bfb74ba3 = {}));
class $471b0ca0afe71980$export$e7d46317c6b644d1 {
    texture;
    u = 0;
    v = 0;
    u2 = 0;
    v2 = 0;
    width = 0;
    height = 0;
    degrees = 0;
    offsetX = 0;
    offsetY = 0;
    originalWidth = 0;
    originalHeight = 0;
}
class $471b0ca0afe71980$export$b3652565e6818133 extends $471b0ca0afe71980$export$5431306cf43de24a {
    setFilters(minFilter, magFilter) {}
    setWraps(uWrap, vWrap) {}
    dispose() {}
}

});



parcelRegister("46qOI", function(module, exports) {

$parcel$export(module.exports, "PathAttachment", () => $2fcc86453abe2c1c$export$d285e3ec07b32800);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");

var $5a4jk = parcelRequire("5a4jk");
class $2fcc86453abe2c1c$export$d285e3ec07b32800 extends (0, $5a4jk.VertexAttachment) {
    /** The lengths along the path in the setup pose from the start of the path to the end of each Bezier curve. */ lengths = [];
    /** If true, the start and end knots are connected. */ closed = false;
    /** If true, additional calculations are performed to make calculating positions along the path more accurate. If false, fewer
     * calculations are performed but calculating positions along the path is less accurate. */ constantSpeed = false;
    /** The color of the path as it was in Spine. Available only when nonessential data was exported. Paths are not usually
     * rendered at runtime. */ color = new (0, $1Yup6.Color)(1, 1, 1, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $2fcc86453abe2c1c$export$d285e3ec07b32800(this.name);
        this.copyTo(copy);
        copy.lengths = new Array(this.lengths.length);
        (0, $1Yup6.Utils).arrayCopy(this.lengths, 0, copy.lengths, 0, this.lengths.length);
        copy.closed = closed;
        copy.constantSpeed = this.constantSpeed;
        copy.color.setFromColor(this.color);
        return copy;
    }
}

});

parcelRegister("hxr00", function(module, exports) {

$parcel$export(module.exports, "PointAttachment", () => $cc4a762d2c6d2eb6$export$1b528cde44a6ab5);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");

var $5a4jk = parcelRequire("5a4jk");
class $cc4a762d2c6d2eb6$export$1b528cde44a6ab5 extends (0, $5a4jk.VertexAttachment) {
    x = 0;
    y = 0;
    rotation = 0;
    /** The color of the point attachment as it was in Spine. Available only when nonessential data was exported. Point attachments
     * are not usually rendered at runtime. */ color = new (0, $1Yup6.Color)(0.38, 0.94, 0, 1);
    constructor(name){
        super(name);
    }
    computeWorldPosition(bone, point) {
        point.x = this.x * bone.a + this.y * bone.b + bone.worldX;
        point.y = this.x * bone.c + this.y * bone.d + bone.worldY;
        return point;
    }
    computeWorldRotation(bone) {
        const r = this.rotation * (0, $1Yup6.MathUtils).degRad, cos = Math.cos(r), sin = Math.sin(r);
        const x = cos * bone.a + sin * bone.b;
        const y = cos * bone.c + sin * bone.d;
        return (0, $1Yup6.MathUtils).atan2Deg(y, x);
    }
    copy() {
        let copy = new $cc4a762d2c6d2eb6$export$1b528cde44a6ab5(this.name);
        copy.x = this.x;
        copy.y = this.y;
        copy.rotation = this.rotation;
        copy.color.setFromColor(this.color);
        return copy;
    }
}

});

parcelRegister("8wKGy", function(module, exports) {

$parcel$export(module.exports, "RegionAttachment", () => $6355869a5ef59f02$export$d0fc51466fa6d530);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");

var $5a4jk = parcelRequire("5a4jk");
class $6355869a5ef59f02$export$d0fc51466fa6d530 extends (0, $5a4jk.Attachment) {
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local scaleX. */ scaleX = 1;
    /** The local scaleY. */ scaleY = 1;
    /** The local rotation. */ rotation = 0;
    /** The width of the region attachment in Spine. */ width = 0;
    /** The height of the region attachment in Spine. */ height = 0;
    /** The color to tint the region attachment. */ color = new (0, $1Yup6.Color)(1, 1, 1, 1);
    /** The name of the texture region for this attachment. */ path;
    region = null;
    sequence = null;
    /** For each of the 4 vertices, a pair of <code>x,y</code> values that is the local position of the vertex.
     *
     * See {@link #updateOffset()}. */ offset = (0, $1Yup6.Utils).newFloatArray(8);
    uvs = (0, $1Yup6.Utils).newFloatArray(8);
    tempColor = new (0, $1Yup6.Color)(1, 1, 1, 1);
    constructor(name, path){
        super(name);
        this.path = path;
    }
    /** Calculates the {@link #offset} using the region settings. Must be called after changing region settings. */ updateRegion() {
        if (!this.region) throw new Error("Region not set.");
        let region = this.region;
        let uvs = this.uvs;
        if (region == null) {
            uvs[0] = 0;
            uvs[1] = 0;
            uvs[2] = 0;
            uvs[3] = 1;
            uvs[4] = 1;
            uvs[5] = 1;
            uvs[6] = 1;
            uvs[7] = 0;
            return;
        }
        let regionScaleX = this.width / this.region.originalWidth * this.scaleX;
        let regionScaleY = this.height / this.region.originalHeight * this.scaleY;
        let localX = -this.width / 2 * this.scaleX + this.region.offsetX * regionScaleX;
        let localY = -this.height / 2 * this.scaleY + this.region.offsetY * regionScaleY;
        let localX2 = localX + this.region.width * regionScaleX;
        let localY2 = localY + this.region.height * regionScaleY;
        let radians = this.rotation * (0, $1Yup6.MathUtils).degRad;
        let cos = Math.cos(radians);
        let sin = Math.sin(radians);
        let x = this.x, y = this.y;
        let localXCos = localX * cos + x;
        let localXSin = localX * sin;
        let localYCos = localY * cos + y;
        let localYSin = localY * sin;
        let localX2Cos = localX2 * cos + x;
        let localX2Sin = localX2 * sin;
        let localY2Cos = localY2 * cos + y;
        let localY2Sin = localY2 * sin;
        let offset = this.offset;
        offset[0] = localXCos - localYSin;
        offset[1] = localYCos + localXSin;
        offset[2] = localXCos - localY2Sin;
        offset[3] = localY2Cos + localXSin;
        offset[4] = localX2Cos - localY2Sin;
        offset[5] = localY2Cos + localX2Sin;
        offset[6] = localX2Cos - localYSin;
        offset[7] = localYCos + localX2Sin;
        if (region.degrees == 90) {
            uvs[0] = region.u2;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v2;
            uvs[4] = region.u;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v;
        } else {
            uvs[0] = region.u;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v;
            uvs[4] = region.u2;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v2;
        }
    }
    /** Transforms the attachment's four vertices to world coordinates. If the attachment has a {@link #sequence}, the region may
     * be changed.
     * <p>
     * See <a href="http://esotericsoftware.com/spine-runtime-skeletons#World-transforms">World transforms</a> in the Spine
     * Runtimes Guide.
     * @param worldVertices The output world vertices. Must have a length >= <code>offset</code> + 8.
     * @param offset The <code>worldVertices</code> index to begin writing values.
     * @param stride The number of <code>worldVertices</code> entries between the value pairs written. */ computeWorldVertices(slot, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        let bone = slot.bone;
        let vertexOffset = this.offset;
        let x = bone.worldX, y = bone.worldY;
        let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
        let offsetX = 0, offsetY = 0;
        offsetX = vertexOffset[0];
        offsetY = vertexOffset[1];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // br
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[2];
        offsetY = vertexOffset[3];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // bl
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[4];
        offsetY = vertexOffset[5];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // ul
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[6];
        offsetY = vertexOffset[7];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // ur
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
    }
    copy() {
        let copy = new $6355869a5ef59f02$export$d0fc51466fa6d530(this.name, this.path);
        copy.region = this.region;
        copy.x = this.x;
        copy.y = this.y;
        copy.scaleX = this.scaleX;
        copy.scaleY = this.scaleY;
        copy.rotation = this.rotation;
        copy.width = this.width;
        copy.height = this.height;
        (0, $1Yup6.Utils).arrayCopy(this.uvs, 0, copy.uvs, 0, 8);
        (0, $1Yup6.Utils).arrayCopy(this.offset, 0, copy.offset, 0, 8);
        copy.color.setFromColor(this.color);
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        return copy;
    }
    static X1 = 0;
    static Y1 = 1;
    static C1R = 2;
    static C1G = 3;
    static C1B = 4;
    static C1A = 5;
    static U1 = 6;
    static V1 = 7;
    static X2 = 8;
    static Y2 = 9;
    static C2R = 10;
    static C2G = 11;
    static C2B = 12;
    static C2A = 13;
    static U2 = 14;
    static V2 = 15;
    static X3 = 16;
    static Y3 = 17;
    static C3R = 18;
    static C3G = 19;
    static C3B = 20;
    static C3A = 21;
    static U3 = 22;
    static V3 = 23;
    static X4 = 24;
    static Y4 = 25;
    static C4R = 26;
    static C4G = 27;
    static C4B = 28;
    static C4A = 29;
    static U4 = 30;
    static V4 = 31;
}

});


parcelRegister("5yGPE", function(module, exports) {

$parcel$export(module.exports, "Bone", () => $40c15a4a15521c66$export$b127726e56765aa4);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1S7b2 = parcelRequire("1S7b2");

var $1Yup6 = parcelRequire("1Yup6");
class $40c15a4a15521c66$export$b127726e56765aa4 {
    /** The bone's setup pose data. */ data;
    /** The skeleton this bone belongs to. */ skeleton;
    /** The parent bone, or null if this is the root bone. */ parent = null;
    /** The immediate children of this bone. */ children = new Array();
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local rotation in degrees, counter clockwise. */ rotation = 0;
    /** The local scaleX. */ scaleX = 0;
    /** The local scaleY. */ scaleY = 0;
    /** The local shearX. */ shearX = 0;
    /** The local shearY. */ shearY = 0;
    /** The applied local x translation. */ ax = 0;
    /** The applied local y translation. */ ay = 0;
    /** The applied local rotation in degrees, counter clockwise. */ arotation = 0;
    /** The applied local scaleX. */ ascaleX = 0;
    /** The applied local scaleY. */ ascaleY = 0;
    /** The applied local shearX. */ ashearX = 0;
    /** The applied local shearY. */ ashearY = 0;
    /** Part of the world transform matrix for the X axis. If changed, {@link #updateAppliedTransform()} should be called. */ a = 0;
    /** Part of the world transform matrix for the Y axis. If changed, {@link #updateAppliedTransform()} should be called. */ b = 0;
    /** Part of the world transform matrix for the X axis. If changed, {@link #updateAppliedTransform()} should be called. */ c = 0;
    /** Part of the world transform matrix for the Y axis. If changed, {@link #updateAppliedTransform()} should be called. */ d = 0;
    /** The world X position. If changed, {@link #updateAppliedTransform()} should be called. */ worldY = 0;
    /** The world Y position. If changed, {@link #updateAppliedTransform()} should be called. */ worldX = 0;
    inherit = (0, $1S7b2.Inherit).Normal;
    sorted = false;
    active = false;
    /** @param parent May be null. */ constructor(data, skeleton, parent){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.skeleton = skeleton;
        this.parent = parent;
        this.setToSetupPose();
    }
    /** Returns false when the bone has not been computed because {@link BoneData#skinRequired} is true and the
      * {@link Skeleton#skin active skin} does not {@link Skin#bones contain} this bone. */ isActive() {
        return this.active;
    }
    /** Computes the world transform using the parent bone and this bone's local applied transform. */ update(physics) {
        this.updateWorldTransformWith(this.ax, this.ay, this.arotation, this.ascaleX, this.ascaleY, this.ashearX, this.ashearY);
    }
    /** Computes the world transform using the parent bone and this bone's local transform.
     *
     * See {@link #updateWorldTransformWith()}. */ updateWorldTransform() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and the specified local transform. The applied transform is set to the
     * specified local transform. Child bones are not updated.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide. */ updateWorldTransformWith(x, y, rotation, scaleX, scaleY, shearX, shearY) {
        this.ax = x;
        this.ay = y;
        this.arotation = rotation;
        this.ascaleX = scaleX;
        this.ascaleY = scaleY;
        this.ashearX = shearX;
        this.ashearY = shearY;
        let parent = this.parent;
        if (!parent) {
            let skeleton = this.skeleton;
            const sx = skeleton.scaleX, sy = skeleton.scaleY;
            const rx = (rotation + shearX) * (0, $1Yup6.MathUtils).degRad;
            const ry = (rotation + 90 + shearY) * (0, $1Yup6.MathUtils).degRad;
            this.a = Math.cos(rx) * scaleX * sx;
            this.b = Math.cos(ry) * scaleY * sx;
            this.c = Math.sin(rx) * scaleX * sy;
            this.d = Math.sin(ry) * scaleY * sy;
            this.worldX = x * sx + skeleton.x;
            this.worldY = y * sy + skeleton.y;
            return;
        }
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        this.worldX = pa * x + pb * y + parent.worldX;
        this.worldY = pc * x + pd * y + parent.worldY;
        switch(this.inherit){
            case (0, $1S7b2.Inherit).Normal:
                {
                    const rx = (rotation + shearX) * (0, $1Yup6.MathUtils).degRad;
                    const ry = (rotation + 90 + shearY) * (0, $1Yup6.MathUtils).degRad;
                    const la = Math.cos(rx) * scaleX;
                    const lb = Math.cos(ry) * scaleY;
                    const lc = Math.sin(rx) * scaleX;
                    const ld = Math.sin(ry) * scaleY;
                    this.a = pa * la + pb * lc;
                    this.b = pa * lb + pb * ld;
                    this.c = pc * la + pd * lc;
                    this.d = pc * lb + pd * ld;
                    return;
                }
            case (0, $1S7b2.Inherit).OnlyTranslation:
                {
                    const rx = (rotation + shearX) * (0, $1Yup6.MathUtils).degRad;
                    const ry = (rotation + 90 + shearY) * (0, $1Yup6.MathUtils).degRad;
                    this.a = Math.cos(rx) * scaleX;
                    this.b = Math.cos(ry) * scaleY;
                    this.c = Math.sin(rx) * scaleX;
                    this.d = Math.sin(ry) * scaleY;
                    break;
                }
            case (0, $1S7b2.Inherit).NoRotationOrReflection:
                {
                    let sx = 1 / this.skeleton.scaleX, sy = 1 / this.skeleton.scaleY;
                    pa *= sx;
                    pc *= sy;
                    let s = pa * pa + pc * pc;
                    let prx = 0;
                    if (s > 0.0001) {
                        s = Math.abs(pa * pd * sy - pb * sx * pc) / s;
                        pb = pc * s;
                        pd = pa * s;
                        prx = Math.atan2(pc, pa) * (0, $1Yup6.MathUtils).radDeg;
                    } else {
                        pa = 0;
                        pc = 0;
                        prx = 90 - Math.atan2(pd, pb) * (0, $1Yup6.MathUtils).radDeg;
                    }
                    const rx = (rotation + shearX - prx) * (0, $1Yup6.MathUtils).degRad;
                    const ry = (rotation + shearY - prx + 90) * (0, $1Yup6.MathUtils).degRad;
                    const la = Math.cos(rx) * scaleX;
                    const lb = Math.cos(ry) * scaleY;
                    const lc = Math.sin(rx) * scaleX;
                    const ld = Math.sin(ry) * scaleY;
                    this.a = pa * la - pb * lc;
                    this.b = pa * lb - pb * ld;
                    this.c = pc * la + pd * lc;
                    this.d = pc * lb + pd * ld;
                    break;
                }
            case (0, $1S7b2.Inherit).NoScale:
            case (0, $1S7b2.Inherit).NoScaleOrReflection:
                {
                    rotation *= (0, $1Yup6.MathUtils).degRad;
                    const cos = Math.cos(rotation), sin = Math.sin(rotation);
                    let za = (pa * cos + pb * sin) / this.skeleton.scaleX;
                    let zc = (pc * cos + pd * sin) / this.skeleton.scaleY;
                    let s = Math.sqrt(za * za + zc * zc);
                    if (s > 0.00001) s = 1 / s;
                    za *= s;
                    zc *= s;
                    s = Math.sqrt(za * za + zc * zc);
                    if (this.inherit == (0, $1S7b2.Inherit).NoScale && pa * pd - pb * pc < 0 != (this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    rotation = Math.PI / 2 + Math.atan2(zc, za);
                    const zb = Math.cos(rotation) * s;
                    const zd = Math.sin(rotation) * s;
                    shearX *= (0, $1Yup6.MathUtils).degRad;
                    shearY = (90 + shearY) * (0, $1Yup6.MathUtils).degRad;
                    const la = Math.cos(shearX) * scaleX;
                    const lb = Math.cos(shearY) * scaleY;
                    const lc = Math.sin(shearX) * scaleX;
                    const ld = Math.sin(shearY) * scaleY;
                    this.a = za * la + zb * lc;
                    this.b = za * lb + zb * ld;
                    this.c = zc * la + zd * lc;
                    this.d = zc * lb + zd * ld;
                    break;
                }
        }
        this.a *= this.skeleton.scaleX;
        this.b *= this.skeleton.scaleX;
        this.c *= this.skeleton.scaleY;
        this.d *= this.skeleton.scaleY;
    }
    /** Sets this bone's local transform to the setup pose. */ setToSetupPose() {
        let data = this.data;
        this.x = data.x;
        this.y = data.y;
        this.rotation = data.rotation;
        this.scaleX = data.scaleX;
        this.scaleY = data.scaleY;
        this.shearX = data.shearX;
        this.shearY = data.shearY;
        this.inherit = data.inherit;
    }
    /** Computes the applied transform values from the world transform.
     *
     * If the world transform is modified (by a constraint, {@link #rotateWorld(float)}, etc) then this method should be called so
     * the applied transform matches the world transform. The applied transform may be needed by other code (eg to apply other
     * constraints).
     *
     * Some information is ambiguous in the world transform, such as -1,-1 scale versus 180 rotation. The applied transform after
     * calling this method is equivalent to the local transform used to compute the world transform, but may not be identical. */ updateAppliedTransform() {
        let parent = this.parent;
        if (!parent) {
            this.ax = this.worldX - this.skeleton.x;
            this.ay = this.worldY - this.skeleton.y;
            this.arotation = Math.atan2(this.c, this.a) * (0, $1Yup6.MathUtils).radDeg;
            this.ascaleX = Math.sqrt(this.a * this.a + this.c * this.c);
            this.ascaleY = Math.sqrt(this.b * this.b + this.d * this.d);
            this.ashearX = 0;
            this.ashearY = Math.atan2(this.a * this.b + this.c * this.d, this.a * this.d - this.b * this.c) * (0, $1Yup6.MathUtils).radDeg;
            return;
        }
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        let pid = 1 / (pa * pd - pb * pc);
        let ia = pd * pid, ib = pb * pid, ic = pc * pid, id = pa * pid;
        let dx = this.worldX - parent.worldX, dy = this.worldY - parent.worldY;
        this.ax = dx * ia - dy * ib;
        this.ay = dy * id - dx * ic;
        let ra, rb, rc, rd;
        if (this.inherit == (0, $1S7b2.Inherit).OnlyTranslation) {
            ra = this.a;
            rb = this.b;
            rc = this.c;
            rd = this.d;
        } else {
            switch(this.inherit){
                case (0, $1S7b2.Inherit).NoRotationOrReflection:
                    {
                        let s = Math.abs(pa * pd - pb * pc) / (pa * pa + pc * pc);
                        pb = -pc * this.skeleton.scaleX * s / this.skeleton.scaleY;
                        pd = pa * this.skeleton.scaleY * s / this.skeleton.scaleX;
                        pid = 1 / (pa * pd - pb * pc);
                        ia = pd * pid;
                        ib = pb * pid;
                        break;
                    }
                case (0, $1S7b2.Inherit).NoScale:
                case (0, $1S7b2.Inherit).NoScaleOrReflection:
                    let cos = (0, $1Yup6.MathUtils).cosDeg(this.rotation), sin = (0, $1Yup6.MathUtils).sinDeg(this.rotation);
                    pa = (pa * cos + pb * sin) / this.skeleton.scaleX;
                    pc = (pc * cos + pd * sin) / this.skeleton.scaleY;
                    let s = Math.sqrt(pa * pa + pc * pc);
                    if (s > 0.00001) s = 1 / s;
                    pa *= s;
                    pc *= s;
                    s = Math.sqrt(pa * pa + pc * pc);
                    if (this.inherit == (0, $1S7b2.Inherit).NoScale && pid < 0 != (this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    let r = (0, $1Yup6.MathUtils).PI / 2 + Math.atan2(pc, pa);
                    pb = Math.cos(r) * s;
                    pd = Math.sin(r) * s;
                    pid = 1 / (pa * pd - pb * pc);
                    ia = pd * pid;
                    ib = pb * pid;
                    ic = pc * pid;
                    id = pa * pid;
            }
            ra = ia * this.a - ib * this.c;
            rb = ia * this.b - ib * this.d;
            rc = id * this.c - ic * this.a;
            rd = id * this.d - ic * this.b;
        }
        this.ashearX = 0;
        this.ascaleX = Math.sqrt(ra * ra + rc * rc);
        if (this.ascaleX > 0.0001) {
            let det = ra * rd - rb * rc;
            this.ascaleY = det / this.ascaleX;
            this.ashearY = -Math.atan2(ra * rb + rc * rd, det) * (0, $1Yup6.MathUtils).radDeg;
            this.arotation = Math.atan2(rc, ra) * (0, $1Yup6.MathUtils).radDeg;
        } else {
            this.ascaleX = 0;
            this.ascaleY = Math.sqrt(rb * rb + rd * rd);
            this.ashearY = 0;
            this.arotation = 90 - Math.atan2(rd, rb) * (0, $1Yup6.MathUtils).radDeg;
        }
    }
    /** The world rotation for the X axis, calculated using {@link #a} and {@link #c}. */ getWorldRotationX() {
        return Math.atan2(this.c, this.a) * (0, $1Yup6.MathUtils).radDeg;
    }
    /** The world rotation for the Y axis, calculated using {@link #b} and {@link #d}. */ getWorldRotationY() {
        return Math.atan2(this.d, this.b) * (0, $1Yup6.MathUtils).radDeg;
    }
    /** The magnitude (always positive) of the world scale X, calculated using {@link #a} and {@link #c}. */ getWorldScaleX() {
        return Math.sqrt(this.a * this.a + this.c * this.c);
    }
    /** The magnitude (always positive) of the world scale Y, calculated using {@link #b} and {@link #d}. */ getWorldScaleY() {
        return Math.sqrt(this.b * this.b + this.d * this.d);
    }
    /** Transforms a point from world coordinates to the bone's local coordinates. */ worldToLocal(world) {
        let invDet = 1 / (this.a * this.d - this.b * this.c);
        let x = world.x - this.worldX, y = world.y - this.worldY;
        world.x = x * this.d * invDet - y * this.b * invDet;
        world.y = y * this.a * invDet - x * this.c * invDet;
        return world;
    }
    /** Transforms a point from the bone's local coordinates to world coordinates. */ localToWorld(local) {
        let x = local.x, y = local.y;
        local.x = x * this.a + y * this.b + this.worldX;
        local.y = x * this.c + y * this.d + this.worldY;
        return local;
    }
    /** Transforms a point from world coordinates to the parent bone's local coordinates. */ worldToParent(world) {
        if (world == null) throw new Error("world cannot be null.");
        return this.parent == null ? world : this.parent.worldToLocal(world);
    }
    /** Transforms a point from the parent bone's coordinates to world coordinates. */ parentToWorld(world) {
        if (world == null) throw new Error("world cannot be null.");
        return this.parent == null ? world : this.parent.localToWorld(world);
    }
    /** Transforms a world rotation to a local rotation. */ worldToLocalRotation(worldRotation) {
        let sin = (0, $1Yup6.MathUtils).sinDeg(worldRotation), cos = (0, $1Yup6.MathUtils).cosDeg(worldRotation);
        return Math.atan2(this.a * sin - this.c * cos, this.d * cos - this.b * sin) * (0, $1Yup6.MathUtils).radDeg + this.rotation - this.shearX;
    }
    /** Transforms a local rotation to a world rotation. */ localToWorldRotation(localRotation) {
        localRotation -= this.rotation - this.shearX;
        let sin = (0, $1Yup6.MathUtils).sinDeg(localRotation), cos = (0, $1Yup6.MathUtils).cosDeg(localRotation);
        return Math.atan2(cos * this.c + sin * this.d, cos * this.a + sin * this.b) * (0, $1Yup6.MathUtils).radDeg;
    }
    /** Rotates the world transform the specified amount.
     * <p>
     * After changes are made to the world transform, {@link #updateAppliedTransform()} should be called and
     * {@link #update(Physics)} will need to be called on any child bones, recursively. */ rotateWorld(degrees) {
        degrees *= (0, $1Yup6.MathUtils).degRad;
        const sin = Math.sin(degrees), cos = Math.cos(degrees);
        const ra = this.a, rb = this.b;
        this.a = cos * ra - sin * this.c;
        this.b = cos * rb - sin * this.d;
        this.c = sin * ra + cos * this.c;
        this.d = sin * rb + cos * this.d;
    }
}

});
parcelRegister("1S7b2", function(module, exports) {

$parcel$export(module.exports, "BoneData", () => $15d066d20c83b36f$export$7d85d96cf093e12f);
$parcel$export(module.exports, "Inherit", () => $15d066d20c83b36f$export$90bfc659784fb526);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");
class $15d066d20c83b36f$export$7d85d96cf093e12f {
    /** The index of the bone in {@link Skeleton#getBones()}. */ index = 0;
    /** The name of the bone, which is unique across all bones in the skeleton. */ name;
    /** @returns May be null. */ parent = null;
    /** The bone's length. */ length = 0;
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local rotation in degrees, counter clockwise. */ rotation = 0;
    /** The local scaleX. */ scaleX = 1;
    /** The local scaleY. */ scaleY = 1;
    /** The local shearX. */ shearX = 0;
    /** The local shearX. */ shearY = 0;
    /** The transform mode for how parent world transforms affect this bone. */ inherit = $15d066d20c83b36f$export$90bfc659784fb526.Normal;
    /** When true, {@link Skeleton#updateWorldTransform()} only updates this bone if the {@link Skeleton#skin} contains this
      * bone.
      * @see Skin#bones */ skinRequired = false;
    /** The color of the bone as it was in Spine. Available only when nonessential data was exported. Bones are not usually
     * rendered at runtime. */ color = new (0, $1Yup6.Color)();
    /** The bone icon as it was in Spine, or null if nonessential data was not exported. */ icon;
    /** False if the bone was hidden in Spine and nonessential data was exported. Does not affect runtime rendering. */ visible = false;
    constructor(index, name, parent){
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        this.index = index;
        this.name = name;
        this.parent = parent;
    }
}
var $15d066d20c83b36f$export$90bfc659784fb526;
(function(Inherit) {
    Inherit[Inherit["Normal"] = 0] = "Normal";
    Inherit[Inherit["OnlyTranslation"] = 1] = "OnlyTranslation";
    Inherit[Inherit["NoRotationOrReflection"] = 2] = "NoRotationOrReflection";
    Inherit[Inherit["NoScale"] = 3] = "NoScale";
    Inherit[Inherit["NoScaleOrReflection"] = 4] = "NoScaleOrReflection";
})($15d066d20c83b36f$export$90bfc659784fb526 || ($15d066d20c83b36f$export$90bfc659784fb526 = {}));

});


parcelRegister("dTqn7", function(module, exports) {

$parcel$export(module.exports, "ConstraintData", () => $a1d4de5372395191$export$b826e1ab3af63566);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** The base class for all constraint datas. */ class $a1d4de5372395191$export$b826e1ab3af63566 {
    name;
    order;
    skinRequired;
    constructor(name, order, skinRequired){
        this.name = name;
        this.order = order;
        this.skinRequired = skinRequired;
    }
}

});

parcelRegister("kPy2S", function(module, exports) {
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $cQp1s = parcelRequire("cQp1s");
class $f2a2fac98ed0510e$export$d187693bfb349728 {
    pathPrefix = "";
    textureLoader;
    downloader;
    cache;
    errors = {};
    toLoad = 0;
    loaded = 0;
    constructor(textureLoader, pathPrefix = "", downloader = new $f2a2fac98ed0510e$export$ef06e7620d37c296(), cache = new $f2a2fac98ed0510e$export$4205e031f0ba7602()){
        this.textureLoader = textureLoader;
        this.pathPrefix = pathPrefix;
        this.downloader = downloader;
        this.cache = cache;
    }
    start(path) {
        this.toLoad++;
        return this.pathPrefix + path;
    }
    success(callback, path, asset) {
        this.toLoad--;
        this.loaded++;
        this.cache.assets[path] = asset;
        this.cache.assetsRefCount[path] = (this.cache.assetsRefCount[path] || 0) + 1;
        if (callback) callback(path, asset);
    }
    error(callback, path, message) {
        this.toLoad--;
        this.loaded++;
        this.errors[path] = message;
        if (callback) callback(path, message);
    }
    loadAll() {
        let promise = new Promise((resolve, reject)=>{
            let check = ()=>{
                if (this.isLoadingComplete()) {
                    if (this.hasErrors()) reject(this.errors);
                    else resolve(this);
                    return;
                }
                requestAnimationFrame(check);
            };
            requestAnimationFrame(check);
        });
        return promise;
    }
    setRawDataURI(path, data) {
        this.downloader.rawDataUris[this.pathPrefix + path] = data;
    }
    loadBinary(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        if (this.reuseAssets(path, success, error)) return;
        this.cache.assetsLoaded[path] = new Promise((resolve, reject)=>{
            this.downloader.downloadBinary(path, (data)=>{
                this.success(success, path, data);
                resolve(data);
            }, (status, responseText)=>{
                const errorMsg = `Couldn't load binary ${path}: status ${status}, ${responseText}`;
                this.error(error, path, errorMsg);
                reject(errorMsg);
            });
        });
    }
    loadText(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        this.downloader.downloadText(path, (data)=>{
            this.success(success, path, data);
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load text ${path}: status ${status}, ${responseText}`);
        });
    }
    loadJson(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        if (this.reuseAssets(path, success, error)) return;
        this.cache.assetsLoaded[path] = new Promise((resolve, reject)=>{
            this.downloader.downloadJson(path, (data)=>{
                this.success(success, path, data);
                resolve(data);
            }, (status, responseText)=>{
                const errorMsg = `Couldn't load JSON ${path}: status ${status}, ${responseText}`;
                this.error(error, path, errorMsg);
                reject(errorMsg);
            });
        });
    }
    reuseAssets(path, success = ()=>{}, error = ()=>{}) {
        const loadedStatus = this.cache.assetsLoaded[path];
        const alreadyExistsOrLoading = loadedStatus !== undefined;
        if (alreadyExistsOrLoading) this.cache.assetsLoaded[path] = loadedStatus.then((data)=>{
            // necessary when user preloads an image into the cache.
            // texture loader is not avaiable in the cache, so we transform in GLTexture at first use
            data = data instanceof Image || data instanceof ImageBitmap ? this.textureLoader(data) : data;
            this.success(success, path, data);
            return data;
        }).catch((errorMsg)=>this.error(error, path, errorMsg));
        return alreadyExistsOrLoading;
    }
    loadTexture(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        if (this.reuseAssets(path, success, error)) return;
        this.cache.assetsLoaded[path] = new Promise((resolve, reject)=>{
            let isBrowser = !!(typeof window !== 'undefined' && typeof navigator !== 'undefined' && window.document);
            let isWebWorker = !isBrowser; // && typeof importScripts !== 'undefined';
            if (isWebWorker) fetch(path, {
                mode: "cors"
            }).then((response)=>{
                if (response.ok) return response.blob();
                const errorMsg = `Couldn't load image: ${path}`;
                this.error(error, path, `Couldn't load image: ${path}`);
                reject(errorMsg);
            }).then((blob)=>{
                return blob ? createImageBitmap(blob, {
                    premultiplyAlpha: "none",
                    colorSpaceConversion: "none"
                }) : null;
            }).then((bitmap)=>{
                if (bitmap) {
                    const texture = this.textureLoader(bitmap);
                    this.success(success, path, texture);
                    resolve(texture);
                }
            });
            else {
                let image = new Image();
                image.crossOrigin = "anonymous";
                image.onload = ()=>{
                    const texture = this.textureLoader(image);
                    this.success(success, path, texture);
                    resolve(texture);
                };
                image.onerror = ()=>{
                    const errorMsg = `Couldn't load image: ${path}`;
                    this.error(error, path, errorMsg);
                    reject(errorMsg);
                };
                if (this.downloader.rawDataUris[path]) path = this.downloader.rawDataUris[path];
                image.src = path;
            }
        });
    }
    loadTextureAtlas(path, success = ()=>{}, error = ()=>{}, fileAlias) {
        let index = path.lastIndexOf("/");
        let parent = index >= 0 ? path.substring(0, index + 1) : "";
        path = this.start(path);
        if (this.reuseAssets(path, success, error)) return;
        this.cache.assetsLoaded[path] = new Promise((resolve, reject)=>{
            this.downloader.downloadText(path, (atlasText)=>{
                try {
                    let atlas = new (0, $cQp1s.TextureAtlas)(atlasText);
                    let toLoad = atlas.pages.length, abort = false;
                    for (let page of atlas.pages)this.loadTexture(!fileAlias ? parent + page.name : fileAlias[page.name], (imagePath, texture)=>{
                        if (!abort) {
                            page.setTexture(texture);
                            if (--toLoad == 0) {
                                this.success(success, path, atlas);
                                resolve(atlas);
                            }
                        }
                    }, (imagePath, message)=>{
                        if (!abort) {
                            const errorMsg = `Couldn't load texture ${path} page image: ${imagePath}`;
                            this.error(error, path, errorMsg);
                            reject(errorMsg);
                        }
                        abort = true;
                    });
                } catch (e) {
                    const errorMsg = `Couldn't parse texture atlas ${path}: ${e.message}`;
                    this.error(error, path, errorMsg);
                    reject(errorMsg);
                }
            }, (status, responseText)=>{
                const errorMsg = `Couldn't load texture atlas ${path}: status ${status}, ${responseText}`;
                this.error(error, path, errorMsg);
                reject(errorMsg);
            });
        });
    }
    loadTextureAtlasButNoTextures(path, success = ()=>{}, error = ()=>{}, fileAlias) {
        path = this.start(path);
        if (this.reuseAssets(path, success, error)) return;
        this.cache.assetsLoaded[path] = new Promise((resolve, reject)=>{
            this.downloader.downloadText(path, (atlasText)=>{
                try {
                    const atlas = new (0, $cQp1s.TextureAtlas)(atlasText);
                    this.success(success, path, atlas);
                    resolve(atlas);
                } catch (e) {
                    const errorMsg = `Couldn't parse texture atlas ${path}: ${e.message}`;
                    this.error(error, path, errorMsg);
                    reject(errorMsg);
                }
            }, (status, responseText)=>{
                const errorMsg = `Couldn't load texture atlas ${path}: status ${status}, ${responseText}`;
                this.error(error, path, errorMsg);
                reject(errorMsg);
            });
        });
    }
    // Promisified versions of load function
    async loadBinaryAsync(path) {
        return new Promise((resolve, reject)=>{
            this.loadBinary(path, (_, binary)=>resolve(binary), (_, message)=>reject(message));
        });
    }
    async loadJsonAsync(path) {
        return new Promise((resolve, reject)=>{
            this.loadJson(path, (_, object)=>resolve(object), (_, message)=>reject(message));
        });
    }
    async loadTextureAsync(path) {
        return new Promise((resolve, reject)=>{
            this.loadTexture(path, (_, texture)=>resolve(texture), (_, message)=>reject(message));
        });
    }
    async loadTextureAtlasAsync(path) {
        return new Promise((resolve, reject)=>{
            this.loadTextureAtlas(path, (_, atlas)=>resolve(atlas), (_, message)=>reject(message));
        });
    }
    async loadTextureAtlasButNoTexturesAsync(path) {
        return new Promise((resolve, reject)=>{
            this.loadTextureAtlasButNoTextures(path, (_, atlas)=>resolve(atlas), (_, message)=>reject(message));
        });
    }
    setCache(cache) {
        this.cache = cache;
    }
    get(path) {
        return this.cache.assets[this.pathPrefix + path];
    }
    require(path) {
        path = this.pathPrefix + path;
        let asset = this.cache.assets[path];
        if (asset) return asset;
        let error = this.errors[path];
        throw Error("Asset not found: " + path + (error ? "\n" + error : ""));
    }
    remove(path) {
        path = this.pathPrefix + path;
        let asset = this.cache.assets[path];
        if (asset.dispose) asset.dispose();
        delete this.cache.assets[path];
        delete this.cache.assetsRefCount[path];
        delete this.cache.assetsLoaded[path];
        return asset;
    }
    removeAll() {
        for(let path in this.cache.assets){
            let asset = this.cache.assets[path];
            if (asset.dispose) asset.dispose();
        }
        this.cache.assets = {};
        this.cache.assetsLoaded = {};
        this.cache.assetsRefCount = {};
    }
    isLoadingComplete() {
        return this.toLoad == 0;
    }
    getToLoad() {
        return this.toLoad;
    }
    getLoaded() {
        return this.loaded;
    }
    dispose() {
        this.removeAll();
    }
    // dispose asset only if it's not used by others
    disposeAsset(path) {
        if (--this.cache.assetsRefCount[path] === 0) this.remove(path);
    }
    hasErrors() {
        return Object.keys(this.errors).length > 0;
    }
    getErrors() {
        return this.errors;
    }
}
class $f2a2fac98ed0510e$export$4205e031f0ba7602 {
    assets = {};
    assetsRefCount = {};
    assetsLoaded = {};
    static AVAILABLE_CACHES = new Map();
    static getCache(id) {
        const cache = $f2a2fac98ed0510e$export$4205e031f0ba7602.AVAILABLE_CACHES.get(id);
        if (cache) return cache;
        const newCache = new $f2a2fac98ed0510e$export$4205e031f0ba7602();
        $f2a2fac98ed0510e$export$4205e031f0ba7602.AVAILABLE_CACHES.set(id, newCache);
        return newCache;
    }
    async addAsset(path, asset) {
        this.assetsLoaded[path] = Promise.resolve(asset);
        this.assets[path] = await asset;
    }
}
class $f2a2fac98ed0510e$export$ef06e7620d37c296 {
    callbacks = {};
    rawDataUris = {};
    dataUriToString(dataUri) {
        if (!dataUri.startsWith("data:")) throw new Error("Not a data URI.");
        let base64Idx = dataUri.indexOf("base64,");
        if (base64Idx != -1) {
            base64Idx += 7;
            return atob(dataUri.substr(base64Idx));
        } else return dataUri.substr(dataUri.indexOf(",") + 1);
    }
    base64ToUint8Array(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for(var i = 0; i < len; i++)bytes[i] = binary_string.charCodeAt(i);
        return bytes;
    }
    dataUriToUint8Array(dataUri) {
        if (!dataUri.startsWith("data:")) throw new Error("Not a data URI.");
        let base64Idx = dataUri.indexOf("base64,");
        if (base64Idx == -1) throw new Error("Not a binary data URI.");
        base64Idx += 7;
        return this.base64ToUint8Array(dataUri.substr(base64Idx));
    }
    downloadText(url, success, error) {
        if (this.start(url, success, error)) return;
        const rawDataUri = this.rawDataUris[url];
        // we assume if a "." is included in a raw data uri, it is used to rewrite an asset URL
        if (rawDataUri && !rawDataUri.includes(".")) {
            try {
                this.finish(url, 200, this.dataUriToString(rawDataUri));
            } catch (e) {
                this.finish(url, 400, JSON.stringify(e));
            }
            return;
        }
        let request = new XMLHttpRequest();
        request.overrideMimeType("text/html");
        request.open("GET", rawDataUri ? rawDataUri : url, true);
        let done = ()=>{
            this.finish(url, request.status, request.responseText);
        };
        request.onload = done;
        request.onerror = done;
        request.send();
    }
    downloadJson(url, success, error) {
        this.downloadText(url, (data)=>{
            success(JSON.parse(data));
        }, error);
    }
    downloadBinary(url, success, error) {
        if (this.start(url, success, error)) return;
        const rawDataUri = this.rawDataUris[url];
        // we assume if a "." is included in a raw data uri, it is used to rewrite an asset URL
        if (rawDataUri && !rawDataUri.includes(".")) {
            try {
                this.finish(url, 200, this.dataUriToUint8Array(rawDataUri));
            } catch (e) {
                this.finish(url, 400, JSON.stringify(e));
            }
            return;
        }
        let request = new XMLHttpRequest();
        request.open("GET", rawDataUri ? rawDataUri : url, true);
        request.responseType = "arraybuffer";
        let onerror = ()=>{
            this.finish(url, request.status, request.response);
        };
        request.onload = ()=>{
            if (request.status == 200 || request.status == 0) this.finish(url, 200, new Uint8Array(request.response));
            else onerror();
        };
        request.onerror = onerror;
        request.send();
    }
    start(url, success, error) {
        let callbacks = this.callbacks[url];
        try {
            if (callbacks) return true;
            this.callbacks[url] = callbacks = [];
        } finally{
            callbacks.push(success, error);
        }
    }
    finish(url, status, data) {
        let callbacks = this.callbacks[url];
        delete this.callbacks[url];
        let args = status == 200 || status == 0 ? [
            data
        ] : [
            status,
            data
        ];
        for(let i = args.length - 1, n = callbacks.length; i < n; i += 2)callbacks[i].apply(null, args);
    }
}

});

parcelRegister("2jWXd", function(module, exports) {

$parcel$export(module.exports, "Event", () => $1b0b163278ab2291$export$d61e24a684f9e51);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the current pose values for an {@link Event}.
 *
 * See Timeline {@link Timeline#apply()},
 * AnimationStateListener {@link AnimationStateListener#event()}, and
 * [Events](http://esotericsoftware.com/spine-events) in the Spine User Guide. */ class $1b0b163278ab2291$export$d61e24a684f9e51 {
    data;
    intValue = 0;
    floatValue = 0;
    stringValue = null;
    time = 0;
    volume = 0;
    balance = 0;
    constructor(time, data){
        if (!data) throw new Error("data cannot be null.");
        this.time = time;
        this.data = data;
    }
}

});

parcelRegister("gfyKS", function(module, exports) {

$parcel$export(module.exports, "EventData", () => $bd4901ace6c255ad$export$a5cf049e34c3d11e);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the setup pose values for an {@link Event}.
 *
 * See [Events](http://esotericsoftware.com/spine-events) in the Spine User Guide. */ class $bd4901ace6c255ad$export$a5cf049e34c3d11e {
    name;
    intValue = 0;
    floatValue = 0;
    stringValue = null;
    audioPath = null;
    volume = 0;
    balance = 0;
    constructor(name){
        this.name = name;
    }
}

});

parcelRegister("kYVpx", function(module, exports) {

$parcel$export(module.exports, "IkConstraint", () => $f465f1df39d40cbb$export$3c158c80ff28c177);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1S7b2 = parcelRequire("1S7b2");

var $1Yup6 = parcelRequire("1Yup6");
class $f465f1df39d40cbb$export$3c158c80ff28c177 {
    /** The IK constraint's setup pose data. */ data;
    /** The bones that will be modified by this IK constraint. */ bones;
    /** The bone that is the IK target. */ target;
    /** Controls the bend direction of the IK bones, either 1 or -1. */ bendDirection = 0;
    /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ compress = false;
    /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ stretch = false;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ mix = 1;
    /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ softness = 0;
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}`);
            this.bones.push(bone);
        }
        let target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find bone ${data.target.name}`);
        this.target = target;
        this.mix = data.mix;
        this.softness = data.softness;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
    }
    isActive() {
        return this.active;
    }
    setToSetupPose() {
        const data = this.data;
        this.mix = data.mix;
        this.softness = data.softness;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
    }
    update(physics) {
        if (this.mix == 0) return;
        let target = this.target;
        let bones = this.bones;
        switch(bones.length){
            case 1:
                this.apply1(bones[0], target.worldX, target.worldY, this.compress, this.stretch, this.data.uniform, this.mix);
                break;
            case 2:
                this.apply2(bones[0], bones[1], target.worldX, target.worldY, this.bendDirection, this.stretch, this.data.uniform, this.softness, this.mix);
                break;
        }
    }
    /** Applies 1 bone IK. The target is specified in the world coordinate system. */ apply1(bone, targetX, targetY, compress, stretch, uniform, alpha) {
        let p = bone.parent;
        if (!p) throw new Error("IK bone must have parent.");
        let pa = p.a, pb = p.b, pc = p.c, pd = p.d;
        let rotationIK = -bone.ashearX - bone.arotation, tx = 0, ty = 0;
        switch(bone.inherit){
            case (0, $1S7b2.Inherit).OnlyTranslation:
                tx = (targetX - bone.worldX) * (0, $1Yup6.MathUtils).signum(bone.skeleton.scaleX);
                ty = (targetY - bone.worldY) * (0, $1Yup6.MathUtils).signum(bone.skeleton.scaleY);
                break;
            case (0, $1S7b2.Inherit).NoRotationOrReflection:
                let s = Math.abs(pa * pd - pb * pc) / Math.max(0.0001, pa * pa + pc * pc);
                let sa = pa / bone.skeleton.scaleX;
                let sc = pc / bone.skeleton.scaleY;
                pb = -sc * s * bone.skeleton.scaleX;
                pd = sa * s * bone.skeleton.scaleY;
                rotationIK += Math.atan2(sc, sa) * (0, $1Yup6.MathUtils).radDeg;
            // Fall through
            default:
                let x = targetX - p.worldX, y = targetY - p.worldY;
                let d = pa * pd - pb * pc;
                if (Math.abs(d) <= 0.0001) {
                    tx = 0;
                    ty = 0;
                } else {
                    tx = (x * pd - y * pb) / d - bone.ax;
                    ty = (y * pa - x * pc) / d - bone.ay;
                }
        }
        rotationIK += Math.atan2(ty, tx) * (0, $1Yup6.MathUtils).radDeg;
        if (bone.ascaleX < 0) rotationIK += 180;
        if (rotationIK > 180) rotationIK -= 360;
        else if (rotationIK < -180) rotationIK += 360;
        let sx = bone.ascaleX, sy = bone.ascaleY;
        if (compress || stretch) {
            switch(bone.inherit){
                case (0, $1S7b2.Inherit).NoScale:
                case (0, $1S7b2.Inherit).NoScaleOrReflection:
                    tx = targetX - bone.worldX;
                    ty = targetY - bone.worldY;
            }
            const b = bone.data.length * sx;
            if (b > 0.0001) {
                const dd = tx * tx + ty * ty;
                if (compress && dd < b * b || stretch && dd > b * b) {
                    const s = (Math.sqrt(dd) / b - 1) * alpha + 1;
                    sx *= s;
                    if (uniform) sy *= s;
                }
            }
        }
        bone.updateWorldTransformWith(bone.ax, bone.ay, bone.arotation + rotationIK * alpha, sx, sy, bone.ashearX, bone.ashearY);
    }
    /** Applies 2 bone IK. The target is specified in the world coordinate system.
     * @param child A direct descendant of the parent bone. */ apply2(parent, child, targetX, targetY, bendDir, stretch, uniform, softness, alpha) {
        if (parent.inherit != (0, $1S7b2.Inherit).Normal || child.inherit != (0, $1S7b2.Inherit).Normal) return;
        let px = parent.ax, py = parent.ay, psx = parent.ascaleX, psy = parent.ascaleY, sx = psx, sy = psy, csx = child.ascaleX;
        let os1 = 0, os2 = 0, s2 = 0;
        if (psx < 0) {
            psx = -psx;
            os1 = 180;
            s2 = -1;
        } else {
            os1 = 0;
            s2 = 1;
        }
        if (psy < 0) {
            psy = -psy;
            s2 = -s2;
        }
        if (csx < 0) {
            csx = -csx;
            os2 = 180;
        } else os2 = 0;
        let cx = child.ax, cy = 0, cwx = 0, cwy = 0, a = parent.a, b = parent.b, c = parent.c, d = parent.d;
        let u = Math.abs(psx - psy) <= 0.0001;
        if (!u || stretch) {
            cy = 0;
            cwx = a * cx + parent.worldX;
            cwy = c * cx + parent.worldY;
        } else {
            cy = child.ay;
            cwx = a * cx + b * cy + parent.worldX;
            cwy = c * cx + d * cy + parent.worldY;
        }
        let pp = parent.parent;
        if (!pp) throw new Error("IK parent must itself have a parent.");
        a = pp.a;
        b = pp.b;
        c = pp.c;
        d = pp.d;
        let id = a * d - b * c, x = cwx - pp.worldX, y = cwy - pp.worldY;
        id = Math.abs(id) <= 0.0001 ? 0 : 1 / id;
        let dx = (x * d - y * b) * id - px, dy = (y * a - x * c) * id - py;
        let l1 = Math.sqrt(dx * dx + dy * dy), l2 = child.data.length * csx, a1, a2;
        if (l1 < 0.0001) {
            this.apply1(parent, targetX, targetY, false, stretch, false, alpha);
            child.updateWorldTransformWith(cx, cy, 0, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
            return;
        }
        x = targetX - pp.worldX;
        y = targetY - pp.worldY;
        let tx = (x * d - y * b) * id - px, ty = (y * a - x * c) * id - py;
        let dd = tx * tx + ty * ty;
        if (softness != 0) {
            softness *= psx * (csx + 1) * 0.5;
            let td = Math.sqrt(dd), sd = td - l1 - l2 * psx + softness;
            if (sd > 0) {
                let p = Math.min(1, sd / (softness * 2)) - 1;
                p = (sd - softness * (1 - p * p)) / td;
                tx -= p * tx;
                ty -= p * ty;
                dd = tx * tx + ty * ty;
            }
        }
        outer: if (u) {
            l2 *= psx;
            let cos = (dd - l1 * l1 - l2 * l2) / (2 * l1 * l2);
            if (cos < -1) {
                cos = -1;
                a2 = Math.PI * bendDir;
            } else if (cos > 1) {
                cos = 1;
                a2 = 0;
                if (stretch) {
                    a = (Math.sqrt(dd) / (l1 + l2) - 1) * alpha + 1;
                    sx *= a;
                    if (uniform) sy *= a;
                }
            } else a2 = Math.acos(cos) * bendDir;
            a = l1 + l2 * cos;
            b = l2 * Math.sin(a2);
            a1 = Math.atan2(ty * a - tx * b, tx * a + ty * b);
        } else {
            a = psx * l2;
            b = psy * l2;
            let aa = a * a, bb = b * b, ta = Math.atan2(ty, tx);
            c = bb * l1 * l1 + aa * dd - aa * bb;
            let c1 = -2 * bb * l1, c2 = bb - aa;
            d = c1 * c1 - 4 * c2 * c;
            if (d >= 0) {
                let q = Math.sqrt(d);
                if (c1 < 0) q = -q;
                q = -(c1 + q) * 0.5;
                let r0 = q / c2, r1 = c / q;
                let r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
                r0 = dd - r * r;
                if (r0 >= 0) {
                    y = Math.sqrt(r0) * bendDir;
                    a1 = ta - Math.atan2(y, r);
                    a2 = Math.atan2(y / psy, (r - l1) / psx);
                    break outer;
                }
            }
            let minAngle = (0, $1Yup6.MathUtils).PI, minX = l1 - a, minDist = minX * minX, minY = 0;
            let maxAngle = 0, maxX = l1 + a, maxDist = maxX * maxX, maxY = 0;
            c = -a * l1 / (aa - bb);
            if (c >= -1 && c <= 1) {
                c = Math.acos(c);
                x = a * Math.cos(c) + l1;
                y = b * Math.sin(c);
                d = x * x + y * y;
                if (d < minDist) {
                    minAngle = c;
                    minDist = d;
                    minX = x;
                    minY = y;
                }
                if (d > maxDist) {
                    maxAngle = c;
                    maxDist = d;
                    maxX = x;
                    maxY = y;
                }
            }
            if (dd <= (minDist + maxDist) * 0.5) {
                a1 = ta - Math.atan2(minY * bendDir, minX);
                a2 = minAngle * bendDir;
            } else {
                a1 = ta - Math.atan2(maxY * bendDir, maxX);
                a2 = maxAngle * bendDir;
            }
        }
        let os = Math.atan2(cy, cx) * s2;
        let rotation = parent.arotation;
        a1 = (a1 - os) * (0, $1Yup6.MathUtils).radDeg + os1 - rotation;
        if (a1 > 180) a1 -= 360;
        else if (a1 < -180) a1 += 360;
        parent.updateWorldTransformWith(px, py, rotation + a1 * alpha, sx, sy, 0, 0);
        rotation = child.arotation;
        a2 = ((a2 + os) * (0, $1Yup6.MathUtils).radDeg - child.ashearX) * s2 + os2 - rotation;
        if (a2 > 180) a2 -= 360;
        else if (a2 < -180) a2 += 360;
        child.updateWorldTransformWith(cx, cy, rotation + a2 * alpha, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
    }
}

});

parcelRegister("2eT9h", function(module, exports) {

$parcel$export(module.exports, "IkConstraintData", () => $1a17aaf311b9f6a0$export$adcb08b651fc712e);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $dTqn7 = parcelRequire("dTqn7");
class $1a17aaf311b9f6a0$export$adcb08b651fc712e extends (0, $dTqn7.ConstraintData) {
    /** The bones that are constrained by this IK constraint. */ bones = new Array();
    /** The bone that is the IK target. */ _target = null;
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
    /** Controls the bend direction of the IK bones, either 1 or -1. */ bendDirection = 0;
    /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ compress = false;
    /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ stretch = false;
    /** When true, only a single bone is being constrained, and {@link #getCompress()} or {@link #getStretch()} is used, the bone
     * is scaled on both the X and Y axes. */ uniform = false;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ mix = 0;
    /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ softness = 0;
    constructor(name){
        super(name, 0, false);
    }
}

});

parcelRegister("dQ0tU", function(module, exports) {

$parcel$export(module.exports, "PathConstraint", () => $a130814e4f9c40a2$export$cb4f92fb0c018828);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $46qOI = parcelRequire("46qOI");

var $1Wvqv = parcelRequire("1Wvqv");

var $1Yup6 = parcelRequire("1Yup6");
class $a130814e4f9c40a2$export$cb4f92fb0c018828 {
    static NONE = -1;
    static BEFORE = -2;
    static AFTER = -3;
    static epsilon = 0.00001;
    /** The path constraint's setup pose data. */ data;
    /** The bones that will be modified by this path constraint. */ bones;
    /** The slot whose path attachment will be used to constrained the bones. */ target;
    /** The position along the path. */ position = 0;
    /** The spacing between bones. */ spacing = 0;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    spaces = new Array();
    positions = new Array();
    world = new Array();
    curves = new Array();
    lengths = new Array();
    segments = new Array();
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0, n = data.bones.length; i < n; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        let target = skeleton.findSlot(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}`);
        this.target = target;
        this.position = data.position;
        this.spacing = data.spacing;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
    }
    isActive() {
        return this.active;
    }
    setToSetupPose() {
        const data = this.data;
        this.position = data.position;
        this.spacing = data.spacing;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
    }
    update(physics) {
        let attachment = this.target.getAttachment();
        if (!(attachment instanceof (0, $46qOI.PathAttachment))) return;
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY;
        if (mixRotate == 0 && mixX == 0 && mixY == 0) return;
        let data = this.data;
        let tangents = data.rotateMode == (0, $1Wvqv.RotateMode).Tangent, scale = data.rotateMode == (0, $1Wvqv.RotateMode).ChainScale;
        let bones = this.bones;
        let boneCount = bones.length, spacesCount = tangents ? boneCount : boneCount + 1;
        let spaces = (0, $1Yup6.Utils).setArraySize(this.spaces, spacesCount), lengths = scale ? this.lengths = (0, $1Yup6.Utils).setArraySize(this.lengths, boneCount) : [];
        let spacing = this.spacing;
        switch(data.spacingMode){
            case (0, $1Wvqv.SpacingMode).Percent:
                if (scale) for(let i = 0, n = spacesCount - 1; i < n; i++){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    let x = setupLength * bone.a, y = setupLength * bone.c;
                    lengths[i] = Math.sqrt(x * x + y * y);
                }
                (0, $1Yup6.Utils).arrayFill(spaces, 1, spacesCount, spacing);
                break;
            case (0, $1Wvqv.SpacingMode).Proportional:
                let sum = 0;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    if (setupLength < $a130814e4f9c40a2$export$cb4f92fb0c018828.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        let x = setupLength * bone.a, y = setupLength * bone.c;
                        let length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = length;
                        sum += length;
                    }
                }
                if (sum > 0) {
                    sum = spacesCount / sum * spacing;
                    for(let i = 1; i < spacesCount; i++)spaces[i] *= sum;
                }
                break;
            default:
                let lengthSpacing = data.spacingMode == (0, $1Wvqv.SpacingMode).Length;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    if (setupLength < $a130814e4f9c40a2$export$cb4f92fb0c018828.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        let x = setupLength * bone.a, y = setupLength * bone.c;
                        let length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = (lengthSpacing ? setupLength + spacing : spacing) * length / setupLength;
                    }
                }
        }
        let positions = this.computeWorldPositions(attachment, spacesCount, tangents);
        let boneX = positions[0], boneY = positions[1], offsetRotation = data.offsetRotation;
        let tip = false;
        if (offsetRotation == 0) tip = data.rotateMode == (0, $1Wvqv.RotateMode).Chain;
        else {
            tip = false;
            let p = this.target.bone;
            offsetRotation *= p.a * p.d - p.b * p.c > 0 ? (0, $1Yup6.MathUtils).degRad : -(0, $1Yup6.MathUtils).degRad;
        }
        for(let i = 0, p = 3; i < boneCount; i++, p += 3){
            let bone = bones[i];
            bone.worldX += (boneX - bone.worldX) * mixX;
            bone.worldY += (boneY - bone.worldY) * mixY;
            let x = positions[p], y = positions[p + 1], dx = x - boneX, dy = y - boneY;
            if (scale) {
                let length = lengths[i];
                if (length != 0) {
                    let s = (Math.sqrt(dx * dx + dy * dy) / length - 1) * mixRotate + 1;
                    bone.a *= s;
                    bone.c *= s;
                }
            }
            boneX = x;
            boneY = y;
            if (mixRotate > 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d, r = 0, cos = 0, sin = 0;
                if (tangents) r = positions[p - 1];
                else if (spaces[i + 1] == 0) r = positions[p + 2];
                else r = Math.atan2(dy, dx);
                r -= Math.atan2(c, a);
                if (tip) {
                    cos = Math.cos(r);
                    sin = Math.sin(r);
                    let length = bone.data.length;
                    boneX += (length * (cos * a - sin * c) - dx) * mixRotate;
                    boneY += (length * (sin * a + cos * c) - dy) * mixRotate;
                } else r += offsetRotation;
                if (r > (0, $1Yup6.MathUtils).PI) r -= (0, $1Yup6.MathUtils).PI2;
                else if (r < -(0, $1Yup6.MathUtils).PI) r += (0, $1Yup6.MathUtils).PI2;
                r *= mixRotate;
                cos = Math.cos(r);
                sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            bone.updateAppliedTransform();
        }
    }
    computeWorldPositions(path, spacesCount, tangents) {
        let target = this.target;
        let position = this.position;
        let spaces = this.spaces, out = (0, $1Yup6.Utils).setArraySize(this.positions, spacesCount * 3 + 2), world = this.world;
        let closed = path.closed;
        let verticesLength = path.worldVerticesLength, curveCount = verticesLength / 6, prevCurve = $a130814e4f9c40a2$export$cb4f92fb0c018828.NONE;
        if (!path.constantSpeed) {
            let lengths = path.lengths;
            curveCount -= closed ? 1 : 2;
            let pathLength = lengths[curveCount];
            if (this.data.positionMode == (0, $1Wvqv.PositionMode).Percent) position *= pathLength;
            let multiplier;
            switch(this.data.spacingMode){
                case (0, $1Wvqv.SpacingMode).Percent:
                    multiplier = pathLength;
                    break;
                case (0, $1Wvqv.SpacingMode).Proportional:
                    multiplier = pathLength / spacesCount;
                    break;
                default:
                    multiplier = 1;
            }
            world = (0, $1Yup6.Utils).setArraySize(this.world, 8);
            for(let i = 0, o = 0, curve = 0; i < spacesCount; i++, o += 3){
                let space = spaces[i] * multiplier;
                position += space;
                let p = position;
                if (closed) {
                    p %= pathLength;
                    if (p < 0) p += pathLength;
                    curve = 0;
                } else if (p < 0) {
                    if (prevCurve != $a130814e4f9c40a2$export$cb4f92fb0c018828.BEFORE) {
                        prevCurve = $a130814e4f9c40a2$export$cb4f92fb0c018828.BEFORE;
                        path.computeWorldVertices(target, 2, 4, world, 0, 2);
                    }
                    this.addBeforePosition(p, world, 0, out, o);
                    continue;
                } else if (p > pathLength) {
                    if (prevCurve != $a130814e4f9c40a2$export$cb4f92fb0c018828.AFTER) {
                        prevCurve = $a130814e4f9c40a2$export$cb4f92fb0c018828.AFTER;
                        path.computeWorldVertices(target, verticesLength - 6, 4, world, 0, 2);
                    }
                    this.addAfterPosition(p - pathLength, world, 0, out, o);
                    continue;
                }
                // Determine curve containing position.
                for(;; curve++){
                    let length = lengths[curve];
                    if (p > length) continue;
                    if (curve == 0) p /= length;
                    else {
                        let prev = lengths[curve - 1];
                        p = (p - prev) / (length - prev);
                    }
                    break;
                }
                if (curve != prevCurve) {
                    prevCurve = curve;
                    if (closed && curve == curveCount) {
                        path.computeWorldVertices(target, verticesLength - 4, 4, world, 0, 2);
                        path.computeWorldVertices(target, 0, 4, world, 4, 2);
                    } else path.computeWorldVertices(target, curve * 6 + 2, 8, world, 0, 2);
                }
                this.addCurvePosition(p, world[0], world[1], world[2], world[3], world[4], world[5], world[6], world[7], out, o, tangents || i > 0 && space == 0);
            }
            return out;
        }
        // World vertices.
        if (closed) {
            verticesLength += 2;
            world = (0, $1Yup6.Utils).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength - 4, world, 0, 2);
            path.computeWorldVertices(target, 0, 2, world, verticesLength - 4, 2);
            world[verticesLength - 2] = world[0];
            world[verticesLength - 1] = world[1];
        } else {
            curveCount--;
            verticesLength -= 4;
            world = (0, $1Yup6.Utils).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength, world, 0, 2);
        }
        // Curve lengths.
        let curves = (0, $1Yup6.Utils).setArraySize(this.curves, curveCount);
        let pathLength = 0;
        let x1 = world[0], y1 = world[1], cx1 = 0, cy1 = 0, cx2 = 0, cy2 = 0, x2 = 0, y2 = 0;
        let tmpx = 0, tmpy = 0, dddfx = 0, dddfy = 0, ddfx = 0, ddfy = 0, dfx = 0, dfy = 0;
        for(let i = 0, w = 2; i < curveCount; i++, w += 6){
            cx1 = world[w];
            cy1 = world[w + 1];
            cx2 = world[w + 2];
            cy2 = world[w + 3];
            x2 = world[w + 4];
            y2 = world[w + 5];
            tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
            tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
            dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
            dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
            ddfx = tmpx * 2 + dddfx;
            ddfy = tmpy * 2 + dddfy;
            dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
            dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx + dddfx;
            dfy += ddfy + dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            curves[i] = pathLength;
            x1 = x2;
            y1 = y2;
        }
        if (this.data.positionMode == (0, $1Wvqv.PositionMode).Percent) position *= pathLength;
        let multiplier;
        switch(this.data.spacingMode){
            case (0, $1Wvqv.SpacingMode).Percent:
                multiplier = pathLength;
                break;
            case (0, $1Wvqv.SpacingMode).Proportional:
                multiplier = pathLength / spacesCount;
                break;
            default:
                multiplier = 1;
        }
        let segments = this.segments;
        let curveLength = 0;
        for(let i = 0, o = 0, curve = 0, segment = 0; i < spacesCount; i++, o += 3){
            let space = spaces[i] * multiplier;
            position += space;
            let p = position;
            if (closed) {
                p %= pathLength;
                if (p < 0) p += pathLength;
                curve = 0;
            } else if (p < 0) {
                this.addBeforePosition(p, world, 0, out, o);
                continue;
            } else if (p > pathLength) {
                this.addAfterPosition(p - pathLength, world, verticesLength - 4, out, o);
                continue;
            }
            // Determine curve containing position.
            for(;; curve++){
                let length = curves[curve];
                if (p > length) continue;
                if (curve == 0) p /= length;
                else {
                    let prev = curves[curve - 1];
                    p = (p - prev) / (length - prev);
                }
                break;
            }
            // Curve segment lengths.
            if (curve != prevCurve) {
                prevCurve = curve;
                let ii = curve * 6;
                x1 = world[ii];
                y1 = world[ii + 1];
                cx1 = world[ii + 2];
                cy1 = world[ii + 3];
                cx2 = world[ii + 4];
                cy2 = world[ii + 5];
                x2 = world[ii + 6];
                y2 = world[ii + 7];
                tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
                tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
                dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.006;
                dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.006;
                ddfx = tmpx * 2 + dddfx;
                ddfy = tmpy * 2 + dddfy;
                dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
                dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
                curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
                segments[0] = curveLength;
                for(ii = 1; ii < 8; ii++){
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    segments[ii] = curveLength;
                }
                dfx += ddfx;
                dfy += ddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[8] = curveLength;
                dfx += ddfx + dddfx;
                dfy += ddfy + dddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[9] = curveLength;
                segment = 0;
            }
            // Weight by segment length.
            p *= curveLength;
            for(;; segment++){
                let length = segments[segment];
                if (p > length) continue;
                if (segment == 0) p /= length;
                else {
                    let prev = segments[segment - 1];
                    p = segment + (p - prev) / (length - prev);
                }
                break;
            }
            this.addCurvePosition(p * 0.1, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents || i > 0 && space == 0);
        }
        return out;
    }
    addBeforePosition(p, temp, i, out, o) {
        let x1 = temp[i], y1 = temp[i + 1], dx = temp[i + 2] - x1, dy = temp[i + 3] - y1, r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addAfterPosition(p, temp, i, out, o) {
        let x1 = temp[i + 2], y1 = temp[i + 3], dx = x1 - temp[i], dy = y1 - temp[i + 1], r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addCurvePosition(p, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents) {
        if (p == 0 || isNaN(p)) {
            out[o] = x1;
            out[o + 1] = y1;
            out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            return;
        }
        let tt = p * p, ttt = tt * p, u = 1 - p, uu = u * u, uuu = uu * u;
        let ut = u * p, ut3 = ut * 3, uut3 = u * ut3, utt3 = ut3 * p;
        let x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt, y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
        out[o] = x;
        out[o + 1] = y;
        if (tangents) {
            if (p < 0.001) out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            else out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt), x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
        }
    }
}

});
parcelRegister("1Wvqv", function(module, exports) {

$parcel$export(module.exports, "PathConstraintData", () => $16a395dfc145fe87$export$d2629ab80d5dd5ba);
$parcel$export(module.exports, "PositionMode", () => $16a395dfc145fe87$export$34d637c671e1e906);
$parcel$export(module.exports, "SpacingMode", () => $16a395dfc145fe87$export$34ce760ad2b0be4b);
$parcel$export(module.exports, "RotateMode", () => $16a395dfc145fe87$export$a2a23846581ac82c);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $dTqn7 = parcelRequire("dTqn7");
class $16a395dfc145fe87$export$d2629ab80d5dd5ba extends (0, $dTqn7.ConstraintData) {
    /** The bones that will be modified by this path constraint. */ bones = new Array();
    /** The slot whose path attachment will be used to constrained the bones. */ _target = null;
    set target(slotData) {
        this._target = slotData;
    }
    get target() {
        if (!this._target) throw new Error("SlotData not set.");
        else return this._target;
    }
    /** The mode for positioning the first bone on the path. */ positionMode = $16a395dfc145fe87$export$34d637c671e1e906.Fixed;
    /** The mode for positioning the bones after the first bone on the path. */ spacingMode = $16a395dfc145fe87$export$34ce760ad2b0be4b.Fixed;
    /** The mode for adjusting the rotation of the bones. */ rotateMode = $16a395dfc145fe87$export$a2a23846581ac82c.Chain;
    /** An offset added to the constrained bone rotation. */ offsetRotation = 0;
    /** The position along the path. */ position = 0;
    /** The spacing between bones. */ spacing = 0;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    constructor(name){
        super(name, 0, false);
    }
}
var $16a395dfc145fe87$export$34d637c671e1e906;
(function(PositionMode) {
    PositionMode[PositionMode["Fixed"] = 0] = "Fixed";
    PositionMode[PositionMode["Percent"] = 1] = "Percent";
})($16a395dfc145fe87$export$34d637c671e1e906 || ($16a395dfc145fe87$export$34d637c671e1e906 = {}));
var $16a395dfc145fe87$export$34ce760ad2b0be4b;
(function(SpacingMode) {
    SpacingMode[SpacingMode["Length"] = 0] = "Length";
    SpacingMode[SpacingMode["Fixed"] = 1] = "Fixed";
    SpacingMode[SpacingMode["Percent"] = 2] = "Percent";
    SpacingMode[SpacingMode["Proportional"] = 3] = "Proportional";
})($16a395dfc145fe87$export$34ce760ad2b0be4b || ($16a395dfc145fe87$export$34ce760ad2b0be4b = {}));
var $16a395dfc145fe87$export$a2a23846581ac82c;
(function(RotateMode) {
    RotateMode[RotateMode["Tangent"] = 0] = "Tangent";
    RotateMode[RotateMode["Chain"] = 1] = "Chain";
    RotateMode[RotateMode["ChainScale"] = 2] = "ChainScale";
})($16a395dfc145fe87$export$a2a23846581ac82c || ($16a395dfc145fe87$export$a2a23846581ac82c = {}));

});


parcelRegister("5iLFL", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $3dc39cfdbd0ba43d$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Physics", () => $3dc39cfdbd0ba43d$export$2f09efa5b67124a7);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $hePJB = parcelRequire("hePJB");

var $5ot6H = parcelRequire("5ot6H");

var $46qOI = parcelRequire("46qOI");

var $8wKGy = parcelRequire("8wKGy");

var $5yGPE = parcelRequire("5yGPE");

var $kYVpx = parcelRequire("kYVpx");

var $dQ0tU = parcelRequire("dQ0tU");

var $18XRN = parcelRequire("18XRN");

var $2OSyh = parcelRequire("2OSyh");

var $hpxEh = parcelRequire("hpxEh");

var $1Yup6 = parcelRequire("1Yup6");
class $3dc39cfdbd0ba43d$export$8f31e4c4a37b8e9c {
    static quadTriangles = [
        0,
        1,
        2,
        2,
        3,
        0
    ];
    static yDown = false;
    /** The skeleton's setup pose data. */ data;
    /** The skeleton's bones, sorted parent first. The root bone is always the first bone. */ bones;
    /** The skeleton's slots in the setup pose draw order. */ slots;
    /** The skeleton's slots in the order they should be drawn. The returned array may be modified to change the draw order. */ drawOrder;
    /** The skeleton's IK constraints. */ ikConstraints;
    /** The skeleton's transform constraints. */ transformConstraints;
    /** The skeleton's path constraints. */ pathConstraints;
    /** The skeleton's physics constraints. */ physicsConstraints;
    /** The list of bones and constraints, sorted in the order they should be updated, as computed by {@link #updateCache()}. */ _updateCache = new Array();
    /** The skeleton's current skin. May be null. */ skin = null;
    /** The color to tint all the skeleton's attachments. */ color;
    /** Scales the entire skeleton on the X axis. This affects all bones, even if the bone's transform mode disallows scale
      * inheritance. */ scaleX = 1;
    /** Scales the entire skeleton on the Y axis. This affects all bones, even if the bone's transform mode disallows scale
      * inheritance. */ _scaleY = 1;
    get scaleY() {
        return $3dc39cfdbd0ba43d$export$8f31e4c4a37b8e9c.yDown ? -this._scaleY : this._scaleY;
    }
    set scaleY(scaleY) {
        this._scaleY = scaleY;
    }
    /** Sets the skeleton X position, which is added to the root bone worldX position. */ x = 0;
    /** Sets the skeleton Y position, which is added to the root bone worldY position. */ y = 0;
    /** Returns the skeleton's time. This is used for time-based manipulations, such as {@link PhysicsConstraint}.
     * <p>
     * See {@link #update(float)}. */ time = 0;
    constructor(data){
        if (!data) throw new Error("data cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let boneData = data.bones[i];
            let bone;
            if (!boneData.parent) bone = new (0, $5yGPE.Bone)(boneData, this, null);
            else {
                let parent = this.bones[boneData.parent.index];
                bone = new (0, $5yGPE.Bone)(boneData, this, parent);
                parent.children.push(bone);
            }
            this.bones.push(bone);
        }
        this.slots = new Array();
        this.drawOrder = new Array();
        for(let i = 0; i < data.slots.length; i++){
            let slotData = data.slots[i];
            let bone = this.bones[slotData.boneData.index];
            let slot = new (0, $2OSyh.Slot)(slotData, bone);
            this.slots.push(slot);
            this.drawOrder.push(slot);
        }
        this.ikConstraints = new Array();
        for(let i = 0; i < data.ikConstraints.length; i++){
            let ikConstraintData = data.ikConstraints[i];
            this.ikConstraints.push(new (0, $kYVpx.IkConstraint)(ikConstraintData, this));
        }
        this.transformConstraints = new Array();
        for(let i = 0; i < data.transformConstraints.length; i++){
            let transformConstraintData = data.transformConstraints[i];
            this.transformConstraints.push(new (0, $hpxEh.TransformConstraint)(transformConstraintData, this));
        }
        this.pathConstraints = new Array();
        for(let i = 0; i < data.pathConstraints.length; i++){
            let pathConstraintData = data.pathConstraints[i];
            this.pathConstraints.push(new (0, $dQ0tU.PathConstraint)(pathConstraintData, this));
        }
        this.physicsConstraints = new Array();
        for(let i = 0; i < data.physicsConstraints.length; i++){
            let physicsConstraintData = data.physicsConstraints[i];
            this.physicsConstraints.push(new (0, $18XRN.PhysicsConstraint)(physicsConstraintData, this));
        }
        this.color = new (0, $1Yup6.Color)(1, 1, 1, 1);
        this.updateCache();
    }
    /** Caches information about bones and constraints. Must be called if the {@link #getSkin()} is modified or if bones,
     * constraints, or weighted path attachments are added or removed. */ updateCache() {
        let updateCache = this._updateCache;
        updateCache.length = 0;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            bone.sorted = bone.data.skinRequired;
            bone.active = !bone.sorted;
        }
        if (this.skin) {
            let skinBones = this.skin.bones;
            for(let i = 0, n = this.skin.bones.length; i < n; i++){
                let bone = this.bones[skinBones[i].index];
                do {
                    bone.sorted = false;
                    bone.active = true;
                    bone = bone.parent;
                }while (bone);
            }
        }
        // IK first, lowest hierarchy depth first.
        let ikConstraints = this.ikConstraints;
        let transformConstraints = this.transformConstraints;
        let pathConstraints = this.pathConstraints;
        let physicsConstraints = this.physicsConstraints;
        let ikCount = ikConstraints.length, transformCount = transformConstraints.length, pathCount = pathConstraints.length, physicsCount = this.physicsConstraints.length;
        let constraintCount = ikCount + transformCount + pathCount + physicsCount;
        outer: for(let i = 0; i < constraintCount; i++){
            for(let ii = 0; ii < ikCount; ii++){
                let constraint = ikConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortIkConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < transformCount; ii++){
                let constraint = transformConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortTransformConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < pathCount; ii++){
                let constraint = pathConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPathConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < physicsCount; ii++){
                const constraint = physicsConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPhysicsConstraint(constraint);
                    continue outer;
                }
            }
        }
        for(let i = 0, n = bones.length; i < n; i++)this.sortBone(bones[i]);
    }
    sortIkConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $1Yup6.Utils).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        let target = constraint.target;
        this.sortBone(target);
        let constrained = constraint.bones;
        let parent = constrained[0];
        this.sortBone(parent);
        if (constrained.length == 1) {
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
        } else {
            let child = constrained[constrained.length - 1];
            this.sortBone(child);
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
            child.sorted = true;
        }
    }
    sortPathConstraint(constraint) {
        constraint.active = constraint.target.bone.isActive() && (!constraint.data.skinRequired || this.skin && (0, $1Yup6.Utils).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        let slot = constraint.target;
        let slotIndex = slot.data.index;
        let slotBone = slot.bone;
        if (this.skin) this.sortPathConstraintAttachment(this.skin, slotIndex, slotBone);
        if (this.data.defaultSkin && this.data.defaultSkin != this.skin) this.sortPathConstraintAttachment(this.data.defaultSkin, slotIndex, slotBone);
        for(let i = 0, n = this.data.skins.length; i < n; i++)this.sortPathConstraintAttachment(this.data.skins[i], slotIndex, slotBone);
        let attachment = slot.getAttachment();
        if (attachment instanceof (0, $46qOI.PathAttachment)) this.sortPathConstraintAttachmentWith(attachment, slotBone);
        let constrained = constraint.bones;
        let boneCount = constrained.length;
        for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortTransformConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $1Yup6.Utils).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        this.sortBone(constraint.target);
        let constrained = constraint.bones;
        let boneCount = constrained.length;
        if (constraint.data.local) for(let i = 0; i < boneCount; i++){
            let child = constrained[i];
            this.sortBone(child.parent);
            this.sortBone(child);
        }
        else for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortPathConstraintAttachment(skin, slotIndex, slotBone) {
        let attachments = skin.attachments[slotIndex];
        if (!attachments) return;
        for(let key in attachments)this.sortPathConstraintAttachmentWith(attachments[key], slotBone);
    }
    sortPathConstraintAttachmentWith(attachment, slotBone) {
        if (!(attachment instanceof (0, $46qOI.PathAttachment))) return;
        let pathBones = attachment.bones;
        if (!pathBones) this.sortBone(slotBone);
        else {
            let bones = this.bones;
            for(let i = 0, n = pathBones.length; i < n;){
                let nn = pathBones[i++];
                nn += i;
                while(i < nn)this.sortBone(bones[pathBones[i++]]);
            }
        }
    }
    sortPhysicsConstraint(constraint) {
        const bone = constraint.bone;
        constraint.active = bone.active && (!constraint.data.skinRequired || this.skin != null && (0, $1Yup6.Utils).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        this.sortBone(bone);
        this._updateCache.push(constraint);
        this.sortReset(bone.children);
        bone.sorted = true;
    }
    sortBone(bone) {
        if (!bone) return;
        if (bone.sorted) return;
        let parent = bone.parent;
        if (parent) this.sortBone(parent);
        bone.sorted = true;
        this._updateCache.push(bone);
    }
    sortReset(bones) {
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (!bone.active) continue;
            if (bone.sorted) this.sortReset(bone.children);
            bone.sorted = false;
        }
    }
    /** Updates the world transform for each bone and applies all constraints.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide. */ updateWorldTransform(physics) {
        if (physics === undefined || physics === null) throw new Error("physics is undefined");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            bone.ax = bone.x;
            bone.ay = bone.y;
            bone.arotation = bone.rotation;
            bone.ascaleX = bone.scaleX;
            bone.ascaleY = bone.scaleY;
            bone.ashearX = bone.shearX;
            bone.ashearY = bone.shearY;
        }
        let updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++)updateCache[i].update(physics);
    }
    updateWorldTransformWith(physics, parent) {
        if (!parent) throw new Error("parent cannot be null.");
        let bones = this.bones;
        for(let i = 1, n = bones.length; i < n; i++){
            let bone = bones[i];
            bone.ax = bone.x;
            bone.ay = bone.y;
            bone.arotation = bone.rotation;
            bone.ascaleX = bone.scaleX;
            bone.ascaleY = bone.scaleY;
            bone.ashearX = bone.shearX;
            bone.ashearY = bone.shearY;
        }
        // Apply the parent bone transform to the root bone. The root bone always inherits scale, rotation and reflection.
        let rootBone = this.getRootBone();
        if (!rootBone) throw new Error("Root bone must not be null.");
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        rootBone.worldX = pa * this.x + pb * this.y + parent.worldX;
        rootBone.worldY = pc * this.x + pd * this.y + parent.worldY;
        const rx = (rootBone.rotation + rootBone.shearX) * (0, $1Yup6.MathUtils).degRad;
        const ry = (rootBone.rotation + 90 + rootBone.shearY) * (0, $1Yup6.MathUtils).degRad;
        const la = Math.cos(rx) * rootBone.scaleX;
        const lb = Math.cos(ry) * rootBone.scaleY;
        const lc = Math.sin(rx) * rootBone.scaleX;
        const ld = Math.sin(ry) * rootBone.scaleY;
        rootBone.a = (pa * la + pb * lc) * this.scaleX;
        rootBone.b = (pa * lb + pb * ld) * this.scaleX;
        rootBone.c = (pc * la + pd * lc) * this.scaleY;
        rootBone.d = (pc * lb + pd * ld) * this.scaleY;
        // Update everything except root bone.
        let updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++){
            let updatable = updateCache[i];
            if (updatable != rootBone) updatable.update(physics);
        }
    }
    /** Sets the bones, constraints, and slots to their setup pose values. */ setToSetupPose() {
        this.setBonesToSetupPose();
        this.setSlotsToSetupPose();
    }
    /** Sets the bones and constraints to their setup pose values. */ setBonesToSetupPose() {
        for (const bone of this.bones)bone.setToSetupPose();
        for (const constraint of this.ikConstraints)constraint.setToSetupPose();
        for (const constraint of this.transformConstraints)constraint.setToSetupPose();
        for (const constraint of this.pathConstraints)constraint.setToSetupPose();
        for (const constraint of this.physicsConstraints)constraint.setToSetupPose();
    }
    /** Sets the slots and draw order to their setup pose values. */ setSlotsToSetupPose() {
        let slots = this.slots;
        (0, $1Yup6.Utils).arrayCopy(slots, 0, this.drawOrder, 0, slots.length);
        for(let i = 0, n = slots.length; i < n; i++)slots[i].setToSetupPose();
    }
    /** @returns May return null. */ getRootBone() {
        if (this.bones.length == 0) return null;
        return this.bones[0];
    }
    /** @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (bone.data.name == boneName) return bone;
        }
        return null;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
     * repeatedly.
     * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.data.name == slotName) return slot;
        }
        return null;
    }
    /** Sets a skin by name.
     *
     * See {@link #setSkin()}. */ setSkinByName(skinName) {
        let skin = this.data.findSkin(skinName);
        if (!skin) throw new Error("Skin not found: " + skinName);
        this.setSkin(skin);
    }
    /** Sets the skin used to look up attachments before looking in the {@link SkeletonData#defaultSkin default skin}. If the
     * skin is changed, {@link #updateCache()} is called.
     *
     * Attachments from the new skin are attached if the corresponding attachment from the old skin was attached. If there was no
     * old skin, each slot's setup mode attachment is attached from the new skin.
     *
     * After changing the skin, the visible attachments can be reset to those attached in the setup pose by calling
     * {@link #setSlotsToSetupPose()}. Also, often {@link AnimationState#apply()} is called before the next time the
     * skeleton is rendered to allow any attachment keys in the current animation(s) to hide or show attachments from the new skin.
     * @param newSkin May be null. */ setSkin(newSkin) {
        if (newSkin == this.skin) return;
        if (newSkin) {
            if (this.skin) newSkin.attachAll(this, this.skin);
            else {
                let slots = this.slots;
                for(let i = 0, n = slots.length; i < n; i++){
                    let slot = slots[i];
                    let name = slot.data.attachmentName;
                    if (name) {
                        let attachment = newSkin.getAttachment(i, name);
                        if (attachment) slot.setAttachment(attachment);
                    }
                }
            }
        }
        this.skin = newSkin;
        this.updateCache();
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot name and attachment
     * name.
     *
     * See {@link #getAttachment()}.
     * @returns May be null. */ getAttachmentByName(slotName, attachmentName) {
        let slot = this.data.findSlot(slotName);
        if (!slot) throw new Error(`Can't find slot with name ${slotName}`);
        return this.getAttachment(slot.index, attachmentName);
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot index and
     * attachment name. First the skin is checked and if the attachment was not found, the default skin is checked.
     *
     * See [Runtime skins](http://esotericsoftware.com/spine-runtime-skins) in the Spine Runtimes Guide.
     * @returns May be null. */ getAttachment(slotIndex, attachmentName) {
        if (!attachmentName) throw new Error("attachmentName cannot be null.");
        if (this.skin) {
            let attachment = this.skin.getAttachment(slotIndex, attachmentName);
            if (attachment) return attachment;
        }
        if (this.data.defaultSkin) return this.data.defaultSkin.getAttachment(slotIndex, attachmentName);
        return null;
    }
    /** A convenience method to set an attachment by finding the slot with {@link #findSlot()}, finding the attachment with
     * {@link #getAttachment()}, then setting the slot's {@link Slot#attachment}.
     * @param attachmentName May be null to clear the slot's attachment. */ setAttachment(slotName, attachmentName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.data.name == slotName) {
                let attachment = null;
                if (attachmentName) {
                    attachment = this.getAttachment(i, attachmentName);
                    if (!attachment) throw new Error("Attachment not found: " + attachmentName + ", for slot: " + slotName);
                }
                slot.setAttachment(attachment);
                return;
            }
        }
        throw new Error("Slot not found: " + slotName);
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
     * than to call it repeatedly.
     * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        return this.ikConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
     * this method than to call it repeatedly.
     * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        return this.transformConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
     * than to call it repeatedly.
     * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        return this.pathConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Finds a physics constraint by comparing each physics constraint's name. It is more efficient to cache the results of this
     * method than to call it repeatedly. */ findPhysicsConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        return this.physicsConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose as `{ x: number, y: number, width: number, height: number }`.
     * Note that this method will create temporary objects which can add to garbage collection pressure. Use `getBounds()` if garbage collection is a concern. */ getBoundsRect(clipper) {
        let offset = new (0, $1Yup6.Vector2)();
        let size = new (0, $1Yup6.Vector2)();
        this.getBounds(offset, size, undefined, clipper);
        return {
            x: offset.x,
            y: offset.y,
            width: size.x,
            height: size.y
        };
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose.
     * @param offset An output value, the distance from the skeleton origin to the bottom left corner of the AABB.
     * @param size An output value, the width and height of the AABB.
     * @param temp Working memory to temporarily store attachments' computed world vertices.
     * @param clipper {@link SkeletonClipping} to use. If <code>null</code>, no clipping is applied. */ getBounds(offset, size, temp = new Array(2), clipper = null) {
        if (!offset) throw new Error("offset cannot be null.");
        if (!size) throw new Error("size cannot be null.");
        let drawOrder = this.drawOrder;
        let minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            let slot = drawOrder[i];
            if (!slot.bone.active) continue;
            let verticesLength = 0;
            let vertices = null;
            let triangles = null;
            let attachment = slot.getAttachment();
            if (attachment instanceof (0, $8wKGy.RegionAttachment)) {
                verticesLength = 8;
                vertices = (0, $1Yup6.Utils).setArraySize(temp, verticesLength, 0);
                attachment.computeWorldVertices(slot, vertices, 0, 2);
                triangles = $3dc39cfdbd0ba43d$export$8f31e4c4a37b8e9c.quadTriangles;
            } else if (attachment instanceof (0, $5ot6H.MeshAttachment)) {
                let mesh = attachment;
                verticesLength = mesh.worldVerticesLength;
                vertices = (0, $1Yup6.Utils).setArraySize(temp, verticesLength, 0);
                mesh.computeWorldVertices(slot, 0, verticesLength, vertices, 0, 2);
                triangles = mesh.triangles;
            } else if (attachment instanceof (0, $hePJB.ClippingAttachment) && clipper != null) {
                clipper.clipStart(slot, attachment);
                continue;
            }
            if (vertices && triangles) {
                if (clipper != null && clipper.isClipping()) {
                    clipper.clipTriangles(vertices, triangles, triangles.length);
                    vertices = clipper.clippedVertices;
                    verticesLength = clipper.clippedVertices.length;
                }
                for(let ii = 0, nn = vertices.length; ii < nn; ii += 2){
                    let x = vertices[ii], y = vertices[ii + 1];
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            if (clipper != null) clipper.clipEndWithSlot(slot);
        }
        if (clipper != null) clipper.clipEnd();
        offset.set(minX, minY);
        size.set(maxX - minX, maxY - minY);
    }
    /** Increments the skeleton's {@link #time}. */ update(delta) {
        this.time += delta;
    }
    physicsTranslate(x, y) {
        const physicsConstraints = this.physicsConstraints;
        for(let i = 0, n = physicsConstraints.length; i < n; i++)physicsConstraints[i].translate(x, y);
    }
    /** Calls {@link PhysicsConstraint#rotate(float, float, float)} for each physics constraint. */ physicsRotate(x, y, degrees) {
        const physicsConstraints = this.physicsConstraints;
        for(let i = 0, n = physicsConstraints.length; i < n; i++)physicsConstraints[i].rotate(x, y, degrees);
    }
}
var $3dc39cfdbd0ba43d$export$2f09efa5b67124a7;
(function(Physics) {
    /** Physics are not updated or applied. */ Physics[Physics["none"] = 0] = "none";
    /** Physics are reset to the current pose. */ Physics[Physics["reset"] = 1] = "reset";
    /** Physics are updated and the pose from physics is applied. */ Physics[Physics["update"] = 2] = "update";
    /** Physics are not updated but the pose from physics is applied. */ Physics[Physics["pose"] = 3] = "pose";
})($3dc39cfdbd0ba43d$export$2f09efa5b67124a7 || ($3dc39cfdbd0ba43d$export$2f09efa5b67124a7 = {}));

});
parcelRegister("18XRN", function(module, exports) {

$parcel$export(module.exports, "PhysicsConstraint", () => $0d54fa125025a02e$export$5a60d3a36c7d9b56);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $5iLFL = parcelRequire("5iLFL");

var $1Yup6 = parcelRequire("1Yup6");
class $0d54fa125025a02e$export$5a60d3a36c7d9b56 {
    data;
    _bone = null;
    /** The bone constrained by this physics constraint. */ set bone(bone) {
        this._bone = bone;
    }
    get bone() {
        if (!this._bone) throw new Error("Bone not set.");
        else return this._bone;
    }
    inertia = 0;
    strength = 0;
    damping = 0;
    massInverse = 0;
    wind = 0;
    gravity = 0;
    mix = 0;
    _reset = true;
    ux = 0;
    uy = 0;
    cx = 0;
    cy = 0;
    tx = 0;
    ty = 0;
    xOffset = 0;
    xVelocity = 0;
    yOffset = 0;
    yVelocity = 0;
    rotateOffset = 0;
    rotateVelocity = 0;
    scaleOffset = 0;
    scaleVelocity = 0;
    active = false;
    skeleton;
    remaining = 0;
    lastTime = 0;
    constructor(data, skeleton){
        this.data = data;
        this.skeleton = skeleton;
        this.bone = skeleton.bones[data.bone.index];
        this.inertia = data.inertia;
        this.strength = data.strength;
        this.damping = data.damping;
        this.massInverse = data.massInverse;
        this.wind = data.wind;
        this.gravity = data.gravity;
        this.mix = data.mix;
    }
    reset() {
        this.remaining = 0;
        this.lastTime = this.skeleton.time;
        this._reset = true;
        this.xOffset = 0;
        this.xVelocity = 0;
        this.yOffset = 0;
        this.yVelocity = 0;
        this.rotateOffset = 0;
        this.rotateVelocity = 0;
        this.scaleOffset = 0;
        this.scaleVelocity = 0;
    }
    setToSetupPose() {
        const data = this.data;
        this.inertia = data.inertia;
        this.strength = data.strength;
        this.damping = data.damping;
        this.massInverse = data.massInverse;
        this.wind = data.wind;
        this.gravity = data.gravity;
        this.mix = data.mix;
    }
    isActive() {
        return this.active;
    }
    /** Applies the constraint to the constrained bones. */ update(physics) {
        const mix = this.mix;
        if (mix == 0) return;
        const x = this.data.x > 0, y = this.data.y > 0, rotateOrShearX = this.data.rotate > 0 || this.data.shearX > 0, scaleX = this.data.scaleX > 0;
        const bone = this.bone;
        const l = bone.data.length;
        switch(physics){
            case (0, $5iLFL.Physics).none:
                return;
            case (0, $5iLFL.Physics).reset:
                this.reset();
            // Fall through.
            case (0, $5iLFL.Physics).update:
                const skeleton = this.skeleton;
                const delta = Math.max(this.skeleton.time - this.lastTime, 0);
                this.remaining += delta;
                this.lastTime = skeleton.time;
                const bx = bone.worldX, by = bone.worldY;
                if (this._reset) {
                    this._reset = false;
                    this.ux = bx;
                    this.uy = by;
                } else {
                    let a = this.remaining, i = this.inertia, t = this.data.step, f = this.skeleton.data.referenceScale, d = -1;
                    let qx = this.data.limit * delta, qy = qx * Math.abs(skeleton.scaleY);
                    qx *= Math.abs(skeleton.scaleX);
                    if (x || y) {
                        if (x) {
                            const u = (this.ux - bx) * i;
                            this.xOffset += u > qx ? qx : u < -qx ? -qx : u;
                            this.ux = bx;
                        }
                        if (y) {
                            const u = (this.uy - by) * i;
                            this.yOffset += u > qy ? qy : u < -qy ? -qy : u;
                            this.uy = by;
                        }
                        if (a >= t) {
                            d = Math.pow(this.damping, 60 * t);
                            const m = this.massInverse * t, e = this.strength, w = this.wind * f * skeleton.scaleX, g = this.gravity * f * skeleton.scaleY;
                            do {
                                if (x) {
                                    this.xVelocity += (w - this.xOffset * e) * m;
                                    this.xOffset += this.xVelocity * t;
                                    this.xVelocity *= d;
                                }
                                if (y) {
                                    this.yVelocity -= (g + this.yOffset * e) * m;
                                    this.yOffset += this.yVelocity * t;
                                    this.yVelocity *= d;
                                }
                                a -= t;
                            }while (a >= t);
                        }
                        if (x) bone.worldX += this.xOffset * mix * this.data.x;
                        if (y) bone.worldY += this.yOffset * mix * this.data.y;
                    }
                    if (rotateOrShearX || scaleX) {
                        let ca = Math.atan2(bone.c, bone.a), c = 0, s = 0, mr = 0;
                        let dx = this.cx - bone.worldX, dy = this.cy - bone.worldY;
                        if (dx > qx) dx = qx;
                        else if (dx < -qx) dx = -qx;
                        if (dy > qy) dy = qy;
                        else if (dy < -qy) dy = -qy;
                        if (rotateOrShearX) {
                            mr = (this.data.rotate + this.data.shearX) * mix;
                            let r = Math.atan2(dy + this.ty, dx + this.tx) - ca - this.rotateOffset * mr;
                            this.rotateOffset += (r - Math.ceil(r * (0, $1Yup6.MathUtils).invPI2 - 0.5) * (0, $1Yup6.MathUtils).PI2) * i;
                            r = this.rotateOffset * mr + ca;
                            c = Math.cos(r);
                            s = Math.sin(r);
                            if (scaleX) {
                                r = l * bone.getWorldScaleX();
                                if (r > 0) this.scaleOffset += (dx * c + dy * s) * i / r;
                            }
                        } else {
                            c = Math.cos(ca);
                            s = Math.sin(ca);
                            const r = l * bone.getWorldScaleX();
                            if (r > 0) this.scaleOffset += (dx * c + dy * s) * i / r;
                        }
                        a = this.remaining;
                        if (a >= t) {
                            if (d == -1) d = Math.pow(this.damping, 60 * t);
                            const m = this.massInverse * t, e = this.strength, w = this.wind, g = (0, $5iLFL.Skeleton).yDown ? -this.gravity : this.gravity, h = l / f;
                            while(true){
                                a -= t;
                                if (scaleX) {
                                    this.scaleVelocity += (w * c - g * s - this.scaleOffset * e) * m;
                                    this.scaleOffset += this.scaleVelocity * t;
                                    this.scaleVelocity *= d;
                                }
                                if (rotateOrShearX) {
                                    this.rotateVelocity -= ((w * s + g * c) * h + this.rotateOffset * e) * m;
                                    this.rotateOffset += this.rotateVelocity * t;
                                    this.rotateVelocity *= d;
                                    if (a < t) break;
                                    const r = this.rotateOffset * mr + ca;
                                    c = Math.cos(r);
                                    s = Math.sin(r);
                                } else if (a < t) break;
                            }
                        }
                    }
                    this.remaining = a;
                }
                this.cx = bone.worldX;
                this.cy = bone.worldY;
                break;
            case (0, $5iLFL.Physics).pose:
                if (x) bone.worldX += this.xOffset * mix * this.data.x;
                if (y) bone.worldY += this.yOffset * mix * this.data.y;
        }
        if (rotateOrShearX) {
            let o = this.rotateOffset * mix, s = 0, c = 0, a = 0;
            if (this.data.shearX > 0) {
                let r = 0;
                if (this.data.rotate > 0) {
                    r = o * this.data.rotate;
                    s = Math.sin(r);
                    c = Math.cos(r);
                    a = bone.b;
                    bone.b = c * a - s * bone.d;
                    bone.d = s * a + c * bone.d;
                }
                r += o * this.data.shearX;
                s = Math.sin(r);
                c = Math.cos(r);
                a = bone.a;
                bone.a = c * a - s * bone.c;
                bone.c = s * a + c * bone.c;
            } else {
                o *= this.data.rotate;
                s = Math.sin(o);
                c = Math.cos(o);
                a = bone.a;
                bone.a = c * a - s * bone.c;
                bone.c = s * a + c * bone.c;
                a = bone.b;
                bone.b = c * a - s * bone.d;
                bone.d = s * a + c * bone.d;
            }
        }
        if (scaleX) {
            const s = 1 + this.scaleOffset * mix * this.data.scaleX;
            bone.a *= s;
            bone.c *= s;
        }
        if (physics != (0, $5iLFL.Physics).pose) {
            this.tx = l * bone.a;
            this.ty = l * bone.c;
        }
        bone.updateAppliedTransform();
    }
    /** Translates the physics constraint so next {@link #update(Physics)} forces are applied as if the bone moved an additional
     * amount in world space. */ translate(x, y) {
        this.ux -= x;
        this.uy -= y;
        this.cx -= x;
        this.cy -= y;
    }
    /** Rotates the physics constraint so next {@link #update(Physics)} forces are applied as if the bone rotated around the
     * specified point in world space. */ rotate(x, y, degrees) {
        const r = degrees * (0, $1Yup6.MathUtils).degRad, cos = Math.cos(r), sin = Math.sin(r);
        const dx = this.cx - x, dy = this.cy - y;
        this.translate(dx * cos - dy * sin - dx, dx * sin + dy * cos - dy);
    }
}

});

parcelRegister("2OSyh", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $20da912a1ef4fb98$export$8c6ed5c666ac1360);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $5a4jk = parcelRequire("5a4jk");

var $1Yup6 = parcelRequire("1Yup6");
class $20da912a1ef4fb98$export$8c6ed5c666ac1360 {
    /** The slot's setup pose data. */ data;
    /** The bone this slot belongs to. */ bone;
    /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
     * color tinting. */ color;
    /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ darkColor = null;
    attachment = null;
    attachmentState = 0;
    /** The index of the texture region to display when the slot's attachment has a {@link Sequence}. -1 represents the
     * {@link Sequence#getSetupIndex()}. */ sequenceIndex = -1;
    /** Values to deform the slot's attachment. For an unweighted mesh, the entries are local positions for each vertex. For a
     * weighted mesh, the entries are an offset for each vertex which will be added to the mesh's local vertex positions.
     *
     * See {@link VertexAttachment#computeWorldVertices()} and {@link DeformTimeline}. */ deform = new Array();
    constructor(data, bone){
        if (!data) throw new Error("data cannot be null.");
        if (!bone) throw new Error("bone cannot be null.");
        this.data = data;
        this.bone = bone;
        this.color = new (0, $1Yup6.Color)();
        this.darkColor = !data.darkColor ? null : new (0, $1Yup6.Color)();
        this.setToSetupPose();
    }
    /** The skeleton this slot belongs to. */ getSkeleton() {
        return this.bone.skeleton;
    }
    /** The current attachment for the slot, or null if the slot has no attachment. */ getAttachment() {
        return this.attachment;
    }
    /** Sets the slot's attachment and, if the attachment changed, resets {@link #sequenceIndex} and clears the {@link #deform}.
     * The deform is not cleared if the old attachment has the same {@link VertexAttachment#getTimelineAttachment()} as the
     * specified attachment. */ setAttachment(attachment) {
        if (this.attachment == attachment) return;
        if (!(attachment instanceof (0, $5a4jk.VertexAttachment)) || !(this.attachment instanceof (0, $5a4jk.VertexAttachment)) || attachment.timelineAttachment != this.attachment.timelineAttachment) this.deform.length = 0;
        this.attachment = attachment;
        this.sequenceIndex = -1;
    }
    /** Sets this slot to the setup pose. */ setToSetupPose() {
        this.color.setFromColor(this.data.color);
        if (this.darkColor) this.darkColor.setFromColor(this.data.darkColor);
        if (!this.data.attachmentName) this.attachment = null;
        else {
            this.attachment = null;
            this.setAttachment(this.bone.skeleton.getAttachment(this.data.index, this.data.attachmentName));
        }
    }
}

});

parcelRegister("hpxEh", function(module, exports) {

$parcel$export(module.exports, "TransformConstraint", () => $cacedf5f4217ea0c$export$a2d8268faabf5c52);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");
class $cacedf5f4217ea0c$export$a2d8268faabf5c52 {
    /** The transform constraint's setup pose data. */ data;
    /** The bones that will be modified by this transform constraint. */ bones;
    /** The target bone whose world transform will be copied to the constrained bones. */ target;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    mixScaleX = 0;
    mixScaleY = 0;
    mixShearY = 0;
    temp = new (0, $1Yup6.Vector2)();
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        let target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}.`);
        this.target = target;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
        this.mixScaleX = data.mixScaleX;
        this.mixScaleY = data.mixScaleY;
        this.mixShearY = data.mixShearY;
    }
    isActive() {
        return this.active;
    }
    setToSetupPose() {
        const data = this.data;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
        this.mixScaleX = data.mixScaleX;
        this.mixScaleY = data.mixScaleY;
        this.mixShearY = data.mixShearY;
    }
    update(physics) {
        if (this.mixRotate == 0 && this.mixX == 0 && this.mixY == 0 && this.mixScaleX == 0 && this.mixScaleY == 0 && this.mixShearY == 0) return;
        if (this.data.local) {
            if (this.data.relative) this.applyRelativeLocal();
            else this.applyAbsoluteLocal();
        } else if (this.data.relative) this.applyRelativeWorld();
        else this.applyAbsoluteWorld();
    }
    applyAbsoluteWorld() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let translate = mixX != 0 || mixY != 0;
        let target = this.target;
        let ta = target.a, tb = target.b, tc = target.c, td = target.d;
        let degRadReflect = ta * td - tb * tc > 0 ? (0, $1Yup6.MathUtils).degRad : -(0, $1Yup6.MathUtils).degRad;
        let offsetRotation = this.data.offsetRotation * degRadReflect;
        let offsetShearY = this.data.offsetShearY * degRadReflect;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (mixRotate != 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
                let r = Math.atan2(tc, ta) - Math.atan2(c, a) + offsetRotation;
                if (r > (0, $1Yup6.MathUtils).PI) r -= (0, $1Yup6.MathUtils).PI2;
                else if (r < -(0, $1Yup6.MathUtils).PI) r += (0, $1Yup6.MathUtils).PI2;
                r *= mixRotate;
                let cos = Math.cos(r), sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            if (translate) {
                let temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                bone.worldX += (temp.x - bone.worldX) * mixX;
                bone.worldY += (temp.y - bone.worldY) * mixY;
            }
            if (mixScaleX != 0) {
                let s = Math.sqrt(bone.a * bone.a + bone.c * bone.c);
                if (s != 0) s = (s + (Math.sqrt(ta * ta + tc * tc) - s + this.data.offsetScaleX) * mixScaleX) / s;
                bone.a *= s;
                bone.c *= s;
            }
            if (mixScaleY != 0) {
                let s = Math.sqrt(bone.b * bone.b + bone.d * bone.d);
                if (s != 0) s = (s + (Math.sqrt(tb * tb + td * td) - s + this.data.offsetScaleY) * mixScaleY) / s;
                bone.b *= s;
                bone.d *= s;
            }
            if (mixShearY > 0) {
                let b = bone.b, d = bone.d;
                let by = Math.atan2(d, b);
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta) - (by - Math.atan2(bone.c, bone.a));
                if (r > (0, $1Yup6.MathUtils).PI) r -= (0, $1Yup6.MathUtils).PI2;
                else if (r < -(0, $1Yup6.MathUtils).PI) r += (0, $1Yup6.MathUtils).PI2;
                r = by + (r + offsetShearY) * mixShearY;
                let s = Math.sqrt(b * b + d * d);
                bone.b = Math.cos(r) * s;
                bone.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyRelativeWorld() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let translate = mixX != 0 || mixY != 0;
        let target = this.target;
        let ta = target.a, tb = target.b, tc = target.c, td = target.d;
        let degRadReflect = ta * td - tb * tc > 0 ? (0, $1Yup6.MathUtils).degRad : -(0, $1Yup6.MathUtils).degRad;
        let offsetRotation = this.data.offsetRotation * degRadReflect, offsetShearY = this.data.offsetShearY * degRadReflect;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (mixRotate != 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
                let r = Math.atan2(tc, ta) + offsetRotation;
                if (r > (0, $1Yup6.MathUtils).PI) r -= (0, $1Yup6.MathUtils).PI2;
                else if (r < -(0, $1Yup6.MathUtils).PI) r += (0, $1Yup6.MathUtils).PI2;
                r *= mixRotate;
                let cos = Math.cos(r), sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            if (translate) {
                let temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                bone.worldX += temp.x * mixX;
                bone.worldY += temp.y * mixY;
            }
            if (mixScaleX != 0) {
                let s = (Math.sqrt(ta * ta + tc * tc) - 1 + this.data.offsetScaleX) * mixScaleX + 1;
                bone.a *= s;
                bone.c *= s;
            }
            if (mixScaleY != 0) {
                let s = (Math.sqrt(tb * tb + td * td) - 1 + this.data.offsetScaleY) * mixScaleY + 1;
                bone.b *= s;
                bone.d *= s;
            }
            if (mixShearY > 0) {
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta);
                if (r > (0, $1Yup6.MathUtils).PI) r -= (0, $1Yup6.MathUtils).PI2;
                else if (r < -(0, $1Yup6.MathUtils).PI) r += (0, $1Yup6.MathUtils).PI2;
                let b = bone.b, d = bone.d;
                r = Math.atan2(d, b) + (r - (0, $1Yup6.MathUtils).PI / 2 + offsetShearY) * mixShearY;
                let s = Math.sqrt(b * b + d * d);
                bone.b = Math.cos(r) * s;
                bone.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyAbsoluteLocal() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let target = this.target;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            let rotation = bone.arotation;
            if (mixRotate != 0) rotation += (target.arotation - rotation + this.data.offsetRotation) * mixRotate;
            let x = bone.ax, y = bone.ay;
            x += (target.ax - x + this.data.offsetX) * mixX;
            y += (target.ay - y + this.data.offsetY) * mixY;
            let scaleX = bone.ascaleX, scaleY = bone.ascaleY;
            if (mixScaleX != 0 && scaleX != 0) scaleX = (scaleX + (target.ascaleX - scaleX + this.data.offsetScaleX) * mixScaleX) / scaleX;
            if (mixScaleY != 0 && scaleY != 0) scaleY = (scaleY + (target.ascaleY - scaleY + this.data.offsetScaleY) * mixScaleY) / scaleY;
            let shearY = bone.ashearY;
            if (mixShearY != 0) shearY += (target.ashearY - shearY + this.data.offsetShearY) * mixShearY;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
    applyRelativeLocal() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let target = this.target;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            let rotation = bone.arotation + (target.arotation + this.data.offsetRotation) * mixRotate;
            let x = bone.ax + (target.ax + this.data.offsetX) * mixX;
            let y = bone.ay + (target.ay + this.data.offsetY) * mixY;
            let scaleX = bone.ascaleX * ((target.ascaleX - 1 + this.data.offsetScaleX) * mixScaleX + 1);
            let scaleY = bone.ascaleY * ((target.ascaleY - 1 + this.data.offsetScaleY) * mixScaleY + 1);
            let shearY = bone.ashearY + (target.ashearY + this.data.offsetShearY) * mixShearY;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
}

});


parcelRegister("d34nV", function(module, exports) {

$parcel$export(module.exports, "SkeletonBinary", () => $97fef4e9c50039b0$export$a7f7eaf4e9fce9ef);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $hevjK = parcelRequire("hevjK");

var $2nRvY = parcelRequire("2nRvY");

var $1S7b2 = parcelRequire("1S7b2");

var $2jWXd = parcelRequire("2jWXd");

var $gfyKS = parcelRequire("gfyKS");

var $2eT9h = parcelRequire("2eT9h");

var $1Wvqv = parcelRequire("1Wvqv");

var $2Ma0J = parcelRequire("2Ma0J");

var $d4Xjx = parcelRequire("d4Xjx");

var $9UdTx = parcelRequire("9UdTx");

var $8FokI = parcelRequire("8FokI");

var $3jtmM = parcelRequire("3jtmM");

var $1Yup6 = parcelRequire("1Yup6");
class $97fef4e9c50039b0$export$a7f7eaf4e9fce9ef {
    /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ scale = 1;
    attachmentLoader;
    linkedMeshes = new Array();
    constructor(attachmentLoader){
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(binary) {
        let scale = this.scale;
        let skeletonData = new (0, $d4Xjx.SkeletonData)();
        skeletonData.name = ""; // BOZO
        let input = new $97fef4e9c50039b0$export$c8e921ea3330f774(binary);
        let lowHash = input.readInt32();
        let highHash = input.readInt32();
        skeletonData.hash = highHash == 0 && lowHash == 0 ? null : highHash.toString(16) + lowHash.toString(16);
        skeletonData.version = input.readString();
        skeletonData.x = input.readFloat();
        skeletonData.y = input.readFloat();
        skeletonData.width = input.readFloat();
        skeletonData.height = input.readFloat();
        skeletonData.referenceScale = input.readFloat() * scale;
        let nonessential = input.readBoolean();
        if (nonessential) {
            skeletonData.fps = input.readFloat();
            skeletonData.imagesPath = input.readString();
            skeletonData.audioPath = input.readString();
        }
        let n = 0;
        // Strings.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let str = input.readString();
            if (!str) throw new Error("String in string table must not be null.");
            input.strings.push(str);
        }
        // Bones.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Bone name must not be null.");
            let parent = i == 0 ? null : skeletonData.bones[input.readInt(true)];
            let data = new (0, $1S7b2.BoneData)(i, name, parent);
            data.rotation = input.readFloat();
            data.x = input.readFloat() * scale;
            data.y = input.readFloat() * scale;
            data.scaleX = input.readFloat();
            data.scaleY = input.readFloat();
            data.shearX = input.readFloat();
            data.shearY = input.readFloat();
            data.length = input.readFloat() * scale;
            data.inherit = input.readByte();
            data.skinRequired = input.readBoolean();
            if (nonessential) {
                (0, $1Yup6.Color).rgba8888ToColor(data.color, input.readInt32());
                data.icon = input.readString() ?? undefined;
                data.visible = input.readBoolean();
            }
            skeletonData.bones.push(data);
        }
        // Slots.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let slotName = input.readString();
            if (!slotName) throw new Error("Slot name must not be null.");
            let boneData = skeletonData.bones[input.readInt(true)];
            let data = new (0, $8FokI.SlotData)(i, slotName, boneData);
            (0, $1Yup6.Color).rgba8888ToColor(data.color, input.readInt32());
            let darkColor = input.readInt32();
            if (darkColor != -1) (0, $1Yup6.Color).rgb888ToColor(data.darkColor = new (0, $1Yup6.Color)(), darkColor);
            data.attachmentName = input.readStringRef();
            data.blendMode = input.readInt(true);
            if (nonessential) data.visible = input.readBoolean();
            skeletonData.slots.push(data);
        }
        // IK constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("IK constraint data name must not be null.");
            let data = new (0, $2eT9h.IkConstraintData)(name);
            data.order = input.readInt(true);
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            let flags = input.readByte();
            data.skinRequired = (flags & 1) != 0;
            data.bendDirection = (flags & 2) != 0 ? 1 : -1;
            data.compress = (flags & 4) != 0;
            data.stretch = (flags & 8) != 0;
            data.uniform = (flags & 16) != 0;
            if ((flags & 32) != 0) data.mix = (flags & 64) != 0 ? input.readFloat() : 1;
            if ((flags & 128) != 0) data.softness = input.readFloat() * scale;
            skeletonData.ikConstraints.push(data);
        }
        // Transform constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Transform constraint data name must not be null.");
            let data = new (0, $3jtmM.TransformConstraintData)(name);
            data.order = input.readInt(true);
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            let flags = input.readByte();
            data.skinRequired = (flags & 1) != 0;
            data.local = (flags & 2) != 0;
            data.relative = (flags & 4) != 0;
            if ((flags & 8) != 0) data.offsetRotation = input.readFloat();
            if ((flags & 16) != 0) data.offsetX = input.readFloat() * scale;
            if ((flags & 32) != 0) data.offsetY = input.readFloat() * scale;
            if ((flags & 64) != 0) data.offsetScaleX = input.readFloat();
            if ((flags & 128) != 0) data.offsetScaleY = input.readFloat();
            flags = input.readByte();
            if ((flags & 1) != 0) data.offsetShearY = input.readFloat();
            if ((flags & 2) != 0) data.mixRotate = input.readFloat();
            if ((flags & 4) != 0) data.mixX = input.readFloat();
            if ((flags & 8) != 0) data.mixY = input.readFloat();
            if ((flags & 16) != 0) data.mixScaleX = input.readFloat();
            if ((flags & 32) != 0) data.mixScaleY = input.readFloat();
            if ((flags & 64) != 0) data.mixShearY = input.readFloat();
            skeletonData.transformConstraints.push(data);
        }
        // Path constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Path constraint data name must not be null.");
            let data = new (0, $1Wvqv.PathConstraintData)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.slots[input.readInt(true)];
            const flags = input.readByte();
            data.positionMode = flags & 1;
            data.spacingMode = flags >> 1 & 3;
            data.rotateMode = flags >> 3 & 3;
            if ((flags & 128) != 0) data.offsetRotation = input.readFloat();
            data.position = input.readFloat();
            if (data.positionMode == (0, $1Wvqv.PositionMode).Fixed) data.position *= scale;
            data.spacing = input.readFloat();
            if (data.spacingMode == (0, $1Wvqv.SpacingMode).Length || data.spacingMode == (0, $1Wvqv.SpacingMode).Fixed) data.spacing *= scale;
            data.mixRotate = input.readFloat();
            data.mixX = input.readFloat();
            data.mixY = input.readFloat();
            skeletonData.pathConstraints.push(data);
        }
        // Physics constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const name = input.readString();
            if (!name) throw new Error("Physics constraint data name must not be null.");
            const data = new (0, $2Ma0J.PhysicsConstraintData)(name);
            data.order = input.readInt(true);
            data.bone = skeletonData.bones[input.readInt(true)];
            let flags = input.readByte();
            data.skinRequired = (flags & 1) != 0;
            if ((flags & 2) != 0) data.x = input.readFloat();
            if ((flags & 4) != 0) data.y = input.readFloat();
            if ((flags & 8) != 0) data.rotate = input.readFloat();
            if ((flags & 16) != 0) data.scaleX = input.readFloat();
            if ((flags & 32) != 0) data.shearX = input.readFloat();
            data.limit = ((flags & 64) != 0 ? input.readFloat() : 5000) * scale;
            data.step = 1 / input.readUnsignedByte();
            data.inertia = input.readFloat();
            data.strength = input.readFloat();
            data.damping = input.readFloat();
            data.massInverse = (flags & 128) != 0 ? input.readFloat() : 1;
            data.wind = input.readFloat();
            data.gravity = input.readFloat();
            flags = input.readByte();
            if ((flags & 1) != 0) data.inertiaGlobal = true;
            if ((flags & 2) != 0) data.strengthGlobal = true;
            if ((flags & 4) != 0) data.dampingGlobal = true;
            if ((flags & 8) != 0) data.massGlobal = true;
            if ((flags & 16) != 0) data.windGlobal = true;
            if ((flags & 32) != 0) data.gravityGlobal = true;
            if ((flags & 64) != 0) data.mixGlobal = true;
            data.mix = (flags & 128) != 0 ? input.readFloat() : 1;
            skeletonData.physicsConstraints.push(data);
        }
        // Default skin.
        let defaultSkin = this.readSkin(input, skeletonData, true, nonessential);
        if (defaultSkin) {
            skeletonData.defaultSkin = defaultSkin;
            skeletonData.skins.push(defaultSkin);
        }
        // Skins.
        {
            let i = skeletonData.skins.length;
            (0, $1Yup6.Utils).setArraySize(skeletonData.skins, n = i + input.readInt(true));
            for(; i < n; i++){
                let skin = this.readSkin(input, skeletonData, false, nonessential);
                if (!skin) throw new Error("readSkin() should not have returned null.");
                skeletonData.skins[i] = skin;
            }
        }
        // Linked meshes.
        n = this.linkedMeshes.length;
        for(let i = 0; i < n; i++){
            let linkedMesh = this.linkedMeshes[i];
            const skin = skeletonData.skins[linkedMesh.skinIndex];
            if (!linkedMesh.parent) throw new Error("Linked mesh parent must not be null");
            let parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
            if (linkedMesh.mesh.region != null) linkedMesh.mesh.updateRegion();
        }
        this.linkedMeshes.length = 0;
        // Events.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let eventName = input.readString();
            if (!eventName) throw new Error("Event data name must not be null");
            let data = new (0, $gfyKS.EventData)(eventName);
            data.intValue = input.readInt(false);
            data.floatValue = input.readFloat();
            data.stringValue = input.readString();
            data.audioPath = input.readString();
            if (data.audioPath) {
                data.volume = input.readFloat();
                data.balance = input.readFloat();
            }
            skeletonData.events.push(data);
        }
        // Animations.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let animationName = input.readString();
            if (!animationName) throw new Error("Animatio name must not be null.");
            skeletonData.animations.push(this.readAnimation(input, animationName, skeletonData));
        }
        return skeletonData;
    }
    readSkin(input, skeletonData, defaultSkin, nonessential) {
        let skin = null;
        let slotCount = 0;
        if (defaultSkin) {
            slotCount = input.readInt(true);
            if (slotCount == 0) return null;
            skin = new (0, $9UdTx.Skin)("default");
        } else {
            let skinName = input.readString();
            if (!skinName) throw new Error("Skin name must not be null.");
            skin = new (0, $9UdTx.Skin)(skinName);
            if (nonessential) (0, $1Yup6.Color).rgba8888ToColor(skin.color, input.readInt32());
            skin.bones.length = input.readInt(true);
            for(let i = 0, n = skin.bones.length; i < n; i++)skin.bones[i] = skeletonData.bones[input.readInt(true)];
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.ikConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.transformConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.pathConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.physicsConstraints[input.readInt(true)]);
            slotCount = input.readInt(true);
        }
        for(let i = 0; i < slotCount; i++){
            let slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let name = input.readStringRef();
                if (!name) throw new Error("Attachment name must not be null");
                let attachment = this.readAttachment(input, skeletonData, skin, slotIndex, name, nonessential);
                if (attachment) skin.setAttachment(slotIndex, name, attachment);
            }
        }
        return skin;
    }
    readAttachment(input, skeletonData, skin, slotIndex, attachmentName, nonessential) {
        let scale = this.scale;
        let flags = input.readByte();
        const name = (flags & 8) != 0 ? input.readStringRef() : attachmentName;
        if (!name) throw new Error("Attachment name must not be null");
        switch(flags & 7){
            case $97fef4e9c50039b0$var$AttachmentType.Region:
                {
                    let path = (flags & 16) != 0 ? input.readStringRef() : null;
                    const color = (flags & 32) != 0 ? input.readInt32() : 0xffffffff;
                    const sequence = (flags & 64) != 0 ? this.readSequence(input) : null;
                    let rotation = (flags & 128) != 0 ? input.readFloat() : 0;
                    let x = input.readFloat();
                    let y = input.readFloat();
                    let scaleX = input.readFloat();
                    let scaleY = input.readFloat();
                    let width = input.readFloat();
                    let height = input.readFloat();
                    if (!path) path = name;
                    let region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = x * scale;
                    region.y = y * scale;
                    region.scaleX = scaleX;
                    region.scaleY = scaleY;
                    region.rotation = rotation;
                    region.width = width * scale;
                    region.height = height * scale;
                    (0, $1Yup6.Color).rgba8888ToColor(region.color, color);
                    region.sequence = sequence;
                    if (sequence == null) region.updateRegion();
                    return region;
                }
            case $97fef4e9c50039b0$var$AttachmentType.BoundingBox:
                {
                    let vertices = this.readVertices(input, (flags & 16) != 0);
                    let color = nonessential ? input.readInt32() : 0;
                    let box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    box.worldVerticesLength = vertices.length;
                    box.vertices = vertices.vertices;
                    box.bones = vertices.bones;
                    if (nonessential) (0, $1Yup6.Color).rgba8888ToColor(box.color, color);
                    return box;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Mesh:
                {
                    let path = (flags & 16) != 0 ? input.readStringRef() : name;
                    const color = (flags & 32) != 0 ? input.readInt32() : 0xffffffff;
                    const sequence = (flags & 64) != 0 ? this.readSequence(input) : null;
                    const hullLength = input.readInt(true);
                    const vertices = this.readVertices(input, (flags & 128) != 0);
                    const uvs = this.readFloatArray(input, vertices.length, 1);
                    const triangles = this.readShortArray(input, (vertices.length - hullLength - 2) * 3);
                    let edges = [];
                    let width = 0, height = 0;
                    if (nonessential) {
                        edges = this.readShortArray(input, input.readInt(true));
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (!path) path = name;
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $1Yup6.Color).rgba8888ToColor(mesh.color, color);
                    mesh.bones = vertices.bones;
                    mesh.vertices = vertices.vertices;
                    mesh.worldVerticesLength = vertices.length;
                    mesh.triangles = triangles;
                    mesh.regionUVs = uvs;
                    if (sequence == null) mesh.updateRegion();
                    mesh.hullLength = hullLength << 1;
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.edges = edges;
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    return mesh;
                }
            case $97fef4e9c50039b0$var$AttachmentType.LinkedMesh:
                {
                    const path = (flags & 16) != 0 ? input.readStringRef() : name;
                    if (path == null) throw new Error("Path of linked mesh must not be null");
                    const color = (flags & 32) != 0 ? input.readInt32() : 0xffffffff;
                    const sequence = (flags & 64) != 0 ? this.readSequence(input) : null;
                    const inheritTimelines = (flags & 128) != 0;
                    const skinIndex = input.readInt(true);
                    const parent = input.readStringRef();
                    let width = 0, height = 0;
                    if (nonessential) {
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $1Yup6.Color).rgba8888ToColor(mesh.color, color);
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    this.linkedMeshes.push(new $97fef4e9c50039b0$var$LinkedMesh(mesh, skinIndex, slotIndex, parent, inheritTimelines));
                    return mesh;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Path:
                {
                    const closed = (flags & 16) != 0;
                    const constantSpeed = (flags & 32) != 0;
                    const vertices = this.readVertices(input, (flags & 64) != 0);
                    const lengths = (0, $1Yup6.Utils).newArray(vertices.length / 6, 0);
                    for(let i = 0, n = lengths.length; i < n; i++)lengths[i] = input.readFloat() * scale;
                    const color = nonessential ? input.readInt32() : 0;
                    const path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = closed;
                    path.constantSpeed = constantSpeed;
                    path.worldVerticesLength = vertices.length;
                    path.vertices = vertices.vertices;
                    path.bones = vertices.bones;
                    path.lengths = lengths;
                    if (nonessential) (0, $1Yup6.Color).rgba8888ToColor(path.color, color);
                    return path;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Point:
                {
                    const rotation = input.readFloat();
                    const x = input.readFloat();
                    const y = input.readFloat();
                    const color = nonessential ? input.readInt32() : 0;
                    const point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = x * scale;
                    point.y = y * scale;
                    point.rotation = rotation;
                    if (nonessential) (0, $1Yup6.Color).rgba8888ToColor(point.color, color);
                    return point;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Clipping:
                {
                    const endSlotIndex = input.readInt(true);
                    const vertices = this.readVertices(input, (flags & 16) != 0);
                    let color = nonessential ? input.readInt32() : 0;
                    let clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    clip.endSlot = skeletonData.slots[endSlotIndex];
                    clip.worldVerticesLength = vertices.length;
                    clip.vertices = vertices.vertices;
                    clip.bones = vertices.bones;
                    if (nonessential) (0, $1Yup6.Color).rgba8888ToColor(clip.color, color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(input) {
        let sequence = new (0, $2nRvY.Sequence)(input.readInt(true));
        sequence.start = input.readInt(true);
        sequence.digits = input.readInt(true);
        sequence.setupIndex = input.readInt(true);
        return sequence;
    }
    readVertices(input, weighted) {
        const scale = this.scale;
        const vertexCount = input.readInt(true);
        const vertices = new $97fef4e9c50039b0$var$Vertices();
        vertices.length = vertexCount << 1;
        if (!weighted) {
            vertices.vertices = this.readFloatArray(input, vertices.length, scale);
            return vertices;
        }
        let weights = new Array();
        let bonesArray = new Array();
        for(let i = 0; i < vertexCount; i++){
            let boneCount = input.readInt(true);
            bonesArray.push(boneCount);
            for(let ii = 0; ii < boneCount; ii++){
                bonesArray.push(input.readInt(true));
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat());
            }
        }
        vertices.vertices = (0, $1Yup6.Utils).toFloatArray(weights);
        vertices.bones = bonesArray;
        return vertices;
    }
    readFloatArray(input, n, scale) {
        let array = new Array(n);
        if (scale == 1) for(let i = 0; i < n; i++)array[i] = input.readFloat();
        else for(let i = 0; i < n; i++)array[i] = input.readFloat() * scale;
        return array;
    }
    readShortArray(input, n) {
        let array = new Array(n);
        for(let i = 0; i < n; i++)array[i] = input.readInt(true);
        return array;
    }
    readAnimation(input, name, skeletonData) {
        input.readInt(true); // Number of timelines.
        let timelines = new Array();
        let scale = this.scale;
        // Slot timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let timelineType = input.readByte();
                let frameCount = input.readInt(true);
                let frameLast = frameCount - 1;
                switch(timelineType){
                    case $97fef4e9c50039b0$var$SLOT_ATTACHMENT:
                        {
                            let timeline = new (0, $hevjK.AttachmentTimeline)(frameCount, slotIndex);
                            for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat(), input.readStringRef());
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGBA:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $hevjK.RGBATimeline)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let a = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let r2 = input.readUnsignedByte() / 255.0;
                                let g2 = input.readUnsignedByte() / 255.0;
                                let b2 = input.readUnsignedByte() / 255.0;
                                let a2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, a2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                                a = a2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGB:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $hevjK.RGBTimeline)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let r2 = input.readUnsignedByte() / 255.0;
                                let g2 = input.readUnsignedByte() / 255.0;
                                let b2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGBA2:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $hevjK.RGBA2Timeline)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let a = input.readUnsignedByte() / 255.0;
                            let r2 = input.readUnsignedByte() / 255.0;
                            let g2 = input.readUnsignedByte() / 255.0;
                            let b2 = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a, r2, g2, b2);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let nr = input.readUnsignedByte() / 255.0;
                                let ng = input.readUnsignedByte() / 255.0;
                                let nb = input.readUnsignedByte() / 255.0;
                                let na = input.readUnsignedByte() / 255.0;
                                let nr2 = input.readUnsignedByte() / 255.0;
                                let ng2 = input.readUnsignedByte() / 255.0;
                                let nb2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, na, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, r2, nr2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, g2, ng2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 6, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                a = na;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGB2:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $hevjK.RGB2Timeline)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let r2 = input.readUnsignedByte() / 255.0;
                            let g2 = input.readUnsignedByte() / 255.0;
                            let b2 = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, r2, g2, b2);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let nr = input.readUnsignedByte() / 255.0;
                                let ng = input.readUnsignedByte() / 255.0;
                                let nb = input.readUnsignedByte() / 255.0;
                                let nr2 = input.readUnsignedByte() / 255.0;
                                let ng2 = input.readUnsignedByte() / 255.0;
                                let nb2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, r2, nr2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, g2, ng2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_ALPHA:
                        {
                            let timeline = new (0, $hevjK.AlphaTimeline)(frameCount, input.readInt(true), slotIndex);
                            let time = input.readFloat(), a = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, a);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let a2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, a, a2, 1);
                                }
                                time = time2;
                                a = a2;
                            }
                            timelines.push(timeline);
                        }
                }
            }
        }
        // Bone timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let boneIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let type = input.readByte(), frameCount = input.readInt(true);
                if (type == $97fef4e9c50039b0$var$BONE_INHERIT) {
                    let timeline = new (0, $hevjK.InheritTimeline)(frameCount, boneIndex);
                    for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat(), input.readByte());
                    timelines.push(timeline);
                    continue;
                }
                let bezierCount = input.readInt(true);
                switch(type){
                    case $97fef4e9c50039b0$var$BONE_ROTATE:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.RotateTimeline)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_TRANSLATE:
                        timelines.push($97fef4e9c50039b0$var$readTimeline2(input, new (0, $hevjK.TranslateTimeline)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $97fef4e9c50039b0$var$BONE_TRANSLATEX:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.TranslateXTimeline)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $97fef4e9c50039b0$var$BONE_TRANSLATEY:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.TranslateYTimeline)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SCALE:
                        timelines.push($97fef4e9c50039b0$var$readTimeline2(input, new (0, $hevjK.ScaleTimeline)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SCALEX:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.ScaleXTimeline)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SCALEY:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.ScaleYTimeline)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SHEAR:
                        timelines.push($97fef4e9c50039b0$var$readTimeline2(input, new (0, $hevjK.ShearTimeline)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SHEARX:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.ShearXTimeline)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SHEARY:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.ShearYTimeline)(frameCount, bezierCount, boneIndex), 1));
                }
            }
        }
        // IK constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true), frameCount = input.readInt(true), frameLast = frameCount - 1;
            let timeline = new (0, $hevjK.IkConstraintTimeline)(frameCount, input.readInt(true), index);
            let flags = input.readByte();
            let time = input.readFloat(), mix = (flags & 1) != 0 ? (flags & 2) != 0 ? input.readFloat() : 1 : 0;
            let softness = (flags & 4) != 0 ? input.readFloat() * scale : 0;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, (flags & 8) != 0 ? 1 : -1, (flags & 16) != 0, (flags & 32) != 0);
                if (frame == frameLast) break;
                flags = input.readByte();
                const time2 = input.readFloat(), mix2 = (flags & 1) != 0 ? (flags & 2) != 0 ? input.readFloat() : 1 : 0;
                const softness2 = (flags & 4) != 0 ? input.readFloat() * scale : 0;
                if ((flags & 64) != 0) timeline.setStepped(frame);
                else if ((flags & 128) != 0) {
                    $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mix, mix2, 1);
                    $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
            }
            timelines.push(timeline);
        }
        // Transform constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true), frameCount = input.readInt(true), frameLast = frameCount - 1;
            let timeline = new (0, $hevjK.TransformConstraintTimeline)(frameCount, input.readInt(true), index);
            let time = input.readFloat(), mixRotate = input.readFloat(), mixX = input.readFloat(), mixY = input.readFloat(), mixScaleX = input.readFloat(), mixScaleY = input.readFloat(), mixShearY = input.readFloat();
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                if (frame == frameLast) break;
                let time2 = input.readFloat(), mixRotate2 = input.readFloat(), mixX2 = input.readFloat(), mixY2 = input.readFloat(), mixScaleX2 = input.readFloat(), mixScaleY2 = input.readFloat(), mixShearY2 = input.readFloat();
                switch(input.readByte()){
                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                        timeline.setStepped(frame);
                        break;
                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixShearY = mixShearY2;
            }
            timelines.push(timeline);
        }
        // Path constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true);
            let data = skeletonData.pathConstraints[index];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const type = input.readByte(), frameCount = input.readInt(true), bezierCount = input.readInt(true);
                switch(type){
                    case $97fef4e9c50039b0$var$PATH_POSITION:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PathConstraintPositionTimeline)(frameCount, bezierCount, index), data.positionMode == (0, $1Wvqv.PositionMode).Fixed ? scale : 1));
                        break;
                    case $97fef4e9c50039b0$var$PATH_SPACING:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PathConstraintSpacingTimeline)(frameCount, bezierCount, index), data.spacingMode == (0, $1Wvqv.SpacingMode).Length || data.spacingMode == (0, $1Wvqv.SpacingMode).Fixed ? scale : 1));
                        break;
                    case $97fef4e9c50039b0$var$PATH_MIX:
                        let timeline = new (0, $hevjK.PathConstraintMixTimeline)(frameCount, bezierCount, index);
                        let time = input.readFloat(), mixRotate = input.readFloat(), mixX = input.readFloat(), mixY = input.readFloat();
                        for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
                            timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                            if (frame == frameLast) break;
                            let time2 = input.readFloat(), mixRotate2 = input.readFloat(), mixX2 = input.readFloat(), mixY2 = input.readFloat();
                            switch(input.readByte()){
                                case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                    timeline.setStepped(frame);
                                    break;
                                case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                    $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                                    $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                                    $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                            }
                            time = time2;
                            mixRotate = mixRotate2;
                            mixX = mixX2;
                            mixY = mixY2;
                        }
                        timelines.push(timeline);
                }
            }
        }
        // Physics timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true) - 1;
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const type = input.readByte(), frameCount = input.readInt(true);
                if (type == $97fef4e9c50039b0$var$PHYSICS_RESET) {
                    const timeline = new (0, $hevjK.PhysicsConstraintResetTimeline)(frameCount, index);
                    for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat());
                    timelines.push(timeline);
                    continue;
                }
                const bezierCount = input.readInt(true);
                switch(type){
                    case $97fef4e9c50039b0$var$PHYSICS_INERTIA:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PhysicsConstraintInertiaTimeline)(frameCount, bezierCount, index), 1));
                        break;
                    case $97fef4e9c50039b0$var$PHYSICS_STRENGTH:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PhysicsConstraintStrengthTimeline)(frameCount, bezierCount, index), 1));
                        break;
                    case $97fef4e9c50039b0$var$PHYSICS_DAMPING:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PhysicsConstraintDampingTimeline)(frameCount, bezierCount, index), 1));
                        break;
                    case $97fef4e9c50039b0$var$PHYSICS_MASS:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PhysicsConstraintMassTimeline)(frameCount, bezierCount, index), 1));
                        break;
                    case $97fef4e9c50039b0$var$PHYSICS_WIND:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PhysicsConstraintWindTimeline)(frameCount, bezierCount, index), 1));
                        break;
                    case $97fef4e9c50039b0$var$PHYSICS_GRAVITY:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PhysicsConstraintGravityTimeline)(frameCount, bezierCount, index), 1));
                        break;
                    case $97fef4e9c50039b0$var$PHYSICS_MIX:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $hevjK.PhysicsConstraintMixTimeline)(frameCount, bezierCount, index), 1));
                }
            }
        }
        // Deform timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let skin = skeletonData.skins[input.readInt(true)];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let slotIndex = input.readInt(true);
                for(let iii = 0, nnn = input.readInt(true); iii < nnn; iii++){
                    let attachmentName = input.readStringRef();
                    if (!attachmentName) throw new Error("attachmentName must not be null.");
                    let attachment = skin.getAttachment(slotIndex, attachmentName);
                    let timelineType = input.readByte();
                    let frameCount = input.readInt(true);
                    let frameLast = frameCount - 1;
                    switch(timelineType){
                        case $97fef4e9c50039b0$var$ATTACHMENT_DEFORM:
                            {
                                let vertexAttachment = attachment;
                                let weighted = vertexAttachment.bones;
                                let vertices = vertexAttachment.vertices;
                                let deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                                let bezierCount = input.readInt(true);
                                let timeline = new (0, $hevjK.DeformTimeline)(frameCount, bezierCount, slotIndex, vertexAttachment);
                                let time = input.readFloat();
                                for(let frame = 0, bezier = 0;; frame++){
                                    let deform;
                                    let end = input.readInt(true);
                                    if (end == 0) deform = weighted ? (0, $1Yup6.Utils).newFloatArray(deformLength) : vertices;
                                    else {
                                        deform = (0, $1Yup6.Utils).newFloatArray(deformLength);
                                        let start = input.readInt(true);
                                        end += start;
                                        if (scale == 1) for(let v = start; v < end; v++)deform[v] = input.readFloat();
                                        else for(let v = start; v < end; v++)deform[v] = input.readFloat() * scale;
                                        if (!weighted) for(let v = 0, vn = deform.length; v < vn; v++)deform[v] += vertices[v];
                                    }
                                    timeline.setFrame(frame, time, deform);
                                    if (frame == frameLast) break;
                                    let time2 = input.readFloat();
                                    switch(input.readByte()){
                                        case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                            timeline.setStepped(frame);
                                            break;
                                        case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                            $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, 0, 1, 1);
                                    }
                                    time = time2;
                                }
                                timelines.push(timeline);
                                break;
                            }
                        case $97fef4e9c50039b0$var$ATTACHMENT_SEQUENCE:
                            {
                                let timeline = new (0, $hevjK.SequenceTimeline)(frameCount, slotIndex, attachment);
                                for(let frame = 0; frame < frameCount; frame++){
                                    let time = input.readFloat();
                                    let modeAndIndex = input.readInt32();
                                    timeline.setFrame(frame, time, (0, $2nRvY.SequenceModeValues)[modeAndIndex & 0xf], modeAndIndex >> 4, input.readFloat());
                                }
                                timelines.push(timeline);
                                break;
                            }
                    }
                }
            }
        }
        // Draw order timeline.
        let drawOrderCount = input.readInt(true);
        if (drawOrderCount > 0) {
            let timeline = new (0, $hevjK.DrawOrderTimeline)(drawOrderCount);
            let slotCount = skeletonData.slots.length;
            for(let i = 0; i < drawOrderCount; i++){
                let time = input.readFloat();
                let offsetCount = input.readInt(true);
                let drawOrder = (0, $1Yup6.Utils).newArray(slotCount, 0);
                for(let ii = slotCount - 1; ii >= 0; ii--)drawOrder[ii] = -1;
                let unchanged = (0, $1Yup6.Utils).newArray(slotCount - offsetCount, 0);
                let originalIndex = 0, unchangedIndex = 0;
                for(let ii = 0; ii < offsetCount; ii++){
                    let slotIndex = input.readInt(true);
                    // Collect unchanged items.
                    while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                    // Set changed items.
                    drawOrder[originalIndex + input.readInt(true)] = originalIndex++;
                }
                // Collect remaining unchanged items.
                while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                // Fill in unchanged items.
                for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                timeline.setFrame(i, time, drawOrder);
            }
            timelines.push(timeline);
        }
        // Event timeline.
        let eventCount = input.readInt(true);
        if (eventCount > 0) {
            let timeline = new (0, $hevjK.EventTimeline)(eventCount);
            for(let i = 0; i < eventCount; i++){
                let time = input.readFloat();
                let eventData = skeletonData.events[input.readInt(true)];
                let event = new (0, $2jWXd.Event)(time, eventData);
                event.intValue = input.readInt(false);
                event.floatValue = input.readFloat();
                event.stringValue = input.readString();
                if (event.stringValue == null) event.stringValue = eventData.stringValue;
                if (event.data.audioPath) {
                    event.volume = input.readFloat();
                    event.balance = input.readFloat();
                }
                timeline.setFrame(i, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        return new (0, $hevjK.Animation)(name, timelines, duration);
    }
}
class $97fef4e9c50039b0$export$c8e921ea3330f774 {
    strings;
    index;
    buffer;
    constructor(data, strings = new Array(), index = 0, buffer = new DataView(data instanceof ArrayBuffer ? data : data.buffer)){
        this.strings = strings;
        this.index = index;
        this.buffer = buffer;
    }
    readByte() {
        return this.buffer.getInt8(this.index++);
    }
    readUnsignedByte() {
        return this.buffer.getUint8(this.index++);
    }
    readShort() {
        let value = this.buffer.getInt16(this.index);
        this.index += 2;
        return value;
    }
    readInt32() {
        let value = this.buffer.getInt32(this.index);
        this.index += 4;
        return value;
    }
    readInt(optimizePositive) {
        let b = this.readByte();
        let result = b & 0x7F;
        if ((b & 0x80) != 0) {
            b = this.readByte();
            result |= (b & 0x7F) << 7;
            if ((b & 0x80) != 0) {
                b = this.readByte();
                result |= (b & 0x7F) << 14;
                if ((b & 0x80) != 0) {
                    b = this.readByte();
                    result |= (b & 0x7F) << 21;
                    if ((b & 0x80) != 0) {
                        b = this.readByte();
                        result |= (b & 0x7F) << 28;
                    }
                }
            }
        }
        return optimizePositive ? result : result >>> 1 ^ -(result & 1);
    }
    readStringRef() {
        let index = this.readInt(true);
        return index == 0 ? null : this.strings[index - 1];
    }
    readString() {
        let byteCount = this.readInt(true);
        switch(byteCount){
            case 0:
                return null;
            case 1:
                return "";
        }
        byteCount--;
        let chars = "";
        let charCount = 0;
        for(let i = 0; i < byteCount;){
            let b = this.readUnsignedByte();
            switch(b >> 4){
                case 12:
                case 13:
                    chars += String.fromCharCode((b & 0x1F) << 6 | this.readByte() & 0x3F);
                    i += 2;
                    break;
                case 14:
                    chars += String.fromCharCode((b & 0x0F) << 12 | (this.readByte() & 0x3F) << 6 | this.readByte() & 0x3F);
                    i += 3;
                    break;
                default:
                    chars += String.fromCharCode(b);
                    i++;
            }
        }
        return chars;
    }
    readFloat() {
        let value = this.buffer.getFloat32(this.index);
        this.index += 4;
        return value;
    }
    readBoolean() {
        return this.readByte() != 0;
    }
}
class $97fef4e9c50039b0$var$LinkedMesh {
    parent;
    skinIndex;
    slotIndex;
    mesh;
    inheritTimeline;
    constructor(mesh, skinIndex, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skinIndex = skinIndex;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
class $97fef4e9c50039b0$var$Vertices {
    bones;
    vertices;
    length;
    constructor(bones = null, vertices = null, length = 0){
        this.bones = bones;
        this.vertices = vertices;
        this.length = length;
    }
}
var $97fef4e9c50039b0$var$AttachmentType;
(function(AttachmentType) {
    AttachmentType[AttachmentType["Region"] = 0] = "Region";
    AttachmentType[AttachmentType["BoundingBox"] = 1] = "BoundingBox";
    AttachmentType[AttachmentType["Mesh"] = 2] = "Mesh";
    AttachmentType[AttachmentType["LinkedMesh"] = 3] = "LinkedMesh";
    AttachmentType[AttachmentType["Path"] = 4] = "Path";
    AttachmentType[AttachmentType["Point"] = 5] = "Point";
    AttachmentType[AttachmentType["Clipping"] = 6] = "Clipping";
})($97fef4e9c50039b0$var$AttachmentType || ($97fef4e9c50039b0$var$AttachmentType = {}));
function $97fef4e9c50039b0$var$readTimeline1(input, timeline, scale) {
    let time = input.readFloat(), value = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value);
        if (frame == frameLast) break;
        let time2 = input.readFloat(), value2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $97fef4e9c50039b0$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $97fef4e9c50039b0$var$CURVE_BEZIER:
                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value, value2, scale);
        }
        time = time2;
        value = value2;
    }
    return timeline;
}
function $97fef4e9c50039b0$var$readTimeline2(input, timeline, scale) {
    let time = input.readFloat(), value1 = input.readFloat() * scale, value2 = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        if (frame == frameLast) break;
        let time2 = input.readFloat(), nvalue1 = input.readFloat() * scale, nvalue2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $97fef4e9c50039b0$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $97fef4e9c50039b0$var$CURVE_BEZIER:
                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value1, nvalue1, scale);
                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
    }
    return timeline;
}
function $97fef4e9c50039b0$var$setBezier(input, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    timeline.setBezier(bezier, frame, value, time1, value1, input.readFloat(), input.readFloat() * scale, input.readFloat(), input.readFloat() * scale, time2, value2);
}
const $97fef4e9c50039b0$var$BONE_ROTATE = 0;
const $97fef4e9c50039b0$var$BONE_TRANSLATE = 1;
const $97fef4e9c50039b0$var$BONE_TRANSLATEX = 2;
const $97fef4e9c50039b0$var$BONE_TRANSLATEY = 3;
const $97fef4e9c50039b0$var$BONE_SCALE = 4;
const $97fef4e9c50039b0$var$BONE_SCALEX = 5;
const $97fef4e9c50039b0$var$BONE_SCALEY = 6;
const $97fef4e9c50039b0$var$BONE_SHEAR = 7;
const $97fef4e9c50039b0$var$BONE_SHEARX = 8;
const $97fef4e9c50039b0$var$BONE_SHEARY = 9;
const $97fef4e9c50039b0$var$BONE_INHERIT = 10;
const $97fef4e9c50039b0$var$SLOT_ATTACHMENT = 0;
const $97fef4e9c50039b0$var$SLOT_RGBA = 1;
const $97fef4e9c50039b0$var$SLOT_RGB = 2;
const $97fef4e9c50039b0$var$SLOT_RGBA2 = 3;
const $97fef4e9c50039b0$var$SLOT_RGB2 = 4;
const $97fef4e9c50039b0$var$SLOT_ALPHA = 5;
const $97fef4e9c50039b0$var$ATTACHMENT_DEFORM = 0;
const $97fef4e9c50039b0$var$ATTACHMENT_SEQUENCE = 1;
const $97fef4e9c50039b0$var$PATH_POSITION = 0;
const $97fef4e9c50039b0$var$PATH_SPACING = 1;
const $97fef4e9c50039b0$var$PATH_MIX = 2;
const $97fef4e9c50039b0$var$PHYSICS_INERTIA = 0;
const $97fef4e9c50039b0$var$PHYSICS_STRENGTH = 1;
const $97fef4e9c50039b0$var$PHYSICS_DAMPING = 2;
const $97fef4e9c50039b0$var$PHYSICS_MASS = 4;
const $97fef4e9c50039b0$var$PHYSICS_WIND = 5;
const $97fef4e9c50039b0$var$PHYSICS_GRAVITY = 6;
const $97fef4e9c50039b0$var$PHYSICS_MIX = 7;
const $97fef4e9c50039b0$var$PHYSICS_RESET = 8;
const $97fef4e9c50039b0$var$CURVE_LINEAR = 0;
const $97fef4e9c50039b0$var$CURVE_STEPPED = 1;
const $97fef4e9c50039b0$var$CURVE_BEZIER = 2;

});
parcelRegister("2Ma0J", function(module, exports) {

$parcel$export(module.exports, "PhysicsConstraintData", () => $2057d46c2abe0568$export$e7a93b7124cc91bd);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $dTqn7 = parcelRequire("dTqn7");
class $2057d46c2abe0568$export$e7a93b7124cc91bd extends (0, $dTqn7.ConstraintData) {
    _bone = null;
    /** The bone constrained by this physics constraint. */ set bone(boneData) {
        this._bone = boneData;
    }
    get bone() {
        if (!this._bone) throw new Error("BoneData not set.");
        else return this._bone;
    }
    x = 0;
    y = 0;
    rotate = 0;
    scaleX = 0;
    shearX = 0;
    limit = 0;
    step = 0;
    inertia = 0;
    strength = 0;
    damping = 0;
    massInverse = 0;
    wind = 0;
    gravity = 0;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained poses. */ mix = 0;
    inertiaGlobal = false;
    strengthGlobal = false;
    dampingGlobal = false;
    massGlobal = false;
    windGlobal = false;
    gravityGlobal = false;
    mixGlobal = false;
    constructor(name){
        super(name, 0, false);
    }
}

});

parcelRegister("d4Xjx", function(module, exports) {

$parcel$export(module.exports, "SkeletonData", () => $9859a8a0f6d556f1$export$e8f362f163550575);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the setup pose and all of the stateless data for a skeleton.
 *
 * See [Data objects](http://esotericsoftware.com/spine-runtime-architecture#Data-objects) in the Spine Runtimes
 * Guide. */ class $9859a8a0f6d556f1$export$e8f362f163550575 {
    /** The skeleton's name, which by default is the name of the skeleton data file, if possible. May be null. */ name = null;
    /** The skeleton's bones, sorted parent first. The root bone is always the first bone. */ bones = new Array();
    /** The skeleton's slots in the setup pose draw order. */ slots = new Array();
    skins = new Array();
    /** The skeleton's default skin. By default this skin contains all attachments that were not in a skin in Spine.
     *
     * See {@link Skeleton#getAttachmentByName()}.
     * May be null. */ defaultSkin = null;
    /** The skeleton's events. */ events = new Array();
    /** The skeleton's animations. */ animations = new Array();
    /** The skeleton's IK constraints. */ ikConstraints = new Array();
    /** The skeleton's transform constraints. */ transformConstraints = new Array();
    /** The skeleton's path constraints. */ pathConstraints = new Array();
    /** The skeleton's physics constraints. */ physicsConstraints = new Array();
    /** The X coordinate of the skeleton's axis aligned bounding box in the setup pose. */ x = 0;
    /** The Y coordinate of the skeleton's axis aligned bounding box in the setup pose. */ y = 0;
    /** The width of the skeleton's axis aligned bounding box in the setup pose. */ width = 0;
    /** The height of the skeleton's axis aligned bounding box in the setup pose. */ height = 0;
    /** Baseline scale factor for applying distance-dependent effects on non-scalable properties, such as angle or scale. Default
     * is 100. */ referenceScale = 100;
    /** The Spine version used to export the skeleton data, or null. */ version = null;
    /** The skeleton data hash. This value will change if any of the skeleton data has changed. May be null. */ hash = null;
    // Nonessential
    /** The dopesheet FPS in Spine. Available only when nonessential data was exported. */ fps = 0;
    /** The path to the images directory as defined in Spine. Available only when nonessential data was exported. May be null. */ imagesPath = null;
    /** The path to the audio directory as defined in Spine. Available only when nonessential data was exported. May be null. */ audioPath = null;
    /** Finds a bone by comparing each bone's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (bone.name == boneName) return bone;
        }
        return null;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.name == slotName) return slot;
        }
        return null;
    }
    /** Finds a skin by comparing each skin's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findSkin(skinName) {
        if (!skinName) throw new Error("skinName cannot be null.");
        let skins = this.skins;
        for(let i = 0, n = skins.length; i < n; i++){
            let skin = skins[i];
            if (skin.name == skinName) return skin;
        }
        return null;
    }
    /** Finds an event by comparing each events's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findEvent(eventDataName) {
        if (!eventDataName) throw new Error("eventDataName cannot be null.");
        let events = this.events;
        for(let i = 0, n = events.length; i < n; i++){
            let event = events[i];
            if (event.name == eventDataName) return event;
        }
        return null;
    }
    /** Finds an animation by comparing each animation's name. It is more efficient to cache the results of this method than to
     * call it multiple times.
     * @returns May be null. */ findAnimation(animationName) {
        if (!animationName) throw new Error("animationName cannot be null.");
        let animations = this.animations;
        for(let i = 0, n = animations.length; i < n; i++){
            let animation = animations[i];
            if (animation.name == animationName) return animation;
        }
        return null;
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
     * this method than to call it multiple times.
     * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a physics constraint by comparing each physics constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findPhysicsConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const physicsConstraints = this.physicsConstraints;
        for(let i = 0, n = physicsConstraints.length; i < n; i++){
            const constraint = physicsConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
}

});

parcelRegister("9UdTx", function(module, exports) {

$parcel$export(module.exports, "Skin", () => $73641f3ef2c01e99$export$b8e0f93a76772233);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $5ot6H = parcelRequire("5ot6H");

var $1Yup6 = parcelRequire("1Yup6");
class $73641f3ef2c01e99$export$18ca51770a196b7d {
    slotIndex;
    name;
    attachment;
    constructor(slotIndex = 0, name, attachment){
        this.slotIndex = slotIndex;
        this.name = name;
        this.attachment = attachment;
    }
}
class $73641f3ef2c01e99$export$b8e0f93a76772233 {
    /** The skin's name, which is unique across all skins in the skeleton. */ name;
    attachments = new Array();
    bones = Array();
    constraints = new Array();
    /** The color of the skin as it was in Spine, or a default color if nonessential data was not exported. */ color = new (0, $1Yup6.Color)(0.99607843, 0.61960787, 0.30980393, 1);
    constructor(name){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
    /** Adds an attachment to the skin for the specified slot index and name. */ setAttachment(slotIndex, name, attachment) {
        if (!attachment) throw new Error("attachment cannot be null.");
        let attachments = this.attachments;
        if (slotIndex >= attachments.length) attachments.length = slotIndex + 1;
        if (!attachments[slotIndex]) attachments[slotIndex] = {};
        attachments[slotIndex][name] = attachment;
    }
    /** Adds all attachments, bones, and constraints from the specified skin to this skin. */ addSkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            let bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            let constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        let attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            var attachment = attachments[i];
            this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
        }
    }
    /** Adds all bones and constraints and copies of all attachments from the specified skin to this skin. Mesh attachments are not
     * copied, instead a new linked mesh is created. The attachment copies can be modified without affecting the originals. */ copySkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            let bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            let constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        let attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            var attachment = attachments[i];
            if (!attachment.attachment) continue;
            if (attachment.attachment instanceof (0, $5ot6H.MeshAttachment)) {
                attachment.attachment = attachment.attachment.newLinkedMesh();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            } else {
                attachment.attachment = attachment.attachment.copy();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            }
        }
    }
    /** Returns the attachment for the specified slot index and name, or null. */ getAttachment(slotIndex, name) {
        let dictionary = this.attachments[slotIndex];
        return dictionary ? dictionary[name] : null;
    }
    /** Removes the attachment in the skin for the specified slot index and name, if any. */ removeAttachment(slotIndex, name) {
        let dictionary = this.attachments[slotIndex];
        if (dictionary) delete dictionary[name];
    }
    /** Returns all attachments in this skin. */ getAttachments() {
        let entries = new Array();
        for(var i = 0; i < this.attachments.length; i++){
            let slotAttachments = this.attachments[i];
            if (slotAttachments) for(let name in slotAttachments){
                let attachment = slotAttachments[name];
                if (attachment) entries.push(new $73641f3ef2c01e99$export$18ca51770a196b7d(i, name, attachment));
            }
        }
        return entries;
    }
    /** Returns all attachments in this skin for the specified slot index. */ getAttachmentsForSlot(slotIndex, attachments) {
        let slotAttachments = this.attachments[slotIndex];
        if (slotAttachments) for(let name in slotAttachments){
            let attachment = slotAttachments[name];
            if (attachment) attachments.push(new $73641f3ef2c01e99$export$18ca51770a196b7d(slotIndex, name, attachment));
        }
    }
    /** Clears all attachments, bones, and constraints. */ clear() {
        this.attachments.length = 0;
        this.bones.length = 0;
        this.constraints.length = 0;
    }
    /** Attach each attachment in this skin if the corresponding attachment in the old skin is currently attached. */ attachAll(skeleton, oldSkin) {
        let slotIndex = 0;
        for(let i = 0; i < skeleton.slots.length; i++){
            let slot = skeleton.slots[i];
            let slotAttachment = slot.getAttachment();
            if (slotAttachment && slotIndex < oldSkin.attachments.length) {
                let dictionary = oldSkin.attachments[slotIndex];
                for(let key in dictionary){
                    let skinAttachment = dictionary[key];
                    if (slotAttachment == skinAttachment) {
                        let attachment = this.getAttachment(slotIndex, key);
                        if (attachment) slot.setAttachment(attachment);
                        break;
                    }
                }
            }
            slotIndex++;
        }
    }
}

});

parcelRegister("8FokI", function(module, exports) {

$parcel$export(module.exports, "SlotData", () => $64f50722bcc00a44$export$a4cce1bf50208679);
$parcel$export(module.exports, "BlendMode", () => $64f50722bcc00a44$export$c9b8fe72ac71821);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");
class $64f50722bcc00a44$export$a4cce1bf50208679 {
    /** The index of the slot in {@link Skeleton#getSlots()}. */ index = 0;
    /** The name of the slot, which is unique across all slots in the skeleton. */ name;
    /** The bone this slot belongs to. */ boneData;
    /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
     * color tinting. */ color = new (0, $1Yup6.Color)(1, 1, 1, 1);
    /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ darkColor = null;
    /** The name of the attachment that is visible for this slot in the setup pose, or null if no attachment is visible. */ attachmentName = null;
    /** The blend mode for drawing the slot's attachment. */ blendMode = $64f50722bcc00a44$export$c9b8fe72ac71821.Normal;
    /** False if the slot was hidden in Spine and nonessential data was exported. Does not affect runtime rendering. */ visible = true;
    constructor(index, name, boneData){
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        if (!boneData) throw new Error("boneData cannot be null.");
        this.index = index;
        this.name = name;
        this.boneData = boneData;
    }
}
var $64f50722bcc00a44$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode[BlendMode["Normal"] = 0] = "Normal";
    BlendMode[BlendMode["Additive"] = 1] = "Additive";
    BlendMode[BlendMode["Multiply"] = 2] = "Multiply";
    BlendMode[BlendMode["Screen"] = 3] = "Screen";
})($64f50722bcc00a44$export$c9b8fe72ac71821 || ($64f50722bcc00a44$export$c9b8fe72ac71821 = {}));

});

parcelRegister("3jtmM", function(module, exports) {

$parcel$export(module.exports, "TransformConstraintData", () => $2699ed07640898d3$export$823fbc29771afdb5);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $dTqn7 = parcelRequire("dTqn7");
class $2699ed07640898d3$export$823fbc29771afdb5 extends (0, $dTqn7.ConstraintData) {
    /** The bones that will be modified by this transform constraint. */ bones = new Array();
    /** The target bone whose world transform will be copied to the constrained bones. */ _target = null;
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    mixScaleX = 0;
    mixScaleY = 0;
    mixShearY = 0;
    /** An offset added to the constrained bone rotation. */ offsetRotation = 0;
    /** An offset added to the constrained bone X translation. */ offsetX = 0;
    /** An offset added to the constrained bone Y translation. */ offsetY = 0;
    /** An offset added to the constrained bone scaleX. */ offsetScaleX = 0;
    /** An offset added to the constrained bone scaleY. */ offsetScaleY = 0;
    /** An offset added to the constrained bone shearY. */ offsetShearY = 0;
    relative = false;
    local = false;
    constructor(name){
        super(name, 0, false);
    }
}

});


parcelRegister("yE81C", function(module, exports) {

$parcel$export(module.exports, "SkeletonBounds", () => $06824dc31dec3458$export$119f1746fc062f5e);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $6LxqM = parcelRequire("6LxqM");

var $1Yup6 = parcelRequire("1Yup6");
class $06824dc31dec3458$export$119f1746fc062f5e {
    /** The left edge of the axis aligned bounding box. */ minX = 0;
    /** The bottom edge of the axis aligned bounding box. */ minY = 0;
    /** The right edge of the axis aligned bounding box. */ maxX = 0;
    /** The top edge of the axis aligned bounding box. */ maxY = 0;
    /** The visible bounding boxes. */ boundingBoxes = new Array();
    /** The world vertices for the bounding box polygons. */ polygons = new Array();
    polygonPool = new (0, $1Yup6.Pool)(()=>{
        return (0, $1Yup6.Utils).newFloatArray(16);
    });
    /** Clears any previous polygons, finds all visible bounding box attachments, and computes the world vertices for each bounding
     * box's polygon.
     * @param updateAabb If true, the axis aligned bounding box containing all the polygons is computed. If false, the
     *           SkeletonBounds AABB methods will always return true. */ update(skeleton, updateAabb) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        let boundingBoxes = this.boundingBoxes;
        let polygons = this.polygons;
        let polygonPool = this.polygonPool;
        let slots = skeleton.slots;
        let slotCount = slots.length;
        boundingBoxes.length = 0;
        polygonPool.freeAll(polygons);
        polygons.length = 0;
        for(let i = 0; i < slotCount; i++){
            let slot = slots[i];
            if (!slot.bone.active) continue;
            let attachment = slot.getAttachment();
            if (attachment instanceof (0, $6LxqM.BoundingBoxAttachment)) {
                let boundingBox = attachment;
                boundingBoxes.push(boundingBox);
                let polygon = polygonPool.obtain();
                if (polygon.length != boundingBox.worldVerticesLength) polygon = (0, $1Yup6.Utils).newFloatArray(boundingBox.worldVerticesLength);
                polygons.push(polygon);
                boundingBox.computeWorldVertices(slot, 0, boundingBox.worldVerticesLength, polygon, 0, 2);
            }
        }
        if (updateAabb) this.aabbCompute();
        else {
            this.minX = Number.POSITIVE_INFINITY;
            this.minY = Number.POSITIVE_INFINITY;
            this.maxX = Number.NEGATIVE_INFINITY;
            this.maxY = Number.NEGATIVE_INFINITY;
        }
    }
    aabbCompute() {
        let minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++){
            let polygon = polygons[i];
            let vertices = polygon;
            for(let ii = 0, nn = polygon.length; ii < nn; ii += 2){
                let x = vertices[ii];
                let y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /** Returns true if the axis aligned bounding box contains the point. */ aabbContainsPoint(x, y) {
        return x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY;
    }
    /** Returns true if the axis aligned bounding box intersects the line segment. */ aabbIntersectsSegment(x1, y1, x2, y2) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        if (x1 <= minX && x2 <= minX || y1 <= minY && y2 <= minY || x1 >= maxX && x2 >= maxX || y1 >= maxY && y2 >= maxY) return false;
        let m = (y2 - y1) / (x2 - x1);
        let y = m * (minX - x1) + y1;
        if (y > minY && y < maxY) return true;
        y = m * (maxX - x1) + y1;
        if (y > minY && y < maxY) return true;
        let x = (minY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        x = (maxY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        return false;
    }
    /** Returns true if the axis aligned bounding box intersects the axis aligned bounding box of the specified bounds. */ aabbIntersectsSkeleton(bounds) {
        return this.minX < bounds.maxX && this.maxX > bounds.minX && this.minY < bounds.maxY && this.maxY > bounds.minY;
    }
    /** Returns the first bounding box attachment that contains the point, or null. When doing many checks, it is usually more
     * efficient to only call this method if {@link #aabbContainsPoint(float, float)} returns true. */ containsPoint(x, y) {
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++)if (this.containsPointPolygon(polygons[i], x, y)) return this.boundingBoxes[i];
        return null;
    }
    /** Returns true if the polygon contains the point. */ containsPointPolygon(polygon, x, y) {
        let vertices = polygon;
        let nn = polygon.length;
        let prevIndex = nn - 2;
        let inside = false;
        for(let ii = 0; ii < nn; ii += 2){
            let vertexY = vertices[ii + 1];
            let prevY = vertices[prevIndex + 1];
            if (vertexY < y && prevY >= y || prevY < y && vertexY >= y) {
                let vertexX = vertices[ii];
                if (vertexX + (y - vertexY) / (prevY - vertexY) * (vertices[prevIndex] - vertexX) < x) inside = !inside;
            }
            prevIndex = ii;
        }
        return inside;
    }
    /** Returns the first bounding box attachment that contains any part of the line segment, or null. When doing many checks, it
     * is usually more efficient to only call this method if {@link #aabbIntersectsSegment()} returns
     * true. */ intersectsSegment(x1, y1, x2, y2) {
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++)if (this.intersectsSegmentPolygon(polygons[i], x1, y1, x2, y2)) return this.boundingBoxes[i];
        return null;
    }
    /** Returns true if the polygon contains any part of the line segment. */ intersectsSegmentPolygon(polygon, x1, y1, x2, y2) {
        let vertices = polygon;
        let nn = polygon.length;
        let width12 = x1 - x2, height12 = y1 - y2;
        let det1 = x1 * y2 - y1 * x2;
        let x3 = vertices[nn - 2], y3 = vertices[nn - 1];
        for(let ii = 0; ii < nn; ii += 2){
            let x4 = vertices[ii], y4 = vertices[ii + 1];
            let det2 = x3 * y4 - y3 * x4;
            let width34 = x3 - x4, height34 = y3 - y4;
            let det3 = width12 * height34 - height12 * width34;
            let x = (det1 * width34 - width12 * det2) / det3;
            if ((x >= x3 && x <= x4 || x >= x4 && x <= x3) && (x >= x1 && x <= x2 || x >= x2 && x <= x1)) {
                let y = (det1 * height34 - height12 * det2) / det3;
                if ((y >= y3 && y <= y4 || y >= y4 && y <= y3) && (y >= y1 && y <= y2 || y >= y2 && y <= y1)) return true;
            }
            x3 = x4;
            y3 = y4;
        }
        return false;
    }
    /** Returns the polygon for the specified bounding box, or null. */ getPolygon(boundingBox) {
        if (!boundingBox) throw new Error("boundingBox cannot be null.");
        let index = this.boundingBoxes.indexOf(boundingBox);
        return index == -1 ? null : this.polygons[index];
    }
    /** The width of the axis aligned bounding box. */ getWidth() {
        return this.maxX - this.minX;
    }
    /** The height of the axis aligned bounding box. */ getHeight() {
        return this.maxY - this.minY;
    }
}

});

parcelRegister("kvLvw", function(module, exports) {

$parcel$export(module.exports, "SkeletonClipping", () => $eeeb8de69d7449cf$export$40b4063afbb1b315);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $aaTAm = parcelRequire("aaTAm");

var $1Yup6 = parcelRequire("1Yup6");
class $eeeb8de69d7449cf$export$40b4063afbb1b315 {
    triangulator = new (0, $aaTAm.Triangulator)();
    clippingPolygon = new Array();
    clipOutput = new Array();
    clippedVertices = new Array();
    clippedUVs = new Array();
    clippedTriangles = new Array();
    scratch = new Array();
    clipAttachment = null;
    clippingPolygons = null;
    clipStart(slot, clip) {
        if (this.clipAttachment) return 0;
        this.clipAttachment = clip;
        let n = clip.worldVerticesLength;
        let vertices = (0, $1Yup6.Utils).setArraySize(this.clippingPolygon, n);
        clip.computeWorldVertices(slot, 0, n, vertices, 0, 2);
        let clippingPolygon = this.clippingPolygon;
        $eeeb8de69d7449cf$export$40b4063afbb1b315.makeClockwise(clippingPolygon);
        let clippingPolygons = this.clippingPolygons = this.triangulator.decompose(clippingPolygon, this.triangulator.triangulate(clippingPolygon));
        for(let i = 0, n = clippingPolygons.length; i < n; i++){
            let polygon = clippingPolygons[i];
            $eeeb8de69d7449cf$export$40b4063afbb1b315.makeClockwise(polygon);
            polygon.push(polygon[0]);
            polygon.push(polygon[1]);
        }
        return clippingPolygons.length;
    }
    clipEndWithSlot(slot) {
        if (this.clipAttachment && this.clipAttachment.endSlot == slot.data) this.clipEnd();
    }
    clipEnd() {
        if (!this.clipAttachment) return;
        this.clipAttachment = null;
        this.clippingPolygons = null;
        this.clippedVertices.length = 0;
        this.clippedTriangles.length = 0;
        this.clippingPolygon.length = 0;
    }
    isClipping() {
        return this.clipAttachment != null;
    }
    clipTriangles(vertices, verticesLengthOrTriangles, trianglesOrTrianglesLength, trianglesLengthOrUvs, uvsOrLight, lightOrDark, darkOrTwoColor, twoColorParam) {
        // Determine which overload is being used
        let triangles;
        let trianglesLength;
        let uvs;
        let light;
        let dark;
        let twoColor;
        if (typeof verticesLengthOrTriangles === 'number') {
            triangles = trianglesOrTrianglesLength;
            trianglesLength = trianglesLengthOrUvs;
            uvs = uvsOrLight;
            light = lightOrDark;
            dark = darkOrTwoColor;
            twoColor = twoColorParam;
        } else {
            triangles = verticesLengthOrTriangles;
            trianglesLength = trianglesOrTrianglesLength;
            uvs = trianglesLengthOrUvs;
            light = uvsOrLight;
            dark = lightOrDark;
            twoColor = darkOrTwoColor;
        }
        if (uvs && light && dark && typeof twoColor === 'boolean') this.clipTrianglesRender(vertices, triangles, trianglesLength, uvs, light, dark, twoColor);
        else this.clipTrianglesNoRender(vertices, triangles, trianglesLength);
    }
    clipTrianglesNoRender(vertices, triangles, trianglesLength) {
        let clipOutput = this.clipOutput, clippedVertices = this.clippedVertices;
        let clippedTriangles = this.clippedTriangles;
        let polygons = this.clippingPolygons;
        let polygonsCount = polygons.length;
        let index = 0;
        clippedVertices.length = 0;
        clippedTriangles.length = 0;
        for(let i = 0; i < trianglesLength; i += 3){
            let vertexOffset = triangles[i] << 1;
            let x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
            vertexOffset = triangles[i + 1] << 1;
            let x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
            vertexOffset = triangles[i + 2] << 1;
            let x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
            for(let p = 0; p < polygonsCount; p++){
                let s = clippedVertices.length;
                if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                    let clipOutputLength = clipOutput.length;
                    if (clipOutputLength == 0) continue;
                    let clipOutputCount = clipOutputLength >> 1;
                    let clipOutputItems = this.clipOutput;
                    let clippedVerticesItems = (0, $1Yup6.Utils).setArraySize(clippedVertices, s + clipOutputCount * 2);
                    for(let ii = 0; ii < clipOutputLength; ii += 2, s += 2){
                        let x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                        clippedVerticesItems[s] = x;
                        clippedVerticesItems[s + 1] = y;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1Yup6.Utils).setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                    clipOutputCount--;
                    for(let ii = 1; ii < clipOutputCount; ii++, s += 3){
                        clippedTrianglesItems[s] = index;
                        clippedTrianglesItems[s + 1] = index + ii;
                        clippedTrianglesItems[s + 2] = index + ii + 1;
                    }
                    index += clipOutputCount + 1;
                } else {
                    let clippedVerticesItems = (0, $1Yup6.Utils).setArraySize(clippedVertices, s + 6);
                    clippedVerticesItems[s] = x1;
                    clippedVerticesItems[s + 1] = y1;
                    clippedVerticesItems[s + 2] = x2;
                    clippedVerticesItems[s + 3] = y2;
                    clippedVerticesItems[s + 4] = x3;
                    clippedVerticesItems[s + 5] = y3;
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1Yup6.Utils).setArraySize(clippedTriangles, s + 3);
                    clippedTrianglesItems[s] = index;
                    clippedTrianglesItems[s + 1] = index + 1;
                    clippedTrianglesItems[s + 2] = index + 2;
                    index += 3;
                    break;
                }
            }
        }
    }
    clipTrianglesRender(vertices, triangles, trianglesLength, uvs, light, dark, twoColor) {
        let clipOutput = this.clipOutput, clippedVertices = this.clippedVertices;
        let clippedTriangles = this.clippedTriangles;
        let polygons = this.clippingPolygons;
        let polygonsCount = polygons.length;
        let vertexSize = twoColor ? 12 : 8;
        let index = 0;
        clippedVertices.length = 0;
        clippedTriangles.length = 0;
        for(let i = 0; i < trianglesLength; i += 3){
            let vertexOffset = triangles[i] << 1;
            let x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
            let u1 = uvs[vertexOffset], v1 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 1] << 1;
            let x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
            let u2 = uvs[vertexOffset], v2 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 2] << 1;
            let x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
            let u3 = uvs[vertexOffset], v3 = uvs[vertexOffset + 1];
            for(let p = 0; p < polygonsCount; p++){
                let s = clippedVertices.length;
                if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                    let clipOutputLength = clipOutput.length;
                    if (clipOutputLength == 0) continue;
                    let d0 = y2 - y3, d1 = x3 - x2, d2 = x1 - x3, d4 = y3 - y1;
                    let d = 1 / (d0 * d2 + d1 * (y1 - y3));
                    let clipOutputCount = clipOutputLength >> 1;
                    let clipOutputItems = this.clipOutput;
                    let clippedVerticesItems = (0, $1Yup6.Utils).setArraySize(clippedVertices, s + clipOutputCount * vertexSize);
                    for(let ii = 0; ii < clipOutputLength; ii += 2, s += vertexSize){
                        let x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                        clippedVerticesItems[s] = x;
                        clippedVerticesItems[s + 1] = y;
                        clippedVerticesItems[s + 2] = light.r;
                        clippedVerticesItems[s + 3] = light.g;
                        clippedVerticesItems[s + 4] = light.b;
                        clippedVerticesItems[s + 5] = light.a;
                        let c0 = x - x3, c1 = y - y3;
                        let a = (d0 * c0 + d1 * c1) * d;
                        let b = (d4 * c0 + d2 * c1) * d;
                        let c = 1 - a - b;
                        clippedVerticesItems[s + 6] = u1 * a + u2 * b + u3 * c;
                        clippedVerticesItems[s + 7] = v1 * a + v2 * b + v3 * c;
                        if (twoColor) {
                            clippedVerticesItems[s + 8] = dark.r;
                            clippedVerticesItems[s + 9] = dark.g;
                            clippedVerticesItems[s + 10] = dark.b;
                            clippedVerticesItems[s + 11] = dark.a;
                        }
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1Yup6.Utils).setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                    clipOutputCount--;
                    for(let ii = 1; ii < clipOutputCount; ii++, s += 3){
                        clippedTrianglesItems[s] = index;
                        clippedTrianglesItems[s + 1] = index + ii;
                        clippedTrianglesItems[s + 2] = index + ii + 1;
                    }
                    index += clipOutputCount + 1;
                } else {
                    let clippedVerticesItems = (0, $1Yup6.Utils).setArraySize(clippedVertices, s + 3 * vertexSize);
                    clippedVerticesItems[s] = x1;
                    clippedVerticesItems[s + 1] = y1;
                    clippedVerticesItems[s + 2] = light.r;
                    clippedVerticesItems[s + 3] = light.g;
                    clippedVerticesItems[s + 4] = light.b;
                    clippedVerticesItems[s + 5] = light.a;
                    if (!twoColor) {
                        clippedVerticesItems[s + 6] = u1;
                        clippedVerticesItems[s + 7] = v1;
                        clippedVerticesItems[s + 8] = x2;
                        clippedVerticesItems[s + 9] = y2;
                        clippedVerticesItems[s + 10] = light.r;
                        clippedVerticesItems[s + 11] = light.g;
                        clippedVerticesItems[s + 12] = light.b;
                        clippedVerticesItems[s + 13] = light.a;
                        clippedVerticesItems[s + 14] = u2;
                        clippedVerticesItems[s + 15] = v2;
                        clippedVerticesItems[s + 16] = x3;
                        clippedVerticesItems[s + 17] = y3;
                        clippedVerticesItems[s + 18] = light.r;
                        clippedVerticesItems[s + 19] = light.g;
                        clippedVerticesItems[s + 20] = light.b;
                        clippedVerticesItems[s + 21] = light.a;
                        clippedVerticesItems[s + 22] = u3;
                        clippedVerticesItems[s + 23] = v3;
                    } else {
                        clippedVerticesItems[s + 6] = u1;
                        clippedVerticesItems[s + 7] = v1;
                        clippedVerticesItems[s + 8] = dark.r;
                        clippedVerticesItems[s + 9] = dark.g;
                        clippedVerticesItems[s + 10] = dark.b;
                        clippedVerticesItems[s + 11] = dark.a;
                        clippedVerticesItems[s + 12] = x2;
                        clippedVerticesItems[s + 13] = y2;
                        clippedVerticesItems[s + 14] = light.r;
                        clippedVerticesItems[s + 15] = light.g;
                        clippedVerticesItems[s + 16] = light.b;
                        clippedVerticesItems[s + 17] = light.a;
                        clippedVerticesItems[s + 18] = u2;
                        clippedVerticesItems[s + 19] = v2;
                        clippedVerticesItems[s + 20] = dark.r;
                        clippedVerticesItems[s + 21] = dark.g;
                        clippedVerticesItems[s + 22] = dark.b;
                        clippedVerticesItems[s + 23] = dark.a;
                        clippedVerticesItems[s + 24] = x3;
                        clippedVerticesItems[s + 25] = y3;
                        clippedVerticesItems[s + 26] = light.r;
                        clippedVerticesItems[s + 27] = light.g;
                        clippedVerticesItems[s + 28] = light.b;
                        clippedVerticesItems[s + 29] = light.a;
                        clippedVerticesItems[s + 30] = u3;
                        clippedVerticesItems[s + 31] = v3;
                        clippedVerticesItems[s + 32] = dark.r;
                        clippedVerticesItems[s + 33] = dark.g;
                        clippedVerticesItems[s + 34] = dark.b;
                        clippedVerticesItems[s + 35] = dark.a;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1Yup6.Utils).setArraySize(clippedTriangles, s + 3);
                    clippedTrianglesItems[s] = index;
                    clippedTrianglesItems[s + 1] = index + 1;
                    clippedTrianglesItems[s + 2] = index + 2;
                    index += 3;
                    break;
                }
            }
        }
    }
    clipTrianglesUnpacked(vertices, triangles, trianglesLength, uvs) {
        let clipOutput = this.clipOutput, clippedVertices = this.clippedVertices, clippedUVs = this.clippedUVs;
        let clippedTriangles = this.clippedTriangles;
        let polygons = this.clippingPolygons;
        let polygonsCount = polygons.length;
        let index = 0;
        clippedVertices.length = 0;
        clippedUVs.length = 0;
        clippedTriangles.length = 0;
        for(let i = 0; i < trianglesLength; i += 3){
            let vertexOffset = triangles[i] << 1;
            let x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
            let u1 = uvs[vertexOffset], v1 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 1] << 1;
            let x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
            let u2 = uvs[vertexOffset], v2 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 2] << 1;
            let x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
            let u3 = uvs[vertexOffset], v3 = uvs[vertexOffset + 1];
            for(let p = 0; p < polygonsCount; p++){
                let s = clippedVertices.length;
                if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                    let clipOutputLength = clipOutput.length;
                    if (clipOutputLength == 0) continue;
                    let d0 = y2 - y3, d1 = x3 - x2, d2 = x1 - x3, d4 = y3 - y1;
                    let d = 1 / (d0 * d2 + d1 * (y1 - y3));
                    let clipOutputCount = clipOutputLength >> 1;
                    let clipOutputItems = this.clipOutput;
                    let clippedVerticesItems = (0, $1Yup6.Utils).setArraySize(clippedVertices, s + clipOutputCount * 2);
                    let clippedUVsItems = (0, $1Yup6.Utils).setArraySize(clippedUVs, s + clipOutputCount * 2);
                    for(let ii = 0; ii < clipOutputLength; ii += 2, s += 2){
                        let x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                        clippedVerticesItems[s] = x;
                        clippedVerticesItems[s + 1] = y;
                        let c0 = x - x3, c1 = y - y3;
                        let a = (d0 * c0 + d1 * c1) * d;
                        let b = (d4 * c0 + d2 * c1) * d;
                        let c = 1 - a - b;
                        clippedUVsItems[s] = u1 * a + u2 * b + u3 * c;
                        clippedUVsItems[s + 1] = v1 * a + v2 * b + v3 * c;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1Yup6.Utils).setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                    clipOutputCount--;
                    for(let ii = 1; ii < clipOutputCount; ii++, s += 3){
                        clippedTrianglesItems[s] = index;
                        clippedTrianglesItems[s + 1] = index + ii;
                        clippedTrianglesItems[s + 2] = index + ii + 1;
                    }
                    index += clipOutputCount + 1;
                } else {
                    let clippedVerticesItems = (0, $1Yup6.Utils).setArraySize(clippedVertices, s + 6);
                    clippedVerticesItems[s] = x1;
                    clippedVerticesItems[s + 1] = y1;
                    clippedVerticesItems[s + 2] = x2;
                    clippedVerticesItems[s + 3] = y2;
                    clippedVerticesItems[s + 4] = x3;
                    clippedVerticesItems[s + 5] = y3;
                    let clippedUVSItems = (0, $1Yup6.Utils).setArraySize(clippedUVs, s + 6);
                    clippedUVSItems[s] = u1;
                    clippedUVSItems[s + 1] = v1;
                    clippedUVSItems[s + 2] = u2;
                    clippedUVSItems[s + 3] = v2;
                    clippedUVSItems[s + 4] = u3;
                    clippedUVSItems[s + 5] = v3;
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1Yup6.Utils).setArraySize(clippedTriangles, s + 3);
                    clippedTrianglesItems[s] = index;
                    clippedTrianglesItems[s + 1] = index + 1;
                    clippedTrianglesItems[s + 2] = index + 2;
                    index += 3;
                    break;
                }
            }
        }
    }
    /** Clips the input triangle against the convex, clockwise clipping area. If the triangle lies entirely within the clipping
     * area, false is returned. The clipping area must duplicate the first vertex at the end of the vertices list. */ clip(x1, y1, x2, y2, x3, y3, clippingArea, output) {
        let originalOutput = output;
        let clipped = false;
        // Avoid copy at the end.
        let input;
        if (clippingArea.length % 4 >= 2) {
            input = output;
            output = this.scratch;
        } else input = this.scratch;
        input.length = 0;
        input.push(x1);
        input.push(y1);
        input.push(x2);
        input.push(y2);
        input.push(x3);
        input.push(y3);
        input.push(x1);
        input.push(y1);
        output.length = 0;
        let clippingVerticesLast = clippingArea.length - 4;
        let clippingVertices = clippingArea;
        for(let i = 0;; i += 2){
            let edgeX = clippingVertices[i], edgeY = clippingVertices[i + 1];
            let ex = edgeX - clippingVertices[i + 2], ey = edgeY - clippingVertices[i + 3];
            let outputStart = output.length;
            let inputVertices = input;
            for(let ii = 0, nn = input.length - 2; ii < nn;){
                let inputX = inputVertices[ii], inputY = inputVertices[ii + 1];
                ii += 2;
                let inputX2 = inputVertices[ii], inputY2 = inputVertices[ii + 1];
                let s2 = ey * (edgeX - inputX2) > ex * (edgeY - inputY2);
                let s1 = ey * (edgeX - inputX) - ex * (edgeY - inputY);
                if (s1 > 0) {
                    if (s2) {
                        output.push(inputX2);
                        output.push(inputY2);
                        continue;
                    }
                    // v1 inside, v2 outside
                    let ix = inputX2 - inputX, iy = inputY2 - inputY, t = s1 / (ix * ey - iy * ex);
                    if (t >= 0 && t <= 1) {
                        output.push(inputX + ix * t);
                        output.push(inputY + iy * t);
                    } else {
                        output.push(inputX2);
                        output.push(inputY2);
                        continue;
                    }
                } else if (s2) {
                    let ix = inputX2 - inputX, iy = inputY2 - inputY, t = s1 / (ix * ey - iy * ex);
                    if (t >= 0 && t <= 1) {
                        output.push(inputX + ix * t);
                        output.push(inputY + iy * t);
                        output.push(inputX2);
                        output.push(inputY2);
                    } else {
                        output.push(inputX2);
                        output.push(inputY2);
                        continue;
                    }
                }
                clipped = true;
            }
            if (outputStart == output.length) {
                originalOutput.length = 0;
                return true;
            }
            output.push(output[0]);
            output.push(output[1]);
            if (i == clippingVerticesLast) break;
            let temp = output;
            output = input;
            output.length = 0;
            input = temp;
        }
        if (originalOutput != output) {
            originalOutput.length = 0;
            for(let i = 0, n = output.length - 2; i < n; i++)originalOutput[i] = output[i];
        } else originalOutput.length = originalOutput.length - 2;
        return clipped;
    }
    static makeClockwise(polygon) {
        let vertices = polygon;
        let verticeslength = polygon.length;
        let area = vertices[verticeslength - 2] * vertices[1] - vertices[0] * vertices[verticeslength - 1], p1x = 0, p1y = 0, p2x = 0, p2y = 0;
        for(let i = 0, n = verticeslength - 3; i < n; i += 2){
            p1x = vertices[i];
            p1y = vertices[i + 1];
            p2x = vertices[i + 2];
            p2y = vertices[i + 3];
            area += p1x * p2y - p2x * p1y;
        }
        if (area < 0) return;
        for(let i = 0, lastX = verticeslength - 2, n = verticeslength >> 1; i < n; i += 2){
            let x = vertices[i], y = vertices[i + 1];
            let other = lastX - i;
            vertices[i] = vertices[other];
            vertices[i + 1] = vertices[other + 1];
            vertices[other] = x;
            vertices[other + 1] = y;
        }
    }
}

});
parcelRegister("aaTAm", function(module, exports) {

$parcel$export(module.exports, "Triangulator", () => $7685f4a504844bde$export$2af2b14d1e1cb475);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $1Yup6 = parcelRequire("1Yup6");
class $7685f4a504844bde$export$2af2b14d1e1cb475 {
    convexPolygons = new Array();
    convexPolygonsIndices = new Array();
    indicesArray = new Array();
    isConcaveArray = new Array();
    triangles = new Array();
    polygonPool = new (0, $1Yup6.Pool)(()=>{
        return new Array();
    });
    polygonIndicesPool = new (0, $1Yup6.Pool)(()=>{
        return new Array();
    });
    triangulate(verticesArray) {
        let vertices = verticesArray;
        let vertexCount = verticesArray.length >> 1;
        let indices = this.indicesArray;
        indices.length = 0;
        for(let i = 0; i < vertexCount; i++)indices[i] = i;
        let isConcave = this.isConcaveArray;
        isConcave.length = 0;
        for(let i = 0, n = vertexCount; i < n; ++i)isConcave[i] = $7685f4a504844bde$export$2af2b14d1e1cb475.isConcave(i, vertexCount, vertices, indices);
        let triangles = this.triangles;
        triangles.length = 0;
        while(vertexCount > 3){
            // Find ear tip.
            let previous = vertexCount - 1, i = 0, next = 1;
            while(true){
                outer: if (!isConcave[i]) {
                    let p1 = indices[previous] << 1, p2 = indices[i] << 1, p3 = indices[next] << 1;
                    let p1x = vertices[p1], p1y = vertices[p1 + 1];
                    let p2x = vertices[p2], p2y = vertices[p2 + 1];
                    let p3x = vertices[p3], p3y = vertices[p3 + 1];
                    for(let ii = (next + 1) % vertexCount; ii != previous; ii = (ii + 1) % vertexCount){
                        if (!isConcave[ii]) continue;
                        let v = indices[ii] << 1;
                        let vx = vertices[v], vy = vertices[v + 1];
                        if ($7685f4a504844bde$export$2af2b14d1e1cb475.positiveArea(p3x, p3y, p1x, p1y, vx, vy)) {
                            if ($7685f4a504844bde$export$2af2b14d1e1cb475.positiveArea(p1x, p1y, p2x, p2y, vx, vy)) {
                                if ($7685f4a504844bde$export$2af2b14d1e1cb475.positiveArea(p2x, p2y, p3x, p3y, vx, vy)) break outer;
                            }
                        }
                    }
                    break;
                }
                if (next == 0) {
                    do {
                        if (!isConcave[i]) break;
                        i--;
                    }while (i > 0);
                    break;
                }
                previous = i;
                i = next;
                next = (next + 1) % vertexCount;
            }
            // Cut ear tip.
            triangles.push(indices[(vertexCount + i - 1) % vertexCount]);
            triangles.push(indices[i]);
            triangles.push(indices[(i + 1) % vertexCount]);
            indices.splice(i, 1);
            isConcave.splice(i, 1);
            vertexCount--;
            let previousIndex = (vertexCount + i - 1) % vertexCount;
            let nextIndex = i == vertexCount ? 0 : i;
            isConcave[previousIndex] = $7685f4a504844bde$export$2af2b14d1e1cb475.isConcave(previousIndex, vertexCount, vertices, indices);
            isConcave[nextIndex] = $7685f4a504844bde$export$2af2b14d1e1cb475.isConcave(nextIndex, vertexCount, vertices, indices);
        }
        if (vertexCount == 3) {
            triangles.push(indices[2]);
            triangles.push(indices[0]);
            triangles.push(indices[1]);
        }
        return triangles;
    }
    decompose(verticesArray, triangles) {
        let vertices = verticesArray;
        let convexPolygons = this.convexPolygons;
        this.polygonPool.freeAll(convexPolygons);
        convexPolygons.length = 0;
        let convexPolygonsIndices = this.convexPolygonsIndices;
        this.polygonIndicesPool.freeAll(convexPolygonsIndices);
        convexPolygonsIndices.length = 0;
        let polygonIndices = this.polygonIndicesPool.obtain();
        polygonIndices.length = 0;
        let polygon = this.polygonPool.obtain();
        polygon.length = 0;
        // Merge subsequent triangles if they form a triangle fan.
        let fanBaseIndex = -1, lastWinding = 0;
        for(let i = 0, n = triangles.length; i < n; i += 3){
            let t1 = triangles[i] << 1, t2 = triangles[i + 1] << 1, t3 = triangles[i + 2] << 1;
            let x1 = vertices[t1], y1 = vertices[t1 + 1];
            let x2 = vertices[t2], y2 = vertices[t2 + 1];
            let x3 = vertices[t3], y3 = vertices[t3 + 1];
            // If the base of the last triangle is the same as this triangle, check if they form a convex polygon (triangle fan).
            let merged = false;
            if (fanBaseIndex == t1) {
                let o = polygon.length - 4;
                let winding1 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(polygon[o], polygon[o + 1], polygon[o + 2], polygon[o + 3], x3, y3);
                let winding2 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(x3, y3, polygon[0], polygon[1], polygon[2], polygon[3]);
                if (winding1 == lastWinding && winding2 == lastWinding) {
                    polygon.push(x3);
                    polygon.push(y3);
                    polygonIndices.push(t3);
                    merged = true;
                }
            }
            // Otherwise make this triangle the new base.
            if (!merged) {
                if (polygon.length > 0) {
                    convexPolygons.push(polygon);
                    convexPolygonsIndices.push(polygonIndices);
                } else {
                    this.polygonPool.free(polygon);
                    this.polygonIndicesPool.free(polygonIndices);
                }
                polygon = this.polygonPool.obtain();
                polygon.length = 0;
                polygon.push(x1);
                polygon.push(y1);
                polygon.push(x2);
                polygon.push(y2);
                polygon.push(x3);
                polygon.push(y3);
                polygonIndices = this.polygonIndicesPool.obtain();
                polygonIndices.length = 0;
                polygonIndices.push(t1);
                polygonIndices.push(t2);
                polygonIndices.push(t3);
                lastWinding = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(x1, y1, x2, y2, x3, y3);
                fanBaseIndex = t1;
            }
        }
        if (polygon.length > 0) {
            convexPolygons.push(polygon);
            convexPolygonsIndices.push(polygonIndices);
        }
        // Go through the list of polygons and try to merge the remaining triangles with the found triangle fans.
        for(let i = 0, n = convexPolygons.length; i < n; i++){
            polygonIndices = convexPolygonsIndices[i];
            if (polygonIndices.length == 0) continue;
            let firstIndex = polygonIndices[0];
            let lastIndex = polygonIndices[polygonIndices.length - 1];
            polygon = convexPolygons[i];
            let o = polygon.length - 4;
            let prevPrevX = polygon[o], prevPrevY = polygon[o + 1];
            let prevX = polygon[o + 2], prevY = polygon[o + 3];
            let firstX = polygon[0], firstY = polygon[1];
            let secondX = polygon[2], secondY = polygon[3];
            let winding = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(prevPrevX, prevPrevY, prevX, prevY, firstX, firstY);
            for(let ii = 0; ii < n; ii++){
                if (ii == i) continue;
                let otherIndices = convexPolygonsIndices[ii];
                if (otherIndices.length != 3) continue;
                let otherFirstIndex = otherIndices[0];
                let otherSecondIndex = otherIndices[1];
                let otherLastIndex = otherIndices[2];
                let otherPoly = convexPolygons[ii];
                let x3 = otherPoly[otherPoly.length - 2], y3 = otherPoly[otherPoly.length - 1];
                if (otherFirstIndex != firstIndex || otherSecondIndex != lastIndex) continue;
                let winding1 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(prevPrevX, prevPrevY, prevX, prevY, x3, y3);
                let winding2 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(x3, y3, firstX, firstY, secondX, secondY);
                if (winding1 == winding && winding2 == winding) {
                    otherPoly.length = 0;
                    otherIndices.length = 0;
                    polygon.push(x3);
                    polygon.push(y3);
                    polygonIndices.push(otherLastIndex);
                    prevPrevX = prevX;
                    prevPrevY = prevY;
                    prevX = x3;
                    prevY = y3;
                    ii = 0;
                }
            }
        }
        // Remove empty polygons that resulted from the merge step above.
        for(let i = convexPolygons.length - 1; i >= 0; i--){
            polygon = convexPolygons[i];
            if (polygon.length == 0) {
                convexPolygons.splice(i, 1);
                this.polygonPool.free(polygon);
                polygonIndices = convexPolygonsIndices[i];
                convexPolygonsIndices.splice(i, 1);
                this.polygonIndicesPool.free(polygonIndices);
            }
        }
        return convexPolygons;
    }
    static isConcave(index, vertexCount, vertices, indices) {
        let previous = indices[(vertexCount + index - 1) % vertexCount] << 1;
        let current = indices[index] << 1;
        let next = indices[(index + 1) % vertexCount] << 1;
        return !this.positiveArea(vertices[previous], vertices[previous + 1], vertices[current], vertices[current + 1], vertices[next], vertices[next + 1]);
    }
    static positiveArea(p1x, p1y, p2x, p2y, p3x, p3y) {
        return p1x * (p3y - p2y) + p2x * (p1y - p3y) + p3x * (p2y - p1y) >= 0;
    }
    static winding(p1x, p1y, p2x, p2y, p3x, p3y) {
        let px = p2x - p1x, py = p2y - p1y;
        return p3x * py - p3y * px + px * p1y - p1x * py >= 0 ? 1 : -1;
    }
}

});


parcelRegister("ePHEE", function(module, exports) {

$parcel$export(module.exports, "SkeletonJson", () => $acc7b1056b491f28$export$8913b5e618c6d2f3);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
var $hevjK = parcelRequire("hevjK");

var $1S7b2 = parcelRequire("1S7b2");

var $gfyKS = parcelRequire("gfyKS");

var $2jWXd = parcelRequire("2jWXd");

var $2eT9h = parcelRequire("2eT9h");

var $1Wvqv = parcelRequire("1Wvqv");

var $d4Xjx = parcelRequire("d4Xjx");

var $9UdTx = parcelRequire("9UdTx");

var $8FokI = parcelRequire("8FokI");

var $3jtmM = parcelRequire("3jtmM");

var $1Yup6 = parcelRequire("1Yup6");

var $2nRvY = parcelRequire("2nRvY");

var $2Ma0J = parcelRequire("2Ma0J");
class $acc7b1056b491f28$export$8913b5e618c6d2f3 {
    attachmentLoader;
    /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ scale = 1;
    linkedMeshes = new Array();
    constructor(attachmentLoader){
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(json) {
        let scale = this.scale;
        let skeletonData = new (0, $d4Xjx.SkeletonData)();
        let root = typeof json === "string" ? JSON.parse(json) : json;
        // Skeleton
        let skeletonMap = root.skeleton;
        if (skeletonMap) {
            skeletonData.hash = skeletonMap.hash;
            skeletonData.version = skeletonMap.spine;
            skeletonData.x = skeletonMap.x;
            skeletonData.y = skeletonMap.y;
            skeletonData.width = skeletonMap.width;
            skeletonData.height = skeletonMap.height;
            skeletonData.referenceScale = $acc7b1056b491f28$var$getValue(skeletonMap, "referenceScale", 100) * scale;
            skeletonData.fps = skeletonMap.fps;
            skeletonData.imagesPath = skeletonMap.images ?? null;
            skeletonData.audioPath = skeletonMap.audio ?? null;
        }
        // Bones
        if (root.bones) for(let i = 0; i < root.bones.length; i++){
            let boneMap = root.bones[i];
            let parent = null;
            let parentName = $acc7b1056b491f28$var$getValue(boneMap, "parent", null);
            if (parentName) parent = skeletonData.findBone(parentName);
            let data = new (0, $1S7b2.BoneData)(skeletonData.bones.length, boneMap.name, parent);
            data.length = $acc7b1056b491f28$var$getValue(boneMap, "length", 0) * scale;
            data.x = $acc7b1056b491f28$var$getValue(boneMap, "x", 0) * scale;
            data.y = $acc7b1056b491f28$var$getValue(boneMap, "y", 0) * scale;
            data.rotation = $acc7b1056b491f28$var$getValue(boneMap, "rotation", 0);
            data.scaleX = $acc7b1056b491f28$var$getValue(boneMap, "scaleX", 1);
            data.scaleY = $acc7b1056b491f28$var$getValue(boneMap, "scaleY", 1);
            data.shearX = $acc7b1056b491f28$var$getValue(boneMap, "shearX", 0);
            data.shearY = $acc7b1056b491f28$var$getValue(boneMap, "shearY", 0);
            data.inherit = (0, $1Yup6.Utils).enumValue((0, $1S7b2.Inherit), $acc7b1056b491f28$var$getValue(boneMap, "inherit", "Normal"));
            data.skinRequired = $acc7b1056b491f28$var$getValue(boneMap, "skin", false);
            let color = $acc7b1056b491f28$var$getValue(boneMap, "color", null);
            if (color) data.color.setFromString(color);
            skeletonData.bones.push(data);
        }
        // Slots.
        if (root.slots) for(let i = 0; i < root.slots.length; i++){
            let slotMap = root.slots[i];
            let slotName = slotMap.name;
            let boneData = skeletonData.findBone(slotMap.bone);
            if (!boneData) throw new Error(`Couldn't find bone ${slotMap.bone} for slot ${slotName}`);
            let data = new (0, $8FokI.SlotData)(skeletonData.slots.length, slotName, boneData);
            let color = $acc7b1056b491f28$var$getValue(slotMap, "color", null);
            if (color) data.color.setFromString(color);
            let dark = $acc7b1056b491f28$var$getValue(slotMap, "dark", null);
            if (dark) data.darkColor = (0, $1Yup6.Color).fromString(dark);
            data.attachmentName = $acc7b1056b491f28$var$getValue(slotMap, "attachment", null);
            data.blendMode = (0, $1Yup6.Utils).enumValue((0, $8FokI.BlendMode), $acc7b1056b491f28$var$getValue(slotMap, "blend", "normal"));
            data.visible = $acc7b1056b491f28$var$getValue(slotMap, "visible", true);
            skeletonData.slots.push(data);
        }
        // IK constraints
        if (root.ik) for(let i = 0; i < root.ik.length; i++){
            let constraintMap = root.ik[i];
            let data = new (0, $2eT9h.IkConstraintData)(constraintMap.name);
            data.order = $acc7b1056b491f28$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $acc7b1056b491f28$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let bone = skeletonData.findBone(constraintMap.bones[ii]);
                if (!bone) throw new Error(`Couldn't find bone ${constraintMap.bones[ii]} for IK constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let target = skeletonData.findBone(constraintMap.target);
            if (!target) throw new Error(`Couldn't find target bone ${constraintMap.target} for IK constraint ${constraintMap.name}.`);
            data.target = target;
            data.mix = $acc7b1056b491f28$var$getValue(constraintMap, "mix", 1);
            data.softness = $acc7b1056b491f28$var$getValue(constraintMap, "softness", 0) * scale;
            data.bendDirection = $acc7b1056b491f28$var$getValue(constraintMap, "bendPositive", true) ? 1 : -1;
            data.compress = $acc7b1056b491f28$var$getValue(constraintMap, "compress", false);
            data.stretch = $acc7b1056b491f28$var$getValue(constraintMap, "stretch", false);
            data.uniform = $acc7b1056b491f28$var$getValue(constraintMap, "uniform", false);
            skeletonData.ikConstraints.push(data);
        }
        // Transform constraints.
        if (root.transform) for(let i = 0; i < root.transform.length; i++){
            let constraintMap = root.transform[i];
            let data = new (0, $3jtmM.TransformConstraintData)(constraintMap.name);
            data.order = $acc7b1056b491f28$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $acc7b1056b491f28$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let boneName = constraintMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for transform constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let targetName = constraintMap.target;
            let target = skeletonData.findBone(targetName);
            if (!target) throw new Error(`Couldn't find target bone ${targetName} for transform constraint ${constraintMap.name}.`);
            data.target = target;
            data.local = $acc7b1056b491f28$var$getValue(constraintMap, "local", false);
            data.relative = $acc7b1056b491f28$var$getValue(constraintMap, "relative", false);
            data.offsetRotation = $acc7b1056b491f28$var$getValue(constraintMap, "rotation", 0);
            data.offsetX = $acc7b1056b491f28$var$getValue(constraintMap, "x", 0) * scale;
            data.offsetY = $acc7b1056b491f28$var$getValue(constraintMap, "y", 0) * scale;
            data.offsetScaleX = $acc7b1056b491f28$var$getValue(constraintMap, "scaleX", 0);
            data.offsetScaleY = $acc7b1056b491f28$var$getValue(constraintMap, "scaleY", 0);
            data.offsetShearY = $acc7b1056b491f28$var$getValue(constraintMap, "shearY", 0);
            data.mixRotate = $acc7b1056b491f28$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $acc7b1056b491f28$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $acc7b1056b491f28$var$getValue(constraintMap, "mixY", data.mixX);
            data.mixScaleX = $acc7b1056b491f28$var$getValue(constraintMap, "mixScaleX", 1);
            data.mixScaleY = $acc7b1056b491f28$var$getValue(constraintMap, "mixScaleY", data.mixScaleX);
            data.mixShearY = $acc7b1056b491f28$var$getValue(constraintMap, "mixShearY", 1);
            skeletonData.transformConstraints.push(data);
        }
        // Path constraints.
        if (root.path) for(let i = 0; i < root.path.length; i++){
            let constraintMap = root.path[i];
            let data = new (0, $1Wvqv.PathConstraintData)(constraintMap.name);
            data.order = $acc7b1056b491f28$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $acc7b1056b491f28$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let boneName = constraintMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for path constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let targetName = constraintMap.target;
            let target = skeletonData.findSlot(targetName);
            if (!target) throw new Error(`Couldn't find target slot ${targetName} for path constraint ${constraintMap.name}.`);
            data.target = target;
            data.positionMode = (0, $1Yup6.Utils).enumValue((0, $1Wvqv.PositionMode), $acc7b1056b491f28$var$getValue(constraintMap, "positionMode", "Percent"));
            data.spacingMode = (0, $1Yup6.Utils).enumValue((0, $1Wvqv.SpacingMode), $acc7b1056b491f28$var$getValue(constraintMap, "spacingMode", "Length"));
            data.rotateMode = (0, $1Yup6.Utils).enumValue((0, $1Wvqv.RotateMode), $acc7b1056b491f28$var$getValue(constraintMap, "rotateMode", "Tangent"));
            data.offsetRotation = $acc7b1056b491f28$var$getValue(constraintMap, "rotation", 0);
            data.position = $acc7b1056b491f28$var$getValue(constraintMap, "position", 0);
            if (data.positionMode == (0, $1Wvqv.PositionMode).Fixed) data.position *= scale;
            data.spacing = $acc7b1056b491f28$var$getValue(constraintMap, "spacing", 0);
            if (data.spacingMode == (0, $1Wvqv.SpacingMode).Length || data.spacingMode == (0, $1Wvqv.SpacingMode).Fixed) data.spacing *= scale;
            data.mixRotate = $acc7b1056b491f28$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $acc7b1056b491f28$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $acc7b1056b491f28$var$getValue(constraintMap, "mixY", data.mixX);
            skeletonData.pathConstraints.push(data);
        }
        // Physics constraints.
        if (root.physics) for(let i = 0; i < root.physics.length; i++){
            const constraintMap = root.physics[i];
            const data = new (0, $2Ma0J.PhysicsConstraintData)(constraintMap.name);
            data.order = $acc7b1056b491f28$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $acc7b1056b491f28$var$getValue(constraintMap, "skin", false);
            const boneName = constraintMap.bone;
            const bone = skeletonData.findBone(boneName);
            if (bone == null) throw new Error("Physics bone not found: " + boneName);
            data.bone = bone;
            data.x = $acc7b1056b491f28$var$getValue(constraintMap, "x", 0);
            data.y = $acc7b1056b491f28$var$getValue(constraintMap, "y", 0);
            data.rotate = $acc7b1056b491f28$var$getValue(constraintMap, "rotate", 0);
            data.scaleX = $acc7b1056b491f28$var$getValue(constraintMap, "scaleX", 0);
            data.shearX = $acc7b1056b491f28$var$getValue(constraintMap, "shearX", 0);
            data.limit = $acc7b1056b491f28$var$getValue(constraintMap, "limit", 5000) * scale;
            data.step = 1 / $acc7b1056b491f28$var$getValue(constraintMap, "fps", 60);
            data.inertia = $acc7b1056b491f28$var$getValue(constraintMap, "inertia", 1);
            data.strength = $acc7b1056b491f28$var$getValue(constraintMap, "strength", 100);
            data.damping = $acc7b1056b491f28$var$getValue(constraintMap, "damping", 1);
            data.massInverse = 1 / $acc7b1056b491f28$var$getValue(constraintMap, "mass", 1);
            data.wind = $acc7b1056b491f28$var$getValue(constraintMap, "wind", 0);
            data.gravity = $acc7b1056b491f28$var$getValue(constraintMap, "gravity", 0);
            data.mix = $acc7b1056b491f28$var$getValue(constraintMap, "mix", 1);
            data.inertiaGlobal = $acc7b1056b491f28$var$getValue(constraintMap, "inertiaGlobal", false);
            data.strengthGlobal = $acc7b1056b491f28$var$getValue(constraintMap, "strengthGlobal", false);
            data.dampingGlobal = $acc7b1056b491f28$var$getValue(constraintMap, "dampingGlobal", false);
            data.massGlobal = $acc7b1056b491f28$var$getValue(constraintMap, "massGlobal", false);
            data.windGlobal = $acc7b1056b491f28$var$getValue(constraintMap, "windGlobal", false);
            data.gravityGlobal = $acc7b1056b491f28$var$getValue(constraintMap, "gravityGlobal", false);
            data.mixGlobal = $acc7b1056b491f28$var$getValue(constraintMap, "mixGlobal", false);
            skeletonData.physicsConstraints.push(data);
        }
        // Skins.
        if (root.skins) for(let i = 0; i < root.skins.length; i++){
            let skinMap = root.skins[i];
            let skin = new (0, $9UdTx.Skin)(skinMap.name);
            if (skinMap.bones) for(let ii = 0; ii < skinMap.bones.length; ii++){
                let boneName = skinMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for skin ${skinMap.name}.`);
                skin.bones.push(bone);
            }
            if (skinMap.ik) for(let ii = 0; ii < skinMap.ik.length; ii++){
                let constraintName = skinMap.ik[ii];
                let constraint = skeletonData.findIkConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find IK constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.transform) for(let ii = 0; ii < skinMap.transform.length; ii++){
                let constraintName = skinMap.transform[ii];
                let constraint = skeletonData.findTransformConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find transform constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.path) for(let ii = 0; ii < skinMap.path.length; ii++){
                let constraintName = skinMap.path[ii];
                let constraint = skeletonData.findPathConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find path constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.physics) for(let ii = 0; ii < skinMap.physics.length; ii++){
                let constraintName = skinMap.physics[ii];
                let constraint = skeletonData.findPhysicsConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find physics constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            for(let slotName in skinMap.attachments){
                let slot = skeletonData.findSlot(slotName);
                if (!slot) throw new Error(`Couldn't find slot ${slotName} for skin ${skinMap.name}.`);
                let slotMap = skinMap.attachments[slotName];
                for(let entryName in slotMap){
                    let attachment = this.readAttachment(slotMap[entryName], skin, slot.index, entryName, skeletonData);
                    if (attachment) skin.setAttachment(slot.index, entryName, attachment);
                }
            }
            skeletonData.skins.push(skin);
            if (skin.name == "default") skeletonData.defaultSkin = skin;
        }
        // Linked meshes.
        for(let i = 0, n = this.linkedMeshes.length; i < n; i++){
            let linkedMesh = this.linkedMeshes[i];
            let skin = !linkedMesh.skin ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (!skin) throw new Error(`Skin not found: ${linkedMesh.skin}`);
            let parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
            if (linkedMesh.mesh.region != null) linkedMesh.mesh.updateRegion();
        }
        this.linkedMeshes.length = 0;
        // Events.
        if (root.events) for(let eventName in root.events){
            let eventMap = root.events[eventName];
            let data = new (0, $gfyKS.EventData)(eventName);
            data.intValue = $acc7b1056b491f28$var$getValue(eventMap, "int", 0);
            data.floatValue = $acc7b1056b491f28$var$getValue(eventMap, "float", 0);
            data.stringValue = $acc7b1056b491f28$var$getValue(eventMap, "string", "");
            data.audioPath = $acc7b1056b491f28$var$getValue(eventMap, "audio", null);
            if (data.audioPath) {
                data.volume = $acc7b1056b491f28$var$getValue(eventMap, "volume", 1);
                data.balance = $acc7b1056b491f28$var$getValue(eventMap, "balance", 0);
            }
            skeletonData.events.push(data);
        }
        // Animations.
        if (root.animations) for(let animationName in root.animations){
            let animationMap = root.animations[animationName];
            this.readAnimation(animationMap, animationName, skeletonData);
        }
        return skeletonData;
    }
    readAttachment(map, skin, slotIndex, name, skeletonData) {
        let scale = this.scale;
        name = $acc7b1056b491f28$var$getValue(map, "name", name);
        switch($acc7b1056b491f28$var$getValue(map, "type", "region")){
            case "region":
                {
                    let path = $acc7b1056b491f28$var$getValue(map, "path", name);
                    let sequence = this.readSequence($acc7b1056b491f28$var$getValue(map, "sequence", null));
                    let region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = $acc7b1056b491f28$var$getValue(map, "x", 0) * scale;
                    region.y = $acc7b1056b491f28$var$getValue(map, "y", 0) * scale;
                    region.scaleX = $acc7b1056b491f28$var$getValue(map, "scaleX", 1);
                    region.scaleY = $acc7b1056b491f28$var$getValue(map, "scaleY", 1);
                    region.rotation = $acc7b1056b491f28$var$getValue(map, "rotation", 0);
                    region.width = map.width * scale;
                    region.height = map.height * scale;
                    region.sequence = sequence;
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) region.color.setFromString(color);
                    if (region.region != null) region.updateRegion();
                    return region;
                }
            case "boundingbox":
                {
                    let box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    this.readVertices(map, box, map.vertexCount << 1);
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) box.color.setFromString(color);
                    return box;
                }
            case "mesh":
            case "linkedmesh":
                {
                    let path = $acc7b1056b491f28$var$getValue(map, "path", name);
                    let sequence = this.readSequence($acc7b1056b491f28$var$getValue(map, "sequence", null));
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) mesh.color.setFromString(color);
                    mesh.width = $acc7b1056b491f28$var$getValue(map, "width", 0) * scale;
                    mesh.height = $acc7b1056b491f28$var$getValue(map, "height", 0) * scale;
                    mesh.sequence = sequence;
                    let parent = $acc7b1056b491f28$var$getValue(map, "parent", null);
                    if (parent) {
                        this.linkedMeshes.push(new $acc7b1056b491f28$var$LinkedMesh(mesh, $acc7b1056b491f28$var$getValue(map, "skin", null), slotIndex, parent, $acc7b1056b491f28$var$getValue(map, "timelines", true)));
                        return mesh;
                    }
                    let uvs = map.uvs;
                    this.readVertices(map, mesh, uvs.length);
                    mesh.triangles = map.triangles;
                    mesh.regionUVs = uvs;
                    if (mesh.region != null) mesh.updateRegion();
                    mesh.edges = $acc7b1056b491f28$var$getValue(map, "edges", null);
                    mesh.hullLength = $acc7b1056b491f28$var$getValue(map, "hull", 0) * 2;
                    return mesh;
                }
            case "path":
                {
                    let path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = $acc7b1056b491f28$var$getValue(map, "closed", false);
                    path.constantSpeed = $acc7b1056b491f28$var$getValue(map, "constantSpeed", true);
                    let vertexCount = map.vertexCount;
                    this.readVertices(map, path, vertexCount << 1);
                    let lengths = (0, $1Yup6.Utils).newArray(vertexCount / 3, 0);
                    for(let i = 0; i < map.lengths.length; i++)lengths[i] = map.lengths[i] * scale;
                    path.lengths = lengths;
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) path.color.setFromString(color);
                    return path;
                }
            case "point":
                {
                    let point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = $acc7b1056b491f28$var$getValue(map, "x", 0) * scale;
                    point.y = $acc7b1056b491f28$var$getValue(map, "y", 0) * scale;
                    point.rotation = $acc7b1056b491f28$var$getValue(map, "rotation", 0);
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) point.color.setFromString(color);
                    return point;
                }
            case "clipping":
                {
                    let clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    let end = $acc7b1056b491f28$var$getValue(map, "end", null);
                    if (end) clip.endSlot = skeletonData.findSlot(end);
                    let vertexCount = map.vertexCount;
                    this.readVertices(map, clip, vertexCount << 1);
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) clip.color.setFromString(color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(map) {
        if (map == null) return null;
        let sequence = new (0, $2nRvY.Sequence)($acc7b1056b491f28$var$getValue(map, "count", 0));
        sequence.start = $acc7b1056b491f28$var$getValue(map, "start", 1);
        sequence.digits = $acc7b1056b491f28$var$getValue(map, "digits", 0);
        sequence.setupIndex = $acc7b1056b491f28$var$getValue(map, "setup", 0);
        return sequence;
    }
    readVertices(map, attachment, verticesLength) {
        let scale = this.scale;
        attachment.worldVerticesLength = verticesLength;
        let vertices = map.vertices;
        if (verticesLength == vertices.length) {
            let scaledVertices = (0, $1Yup6.Utils).toFloatArray(vertices);
            if (scale != 1) for(let i = 0, n = vertices.length; i < n; i++)scaledVertices[i] *= scale;
            attachment.vertices = scaledVertices;
            return;
        }
        let weights = new Array();
        let bones = new Array();
        for(let i = 0, n = vertices.length; i < n;){
            let boneCount = vertices[i++];
            bones.push(boneCount);
            for(let nn = i + boneCount * 4; i < nn; i += 4){
                bones.push(vertices[i]);
                weights.push(vertices[i + 1] * scale);
                weights.push(vertices[i + 2] * scale);
                weights.push(vertices[i + 3]);
            }
        }
        attachment.bones = bones;
        attachment.vertices = (0, $1Yup6.Utils).toFloatArray(weights);
    }
    readAnimation(map, name, skeletonData) {
        let scale = this.scale;
        let timelines = new Array();
        // Slot timelines.
        if (map.slots) for(let slotName in map.slots){
            let slotMap = map.slots[slotName];
            let slot = skeletonData.findSlot(slotName);
            if (!slot) throw new Error("Slot not found: " + slotName);
            let slotIndex = slot.index;
            for(let timelineName in slotMap){
                let timelineMap = slotMap[timelineName];
                if (!timelineMap) continue;
                let frames = timelineMap.length;
                if (timelineName == "attachment") {
                    let timeline = new (0, $hevjK.AttachmentTimeline)(frames, slotIndex);
                    for(let frame = 0; frame < frames; frame++){
                        let keyMap = timelineMap[frame];
                        timeline.setFrame(frame, $acc7b1056b491f28$var$getValue(keyMap, "time", 0), $acc7b1056b491f28$var$getValue(keyMap, "name", null));
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgba") {
                    let timeline = new (0, $hevjK.RGBATimeline)(frames, frames << 2, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1Yup6.Color).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1Yup6.Color).fromString(nextMap.color);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb") {
                    let timeline = new (0, $hevjK.RGBTimeline)(frames, frames * 3, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1Yup6.Color).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1Yup6.Color).fromString(nextMap.color);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "alpha") timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, new (0, $hevjK.AlphaTimeline)(frames, frames, slotIndex), 0, 1));
                else if (timelineName == "rgba2") {
                    let timeline = new (0, $hevjK.RGBA2Timeline)(frames, frames * 7, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1Yup6.Color).fromString(keyMap.light);
                    let color2 = (0, $1Yup6.Color).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a, color2.r, color2.g, color2.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1Yup6.Color).fromString(nextMap.light);
                        let newColor2 = (0, $1Yup6.Color).fromString(nextMap.dark);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.r, newColor2.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.g, newColor2.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 6, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb2") {
                    let timeline = new (0, $hevjK.RGB2Timeline)(frames, frames * 6, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1Yup6.Color).fromString(keyMap.light);
                    let color2 = (0, $1Yup6.Color).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color2.r, color2.g, color2.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1Yup6.Color).fromString(nextMap.light);
                        let newColor2 = (0, $1Yup6.Color).fromString(nextMap.dark);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color2.r, newColor2.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.g, newColor2.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        // Bone timelines.
        if (map.bones) for(let boneName in map.bones){
            let boneMap = map.bones[boneName];
            let bone = skeletonData.findBone(boneName);
            if (!bone) throw new Error("Bone not found: " + boneName);
            let boneIndex = bone.index;
            for(let timelineName in boneMap){
                let timelineMap = boneMap[timelineName];
                let frames = timelineMap.length;
                if (frames == 0) continue;
                if (timelineName === "rotate") timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, new (0, $hevjK.RotateTimeline)(frames, frames, boneIndex), 0, 1));
                else if (timelineName === "translate") {
                    let timeline = new (0, $hevjK.TranslateTimeline)(frames, frames << 1, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline2(timelineMap, timeline, "x", "y", 0, scale));
                } else if (timelineName === "translatex") {
                    let timeline = new (0, $hevjK.TranslateXTimeline)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "translatey") {
                    let timeline = new (0, $hevjK.TranslateYTimeline)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "scale") {
                    let timeline = new (0, $hevjK.ScaleTimeline)(frames, frames << 1, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline2(timelineMap, timeline, "x", "y", 1, 1));
                } else if (timelineName === "scalex") {
                    let timeline = new (0, $hevjK.ScaleXTimeline)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "scaley") {
                    let timeline = new (0, $hevjK.ScaleYTimeline)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "shear") {
                    let timeline = new (0, $hevjK.ShearTimeline)(frames, frames << 1, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline2(timelineMap, timeline, "x", "y", 0, 1));
                } else if (timelineName === "shearx") {
                    let timeline = new (0, $hevjK.ShearXTimeline)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, 1));
                } else if (timelineName === "sheary") {
                    let timeline = new (0, $hevjK.ShearYTimeline)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, 1));
                } else if (timelineName === "inherit") {
                    let timeline = new (0, $hevjK.InheritTimeline)(frames, bone.index);
                    for(let frame = 0; frame < timelineMap.length; frame++){
                        let aFrame = timelineMap[frame];
                        timeline.setFrame(frame, $acc7b1056b491f28$var$getValue(aFrame, "time", 0), (0, $1Yup6.Utils).enumValue((0, $1S7b2.Inherit), $acc7b1056b491f28$var$getValue(aFrame, "inherit", "Normal")));
                    }
                    timelines.push(timeline);
                }
            }
        }
        // IK constraint timelines.
        if (map.ik) for(let constraintName in map.ik){
            let constraintMap = map.ik[constraintName];
            let keyMap = constraintMap[0];
            if (!keyMap) continue;
            let constraint = skeletonData.findIkConstraint(constraintName);
            if (!constraint) throw new Error("IK Constraint not found: " + constraintName);
            let constraintIndex = skeletonData.ikConstraints.indexOf(constraint);
            let timeline = new (0, $hevjK.IkConstraintTimeline)(constraintMap.length, constraintMap.length << 1, constraintIndex);
            let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
            let mix = $acc7b1056b491f28$var$getValue(keyMap, "mix", 1);
            let softness = $acc7b1056b491f28$var$getValue(keyMap, "softness", 0) * scale;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, $acc7b1056b491f28$var$getValue(keyMap, "bendPositive", true) ? 1 : -1, $acc7b1056b491f28$var$getValue(keyMap, "compress", false), $acc7b1056b491f28$var$getValue(keyMap, "stretch", false));
                let nextMap = constraintMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                let mix2 = $acc7b1056b491f28$var$getValue(nextMap, "mix", 1);
                let softness2 = $acc7b1056b491f28$var$getValue(nextMap, "softness", 0) * scale;
                let curve = keyMap.curve;
                if (curve) {
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mix, mix2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        // Transform constraint timelines.
        if (map.transform) for(let constraintName in map.transform){
            let timelineMap = map.transform[constraintName];
            let keyMap = timelineMap[0];
            if (!keyMap) continue;
            let constraint = skeletonData.findTransformConstraint(constraintName);
            if (!constraint) throw new Error("Transform constraint not found: " + constraintName);
            let constraintIndex = skeletonData.transformConstraints.indexOf(constraint);
            let timeline = new (0, $hevjK.TransformConstraintTimeline)(timelineMap.length, timelineMap.length * 6, constraintIndex);
            let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
            let mixRotate = $acc7b1056b491f28$var$getValue(keyMap, "mixRotate", 1);
            let mixX = $acc7b1056b491f28$var$getValue(keyMap, "mixX", 1);
            let mixY = $acc7b1056b491f28$var$getValue(keyMap, "mixY", mixX);
            let mixScaleX = $acc7b1056b491f28$var$getValue(keyMap, "mixScaleX", 1);
            let mixScaleY = $acc7b1056b491f28$var$getValue(keyMap, "mixScaleY", mixScaleX);
            let mixShearY = $acc7b1056b491f28$var$getValue(keyMap, "mixShearY", 1);
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                let nextMap = timelineMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                let mixRotate2 = $acc7b1056b491f28$var$getValue(nextMap, "mixRotate", 1);
                let mixX2 = $acc7b1056b491f28$var$getValue(nextMap, "mixX", 1);
                let mixY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixY", mixX2);
                let mixScaleX2 = $acc7b1056b491f28$var$getValue(nextMap, "mixScaleX", 1);
                let mixScaleY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixScaleY", mixScaleX2);
                let mixShearY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixShearY", 1);
                let curve = keyMap.curve;
                if (curve) {
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixScaleX = mixScaleX2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        // Path constraint timelines.
        if (map.path) for(let constraintName in map.path){
            let constraintMap = map.path[constraintName];
            let constraint = skeletonData.findPathConstraint(constraintName);
            if (!constraint) throw new Error("Path constraint not found: " + constraintName);
            let constraintIndex = skeletonData.pathConstraints.indexOf(constraint);
            for(let timelineName in constraintMap){
                let timelineMap = constraintMap[timelineName];
                let keyMap = timelineMap[0];
                if (!keyMap) continue;
                let frames = timelineMap.length;
                if (timelineName === "position") {
                    let timeline = new (0, $hevjK.PathConstraintPositionTimeline)(frames, frames, constraintIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, constraint.positionMode == (0, $1Wvqv.PositionMode).Fixed ? scale : 1));
                } else if (timelineName === "spacing") {
                    let timeline = new (0, $hevjK.PathConstraintSpacingTimeline)(frames, frames, constraintIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, constraint.spacingMode == (0, $1Wvqv.SpacingMode).Length || constraint.spacingMode == (0, $1Wvqv.SpacingMode).Fixed ? scale : 1));
                } else if (timelineName === "mix") {
                    let timeline = new (0, $hevjK.PathConstraintMixTimeline)(frames, frames * 3, constraintIndex);
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let mixRotate = $acc7b1056b491f28$var$getValue(keyMap, "mixRotate", 1);
                    let mixX = $acc7b1056b491f28$var$getValue(keyMap, "mixX", 1);
                    let mixY = $acc7b1056b491f28$var$getValue(keyMap, "mixY", mixX);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let mixRotate2 = $acc7b1056b491f28$var$getValue(nextMap, "mixRotate", 1);
                        let mixX2 = $acc7b1056b491f28$var$getValue(nextMap, "mixX", 1);
                        let mixY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixY", mixX2);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                        }
                        time = time2;
                        mixRotate = mixRotate2;
                        mixX = mixX2;
                        mixY = mixY2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        // Physics constraint timelines.
        if (map.physics) for(let constraintName in map.physics){
            let constraintMap = map.physics[constraintName];
            let constraintIndex = -1;
            if (constraintName.length > 0) {
                let constraint = skeletonData.findPhysicsConstraint(constraintName);
                if (!constraint) throw new Error("Physics constraint not found: " + constraintName);
                constraintIndex = skeletonData.physicsConstraints.indexOf(constraint);
            }
            for(let timelineName in constraintMap){
                let timelineMap = constraintMap[timelineName];
                let keyMap = timelineMap[0];
                if (!keyMap) continue;
                let frames = timelineMap.length;
                if (timelineName == "reset") {
                    const timeline = new (0, $hevjK.PhysicsConstraintResetTimeline)(frames, constraintIndex);
                    for(let frame = 0; keyMap != null; keyMap = timelineMap[frame + 1], frame++)timeline.setFrame(frame, $acc7b1056b491f28$var$getValue(keyMap, "time", 0));
                    timelines.push(timeline);
                    continue;
                }
                let timeline;
                if (timelineName == "inertia") timeline = new (0, $hevjK.PhysicsConstraintInertiaTimeline)(frames, frames, constraintIndex);
                else if (timelineName == "strength") timeline = new (0, $hevjK.PhysicsConstraintStrengthTimeline)(frames, frames, constraintIndex);
                else if (timelineName == "damping") timeline = new (0, $hevjK.PhysicsConstraintDampingTimeline)(frames, frames, constraintIndex);
                else if (timelineName == "mass") timeline = new (0, $hevjK.PhysicsConstraintMassTimeline)(frames, frames, constraintIndex);
                else if (timelineName == "wind") timeline = new (0, $hevjK.PhysicsConstraintWindTimeline)(frames, frames, constraintIndex);
                else if (timelineName == "gravity") timeline = new (0, $hevjK.PhysicsConstraintGravityTimeline)(frames, frames, constraintIndex);
                else if (timelineName == "mix") timeline = new (0, $hevjK.PhysicsConstraintMixTimeline)(frames, frames, constraintIndex);
                else continue;
                timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, 1));
            }
        }
        // Attachment timelines.
        if (map.attachments) for(let attachmentsName in map.attachments){
            let attachmentsMap = map.attachments[attachmentsName];
            let skin = skeletonData.findSkin(attachmentsName);
            if (!skin) throw new Error("Skin not found: " + attachmentsName);
            for(let slotMapName in attachmentsMap){
                let slotMap = attachmentsMap[slotMapName];
                let slot = skeletonData.findSlot(slotMapName);
                if (!slot) throw new Error("Slot not found: " + slotMapName);
                let slotIndex = slot.index;
                for(let attachmentMapName in slotMap){
                    let attachmentMap = slotMap[attachmentMapName];
                    let attachment = skin.getAttachment(slotIndex, attachmentMapName);
                    for(let timelineMapName in attachmentMap){
                        let timelineMap = attachmentMap[timelineMapName];
                        let keyMap = timelineMap[0];
                        if (!keyMap) continue;
                        if (timelineMapName == "deform") {
                            let weighted = attachment.bones;
                            let vertices = attachment.vertices;
                            let deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                            let timeline = new (0, $hevjK.DeformTimeline)(timelineMap.length, timelineMap.length, slotIndex, attachment);
                            let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                            for(let frame = 0, bezier = 0;; frame++){
                                let deform;
                                let verticesValue = $acc7b1056b491f28$var$getValue(keyMap, "vertices", null);
                                if (!verticesValue) deform = weighted ? (0, $1Yup6.Utils).newFloatArray(deformLength) : vertices;
                                else {
                                    deform = (0, $1Yup6.Utils).newFloatArray(deformLength);
                                    let start = $acc7b1056b491f28$var$getValue(keyMap, "offset", 0);
                                    (0, $1Yup6.Utils).arrayCopy(verticesValue, 0, deform, start, verticesValue.length);
                                    if (scale != 1) for(let i = start, n = i + verticesValue.length; i < n; i++)deform[i] *= scale;
                                    if (!weighted) for(let i = 0; i < deformLength; i++)deform[i] += vertices[i];
                                }
                                timeline.setFrame(frame, time, deform);
                                let nextMap = timelineMap[frame + 1];
                                if (!nextMap) {
                                    timeline.shrink(bezier);
                                    break;
                                }
                                let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                                let curve = keyMap.curve;
                                if (curve) bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, 0, 1, 1);
                                time = time2;
                                keyMap = nextMap;
                            }
                            timelines.push(timeline);
                        } else if (timelineMapName == "sequence") {
                            let timeline = new (0, $hevjK.SequenceTimeline)(timelineMap.length, slotIndex, attachment);
                            let lastDelay = 0;
                            for(let frame = 0; frame < timelineMap.length; frame++){
                                let delay = $acc7b1056b491f28$var$getValue(keyMap, "delay", lastDelay);
                                let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                                let mode = (0, $2nRvY.SequenceMode)[$acc7b1056b491f28$var$getValue(keyMap, "mode", "hold")];
                                let index = $acc7b1056b491f28$var$getValue(keyMap, "index", 0);
                                timeline.setFrame(frame, time, mode, index, delay);
                                lastDelay = delay;
                                keyMap = timelineMap[frame + 1];
                            }
                            timelines.push(timeline);
                        }
                    }
                }
            }
        }
        // Draw order timelines.
        if (map.drawOrder) {
            let timeline = new (0, $hevjK.DrawOrderTimeline)(map.drawOrder.length);
            let slotCount = skeletonData.slots.length;
            let frame = 0;
            for(let i = 0; i < map.drawOrder.length; i++, frame++){
                let drawOrderMap = map.drawOrder[i];
                let drawOrder = null;
                let offsets = $acc7b1056b491f28$var$getValue(drawOrderMap, "offsets", null);
                if (offsets) {
                    drawOrder = (0, $1Yup6.Utils).newArray(slotCount, -1);
                    let unchanged = (0, $1Yup6.Utils).newArray(slotCount - offsets.length, 0);
                    let originalIndex = 0, unchangedIndex = 0;
                    for(let ii = 0; ii < offsets.length; ii++){
                        let offsetMap = offsets[ii];
                        let slot = skeletonData.findSlot(offsetMap.slot);
                        if (!slot) throw new Error("Slot not found: " + slot);
                        let slotIndex = slot.index;
                        // Collect unchanged items.
                        while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                        // Set changed items.
                        drawOrder[originalIndex + offsetMap.offset] = originalIndex++;
                    }
                    // Collect remaining unchanged items.
                    while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                    // Fill in unchanged items.
                    for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                }
                timeline.setFrame(frame, $acc7b1056b491f28$var$getValue(drawOrderMap, "time", 0), drawOrder);
            }
            timelines.push(timeline);
        }
        // Event timelines.
        if (map.events) {
            let timeline = new (0, $hevjK.EventTimeline)(map.events.length);
            let frame = 0;
            for(let i = 0; i < map.events.length; i++, frame++){
                let eventMap = map.events[i];
                let eventData = skeletonData.findEvent(eventMap.name);
                if (!eventData) throw new Error("Event not found: " + eventMap.name);
                let event = new (0, $2jWXd.Event)((0, $1Yup6.Utils).toSinglePrecision($acc7b1056b491f28$var$getValue(eventMap, "time", 0)), eventData);
                event.intValue = $acc7b1056b491f28$var$getValue(eventMap, "int", eventData.intValue);
                event.floatValue = $acc7b1056b491f28$var$getValue(eventMap, "float", eventData.floatValue);
                event.stringValue = $acc7b1056b491f28$var$getValue(eventMap, "string", eventData.stringValue);
                if (event.data.audioPath) {
                    event.volume = $acc7b1056b491f28$var$getValue(eventMap, "volume", 1);
                    event.balance = $acc7b1056b491f28$var$getValue(eventMap, "balance", 0);
                }
                timeline.setFrame(frame, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        skeletonData.animations.push(new (0, $hevjK.Animation)(name, timelines, duration));
    }
}
class $acc7b1056b491f28$var$LinkedMesh {
    parent;
    skin;
    slotIndex;
    mesh;
    inheritTimeline;
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
function $acc7b1056b491f28$var$readTimeline1(keys, timeline, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
    let value = $acc7b1056b491f28$var$getValue(keyMap, "value", defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value);
        let nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
        let value2 = $acc7b1056b491f28$var$getValue(nextMap, "value", defaultValue) * scale;
        if (keyMap.curve) bezier = $acc7b1056b491f28$var$readCurve(keyMap.curve, timeline, bezier, frame, 0, time, time2, value, value2, scale);
        time = time2;
        value = value2;
        keyMap = nextMap;
    }
}
function $acc7b1056b491f28$var$readTimeline2(keys, timeline, name1, name2, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
    let value1 = $acc7b1056b491f28$var$getValue(keyMap, name1, defaultValue) * scale;
    let value2 = $acc7b1056b491f28$var$getValue(keyMap, name2, defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        let nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
        let nvalue1 = $acc7b1056b491f28$var$getValue(nextMap, name1, defaultValue) * scale;
        let nvalue2 = $acc7b1056b491f28$var$getValue(nextMap, name2, defaultValue) * scale;
        let curve = keyMap.curve;
        if (curve) {
            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, value1, nvalue1, scale);
            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
        keyMap = nextMap;
    }
}
function $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    if (curve == "stepped") {
        timeline.setStepped(frame);
        return bezier;
    }
    let i = value << 2;
    let cx1 = curve[i];
    let cy1 = curve[i + 1] * scale;
    let cx2 = curve[i + 2];
    let cy2 = curve[i + 3] * scale;
    timeline.setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2);
    return bezier + 1;
}
function $acc7b1056b491f28$var$getValue(map, property, defaultValue) {
    return map[property] !== undefined ? map[property] : defaultValue;
}

});

parcelRegister("d5XqA", function(module, exports) {
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
});

parcelRegister("1Y2C7", function(module, exports) {
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ (()=>{
    if (typeof Math.fround === "undefined") Math.fround = function(array) {
        return function(x) {
            return array[0] = x, array[0];
        };
    }(new Float32Array(1));
})();

});

parcelRegister("lA4oi", function(module, exports) {
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated April 5, 2025. Replaces all prior versions.
 *
 * Copyright (c) 2013-2025, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
});




parcelRegister("9e8rD", function(module, exports) {
parcelRequire("iuB9z");
var $dofl4 = parcelRequire("dofl4");
var $iCGeI = parcelRequire("iCGeI");
var $i9BKe = parcelRequire("i9BKe");
var $iEtN5 = parcelRequire("iEtN5");
function $beaa80e3e76a72a3$var$isJson(resource) {
    return Object.prototype.hasOwnProperty.call(resource, "bones");
}
function $beaa80e3e76a72a3$var$isBuffer(resource) {
    return resource instanceof Uint8Array;
}
const $beaa80e3e76a72a3$var$spineLoaderExtension = {
    extension: (0, $i9BKe.ExtensionType).Asset,
    loader: {
        extension: {
            type: (0, $i9BKe.ExtensionType).LoadParser,
            priority: (0, $iEtN5.LoaderParserPriority).Normal,
            name: "spineSkeletonLoader"
        },
        test (url) {
            return (0, $dofl4.checkExtension)(url, ".skel");
        },
        async load (url) {
            const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
            const buffer = new Uint8Array(await response.arrayBuffer());
            return buffer;
        },
        testParse (asset, options) {
            const isJsonSpineModel = (0, $dofl4.checkExtension)(options.src, ".json") && $beaa80e3e76a72a3$var$isJson(asset);
            const isBinarySpineModel = (0, $dofl4.checkExtension)(options.src, ".skel") && $beaa80e3e76a72a3$var$isBuffer(asset);
            return Promise.resolve(isJsonSpineModel || isBinarySpineModel);
        }
    }
};
(0, $i9BKe.extensions).add($beaa80e3e76a72a3$var$spineLoaderExtension);

});

parcelRegister("9inJy", function(module, exports) {
parcelRequire("iuB9z");
var $4rmMq = parcelRequire("4rmMq");
var $a2eTA = parcelRequire("a2eTA");
var $i9BKe = parcelRequire("i9BKe");

var $c0EDH = parcelRequire("c0EDH");

var $a5w7X = parcelRequire("a5w7X");
var $6e84aa2d3a34b940$var$__defProp = Object.defineProperty;
var $6e84aa2d3a34b940$var$__defNormalProp = (obj, key, value)=>key in obj ? $6e84aa2d3a34b940$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6e84aa2d3a34b940$var$__publicField = (obj, key, value)=>{
    $6e84aa2d3a34b940$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
let $6e84aa2d3a34b940$var$defaultShader = null;
const $6e84aa2d3a34b940$var$_DarkTintBatcher = class _DarkTintBatcher extends (0, $4rmMq.Batcher) {
    constructor(){
        super(...arguments);
        $6e84aa2d3a34b940$var$__publicField(this, "geometry", new (0, $c0EDH.DarkTintBatchGeometry)());
        $6e84aa2d3a34b940$var$__publicField(this, "shader", $6e84aa2d3a34b940$var$defaultShader || ($6e84aa2d3a34b940$var$defaultShader = new (0, $a5w7X.DarkTintShader)(this.maxTextures)));
        $6e84aa2d3a34b940$var$__publicField(this, "name", _DarkTintBatcher.extension.name);
        /** The size of one attribute. 1 = 32 bit. x, y, u, v, color, darkColor, textureIdAndRound -> total = 7 */ $6e84aa2d3a34b940$var$__publicField(this, "vertexSize", 7);
    }
    packAttributes(element, float32View, uint32View, index, textureId) {
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const { positions: positions, uvs: uvs } = element;
        const argb = element.color;
        const worldAlpha = (argb >> 24 & 255) / 255;
        const darkColor = (0, $a2eTA.Color).shared.setValue(element.darkColor).premultiply(worldAlpha, true).toPremultiplied(1, false);
        const offset = element.attributeOffset;
        const end = offset + element.attributeSize;
        for(let i = offset; i < end; i++){
            const i2 = i * 2;
            const x = positions[i2];
            const y = positions[i2 + 1];
            float32View[index++] = a * x + c * y + tx;
            float32View[index++] = d * y + b * x + ty;
            float32View[index++] = uvs[i2];
            float32View[index++] = uvs[i2 + 1];
            uint32View[index++] = argb;
            uint32View[index++] = darkColor;
            uint32View[index++] = textureIdAndRound;
        }
    }
    packQuadAttributes(element, float32View, uint32View, index, textureId) {
        const texture = element.texture;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const bounds = element.bounds;
        const w0 = bounds.maxX;
        const w1 = bounds.minX;
        const h0 = bounds.maxY;
        const h1 = bounds.minY;
        const uvs = texture.uvs;
        const argb = element.color;
        const darkColor = element.darkColor;
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        float32View[index + 0] = a * w1 + c * h1 + tx;
        float32View[index + 1] = d * h1 + b * w1 + ty;
        float32View[index + 2] = uvs.x0;
        float32View[index + 3] = uvs.y0;
        uint32View[index + 4] = argb;
        uint32View[index + 5] = darkColor;
        uint32View[index + 6] = textureIdAndRound;
        float32View[index + 7] = a * w0 + c * h1 + tx;
        float32View[index + 8] = d * h1 + b * w0 + ty;
        float32View[index + 9] = uvs.x1;
        float32View[index + 10] = uvs.y1;
        uint32View[index + 11] = argb;
        uint32View[index + 12] = darkColor;
        uint32View[index + 13] = textureIdAndRound;
        float32View[index + 14] = a * w0 + c * h0 + tx;
        float32View[index + 15] = d * h0 + b * w0 + ty;
        float32View[index + 16] = uvs.x2;
        float32View[index + 17] = uvs.y2;
        uint32View[index + 18] = argb;
        uint32View[index + 19] = darkColor;
        uint32View[index + 20] = textureIdAndRound;
        float32View[index + 21] = a * w1 + c * h0 + tx;
        float32View[index + 22] = d * h0 + b * w1 + ty;
        float32View[index + 23] = uvs.x3;
        float32View[index + 24] = uvs.y3;
        uint32View[index + 25] = argb;
        uint32View[index + 26] = darkColor;
        uint32View[index + 27] = textureIdAndRound;
    }
};
/** @ignore */ $6e84aa2d3a34b940$var$__publicField($6e84aa2d3a34b940$var$_DarkTintBatcher, "extension", {
    type: [
        (0, $i9BKe.ExtensionType).Batcher
    ],
    name: "darkTint"
});
let $6e84aa2d3a34b940$export$257521f2568b0b84 = $6e84aa2d3a34b940$var$_DarkTintBatcher;
(0, $i9BKe.extensions).add($6e84aa2d3a34b940$export$257521f2568b0b84);

});
parcelRegister("c0EDH", function(module, exports) {

$parcel$export(module.exports, "DarkTintBatchGeometry", () => $612e2a7b810542d5$export$f48f49e60ab904bd);
parcelRequire("iuB9z");
var $lvEAL = parcelRequire("lvEAL");
var $1UZ6r = parcelRequire("1UZ6r");
var $cOnev = parcelRequire("cOnev");
const $612e2a7b810542d5$var$placeHolderBufferData = new Float32Array(1);
const $612e2a7b810542d5$var$placeHolderIndexData = new Uint32Array(1);
class $612e2a7b810542d5$export$f48f49e60ab904bd extends (0, $cOnev.Geometry) {
    constructor(){
        const vertexSize = 7;
        const attributeBuffer = new (0, $lvEAL.Buffer)({
            data: $612e2a7b810542d5$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $lvEAL.Buffer)({
            data: $612e2a7b810542d5$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16
                },
                aDarkColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 20
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 24
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});

parcelRegister("a5w7X", function(module, exports) {

$parcel$export(module.exports, "DarkTintShader", () => $2c7d9b16f22b9469$export$98b336f7e397d203);
parcelRequire("iuB9z");
var $cNnNT = parcelRequire("cNnNT");
var $3JBHn = parcelRequire("3JBHn");
var $ikSZA = parcelRequire("ikSZA");
var $10zIa = parcelRequire("10zIa");
var $kSpdC = parcelRequire("kSpdC");
var $5iDyo = parcelRequire("5iDyo");

var $7JWl8 = parcelRequire("7JWl8");
class $2c7d9b16f22b9469$export$98b336f7e397d203 extends (0, $5iDyo.Shader) {
    constructor(maxTextures){
        const glProgram = (0, $3JBHn.compileHighShaderGlProgram)({
            name: "dark-tint-batch",
            bits: [
                (0, $cNnNT.colorBitGl),
                (0, $7JWl8.darkTintBitGl),
                (0, $ikSZA.generateTextureBatchBitGl)(maxTextures),
                (0, $kSpdC.roundPixelsBitGl)
            ]
        });
        const gpuProgram = (0, $3JBHn.compileHighShaderGpuProgram)({
            name: "dark-tint-batch",
            bits: [
                (0, $cNnNT.colorBit),
                (0, $7JWl8.darkTintBit),
                (0, $ikSZA.generateTextureBatchBit)(maxTextures),
                (0, $kSpdC.roundPixelsBit)
            ]
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                batchSamplers: (0, $10zIa.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
    }
}

});
parcelRegister("7JWl8", function(module, exports) {

$parcel$export(module.exports, "darkTintBit", () => $0d8cbaf009120f3b$export$4b0a046b02e5d0a3);
$parcel$export(module.exports, "darkTintBitGl", () => $0d8cbaf009120f3b$export$98776232ad81b7a5);
const $0d8cbaf009120f3b$export$4b0a046b02e5d0a3 = {
    name: "color-bit",
    vertex: {
        header: /* wgsl */ `
            @in aDarkColor: vec4<f32>;
            @out vDarkColor: vec4<f32>;
        `,
        main: /* wgsl */ `
        vDarkColor = aDarkColor;
        `
    },
    fragment: {
        header: /* wgsl */ `
            @in vDarkColor: vec4<f32>;
        `,
        end: /* wgsl */ `
            
        let alpha = outColor.a * vColor.a;
        let rgb = ((outColor.a - 1.0) * vDarkColor.a + 1.0 - outColor.rgb) * vDarkColor.rgb + outColor.rgb * vColor.rgb;

        finalColor = vec4<f32>(rgb, alpha);

        `
    }
};
const $0d8cbaf009120f3b$export$98776232ad81b7a5 = {
    name: "color-bit",
    vertex: {
        header: /* glsl */ `
            in vec4 aDarkColor;
            out vec4 vDarkColor;
        `,
        main: /* glsl */ `
            vDarkColor = aDarkColor;
        `
    },
    fragment: {
        header: /* glsl */ `
            in vec4 vDarkColor;
        `,
        end: /* glsl */ `
            
        finalColor.a = outColor.a * vColor.a;
        finalColor.rgb = ((outColor.a - 1.0) * vDarkColor.a + 1.0 - outColor.rgb) * vDarkColor.rgb + outColor.rgb * vColor.rgb;
        `
    }
};

});



parcelRegister("1ng6v", function(module, exports) {
parcelRequire("iuB9z");
var $3WPIH = parcelRequire("3WPIH");
var $i9BKe = parcelRequire("i9BKe");

var $iu4mr = parcelRequire("iu4mr");
parcelRequire("6DlDK");
var $5ot6H = parcelRequire("5ot6H");
var $8wKGy = parcelRequire("8wKGy");
var $kvLvw = parcelRequire("kvLvw");
var $f4f3403005411a27$var$__defProp = Object.defineProperty;
var $f4f3403005411a27$var$__defNormalProp = (obj, key, value)=>key in obj ? $f4f3403005411a27$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f4f3403005411a27$var$__publicField = (obj, key, value)=>{
    $f4f3403005411a27$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $f4f3403005411a27$var$clipper = new (0, $kvLvw.SkeletonClipping)();
const $f4f3403005411a27$var$spineBlendModeMap = {
    0: "normal",
    1: "add",
    2: "multiply",
    3: "screen"
};
class $f4f3403005411a27$export$80b6657f531375a8 {
    constructor(renderer){
        $f4f3403005411a27$var$__publicField(this, "renderer");
        $f4f3403005411a27$var$__publicField(this, "gpuSpineData", {});
        this.renderer = renderer;
    }
    validateRenderable(spine) {
        spine._applyState();
        if (spine.spineAttachmentsDirty) return true;
        else if (spine.spineTexturesDirty) {
            const drawOrder = spine.skeleton.drawOrder;
            const gpuSpine = this.gpuSpineData[spine.uid];
            for(let i = 0, n = drawOrder.length; i < n; i++){
                const slot = drawOrder[i];
                const attachment = slot.getAttachment();
                if (attachment instanceof (0, $8wKGy.RegionAttachment) || attachment instanceof (0, $5ot6H.MeshAttachment)) {
                    const cacheData = spine._getCachedData(slot, attachment);
                    const batchableSpineSlot = gpuSpine.slotBatches[cacheData.id];
                    const texture = cacheData.texture;
                    if (texture !== batchableSpineSlot.texture) {
                        if (!batchableSpineSlot._batcher.checkAndUpdateTexture(batchableSpineSlot, texture)) return true;
                    }
                }
            }
        }
        return false;
    }
    addRenderable(spine, instructionSet) {
        var _a, _b, _c, _d;
        const gpuSpine = (_a = this.gpuSpineData)[_b = spine.uid] || (_a[_b] = {
            slotBatches: {}
        });
        const batcher = this.renderer.renderPipes.batch;
        const drawOrder = spine.skeleton.drawOrder;
        const roundPixels = this.renderer._roundPixels | spine._roundPixels;
        spine._applyState();
        for(let i = 0, n = drawOrder.length; i < n; i++){
            const slot = drawOrder[i];
            const attachment = slot.getAttachment();
            const blendMode = $f4f3403005411a27$var$spineBlendModeMap[slot.data.blendMode];
            if (attachment instanceof (0, $8wKGy.RegionAttachment) || attachment instanceof (0, $5ot6H.MeshAttachment)) {
                const cacheData = spine._getCachedData(slot, attachment);
                const batchableSpineSlot = (_c = gpuSpine.slotBatches)[_d = cacheData.id] || (_c[_d] = new (0, $iu4mr.BatchableSpineSlot)());
                batchableSpineSlot.setData(spine, cacheData, blendMode, roundPixels);
                if (!cacheData.skipRender) batcher.addToBatch(batchableSpineSlot, instructionSet);
            }
            const containerAttachment = spine._slotsObject[slot.data.name];
            if (containerAttachment) {
                const container = containerAttachment.container;
                container.includeInBuild = true;
                (0, $3WPIH.collectAllRenderables)(container, instructionSet, this.renderer);
                container.includeInBuild = false;
            }
        }
        $f4f3403005411a27$var$clipper.clipEnd();
    }
    updateRenderable(spine) {
        const gpuSpine = this.gpuSpineData[spine.uid];
        spine._applyState();
        const drawOrder = spine.skeleton.drawOrder;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            const slot = drawOrder[i];
            const attachment = slot.getAttachment();
            if (attachment instanceof (0, $8wKGy.RegionAttachment) || attachment instanceof (0, $5ot6H.MeshAttachment)) {
                const cacheData = spine._getCachedData(slot, attachment);
                if (!cacheData.skipRender) {
                    const batchableSpineSlot = gpuSpine.slotBatches[spine._getCachedData(slot, attachment).id];
                    batchableSpineSlot._batcher?.updateElement(batchableSpineSlot);
                }
            }
        }
    }
    destroyRenderable(spine) {
        this.gpuSpineData[spine.uid] = null;
    }
    destroy() {
        this.gpuSpineData = null;
        this.renderer = null;
    }
}
/** @ignore */ $f4f3403005411a27$var$__publicField($f4f3403005411a27$export$80b6657f531375a8, "extension", {
    type: [
        (0, $i9BKe.ExtensionType).WebGLPipes,
        (0, $i9BKe.ExtensionType).WebGPUPipes,
        (0, $i9BKe.ExtensionType).CanvasPipes
    ],
    name: "spine"
});
(0, $i9BKe.extensions).add($f4f3403005411a27$export$80b6657f531375a8);

});
parcelRegister("iu4mr", function(module, exports) {

$parcel$export(module.exports, "BatchableSpineSlot", () => $7abce02e6e9dad1f$export$3d8cf245c51df902);
var $7abce02e6e9dad1f$var$__defProp = Object.defineProperty;
var $7abce02e6e9dad1f$var$__defNormalProp = (obj, key, value)=>key in obj ? $7abce02e6e9dad1f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7abce02e6e9dad1f$var$__publicField = (obj, key, value)=>{
    $7abce02e6e9dad1f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $7abce02e6e9dad1f$export$3d8cf245c51df902 {
    constructor(){
        $7abce02e6e9dad1f$var$__publicField(this, "indexOffset", 0);
        $7abce02e6e9dad1f$var$__publicField(this, "attributeOffset", 0);
        $7abce02e6e9dad1f$var$__publicField(this, "indexSize");
        $7abce02e6e9dad1f$var$__publicField(this, "attributeSize");
        $7abce02e6e9dad1f$var$__publicField(this, "batcherName", "darkTint");
        $7abce02e6e9dad1f$var$__publicField(this, "packAsQuad", false);
        $7abce02e6e9dad1f$var$__publicField(this, "renderable");
        $7abce02e6e9dad1f$var$__publicField(this, "positions");
        $7abce02e6e9dad1f$var$__publicField(this, "indices");
        $7abce02e6e9dad1f$var$__publicField(this, "uvs");
        $7abce02e6e9dad1f$var$__publicField(this, "roundPixels");
        $7abce02e6e9dad1f$var$__publicField(this, "data");
        $7abce02e6e9dad1f$var$__publicField(this, "blendMode");
        $7abce02e6e9dad1f$var$__publicField(this, "darkTint");
        $7abce02e6e9dad1f$var$__publicField(this, "texture");
        $7abce02e6e9dad1f$var$__publicField(this, "transform");
        // used internally by batcher specific..
        // stored for efficient updating..
        $7abce02e6e9dad1f$var$__publicField(this, "_textureId");
        $7abce02e6e9dad1f$var$__publicField(this, "_attributeStart");
        $7abce02e6e9dad1f$var$__publicField(this, "_indexStart");
        $7abce02e6e9dad1f$var$__publicField(this, "_batcher");
        $7abce02e6e9dad1f$var$__publicField(this, "_batch");
    }
    get color() {
        const slotColor = this.data.color;
        const parentColor = this.renderable.groupColor;
        const parentAlpha = this.renderable.groupAlpha;
        let abgr;
        const mixedA = slotColor.a * parentAlpha * 255;
        if (parentColor !== 16777215) {
            const parentB = parentColor >> 16 & 255;
            const parentG = parentColor >> 8 & 255;
            const parentR = parentColor & 255;
            const mixedR = slotColor.r * parentR;
            const mixedG = slotColor.g * parentG;
            const mixedB = slotColor.b * parentB;
            abgr = mixedA << 24 | mixedB << 16 | mixedG << 8 | mixedR;
        } else abgr = mixedA << 24 | slotColor.b * 255 << 16 | slotColor.g * 255 << 8 | slotColor.r * 255;
        return abgr;
    }
    get darkColor() {
        const darkColor = this.data.darkColor;
        return darkColor.b * 255 << 16 | darkColor.g * 255 << 8 | darkColor.r * 255;
    }
    get groupTransform() {
        return this.renderable.groupTransform;
    }
    setData(renderable, data, blendMode, roundPixels) {
        this.renderable = renderable;
        this.transform = renderable.groupTransform;
        this.data = data;
        if (data.clipped) {
            const clippedData = data.clippedData;
            this.indexSize = clippedData.indicesCount;
            this.attributeSize = clippedData.vertexCount;
            this.positions = clippedData.vertices;
            this.indices = clippedData.indices;
            this.uvs = clippedData.uvs;
        } else {
            this.indexSize = data.indices.length;
            this.attributeSize = data.vertices.length / 2;
            this.positions = data.vertices;
            this.indices = data.indices;
            this.uvs = data.uvs;
        }
        this.texture = data.texture;
        this.roundPixels = roundPixels;
        this.blendMode = blendMode;
        this.batcherName = data.darkTint ? "darkTint" : "default";
    }
}

});


parcelRegister("1ovqM", function(module, exports) {

$parcel$export(module.exports, "Spine", () => $32e04fc3af252013$export$ce0a100797286aea);
parcelRequire("iuB9z");
var $9Gm4h = parcelRequire("9Gm4h");
var $2IhKp = parcelRequire("2IhKp");
var $eicwU = parcelRequire("eicwU");
var $aWW4e = parcelRequire("aWW4e");
var $bLlTJ = parcelRequire("bLlTJ");
var $4J7WL = parcelRequire("4J7WL");
var $b9FQU = parcelRequire("b9FQU");
parcelRequire("6DlDK");
var $1RIMy = parcelRequire("1RIMy");
var $1LYJi = parcelRequire("1LYJi");
var $2mGUN = parcelRequire("2mGUN");
var $hePJB = parcelRequire("hePJB");
var $1Yup6 = parcelRequire("1Yup6");
var $5ot6H = parcelRequire("5ot6H");
var $5iLFL = parcelRequire("5iLFL");
var $8wKGy = parcelRequire("8wKGy");
var $d34nV = parcelRequire("d34nV");
var $yE81C = parcelRequire("yE81C");
var $kvLvw = parcelRequire("kvLvw");
var $d4Xjx = parcelRequire("d4Xjx");
var $ePHEE = parcelRequire("ePHEE");
var $32e04fc3af252013$var$__defProp = Object.defineProperty;
var $32e04fc3af252013$var$__defNormalProp = (obj, key, value)=>key in obj ? $32e04fc3af252013$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $32e04fc3af252013$var$__publicField = (obj, key, value)=>{
    $32e04fc3af252013$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $32e04fc3af252013$var$vectorAux = new (0, $1Yup6.Vector2)();
const $32e04fc3af252013$var$lightColor = new (0, $1Yup6.Color)();
const $32e04fc3af252013$var$darkColor = new (0, $1Yup6.Color)();
(0, $5iLFL.Skeleton).yDown = true;
const $32e04fc3af252013$var$clipper = new (0, $kvLvw.SkeletonClipping)();
class $32e04fc3af252013$export$ce0a100797286aea extends (0, $b9FQU.ViewContainer) {
    constructor(options){
        if (options instanceof (0, $d4Xjx.SkeletonData)) options = {
            skeletonData: options
        };
        super();
        // Pixi properties
        $32e04fc3af252013$var$__publicField(this, "batched", true);
        $32e04fc3af252013$var$__publicField(this, "buildId", 0);
        $32e04fc3af252013$var$__publicField(this, "renderPipeId", "spine");
        $32e04fc3af252013$var$__publicField(this, "_didSpineUpdate", false);
        $32e04fc3af252013$var$__publicField(this, "beforeUpdateWorldTransforms", ()=>{});
        $32e04fc3af252013$var$__publicField(this, "afterUpdateWorldTransforms", ()=>{});
        // Spine properties
        $32e04fc3af252013$var$__publicField(this, "skeleton");
        $32e04fc3af252013$var$__publicField(this, "state");
        $32e04fc3af252013$var$__publicField(this, "skeletonBounds");
        $32e04fc3af252013$var$__publicField(this, "_debug");
        $32e04fc3af252013$var$__publicField(this, "_slotsObject", /* @__PURE__ */ Object.create(null));
        $32e04fc3af252013$var$__publicField(this, "spineAttachmentsDirty", true);
        $32e04fc3af252013$var$__publicField(this, "spineTexturesDirty", true);
        $32e04fc3af252013$var$__publicField(this, "_lastAttachments");
        $32e04fc3af252013$var$__publicField(this, "_stateChanged", true);
        $32e04fc3af252013$var$__publicField(this, "attachmentCacheData", []);
        $32e04fc3af252013$var$__publicField(this, "autoUpdateWarned", false);
        $32e04fc3af252013$var$__publicField(this, "_autoUpdate", true);
        const skeletonData = options instanceof (0, $d4Xjx.SkeletonData) ? options : options.skeletonData;
        this.skeleton = new (0, $5iLFL.Skeleton)(skeletonData);
        this.state = new (0, $1RIMy.AnimationState)(new (0, $1LYJi.AnimationStateData)(skeletonData));
        this.autoUpdate = options?.autoUpdate ?? true;
        const slots = this.skeleton.slots;
        for(let i = 0; i < slots.length; i++)this.attachmentCacheData[i] = /* @__PURE__ */ Object.create(null);
        this._updateState(0);
    }
    getSlotFromRef(slotRef) {
        let slot;
        if (typeof slotRef === "number") slot = this.skeleton.slots[slotRef];
        else if (typeof slotRef === "string") slot = this.skeleton.findSlot(slotRef);
        else slot = slotRef;
        if (!slot) throw new Error(`No slot found with the given slot reference: ${slotRef}`);
        return slot;
    }
    get debug() {
        return this._debug;
    }
    set debug(value) {
        if (this._debug) this._debug.unregisterSpine(this);
        if (value) value.registerSpine(this);
        this._debug = value;
    }
    get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value) {
            (0, $4J7WL.Ticker).shared.add(this.internalUpdate, this);
            this.autoUpdateWarned = false;
        } else (0, $4J7WL.Ticker).shared.remove(this.internalUpdate, this);
        this._autoUpdate = value;
    }
    update(dt) {
        if (this.autoUpdate && !this.autoUpdateWarned) {
            console.warn(// eslint-disable-next-line max-len
            "You are calling update on a Spine instance that has autoUpdate set to true. This is probably not what you want.");
            this.autoUpdateWarned = true;
        }
        this.internalUpdate(0, dt);
    }
    internalUpdate(_deltaFrame, deltaSeconds) {
        this._updateState(deltaSeconds ?? (0, $4J7WL.Ticker).shared.deltaMS / 1e3);
    }
    get bounds() {
        if (this._boundsDirty) this.updateBounds();
        return this._bounds;
    }
    setBonePosition(bone, position) {
        const boneAux = bone;
        if (typeof bone === "string") bone = this.skeleton.findBone(bone);
        if (!bone) throw Error(`Cant set bone position, bone ${String(boneAux)} not found`);
        $32e04fc3af252013$var$vectorAux.set(position.x, position.y);
        if (bone.parent) {
            const aux = bone.parent.worldToLocal($32e04fc3af252013$var$vectorAux);
            bone.x = aux.x;
            bone.y = -aux.y;
        } else {
            bone.x = $32e04fc3af252013$var$vectorAux.x;
            bone.y = $32e04fc3af252013$var$vectorAux.y;
        }
    }
    getBonePosition(bone, outPos) {
        const boneAux = bone;
        if (typeof bone === "string") bone = this.skeleton.findBone(bone);
        if (!bone) {
            console.error(`Cant set bone position! Bone ${String(boneAux)} not found`);
            return outPos;
        }
        if (!outPos) outPos = {
            x: 0,
            y: 0
        };
        outPos.x = bone.worldX;
        outPos.y = bone.worldY;
        return outPos;
    }
    /**
   * Will update the state based on the specified time, this will not apply the state to the skeleton
   * as this is differed until the `applyState` method is called.
   *
   * @param time the time at which to set the state
   * @internal
   */ _updateState(time) {
        this.state.update(time);
        this.skeleton.update(time);
        this._stateChanged = true;
        this._boundsDirty = true;
        this.onViewUpdate();
    }
    /**
   * Applies the state to this spine instance.
   * - updates the state to the skeleton
   * - updates its world transform (spine world transform)
   * - validates the attachments - to flag if the attachments have changed this state
   * - transforms the attachments - to update the vertices of the attachments based on the new positions
   * - update the slot attachments - to update the position, rotation, scale, and visibility of the attached containers
   * @internal
   */ _applyState() {
        if (!this._stateChanged) return;
        this._stateChanged = false;
        const { skeleton: skeleton } = this;
        this.state.apply(skeleton);
        this.beforeUpdateWorldTransforms(this);
        skeleton.updateWorldTransform((0, $5iLFL.Physics).update);
        this.afterUpdateWorldTransforms(this);
        this.validateAttachments();
        this.transformAttachments();
        this.updateSlotObjects();
    }
    validateAttachments() {
        const currentDrawOrder = this.skeleton.drawOrder;
        const lastAttachments = this._lastAttachments || (this._lastAttachments = []);
        let index = 0;
        let spineAttachmentsDirty = false;
        for(let i = 0; i < currentDrawOrder.length; i++){
            const slot = currentDrawOrder[i];
            const attachment = slot.getAttachment();
            if (attachment) {
                if (attachment !== lastAttachments[index]) {
                    spineAttachmentsDirty = true;
                    lastAttachments[index] = attachment;
                }
                index++;
            }
        }
        if (index !== lastAttachments.length) {
            spineAttachmentsDirty = true;
            lastAttachments.length = index;
        }
        this.spineAttachmentsDirty = spineAttachmentsDirty;
    }
    transformAttachments() {
        const currentDrawOrder = this.skeleton.drawOrder;
        for(let i = 0; i < currentDrawOrder.length; i++){
            const slot = currentDrawOrder[i];
            const attachment = slot.getAttachment();
            if (attachment) {
                if (attachment instanceof (0, $5ot6H.MeshAttachment) || attachment instanceof (0, $8wKGy.RegionAttachment)) {
                    const cacheData = this._getCachedData(slot, attachment);
                    if (attachment instanceof (0, $8wKGy.RegionAttachment)) attachment.computeWorldVertices(slot, cacheData.vertices, 0, 2);
                    else attachment.computeWorldVertices(slot, 0, attachment.worldVerticesLength, cacheData.vertices, 0, 2);
                    cacheData.uvs = attachment.uvs;
                    const skeleton = slot.bone.skeleton;
                    const skeletonColor = skeleton.color;
                    const slotColor = slot.color;
                    const attachmentColor = attachment.color;
                    cacheData.color.set(skeletonColor.r * slotColor.r * attachmentColor.r, skeletonColor.g * slotColor.g * attachmentColor.g, skeletonColor.b * slotColor.b * attachmentColor.b, skeletonColor.a * slotColor.a * attachmentColor.a);
                    cacheData.darkTint = !!slot.darkColor;
                    if (slot.darkColor) cacheData.darkColor.setFromColor(slot.darkColor);
                    cacheData.skipRender = cacheData.clipped = false;
                    const texture = attachment.region?.texture.texture || (0, $bLlTJ.Texture).EMPTY;
                    if (cacheData.texture !== texture) {
                        cacheData.texture = texture;
                        this.spineTexturesDirty = true;
                    }
                    if ($32e04fc3af252013$var$clipper.isClipping()) this.updateClippingData(cacheData);
                } else if (attachment instanceof (0, $hePJB.ClippingAttachment)) {
                    $32e04fc3af252013$var$clipper.clipStart(slot, attachment);
                    continue;
                }
            }
            $32e04fc3af252013$var$clipper.clipEndWithSlot(slot);
        }
        $32e04fc3af252013$var$clipper.clipEnd();
    }
    updateClippingData(cacheData) {
        cacheData.clipped = true;
        $32e04fc3af252013$var$clipper.clipTriangles(cacheData.vertices, cacheData.vertices.length, cacheData.indices, cacheData.indices.length, cacheData.uvs, $32e04fc3af252013$var$lightColor, $32e04fc3af252013$var$darkColor, false);
        const { clippedVertices: clippedVertices, clippedTriangles: clippedTriangles } = $32e04fc3af252013$var$clipper;
        const verticesCount = clippedVertices.length / 8;
        const indicesCount = clippedTriangles.length;
        if (!cacheData.clippedData) {
            cacheData.clippedData = {
                vertices: new Float32Array(verticesCount * 2),
                uvs: new Float32Array(verticesCount * 2),
                vertexCount: verticesCount,
                indices: new Uint16Array(indicesCount),
                indicesCount: indicesCount
            };
            this.spineAttachmentsDirty = true;
        }
        const clippedData = cacheData.clippedData;
        const sizeChange = clippedData.vertexCount !== verticesCount || indicesCount !== clippedData.indicesCount;
        cacheData.skipRender = verticesCount === 0;
        if (sizeChange) {
            this.spineAttachmentsDirty = true;
            if (clippedData.vertexCount < verticesCount) {
                clippedData.vertices = new Float32Array(verticesCount * 2);
                clippedData.uvs = new Float32Array(verticesCount * 2);
            }
            if (clippedData.indices.length < indicesCount) clippedData.indices = new Uint16Array(indicesCount);
        }
        const { vertices: vertices, uvs: uvs, indices: indices } = clippedData;
        for(let i = 0; i < verticesCount; i++){
            vertices[i * 2] = clippedVertices[i * 8];
            vertices[i * 2 + 1] = clippedVertices[i * 8 + 1];
            uvs[i * 2] = clippedVertices[i * 8 + 6];
            uvs[i * 2 + 1] = clippedVertices[i * 8 + 7];
        }
        clippedData.vertexCount = verticesCount;
        for(let i = 0; i < indices.length; i++)indices[i] = clippedTriangles[i];
        clippedData.indicesCount = indicesCount;
    }
    /**
   * ensure that attached containers map correctly to their slots
   * along with their position, rotation, scale, and visibility.
   */ updateSlotObjects() {
        for(const i in this._slotsObject){
            const slotAttachment = this._slotsObject[i];
            if (!slotAttachment) continue;
            this.updateSlotObject(slotAttachment);
        }
    }
    updateSlotObject(slotAttachment) {
        const { slot: slot, container: container } = slotAttachment;
        container.visible = this.skeleton.drawOrder.includes(slot);
        if (container.visible) {
            const bone = slot.bone;
            container.position.set(bone.worldX, bone.worldY);
            container.scale.x = bone.getWorldScaleX();
            container.scale.y = bone.getWorldScaleY();
            container.rotation = bone.getWorldRotationX() * (0, $aWW4e.DEG_TO_RAD);
        }
    }
    /** @internal */ _getCachedData(slot, attachment) {
        return this.attachmentCacheData[slot.data.index][attachment.name] || this.initCachedData(slot, attachment);
    }
    initCachedData(slot, attachment) {
        let vertices;
        if (attachment instanceof (0, $8wKGy.RegionAttachment)) {
            vertices = new Float32Array(8);
            this.attachmentCacheData[slot.data.index][attachment.name] = {
                id: `${slot.data.index}-${attachment.name}`,
                vertices: vertices,
                clipped: false,
                indices: [
                    0,
                    1,
                    2,
                    0,
                    2,
                    3
                ],
                uvs: attachment.uvs,
                color: new (0, $1Yup6.Color)(1, 1, 1, 1),
                darkColor: new (0, $1Yup6.Color)(0, 0, 0, 0),
                darkTint: false,
                skipRender: false,
                texture: attachment.region?.texture.texture
            };
        } else {
            vertices = new Float32Array(attachment.worldVerticesLength);
            this.attachmentCacheData[slot.data.index][attachment.name] = {
                id: `${slot.data.index}-${attachment.name}`,
                vertices: vertices,
                clipped: false,
                indices: attachment.triangles,
                uvs: attachment.uvs,
                color: new (0, $1Yup6.Color)(1, 1, 1, 1),
                darkColor: new (0, $1Yup6.Color)(0, 0, 0, 0),
                darkTint: false,
                skipRender: false,
                texture: attachment.region?.texture.texture
            };
        }
        return this.attachmentCacheData[slot.data.index][attachment.name];
    }
    onViewUpdate() {
        this._didChangeId += 4096;
        this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
        this.debug?.renderDebug(this);
    }
    /**
   * Attaches a PixiJS container to a specified slot. This will map the world transform of the slots bone
   * to the attached container. A container can only be attached to one slot at a time.
   *
   * @param container - The container to attach to the slot
   * @param slotRef - The slot id or  slot to attach to
   */ addSlotObject(slot, container) {
        slot = this.getSlotFromRef(slot);
        for(const i in this._slotsObject)if (this._slotsObject[i]?.container === container) this.removeSlotObject(this._slotsObject[i].slot);
        this.removeSlotObject(slot);
        container.includeInBuild = false;
        this.addChild(container);
        this._slotsObject[slot.data.name] = {
            container: container,
            slot: slot
        };
        this.updateSlotObject(this._slotsObject[slot.data.name]);
    }
    /**
   * Removes a PixiJS container from the slot it is attached to.
   *
   * @param container - The container to detach from the slot
   * @param slotOrContainer - The container, slot id or slot to detach from
   */ removeSlotObject(slotOrContainer) {
        let containerToRemove;
        if (slotOrContainer instanceof (0, $eicwU.Container)) {
            for(const i in this._slotsObject)if (this._slotsObject[i]?.container === slotOrContainer) {
                this._slotsObject[i] = null;
                containerToRemove = slotOrContainer;
                break;
            }
        } else {
            const slot = this.getSlotFromRef(slotOrContainer);
            containerToRemove = this._slotsObject[slot.data.name]?.container;
            this._slotsObject[slot.data.name] = null;
        }
        if (containerToRemove) {
            this.removeChild(containerToRemove);
            containerToRemove.includeInBuild = true;
        }
    }
    /**
   * Returns a container attached to a slot, or undefined if no container is attached.
   *
   * @param slotRef - The slot id or slot to get the attachment from
   * @returns - The container attached to the slot
   */ getSlotObject(slot) {
        slot = this.getSlotFromRef(slot);
        return this._slotsObject[slot.data.name].container;
    }
    updateBounds() {
        this._boundsDirty = false;
        this.skeletonBounds || (this.skeletonBounds = new (0, $yE81C.SkeletonBounds)());
        const skeletonBounds = this.skeletonBounds;
        skeletonBounds.update(this.skeleton, true);
        if (skeletonBounds.minX === Infinity) {
            this._applyState();
            const drawOrder = this.skeleton.drawOrder;
            const bounds = this._bounds;
            bounds.clear();
            for(let i = 0; i < drawOrder.length; i++){
                const slot = drawOrder[i];
                const attachment = slot.getAttachment();
                if (attachment && (attachment instanceof (0, $8wKGy.RegionAttachment) || attachment instanceof (0, $5ot6H.MeshAttachment))) {
                    const cacheData = this._getCachedData(slot, attachment);
                    bounds.addVertexData(cacheData.vertices, 0, cacheData.vertices.length);
                }
            }
        } else {
            this._bounds.minX = skeletonBounds.minX;
            this._bounds.minY = skeletonBounds.minY;
            this._bounds.maxX = skeletonBounds.maxX;
            this._bounds.maxY = skeletonBounds.maxY;
        }
    }
    /** @internal */ addBounds(bounds) {
        bounds.addBounds(this.bounds);
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */ destroy(options = false) {
        super.destroy(options);
        (0, $4J7WL.Ticker).shared.remove(this.internalUpdate, this);
        this.state.clearListeners();
        this.debug = void 0;
        this.skeleton = null;
        this.state = null;
        this._slotsObject = null;
        this._lastAttachments = null;
        this.attachmentCacheData = null;
    }
    /** Converts a point from the skeleton coordinate system to the Pixi world coordinate system. */ skeletonToPixiWorldCoordinates(point) {
        this.worldTransform.apply(point, point);
    }
    /** Converts a point from the Pixi world coordinate system to the skeleton coordinate system. */ pixiWorldCoordinatesToSkeleton(point) {
        this.worldTransform.applyInverse(point, point);
    }
    /** Converts a point from the Pixi world coordinate system to the bone's local coordinate system. */ pixiWorldCoordinatesToBone(point, bone) {
        this.pixiWorldCoordinatesToSkeleton(point);
        if (bone.parent) bone.parent.worldToLocal(point);
        else bone.worldToLocal(point);
    }
    static from({ skeleton: skeleton, atlas: atlas, scale: scale = 1 }) {
        const cacheKey = `${skeleton}-${atlas}-${scale}`;
        if ((0, $2IhKp.Cache).has(cacheKey)) return new $32e04fc3af252013$export$ce0a100797286aea((0, $2IhKp.Cache).get(cacheKey));
        const skeletonAsset = (0, $9Gm4h.Assets).get(skeleton);
        const atlasAsset = (0, $9Gm4h.Assets).get(atlas);
        const attachmentLoader = new (0, $2mGUN.AtlasAttachmentLoader)(atlasAsset);
        const parser = skeletonAsset instanceof Uint8Array ? new (0, $d34nV.SkeletonBinary)(attachmentLoader) : new (0, $ePHEE.SkeletonJson)(attachmentLoader);
        parser.scale = scale;
        const skeletonData = parser.readSkeletonData(skeletonAsset);
        (0, $2IhKp.Cache).set(cacheKey, skeletonData);
        return new $32e04fc3af252013$export$ce0a100797286aea({
            skeletonData: skeletonData
        });
    }
}

});

parcelRegister("k9fTk", function(module, exports) {
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $gc0ip = parcelRequire("gc0ip");
parcelRequire("6DlDK");
var $hePJB = parcelRequire("hePJB");
var $5ot6H = parcelRequire("5ot6H");
var $46qOI = parcelRequire("46qOI");
var $8wKGy = parcelRequire("8wKGy");
var $yE81C = parcelRequire("yE81C");
var $5943ea0cb7c9f20f$var$__defProp = Object.defineProperty;
var $5943ea0cb7c9f20f$var$__defNormalProp = (obj, key, value)=>key in obj ? $5943ea0cb7c9f20f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5943ea0cb7c9f20f$var$__publicField = (obj, key, value)=>{
    $5943ea0cb7c9f20f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $5943ea0cb7c9f20f$export$e5d479851d866fc2 {
    constructor(){
        $5943ea0cb7c9f20f$var$__publicField(this, "registeredSpines", /* @__PURE__ */ new Map());
        $5943ea0cb7c9f20f$var$__publicField(this, "drawMeshHull", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "drawMeshTriangles", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "drawBones", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "drawPaths", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "drawBoundingBoxes", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "drawClipping", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "drawRegionAttachments", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "drawEvents", true);
        $5943ea0cb7c9f20f$var$__publicField(this, "lineWidth", 1);
        $5943ea0cb7c9f20f$var$__publicField(this, "regionAttachmentsColor", 30975);
        $5943ea0cb7c9f20f$var$__publicField(this, "meshHullColor", 30975);
        $5943ea0cb7c9f20f$var$__publicField(this, "meshTrianglesColor", 16763904);
        $5943ea0cb7c9f20f$var$__publicField(this, "clippingPolygonColor", 16711935);
        $5943ea0cb7c9f20f$var$__publicField(this, "boundingBoxesRectColor", 65280);
        $5943ea0cb7c9f20f$var$__publicField(this, "boundingBoxesPolygonColor", 65280);
        $5943ea0cb7c9f20f$var$__publicField(this, "boundingBoxesCircleColor", 65280);
        $5943ea0cb7c9f20f$var$__publicField(this, "pathsCurveColor", 16711680);
        $5943ea0cb7c9f20f$var$__publicField(this, "pathsLineColor", 16711935);
        $5943ea0cb7c9f20f$var$__publicField(this, "skeletonXYColor", 16711680);
        $5943ea0cb7c9f20f$var$__publicField(this, "bonesColor", 61132);
        $5943ea0cb7c9f20f$var$__publicField(this, "eventFontSize", 24);
        $5943ea0cb7c9f20f$var$__publicField(this, "eventFontColor", 0);
    }
    /**
   * The debug is attached by force to each spine object.
   * So we need to create it inside the spine when we get the first update
   */ registerSpine(spine) {
        if (this.registeredSpines.has(spine)) {
            console.warn("SpineDebugRenderer.registerSpine() - this spine is already registered!", spine);
            return;
        }
        const debugDisplayObjects = {
            parentDebugContainer: new (0, $eicwU.Container)(),
            bones: new (0, $eicwU.Container)(),
            skeletonXY: new (0, $3cebA.Graphics)(),
            regionAttachmentsShape: new (0, $3cebA.Graphics)(),
            meshTrianglesLine: new (0, $3cebA.Graphics)(),
            meshHullLine: new (0, $3cebA.Graphics)(),
            clippingPolygon: new (0, $3cebA.Graphics)(),
            boundingBoxesRect: new (0, $3cebA.Graphics)(),
            boundingBoxesCircle: new (0, $3cebA.Graphics)(),
            boundingBoxesPolygon: new (0, $3cebA.Graphics)(),
            pathsCurve: new (0, $3cebA.Graphics)(),
            pathsLine: new (0, $3cebA.Graphics)(),
            eventText: new (0, $eicwU.Container)(),
            eventCallback: {
                event: (_, event)=>{
                    if (this.drawEvents) {
                        const scale = Math.abs(spine.scale.x || spine.scale.y || 1);
                        const text = new (0, $gc0ip.Text)({
                            text: event.data.name,
                            style: {
                                fontSize: this.eventFontSize / scale,
                                fill: this.eventFontColor,
                                fontFamily: "monospace"
                            }
                        });
                        text.scale.x = Math.sign(spine.scale.x);
                        text.anchor.set(0.5);
                        debugDisplayObjects.eventText.addChild(text);
                        setTimeout(()=>{
                            if (!text.destroyed) text.destroy();
                        }, 250);
                    }
                }
            }
        };
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.bones);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.skeletonXY);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.regionAttachmentsShape);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.meshTrianglesLine);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.meshHullLine);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.clippingPolygon);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.boundingBoxesRect);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.boundingBoxesCircle);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.boundingBoxesPolygon);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.pathsCurve);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.pathsLine);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.eventText);
        debugDisplayObjects.parentDebugContainer.zIndex = 9999999;
        debugDisplayObjects.parentDebugContainer.accessibleChildren = false;
        debugDisplayObjects.parentDebugContainer.eventMode = "none";
        debugDisplayObjects.parentDebugContainer.interactiveChildren = false;
        spine.addChild(debugDisplayObjects.parentDebugContainer);
        spine.state.addListener(debugDisplayObjects.eventCallback);
        this.registeredSpines.set(spine, debugDisplayObjects);
    }
    renderDebug(spine) {
        if (!this.registeredSpines.has(spine)) this.registerSpine(spine);
        const debugDisplayObjects = this.registeredSpines.get(spine);
        if (!debugDisplayObjects) return;
        spine.addChild(debugDisplayObjects.parentDebugContainer);
        debugDisplayObjects.skeletonXY.clear();
        debugDisplayObjects.regionAttachmentsShape.clear();
        debugDisplayObjects.meshTrianglesLine.clear();
        debugDisplayObjects.meshHullLine.clear();
        debugDisplayObjects.clippingPolygon.clear();
        debugDisplayObjects.boundingBoxesRect.clear();
        debugDisplayObjects.boundingBoxesCircle.clear();
        debugDisplayObjects.boundingBoxesPolygon.clear();
        debugDisplayObjects.pathsCurve.clear();
        debugDisplayObjects.pathsLine.clear();
        for(let len = debugDisplayObjects.bones.children.length; len > 0; len--)debugDisplayObjects.bones.children[len - 1].destroy({
            children: true,
            texture: true,
            textureSource: true
        });
        const scale = Math.abs(spine.scale.x || spine.scale.y || 1);
        const lineWidth = this.lineWidth / scale;
        if (this.drawBones) this.drawBonesFunc(spine, debugDisplayObjects, lineWidth, scale);
        if (this.drawPaths) this.drawPathsFunc(spine, debugDisplayObjects, lineWidth);
        if (this.drawBoundingBoxes) this.drawBoundingBoxesFunc(spine, debugDisplayObjects, lineWidth);
        if (this.drawClipping) this.drawClippingFunc(spine, debugDisplayObjects, lineWidth);
        if (this.drawMeshHull || this.drawMeshTriangles) this.drawMeshHullAndMeshTriangles(spine, debugDisplayObjects, lineWidth);
        if (this.drawRegionAttachments) this.drawRegionAttachmentsFunc(spine, debugDisplayObjects, lineWidth);
        if (this.drawEvents) for (const child of debugDisplayObjects.eventText.children){
            child.alpha -= 0.05;
            child.y -= 2;
        }
    }
    drawBonesFunc(spine, debugDisplayObjects, lineWidth, scale) {
        const skeleton = spine.skeleton;
        const skeletonX = skeleton.x;
        const skeletonY = skeleton.y;
        const bones = skeleton.bones;
        debugDisplayObjects.skeletonXY.strokeStyle = {
            width: lineWidth,
            color: this.skeletonXYColor
        };
        for(let i = 0, len = bones.length; i < len; i++){
            const bone = bones[i];
            const boneLen = bone.data.length;
            const starX = skeletonX + bone.worldX;
            const starY = skeletonY + bone.worldY;
            const endX = skeletonX + boneLen * bone.a + bone.worldX;
            const endY = skeletonY + boneLen * bone.b + bone.worldY;
            if (bone.data.name === "root" || bone.data.parent === null) continue;
            const w = Math.abs(starX - endX);
            const h = Math.abs(starY - endY);
            const a2 = Math.pow(w, 2);
            const b = h;
            const b2 = Math.pow(h, 2);
            const c = Math.sqrt(a2 + b2);
            const c2 = Math.pow(c, 2);
            const rad = Math.PI / 180;
            const B = Math.acos((c2 + b2 - a2) / (2 * b * c)) || 0;
            if (c === 0) continue;
            const gp = new (0, $3cebA.Graphics)();
            debugDisplayObjects.bones.addChild(gp);
            const refRation = c / 50 / scale;
            gp.context.poly([
                0,
                0,
                0 - refRation,
                c - refRation * 3,
                0,
                c - refRation,
                0 + refRation,
                c - refRation * 3
            ]).fill(this.bonesColor);
            gp.x = starX;
            gp.y = starY;
            gp.pivot.y = c;
            let rotation = 0;
            if (starX < endX && starY < endY) rotation = -B + 180 * rad;
            else if (starX > endX && starY < endY) rotation = 180 * (rad + B);
            else if (starX > endX && starY > endY) rotation = -B;
            else if (starX < endX && starY > endY) rotation = B;
            else if (starY === endY && starX < endX) rotation = 90 * rad;
            else if (starY === endY && starX > endX) rotation = -90 * rad;
            else if (starX === endX && starY < endY) rotation = 180 * rad;
            else if (starX === endX && starY > endY) rotation = 0;
            gp.rotation = rotation;
            gp.circle(0, c, refRation * 1.2).fill({
                color: 0,
                alpha: 0.6
            }).stroke({
                width: lineWidth,
                color: this.skeletonXYColor
            });
        }
        const startDotSize = lineWidth * 3;
        debugDisplayObjects.skeletonXY.context.moveTo(skeletonX - startDotSize, skeletonY - startDotSize).lineTo(skeletonX + startDotSize, skeletonY + startDotSize).moveTo(skeletonX + startDotSize, skeletonY - startDotSize).lineTo(skeletonX - startDotSize, skeletonY + startDotSize).stroke();
    }
    drawRegionAttachmentsFunc(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            const attachment = slot.getAttachment();
            if (attachment === null || !(attachment instanceof (0, $8wKGy.RegionAttachment))) continue;
            const regionAttachment = attachment;
            const vertices = new Float32Array(8);
            regionAttachment.computeWorldVertices(slot, vertices, 0, 2);
            debugDisplayObjects.regionAttachmentsShape.poly(Array.from(vertices.slice(0, 8)));
        }
        debugDisplayObjects.regionAttachmentsShape.stroke({
            color: this.regionAttachmentsColor,
            width: lineWidth
        });
    }
    drawMeshHullAndMeshTriangles(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            if (!slot.bone.active) continue;
            const attachment = slot.getAttachment();
            if (attachment === null || !(attachment instanceof (0, $5ot6H.MeshAttachment))) continue;
            const meshAttachment = attachment;
            const vertices = new Float32Array(meshAttachment.worldVerticesLength);
            const triangles = meshAttachment.triangles;
            let hullLength = meshAttachment.hullLength;
            meshAttachment.computeWorldVertices(slot, 0, meshAttachment.worldVerticesLength, vertices, 0, 2);
            if (this.drawMeshTriangles) for(let i2 = 0, len2 = triangles.length; i2 < len2; i2 += 3){
                const v1 = triangles[i2] * 2;
                const v2 = triangles[i2 + 1] * 2;
                const v3 = triangles[i2 + 2] * 2;
                debugDisplayObjects.meshTrianglesLine.context.moveTo(vertices[v1], vertices[v1 + 1]).lineTo(vertices[v2], vertices[v2 + 1]).lineTo(vertices[v3], vertices[v3 + 1]);
            }
            if (this.drawMeshHull && hullLength > 0) {
                hullLength = (hullLength >> 1) * 2;
                let lastX = vertices[hullLength - 2];
                let lastY = vertices[hullLength - 1];
                for(let i2 = 0, len2 = hullLength; i2 < len2; i2 += 2){
                    const x = vertices[i2];
                    const y = vertices[i2 + 1];
                    debugDisplayObjects.meshHullLine.context.moveTo(x, y).lineTo(lastX, lastY);
                    lastX = x;
                    lastY = y;
                }
            }
        }
        debugDisplayObjects.meshHullLine.stroke({
            width: lineWidth,
            color: this.meshHullColor
        });
        debugDisplayObjects.meshTrianglesLine.stroke({
            width: lineWidth,
            color: this.meshTrianglesColor
        });
    }
    drawClippingFunc(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            if (!slot.bone.active) continue;
            const attachment = slot.getAttachment();
            if (attachment === null || !(attachment instanceof (0, $hePJB.ClippingAttachment))) continue;
            const clippingAttachment = attachment;
            const nn = clippingAttachment.worldVerticesLength;
            const world = new Float32Array(nn);
            clippingAttachment.computeWorldVertices(slot, 0, nn, world, 0, 2);
            debugDisplayObjects.clippingPolygon.poly(Array.from(world));
        }
        debugDisplayObjects.clippingPolygon.stroke({
            width: lineWidth,
            color: this.clippingPolygonColor,
            alpha: 1
        });
    }
    drawBoundingBoxesFunc(spine, debugDisplayObjects, lineWidth) {
        debugDisplayObjects.boundingBoxesRect.lineStyle(lineWidth, this.boundingBoxesRectColor, 5);
        const bounds = new (0, $yE81C.SkeletonBounds)();
        bounds.update(spine.skeleton, true);
        debugDisplayObjects.boundingBoxesRect.rect(bounds.minX, bounds.minY, bounds.getWidth(), bounds.getHeight()).stroke({
            width: lineWidth,
            color: this.boundingBoxesRectColor
        });
        const polygons = bounds.polygons;
        const drawPolygon = (polygonVertices, _offset, count)=>{
            if (count < 3) throw new Error("Polygon must contain at least 3 vertices");
            const paths = [];
            const dotSize = lineWidth * 2;
            for(let i = 0, len = polygonVertices.length; i < len; i += 2){
                const x1 = polygonVertices[i];
                const y1 = polygonVertices[i + 1];
                debugDisplayObjects.boundingBoxesCircle.beginFill(this.boundingBoxesCircleColor);
                debugDisplayObjects.boundingBoxesCircle.drawCircle(x1, y1, dotSize);
                debugDisplayObjects.boundingBoxesCircle.fill(0);
                paths.push(x1, y1);
            }
            debugDisplayObjects.boundingBoxesPolygon.poly(paths).fill({
                color: this.boundingBoxesPolygonColor,
                alpha: 0.1
            }).stroke({
                width: lineWidth,
                color: this.boundingBoxesPolygonColor
            });
        };
        for(let i = 0, len = polygons.length; i < len; i++){
            const polygon = polygons[i];
            drawPolygon(polygon, 0, polygon.length);
        }
    }
    drawPathsFunc(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            if (!slot.bone.active) continue;
            const attachment = slot.getAttachment();
            if (attachment === null || !(attachment instanceof (0, $46qOI.PathAttachment))) continue;
            const pathAttachment = attachment;
            let nn = pathAttachment.worldVerticesLength;
            const world = new Float32Array(nn);
            pathAttachment.computeWorldVertices(slot, 0, nn, world, 0, 2);
            let x1 = world[2];
            let y1 = world[3];
            let x2 = 0;
            let y2 = 0;
            if (pathAttachment.closed) {
                const cx1 = world[0];
                const cy1 = world[1];
                const cx2 = world[nn - 2];
                const cy2 = world[nn - 1];
                x2 = world[nn - 4];
                y2 = world[nn - 3];
                debugDisplayObjects.pathsCurve.moveTo(x1, y1);
                debugDisplayObjects.pathsCurve.bezierCurveTo(cx1, cy1, cx2, cy2, x2, y2);
                debugDisplayObjects.pathsLine.moveTo(x1, y1);
                debugDisplayObjects.pathsLine.lineTo(cx1, cy1);
                debugDisplayObjects.pathsLine.moveTo(x2, y2);
                debugDisplayObjects.pathsLine.lineTo(cx2, cy2);
            }
            nn -= 4;
            for(let ii = 4; ii < nn; ii += 6){
                const cx1 = world[ii];
                const cy1 = world[ii + 1];
                const cx2 = world[ii + 2];
                const cy2 = world[ii + 3];
                x2 = world[ii + 4];
                y2 = world[ii + 5];
                debugDisplayObjects.pathsCurve.moveTo(x1, y1);
                debugDisplayObjects.pathsCurve.bezierCurveTo(cx1, cy1, cx2, cy2, x2, y2);
                debugDisplayObjects.pathsLine.moveTo(x1, y1);
                debugDisplayObjects.pathsLine.lineTo(cx1, cy1);
                debugDisplayObjects.pathsLine.moveTo(x2, y2);
                debugDisplayObjects.pathsLine.lineTo(cx2, cy2);
                x1 = x2;
                y1 = y2;
            }
        }
        debugDisplayObjects.pathsCurve.stroke({
            width: lineWidth,
            color: this.pathsCurveColor
        });
        debugDisplayObjects.pathsLine.stroke({
            width: lineWidth,
            color: this.pathsLineColor
        });
    }
    unregisterSpine(spine) {
        if (!this.registeredSpines.has(spine)) console.warn("SpineDebugRenderer.unregisterSpine() - spine is not registered, can't unregister!", spine);
        const debugDisplayObjects = this.registeredSpines.get(spine);
        if (!debugDisplayObjects) return;
        spine.state.removeListener(debugDisplayObjects.eventCallback);
        debugDisplayObjects.parentDebugContainer.destroy({
            textureSource: true,
            children: true,
            texture: true
        });
        this.registeredSpines.delete(spine);
    }
}

});


parcelRegister("2Tywo", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.13.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
parcelRequire("logJB");
var $1ovqM = parcelRequire("1ovqM");

var $2Tywo = parcelRequire("2Tywo");
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $2Tywo = parcelRequire("2Tywo");
var $0cdfc2eaac330c87$var$_win, $0cdfc2eaac330c87$var$_doc, $0cdfc2eaac330c87$var$_docElement, $0cdfc2eaac330c87$var$_pluginInitted, $0cdfc2eaac330c87$var$_tempDiv, $0cdfc2eaac330c87$var$_tempDivStyler, $0cdfc2eaac330c87$var$_recentSetterPlugin, $0cdfc2eaac330c87$var$_reverting, $0cdfc2eaac330c87$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $0cdfc2eaac330c87$var$_transformProps = {}, $0cdfc2eaac330c87$var$_RAD2DEG = 180 / Math.PI, $0cdfc2eaac330c87$var$_DEG2RAD = Math.PI / 180, $0cdfc2eaac330c87$var$_atan2 = Math.atan2, $0cdfc2eaac330c87$var$_bigNum = 1e8, $0cdfc2eaac330c87$var$_capsExp = /([A-Z])/g, $0cdfc2eaac330c87$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $0cdfc2eaac330c87$var$_complexExp = /[\s,\(]\S/, $0cdfc2eaac330c87$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $0cdfc2eaac330c87$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$0cdfc2eaac330c87$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $0cdfc2eaac330c87$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $0cdfc2eaac330c87$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $0cdfc2eaac330c87$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $0cdfc2eaac330c87$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $0cdfc2eaac330c87$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_transformProp = "transform", $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin", $0cdfc2eaac330c87$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $0cdfc2eaac330c87$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $0cdfc2eaac330c87$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $0cdfc2eaac330c87$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $0cdfc2eaac330c87$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $0cdfc2eaac330c87$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $0cdfc2eaac330c87$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($0cdfc2eaac330c87$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($0cdfc2eaac330c87$var$_transformOriginProp, isNotCSS, "");
        }
        property = $0cdfc2eaac330c87$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $0cdfc2eaac330c87$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $0cdfc2eaac330c87$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $0cdfc2eaac330c87$var$_reverting();
        if ((!i || !i.isStart) && !style[$0cdfc2eaac330c87$var$_transformProp]) {
            $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$0cdfc2eaac330c87$var$_transformOriginProp]) {
                style[$0cdfc2eaac330c87$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $0cdfc2eaac330c87$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $0cdfc2eaac330c87$var$_revertStyle,
        save: $0cdfc2eaac330c87$var$_saveStyle
    };
    target._gsap || (0, $2Tywo.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $0cdfc2eaac330c87$var$_supports3D, $0cdfc2eaac330c87$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $0cdfc2eaac330c87$var$_doc.createElementNS ? $0cdfc2eaac330c87$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $0cdfc2eaac330c87$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $0cdfc2eaac330c87$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $0cdfc2eaac330c87$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $0cdfc2eaac330c87$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $0cdfc2eaac330c87$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $0cdfc2eaac330c87$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($0cdfc2eaac330c87$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $0cdfc2eaac330c87$var$_prefixes[i] : "") + property;
}, $0cdfc2eaac330c87$var$_initCore = function _initCore() {
    if ($0cdfc2eaac330c87$var$_windowExists() && window.document) {
        $0cdfc2eaac330c87$var$_win = window;
        $0cdfc2eaac330c87$var$_doc = $0cdfc2eaac330c87$var$_win.document;
        $0cdfc2eaac330c87$var$_docElement = $0cdfc2eaac330c87$var$_doc.documentElement;
        $0cdfc2eaac330c87$var$_tempDiv = $0cdfc2eaac330c87$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $0cdfc2eaac330c87$var$_tempDivStyler = $0cdfc2eaac330c87$export$a232bb0480ae674a("div");
        $0cdfc2eaac330c87$var$_transformProp = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b($0cdfc2eaac330c87$var$_transformProp);
        $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin";
        $0cdfc2eaac330c87$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $0cdfc2eaac330c87$var$_supports3D = !!$0cdfc2eaac330c87$export$8cbef5dd49a09c8b("perspective");
        $0cdfc2eaac330c87$var$_reverting = (0, $2Tywo.gsap).core.reverting;
        $0cdfc2eaac330c87$var$_pluginInitted = 1;
    }
}, $0cdfc2eaac330c87$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $0cdfc2eaac330c87$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $0cdfc2eaac330c87$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $0cdfc2eaac330c87$var$_docElement.removeChild(svg);
    return bbox;
}, $0cdfc2eaac330c87$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $0cdfc2eaac330c87$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $0cdfc2eaac330c87$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $0cdfc2eaac330c87$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $0cdfc2eaac330c87$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$0cdfc2eaac330c87$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp) property = $0cdfc2eaac330c87$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $0cdfc2eaac330c87$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $0cdfc2eaac330c87$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$0cdfc2eaac330c87$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $0cdfc2eaac330c87$var$_tempDiv.style, horizontal = $0cdfc2eaac330c87$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $0cdfc2eaac330c87$var$_nonConvertibleUnits[unit] || $0cdfc2eaac330c87$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($0cdfc2eaac330c87$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $2Tywo._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $0cdfc2eaac330c87$var$_doc || !parent.appendChild) parent = $0cdfc2eaac330c87$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $2Tywo._ticker).time && !cache.uncache) return (0, $2Tywo._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $0cdfc2eaac330c87$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$0cdfc2eaac330c87$var$_nonStandardLayouts[$0cdfc2eaac330c87$var$_getComputedProperty(parent, "display")] && (style.position = $0cdfc2eaac330c87$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($0cdfc2eaac330c87$var$_tempDiv);
            px = $0cdfc2eaac330c87$var$_tempDiv[measureProperty];
            parent.removeChild($0cdfc2eaac330c87$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $2Tywo._getCache)(parent);
            cache.time = (0, $2Tywo._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $2Tywo._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $0cdfc2eaac330c87$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore();
    if (property in $0cdfc2eaac330c87$var$_propertyAliases && property !== "transform") {
        property = $0cdfc2eaac330c87$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($0cdfc2eaac330c87$var$_transformProps[property] && property !== "transform") {
        value = $0cdfc2eaac330c87$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $0cdfc2eaac330c87$var$_firstTwoOnly($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $0cdfc2eaac330c87$var$_specialProps[property] && $0cdfc2eaac330c87$var$_specialProps[property](target, property, unit) || $0cdfc2eaac330c87$var$_getComputedProperty(target, property) || (0, $2Tywo._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $0cdfc2eaac330c87$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $0cdfc2eaac330c87$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $0cdfc2eaac330c87$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $0cdfc2eaac330c87$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $2Tywo.PropTween)(this._pt, target.style, prop, 0, 1, (0, $2Tywo._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $0cdfc2eaac330c87$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $0cdfc2eaac330c87$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $0cdfc2eaac330c87$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $2Tywo._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $2Tywo._numWithUnitExp)) || [];
    endValues = end.match((0, $2Tywo._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $2Tywo._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $2Tywo._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $2Tywo._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $2Tywo._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue;
    (0, $2Tywo._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $0cdfc2eaac330c87$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $0cdfc2eaac330c87$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $0cdfc2eaac330c87$var$_keywordToPercent[x] || x;
    split[1] = $0cdfc2eaac330c87$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $0cdfc2eaac330c87$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($0cdfc2eaac330c87$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $0cdfc2eaac330c87$var$_transformOriginProp : $0cdfc2eaac330c87$var$_transformProp;
                }
                $0cdfc2eaac330c87$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $0cdfc2eaac330c87$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$0cdfc2eaac330c87$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 0, $0cdfc2eaac330c87$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $0cdfc2eaac330c87$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $0cdfc2eaac330c87$var$_rotationalProperties = {}, $0cdfc2eaac330c87$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp);
    return $0cdfc2eaac330c87$var$_isNullTransform(matrixString) ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrixString.substr(7).match((0, $2Tywo._numExp)).map((0, $2Tywo._round));
}, $0cdfc2eaac330c87$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $2Tywo._getCache)(target), style = target.style, matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrix;
    } else if (matrix === $0cdfc2eaac330c87$var$_identity2DMatrix && !target.offsetParent && target !== $0cdfc2eaac330c87$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $0cdfc2eaac330c87$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $0cdfc2eaac330c87$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $0cdfc2eaac330c87$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $0cdfc2eaac330c87$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $0cdfc2eaac330c87$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$0cdfc2eaac330c87$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $0cdfc2eaac330c87$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $2Tywo.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$0cdfc2eaac330c87$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$0cdfc2eaac330c87$var$_transformProp] !== "none" ? cs[$0cdfc2eaac330c87$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $0cdfc2eaac330c87$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $0cdfc2eaac330c87$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $0cdfc2eaac330c87$var$_atan2(b, a) * $0cdfc2eaac330c87$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $0cdfc2eaac330c87$var$_atan2(c, d) * $0cdfc2eaac330c87$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $0cdfc2eaac330c87$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $0cdfc2eaac330c87$var$_atan2(a32, a33);
            rotationX = angle * $0cdfc2eaac330c87$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $0cdfc2eaac330c87$var$_atan2(-c, a33);
            rotationY = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $0cdfc2eaac330c87$var$_atan2(b, a);
            rotation = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $2Tywo._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $2Tywo._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $0cdfc2eaac330c87$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $0cdfc2eaac330c87$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$0cdfc2eaac330c87$var$_isNullTransform($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $2Tywo._round)(scaleX);
    cache.scaleY = (0, $2Tywo._round)(scaleY);
    cache.rotation = (0, $2Tywo._round)(rotation) + deg;
    cache.rotationX = (0, $2Tywo._round)(rotationX) + deg;
    cache.rotationY = (0, $2Tywo._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$0cdfc2eaac330c87$var$_transformOriginProp] = $0cdfc2eaac330c87$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $2Tywo._config).force3D;
    cache.renderTransform = cache.svg ? $0cdfc2eaac330c87$var$_renderSVGTransforms : $0cdfc2eaac330c87$var$_supports3D ? $0cdfc2eaac330c87$var$_renderCSSTransforms : $0cdfc2eaac330c87$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $0cdfc2eaac330c87$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$0cdfc2eaac330c87$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $2Tywo.getUnit)(start);
    return (0, $2Tywo._round)(parseFloat(start) + parseFloat($0cdfc2eaac330c87$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $0cdfc2eaac330c87$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $0cdfc2eaac330c87$var$_renderCSSTransforms(ratio, cache);
}, $0cdfc2eaac330c87$var$_zeroDeg = "0deg", $0cdfc2eaac330c87$var$_zeroPx = "0px", $0cdfc2eaac330c87$var$_endParenthesis = ") ", $0cdfc2eaac330c87$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg || rotationY !== $0cdfc2eaac330c87$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $0cdfc2eaac330c87$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $0cdfc2eaac330c87$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $0cdfc2eaac330c87$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $0cdfc2eaac330c87$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $0cdfc2eaac330c87$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $0cdfc2eaac330c87$var$_zeroPx) transforms += "perspective(" + transformPerspective + $0cdfc2eaac330c87$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $0cdfc2eaac330c87$var$_zeroPx || y !== $0cdfc2eaac330c87$var$_zeroPx || z !== $0cdfc2eaac330c87$var$_zeroPx) transforms += z !== $0cdfc2eaac330c87$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotation !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotate(" + rotation + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateY(" + rotationY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateX(" + rotationX + $0cdfc2eaac330c87$var$_endParenthesis;
    if (skewX !== $0cdfc2eaac330c87$var$_zeroDeg || skewY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $0cdfc2eaac330c87$var$_endParenthesis;
    target.style[$0cdfc2eaac330c87$var$_transformProp] = transforms || "translate(0, 0)";
}, $0cdfc2eaac330c87$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $0cdfc2eaac330c87$var$_DEG2RAD;
        skewX *= $0cdfc2eaac330c87$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $0cdfc2eaac330c87$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $2Tywo._round)(a11);
        a21 = (0, $2Tywo._round)(a21);
        a12 = (0, $2Tywo._round)(a12);
        a22 = (0, $2Tywo._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $0cdfc2eaac330c87$var$_convertToUnit(target, "x", x, "px");
        ty = $0cdfc2eaac330c87$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $2Tywo._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $2Tywo._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $2Tywo._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $2Tywo._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$0cdfc2eaac330c87$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $0cdfc2eaac330c87$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $2Tywo._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $0cdfc2eaac330c87$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, startNum, change, $0cdfc2eaac330c87$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $0cdfc2eaac330c87$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $0cdfc2eaac330c87$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$0cdfc2eaac330c87$var$_transformProp];
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        style[$0cdfc2eaac330c87$var$_transformProp] = startValue;
    }
    for(p in $0cdfc2eaac330c87$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $2Tywo.getUnit)(startValue);
            endUnit = (0, $2Tywo.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $0cdfc2eaac330c87$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $0cdfc2eaac330c87$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $2Tywo._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $0cdfc2eaac330c87$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $0cdfc2eaac330c87$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $0cdfc2eaac330c87$export$855822f522f18eef = {
    name: "css",
    register: $0cdfc2eaac330c87$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $0cdfc2eaac330c87$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $2Tywo._plugins)[p] && (0, $2Tywo._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $0cdfc2eaac330c87$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $2Tywo._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $2Tywo._colorExp).lastIndex = 0;
                if (!(0, $2Tywo._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $2Tywo.getUnit)(startValue);
                    endUnit = (0, $2Tywo.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $2Tywo._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $2Tywo._replaceRandom)(startValue));
                    (0, $2Tywo.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $2Tywo._config).units[p] || (0, $2Tywo.getUnit)($0cdfc2eaac330c87$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $0cdfc2eaac330c87$var$_get(target, p)); // can't work with relative values
                } else startValue = $0cdfc2eaac330c87$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $0cdfc2eaac330c87$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $0cdfc2eaac330c87$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $0cdfc2eaac330c87$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $0cdfc2eaac330c87$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $0cdfc2eaac330c87$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $0cdfc2eaac330c87$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $2Tywo.PropTween)(this._pt, style, $0cdfc2eaac330c87$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $2Tywo.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $2Tywo._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $0cdfc2eaac330c87$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($0cdfc2eaac330c87$var$_transformOriginProp, 0, style[$0cdfc2eaac330c87$var$_transformOriginProp]);
                        endValue = $0cdfc2eaac330c87$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, p, $0cdfc2eaac330c87$var$_firstTwoOnly(startValue), $0cdfc2eaac330c87$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $0cdfc2eaac330c87$var$_rotationalProperties) {
                        $0cdfc2eaac330c87$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $2Tywo._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $0cdfc2eaac330c87$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$0cdfc2eaac330c87$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $2Tywo.getUnit)(endValue) || (p in (0, $2Tywo._config).units ? (0, $2Tywo._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $2Tywo.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $2Tywo._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $0cdfc2eaac330c87$var$_renderRoundedCSSProp : $0cdfc2eaac330c87$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $2Tywo._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $0cdfc2eaac330c87$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $2Tywo._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$0cdfc2eaac330c87$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $0cdfc2eaac330c87$var$_get,
    aliases: $0cdfc2eaac330c87$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $0cdfc2eaac330c87$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp && (target._gsap.x || $0cdfc2eaac330c87$var$_get(target, "x")) ? plugin && $0cdfc2eaac330c87$var$_recentSetterPlugin === plugin ? property === "scale" ? $0cdfc2eaac330c87$var$_setterScale : $0cdfc2eaac330c87$var$_setterTransform : ($0cdfc2eaac330c87$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $0cdfc2eaac330c87$var$_setterScaleWithRender : $0cdfc2eaac330c87$var$_setterTransformWithRender) : target.style && !(0, $2Tywo._isUndefined)(target.style[property]) ? $0cdfc2eaac330c87$var$_setterCSSStyle : ~property.indexOf("-") ? $0cdfc2eaac330c87$var$_setterCSSProp : (0, $2Tywo._getSetter)(target, property);
    },
    core: {
        _removeProperty: $0cdfc2eaac330c87$var$_removeProperty,
        _getMatrix: $0cdfc2eaac330c87$var$_getMatrix
    }
};
(0, $2Tywo.gsap).utils.checkPrefix = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b;
(0, $2Tywo.gsap).core.getStyleSaver = $0cdfc2eaac330c87$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $2Tywo._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $0cdfc2eaac330c87$var$_transformProps[name] = 1;
    });
    (0, $2Tywo._forEachName)(rotation, function(name) {
        (0, $2Tywo._config).units[name] = "deg";
        $0cdfc2eaac330c87$var$_rotationalProperties[name] = 1;
    });
    $0cdfc2eaac330c87$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $2Tywo._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $0cdfc2eaac330c87$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $2Tywo._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $2Tywo._config).units[name] = "px";
});
(0, $2Tywo.gsap).registerPlugin($0cdfc2eaac330c87$export$855822f522f18eef);


var $357b3f2d5f2ec9d5$export$99ee26438460406a = (0, $2Tywo.gsap).registerPlugin((0, $0cdfc2eaac330c87$export$855822f522f18eef)) || (0, $2Tywo.gsap), // to protect from tree shaking
$357b3f2d5f2ec9d5$export$7b23975ad686bf91 = $357b3f2d5f2ec9d5$export$99ee26438460406a.core.Tween;


// Sound fading feature to a certain volume
// Sound Instance and Audio Sprite loading and playing
// Custom sound states
// This class provides a unified sound creation and usage experience
let $0849d58f9b8d07c3$export$9544d5bb712b01ea;
function $0849d58f9b8d07c3$export$7fbc60ba12697434(sound) {
    $0849d58f9b8d07c3$export$9544d5bb712b01ea = sound;
    return sound;
}
function $0849d58f9b8d07c3$export$8bedcca5bbd73999() {
    return $0849d58f9b8d07c3$export$9544d5bb712b01ea;
}


class $9691db0adb5f8436$export$ec91da630f36d5ea {
    /**
   * @param {AudioNode} destination - The audio node to use as the destination for the input AudioNode
   * @param {AudioNode} [source] - Optional output node, defaults to destination node. This is useful
   *        when creating filters which contains multiple AudioNode elements chained together.
   */ constructor(destination, source){
        this.init(destination, source);
    }
    /** Reinitialize */ init(destination, source) {
        this.destination = destination;
        this.source = source || destination;
    }
    /**
   * Connect to the destination.
   * @param {AudioNode} destination - The destination node to connect the output to
   */ connect(destination) {
        this.source?.connect(destination);
    }
    /** Completely disconnect filter from destination and source nodes. */ disconnect() {
        this.source?.disconnect();
    }
    /** Destroy the filter and don't use after this. */ destroy() {
        this.disconnect();
        this.destination = null;
        this.source = null;
    }
}


class $8f0798abc71e2ee2$export$60a770664ca75ef2 extends (0, $9691db0adb5f8436$export$ec91da630f36d5ea) {
    /** @param amount - The amount of distoration from 0 to 1. */ constructor(amount = 0){
        let distortion;
        if (!(0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
            distortion = audioContext.createWaveShaper();
        }
        super(distortion);
        this._distortion = distortion;
        this.amount = amount;
    }
    /** The amount of distortion to set. */ set amount(value) {
        this._amount = value;
        if ((0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) return;
        const scaledValue = value * 1e3;
        const samples = 44100;
        const curve = new Float32Array(samples);
        const deg = Math.PI / 180;
        let i = 0;
        let x;
        for(; i < samples; ++i){
            x = i * 2 / samples - 1;
            curve[i] = (3 + scaledValue) * x * 20 * deg / (Math.PI + scaledValue * Math.abs(x));
        }
        this._distortion.curve = curve;
        this._distortion.oversample = "4x";
    }
    get amount() {
        return this._amount;
    }
    destroy() {
        this._distortion = null;
        super.destroy();
    }
}




class $4bc14ac1ce344e43$export$5caed31a857b7191 {
    /**
   * Dezippering is removed in the future Web Audio API, instead
   * we use the `setValueAtTime` method, however, this is not available
   * in all environments (e.g., Android webview), so we fallback to the `value` setter.
   * @param param - AudioNode parameter object
   * @param value - Value to set
   * @return The value set
   */ static setParamValue(param, value) {
        if (param.setValueAtTime) {
            const context = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
            param.setValueAtTime(value, context.audioContext.currentTime);
        } else param.value = value;
        return value;
    }
}



const $62983a71f58345da$var$_EqualizerFilter = class extends (0, $9691db0adb5f8436$export$ec91da630f36d5ea) {
    /**
   * @param f32 - Default gain for 32 Hz
   * @param f64 - Default gain for 64 Hz
   * @param f125 - Default gain for 125 Hz
   * @param f250 - Default gain for 250 Hz
   * @param f500 - Default gain for 500 Hz
   * @param f1k - Default gain for 1000 Hz
   * @param f2k - Default gain for 2000 Hz
   * @param f4k - Default gain for 4000 Hz
   * @param f8k - Default gain for 8000 Hz
   * @param f16k - Default gain for 16000 Hz
   */ constructor(f32 = 0, f64 = 0, f125 = 0, f250 = 0, f500 = 0, f1k = 0, f2k = 0, f4k = 0, f8k = 0, f16k = 0){
        let bands = [];
        const equalizerBands = [
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F32,
                type: "lowshelf",
                gain: f32
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F64,
                type: "peaking",
                gain: f64
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F125,
                type: "peaking",
                gain: f125
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F250,
                type: "peaking",
                gain: f250
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F500,
                type: "peaking",
                gain: f500
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F1K,
                type: "peaking",
                gain: f1k
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F2K,
                type: "peaking",
                gain: f2k
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F4K,
                type: "peaking",
                gain: f4k
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F8K,
                type: "peaking",
                gain: f8k
            },
            {
                f: $62983a71f58345da$var$_EqualizerFilter.F16K,
                type: "highshelf",
                gain: f16k
            }
        ];
        if (!(0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) bands = equalizerBands.map((band)=>{
            const node = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context.audioContext.createBiquadFilter();
            node.type = band.type;
            (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(node.Q, 1);
            node.frequency.value = band.f;
            (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(node.gain, band.gain);
            return node;
        });
        super(bands[0], bands[bands.length - 1]);
        this.bands = bands;
        this.bandsMap = {};
        for(let i = 0; i < this.bands.length; i++){
            const node = this.bands[i];
            if (i > 0) this.bands[i - 1].connect(node);
            this.bandsMap[node.frequency.value] = node;
        }
    }
    /**
   * Set gain on a specific frequency.
   * @param frequency - The frequency, see EqualizerFilter.F* for bands
   * @param gain - Recommended -40 to 40.
   */ setGain(frequency, gain = 0) {
        if (!this.bandsMap[frequency]) throw new Error(`No band found for frequency ${frequency}`);
        (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(this.bandsMap[frequency].gain, gain);
    }
    /**
   * Get gain amount on a specific frequency.
   * @return The amount of gain set.
   */ getGain(frequency) {
        if (!this.bandsMap[frequency]) throw new Error(`No band found for frequency ${frequency}`);
        return this.bandsMap[frequency].gain.value;
    }
    /**
   * Gain at 32 Hz frequencey.
   * @default 0
   */ set f32(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F32, value);
    }
    get f32() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F32);
    }
    /**
   * Gain at 64 Hz frequencey.
   * @default 0
   */ set f64(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F64, value);
    }
    get f64() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F64);
    }
    /**
   * Gain at 125 Hz frequencey.
   * @default 0
   */ set f125(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F125, value);
    }
    get f125() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F125);
    }
    /**
   * Gain at 250 Hz frequencey.
   * @default 0
   */ set f250(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F250, value);
    }
    get f250() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F250);
    }
    /**
   * Gain at 500 Hz frequencey.
   * @default 0
   */ set f500(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F500, value);
    }
    get f500() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F500);
    }
    /**
   * Gain at 1 KHz frequencey.
   * @default 0
   */ set f1k(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F1K, value);
    }
    get f1k() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F1K);
    }
    /**
   * Gain at 2 KHz frequencey.
   * @default 0
   */ set f2k(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F2K, value);
    }
    get f2k() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F2K);
    }
    /**
   * Gain at 4 KHz frequencey.
   * @default 0
   */ set f4k(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F4K, value);
    }
    get f4k() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F4K);
    }
    /**
   * Gain at 8 KHz frequencey.
   * @default 0
   */ set f8k(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F8K, value);
    }
    get f8k() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F8K);
    }
    /**
   * Gain at 16 KHz frequencey.
   * @default 0
   */ set f16k(value) {
        this.setGain($62983a71f58345da$var$_EqualizerFilter.F16K, value);
    }
    get f16k() {
        return this.getGain($62983a71f58345da$var$_EqualizerFilter.F16K);
    }
    /** Reset all frequency bands to have gain of 0 */ reset() {
        this.bands.forEach((band)=>{
            (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(band.gain, 0);
        });
    }
    destroy() {
        this.bands.forEach((band)=>{
            band.disconnect();
        });
        this.bands = null;
        this.bandsMap = null;
    }
};
let $62983a71f58345da$export$da9588c63637d4bd = $62983a71f58345da$var$_EqualizerFilter;
/**
 * Band at 32 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F32 = 32;
/**
 * Band at 64 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F64 = 64;
/**
 * Band at 125 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F125 = 125;
/**
 * Band at 250 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F250 = 250;
/**
 * Band at 500 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F500 = 500;
/**
 * Band at 1000 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F1K = 1e3;
/**
 * Band at 2000 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F2K = 2e3;
/**
 * Band at 4000 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F4K = 4e3;
/**
 * Band at 8000 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F8K = 8e3;
/**
 * Band at 16000 Hz
 * @readonly
 */ $62983a71f58345da$export$da9588c63637d4bd.F16K = 16e3;





class $0d291636c50f2e96$export$6237f62c652e6374 extends (0, $9691db0adb5f8436$export$ec91da630f36d5ea) {
    constructor(){
        let merger;
        let splitter;
        if (!(0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
            splitter = audioContext.createChannelSplitter();
            merger = audioContext.createChannelMerger();
            merger.connect(splitter);
        }
        super(merger, splitter);
        this._merger = merger;
    }
    destroy() {
        this._merger?.disconnect();
        this._merger = null;
        super.destroy();
    }
}




class $ec5bf92581ae78a9$export$cbbc92373fb81e3b extends (0, $9691db0adb5f8436$export$ec91da630f36d5ea) {
    /**
   * @param seconds - Seconds for reverb
   * @param decay - The decay length
   * @param reverse - Reverse reverb
   */ constructor(seconds = 3, decay = 2, reverse = false){
        super(null);
        this._seconds = this._clamp(seconds, 1, 50);
        this._decay = this._clamp(decay, 0, 100);
        this._reverse = reverse;
        this._rebuild();
    }
    /**
   * Clamp a value
   * @param value
   * @param min - Minimum value
   * @param max - Maximum value
   * @return Clamped number
   */ _clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }
    /**
   * Length of reverb in seconds from 1 to 50
   * @default 3
   */ get seconds() {
        return this._seconds;
    }
    set seconds(seconds) {
        this._seconds = this._clamp(seconds, 1, 50);
        this._rebuild();
    }
    /**
   * Decay value from 0 to 100
   * @default 2
   */ get decay() {
        return this._decay;
    }
    set decay(decay) {
        this._decay = this._clamp(decay, 0, 100);
        this._rebuild();
    }
    /**
   * Reverse value from 0 to 1
   * @default false
   */ get reverse() {
        return this._reverse;
    }
    set reverse(reverse) {
        this._reverse = reverse;
        this._rebuild();
    }
    /**
   * Utility function for building an impulse response
   * from the module parameters.
   */ _rebuild() {
        if ((0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) return;
        const { audioContext: audioContext } = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
        const rate = audioContext.sampleRate;
        const length = rate * this._seconds;
        const impulse = audioContext.createBuffer(2, length, rate);
        const impulseL = impulse.getChannelData(0);
        const impulseR = impulse.getChannelData(1);
        let n;
        for(let i = 0; i < length; i++){
            n = this._reverse ? length - i : i;
            impulseL[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this._decay);
            impulseR[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this._decay);
        }
        const convolver = audioContext.createConvolver();
        convolver.buffer = impulse;
        this.init(convolver);
    }
}





class $033ffe8857b1091d$export$3f75220355fd576e extends (0, $9691db0adb5f8436$export$ec91da630f36d5ea) {
    /** @param pan - The amount of panning, -1 is left, 1 is right, 0 is centered. */ constructor(pan = 0){
        let stereo;
        let panner;
        let destination;
        if (!(0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
            if (audioContext.createStereoPanner) {
                stereo = audioContext.createStereoPanner();
                destination = stereo;
            } else {
                panner = audioContext.createPanner();
                panner.panningModel = "equalpower";
                destination = panner;
            }
        }
        super(destination);
        this._stereo = stereo;
        this._panner = panner;
        this.pan = pan;
    }
    /** Set the amount of panning, where -1 is left, 1 is right, and 0 is centered */ set pan(value) {
        this._pan = value;
        if (this._stereo) (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(this._stereo.pan, value);
        else if (this._panner) this._panner.setPosition(value, 0, 1 - Math.abs(value));
    }
    get pan() {
        return this._pan;
    }
    destroy() {
        super.destroy();
        this._stereo = null;
        this._panner = null;
    }
}




class $2b20c8ef91623759$export$a54bec6fd61dbe35 extends (0, $9691db0adb5f8436$export$ec91da630f36d5ea) {
    constructor(){
        let destination;
        let source;
        if (!(0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
            destination = audioContext.createMediaStreamDestination();
            source = audioContext.createMediaStreamSource(destination.stream);
        }
        super(destination, source);
        this._stream = destination?.stream;
    }
    get stream() {
        return this._stream;
    }
    destroy() {
        this._stream = null;
        super.destroy();
    }
}





class $daafef9912c9cf5b$export$e75cce85db5659f7 extends (0, $9691db0adb5f8436$export$ec91da630f36d5ea) {
    constructor(){
        let destination;
        let source;
        if (!(0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
            const lpf1 = audioContext.createBiquadFilter();
            const lpf2 = audioContext.createBiquadFilter();
            const hpf1 = audioContext.createBiquadFilter();
            const hpf2 = audioContext.createBiquadFilter();
            lpf1.type = "lowpass";
            (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(lpf1.frequency, 2e3);
            lpf2.type = "lowpass";
            (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(lpf2.frequency, 2e3);
            hpf1.type = "highpass";
            (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(hpf1.frequency, 500);
            hpf2.type = "highpass";
            (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(hpf2.frequency, 500);
            lpf1.connect(lpf2);
            lpf2.connect(hpf1);
            hpf1.connect(hpf2);
            destination = lpf1;
            source = hpf2;
        }
        super(destination, source);
    }
}




parcelRequire("iuB9z");
var $3vRz3 = parcelRequire("3vRz3");
class $fa41e941aefd0fd2$export$135605210c0a871c extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments);
        /** Current global speed from 0 to 1 */ this.speed = 1;
        /** Current muted status of the context */ this.muted = false;
        /** Current volume from 0 to 1  */ this.volume = 1;
        /** Current paused status */ this.paused = false;
    }
    /** Internal trigger when volume, mute or speed changes */ refresh() {
        this.emit("refresh");
    }
    /** Internal trigger paused changes */ refreshPaused() {
        this.emit("refreshPaused");
    }
    /**
   * HTML Audio does not support filters, this is non-functional API.
   */ get filters() {
        console.warn("HTML Audio does not support filters");
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    /**
   * HTML Audio does not support `audioContext`
   * @readonly
   * @type {AudioContext}
   */ get audioContext() {
        console.warn("HTML Audio does not support audioContext");
        return null;
    }
    /**
   * Toggles the muted state.
   * @return The current muted state.
   */ toggleMute() {
        this.muted = !this.muted;
        this.refresh();
        return this.muted;
    }
    /**
   * Toggles the paused state.
   * @return The current paused state.
   */ togglePause() {
        this.paused = !this.paused;
        this.refreshPaused();
        return this.paused;
    }
    /** Destroy and don't use after this */ destroy() {
        this.removeAllListeners();
    }
}


parcelRequire("iuB9z");
var $3vRz3 = parcelRequire("3vRz3");
var $4J7WL = parcelRequire("4J7WL");
let $7c943c3c78d2d741$var$id = 0;
const $7c943c3c78d2d741$var$_HTMLAudioInstance = class extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /** @param parent - Parent element */ constructor(parent){
        super();
        this.id = $7c943c3c78d2d741$var$id++;
        this.init(parent);
    }
    /**
   * Set a property by name, this makes it easy to chain values
   * @param name - Name of the property to set
   * @param value - Value to set property to
   */ set(name, value) {
        if (this[name] === void 0) throw new Error(`Property with name ${name} does not exist.`);
        else switch(name){
            case "speed":
                this.speed = value;
                break;
            case "volume":
                this.volume = value;
                break;
            case "paused":
                this.paused = value;
                break;
            case "loop":
                this.loop = value;
                break;
            case "muted":
                this.muted = value;
                break;
        }
        return this;
    }
    /** The current playback progress from 0 to 1. */ get progress() {
        const { currentTime: currentTime } = this._source;
        return currentTime / this._duration;
    }
    /** Pauses the sound. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /**
   * Reference: http://stackoverflow.com/a/40370077
   * @private
   */ _onPlay() {
        this._playing = true;
    }
    /**
   * Reference: http://stackoverflow.com/a/40370077
   * @private
   */ _onPause() {
        this._playing = false;
    }
    /**
   * Initialize the instance.
   * @param {htmlaudio.HTMLAudioMedia} media - Same as constructor
   */ init(media) {
        this._playing = false;
        this._duration = media.source.duration;
        const source = this._source = media.source.cloneNode(false);
        source.src = media.parent.url;
        source.onplay = this._onPlay.bind(this);
        source.onpause = this._onPause.bind(this);
        media.context.on("refresh", this.refresh, this);
        media.context.on("refreshPaused", this.refreshPaused, this);
        this._media = media;
    }
    /**
   * Stop the sound playing
   * @private
   */ _internalStop() {
        if (this._source && this._playing) {
            this._source.onended = null;
            this._source.pause();
        }
    }
    /** Stop the sound playing */ stop() {
        this._internalStop();
        if (this._source) this.emit("stop");
    }
    /** Set the instance speed from 0 to 1 */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
    }
    /** Get the set the volume for this instance from 0 to 1 */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** If the sound instance should loop playback */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** `true` if the sound is muted */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /**
   * HTML Audio does not support filters, this is non-functional API.
   */ get filters() {
        console.warn("HTML Audio does not support filters");
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    /** Call whenever the loop, speed or volume changes */ refresh() {
        const global = this._media.context;
        const sound = this._media.parent;
        this._source.loop = this._loop || sound.loop;
        const globalVolume = global.volume * (global.muted ? 0 : 1);
        const soundVolume = sound.volume * (sound.muted ? 0 : 1);
        const instanceVolume = this._volume * (this._muted ? 0 : 1);
        this._source.volume = instanceVolume * globalVolume * soundVolume;
        this._source.playbackRate = this._speed * global.speed * sound.speed;
    }
    /** Handle changes in paused state, either globally or sound or instance */ refreshPaused() {
        const global = this._media.context;
        const sound = this._media.parent;
        const pausedReal = this._paused || sound.paused || global.paused;
        if (pausedReal !== this._pausedReal) {
            this._pausedReal = pausedReal;
            if (pausedReal) {
                this._internalStop();
                this.emit("paused");
            } else {
                this.emit("resumed");
                this.play({
                    start: this._source.currentTime,
                    end: this._end,
                    volume: this._volume,
                    speed: this._speed,
                    loop: this._loop
                });
            }
            this.emit("pause", pausedReal);
        }
    }
    /** Start playing the sound/ */ play(options) {
        const { start: start, end: end, speed: speed, loop: loop, volume: volume, muted: muted } = options;
        if (end) console.assert(end > start, "End time is before start time");
        this._speed = speed;
        this._volume = volume;
        this._loop = !!loop;
        this._muted = muted;
        this.refresh();
        if (this.loop && end !== null) {
            console.warn('Looping not support when specifying an "end" time');
            this.loop = false;
        }
        this._start = start;
        this._end = end || this._duration;
        this._start = Math.max(0, this._start - $7c943c3c78d2d741$var$_HTMLAudioInstance.PADDING);
        this._end = Math.min(this._end + $7c943c3c78d2d741$var$_HTMLAudioInstance.PADDING, this._duration);
        this._source.onloadedmetadata = ()=>{
            if (this._source) {
                this._source.currentTime = start;
                this._source.onloadedmetadata = null;
                this.emit("progress", start / this._duration, this._duration);
                (0, $4J7WL.Ticker).shared.add(this._onUpdate, this);
            }
        };
        this._source.onended = this._onComplete.bind(this);
        this._source.play();
        this.emit("start");
    }
    /**
   * Handle time update on sound.
   * @private
   */ _onUpdate() {
        this.emit("progress", this.progress, this._duration);
        if (this._source.currentTime >= this._end && !this._source.loop) this._onComplete();
    }
    /**
   * Callback when completed.
   * @private
   */ _onComplete() {
        (0, $4J7WL.Ticker).shared.remove(this._onUpdate, this);
        this._internalStop();
        this.emit("progress", 1, this._duration);
        this.emit("end", this);
    }
    /** Don't use after this. */ destroy() {
        (0, $4J7WL.Ticker).shared.remove(this._onUpdate, this);
        this.removeAllListeners();
        const source = this._source;
        if (source) {
            source.onended = null;
            source.onplay = null;
            source.onpause = null;
            this._internalStop();
        }
        this._source = null;
        this._speed = 1;
        this._volume = 1;
        this._loop = false;
        this._end = null;
        this._start = 0;
        this._duration = 0;
        this._playing = false;
        this._pausedReal = false;
        this._paused = false;
        this._muted = false;
        if (this._media) {
            this._media.context.off("refresh", this.refresh, this);
            this._media.context.off("refreshPaused", this.refreshPaused, this);
            this._media = null;
        }
    }
    /**
   * To string method for instance.
   * @return The string representation of instance.
   */ toString() {
        return `[HTMLAudioInstance id=${this.id}]`;
    }
};
let $7c943c3c78d2d741$export$5ba2228815fb4afb = $7c943c3c78d2d741$var$_HTMLAudioInstance;
/** Extra padding, in seconds, to deal with low-latecy of HTMLAudio. */ $7c943c3c78d2d741$export$5ba2228815fb4afb.PADDING = 0.1;


parcelRequire("iuB9z");
var $3vRz3 = parcelRequire("3vRz3");

class $f6abf5687674e657$export$e5eedbe48857dcd extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    init(parent) {
        this.parent = parent;
        this._source = parent.options.source || new Audio();
        if (parent.url) this._source.src = parent.url;
    }
    // Implement create
    create() {
        return new (0, $7c943c3c78d2d741$export$5ba2228815fb4afb)(this);
    }
    /**
   * If the audio media is playable (ready).
   * @readonly
   */ get isPlayable() {
        return !!this._source && this._source.readyState === 4;
    }
    /**
   * THe duration of the media in seconds.
   * @readonly
   */ get duration() {
        return this._source.duration;
    }
    /**
   * Reference to the context.
   * @readonly
   */ get context() {
        return this.parent.context;
    }
    /** The collection of filters, does not apply to HTML Audio. */ get filters() {
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    // Override the destroy
    destroy() {
        this.removeAllListeners();
        this.parent = null;
        if (this._source) {
            this._source.src = "";
            this._source.load();
            this._source = null;
        }
    }
    /**
   * Get the audio source element.
   * @type {HTMLAudioElement}
   * @readonly
   */ get source() {
        return this._source;
    }
    // Implement the method to being preloading
    load(callback) {
        const source = this._source;
        const sound = this.parent;
        if (source.readyState === 4) {
            sound.isLoaded = true;
            const instance = sound.autoPlayStart();
            if (callback) setTimeout(()=>{
                callback(null, sound, instance);
            }, 0);
            return;
        }
        if (!sound.url) {
            callback(new Error("sound.url or sound.source must be set"));
            return;
        }
        source.src = sound.url;
        const onLoad = ()=>{
            removeListeners();
            sound.isLoaded = true;
            const instance = sound.autoPlayStart();
            if (callback) callback(null, sound, instance);
        };
        const onAbort = ()=>{
            removeListeners();
            if (callback) callback(new Error("Sound loading has been aborted"));
        };
        const onError = ()=>{
            removeListeners();
            const message = `Failed to load audio element (code: ${source.error.code})`;
            if (callback) callback(new Error(message));
            else console.error(message);
        };
        const removeListeners = ()=>{
            source.removeEventListener("canplaythrough", onLoad);
            source.removeEventListener("load", onLoad);
            source.removeEventListener("abort", onAbort);
            source.removeEventListener("error", onError);
        };
        source.addEventListener("canplaythrough", onLoad, false);
        source.addEventListener("load", onLoad, false);
        source.addEventListener("abort", onAbort, false);
        source.addEventListener("error", onError, false);
        source.load();
    }
}






parcelRequire("iuB9z");
var $lzfZe = parcelRequire("lzfZe");


class $126746c90b5a7d5e$export$fae5af5bab2ccf8 {
    /**
   * @param parent - The parent sound
   * @param options - Data associated with object.
   */ constructor(parent, options){
        this.parent = parent;
        Object.assign(this, options);
        this.duration = this.end - this.start;
        console.assert(this.duration > 0, "End time must be after start time");
    }
    /**
   * Play the sound sprite.
   * @param {Function} [complete] - Function call when complete
   * @return Sound instance being played.
   */ play(complete) {
        return this.parent.play({
            complete: complete,
            speed: this.speed || this.parent.speed,
            end: this.end,
            start: this.start,
            loop: this.loop
        });
    }
    /** Destroy and don't use after this */ destroy() {
        this.parent = null;
    }
}


const $dc5147c44338cd30$export$cc3e2d3244e01b7f = [
    "ogg",
    "oga",
    "opus",
    "m4a",
    "mp3",
    "mpeg",
    "wav",
    "aiff",
    "wma",
    "mid",
    "caf"
];
const $dc5147c44338cd30$export$8114c8bcb5760e77 = [
    "audio/mpeg",
    "audio/ogg"
];
const $dc5147c44338cd30$export$5f747a46dc0eb6ee = {};
function $dc5147c44338cd30$export$ca906cd9daab0e17(typeOverrides) {
    const overrides = {
        m4a: "audio/mp4",
        oga: "audio/ogg",
        opus: 'audio/ogg; codecs="opus"',
        caf: 'audio/x-caf; codecs="opus"',
        ...typeOverrides || {}
    };
    const audio = document.createElement("audio");
    const formats = {};
    const no = /^no$/;
    $dc5147c44338cd30$export$cc3e2d3244e01b7f.forEach((ext)=>{
        const canByExt = audio.canPlayType(`audio/${ext}`).replace(no, "");
        const canByType = overrides[ext] ? audio.canPlayType(overrides[ext]).replace(no, "") : "";
        formats[ext] = !!canByExt || !!canByType;
    });
    Object.assign($dc5147c44338cd30$export$5f747a46dc0eb6ee, formats);
}
$dc5147c44338cd30$export$ca906cd9daab0e17();


parcelRequire("iuB9z");
var $iCGeI = parcelRequire("iCGeI");
parcelRequire("iuB9z");
var $3vRz3 = parcelRequire("3vRz3");
var $4J7WL = parcelRequire("4J7WL");

let $2f1571a342edec8a$var$id = 0;
class $2f1571a342edec8a$export$2af5ef044257da25 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(media){
        super();
        this.id = $2f1571a342edec8a$var$id++;
        this._media = null;
        this._paused = false;
        this._muted = false;
        this._elapsed = 0;
        this.init(media);
    }
    /**
   * Set a property by name, this makes it easy to chain values
   * @param name - Name of the property to set.
   * @param value - Value to set property to.
   */ set(name, value) {
        if (this[name] === void 0) throw new Error(`Property with name ${name} does not exist.`);
        else switch(name){
            case "speed":
                this.speed = value;
                break;
            case "volume":
                this.volume = value;
                break;
            case "muted":
                this.muted = value;
                break;
            case "loop":
                this.loop = value;
                break;
            case "paused":
                this.paused = value;
                break;
        }
        return this;
    }
    /** Stops the instance, don't use after this. */ stop() {
        if (this._source) {
            this._internalStop();
            this.emit("stop");
        }
    }
    /** Set the instance speed from 0 to 1 */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
        this._update(true);
    }
    /** Get the set the volume for this instance from 0 to 1 */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** `true` if the sound is muted */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /** If the sound instance should loop playback */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** The collection of filters. */ get filters() {
        return this._filters;
    }
    set filters(filters) {
        if (this._filters) {
            this._filters?.filter((filter)=>filter).forEach((filter)=>filter.disconnect());
            this._filters = null;
            this._source.connect(this._gain);
        }
        this._filters = filters?.length ? filters.slice(0) : null;
        this.refresh();
    }
    /** Refresh loop, volume and speed based on changes to parent */ refresh() {
        if (!this._source) return;
        const global = this._media.context;
        const sound = this._media.parent;
        this._source.loop = this._loop || sound.loop;
        const globalVolume = global.volume * (global.muted ? 0 : 1);
        const soundVolume = sound.volume * (sound.muted ? 0 : 1);
        const instanceVolume = this._volume * (this._muted ? 0 : 1);
        (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(this._gain.gain, instanceVolume * soundVolume * globalVolume);
        (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(this._source.playbackRate, this._speed * sound.speed * global.speed);
        this.applyFilters();
    }
    /** Connect filters nodes to audio context */ applyFilters() {
        if (this._filters?.length) {
            this._source.disconnect();
            let source = this._source;
            this._filters.forEach((filter)=>{
                source.connect(filter.destination);
                source = filter;
            });
            source.connect(this._gain);
        }
    }
    /** Handle changes in paused state, either globally or sound or instance */ refreshPaused() {
        const global = this._media.context;
        const sound = this._media.parent;
        const pausedReal = this._paused || sound.paused || global.paused;
        if (pausedReal !== this._pausedReal) {
            this._pausedReal = pausedReal;
            if (pausedReal) {
                this._internalStop();
                this.emit("paused");
            } else {
                this.emit("resumed");
                this.play({
                    start: this._elapsed % this._duration,
                    end: this._end,
                    speed: this._speed,
                    loop: this._loop,
                    volume: this._volume
                });
            }
            this.emit("pause", pausedReal);
        }
    }
    /**
   * Plays the sound.
   * @param options - Play options.
   */ play(options) {
        const { start: start, end: end, speed: speed, loop: loop, volume: volume, muted: muted, filters: filters } = options;
        if (end) console.assert(end > start, "End time is before start time");
        this._paused = false;
        const { source: source, gain: gain } = this._media.nodes.cloneBufferSource();
        this._source = source;
        this._gain = gain;
        this._speed = speed;
        this._volume = volume;
        this._loop = !!loop;
        this._muted = muted;
        this._filters = filters;
        this.refresh();
        const duration = this._source.buffer.duration;
        this._duration = duration;
        this._end = end;
        this._lastUpdate = this._now();
        this._elapsed = start;
        this._source.onended = this._onComplete.bind(this);
        if (this._loop) {
            this._source.loopEnd = end;
            this._source.loopStart = start;
            this._source.start(0, start);
        } else if (end) this._source.start(0, start, end - start);
        else this._source.start(0, start);
        this.emit("start");
        this._update(true);
        this.enableTicker(true);
    }
    /** Start the update progress. */ enableTicker(enabled) {
        (0, $4J7WL.Ticker).shared.remove(this._updateListener, this);
        if (enabled) (0, $4J7WL.Ticker).shared.add(this._updateListener, this);
    }
    /** The current playback progress from 0 to 1. */ get progress() {
        return this._progress;
    }
    /** Pauses the sound. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /** Don't use after this. */ destroy() {
        this.removeAllListeners();
        this._internalStop();
        if (this._gain) {
            this._gain.disconnect();
            this._gain = null;
        }
        if (this._media) {
            this._media.context.events.off("refresh", this.refresh, this);
            this._media.context.events.off("refreshPaused", this.refreshPaused, this);
            this._media = null;
        }
        this._filters?.forEach((filter)=>filter.disconnect());
        this._filters = null;
        this._end = null;
        this._speed = 1;
        this._volume = 1;
        this._loop = false;
        this._elapsed = 0;
        this._duration = 0;
        this._paused = false;
        this._muted = false;
        this._pausedReal = false;
    }
    /**
   * To string method for instance.
   * @return The string representation of instance.
   */ toString() {
        return `[WebAudioInstance id=${this.id}]`;
    }
    /**
   * Get the current time in seconds.
   * @return Seconds since start of context
   */ _now() {
        return this._media.context.audioContext.currentTime;
    }
    /** Callback for update listener */ _updateListener() {
        this._update();
    }
    /** Internal update the progress. */ _update(force = false) {
        if (this._source) {
            const now = this._now();
            const delta = now - this._lastUpdate;
            if (delta > 0 || force) {
                const speed = this._source.playbackRate.value;
                this._elapsed += delta * speed;
                this._lastUpdate = now;
                const duration = this._duration;
                let progress;
                if (this._source.loopStart) {
                    const soundLength = this._source.loopEnd - this._source.loopStart;
                    progress = (this._source.loopStart + this._elapsed % soundLength) / duration;
                } else progress = this._elapsed % duration / duration;
                this._progress = progress;
                this.emit("progress", this._progress, duration);
            }
        }
    }
    /** Initializes the instance. */ init(media) {
        this._media = media;
        media.context.events.on("refresh", this.refresh, this);
        media.context.events.on("refreshPaused", this.refreshPaused, this);
    }
    /** Stops the instance. */ _internalStop() {
        if (this._source) {
            this.enableTicker(false);
            this._source.onended = null;
            this._source.stop(0);
            this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (err) {
                console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
            }
            this._source = null;
        }
    }
    /** Callback when completed. */ _onComplete() {
        if (this._source) {
            this.enableTicker(false);
            this._source.onended = null;
            this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (err) {
                console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
            }
        }
        this._source = null;
        this._progress = 1;
        this.emit("progress", 1, this._duration);
        this.emit("end", this);
    }
}


class $1a83c23817070e16$export$d00e1c48fb621173 {
    /**
   * @param input - The source audio node
   * @param output - The output audio node
   */ constructor(input, output){
        this._output = output;
        this._input = input;
    }
    /** The destination output audio node */ get destination() {
        return this._input;
    }
    /** The collection of filters. */ get filters() {
        return this._filters;
    }
    set filters(filters) {
        if (this._filters) {
            this._filters.forEach((filter)=>{
                if (filter) filter.disconnect();
            });
            this._filters = null;
            this._input.connect(this._output);
        }
        if (filters && filters.length) {
            this._filters = filters.slice(0);
            this._input.disconnect();
            let prevFilter = null;
            filters.forEach((filter)=>{
                if (prevFilter === null) this._input.connect(filter.destination);
                else prevFilter.connect(filter.destination);
                prevFilter = filter;
            });
            prevFilter.connect(this._output);
        }
    }
    /** Cleans up. */ destroy() {
        this.filters = null;
        this._input = null;
        this._output = null;
    }
}



const $a148dea50f15b9fe$var$_WebAudioNodes = class extends (0, $1a83c23817070e16$export$d00e1c48fb621173) {
    /**
   * @param context - The audio context.
   */ constructor(context){
        const audioContext = context.audioContext;
        const bufferSource = audioContext.createBufferSource();
        const gain = audioContext.createGain();
        const analyser = audioContext.createAnalyser();
        bufferSource.connect(analyser);
        analyser.connect(gain);
        gain.connect(context.destination);
        super(analyser, gain);
        this.context = context;
        this.bufferSource = bufferSource;
        this.gain = gain;
        this.analyser = analyser;
    }
    /**
   * Get the script processor node.
   * @readonly
   */ get script() {
        if (!this._script) {
            this._script = this.context.audioContext.createScriptProcessor($a148dea50f15b9fe$var$_WebAudioNodes.BUFFER_SIZE);
            this._script.connect(this.context.destination);
        }
        return this._script;
    }
    /** Cleans up. */ destroy() {
        super.destroy();
        this.bufferSource.disconnect();
        if (this._script) this._script.disconnect();
        this.gain.disconnect();
        this.analyser.disconnect();
        this.bufferSource = null;
        this._script = null;
        this.gain = null;
        this.analyser = null;
        this.context = null;
    }
    /**
   * Clones the bufferSource. Used just before playing a sound.
   * @returns {SourceClone} The clone AudioBufferSourceNode.
   */ cloneBufferSource() {
        const orig = this.bufferSource;
        const source = this.context.audioContext.createBufferSource();
        source.buffer = orig.buffer;
        (0, $4bc14ac1ce344e43$export$5caed31a857b7191).setParamValue(source.playbackRate, orig.playbackRate.value);
        source.loop = orig.loop;
        const gain = this.context.audioContext.createGain();
        source.connect(gain);
        gain.connect(this.destination);
        return {
            source: source,
            gain: gain
        };
    }
    /**
   * Get buffer size of `ScriptProcessorNode`.
   * @readonly
   */ get bufferSize() {
        return this.script.bufferSize;
    }
};
let $a148dea50f15b9fe$export$b248c21a702795c4 = $a148dea50f15b9fe$var$_WebAudioNodes;
/**
 * The buffer size for script processor, default is `0` which auto-detects. If you plan to use
 * script node on iOS, you'll need to provide a non-zero amount.
 * @default 0
 */ $a148dea50f15b9fe$export$b248c21a702795c4.BUFFER_SIZE = 0;


class $eff32f4d75ee76d4$export$9ea3865f5a7f2b06 {
    /**
   * Re-initialize without constructing.
   * @param parent - - Instance of parent Sound container
   */ init(parent) {
        this.parent = parent;
        this._nodes = new (0, $a148dea50f15b9fe$export$b248c21a702795c4)(this.context);
        this._source = this._nodes.bufferSource;
        this.source = parent.options.source;
    }
    /** Destructor, safer to use `SoundLibrary.remove(alias)` to remove this sound. */ destroy() {
        this.parent = null;
        this._nodes.destroy();
        this._nodes = null;
        try {
            this._source.buffer = null;
        } catch (err) {
            console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
        }
        this._source = null;
        this.source = null;
    }
    // Implement create
    create() {
        return new (0, $2f1571a342edec8a$export$2af5ef044257da25)(this);
    }
    // Implement context
    get context() {
        return this.parent.context;
    }
    // Implement isPlayable
    get isPlayable() {
        return !!this._source && !!this._source.buffer;
    }
    // Implement filters
    get filters() {
        return this._nodes.filters;
    }
    set filters(filters) {
        this._nodes.filters = filters;
    }
    // Implements duration
    get duration() {
        console.assert(this.isPlayable, "Sound not yet playable, no duration");
        return this._source.buffer.duration;
    }
    /** Gets and sets the buffer. */ get buffer() {
        return this._source.buffer;
    }
    set buffer(buffer) {
        this._source.buffer = buffer;
    }
    /** Get the current chained nodes object */ get nodes() {
        return this._nodes;
    }
    // Implements load
    load(callback) {
        if (this.source) this._decode(this.source, callback);
        else if (this.parent.url) this._loadUrl(callback);
        else if (callback) callback(new Error("sound.url or sound.source must be set"));
        else console.error("sound.url or sound.source must be set");
    }
    /** Loads a sound using XHMLHttpRequest object. */ async _loadUrl(callback) {
        const url = this.parent.url;
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        this._decode(await response.arrayBuffer(), callback);
    }
    /**
   * Decodes the array buffer.
   * @param arrayBuffer - From load.
   * @param {Function} callback - Callback optional
   */ _decode(arrayBuffer, callback) {
        const audioBufferReadyFn = (err, buffer)=>{
            if (err) {
                if (callback) callback(err);
            } else {
                this.parent.isLoaded = true;
                this.buffer = buffer;
                const instance = this.parent.autoPlayStart();
                if (callback) callback(null, this.parent, instance);
            }
        };
        if (arrayBuffer instanceof AudioBuffer) audioBufferReadyFn(null, arrayBuffer);
        else {
            const context = this.parent.context;
            context.decode(arrayBuffer, audioBufferReadyFn);
        }
    }
}


const $87165ad660797c67$var$_Sound = class {
    /**
   * Create a new sound instance from source.
   * @param source - Either the path or url to the source file.
   *        or the object of options to use.
   * @return Created sound instance.
   */ static from(source) {
        let options = {};
        if (typeof source === "string") options.url = source;
        else if (source instanceof ArrayBuffer || source instanceof AudioBuffer || source instanceof HTMLAudioElement) options.source = source;
        else if (Array.isArray(source)) options.url = source;
        else options = source;
        options = {
            autoPlay: false,
            singleInstance: false,
            url: null,
            source: null,
            preload: false,
            volume: 1,
            speed: 1,
            complete: null,
            loaded: null,
            loop: false,
            ...options
        };
        Object.freeze(options);
        const media = (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().useLegacy ? new (0, $f6abf5687674e657$export$e5eedbe48857dcd)() : new (0, $eff32f4d75ee76d4$export$9ea3865f5a7f2b06)();
        return new $87165ad660797c67$var$_Sound(media, options);
    }
    /**
   * Use `Sound.from`
   * @ignore
   */ constructor(media, options){
        this.media = media;
        this.options = options;
        this._instances = [];
        this._sprites = {};
        this.media.init(this);
        const complete = options.complete;
        this._autoPlayOptions = complete ? {
            complete: complete
        } : null;
        this.isLoaded = false;
        this._preloadQueue = null;
        this.isPlaying = false;
        this.autoPlay = options.autoPlay;
        this.singleInstance = options.singleInstance;
        this.preload = options.preload || this.autoPlay;
        this.url = Array.isArray(options.url) ? this.preferUrl(options.url) : options.url;
        this.speed = options.speed;
        this.volume = options.volume;
        this.loop = options.loop;
        if (options.sprites) this.addSprites(options.sprites);
        if (this.preload) this._preload(options.loaded);
    }
    /**
   * Internal help for resolving which file to use if there are multiple provide
   * this is especially helpful for working with bundlers (non Assets loading).
   */ preferUrl(urls) {
        const [file] = urls.map((url)=>({
                url: url,
                ext: (0, $lzfZe.path).extname(url).slice(1)
            })).filter(({ ext: ext })=>(0, $dc5147c44338cd30$export$5f747a46dc0eb6ee)[ext]).sort((a, b)=>(0, $dc5147c44338cd30$export$cc3e2d3244e01b7f).indexOf(a.ext) - (0, $dc5147c44338cd30$export$cc3e2d3244e01b7f).indexOf(b.ext));
        if (!file) throw new Error("No supported file type found");
        return file.url;
    }
    /** Instance of the media context. */ get context() {
        return (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().context;
    }
    /** Stops all the instances of this sound from playing. */ pause() {
        this.isPlaying = false;
        this.paused = true;
        return this;
    }
    /** Resuming all the instances of this sound from playing */ resume() {
        this.isPlaying = this._instances.length > 0;
        this.paused = false;
        return this;
    }
    /** Stops all the instances of this sound from playing. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /** The playback rate. */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
    }
    /** Set the filters. Only supported with WebAudio. */ get filters() {
        return this.media.filters;
    }
    set filters(filters) {
        this.media.filters = filters;
    }
    /**
   * @ignore
   */ addSprites(source, data) {
        if (typeof source === "object") {
            const results = {};
            for(const alias in source)results[alias] = this.addSprites(alias, source[alias]);
            return results;
        }
        console.assert(!this._sprites[source], `Alias ${source} is already taken`);
        const sprite = new (0, $126746c90b5a7d5e$export$fae5af5bab2ccf8)(this, data);
        this._sprites[source] = sprite;
        return sprite;
    }
    /** Destructor, safer to use `SoundLibrary.remove(alias)` to remove this sound. */ destroy() {
        this._removeInstances();
        this.removeSprites();
        this.media.destroy();
        this.media = null;
        this._sprites = null;
        this._instances = null;
    }
    /**
   * Remove a sound sprite.
   * @param alias - The unique name of the sound sprite, if alias is omitted, removes all sprites.
   */ removeSprites(alias) {
        if (!alias) for(const name in this._sprites)this.removeSprites(name);
        else {
            const sprite = this._sprites[alias];
            if (sprite !== void 0) {
                sprite.destroy();
                delete this._sprites[alias];
            }
        }
        return this;
    }
    /** If the current sound is playable (loaded). */ get isPlayable() {
        return this.isLoaded && this.media && this.media.isPlayable;
    }
    /** Stops all the instances of this sound from playing. */ stop() {
        if (!this.isPlayable) {
            this.autoPlay = false;
            this._autoPlayOptions = null;
            return this;
        }
        this.isPlaying = false;
        for(let i = this._instances.length - 1; i >= 0; i--)this._instances[i].stop();
        return this;
    }
    // Overloaded function
    play(source, complete) {
        let options;
        if (typeof source === "string") {
            const sprite = source;
            options = {
                sprite: sprite,
                loop: this.loop,
                complete: complete
            };
        } else if (typeof source === "function") {
            options = {};
            options.complete = source;
        } else options = source;
        options = {
            complete: null,
            loaded: null,
            sprite: null,
            end: null,
            start: 0,
            volume: 1,
            speed: 1,
            muted: false,
            loop: false,
            ...options || {}
        };
        if (options.sprite) {
            const alias = options.sprite;
            console.assert(!!this._sprites[alias], `Alias ${alias} is not available`);
            const sprite = this._sprites[alias];
            options.start = sprite.start + (options.start || 0);
            options.end = sprite.end;
            options.speed = sprite.speed || 1;
            options.loop = sprite.loop || options.loop;
            delete options.sprite;
        }
        if (options.offset) options.start = options.offset;
        if (!this.isLoaded) {
            if (this._preloadQueue) return new Promise((resolve)=>{
                this._preloadQueue.push(()=>{
                    resolve(this.play(options));
                });
            });
            this._preloadQueue = [];
            this.autoPlay = true;
            this._autoPlayOptions = options;
            return new Promise((resolve, reject)=>{
                this._preload((err, sound, media)=>{
                    this._preloadQueue.forEach((resolve2)=>resolve2());
                    this._preloadQueue = null;
                    if (err) reject(err);
                    else {
                        if (options.loaded) options.loaded(err, sound, media);
                        resolve(media);
                    }
                });
            });
        }
        if (this.singleInstance || options.singleInstance) this._removeInstances();
        const instance = this._createInstance();
        this._instances.push(instance);
        this.isPlaying = true;
        instance.once("end", ()=>{
            if (options.complete) options.complete(this);
            this._onComplete(instance);
        });
        instance.once("stop", ()=>{
            this._onComplete(instance);
        });
        instance.play(options);
        return instance;
    }
    /** Internal only, speed, loop, volume change occured. */ refresh() {
        const len = this._instances.length;
        for(let i = 0; i < len; i++)this._instances[i].refresh();
    }
    /** Handle changes in paused state. Internal only. */ refreshPaused() {
        const len = this._instances.length;
        for(let i = 0; i < len; i++)this._instances[i].refreshPaused();
    }
    /** Gets and sets the volume. */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** Gets and sets the muted flag. */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /** Gets and sets the looping. */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** Starts the preloading of sound. */ _preload(callback) {
        this.media.load(callback);
    }
    /** Gets the list of instances that are currently being played of this sound. */ get instances() {
        return this._instances;
    }
    /** Get the map of sprites. */ get sprites() {
        return this._sprites;
    }
    /** Get the duration of the audio in seconds. */ get duration() {
        return this.media.duration;
    }
    /** Auto play the first instance. */ autoPlayStart() {
        let instance;
        if (this.autoPlay) instance = this.play(this._autoPlayOptions);
        return instance;
    }
    /** Removes all instances. */ _removeInstances() {
        for(let i = this._instances.length - 1; i >= 0; i--)this._poolInstance(this._instances[i]);
        this._instances.length = 0;
    }
    /**
   * Sound instance completed.
   * @param instance
   */ _onComplete(instance) {
        if (this._instances) {
            const index = this._instances.indexOf(instance);
            if (index > -1) this._instances.splice(index, 1);
            this.isPlaying = this._instances.length > 0;
        }
        this._poolInstance(instance);
    }
    /** Create a new instance. */ _createInstance() {
        if ($87165ad660797c67$var$_Sound._pool.length > 0) {
            const instance = $87165ad660797c67$var$_Sound._pool.pop();
            instance.init(this.media);
            return instance;
        }
        return this.media.create();
    }
    /**
   * Destroy/recycling the instance object.
   * @param instance - Instance to recycle
   */ _poolInstance(instance) {
        instance.destroy();
        if ($87165ad660797c67$var$_Sound._pool.indexOf(instance) < 0) $87165ad660797c67$var$_Sound._pool.push(instance);
    }
};
let $87165ad660797c67$export$85990f0f98a390bb = $87165ad660797c67$var$_Sound;
/** Pool of instances */ $87165ad660797c67$export$85990f0f98a390bb._pool = [];


parcelRequire("iuB9z");
var $3vRz3 = parcelRequire("3vRz3");

class $84b2c3336e00d9fc$export$25289944de7a55e4 extends (0, $1a83c23817070e16$export$d00e1c48fb621173) {
    constructor(){
        const win = window;
        const ctx = new $84b2c3336e00d9fc$export$25289944de7a55e4.AudioContext();
        const compressor = ctx.createDynamicsCompressor();
        const analyser = ctx.createAnalyser();
        analyser.connect(compressor);
        compressor.connect(ctx.destination);
        super(analyser, compressor);
        /** Set to false ignore suspending when window is blurred */ this.autoPause = true;
        this._ctx = ctx;
        this._offlineCtx = new $84b2c3336e00d9fc$export$25289944de7a55e4.OfflineAudioContext(1, 2, win.OfflineAudioContext ? Math.max(8e3, Math.min(96e3, ctx.sampleRate)) : 44100);
        this.compressor = compressor;
        this.analyser = analyser;
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();
        this.volume = 1;
        this.speed = 1;
        this.muted = false;
        this.paused = false;
        this._locked = ctx.state === "suspended" && ("ontouchstart" in globalThis || "onclick" in globalThis);
        if (this._locked) {
            this._unlock();
            this._unlock = this._unlock.bind(this);
            document.addEventListener("mousedown", this._unlock, true);
            document.addEventListener("touchstart", this._unlock, true);
            document.addEventListener("touchend", this._unlock, true);
        }
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        globalThis.addEventListener("focus", this.onFocus);
        globalThis.addEventListener("blur", this.onBlur);
    }
    /** Handle mobile WebAudio context resume */ onFocus() {
        if (!this.autoPause) return;
        const state = this._ctx.state;
        if (state === "suspended" || state === "interrupted" || !this._locked) {
            this.paused = this._pausedOnBlur;
            this.refreshPaused();
        }
    }
    /** Handle mobile WebAudio context suspend */ onBlur() {
        if (!this.autoPause) return;
        if (!this._locked) {
            this._pausedOnBlur = this._paused;
            this.paused = true;
            this.refreshPaused();
        }
    }
    /**
   * Try to unlock audio on iOS. This is triggered from either WebAudio plugin setup (which will work if inside of
   * a `mousedown` or `touchend` event stack), or the first document touchend/mousedown event. If it fails (touchend
   * will fail if the user presses for too long, indicating a scroll event instead of a click event.
   *
   * Note that earlier versions of iOS supported `touchstart` for this, but iOS9 removed this functionality. Adding
   * a `touchstart` event to support older platforms may preclude a `mousedown` even from getting fired on iOS9, so we
   * stick with `mousedown` and `touchend`.
   */ _unlock() {
        if (!this._locked) return;
        this.playEmptySound();
        if (this._ctx.state === "running") {
            document.removeEventListener("mousedown", this._unlock, true);
            document.removeEventListener("touchend", this._unlock, true);
            document.removeEventListener("touchstart", this._unlock, true);
            this._locked = false;
        }
    }
    /**
   * Plays an empty sound in the web audio context.  This is used to enable web audio on iOS devices, as they
   * require the first sound to be played inside of a user initiated event (touch/click).
   */ playEmptySound() {
        const source = this._ctx.createBufferSource();
        source.buffer = this._ctx.createBuffer(1, 1, 22050);
        source.connect(this._ctx.destination);
        source.start(0, 0, 0);
        if (source.context.state === "suspended") source.context.resume();
    }
    /**
   * Get AudioContext class, if not supported returns `null`
   * @type {AudioContext}
   * @readonly
   */ static get AudioContext() {
        const win = window;
        return win.AudioContext || win.webkitAudioContext || null;
    }
    /**
   * Get OfflineAudioContext class, if not supported returns `null`
   * @type {OfflineAudioContext}
   * @readonly
   */ static get OfflineAudioContext() {
        const win = window;
        return win.OfflineAudioContext || win.webkitOfflineAudioContext || null;
    }
    /** Destroy this context. */ destroy() {
        super.destroy();
        const ctx = this._ctx;
        if (typeof ctx.close !== "undefined") ctx.close();
        globalThis.removeEventListener("focus", this.onFocus);
        globalThis.removeEventListener("blur", this.onBlur);
        this.events.removeAllListeners();
        this.analyser.disconnect();
        this.compressor.disconnect();
        this.analyser = null;
        this.compressor = null;
        this.events = null;
        this._offlineCtx = null;
        this._ctx = null;
    }
    /**
   * The WebAudio API AudioContext object.
   * @readonly
   * @type {AudioContext}
   */ get audioContext() {
        return this._ctx;
    }
    /**
   * The WebAudio API OfflineAudioContext object.
   * @readonly
   * @type {OfflineAudioContext}
   */ get offlineContext() {
        return this._offlineCtx;
    }
    /**
   * Pauses all sounds, even though we handle this at the instance
   * level, we'll also pause the audioContext so that the
   * time used to compute progress isn't messed up.
   * @default false
   */ set paused(paused) {
        if (paused && this._ctx.state === "running") this._ctx.suspend();
        else if (!paused && this._ctx.state === "suspended") this._ctx.resume();
        this._paused = paused;
    }
    get paused() {
        return this._paused;
    }
    /** Emit event when muted, volume or speed changes */ refresh() {
        this.events.emit("refresh");
    }
    /** Emit event when muted, volume or speed changes */ refreshPaused() {
        this.events.emit("refreshPaused");
    }
    /**
   * Toggles the muted state.
   * @return The current muted state.
   */ toggleMute() {
        this.muted = !this.muted;
        this.refresh();
        return this.muted;
    }
    /**
   * Toggles the paused state.
   * @return The current muted state.
   */ togglePause() {
        this.paused = !this.paused;
        this.refreshPaused();
        return this._paused;
    }
    /**
   * Decode the audio data
   * @param arrayBuffer - Buffer from loader
   * @param callback - When completed, error and audioBuffer are parameters.
   */ decode(arrayBuffer, callback) {
        const handleError = (err)=>{
            callback(new Error(err?.message || "Unable to decode file"));
        };
        const result = this._offlineCtx.decodeAudioData(arrayBuffer, (buffer)=>{
            callback(null, buffer);
        }, handleError);
        if (result) result.catch(handleError);
    }
}


class $27962a4b0235b4e1$export$8f62fda960fa1546 {
    constructor(){
        this.init();
    }
    /**
   * Re-initialize the sound library, this will
   * recreate the AudioContext. If there's a hardware-failure
   * call `close` and then `init`.
   * @return Sound instance
   */ init() {
        if (this.supported) this._webAudioContext = new (0, $84b2c3336e00d9fc$export$25289944de7a55e4)();
        this._htmlAudioContext = new (0, $fa41e941aefd0fd2$export$135605210c0a871c)();
        this._sounds = {};
        this.useLegacy = !this.supported;
        return this;
    }
    /**
   * The global context to use.
   * @readonly
   */ get context() {
        return this._context;
    }
    /**
   * Apply filters to all sounds. Can be useful
   * for setting global planning or global effects.
   * **Only supported with WebAudio.**
   * @example
   * import { sound, filters } from '@pixi/sound';
   * // Adds a filter to pan all output left
   * sound.filtersAll = [
   *     new filters.StereoFilter(-1)
   * ];
   */ get filtersAll() {
        if (!this.useLegacy) return this._context.filters;
        return [];
    }
    set filtersAll(filtersAll) {
        if (!this.useLegacy) this._context.filters = filtersAll;
    }
    /**
   * `true` if WebAudio is supported on the current browser.
   */ get supported() {
        return (0, $84b2c3336e00d9fc$export$25289944de7a55e4).AudioContext !== null;
    }
    /**
   * @ignore
   */ add(source, sourceOptions) {
        if (typeof source === "object") {
            const results = {};
            for(const alias in source){
                const options2 = this._getOptions(source[alias], sourceOptions);
                results[alias] = this.add(alias, options2);
            }
            return results;
        }
        console.assert(!this._sounds[source], `Sound with alias ${source} already exists.`);
        if (sourceOptions instanceof (0, $87165ad660797c67$export$85990f0f98a390bb)) {
            this._sounds[source] = sourceOptions;
            return sourceOptions;
        }
        const options = this._getOptions(sourceOptions);
        const sound = (0, $87165ad660797c67$export$85990f0f98a390bb).from(options);
        this._sounds[source] = sound;
        return sound;
    }
    /**
   * Internal methods for getting the options object
   * @private
   * @param source - The source options
   * @param overrides - Override default options
   * @return The construction options
   */ _getOptions(source, overrides) {
        let options;
        if (typeof source === "string") options = {
            url: source
        };
        else if (Array.isArray(source)) options = {
            url: source
        };
        else if (source instanceof ArrayBuffer || source instanceof AudioBuffer || source instanceof HTMLAudioElement) options = {
            source: source
        };
        else options = source;
        options = {
            ...options,
            ...overrides || {}
        };
        return options;
    }
    /**
   * Do not use WebAudio, force the use of legacy. This **must** be called before loading any files.
   */ get useLegacy() {
        return this._useLegacy;
    }
    set useLegacy(legacy) {
        this._useLegacy = legacy;
        this._context = !legacy && this.supported ? this._webAudioContext : this._htmlAudioContext;
    }
    /**
   * This disables auto-pause all playback when the window blurs (WebAudio only).
   * This is helpful to keep from playing sounds when the user switches tabs.
   * However, if you're running content within an iframe, this may be undesirable
   * and you should disable (set to `true`) this behavior.
   * @default false
   */ get disableAutoPause() {
        return !this._webAudioContext.autoPause;
    }
    set disableAutoPause(autoPause) {
        this._webAudioContext.autoPause = !autoPause;
    }
    /**
   * Removes a sound by alias.
   * @param alias - The sound alias reference.
   * @return Instance for chaining.
   */ remove(alias) {
        this.exists(alias, true);
        this._sounds[alias].destroy();
        delete this._sounds[alias];
        return this;
    }
    /**
   * Set the global volume for all sounds. To set per-sound volume see {@link SoundLibrary#volume}.
   */ get volumeAll() {
        return this._context.volume;
    }
    set volumeAll(volume) {
        this._context.volume = volume;
        this._context.refresh();
    }
    /**
   * Set the global speed for all sounds. To set per-sound speed see {@link SoundLibrary#speed}.
   */ get speedAll() {
        return this._context.speed;
    }
    set speedAll(speed) {
        this._context.speed = speed;
        this._context.refresh();
    }
    /**
   * Toggle paused property for all sounds.
   * @return `true` if all sounds are paused.
   */ togglePauseAll() {
        return this._context.togglePause();
    }
    /**
   * Pauses any playing sounds.
   * @return Instance for chaining.
   */ pauseAll() {
        this._context.paused = true;
        this._context.refreshPaused();
        return this;
    }
    /**
   * Resumes any sounds.
   * @return Instance for chaining.
   */ resumeAll() {
        this._context.paused = false;
        this._context.refreshPaused();
        return this;
    }
    /**
   * Toggle muted property for all sounds.
   * @return `true` if all sounds are muted.
   */ toggleMuteAll() {
        return this._context.toggleMute();
    }
    /**
   * Mutes all playing sounds.
   * @return Instance for chaining.
   */ muteAll() {
        this._context.muted = true;
        this._context.refresh();
        return this;
    }
    /**
   * Unmutes all playing sounds.
   * @return Instance for chaining.
   */ unmuteAll() {
        this._context.muted = false;
        this._context.refresh();
        return this;
    }
    /**
   * Stops and removes all sounds. They cannot be used after this.
   * @return Instance for chaining.
   */ removeAll() {
        for(const alias in this._sounds){
            this._sounds[alias].destroy();
            delete this._sounds[alias];
        }
        return this;
    }
    /**
   * Stops all sounds.
   * @return Instance for chaining.
   */ stopAll() {
        for(const alias in this._sounds)this._sounds[alias].stop();
        return this;
    }
    /**
   * Checks if a sound by alias exists.
   * @param alias - Check for alias.
   * @param assert - Whether enable console.assert.
   * @return true if the sound exists.
   */ exists(alias, assert = false) {
        const exists = !!this._sounds[alias];
        if (assert) console.assert(exists, `No sound matching alias '${alias}'.`);
        return exists;
    }
    /**
   * Convenience function to check to see if any sound is playing.
   * @returns `true` if any sound is currently playing.
   */ isPlaying() {
        for(const alias in this._sounds){
            if (this._sounds[alias].isPlaying) return true;
        }
        return false;
    }
    /**
   * Find a sound by alias.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ find(alias) {
        this.exists(alias, true);
        return this._sounds[alias];
    }
    /**
   * Plays a sound.
   * @method play
   * @instance
   * @param {string} alias - The sound alias reference.
   * @param {string} sprite - The alias of the sprite to play.
   * @return {IMediaInstance|null} The sound instance, this cannot be reused
   *         after it is done playing. Returns `null` if the sound has not yet loaded.
   */ /**
   * Plays a sound.
   * @param alias - The sound alias reference.
   * @param {PlayOptions|Function} options - The options or callback when done.
   * @return The sound instance,
   *        this cannot be reused after it is done playing. Returns a Promise if the sound
   *        has not yet loaded.
   */ play(alias, options) {
        return this.find(alias).play(options);
    }
    /**
   * Stops a sound.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ stop(alias) {
        return this.find(alias).stop();
    }
    /**
   * Pauses a sound.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ pause(alias) {
        return this.find(alias).pause();
    }
    /**
   * Resumes a sound.
   * @param alias - The sound alias reference.
   * @return Instance for chaining.
   */ resume(alias) {
        return this.find(alias).resume();
    }
    /**
   * Get or set the volume for a sound.
   * @param alias - The sound alias reference.
   * @param volume - Optional current volume to set.
   * @return The current volume.
   */ volume(alias, volume) {
        const sound = this.find(alias);
        if (volume !== void 0) sound.volume = volume;
        return sound.volume;
    }
    /**
   * Get or set the speed for a sound.
   * @param alias - The sound alias reference.
   * @param speed - Optional current speed to set.
   * @return The current speed.
   */ speed(alias, speed) {
        const sound = this.find(alias);
        if (speed !== void 0) sound.speed = speed;
        return sound.speed;
    }
    /**
   * Get the length of a sound in seconds.
   * @param alias - The sound alias reference.
   * @return The current duration in seconds.
   */ duration(alias) {
        return this.find(alias).duration;
    }
    /**
   * Closes the sound library. This will release/destroy
   * the AudioContext(s). Can be used safely if you want to
   * initialize the sound library later. Use `init` method.
   */ close() {
        this.removeAll();
        this._sounds = null;
        if (this._webAudioContext) {
            this._webAudioContext.destroy();
            this._webAudioContext = null;
        }
        if (this._htmlAudioContext) {
            this._htmlAudioContext.destroy();
            this._htmlAudioContext = null;
        }
        this._context = null;
        return this;
    }
}



let $7d30d04884b26add$export$75d5873f93626b73 = 0;
function $7d30d04884b26add$export$24b8a725481a84c8(url, callback) {
    const alias = `alias${$7d30d04884b26add$export$75d5873f93626b73++}`;
    (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().add(alias, {
        url: url,
        preload: true,
        autoPlay: true,
        loaded: (err)=>{
            if (err) {
                console.error(err);
                (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().remove(alias);
                if (callback) callback(err);
            }
        },
        complete: ()=>{
            (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().remove(alias);
            if (callback) callback(null);
        }
    });
    return alias;
}


parcelRequire("iuB9z");
var $8xl7d = parcelRequire("8xl7d");

function $6af2dcd9f366bc64$export$b3890eb0ae9dca99(sound, options) {
    const canvas = document.createElement("canvas");
    options = {
        width: 512,
        height: 128,
        fill: "black",
        ...options || {}
    };
    canvas.width = options.width;
    canvas.height = options.height;
    const textureSource = new (0, $8xl7d.CanvasSource)({
        resource: canvas
    });
    if (!(sound.media instanceof (0, $eff32f4d75ee76d4$export$9ea3865f5a7f2b06))) return textureSource;
    const media = sound.media;
    console.assert(!!media.buffer, "No buffer found, load first");
    const context = canvas.getContext("2d");
    context.fillStyle = options.fill;
    const data = media.buffer.getChannelData(0);
    const step = Math.ceil(data.length / options.width);
    const amp = options.height / 2;
    for(let i = 0; i < options.width; i++){
        let min = 1;
        let max = -1;
        for(let j = 0; j < step; j++){
            const datum = data[i * step + j];
            if (datum < min) min = datum;
            if (datum > max) max = datum;
        }
        context.fillRect(i, (1 + min) * amp, 1, Math.max(1, (max - min) * amp));
    }
    return textureSource;
}




function $276464f3559001e4$export$174af12dde0cc01(hertz = 200, seconds = 1) {
    const sound = (0, $87165ad660797c67$export$85990f0f98a390bb).from({
        singleInstance: true
    });
    if (!(sound.media instanceof (0, $eff32f4d75ee76d4$export$9ea3865f5a7f2b06))) return sound;
    const media = sound.media;
    const context = sound.context;
    const nChannels = 1;
    const sampleRate = 48e3;
    const amplitude = 2;
    const buffer = context.audioContext.createBuffer(nChannels, seconds * sampleRate, sampleRate);
    const fArray = buffer.getChannelData(0);
    for(let i = 0; i < fArray.length; i++){
        const time = i / buffer.sampleRate;
        const angle = hertz * time * 2 * Math.PI;
        fArray[i] = Math.sin(angle) * amplitude;
    }
    media.buffer = buffer;
    sound.isLoaded = true;
    return sound;
}















parcelRequire("iuB9z");
var $i9BKe = parcelRequire("i9BKe");
var $iEtN5 = parcelRequire("iEtN5");
var $lzfZe = parcelRequire("lzfZe");



const $9149c22799672adc$var$getAlias = (asset)=>{
    const src = asset.src;
    let alias = asset?.alias?.[0];
    if (!alias || asset.src === alias) alias = (0, $lzfZe.path).basename(src, (0, $lzfZe.path).extname(src));
    return alias;
};
const $9149c22799672adc$export$ac5ef27803a8e50 = {
    extension: (0, $i9BKe.ExtensionType).Asset,
    detection: {
        test: async ()=>true,
        add: async (formats)=>[
                ...formats,
                ...(0, $dc5147c44338cd30$export$cc3e2d3244e01b7f).filter((ext)=>(0, $dc5147c44338cd30$export$5f747a46dc0eb6ee)[ext])
            ],
        remove: async (formats)=>formats.filter((ext)=>formats.includes(ext))
    },
    loader: {
        name: "sound",
        extension: {
            type: [
                (0, $i9BKe.ExtensionType).LoadParser
            ],
            priority: (0, $iEtN5.LoaderParserPriority).High
        },
        /** Should we attempt to load this file? */ test (url) {
            const ext = (0, $lzfZe.path).extname(url).slice(1);
            return !!(0, $dc5147c44338cd30$export$5f747a46dc0eb6ee)[ext] || (0, $dc5147c44338cd30$export$8114c8bcb5760e77).some((mime)=>url.startsWith(`data:${mime}`));
        },
        /** Load the sound file, this is mostly handled by Sound.from() */ async load (url, asset) {
            const sound = await new Promise((resolve, reject)=>(0, $87165ad660797c67$export$85990f0f98a390bb).from({
                    ...asset.data,
                    url: url,
                    preload: true,
                    loaded (err, sound2) {
                        if (err) reject(err);
                        else resolve(sound2);
                        asset.data?.loaded?.(err, sound2);
                    }
                }));
            (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().add($9149c22799672adc$var$getAlias(asset), sound);
            return sound;
        },
        /** Remove the sound from the library */ async unload (_sound, asset) {
            (0, $0849d58f9b8d07c3$export$8bedcca5bbd73999)().remove($9149c22799672adc$var$getAlias(asset));
        }
    }
};
(0, $i9BKe.extensions).add($9149c22799672adc$export$ac5ef27803a8e50);



const $205d04c2ae054fb9$export$eab32dcfc4ded11c = (0, $0849d58f9b8d07c3$export$7fbc60ba12697434)(new (0, $27962a4b0235b4e1$export$8f62fda960fa1546)());


const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $568f4ee4022ba00e$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


class $7a3aa552ffc217dd$export$85990f0f98a390bb {
    async load(config) {
        await new Promise((resolve, reject)=>{
            const sound = (0, $87165ad660797c67$export$85990f0f98a390bb).from({
                url: [
                    config.url
                ],
                volume: config.volume ?? 1.0
            });
            this._data.sound = sound;
            this._config = config;
            // force load, then listen to the callback
            sound.media.load((err, sound, _)=>{
                if (err || !sound) {
                    console.warn(`Could not load sound ${config.url}`);
                    reject(err);
                    return;
                }
                // if (config.autoPlayOptions) {
                //     // Manual autoplay in order to preserve fading functionality
                //     this.play(config.autoPlayOptions);
                // }
                resolve();
            });
        });
    }
    async play(playOptions) {
        if (!this._isSoundDataLoaded() || !this._isSoundLoadConfigValid()) return undefined;
        const defaultPlayOptions = {
            volume: playOptions?.volume ?? this._config.volume ?? 1,
            loop: this._config.loop,
            complete: playOptions?.complete ?? (()=>{})
        };
        const mediaInstance = await this._data.sound.play(defaultPlayOptions);
        const soundInstance = new $7a3aa552ffc217dd$export$9df2da69341d6f5a(playOptions ?? defaultPlayOptions, this._config, mediaInstance);
        return soundInstance;
    }
    setMuted(mute = true) {
        if (!this._isSoundDataLoaded() || !this._isSoundLoadConfigValid()) return;
        this._data.sound.muted = mute;
    }
    _isSoundDataLoaded() {
        if (!this._data.sound) {
            console.warn("An ISound object is trying to be played without loading first.");
            return false;
        }
        return true;
    }
    _isSoundLoadConfigValid() {
        if (this._config.url === "" && this._config.key === "") {
            console.warn("An ISound object is trying to be played without loading first.");
            return false;
        }
        return true;
    }
    constructor(){
        this._data = {
            sound: undefined
        };
        this._config = {
            url: "",
            key: "",
            volume: 1
        };
    }
}
class $7a3aa552ffc217dd$export$cd57b1b9e1075a99 {
    async load(config) {
        await new Promise((resolve, reject)=>{
            const sound = (0, $87165ad660797c67$export$85990f0f98a390bb).from({
                url: [
                    config.url
                ],
                volume: config.volume ?? 1.0
            });
            this._data.sound = sound;
            this._data.sprites = config.sprites;
            this._config = config;
            // force load, then listen to the callback
            sound.media.load((err, sound, _)=>{
                if (err || !sound) {
                    console.warn(`Could not load sound ${config.url}`);
                    reject(err);
                    return;
                }
                // if (config.autoPlayOptions) {
                //     // Manual autoplay in order to preserve fading functionality
                //     this.play(config.autoPlayOptions);
                // }
                resolve();
            });
        });
    }
    async play(playOptions) {
        if (!this._isAudioSpriteDataLoaded() || !this._isAudioSpriteLoadConfigValid()) return undefined;
        const defaultPlayOptions = {
            sprite: playOptions.spriteName,
            volume: playOptions.volume ?? this._config.volume ?? 1,
            loop: this._config.loop,
            complete: playOptions.complete || (()=>{} // this._config.autoPlayOptions?.complete,
            )
        };
        const mediaInstance = await this._data.sound.play(defaultPlayOptions);
        const soundInstance = new $7a3aa552ffc217dd$export$2eba42f2e9aaf8ed(playOptions ?? defaultPlayOptions, this._config, mediaInstance);
        return soundInstance;
    }
    setMuted(mute = true) {
        if (!this._isAudioSpriteDataLoaded() || !this._isAudioSpriteLoadConfigValid()) return;
        this._data.sound.muted = mute;
    }
    _isAudioSpriteDataLoaded() {
        if (!this._data.sound && !this._data.sprites) {
            console.warn("An ISound object is trying to be played without loading first.");
            return false;
        }
        return true;
    }
    _isAudioSpriteLoadConfigValid() {
        if (this._config.url === "" && this._config.key === "") {
            console.warn("An ISound object is trying to be played without loading first.");
            return false;
        }
        return true;
    }
    constructor(){
        this._data = {
            sound: undefined
        };
        this._config = {
            url: "",
            key: "",
            volume: 1
        };
    }
}
class $7a3aa552ffc217dd$export$9df2da69341d6f5a {
    constructor(playOptions = {}, config = {}, mediaInstance){
        this.id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        this._playOptions = playOptions;
        this._config = config;
        this._mediaInstance = mediaInstance;
    }
    play(options) {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.play({
            volume: options?.volume,
            complete: options?.complete
        });
    }
    // Load and store the SoundData in this.data
    pause() {
        if (!this._isMediaInstanceValid()) return;
        if (!this._mediaInstance.paused) this._mediaInstance.paused = true;
    }
    resume() {
        if (!this._isMediaInstanceValid()) return;
        if (this._mediaInstance.paused) this._mediaInstance.paused = false;
    }
    stop() {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.stop();
    }
    setMuted(mute = true) {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.muted = mute;
    }
    setVolume(volume, fadeDuration = 0.25, fadeFinished) {
        if (!this._isMediaInstanceValid()) return;
        this._fadeVolume(volume, fadeDuration, fadeFinished);
    }
    getVolume() {
        if (!this._isMediaInstanceValid()) return 0;
        return this._mediaInstance.volume;
    }
    getBaseVolume() {
        if (!this._isMediaInstanceValid()) return 0;
        let baseVolume = this._config.volume ?? 1;
        baseVolume = this._playOptions.volume ?? baseVolume;
        return baseVolume;
    }
    reset() {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.destroy();
    }
    tryGetMediaInstance() {
        if (!this._isMediaInstanceValid()) return undefined;
        return this._mediaInstance;
    }
    _fadeVolume(targetVolume, duration, fadeFinished) {
        const startVolume = this.getVolume();
        const startTime = Date.now();
        const fade = ()=>{
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / (duration * 1000), 1); // Convert to ms
            const currentVolume = startVolume + (targetVolume - startVolume) * progress;
            this._mediaInstance.volume = currentVolume;
            if (progress < 1) {
                requestAnimationFrame(fade);
                return;
            }
            fadeFinished?.();
        };
        requestAnimationFrame(fade);
    }
    _isMediaInstanceValid() {
        if (!this._mediaInstance) {
            console.warn("The media instance is invalid, can not perform the action");
            return false;
        }
        return true;
    }
}
class $7a3aa552ffc217dd$export$2eba42f2e9aaf8ed {
    constructor(playOptions = {}, config = {}, mediaInstance){
        this.id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        this._playOptions = playOptions;
        this._config = config;
        this._mediaInstance = mediaInstance;
    }
    play(options) {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.play({
            volume: options?.volume,
            complete: options?.complete
        });
    }
    pause() {
        if (!this._isMediaInstanceValid()) return;
        if (!this._mediaInstance.paused) this._mediaInstance.paused = true;
    }
    resume() {
        if (!this._isMediaInstanceValid()) return;
        if (this._mediaInstance.paused) this._mediaInstance.paused = false;
    }
    stop() {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.stop();
    }
    setMuted(mute = true) {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.muted = mute;
    }
    setVolume(volume, fadeDuration = 0.25, fadeFinished) {
        if (!this._isMediaInstanceValid()) return;
        this._fadeVolume(volume, fadeDuration, fadeFinished);
    }
    getVolume() {
        if (!this._isMediaInstanceValid()) return 0;
        return this._mediaInstance.volume;
    }
    getBaseVolume() {
        if (!this._isMediaInstanceValid()) return 0;
        let baseVolume = this._config.volume ?? 1;
        baseVolume = this._playOptions.volume ?? baseVolume;
        return baseVolume;
    }
    reset() {
        if (!this._isMediaInstanceValid()) return;
        this._mediaInstance.destroy();
    }
    tryGetMediaInstance() {
        if (!this._isMediaInstanceValid()) return undefined;
        return this._mediaInstance;
    }
    _fadeVolume(targetVolume, duration, fadeFinished) {
        const startVolume = this.getVolume();
        const startTime = Date.now();
        const fade = ()=>{
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / (duration * 1000), 1); // Convert to ms
            const currentVolume = startVolume + (targetVolume - startVolume) * progress;
            this._mediaInstance.volume = currentVolume;
            if (progress < 1) {
                requestAnimationFrame(fade);
                return;
            }
            fadeFinished?.();
        };
        requestAnimationFrame(fade);
    }
    _isMediaInstanceValid() {
        if (!this._mediaInstance) {
            console.warn("The media instance is invalid, can not perform the action");
            return false;
        }
        return true;
    }
}


class $bbd3d886140ad386$var$SoundManager {
    get _isEffectivelyMuted() {
        return this._isGameMuted || this._isTabMuted;
    }
    constructor(){
        this._sounds = new Map();
        this._audioSpriteSounds = new Map();
        this._soundInstances = [];
        // User-side mute
        this._isGameMuted = false;
        // Tab focus/unfocus mute
        this._isTabMuted = false;
        this._masterVolume = 1;
        document.addEventListener("visibilitychange", ()=>{
            this._isTabMuted = document.hidden;
            this._computeMasterVolume();
        });
    }
    static getInstance() {
        if (!this._instance) this._instance = new $bbd3d886140ad386$var$SoundManager();
        return this._instance;
    }
    setGameMuted(isMuted) {
        this._isGameMuted = isMuted;
        this._computeMasterVolume();
    }
    async createSound(config) {
        const sound = new (0, $7a3aa552ffc217dd$export$85990f0f98a390bb)();
        await sound.load(config);
        this._sounds.set(config.key, sound);
    }
    async createAudioSprite(config) {
        const audioSprite = new (0, $7a3aa552ffc217dd$export$cd57b1b9e1075a99)();
        await audioSprite.load(config);
        this._audioSpriteSounds.set(config.key, audioSprite);
    }
    // An ISoundInstance is created after playing an ISound object
    // The play methods play and store the instances they play internally
    async playSound(key, playOptions) {
        const sound = this._tryGetSound(key);
        if (!sound) return Promise.resolve(undefined);
        let soundInstanceGeneric = await sound.play(playOptions);
        if (!soundInstanceGeneric) return undefined;
        const soundInstance = soundInstanceGeneric;
        this._soundInstances.push(soundInstance);
        soundInstance.tryGetMediaInstance()?.on('end', ()=>{
            const index = this._soundInstances.findIndex((instance)=>instance.id === soundInstance.id);
            if (index >= 0) this._soundInstances.splice(index, 1);
        });
        return soundInstance;
    }
    async playAudioSprite(key, playOptions) {
        const audioSprite = this._tryGetAudioSprite(key);
        if (!audioSprite) return Promise.resolve(undefined);
        let audioSpriteInstanceGeneric = await audioSprite.play(playOptions);
        if (!audioSpriteInstanceGeneric) return undefined;
        const audioSpriteInstance = audioSpriteInstanceGeneric;
        this._soundInstances.push(audioSpriteInstance);
        audioSpriteInstance.tryGetMediaInstance()?.on('end', ()=>{
            const index = this._soundInstances.findIndex((instance)=>instance.id === audioSpriteInstance.id);
            if (index >= 0) this._soundInstances.splice(index, 1);
        });
        return audioSpriteInstance;
    }
    stopSoundInstance(soundInstance) {
        if (!soundInstance) return;
        soundInstance.stop();
        soundInstance.reset();
        const index = this._soundInstances.findIndex((instance)=>instance.id === soundInstance.id);
        if (index >= 0) this._soundInstances.splice(index, 1);
    }
    pauseSoundInstance(soundInstance) {
        if (!soundInstance) return;
        soundInstance.pause();
    }
    resumeSoundInstance(soundInstance) {
        if (!soundInstance) return;
        soundInstance.resume();
    }
    setSoundInstanceVolume(soundInstance, volume, fadeDuration = 0.25, fadeFinished) {
        if (!soundInstance) return;
        soundInstance.setVolume(volume * this._masterVolume, fadeDuration, fadeFinished);
    }
    setMuted(mute = true) {
        // Change the mute state of the future instances
        for (const [_, sound] of this._sounds)sound.setMuted(mute);
        for (const [_, sound] of this._audioSpriteSounds)sound.setMuted(mute);
        // Change the mute state of present sound instances
        for (const instance of this._soundInstances)instance.setMuted(mute);
    }
    _tryGetSound(key) {
        const sound = this._sounds.get(key);
        if (!sound) {
            console.warn(`Sound ${key} wasn't loaded. Can not play the sound.`);
            return undefined;
        }
        return sound;
    }
    _tryGetAudioSprite(key) {
        const audioSprite = this._audioSpriteSounds.get(key);
        if (!audioSprite) {
            console.warn(`Audio Sprite ${key} wasn't loaded. Can not play the sound.`);
            return undefined;
        }
        return audioSprite;
    }
    _computeMasterVolume() {
        const newVolume = this._isEffectivelyMuted ? 0 : 1;
        if (this._masterVolume !== newVolume) {
            this._masterVolume = newVolume;
            for (const soundInstance of this._soundInstances)soundInstance.setVolume(soundInstance.getBaseVolume() * this._masterVolume);
        }
    }
}
const $bbd3d886140ad386$export$402b940662af5211 = $bbd3d886140ad386$var$SoundManager.getInstance();


// Create a SymbolPool class to manage the pool of symbols
class $4706fae892b9b431$var$SymbolPool {
    constructor(initialPoolSize = 10){
        this.pool = [];
        for(let i = 0; i < initialPoolSize; i++)this.pool.push(new $4706fae892b9b431$export$3e25e887b7a5b37b("1"));
    }
    acquire() {
        let symbol;
        if (this.pool.length > 0) symbol = this.pool.pop();
        else symbol = new $4706fae892b9b431$export$3e25e887b7a5b37b("1");
        symbol.alpha = 1;
        symbol.scale.set(1);
        symbol.position.set(0, 0);
        return symbol;
    }
    release(symbol) {
        symbol.parent?.removeChild(symbol);
        // @ts-ignore - access internal state to wipe listeners
        symbol["symbol"].state.clearListeners();
        this.pool.push(symbol);
    }
}
class $4706fae892b9b431$export$3e25e887b7a5b37b extends $eicwU.Container {
    static{
        this.playedExpandingWildAudio = false;
    }
    static{
        this.playedAppearingWildAudio = false;
    }
    static{
        this.SYMBOL_WIDTH = 145 // Default width of the Symbol.
        ;
    }
    static{
        this.SYMBOL_HEIGHT = 140 // Default height of the Symbol.
        ;
    }
    static get pool() {
        if (!$4706fae892b9b431$export$3e25e887b7a5b37b._pool) throw new Error("Symbol pool is not initialized. Call Symbol.createPool() first.");
        return $4706fae892b9b431$export$3e25e887b7a5b37b._pool;
    }
    static createPool(initialPoolSize = 10) {
        $4706fae892b9b431$export$3e25e887b7a5b37b._pool = new $4706fae892b9b431$var$SymbolPool(initialPoolSize);
    }
    constructor(type){
        super(), this.isWinAnimating = false, this.multiplier = 0;
        this.symbol = (0, $1ovqM.Spine).from({
            skeleton: "sevenJson",
            atlas: "sevenAtlas"
        });
        this.addChild(this.symbol);
        this.setType(type.toString());
    }
    getType() {
        return this.type;
    }
    getMultiplier() {
        return this.multiplier;
    }
    setType(type) {
        this.isWinAnimating = false;
        this.removeChild(this.symbol);
        this.symbol.destroy();
        this.type = type;
        let symbolName = "";
        this.zIndex = 0;
        switch(this.type){
            case "1":
                symbolName = "seven";
                break;
            case "2":
                symbolName = "l_grape";
                break;
            case "3":
                symbolName = "l_wmelon";
                break;
            case "4":
                symbolName = "bell";
                break;
            case "5":
                symbolName = "l_plum";
                break;
            case "6":
                symbolName = "l_orange";
                break;
            case "7":
                symbolName = "l_lemon";
                break;
            case "8":
                symbolName = "l_cherry";
                break;
            case "100":
                symbolName = "dollar";
                break;
            case "101":
                symbolName = "star";
                break;
            case "200":
                symbolName = "wild";
                this.zIndex = 10;
                break;
            default:
                console.error("Invalid symbol type:" + type);
                break;
        }
        if (symbolName[0] === "l") {
            this.symbol = (0, $1ovqM.Spine).from({
                skeleton: "lowsJson",
                atlas: "lowsAtlas"
            });
            this.symbol.skeleton.setSkinByName(symbolName);
        } else this.symbol = (0, $1ovqM.Spine).from({
            skeleton: `${symbolName}Json`,
            atlas: `${symbolName}Atlas`
        });
        this.symbol.skeleton.setSlotsToSetupPose();
        this.symbol.scale.set(0.11);
        this.symbol.angle = 0;
        this.addChild(this.symbol);
        this.idle();
        this.symbol.state.clearListeners();
        this.symbol.state.addListener({
            event: function(entry, event) {},
            complete: (entry)=>{
                if (entry.animation) this.emit(entry.animation.name);
            },
            start: (entry)=>{
                if (entry.animation.name.includes("land") && this.type === "200") {
                    console.log(`playing land audio on symbol ${this.type}`);
                    (0, $bbd3d886140ad386$export$402b940662af5211).playSound("appearingWild");
                }
                if (entry.animation.name.includes("land") && this.type === "200") {
                    if (!$4706fae892b9b431$export$3e25e887b7a5b37b.playedAppearingWildAudio) {
                        console.log(`playing land audio on symbol ${this.type}`);
                        (0, $bbd3d886140ad386$export$402b940662af5211).playSound("appearingWild");
                        $4706fae892b9b431$export$3e25e887b7a5b37b.playedAppearingWildAudio = true;
                    }
                }
                if (!$4706fae892b9b431$export$3e25e887b7a5b37b.playedExpandingWildAudio) {
                    if (entry.animation.name.includes("expand")) {
                        console.log(`playing expand audio on symbol ${this.type}`);
                        (0, $bbd3d886140ad386$export$402b940662af5211).playSound("expandingWild");
                    }
                    $4706fae892b9b431$export$3e25e887b7a5b37b.playedExpandingWildAudio = true;
                }
            },
            end: function(entry) {},
            dispose: function(entry) {}
        });
    }
    async win(quickStop) {
        if (this.isWinAnimating) return Promise.resolve();
        this.isWinAnimating = true;
        return new Promise((resolve)=>{
            const animationName = this.type === "200" ? "match_expand" : "match";
            const idleName = this.type === "200" ? "idle_expand" : "idle";
            // 1. Create a stable listener object
            const listener = {
                complete: (entry)=>{
                    // console.log(`completed animation ${animationName}`);
                    if (entry.animation.name === animationName) {
                        // 2. Remove using the exact object reference
                        this.symbol.state.removeListener(listener);
                        this.isWinAnimating = false;
                        resolve();
                    }
                }
            };
            this.symbol.state.addListener(listener);
            this.symbol.state.setAnimation(0, animationName, false);
            this.symbol.state.addAnimation(0, idleName, true, 0);
            if (quickStop) {
                this.symbol.state.removeListener(listener); // Clean up immediately
                this.isWinAnimating = false;
                resolve();
            }
        });
    }
    expandWild() {
        return new Promise((resolve)=>{
            if (this.type === "200") {
                this.once("expand", ()=>{
                    this.symbol.state.setAnimation(0, "idle_expand", true);
                    resolve();
                });
                this.symbol.state.setAnimation(0, "expand", false);
            } else resolve();
        });
    }
    hideSymbol() {
        return new Promise((resolve)=>{
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(this, {
                alpha: 0,
                duration: 0.1,
                onComplete: ()=>{
                    resolve();
                }
            });
        });
    }
    land() {
        this.symbol.state.setAnimation(0, "land", false);
        this.symbol.state.addAnimation(0, "idle", true);
    }
    idle() {
        let animationName = "idle";
        if (this.type === "10") animationName = "m_idle_on";
        // Get the animation duration (in frames or time)
        const animation = this.symbol.skeleton.data.findAnimation(animationName);
        if (animation) {
            const duration = animation.duration;
            // Randomly pick a time between 0 and the animation duration
            const randomTime = Math.random() * duration;
            // Set the animation to play from the random time
            this.symbol.state.setAnimation(0, animationName, true).timeScale = 0.5; // loop is set to true
            this.symbol.state.update(randomTime);
        }
    }
}


var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $852805a52f1deab9$export$eb5ccdbd077479c = /*#__PURE__*/ function(GameState) {
    GameState["MAIN"] = "MAIN";
    GameState["MAIN_TO_BONUS"] = "MAIN_TO_BONUS";
    GameState["BONUS"] = "BONUS";
    GameState["BONUS_TO_MAIN"] = "BONUS_TO_MAIN";
    return GameState;
}({});
class $852805a52f1deab9$export$937f7100a7ce63f2 extends (0, $5440e9199a418654$exports.EventEmitter) {
    // Private constructor to prevent instantiation
    constructor(){
        super(), // Private fields
        this._bet = 10 // Default bet amount
        , this._state = "MAIN", this._balance = 1000 // Initial balance
        , this._freespins = 0 // Initial freespins
        , this._soundOn = true, this._fastOn = false;
    }
    // Public getter methods for readonly fields
    get bet() {
        return this._bet;
    }
    get state() {
        return this._state;
    }
    get balance() {
        return this._balance;
    }
    get freespins() {
        return this._freespins;
    }
    get soundOn() {
        return this._soundOn;
    }
    get fastOn() {
        return this._fastOn;
    }
    // Static method to get the singleton instance
    static getInstance() {
        if (!$852805a52f1deab9$export$937f7100a7ce63f2.instance) $852805a52f1deab9$export$937f7100a7ce63f2.instance = new $852805a52f1deab9$export$937f7100a7ce63f2();
        return $852805a52f1deab9$export$937f7100a7ce63f2.instance;
    }
    // Method to update state
    updateState(data) {
        Object.keys(data).forEach((key)=>{
            if (data.hasOwnProperty(key)) this[`_${key}`] = data[key];
        });
        // Emit an 'update' event with the instance itself
        this.emit('update', this);
    }
}


// observer.ts
class $587a15fb35551ac3$var$Observer {
    constructor(){
        this.events = {};
    }
    static getInstance() {
        if (!$587a15fb35551ac3$var$Observer.instance) $587a15fb35551ac3$var$Observer.instance = new $587a15fb35551ac3$var$Observer();
        return $587a15fb35551ac3$var$Observer.instance;
    }
    subscribe(event, callback) {
        this.on(event, callback);
    }
    publish(event, ...args) {
        const callbacks = this.events[event];
        if (callbacks) callbacks.forEach((callback)=>callback(...args));
    }
    on(event, callback) {
        if (!this.events[event]) this.events[event] = [];
        this.events[event].push(callback);
    }
    once(event, callback) {
        const wrapper = (...args)=>{
            callback(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
    }
    off(event, callback) {
        if (this.events[event]) this.events[event] = this.events[event].filter((cb)=>cb !== callback);
    }
}
const $587a15fb35551ac3$export$b6ae1bc530f4c149 = $587a15fb35551ac3$var$Observer.getInstance();




class $60f18d778f0d7742$export$b2278035370d6017 {
    constructor(){
        this.isDebug = false // Set to true for local testing
        ;
        const params = new URLSearchParams(window.location.search);
        const gameId = params.get("gameId") || "risingcup"; // Default value if not provided
        const playerId = params.get("playerId") || "player1"; // Default value if not provided
        if (!gameId || !playerId) throw new Error("Missing gameId or playerId in URL");
        this.gameId = gameId;
        this.playerId = playerId;
        this.baseUrl = this.isDebug ? "http://localhost:3000" : "https://slot-backend-190897502095.us-central1.run.app";
    }
    async getInitialState() {
        try {
            const response = await fetch(`${this.baseUrl}/init`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    gameId: this.gameId,
                    playerId: this.playerId
                })
            });
            if (!response.ok) throw new Error(await response.text());
            const data = await response.json();
            (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).publish("init", data);
        } catch (error) {
            console.error("Failed to fetch initial state:", error);
        }
    }
    async gameAction(rig) {
        try {
            const bet = (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().bet;
            const response = await fetch(`${this.baseUrl}/spin`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    gameId: this.gameId,
                    playerId: this.playerId,
                    bet: bet,
                    rig: rig
                })
            });
            if (!response.ok) throw new Error(await response.text());
            const data = await response.json();
            (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).publish("spin", data);
        } catch (error) {
            console.error("Failed to perform spin:", error);
        }
    }
    on(eventName, callback) {
        (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).on(eventName, callback);
    }
    off(eventName, callback) {
        (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).off(eventName, callback);
    }
    onInitialStateResult(callback) {
        (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).on("init", callback);
    }
    onGameActionResult(callback) {
        (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).on("spin", callback);
    }
}


class $7502dfc019795313$export$4193d9976a2c789 {
    constructor(){
        this.config = {
            reels: 5,
            rows: 3,
            isCascade: false,
            isMock: true,
            winType: "line"
        };
        this.counter = 0;
        this.rig = "";
        // Use EngineMock for testing purposes
        if (this.config.isMock) this.client = new (0, $60f18d778f0d7742$export$b2278035370d6017)();
        // Set up event listeners for initial state and game action results
        this.client.onInitialStateResult((data)=>{
            this.loadResponse = data;
            (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
                bet: data.bet ? data.bet : 1,
                balance: data.balance,
                state: data.state
            });
            (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).publish('initialStateResponse', data);
        });
        this.client.onGameActionResult((data)=>{
            this.data = data;
            console.log(this.data);
            let balance = data.balance || (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().balance;
            // Update balance based on game state and wins
            if (data.state === (0, $852805a52f1deab9$export$eb5ccdbd077479c).BONUS_TO_MAIN && data.totalWin) balance += data.totalWin;
            else if (data.roundWin && data.state === (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN && data.wins.length === 0) balance += data.roundWin;
            (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
                balance: balance,
                state: data.state
            });
            (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).publish('gameActionResponse', data);
        });
        (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).subscribe("rigSelected", (rig)=>{
            this.rig = rig;
        });
        // Initialize number formatter
        this.formatter = new Intl.NumberFormat('en', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    // Public method to get the singleton instance
    static getInstance() {
        if (!$7502dfc019795313$export$4193d9976a2c789.instance) $7502dfc019795313$export$4193d9976a2c789.instance = new $7502dfc019795313$export$4193d9976a2c789();
        return $7502dfc019795313$export$4193d9976a2c789.instance;
    }
    getFormatter() {
        return this.formatter;
    }
    // Initialize the game engine
    async init() {
        await this.client.getInitialState();
    }
    // Handle game action requests
    gameActionRequest() {
        this.spin(this.rig);
        this.rig = ""; // Reset cheat after use
    }
    // Perform a spin action
    spin(rig) {
        this.client.gameAction(rig);
    }
    // Get the latest game response
    getResponse() {
        return this.data;
    }
    // Get the initial load response
    getLoadResponse() {
        return this.loadResponse;
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $4rhnu = parcelRequire("4rhnu");
var $gc0ip = parcelRequire("gc0ip");
class $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6 {
}


parcelRequire("iuB9z");
var $bja9j = parcelRequire("bja9j");
class $1207aae49fb03bed$var$AppSingleton {
    constructor(){
        this.app = new $bja9j.Application();
    }
    static getInstance() {
        if (!$1207aae49fb03bed$var$AppSingleton.instance) $1207aae49fb03bed$var$AppSingleton.instance = new $1207aae49fb03bed$var$AppSingleton();
        return $1207aae49fb03bed$var$AppSingleton.instance;
    }
}
var $1207aae49fb03bed$export$2e2bcd8739ae039 = $1207aae49fb03bed$var$AppSingleton;


class $a132e74cb7d48d50$export$2d669a97455aff47 extends $eicwU.Container {
    constructor(){
        super();
        this.app = (0, $1207aae49fb03bed$export$2e2bcd8739ae039).getInstance().app;
        this.app.stage.on("resize", this.resize, this);
        this.content = new $eicwU.Container();
        this.addChild(this.content);
        this.loadingContent = new $eicwU.Container();
        this.loadingContent.visible = true;
        this.logo = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading.loadingAtlas.textures["gameLogo.png"]);
        this.logo.anchor.set(0.5);
        this.plant1 = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading.loadingAtlas.textures["plant.png"]);
        this.plant2 = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading.loadingAtlas.textures["plant.png"]);
        this.plant1.anchor.set(0.5);
        this.plant2.scale.set(-1, 1);
        this.plant2.anchor.set(0.5);
        this.background = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading.introBg);
        this.background.anchor.set(0.5);
        const loadingBar = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading.loadingAtlas.textures["introFillBar.png"]);
        loadingBar.anchor.set(0.5);
        loadingBar.y = 0;
        const loadingBarBg = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading.loadingAtlas.textures["introFillBg.png"]);
        loadingBarBg.anchor.set(0.5);
        loadingBarBg.y = 0;
        // Create a mask (a rectangle that grows with progress)
        this.loadingMask = new $3cebA.Graphics();
        this.loadingMask.rect(0, 0, loadingBar.width, loadingBar.height).fill(0xffffff);
        this.loadingMask.x = loadingBar.x - loadingBar.width / 2;
        this.loadingMask.y = loadingBar.y - loadingBar.height / 2;
        this.loadingMask.width = 0;
        loadingBar.mask = this.loadingMask;
        // Set the max width for the loading bar
        this.loadingBarWidth = loadingBar.width;
        this.loadingContent.addChild(loadingBarBg);
        this.loadingContent.addChild(loadingBar);
        this.loadingContent.addChild(this.loadingMask);
        this.content1 = new $eicwU.Container();
        this.content1.position.set(0, 50);
        const content1Text = new $gc0ip.Text({
            text: "All wilds are expanding!",
            style: {
                fontSize: 40,
                align: "center",
                wordWrap: true,
                wordWrapWidth: 600,
                fontFamily: "TextFont",
                fill: "0xfad035",
                stroke: {
                    color: "0x4a1850",
                    width: 4,
                    join: "round"
                }
            }
        });
        const content1Texture = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading.loadingAtlas.textures["content1.png"]);
        content1Texture.anchor.set(0.5);
        content1Texture.y = 20;
        content1Text.anchor.set(0.5);
        content1Text.position.set(0, 230);
        this.content1.addChild(content1Text);
        this.content1.addChild(content1Texture);
        const content3Text = new $gc0ip.Text({
            text: "Win Up To 1000x Your Bet!",
            style: {
                fontSize: 60,
                align: "center",
                wordWrap: false,
                fontFamily: "TextFont",
                fill: "0xfad035",
                stroke: {
                    color: "0x4a1850",
                    width: 4,
                    join: "round"
                }
            }
        });
        content3Text.anchor.set(0.5);
        const content3RtpText = new $gc0ip.Text({
            text: "RTP: 96.12%",
            style: {
                fontSize: 40,
                align: "center",
                wordWrap: true,
                wordWrapWidth: 600,
                fontFamily: "TextFont",
                fill: "0xffffff",
                stroke: {
                    color: "0x000",
                    width: 4,
                    join: "round"
                }
            }
        });
        content3RtpText.anchor.set(0.5);
        content3RtpText.position.set(0, 70);
        this.content3 = new $eicwU.Container();
        this.content3.addChild(content3Text);
        this.content3.addChild(content3RtpText);
        this.tapText = new $gc0ip.Text({
            text: "Tap Anywhere to Continue",
            style: {
                fontSize: 40,
                align: "center",
                fontFamily: "TextFont",
                fill: "0xffffff",
                stroke: {
                    color: "0x000000",
                    width: 4,
                    join: "round"
                }
            }
        });
        this.tapText.anchor.set(0.5);
        this.tapText.position.set(0, 450);
        this.tapText.visible = false;
        this.onHandleKeyDown = this.handleKeyDown.bind(this);
        this.content.addChild(this.background);
        this.content.addChild(this.logo);
        this.content.addChild(this.plant1);
        this.content.addChild(this.plant2);
        this.content.addChild(this.tapText);
        this.content.addChild(this.loadingContent);
        this.content.addChild(this.content1);
        this.content.addChild(this.content3);
    }
    handleKeyDown(event) {
        switch(event.code){
            case "Space":
            case "Enter":
                this.onScreenClick();
                break;
        }
    }
    onScreenClick() {
        this.off("pointerup", this.onScreenClick, this);
        window.removeEventListener("keyup", this.onHandleKeyDown);
        this.emit("onScreenClick");
    }
    updateProgress(progress) {
        // Update the mask width based on the progress
        this.loadingMask.width = this.loadingBarWidth * progress; // Scale the width
    }
    showTapText() {
        this.interactive = true;
        this.on("pointerup", this.onScreenClick, this);
        window.addEventListener("keyup", this.onHandleKeyDown);
        this.loadingContent.visible = false;
        this.tapText.visible = true;
    }
    resize(data) {
        if (data.ratio < 1.4) this.onPortrait();
        else this.onLandscape();
    }
    onPortrait() {
        this.background.scale.set(1.8);
        this.logo.scale.set(1.2);
        this.logo.position.set(0, -650);
        this.loadingContent.position.set(0, 800);
        this.tapText.position.set(0, 800);
        this.tapText.scale.set(1.5);
        this.plant1.position.set(-600, 800);
        this.plant2.position.set(650, 850);
        this.plant1.scale.set(2, 2);
        this.plant2.scale.set(-2, 2);
        this.content1.position.set(0, 100);
        this.content1.scale.set(1.5);
        this.content3.position.set(0, -300);
        this.content3.scale.set(0.9);
    }
    onLandscape() {
        this.background.scale.set(1);
        this.logo.scale.set(0.8);
        this.logo.position.set(0, -400);
        this.loadingContent.position.set(0, 450);
        this.tapText.position.set(0, 450);
        this.tapText.scale.set(1);
        this.plant1.position.set(-650, 350);
        this.plant2.position.set(650, 350);
        this.plant1.scale.set(1, 1);
        this.plant2.scale.set(-1, 1);
        this.content1.position.set(0, 50);
        this.content1.scale.set(1);
        this.content3.position.set(0, -200);
        this.content3.scale.set(1);
    }
}



parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $1HooC = parcelRequire("1HooC");
var $4rhnu = parcelRequire("4rhnu");
var $gc0ip = parcelRequire("gc0ip");
var $7EPSr = parcelRequire("7EPSr");


parcelRequire("logJB");
var $1ovqM = parcelRequire("1ovqM");
parcelRequire("iuB9z");
var $a32IU = parcelRequire("a32IU");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $4J7WL = parcelRequire("4J7WL");

parcelRequire("iuB9z");
var $1HooC = parcelRequire("1HooC");
function $eaf33f53abcad223$export$660d7e9fbd8bd424(object, newParent) {
    // Ensure the object and newParent are valid
    if (!object || !newParent) {
        console.error('Invalid object or new parent container.');
        return;
    }
    // Step 1: Calculate the world position of the container
    const worldPosition = object.toGlobal(new $1HooC.Point());
    // Step 2: Remove the container from its current parent and add it to the new parent
    if (object.parent) object.parent.removeChild(object);
    newParent.addChild(object);
    // Step 3: Recalculate the local position relative to the new parent
    const localPosition = newParent.toLocal(worldPosition);
    // Set the container's position to the calculated local position
    object.position.set(localPosition.x, localPosition.y);
}
function $eaf33f53abcad223$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


parcelRequire("iuB9z");
var $aV5iD = parcelRequire("aV5iD");
var $eicwU = parcelRequire("eicwU");
var $4J7WL = parcelRequire("4J7WL");
const $204b514c569eb3d8$var$WIDTH = 20;
const $204b514c569eb3d8$var$HEIGHT = 25;
const $204b514c569eb3d8$var$GRAVITY = 0.4;
class $204b514c569eb3d8$var$Particle extends $eicwU.Container {
    constructor(texture){
        super();
        this.sprite = new $aV5iD.AnimatedSprite(texture);
        this.addChild(this.sprite);
        this.sprite.anchor.set(0.5);
        this.sprite.animationSpeed = 0.5;
        this.velocity = {
            x: 0,
            y: 0
        };
        this.gravity = $204b514c569eb3d8$var$GRAVITY;
        this.life = 0;
        this.active = false;
        this.visible = false; // 🔹 Hides the particle until it's initialized
    }
    init(x, y, velocityX, velocityY, life) {
        this.position.set(x + Math.random() * 400 - 200, y);
        this.velocity.x = velocityX;
        this.velocity.y = velocityY;
        this.sprite.scale.set(0.5 + Math.random() * 0.5);
        this.life = life;
        this.active = true;
        this.sprite.gotoAndPlay(Math.round(Math.random() * (this.sprite.totalFrames - 1)));
        this.visible = true;
    }
    update(delta) {
        if (!this.active) return;
        this.velocity.y += this.gravity * delta;
        this.x += this.velocity.x * delta;
        this.y += this.velocity.y * delta;
        this.angle += 1 * delta;
        this.life--;
        if (this.life <= 0) {
            this.active = false;
            this.sprite.stop();
            this.visible = false;
        }
    }
}
class $204b514c569eb3d8$export$f219b6a0e4bb0b6d extends $eicwU.Container {
    constructor(texture, maxParticles){
        super(), this.emitting = false, this.update = (ticker)=>{
            this.particles.forEach((p)=>p.update(ticker.deltaTime));
        };
        this.texture = texture;
        this.particles = Array.from({
            length: maxParticles
        }, ()=>new $204b514c569eb3d8$var$Particle(texture));
        this.particles.forEach((p)=>this.addChild(p));
        // Add update function to Pixi's ticker
        $4J7WL.Ticker.shared.add(this.update, this);
    }
    emitParticle(x, y, velocityX, velocityY, life) {
        const particle = this.particles.find((p)=>!p.active);
        if (particle) particle.init(x, y, velocityX, velocityY, life);
    }
    start(x, y, interval = 100) {
        if (this.emitting) return;
        this.emitting = true;
        this.intervalId = window.setInterval(()=>{
            this.emitParticle(x, y, Math.random() * $204b514c569eb3d8$var$WIDTH - $204b514c569eb3d8$var$WIDTH / 2, -Math.random() * $204b514c569eb3d8$var$HEIGHT, 300);
        }, interval);
    }
    stop() {
        if (this.intervalId !== undefined) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
            this.emitting = false;
        }
    }
    destroy() {
        $4J7WL.Ticker.shared.remove(this.update, this);
        super.destroy();
    }
}






class $b80a71fbc2c8197b$export$2e2bcd8739ae039 {
    static mapRange(value, inMin, inMax, outMin, outMax) {
        return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
    }
    static lerp(a, b, t) {
        return a + (b - a) * t;
    }
    static clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }
}



class $5c4dd7c86681d247$var$GameStateSoundManager {
    get musicMain() {
        return this._musicMain;
    }
    get musicBonus() {
        return this._musicBonus;
    }
    constructor(){
        this._musicMain = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)();
        this._musicBonus = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)();
        this._musicMainBaseVolume = 0;
        this._musicBonusBaseVolume = 0;
        document.addEventListener("BONUS_START", ()=>{
            this.updateBgMusic('bonusStart');
        });
        document.addEventListener("BONUS_END", ()=>{
            this.updateBgMusic('bonusEnd');
        });
        document.addEventListener("TOTAL_WIN", ()=>{
            this.updateBgMusic('none');
        });
    }
    static getInstance() {
        if (!$5c4dd7c86681d247$var$GameStateSoundManager._instance) $5c4dd7c86681d247$var$GameStateSoundManager._instance = new $5c4dd7c86681d247$var$GameStateSoundManager();
        return $5c4dd7c86681d247$var$GameStateSoundManager._instance;
    }
    updateBgMusicVolume(volume) {
        switch((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().state){
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN:
                volume = (0, $b80a71fbc2c8197b$export$2e2bcd8739ae039).clamp(volume ?? this._musicMainBaseVolume, 0, 1);
                (0, $bbd3d886140ad386$export$402b940662af5211).setSoundInstanceVolume(this._musicMain, volume);
                break;
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).BONUS:
                volume = (0, $b80a71fbc2c8197b$export$2e2bcd8739ae039).clamp(volume ?? this._musicBonusBaseVolume, 0, 1);
                (0, $bbd3d886140ad386$export$402b940662af5211).setSoundInstanceVolume(this._musicBonus, volume);
                break;
        }
    }
    async updateBgMusic(command) {
        switch(command){
            case 'none':
                if (this._musicBonus.tryGetMediaInstance()) (0, $bbd3d886140ad386$export$402b940662af5211).setSoundInstanceVolume(this._musicBonus, 0, 2, ()=>{
                    (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this._musicBonus);
                    this._musicBonus.reset();
                    (0, $bbd3d886140ad386$export$402b940662af5211).playSound("totalWin");
                });
                break;
            case 'gameStart':
            case 'bonusEnd':
                console.log("Ended Bonus");
                if (this._musicBonus.tryGetMediaInstance()) {
                    (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this._musicBonus);
                    this._musicBonus.reset();
                }
                const musicMain = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("musicMain");
                if (musicMain) {
                    this._musicMain = musicMain;
                    this._musicMainBaseVolume = musicMain.getBaseVolume();
                }
                break;
            case 'bonusStart':
                console.log("Started Bonus");
                if (this._musicMain.tryGetMediaInstance()) {
                    (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this._musicMain);
                    this._musicMain.reset();
                }
                const musicBonus = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("musicBonus");
                if (musicBonus) {
                    this._musicBonus = musicBonus;
                    this._musicBonusBaseVolume = musicBonus.getBaseVolume();
                }
                await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("bonusCollect");
                break;
        }
    }
}
const $5c4dd7c86681d247$export$69b20b9d7ca9f56e = $5c4dd7c86681d247$var$GameStateSoundManager.getInstance();



const $07fae797887d9e1d$var$WIN_FONT_SIZE = 80;
const $07fae797887d9e1d$var$BIG_WIN_FONT_SIZE = 100;
const $07fae797887d9e1d$var$LABEL_OFFSET_BIG_WINS = 250;
const $07fae797887d9e1d$var$WIN_REMAIN_DURATION = 1500;
const $07fae797887d9e1d$var$WIN_LAST_DURATION = [
    6000,
    10000,
    17000
]; // a few seconds off each duration, to line up with the sounds
class $07fae797887d9e1d$export$d6bf22216e59f666 extends $eicwU.Container {
    constructor(){
        super(), this.prize = 0, this.odd = 0, this.isStopped = false, this.level = -1, // Used to prevent stopping and replaying the same sounds
        this.alreadyPlayedWinSounds = new Set(), this.winSmall = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.winNormal = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.winBig = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.winSuper = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.winMega = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.swordBattle = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.lionBattle = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)();
        this.particleSystem = new (0, $204b514c569eb3d8$export$f219b6a0e4bb0b6d)((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.coinAtlas.animations.Coin, 100);
        this.winLabel = new $a32IU.BitmapText({
            text: "123456.00",
            style: {
                fontSize: $07fae797887d9e1d$var$WIN_FONT_SIZE,
                fontFamily: "winFont",
                fill: "0xffffff"
            }
        });
        this.winLabelContainer = new $eicwU.Container();
        this.winLabel.position.set(0, 0);
        this.winLabel.anchor.set(0.5);
        this.winLayer = new $3cebA.Graphics().rect(-2000, -2000, 4000, 4000).fill(0);
        this.winLayer.alpha = 0.7;
        this.winTitles = (0, $1ovqM.Spine).from({
            skeleton: "winsJson",
            atlas: "winsAtlas"
        });
        this.winTitles.state.addListener({
            event: function(entry, event) {},
            start: async (entry)=>{
                if (entry.animation.name.includes("Hide")) switch(this.level){
                    case 2:
                        if (entry.animation.name.includes("big")) {
                            console.log("stopped big win sounds");
                            (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winEnd");
                            this._stopAllWinSounds();
                        } else if (entry.animation.name.includes("super")) ;
                        else entry.animation.name.includes("mega");
                        break;
                    case 3:
                        if (entry.animation.name.includes("big")) ;
                        else if (entry.animation.name.includes("super")) {
                            console.log("stopped super win sounds");
                            (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winEnd");
                            this._stopAllWinSounds();
                        } else entry.animation.name.includes("mega");
                        break;
                    case 4:
                        if (entry.animation.name.includes("big")) ;
                        else if (entry.animation.name.includes("super")) ;
                        else if (entry.animation.name.includes("mega")) {
                            console.log("stopped mega win sounds");
                            (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winEnd");
                            this._stopAllWinSounds();
                        }
                        break;
                }
            },
            complete: async (entry)=>{
                if (entry.animation) this.emit(entry.animation.name);
                if (entry.animation.name.includes("Show")) {
                    console.log(entry.animation.name);
                    switch(this.level){
                        case 2:
                            await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("swordHit");
                            break;
                        case 3:
                            if (entry.animation.name.includes("big")) await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("swordHit");
                            else if (entry.animation.name.includes("super")) this.swordBattle = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("swordBattle");
                            break;
                        case 4:
                            if (entry.animation.name.includes("big")) await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("swordHit");
                            else if (entry.animation.name.includes("super")) this.swordBattle = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("swordBattle");
                            else if (entry.animation.name.includes("mega")) this.lionBattle = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("lionBattle");
                            break;
                    }
                }
                // Handle quick stop sounds
                if (this.isStopped && entry.animation.name.includes("Hide")) {
                    console.log("COMPLETED ANIMATION WHILE IS STOPPED IS TRUE");
                    switch(this.level){
                        case 2:
                            if (this.winBig) {
                                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.winBig);
                                this.winBig = undefined;
                            }
                            break;
                        case 3:
                            if (this.winSuper) {
                                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.winSuper);
                                this.winSuper = undefined;
                            }
                            break;
                        case 4:
                            if (this.winMega) {
                                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.winMega);
                                this.winMega = undefined;
                            }
                            break;
                    }
                }
            },
            end: function(entry) {},
            dispose: function(entry) {}
        });
        this.winTitles.position.set(0, -200);
        this.winTitles.scale.set(0.5);
        this.addChild(this.winLayer);
        this.addChild(this.particleSystem);
        this.addChild(this.winTitles);
        this.addChild(this.winLabelContainer);
        this.winLayer.visible = false;
        this.winTitles.visible = false;
        this.winLabelContainer.visible = false;
        this.winLabelContainer.addChild(this.winLabel);
    }
    async _showStaticWin() {
        return new Promise((resolve)=>{
            console.log("static win");
            this.winLabel.y = 0;
            this.winLabel.style.fontSize = $07fae797887d9e1d$var$WIN_FONT_SIZE;
            this.winLabel.text = (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(this.prize);
            setTimeout(()=>{
                if (this.winSmall) {
                    (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.winSmall);
                    this.winSmall = undefined;
                }
                resolve();
            }, 1000);
        });
    }
    async _showCounterWin() {
        return new Promise(async (resolve)=>{
            console.log("counter win");
            this.winLabel.y = 0;
            this.winLabel.style.fontSize = $07fae797887d9e1d$var$BIG_WIN_FONT_SIZE;
            this.winLabel.text = (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(this.prize);
            await this._showProgressWin(2200);
            setTimeout(()=>{
                if (this.winNormal) {
                    (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.winNormal);
                    this.winNormal = undefined;
                }
                resolve();
            }, 1000);
        });
    }
    async _showBigWin() {
        return new Promise(async (resolve)=>{
            this.particleSystem.start(0, 250, 100);
            this.winLabel.y = $07fae797887d9e1d$var$LABEL_OFFSET_BIG_WINS;
            this.winTitles.visible = true;
            this.winTitles.state.setAnimation(0, `bigWinShow`, false);
            this.winTitles.state.addAnimation(0, `bigWinLoop`, true);
            this.winLabel.style.fontSize = $07fae797887d9e1d$var$BIG_WIN_FONT_SIZE;
            await this._showProgressWin($07fae797887d9e1d$var$WIN_LAST_DURATION[0]);
            await (0, $eaf33f53abcad223$export$1391212d75b2ee65)($07fae797887d9e1d$var$WIN_REMAIN_DURATION);
            this.winTitles.state.setAnimation(0, `bigWinHide`, false);
            this.particleSystem.stop();
            setTimeout(()=>{
                resolve();
            }, 500);
        });
    }
    async _showSuperWin() {
        return new Promise(async (resolve)=>{
            this.particleSystem.start(0, 250, 100);
            this.winLabel.y = $07fae797887d9e1d$var$LABEL_OFFSET_BIG_WINS;
            this.winTitles.visible = true;
            this.winTitles.state.setAnimation(0, `bigWinShow`, false);
            this.winTitles.state.addAnimation(0, `bigWinLoop`, false);
            this.winTitles.state.addAnimation(0, `bigWinHide`, false);
            this.winTitles.state.addAnimation(0, `superWinShow`, false);
            this.winTitles.state.addAnimation(0, `superWinLoop`, true);
            this.winLabel.style.fontSize = $07fae797887d9e1d$var$BIG_WIN_FONT_SIZE;
            await this._showProgressWin($07fae797887d9e1d$var$WIN_LAST_DURATION[1]);
            await (0, $eaf33f53abcad223$export$1391212d75b2ee65)($07fae797887d9e1d$var$WIN_REMAIN_DURATION);
            this.winTitles.state.setAnimation(0, `superWinHide`, false);
            if (this.swordBattle) {
                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.swordBattle);
                this.swordBattle = undefined;
            }
            this.particleSystem.stop();
            setTimeout(()=>{
                resolve();
            }, 500);
        });
    }
    async _showMegaWin() {
        return new Promise(async (resolve)=>{
            this.particleSystem.start(0, 250, 100);
            this.winLabel.y = $07fae797887d9e1d$var$LABEL_OFFSET_BIG_WINS;
            this.winTitles.visible = true;
            this.winTitles.state.setAnimation(0, `bigWinShow`, false);
            this.winTitles.state.addAnimation(0, `bigWinLoop`, false);
            this.winTitles.state.addAnimation(0, `bigWinHide`, false);
            this.winTitles.state.addAnimation(0, `superWinShow`, false);
            this.winTitles.state.addAnimation(0, `superWinLoop`, false);
            this.winTitles.state.addAnimation(0, `superWinHide`, false);
            this.winTitles.state.addAnimation(0, `megaWinShow`, false);
            this.winTitles.state.addAnimation(0, `megaWinLoop`, true);
            this.winLabel.style.fontSize = $07fae797887d9e1d$var$BIG_WIN_FONT_SIZE;
            await this._showProgressWin($07fae797887d9e1d$var$WIN_LAST_DURATION[2]);
            await (0, $eaf33f53abcad223$export$1391212d75b2ee65)($07fae797887d9e1d$var$WIN_REMAIN_DURATION);
            this.winTitles.state.setAnimation(0, `megaWinHide`, false);
            if (this.swordBattle) {
                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.swordBattle);
                this.swordBattle = undefined;
            }
            if (this.lionBattle) {
                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.lionBattle);
                this.lionBattle = undefined;
            }
            this.particleSystem.stop();
            setTimeout(()=>{
                resolve();
            }, 500);
        });
    }
    onLandscape() {
        this.winTitles.scale.set(0.2);
        this.winTitles.y = 0;
        this.winLabelContainer.y = 50;
    }
    onPortrait() {
        this.winTitles.scale.set(0.3);
        this.winTitles.y = 0;
        this.winLabelContainer.y = 100;
    }
    async _showProgressWin(duration = 2000) {
        return new Promise((resolve)=>{
            if (duration <= 0) {
                this.winLabel.text = (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(this.prize);
                return resolve();
            }
            const startTime = performance.now();
            const endValue = this.prize;
            const ticker = $4J7WL.Ticker.shared;
            this.isStopped = false;
            const update = ()=>{
                const now = performance.now();
                const elapsed = now - startTime;
                const progress = Math.min(elapsed / duration, 1);
                // --- THE EASING MAGIC: Ease-In-Out Cubic ---
                const easedProgress = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
                const currentValue = endValue * easedProgress;
                // Handle Early Stop or Completion
                if (this.isStopped || progress >= 1) {
                    ticker.remove(update);
                    this.winLabel.text = (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(endValue);
                    if (this.isStopped && (this.level === 0 || this.level === 1)) this._stopAllWinSounds();
                    setTimeout(resolve, 1000);
                    return;
                }
                this.winLabel.text = (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(currentValue);
            };
            ticker.add(update);
        });
    }
    async showPrize(prize, odd) {
        return new Promise(async (resolve)=>{
            this.isStopped = false;
            this.winTitles.visible = false;
            (0, $5c4dd7c86681d247$export$69b20b9d7ca9f56e).updateBgMusicVolume(0.2);
            let coinLoop = undefined;
            this.alreadyPlayedWinSounds.clear();
            this.winLayer.visible = true;
            this.winLabelContainer.visible = true;
            this.prize = prize;
            this.odd = odd;
            if (this.odd < 20) {
                this.level = 0;
                this.winSmall = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winSmall");
                await this._showStaticWin();
            } else if (this.odd < 50) {
                this.level = 1;
                this.winNormal = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winNormal");
                await this._showCounterWin();
                await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winEnd");
            } else if (this.odd < 502) {
                this.level = 2;
                this.winBig = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winBig");
                coinLoop = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("coinLoop");
                console.log("win big played");
                await this._showBigWin();
            } else if (this.odd < 542) {
                this.level = 3;
                if (!this.alreadyPlayedWinSounds.has("winSuper")) {
                    this.winSuper = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winSuper");
                    coinLoop = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("coinLoop");
                    this.alreadyPlayedWinSounds.add("winSuper");
                }
                await this._showSuperWin();
            } else {
                this.level = 4;
                if (!this.alreadyPlayedWinSounds.has("winMega")) {
                    this.winMega = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("winMega");
                    coinLoop = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("coinLoop");
                    this.alreadyPlayedWinSounds.add("winMega");
                }
                await this._showMegaWin();
            }
            this.isStopped = false;
            if (coinLoop) {
                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(coinLoop);
                coinLoop = undefined;
            }
            (0, $5c4dd7c86681d247$export$69b20b9d7ca9f56e).updateBgMusicVolume();
            this.winTitles.visible = false;
            this.winLayer.visible = false;
            this.winLabelContainer.visible = false;
            resolve();
        });
    }
    quickStop() {
        this.isStopped = true;
        switch(this.level){
            case 0:
                break;
            case 1:
                break;
            case 2:
                break;
            case 3:
                if (this.winTitles.state.getCurrent(0)?.animation?.name.includes("big")) {
                    this.winTitles.state.setAnimation(0, `superWinShow`, false);
                    this.winTitles.state.addAnimation(0, `superWinLoop`, true);
                }
                break;
            case 4:
                if (this.winTitles.state.getCurrent(0)?.animation?.name.includes("big") || this.winTitles.state.getCurrent(0)?.animation?.name.includes("super")) {
                    this.winTitles.state.setAnimation(0, `megaWinShow`, false);
                    this.winTitles.state.addAnimation(0, `megaWinLoop`, true);
                }
                break;
        }
    }
    _stopAllWinSounds() {
        const sounds = [
            this.winSmall,
            this.winNormal,
            this.winBig,
            this.winSuper,
            this.winMega,
            this.swordBattle,
            this.lionBattle
        ];
        sounds.forEach((sound)=>{
            if (sound) (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(sound);
        });
        // Reset the references
        this.winSmall = this.winNormal = this.winBig = undefined;
        this.winSuper = this.winMega = this.swordBattle = this.lionBattle = undefined;
    }
}



// Define the Reel interface
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");



var $d91fd588aac8eb5d$export$67a7830d065ed33 = /*#__PURE__*/ function(ReelState) {
    ReelState["IDLE"] = "IDLE";
    ReelState["SPIN"] = "SPIN";
    ReelState["STOP"] = "STOP";
    ReelState["SPIN_END"] = "SPIN_END";
    return ReelState;
}({});
class $d91fd588aac8eb5d$export$c7fda9bd1fa78de5 extends $eicwU.Container {
    constructor(reelData, index){
        super(), this.reelData = [], this.symbols = [], this.currentState = "IDLE", this.index = 0, this.quickStop = false;
        this.index = index;
        this.reelData = reelData;
        this._createSymbols();
    }
    expandWild() {
        throw new Error("Method not implemented.");
    }
    /**
   * Get the index of this reel.
   * @returns The index of the reel.
   */ getIndex() {
        return this.index;
    }
    /**
   * Get the reel data.
   * @returns The reel data array.
   */ getData() {
        return this.reelData;
    }
    /**
   * Set the reel data.
   * @param reelData - An array of symbols to populate the reel.
   */ setData(reelData) {
        this.reelData = reelData;
    }
    /**
   * Create symbols and populate the reel.
   */ _createSymbols() {
        for(let i = 0; i < this.reelData.length; i++){
            const symbol = (0, $4706fae892b9b431$export$3e25e887b7a5b37b).pool.acquire();
            symbol.setType(this.reelData[i].toString());
            symbol.y = this._getY(i);
            this.addChild(symbol);
            this.symbols.push(symbol);
            symbol.originalParent = this;
            symbol.originalPosition = symbol.position.clone();
        }
    }
    /**
   * Change the current state of the reel.
   * @param newState - The new state to transition to.
   */ _changeState(newState) {
        if (this.currentState === newState) return;
        this.currentState = newState;
        switch(this.currentState){
            case "IDLE":
                this._onEnterIdle();
                break;
            case "SPIN":
                this._onEnterSpin();
                break;
            case "STOP":
                if (!this.reelData.length) {
                    console.warn("Try to stop reel with no data!");
                    return;
                }
                this._onEnterStop();
                break;
            case "SPIN_END":
                for(let i = 0; i < (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows; i++)this.symbols[i].visible = false;
                break;
        }
        this.emit(this.currentState, this);
    }
    /**
   * Handle logic when entering the idle state.
   */ _onEnterIdle() {
        this.quickStop = false; // Reset quickStop flag
    }
    /**
   * Handle logic when entering the spin state.
   */ async _onEnterSpin() {
        const promises = this.symbols.slice().reverse().map((symbol, index)=>{
            return new Promise((resolve)=>{
                (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(symbol, {
                    y: this.height + symbol.y + symbol.height,
                    duration: this.quickStop ? 0.1 : index * 0.1 + 0.1,
                    // delay: this.quickStop ? 0 : index * 0.1, // Simulate stagger manually
                    onComplete: ()=>{
                        // symbol.visible = false; // Call the method after the animation of each symbol
                        resolve(); // Resolve the promise after the tween is complete
                    }
                });
            });
        });
        // Wait for all tweens to finish
        await Promise.all(promises);
        this._changeState("SPIN_END");
    }
    /**
   * Handle logic when entering the stop state.
   */ async _onEnterStop() {
        this.symbols.forEach((symbol)=>{
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).killTweensOf(symbol);
        });
        // Set symbol types and make them visible
        for(let i = 0; i < this.reelData.length; i++){
            this.symbols[i].setType(this.reelData[i].toString());
            this.symbols[i].visible = true;
            this.symbols[i].y = -800 + this._getY(i);
        }
        const promises = this.symbols.slice().reverse().map((symbol, index)=>{
            return new Promise((resolve)=>{
                (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(symbol, {
                    y: this._getY((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows - 1 - index),
                    duration: this.quickStop ? 0.1 : 0.3,
                    ease: "power2.out",
                    delay: this.quickStop ? 0 : index * 0.07,
                    onComplete: ()=>{
                        symbol.land(); // Call the method after the animation of each symbol
                        resolve(); // Resolve the promise after the tween is complete
                    }
                });
            });
        });
        // Wait for all tweens to finish
        await Promise.all(promises);
        (0, $4706fae892b9b431$export$3e25e887b7a5b37b).playedExpandingWildAudio = false;
        this._changeState("IDLE");
    }
    getState() {
        return this.currentState;
    }
    /**
   * Get the Y position for a symbol based on its row index.
   * @param row - The row index.
   * @returns The calculated Y position.
   */ _getY(row) {
        return (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT * row + (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT / 2;
    }
    /**
   * Get a symbol at a specific index.
   * @param index - The index of the symbol.
   * @returns The symbol at the given index.
   */ getSymbol(index) {
        return this.symbols[index];
    }
    resetData() {
        this.reelData.length = 0;
    }
    /**
   * Trigger the spin state for the reel.
   */ triggerSpin() {
        this._changeState("SPIN");
    }
    /**
   * Trigger the stop state for the reel.
   */ triggerStop(quickStop = false) {
        this.quickStop = quickStop;
        switch(this.currentState){
            case "SPIN":
                this.symbols.forEach((symbol)=>{
                    (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).killTweensOf(symbol);
                });
                this._changeState("SPIN_END");
                break;
            case "SPIN_END":
                this._changeState("STOP");
                break;
        }
    }
    /**
   * Move a symbol to a specific row.
   * @param symbol - The symbol to move.
   * @param row - The row index to move the symbol to.
   * @param delay - The delay before the move starts.
   * @returns A promise that resolves when the movement is complete.
   */ async moveSymbol(symbol, row = 0, delay) {
        return new Promise((resolve)=>{
            this.symbols[row] = symbol;
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(symbol, {
                delay: delay,
                y: this._getY(row),
                duration: this.quickStop ? 0.1 : 0.2,
                ease: "back.out(1)",
                onComplete: ()=>{
                    symbol.land();
                    resolve();
                }
            });
        });
    }
    /**
   * Remove a symbol from a specific row.
   * @param row - The row index to remove the symbol from.
   * @param quickStop - The quickStop is for fast removal
   * @returns A promise that resolves when the symbol is removed.
   */ async removeSymbol(row, quickStop) {
        const symbol = this.symbols[row];
        await symbol.win(quickStop);
        this.removeChild(symbol);
        (0, $4706fae892b9b431$export$3e25e887b7a5b37b).pool.release(symbol);
    }
    startAnticipation() {}
    stopAnticipation() {}
    getScattersAmount() {
        return this.reelData.filter((symbol)=>symbol === "11").length;
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");




parcelRequire("logJB");
var $1ovqM = parcelRequire("1ovqM");

const $b7f9c75db00dc914$var$SPIN_SPEED_NORMAL = 0.05; // Normal spin speed
const $b7f9c75db00dc914$var$SPIN_SPEED_ANTICIPATION = 0.2; // Normal spin speed
const $b7f9c75db00dc914$var$STOP_SPEED_NORMAL = 0.4; // Normal spin speed
const $b7f9c75db00dc914$var$STOP_SPEED_ANTICIPATION = 1.5; // Normal spin speed
class $b7f9c75db00dc914$export$17f36a75b2cd6b8b extends $eicwU.Container {
    /**
   * Constructor for initializing the reel with data and an index
   * @param {string[]} reelData - An array of symbol data for the reel
   * @param {number} index - The index of the reel (for identification)
   */ constructor(reelData, index){
        super(), this.reelData = [] // Array holding the reel's symbol data
        , this.symbols = [] // Array holding the symbols on the reel
        , this.currentState = (0, $d91fd588aac8eb5d$export$67a7830d065ed33).IDLE // Current state of the reel
        , this.delay = 0 // Delay before starting the spin
        , this.spinSpeed = 0 // Spin speed for the reel
        , this.stopSpeed = 0 // Spin speed for the reel
        , this.isStop = false // Flag to stop the reel
        , this.quickStop = false // Flag to indicate if the reel should stop quickly
        , this.index = 0 // Index of the reel
        , this.rowsToHide = [] // Stores the row indexes to hide when stopping
        , this.anticipationSoundInstance = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.isExpandingWild = false;
        this.spinSpeed = $b7f9c75db00dc914$var$SPIN_SPEED_NORMAL;
        this.stopSpeed = $b7f9c75db00dc914$var$STOP_SPEED_NORMAL;
        this.index = index; // Store the reel's index
        this.reelData = reelData; // Set the reel data
        this.content = new $eicwU.Container();
        this.addChild(this.content); // Add the content container to the reel
        this._createSymbols(); // Create the symbols on the reel
        this._createAnticipation(); // Create the symbols on the reel
    }
    /**
   * Set new data for the reel (reel's symbols)
   * @param {string[]} reelData - An array of new symbol data for the reel
   */ setData(reelData) {
        this.reelData = reelData;
    }
    /**
   * Helper function to calculate the y-position of symbols based on row index
   * @param {number} row - The row index of the symbol
   * @returns {number} - The calculated y-position for the symbol
   */ _getY(row) {
        return (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT * row + (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT / 2;
    }
    getState() {
        return this.currentState;
    }
    /**
   * Create symbols and populate the reel.
   */ _createSymbols() {
        for(let i = 0; i < this.reelData.length; i++){
            const symbol = (0, $4706fae892b9b431$export$3e25e887b7a5b37b).pool.acquire();
            symbol.setType(this.reelData[i].toString());
            symbol.y = this._getY(i);
            this.content.addChild(symbol);
            this.symbols.push(symbol);
            symbol.originalParent = this.content;
            symbol.originalPosition = symbol.position.clone();
        }
    }
    hasExpandedWild() {
        return this.isExpandingWild;
    }
    async expandWild() {
        const promises = [];
        if (this.reelData.includes("200")) {
            // Find the symbol with type "200"
            const wildIndex = this.symbols.findIndex((symbol)=>symbol.getType() === "200");
            if (wildIndex !== -1) {
                const wildSymbol = this.symbols[wildIndex];
                // Move the wild symbol to the first index
                this.symbols.splice(wildIndex, 1);
                this.symbols.unshift(wildSymbol);
            }
            this.isExpandingWild = true; // Set the flag to indicate wild expansion
            this.symbols.forEach((symbol, i)=>{
                if (symbol.getType() === "200") {
                    promises.push(symbol.expandWild());
                    (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(symbol, {
                        y: this._getY(0),
                        duration: 0.4,
                        ease: "back.out(1)"
                    });
                } else promises.push(symbol.hideSymbol());
            });
        }
        await Promise.all(promises);
    }
    /**
   * Create symbols and populate the reel.
   */ _createAnticipation() {
        this.anticipationSkeleton = (0, $1ovqM.Spine).from({
            skeleton: `anticipationJson`,
            atlas: `anticipationAtlas`
        });
        this.addChild(this.anticipationSkeleton);
        this.anticipationSkeleton.scale.set(0.2, 0.187);
        this.anticipationSkeleton.position.set(0, this.anticipationSkeleton.height / 2 - 15);
        this.anticipationSkeleton.zIndex = 10;
        this.anticipationSkeleton.visible = false;
        this.anticipationSkeleton.state.addListener({
            complete: (entry)=>{
                if (entry.animation?.name === "hide") this.anticipationSkeleton.visible = false;
            }
        });
    }
    /**
   * Change the state of the reel and trigger corresponding actions
   * @param {ReelState} newState - The new state to transition to
   */ _changeState(newState) {
        if (this.currentState === newState) return; // Avoid unnecessary state changes
        this.currentState = newState; // Update the current state
        switch(this.currentState){
            case (0, $d91fd588aac8eb5d$export$67a7830d065ed33).IDLE:
                this._onEnterIdle(); // Handle entering IDLE state
                break;
            case (0, $d91fd588aac8eb5d$export$67a7830d065ed33).SPIN:
                this._onEnterSpin(); // Handle entering SPIN state
                break;
            case (0, $d91fd588aac8eb5d$export$67a7830d065ed33).STOP:
                this._onEnterStop(); // Handle entering STOP state
                break;
            case (0, $d91fd588aac8eb5d$export$67a7830d065ed33).SPIN_END:
                this.symbols.forEach((symbol)=>{
                    symbol.alpha = 0.8;
                });
                this._spinStep(); // Call the spin step when the animation completes
                break;
        }
        this.emit(this.currentState, this);
    }
    /**
   * Handle actions when entering IDLE state
   * Resets the stop flags.
   */ _onEnterIdle() {
        this.quickStop = false; // Reset quickStop flag
        this.isStop = false; // Reset stop flag
        this.rowsToHide.length = 0;
    }
    /**
   * Handle actions when entering SPIN state
   * Creates a new symbol offscreen and starts the spinning animation.
   */ _onEnterSpin() {
        this.quickStop = false;
        // Create a new symbol and set its position offscreen above the reel
        const symbol = (0, $4706fae892b9b431$export$3e25e887b7a5b37b).pool.acquire();
        symbol.alpha = 1.0;
        symbol.setType(Math.ceil(Math.random() * 8).toString());
        symbol.originalParent = this.content;
        symbol.y = -(0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT / 2;
        this.content.addChild(symbol); // Add the symbol to the reel container
        this.symbols.unshift(symbol); // Add the symbol to the beginning of the symbol array
        // Start spinning animation with GSAP
        this.tween = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(this.content, {
            delay: this.delay,
            ease: "back.in(1)",
            y: (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT,
            duration: 0.3,
            onComplete: ()=>{
                this._changeState((0, $d91fd588aac8eb5d$export$67a7830d065ed33).SPIN_END);
            }
        });
    }
    /**
   * Step of the spinning animation, continues spinning or stops based on the stop flag.
   */ _spinStep() {
        // Only stop if the stop flag is true AND we actually have data to show
        const canStop = this.isStop && this.reelData && this.reelData.length > 0;
        if (canStop) {
            this.isStop = false;
            this._changeState((0, $d91fd588aac8eb5d$export$67a7830d065ed33).STOP);
        } else {
            const symbol = this.symbols.pop();
            // Use random symbols while waiting for real data
            symbol.setType(Math.ceil(Math.random() * 8).toString());
            this.symbols.unshift(symbol);
            const referenceSymbol = this.symbols[1];
            symbol.y = referenceSymbol.y - (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT;
            this.tween = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(this.content, {
                y: this.content.y + (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT,
                duration: this.spinSpeed,
                ease: "linear",
                onComplete: ()=>this._spinStep()
            });
        }
    }
    /**
   * Handle actions when entering STOP state
   * Stops the spinning and repositions the symbols.
   */ _onEnterStop() {
        // 1. Move old symbols to their final landing zone (relative to content)
        this.symbols.forEach((symbol)=>{
            symbol.y += this.content.y + (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows * (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT;
            symbol.alpha = 1;
        });
        // 2. Snap content to its offset position
        this.content.y = -(0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows * (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT;
        // 3. IMPORTANT: Clear the symbols array but KEEP references to release them later
        // We want the symbols array to ONLY contain the new result symbols from this point on
        const symbolsToRelease = [
            ...this.symbols
        ];
        this.symbols = [];
        // 4. Create new symbols (The actual Result)
        for(let i = 0; i < (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows; i++){
            const symbol = (0, $4706fae892b9b431$export$3e25e887b7a5b37b).pool.acquire();
            symbol.setType(this.reelData[i].toString());
            symbol.alpha = 1.0;
            symbol.originalParent = this.content;
            symbol.y = this._getY(i);
            this.content.addChild(symbol);
            this.symbols.push(symbol); // Now index 0 is row 0, index 1 is row 1, etc.
            if (this.rowsToHide.includes(i)) symbol.alpha = 0;
        }
        // 5. Animate the container back to 0
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(this.content, {
            y: 0,
            duration: this.quickStop ? 0.2 : this.stopSpeed,
            ease: "power.in(1)",
            onComplete: ()=>{
                // 6. Release the OLD symbols we saved in step 3
                symbolsToRelease.forEach((symbol)=>{
                    (0, $4706fae892b9b431$export$3e25e887b7a5b37b).pool.release(symbol);
                });
                // 7. Final alignment for new symbols
                this.symbols.forEach((symbol, i)=>{
                    symbol.y = this._getY(i);
                    symbol.alpha = 1;
                    symbol.land();
                });
                this.content.y = 0;
                this.stopAnticipation();
                this._changeState((0, $d91fd588aac8eb5d$export$67a7830d065ed33).IDLE);
            }
        });
    }
    /**
 * Set the row indexes that should be hidden when the reel stops.
 * @param {number[]} rows - The indexes of the rows to hide.
 */ addRowToHide(row) {
        this.rowsToHide.push(row);
    }
    resetHiddenSymbols() {
        this.rowsToHide.length = 0;
        this.symbols.forEach((symbol)=>{
            symbol.alpha = 1;
        });
    }
    /**
   * Move a symbol to a specific row with an animation.
   * @param {Symbol} symbol - The symbol to move
   * @param {number} [row=0] - The target row index to move the symbol to (defaults to 0)
   * @returns {Promise<void>} - A promise that resolves when the animation is complete
   */ async moveSymbol(symbol, row = 0) {
        return new Promise((resolve)=>{
            this.symbols[row] = symbol; // Update the symbol in the specified row
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(symbol, {
                y: this._getY(row),
                duration: this.quickStop ? 0.2 : 0.4,
                ease: "back.out(1)",
                onComplete: resolve
            });
        });
    }
    /**
   * Get the index of the reel.
   * @returns {number} - The index of the reel
   */ getIndex() {
        return this.index;
    }
    /**
   * Get a specific symbol by index, and optionally remove it from the reel.
   * @param {number} index - The index of the symbol to retrieve
   * @param {boolean} [remove=false] - Whether to remove the symbol from the reel (defaults to false)
   * @returns {Symbol} - The symbol at the specified index
   */ getSymbol(index, remove = false) {
        const symbol = this.symbols[index];
        if (remove) {
            delete this.reelData[index]; // Optionally remove symbol data
            delete this.symbols[index]; // Optionally remove symbol from array
        }
        return symbol;
    }
    /**
   * Trigger the spin.
   */ triggerSpin() {
        this._changeState((0, $d91fd588aac8eb5d$export$67a7830d065ed33).SPIN); // Change to SPIN state
    }
    resetData() {
        this.reelData = [];
        this.quickStop = false;
        this.isExpandingWild = false;
    }
    /**
   * Trigger the stop action during the spin.
   * Sets the flag to stop the reel once the spin completes.
   */ triggerStop(quickStop = false) {
        this.quickStop = quickStop;
        // this.isStop = true;
        if (this.currentState === (0, $d91fd588aac8eb5d$export$67a7830d065ed33).SPIN_END) this.isStop = true; // Set the stop flag
    }
    /**
   * Remove a symbol from a specific row after a win.
   * @param {number} row - The row index of the symbol to remove
   * @returns {Promise<void>} - A promise that resolves when the symbol has been removed
   */ async removeSymbol(row) {
        const symbol = this.symbols[row];
        await symbol.win(); // Perform any win-related actions
        this.removeChild(symbol); // Remove the symbol from the reel
        (0, $4706fae892b9b431$export$3e25e887b7a5b37b).pool.release(symbol); // Release the symbol back to the pool
    }
    async startAnticipation() {
        this.spinSpeed = $b7f9c75db00dc914$var$SPIN_SPEED_ANTICIPATION;
        this.stopSpeed = $b7f9c75db00dc914$var$STOP_SPEED_ANTICIPATION;
        this.anticipationSkeleton.visible = true;
        this.anticipationSkeleton.state.setAnimation(0, "show", false);
        this.anticipationSkeleton.state.addAnimation(0, "idle", true);
    }
    stopAnticipation() {
        this.spinSpeed = $b7f9c75db00dc914$var$SPIN_SPEED_NORMAL;
        this.stopSpeed = $b7f9c75db00dc914$var$STOP_SPEED_NORMAL;
        this.anticipationSkeleton.state.setAnimation(0, "hide", false);
    }
    getScattersAmount() {
        return this.reelData.filter((symbol)=>symbol === "11").length;
    }
}





parcelRequire("logJB");
var $1ovqM = parcelRequire("1ovqM");
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
parcelRequire("logJB");
var $1ovqM = parcelRequire("1ovqM");
// Create a SymbolPool class to manage the pool of symbols
class $ea6ab95c0dda9d47$var$PaylinePool {
    constructor(initialPoolSize = 10){
        this.pool = [];
        for(let i = 0; i < initialPoolSize; i++)this.pool.push(new $ea6ab95c0dda9d47$export$dd7da141bf57a565(1));
    }
    acquire(index) {
        if (this.pool.length > 0) {
            const payline = this.pool.pop();
            payline.setIndex(index);
            return payline;
        } else return new $ea6ab95c0dda9d47$export$dd7da141bf57a565(index);
    }
    release(symbol) {
        symbol.parent?.removeChild(symbol);
        this.pool.push(symbol);
    }
}
class $ea6ab95c0dda9d47$export$dd7da141bf57a565 extends $eicwU.Container {
    static get pool() {
        if (!$ea6ab95c0dda9d47$export$dd7da141bf57a565._pool) throw new Error("Symbol pool is not initialized. Call Symbol.createPool() first.");
        return $ea6ab95c0dda9d47$export$dd7da141bf57a565._pool;
    }
    static createPool(initialPoolSize = 10) {
        $ea6ab95c0dda9d47$export$dd7da141bf57a565._pool = new $ea6ab95c0dda9d47$var$PaylinePool(initialPoolSize);
    }
    constructor(index){
        super();
        this.skeleton = (0, $1ovqM.Spine).from({
            skeleton: "paylinesJson",
            atlas: "paylinesAtlas"
        });
        this.skeleton.state.addListener({
            complete: (entry)=>{
            // this.removeChild(this.skeleton);
            }
        });
        this.skeleton.state.setAnimation(0, `Payline${index}`, false);
        this.addChild(this.skeleton);
    }
    setIndex(index) {
        // Check if animation exists before playing
        const animName = `Payline${index}`;
        const hasAnim = this.skeleton.skeleton.data.findAnimation(animName);
        if (hasAnim) this.skeleton.state.setAnimation(0, animName, false);
        else console.warn(`Animation ${animName} not found in paylines Spine!`);
        this.addChild(this.skeleton);
    }
}





const $edbde9f8ce289a9d$var$STOP_REEL_INTERVAL = 250;
const $edbde9f8ce289a9d$var$STOP_REEL_ANTICIPATION_INTERVAL = 3000;
const $edbde9f8ce289a9d$var$SPIN_REEL_INTERVAL = 30;
var $edbde9f8ce289a9d$export$1f169da95b171b20 = /*#__PURE__*/ function(PanelState) {
    PanelState["IDLE"] = "IDLE";
    PanelState["SPIN"] = "SPIN";
    PanelState["SPIN_END"] = "SPIN_END";
    PanelState["MATCH"] = "MATCH";
    PanelState["CASCADE"] = "CASCADE";
    PanelState["EXPANDED_WILD"] = "EXPANDED_WILD";
    PanelState["WIN"] = "WIN";
    PanelState["STOPPING"] = "STOPPING";
    PanelState["MULTIPLIER"] = "MULTIPLIER";
    PanelState["SCATTER_MATCH"] = "SCATTER_MATCH";
    PanelState["STOP"] = "STOP";
    return PanelState;
}({});
class $edbde9f8ce289a9d$export$2ddb90ad54e5f587 extends $eicwU.Container {
    constructor(){
        super(), this.reels = [], this.currentState = "STOP", this.currentReelIndex = 0, this.currentSccatersAmount = 0, this.isQuickStop = false, this.roundWin = 0, this.reelSpinLoop = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.anticipationSoundInstance = new (0, $7a3aa552ffc217dd$export$9df2da69341d6f5a)(), this.currentLoopId = 0, this.isSpinning = false // To stop the loop when a new spin starts
        ;
        this.bottomContainer = new $eicwU.Container();
        this.topContainer = new $eicwU.Container();
        this.content = new $eicwU.Container();
        this.addChild(this.content);
        this.panelBack = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.panel);
        this.panelBack.anchor.set(0.5);
        this.panelBack.scale.set(1.05);
        this.panelBack.position.set(0, 160);
        this.logoSkeleton = (0, $1ovqM.Spine).from({
            skeleton: "logoJson",
            atlas: "logoAtlas"
        });
        this.logoSkeleton.state.setAnimation(0, 'idle', true);
        const width = (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_WIDTH * (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.reels;
        this.paylineContainer = new $eicwU.Container();
        this.panelMask = new $3cebA.Graphics().rect(-width / 2, 0, width, (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT * (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows + 5).fill(0xffffff);
        const paylineMask = new $3cebA.Graphics().rect(-width / 2, 0, width, (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT * (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows).fill(0xffffff);
        this.bottomContainer.mask = this.panelMask;
        this.bottomContainer.addChild(this.panelMask);
        this.paylineContainer.mask = paylineMask;
        this.paylineContainer.addChild(paylineMask);
        this.winLayer = new $3cebA.Graphics().rect(-width / 2, 0, width, (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT * (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.rows).fill(0x000000);
        this.winLayer.alpha = 0.7;
        this.winLayer.visible = false;
        this.bottomContainer.position.set(0, -148);
        this.winLayer.position.set(this.bottomContainer.position.x, this.bottomContainer.position.y);
        this.topContainer.position.set(this.bottomContainer.position.x, this.bottomContainer.position.y);
        this.paylineContainer.position.set(this.bottomContainer.position.x, this.bottomContainer.position.y);
        this.winCounter = new (0, $07fae797887d9e1d$export$d6bf22216e59f666)();
        this.winCounter.zIndex = 10;
        this.bulbsSkeleton = (0, $1ovqM.Spine).from({
            skeleton: "bulbsJson",
            atlas: "bulbsAtlas"
        });
        this.bulbsSkeleton.position.set(0, 180);
        this.bulbsSkeleton.scale.set(0.25);
        this.bulbsSkeleton.state.setAnimation(0, "on", true);
        // ----------- The Dot Matrix Display Grid ----------- //
        // 1. Create a Container to hold the "Electronic" parts
        const displayContainer = new $eicwU.Container();
        displayContainer.position.set(0, -232);
        this.content.addChild(displayContainer);
        // 2. Create the "Stencil" (The shape of your display)
        // Use a Rounded Rectangle or a custom shape that matches your cylindrical hole
        const stencil = new $3cebA.Graphics().roundRect(-240, -32, 480, 65, 48) // Match your panel's display dimensions
        .fill({
            color: 0xffffff
        });
        stencil.position.set(displayContainer.x, displayContainer.y);
        this.content.addChild(stencil);
        displayContainer.mask = stencil; // Everything in displayContainer is now trapped inside this shape
        // 3. Add the Text
        this.winText = new $gc0ip.Text({
            text: "1,501.00",
            style: {
                fontSize: 70,
                fontFamily: "LcdFont",
                align: "center",
                fill: 0xffcc00,
                dropShadow: {
                    color: 0xffcc00,
                    blur: 10,
                    distance: 0,
                    alpha: 0.8
                },
                letterSpacing: 4
            }
        });
        this.winText.anchor.set(0.5);
        displayContainer.addChild(this.winText);
        // 4. Add the Grid Overlay (Trapped inside the mask)
        const g = new $3cebA.Graphics().rect(2, 0, 1, 1).fill({
            color: 0x000000,
            alpha: 0.2
        }).rect(0, 2, 3, 1).fill({
            color: 0x000000,
            alpha: 0.2
        });
        const gridTexture = (0, $1207aae49fb03bed$export$2e2bcd8739ae039).getInstance().app.renderer.textureGenerator.generateTexture(g);
        const pixelGrid = new $7EPSr.TilingSprite({
            texture: gridTexture,
            width: 2000,
            height: 200
        });
        pixelGrid.anchor.set(0.5);
        pixelGrid.blendMode = 'multiply';
        pixelGrid.x = 0.01;
        pixelGrid.y = 0.895;
        displayContainer.addChild(pixelGrid);
        // 5. THE CYLINDER TRICK: Bulge the text
        // To simulate the curve, we subtly expand the center
        this.winText.scale.set(1.1, 1.05); // Slightly wider and taller to feel "projected"    pixelGrid.blendMode = 'multiply';
        // ---------------------------------------------- //
        // DMD flicker 
        this.winTextFlickerTween = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(this.winText, {
            alpha: 0.85,
            duration: 0.04,
            repeat: -1,
            yoyo: true,
            ease: "none"
        });
        this.winTextPulseTween = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(displayContainer, {
            alpha: 0.2,
            duration: 1.5,
            repeat: -1,
            ease: "power4.in",
            yoyo: true
        });
        this._changeState("IDLE");
        this.content.addChild(this.panelBack);
        this.content.addChild(this.bottomContainer);
        this.content.addChild(this.winLayer);
        this.content.addChild(this.topContainer);
        this.content.addChild(this.paylineContainer);
        this.content.addChild(this.bulbsSkeleton);
        this.content.addChild(this.logoSkeleton);
        this.content.addChild(this.winCounter);
        this.content.addChild(displayContainer);
        this.setWinVisible(false);
    // for (let i = 1; i <= 10; i++) {
    //     const payline: Payline = Payline.pool.acquire(i);
    //     payline.zIndex = 20;
    //     payline.y = 140;
    //     payline.scale.set(1.15);
    //     this.paylineContainer.addChild(payline);
    // }
    }
    setWinVisible(visible) {
        this.winText.visible = visible;
        if (visible) {
            this.winTextFlickerTween?.play();
            this.winTextPulseTween?.play();
        } else {
            this.winTextFlickerTween?.pause();
            this.winTextPulseTween?.pause();
        }
    }
    init(data) {
        this.panelData = data.panel;
        this._createReels();
    }
    onLandscape(data) {
        this.scale.set(1.3);
        this.y = -100;
        const k = Math.max(1.7 / data.ratio, 1) * 1.1;
        this.logoSkeleton.position.set(-600 / k, -220);
        this.logoSkeleton.scale.set(0.13 / k);
        this.winCounter.onLandscape();
    }
    onPortrait(data) {
        this.y = -150;
        const maxRatio = 0.77;
        const maxScale = 1.6;
        const ratio = data.ratio;
        let scale;
        if (ratio >= maxRatio) {
            scale = maxScale;
            this.logoSkeleton.scale.set(0.1);
            this.logoSkeleton.position.set(0, -360);
        } else {
            // Linear interpolation between minScale and maxScale
            scale = ratio / maxRatio * maxScale;
            this.logoSkeleton.scale.set(0.1 / (ratio / maxRatio));
            // Use a coefficient to control the speed of y position change
            const yCoef = 1.3; // Adjust this coefficient to control the speed
            const y = -360 - (1 - ratio / maxRatio) * 200 * yCoef;
            this.logoSkeleton.position.set(0, y);
        }
        this.scale.set(scale);
        this.winCounter.onPortrait();
    }
    getState() {
        return this.currentState;
    }
    async setData(data) {
        this.roundWin = 0;
        this.data = data;
        this.roundWin = this.data.roundWin;
        this.panelData = JSON.parse(JSON.stringify(data.panel));
        this.reels.forEach((reel, index)=>{
            const reelData = this.panelData[index];
            reel.setData(reelData);
        });
        this._stopReels();
    }
    _getWildByCoordinate(reel, row) {
        return this.bottomContainer.children.find((child)=>child instanceof (0, $4706fae892b9b431$export$3e25e887b7a5b37b) && child.position.x === reel * (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_WIDTH - 2 * (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_WIDTH && child.position.y === (row + 0.5) * (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT) || null;
    }
    _stopReels() {
        if (this.panelData.length && this.currentState === "SPIN_END") this._changeState("STOPPING");
    }
    _createReels() {
        for(let i = 0; i < (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.reels; i++){
            const reel = new (0, $b7f9c75db00dc914$export$17f36a75b2cd6b8b)(this.panelData[i], i);
            reel.x = i * (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_WIDTH - (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().config.reels * (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_WIDTH / 2 + (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_WIDTH / 2;
            this.bottomContainer.addChild(reel);
            this.reels.push(reel);
            reel.on((0, $d91fd588aac8eb5d$export$67a7830d065ed33).IDLE, this._onReelStop, this);
            reel.on((0, $d91fd588aac8eb5d$export$67a7830d065ed33).SPIN_END, this._onReelSpinEnd, this);
        }
    }
    _onReelStop() {
        let allStopped = true;
        this.reels.forEach((reel)=>{
            if (reel.getState() !== (0, $d91fd588aac8eb5d$export$67a7830d065ed33).IDLE) allStopped = false;
        });
        if (allStopped) {
            if (this.reelSpinLoop) {
                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.reelSpinLoop);
                this.reelSpinLoop = undefined;
            }
            this.isQuickStop = false;
            this._changeState("STOP");
        }
    }
    _onReelSpinEnd(reel) {
        let allSpin = true;
        this.reels.forEach((reel)=>{
            if (reel.getState() !== (0, $d91fd588aac8eb5d$export$67a7830d065ed33).SPIN_END) allSpin = false;
        });
        if (allSpin) {
            this._changeState("SPIN_END");
            this._stopReels();
        }
    }
    // Method to change the state and execute the corresponding actions
    _changeState(newState) {
        if (this.currentState === newState) return; // No change if the same state
        // Enter logic for the new state
        this.currentState = newState;
        switch(this.currentState){
            case "IDLE":
                this._onEnterIdle();
                break;
            case "SPIN":
                this._onEnterSpin();
                break;
            case "WIN":
                this._onRoundWin();
                break;
            case "MATCH":
                (async ()=>{
                    await this._onMatch();
                })();
                break;
            case "SCATTER_MATCH":
                (async ()=>await this._onScatterMatch())();
                (0, $bbd3d886140ad386$export$402b940662af5211).playSound("wildBonus");
                break;
            case "EXPANDED_WILD":
                this._onExpandedWilds();
                break;
            case "STOPPING":
                this._onStopping();
                break;
            case "STOP":
                this._changeState("EXPANDED_WILD");
                console.log("stopping anticipation sound");
                setTimeout(()=>{
                    if (this.anticipationSoundInstance) {
                        (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.anticipationSoundInstance);
                        this.anticipationSoundInstance = undefined;
                    }
                }, 100);
                break;
        }
        this.emit(this.currentState);
    }
    // Define custom logic for entering and exiting each state
    _onEnterIdle() {
        this.bulbsSkeleton.state.setAnimation(0, "off", true);
    }
    _resetQuickStop() {
        this.isQuickStop = false;
        this.emit("resetQuickStop");
    }
    async _onEnterSpin() {
        this.isQuickStop = false;
        this.isSpinning = true;
        this.currentLoopId++;
        // 1. SAFE RECOVERY: Copy the array before iterating so we don't skip children
        const symbolsToRecover = [
            ...this.topContainer.children
        ];
        symbolsToRecover.forEach((child)=>{
            if (child instanceof (0, $4706fae892b9b431$export$3e25e887b7a5b37b)) {
                // Force return to reel
                if (child.originalParent) {
                    (0, $eaf33f53abcad223$export$660d7e9fbd8bd424)(child, child.originalParent);
                    child.position.set(child.originalPosition.x, child.originalPosition.y);
                } else // Fallback: If parent is lost, release to pool so it doesn't just hang in topContainer
                this.topContainer.removeChild(child);
            }
        });
        // 2. Clear visual layers
        this.topContainer.removeChildren();
        this.paylineContainer.removeChildren();
        this.winLayer.visible = false;
        this.setWinVisible(false);
        // 3. Reset Reels - MUST happen AFTER symbol recovery
        for(let i = 0; i < this.reels.length; i++){
            this.reels[i].resetData();
            // Ensure the reel itself is in the bottom container
            if (this.reels[i].parent !== this.bottomContainer) (0, $eaf33f53abcad223$export$660d7e9fbd8bd424)(this.reels[i], this.bottomContainer);
        }
        // ... rest of spin logic
        this.currentReelIndex = 0;
        this.reels[this.currentReelIndex].triggerSpin();
        this.currentReelIndex++;
        this._startNextSpin();
        this.reelSpinLoop = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("reelSpinLoop");
    }
    _startNextSpin() {
        this.stopNextId = setTimeout(()=>{
            if (this.reels[this.currentReelIndex]) {
                this.reels[this.currentReelIndex].triggerSpin();
                this.currentReelIndex++;
                this._startNextSpin();
            }
        }, $edbde9f8ce289a9d$var$SPIN_REEL_INTERVAL);
    }
    async _onRoundWin() {
        this._resetQuickStop();
        this.isSpinning = false;
        await this.winCounter.showPrize(this.roundWin, this.data.odd);
        this.winText.text = (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(this.roundWin);
        this.setWinVisible(true);
        if (this.data.scatters && this.data.scatters.coordinates.length) await this._onScatterMatch();
        if (this.data.wins.length > 0) {
            // IMPORTANT: Start loop but DON'T await it, or the state never changes
            this._startWinLoop(0, this.currentLoopId); // Pass the ID here
            // Allow the UI to let the player spin again
            this._changeState("IDLE");
        } else this._changeState("IDLE");
    }
    async _startWinLoop(startIndex = 0, loopId) {
        // Immediate exit if loop is stale
        if (this.isSpinning || loopId !== this.currentLoopId) return;
        const winData = this.data.wins[startIndex];
        this.winLayer.visible = true;
        const { symbols: symbols, paylines: paylines } = await this._showSingleWin(winData);
        // After an 'await', the world has changed. Check validity again.
        if (loopId !== this.currentLoopId) {
            paylines.forEach((p)=>(0, $ea6ab95c0dda9d47$export$dd7da141bf57a565).pool.release(p));
            // DO NOT move symbols here. _onEnterSpin handled it.
            return;
        }
        await new Promise((res)=>setTimeout(res, 1200));
        // After the pause, check validity again.
        if (loopId !== this.currentLoopId) {
            paylines.forEach((p)=>(0, $ea6ab95c0dda9d47$export$dd7da141bf57a565).pool.release(p));
            return;
        }
        // Normal cleanup for the next iteration of the loop
        paylines.forEach((p)=>(0, $ea6ab95c0dda9d47$export$dd7da141bf57a565).pool.release(p));
        symbols.forEach((s)=>{
            // ONLY move back if we are still in the win loop and NOT spinning
            if (loopId === this.currentLoopId && s.parent === this.topContainer) {
                (0, $eaf33f53abcad223$export$660d7e9fbd8bd424)(s, s.originalParent);
                s.position.set(s.originalPosition.x, s.originalPosition.y);
            }
        });
        const nextIndex = (startIndex + 1) % this.data.wins.length;
        this._startWinLoop(nextIndex, loopId);
    }
    async _showSingleWin(winData) {
        const winningSymbols = [];
        const activePaylines = [];
        winData.coordinates.forEach((coord)=>{
            const reelObj = this.reels[coord.reel];
            const symbol = reelObj.hasExpandedWild() ? reelObj.getSymbol(0) : reelObj.getSymbol(coord.row);
            if (symbol) {
                winningSymbols.push(symbol);
                symbol.originalParent = symbol.parent;
                symbol.originalPosition = new $1HooC.Point(symbol.x, symbol.y);
                (0, $eaf33f53abcad223$export$660d7e9fbd8bd424)(symbol, this.topContainer);
            }
        });
        if (typeof winData.payline !== "undefined" && winData.payline >= 0) {
            const payline = (0, $ea6ab95c0dda9d47$export$dd7da141bf57a565).pool.acquire(winData.payline + 1);
            // Reset positioning logic: if container is at -148, 148 is the center.
            payline.position.set(0, 148);
            this.paylineContainer.addChild(payline);
            activePaylines.push(payline);
            // @ts-ignore
            payline.skeleton.state.setAnimation(0, `Payline${winData.payline + 1}`, false);
        }
        await Promise.all(winningSymbols.map((s)=>s.win(this.isQuickStop)));
        // DO NOT move symbols back here. Return them so the loop can clean them up.
        return {
            symbols: winningSymbols,
            paylines: activePaylines
        };
    }
    async _onMatch() {
        this.winLayer.visible = true;
        const allWinningSymbols = new Set();
        this.data.wins.forEach((win)=>{
            win.coordinates.forEach((coord)=>{
                // Correctly access the array of coordinates
                const reelObj = this.reels[coord.reel];
                const symbol = reelObj.hasExpandedWild() ? reelObj.getSymbol(0) : reelObj.getSymbol(coord.row);
                if (symbol) allWinningSymbols.add(symbol);
            });
        });
        allWinningSymbols.forEach((s)=>(0, $eaf33f53abcad223$export$660d7e9fbd8bd424)(s, this.topContainer));
        await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("paylineShow");
        await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("matchShow");
        await Promise.all([
            Promise.all(this.data.wins.map((winData)=>this._showWin(winData))),
            new Promise((res)=>setTimeout(res, 1200))
        ]);
        // Return to original reel and FORCE SNAP
        allWinningSymbols.forEach((s)=>{
            (0, $eaf33f53abcad223$export$660d7e9fbd8bd424)(s, s.originalParent);
            // This is the safety "Snap". It forces the symbol to ignore any 
            // lingering tween offsets and sit exactly on the grid.
            const row = Math.round((s.y - (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT / 2) / (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT);
            s.y = (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT * row + (0, $4706fae892b9b431$export$3e25e887b7a5b37b).SYMBOL_HEIGHT / 2;
        });
        this.winLayer.visible = false;
        this._changeState("WIN");
    }
    async _onScatterMatch() {
        if (this.data.scatters && this.data.scatters.coordinates.length) {
            this.winLayer.visible = true; // Layer ON
            await this._showWin(this.data.scatters);
            this.winLayer.visible = false; // Layer OFF
        }
        this._changeState("IDLE");
    }
    async _onExpandedWilds() {
        if (this.data.wins.length) {
            await this._expandWilds();
            this._changeState("MATCH");
        } else if (this.data.scatters && this.data.scatters.coordinates.length) this._changeState("SCATTER_MATCH");
        else this._changeState("IDLE");
    }
    _expandWilds() {
        return new Promise(async (resolve)=>{
            // Call expandWild on all reels and await their promises
            await Promise.all(this.reels.map((reel)=>reel.expandWild()));
            resolve();
        });
    }
    async _showWin(winData) {
        const mult = winData.win / (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().bet;
        if (mult < 3) {
            this.bulbsSkeleton.state.setAnimation(0, "fall1", false);
            this.bulbsSkeleton.state.addAnimation(0, "fall1", false);
        } else if (mult < 10) {
            this.bulbsSkeleton.state.setAnimation(0, "fall2", false);
            this.bulbsSkeleton.state.addAnimation(0, "fall2", false);
        } else if (mult < 20) {
            this.bulbsSkeleton.state.setAnimation(0, "flicker", false);
            this.bulbsSkeleton.state.addAnimation(0, "flicker", false);
        } else {
            this.bulbsSkeleton.state.setAnimation(0, "checker", false);
            this.bulbsSkeleton.state.addAnimation(0, "checker", false);
        }
        this.bulbsSkeleton.state.addAnimation(0, "on", true);
        this.bulbsSkeleton.state.setAnimation(0, "checker", true);
        const paylines = [];
        const winPromises = winData.coordinates.map(async (coordinates)=>{
            const symbol = this.reels[coordinates.reel].hasExpandedWild() ? this.reels[coordinates.reel].getSymbol(0) : this.reels[coordinates.reel].getSymbol(coordinates.row);
            if (typeof winData.payline !== "undefined" && winData.payline >= 0) {
                const payline = (0, $ea6ab95c0dda9d47$export$dd7da141bf57a565).pool.acquire(winData.payline + 1);
                payline.zIndex = 20;
                payline.y = 140;
                payline.scale.set(1.15);
                this.paylineContainer.addChild(payline);
                paylines.push(payline);
            }
            return await symbol.win(this.isQuickStop);
        });
        await Promise.all(winPromises); // Wait for all win() calls to complete
        paylines.forEach((payline)=>{
            (0, $ea6ab95c0dda9d47$export$dd7da141bf57a565).pool.release(payline);
        });
    }
    async _onStopping() {
        this.currentReelIndex = 0;
        this.currentSccatersAmount = 0;
        if (this.stopNextId) clearTimeout(this.stopNextId);
        if (this.isQuickStop) {
            if (this.reelSpinLoop) {
                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.reelSpinLoop);
                this.reelSpinLoop = undefined;
            }
            for(let i = this.currentReelIndex; i < this.reels.length; i++)this.reels[i].triggerStop(this.isQuickStop);
        } else this._stopNext();
    }
    _triggerStopReel(delay = $edbde9f8ce289a9d$var$STOP_REEL_INTERVAL) {
        this.reels[this.currentReelIndex].triggerStop(this.isQuickStop);
        this.currentReelIndex++;
        this.stopNextId = setTimeout(async ()=>{
            await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("reelStop");
            this._stopNext();
        }, delay);
    }
    _stopNext() {
        if (this.isQuickStop) {
            if (this.stopNextId) {
                clearTimeout(this.stopNextId);
                this.stopNextId = null;
                for(let i = this.currentReelIndex; i < this.reels.length; i++)this.reels[i].triggerStop(this.isQuickStop);
            }
        } else if (this.reels[this.currentReelIndex]) {
            this.stopNextId = null;
            if (this._checkForAnticipation() && this.currentReelIndex === 4) {
                this.reels[this.currentReelIndex].startAnticipation();
                (async ()=>{
                    this.anticipationSoundInstance = await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("anticipation");
                })();
                if (this.reelSpinLoop) {
                    (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.reelSpinLoop);
                    this.reelSpinLoop = undefined;
                }
                // console.log("stopped anticipation");
                (0, $bbd3d886140ad386$export$402b940662af5211).stopSoundInstance(this.anticipationSoundInstance);
                this.stopNextId = setTimeout(()=>{
                    this._triggerStopReel(5 * $edbde9f8ce289a9d$var$STOP_REEL_INTERVAL);
                }, $edbde9f8ce289a9d$var$STOP_REEL_ANTICIPATION_INTERVAL);
            } else this._triggerStopReel();
        }
    }
    _checkForAnticipation() {
        // Safety check: if there's no data, there's no anticipation
        if (!this.data || !this.data.wins) return false;
        let hasAnticipation = false;
        this.data.wins.forEach((win)=>{
            if (win.symbol === '1') {
                if (win.odd > 3) hasAnticipation = true;
            }
            if (win.symbol === '100') {
                if (win.odd > 3) hasAnticipation = true;
            }
            if (win.symbol === '101') {
                if (win.odd > 2) hasAnticipation = true;
            }
        });
        return hasAnticipation;
    }
    spin() {
        this._changeState("SPIN");
    }
    async quickStop() {
        this.isQuickStop = true;
        console.log("QUICK STOP", this.currentState);
        switch(this.currentState){
            case "SPIN":
            case "SPIN_END":
                break;
            case "STOPPING":
                this._onStopping();
                break;
            case "MATCH":
                break;
            case "WIN":
                this.winCounter.quickStop();
                break;
        }
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $4rhnu = parcelRequire("4rhnu");
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");
var $gc0ip = parcelRequire("gc0ip");

class $210bcc0c0eb80dea$export$bb3bb25c9b1d4262 extends $eicwU.Container {
    constructor(title, text, fontSize, spacing = 50){
        super(), this.isLandscape = true;
        this.spacing = spacing;
        this.sprite = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["amountBackground.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.addChild(this.sprite);
        // Initialize title
        this.title = new $gc0ip.Text({
            text: title,
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: fontSize,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2
                }
            }
        });
        this.addChild(this.title);
        // Initialize text
        this.text = new $gc0ip.Text({
            text: text,
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: fontSize,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2
                }
            }
        });
        this.addChild(this.text);
        // Initial alignment
        this.updateTextPosition();
    }
    updateTextPosition() {
        if (this.isLandscape) {
            this.title.position.set(-this.sprite.width / 2 - this.title.width - this.spacing, -this.title.height / 2);
            this.text.position.set(-this.text.width / 2, this.text.y = -this.text.height / 2);
        } else {
            this.title.position.set(-this.title.width / 2, -this.sprite.height - this.title.height / 2);
            this.text.position.set(-this.text.width / 2, this.text.y = -this.text.height / 2);
        }
    }
    onPortrait() {
        this.isLandscape = false;
        this.updateTextPosition(); // Recalculate position
    }
    onLandscape() {
        this.isLandscape = true;
        this.updateTextPosition(); // Recalculate position
    }
    setTitle(newTitle) {
        this.title.text = newTitle;
        this.updateTextPosition(); // Recalculate position
    }
    setText(newText) {
        this.text.text = newText;
        this.updateTextPosition(); // Ensure position remains consistent
    }
    setFontSize(newFontSize) {
        this.title.style.fontSize = newFontSize;
        this.text.style.fontSize = newFontSize;
        this.updateTextPosition(); // Adjust position based on new size
    }
    setSpacing(newSpacing) {
        this.spacing = newSpacing;
        this.updateTextPosition(); // Adjust position based on new spacing
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $gc0ip = parcelRequire("gc0ip");

parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $gc0ip = parcelRequire("gc0ip");
class $eaf67dfdd78b11b7$export$d03954f05e20853e extends $eicwU.Container {
    static{
        this.WIDTH = 140;
    }
    static{
        this.HEIGHT = 70;
    }
    constructor(text, width = $eaf67dfdd78b11b7$export$d03954f05e20853e.WIDTH, height = $eaf67dfdd78b11b7$export$d03954f05e20853e.HEIGHT){
        super();
        // Create a rounded rectangle for the button
        this.background = new $3cebA.Graphics();
        this.background.roundRect(-width / 2, -height / 2, width, height, height / 2); // Rounded rect
        this.background.fill(0x000000); // Blue color
        this.background.stroke({
            width: 3,
            color: 0x333333
        });
        this.selectedFrame = new $3cebA.Graphics();
        this.selectedFrame.roundRect(-width / 2, -height / 2, width, height, height / 2); // Rounded rect
        this.selectedFrame.stroke({
            width: 3,
            color: 0xffffff
        });
        this.background.strokeStyle.width = 3;
        this.addChild(this.background);
        this.addChild(this.selectedFrame);
        this.unselect();
        // Create the label
        this.betLabel = new $gc0ip.Text({
            text: text,
            style: {
                fill: "#ffffff",
                fontSize: 30,
                fontWeight: "bold",
                align: "center"
            }
        });
        this.betLabel.anchor.set(0.5);
        this.betLabel.position.set(0, 0); // Center in the button
        this.addChild(this.betLabel);
        // Add click listener
        this.interactive = true;
        this.on("pointerup", ()=>{
            this.emit('onSelect', this);
        });
    }
    setData(data) {
        this.data = data;
    }
    getData() {
        return this.data;
    }
    select() {
        this.selectedFrame.visible = true;
    }
    unselect() {
        this.selectedFrame.visible = false;
    }
}



class $7b62bc00dfc2a3de$export$33bcfd34e1344020 extends $eicwU.Container {
    constructor(reels){
        super(), this.buttons = [], this.selectedButton = null, this.betUpdatedEvent = new CustomEvent("updatedBet");
        this.reels = reels;
        const width = 700;
        const height = 700;
        const title = new $gc0ip.Text({
            text: "Bet",
            style: {
                fill: "0xff8531",
                fontWeight: "bold",
                fontSize: 30
            }
        });
        title.anchor.set(0.5);
        title.y = -300;
        // Create the popup background
        this.background = new $3cebA.Graphics();
        this.background.roundRect(-width / 2, -height / 2, width, height, 20); // Rounded rectangle
        this.background.fill(0x000000); // Dark gray
        this.background.alpha = 0.85;
        this.background.interactive = true;
        this.addChild(this.background);
        this.addChild(title);
    }
    show() {
        this.visible = true;
    }
    hide() {
        this.visible = false;
    }
    // Method to set bet amounts dynamically
    setBetAmounts(bets) {
        // Clear existing buttons
        this.buttons.forEach((button)=>this.removeChild(button));
        this.buttons = [];
        // Determine rows based on the number of bets and fixed reels
        const rows = Math.ceil(bets.length / this.reels);
        const padding = 20; // Padding between buttons
        const buttonWidth = (0, $eaf67dfdd78b11b7$export$d03954f05e20853e).WIDTH;
        const buttonHeight = (0, $eaf67dfdd78b11b7$export$d03954f05e20853e).HEIGHT;
        // Calculate total width of the buttons and padding for horizontal centering
        const totalWidth = this.reels * buttonWidth + (this.reels - 1) * padding;
        const startX = -totalWidth / 2 + buttonWidth / 2; // Center horizontally by adjusting X position
        // Calculate the vertical start position to center the buttons
        const totalHeight = rows * buttonHeight + (rows - 1) * padding;
        const startY = -totalHeight / 2 + 50; // Center vertically by adjusting Y position
        // Create buttons dynamically based on bets array
        bets.forEach((betAmount, index)=>{
            const row = Math.floor(index / this.reels);
            const col = index % this.reels;
            const x = startX + col * (buttonWidth + padding);
            const y = startY + row * (buttonHeight + padding);
            const button = new (0, $eaf67dfdd78b11b7$export$d03954f05e20853e)((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(betAmount));
            button.setData(betAmount);
            button.position.set(x, y);
            // Listen to the 'onSelect' event for each button
            button.on('onSelect', this.onBetButtonSelect, this);
            if (betAmount === (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getLoadResponse().bet) this.selectedButton = button;
            this.addChild(button);
            this.buttons.push(button);
        });
        this.selectedButton?.select();
    }
    // Handle bet button selection
    onBetButtonSelect(selectedButton) {
        // If a button is already selected, unselect it
        if (this.selectedButton) this.selectedButton.unselect();
        this.selectedButton = selectedButton;
        this.selectedButton.select();
        (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
            bet: this.selectedButton.getData()
        });
        this.emit('betUpdated', this.selectedButton.getData());
        document.dispatchEvent(this.betUpdatedEvent);
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $gc0ip = parcelRequire("gc0ip");


class $17fe5bbd6d1085ab$export$cd1f2414be8b21df extends $eicwU.Container {
    constructor(){
        super(), this.buttons = [];
        this.reels = 3;
        const width = 700;
        const height = 700;
        const title = new $gc0ip.Text({
            text: "Cheats",
            style: {
                fill: "0xff8531",
                fontWeight: "bold",
                fontSize: 30
            }
        });
        title.anchor.set(0.5);
        title.y = -300;
        // Create the popup background
        this.background = new $3cebA.Graphics();
        this.background.roundRect(-width / 2, -height / 2, width, height, 20); // Rounded rectangle
        this.background.fill(0x000000); // Dark gray
        this.background.alpha = 0.85;
        this.background.interactive = true;
        this.addChild(this.background);
        this.addChild(title);
        this.setCheats(Object.keys((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getLoadResponse().rigData));
    }
    show() {
        this.visible = true;
    }
    hide() {
        this.visible = false;
    }
    // Method to set bet amounts dynamically
    setCheats(cheats) {
        // Clear existing buttons
        this.buttons.forEach((button)=>this.removeChild(button));
        this.buttons = [];
        // Determine rows based on the number of bets and fixed reels
        const rows = Math.ceil(cheats.length / this.reels);
        const padding = 20; // Padding between buttons
        const buttonWidth = 200;
        const buttonHeight = (0, $eaf67dfdd78b11b7$export$d03954f05e20853e).HEIGHT;
        // Calculate total width of the buttons and padding for horizontal centering
        const totalWidth = this.reels * buttonWidth + (this.reels - 1) * padding;
        const startX = -totalWidth / 2 + buttonWidth / 2; // Center horizontally by adjusting X position
        // Calculate the vertical start position to center the buttons
        const totalHeight = rows * buttonHeight + (rows - 1) * padding;
        const startY = -totalHeight / 2 + 50; // Center vertically by adjusting Y position
        // Create buttons dynamically based on bets array
        cheats.forEach((cheat, index)=>{
            const row = Math.floor(index / this.reels);
            const col = index % this.reels;
            const x = startX + col * (buttonWidth + padding);
            const y = startY + row * (buttonHeight + padding);
            const button = new (0, $eaf67dfdd78b11b7$export$d03954f05e20853e)(cheat, buttonWidth, buttonHeight);
            button.setData(cheat);
            button.position.set(x, y);
            // Listen to the 'onSelect' event for each button
            button.on('onSelect', this.onCheatButtonSelect, this);
            this.addChild(button);
            this.buttons.push(button);
        });
    }
    // Handle bet button selection
    onCheatButtonSelect(selectedButton) {
        // If a button is already selected, unselect it
        this.emit('rigSelected', selectedButton.getData());
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $gc0ip = parcelRequire("gc0ip");

class $d2e79a271e959999$export$fb03b928fc8a3e10 extends $eicwU.Container {
    constructor(reels){
        super(), this.buttons = [], this.selectedButton = null;
        this.reels = reels;
        const width = 500;
        const height = 700;
        const title = new $gc0ip.Text({
            text: "Autoplay",
            style: {
                fill: "0xff8531",
                fontWeight: "bold",
                fontSize: 30
            }
        });
        title.anchor.set(0.5);
        title.y = -300;
        // Create the popup background
        this.background = new $3cebA.Graphics();
        this.background.roundRect(-width / 2, -height / 2, width, height, 20); // Rounded rectangle
        this.background.fill(0x000000); // Dark gray
        this.background.alpha = 0.85;
        this.background.interactive = true;
        this.addChild(this.background);
        this.addChild(title);
    }
    // Method to set bet amounts dynamically
    setData(data) {
        // Clear existing buttons
        this.buttons.forEach((button)=>this.removeChild(button));
        this.buttons = [];
        // Determine rows based on the number of bets and fixed reels
        const rows = Math.ceil(data.length / this.reels);
        const padding = 20; // Padding between buttons
        const buttonWidth = (0, $eaf67dfdd78b11b7$export$d03954f05e20853e).WIDTH;
        const buttonHeight = (0, $eaf67dfdd78b11b7$export$d03954f05e20853e).HEIGHT;
        // Calculate total width of the buttons and padding for horizontal centering
        const totalWidth = this.reels * buttonWidth + (this.reels - 1) * padding;
        const startX = -totalWidth / 2 + buttonWidth / 2; // Center horizontally by adjusting X position
        // Calculate the vertical start position to center the buttons
        const totalHeight = rows * buttonHeight + (rows - 1) * padding;
        const startY = -totalHeight / 2 + 50; // Center vertically by adjusting Y position
        // Create buttons dynamically based on bets array
        data.forEach((amount, index)=>{
            const row = Math.floor(index / this.reels);
            const col = index % this.reels;
            const x = startX + col * (buttonWidth + padding);
            const y = startY + row * (buttonHeight + padding);
            let text = amount.toString();
            if (amount === -1) text = '\u221E';
            const button = new (0, $eaf67dfdd78b11b7$export$d03954f05e20853e)(text);
            button.setData(amount);
            button.position.set(x, y);
            // Listen to the 'onSelect' event for each button
            button.on('onSelect', this.onBetButtonSelect, this);
            this.addChild(button);
            this.buttons.push(button);
        });
    }
    show() {
        if (this.selectedButton) this.selectedButton.unselect();
        this.visible = true;
    }
    hide() {
        this.visible = false;
    }
    // Handle bet button selection
    onBetButtonSelect(selectedButton) {
        // If a button is already selected, unselect it
        if (this.selectedButton) this.selectedButton.unselect();
        this.selectedButton = selectedButton;
        this.selectedButton.select();
        this.emit('autoplaySelected', this.selectedButton.getData());
    }
}




parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");
var $gc0ip = parcelRequire("gc0ip");

var $e6a480e9d61a9d4a$export$b9296404935c5917 = /*#__PURE__*/ function(SpinButtonState) {
    SpinButtonState["SPIN"] = "SPIN";
    SpinButtonState["AUTOPLAY"] = "AUTOPLAY";
    SpinButtonState["PASSIVE"] = "PASSIVE";
    return SpinButtonState;
}({});
class $e6a480e9d61a9d4a$export$40bd1878c35e891c extends $eicwU.Container {
    get Sprite() {
        return this.sprite;
    }
    constructor(){
        super(), this.currentState = "PASSIVE", this.autoplayAmount = 0;
        this.autoplayLabel = new $gc0ip.Text({
            text: "5",
            style: {
                fill: "#ffffff",
                fontSize: 30,
                fontWeight: "bold",
                align: "center"
            }
        });
        this.autoplayLabel.anchor.set(0.5);
        this.autoplayLabel.position.set(0, 0); // Center in the button
        this.autoplayLabel.visible = false;
        this.sprite = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["spinButton.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("pointerup", this._handleClick, this);
        this.addChild(this.sprite);
        this.addChild(this.autoplayLabel);
    }
    getAutoplay() {
        return this.autoplayAmount;
    }
    resetButton() {
        if (this.currentState === "AUTOPLAY") {
            this._decrementAutoplay();
            if (this.autoplayAmount === 0) {
                this.autoplayLabel.visible = false;
                this._changeState("SPIN");
            } else this.emit("spin");
        } else this._changeState("SPIN");
    }
    onClick() {
        this._handleClick();
    }
    setPassive() {
        this._changeState("PASSIVE");
    }
    setAutoplay(autoplayAmount) {
        this.autoplayAmount = autoplayAmount;
        if (this.autoplayAmount !== 0) {
            // this.sprite.texture = GameAssets.textures.stopButton;
            this.autoplayLabel.visible = true;
            this.autoplayLabel.style.fill = 0xffffff;
            let text = this.autoplayAmount.toString();
            if (autoplayAmount === -1) text = "\u221E";
            this.autoplayLabel.text = text;
        } else // this.sprite.texture = GameAssets.textures.spinButton;
        this.autoplayLabel.visible = false;
    }
    _handleClick() {
        switch(this.currentState){
            case "PASSIVE":
                break;
            case "SPIN":
                if (this.autoplayAmount !== 0) {
                    this.emit("autoplayStart");
                    this._changeState("AUTOPLAY");
                } else {
                    this.emit("spin");
                    this._changeState("PASSIVE");
                }
                break;
            case "AUTOPLAY":
                this.autoplayAmount = 0;
                this.autoplayLabel.visible = false;
                this._changeState("PASSIVE");
                this.emit("autoplayStop");
                break;
        }
    }
    resize(data) {}
    _onSpin() {
        this.sprite.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["spinButton.webp"];
        this.sprite.alpha = 1;
        this.sprite.interactive = true;
        this.sprite.visible = true;
    }
    _onAutoplay() {
        this.sprite.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["stopButton.webp"];
        this.autoplayLabel.style.fill = 0xff8531;
        this.sprite.interactive = true;
        this._decrementAutoplay();
        this.emit("spin");
    }
    _decrementAutoplay() {
        if (this.autoplayAmount > 0) {
            this.autoplayAmount--;
            this.autoplayLabel.text = this.autoplayAmount.toString();
        }
    }
    _onPassive() {
        this.sprite.visible = false;
        this.sprite.interactive = false;
    }
    _changeState(newState) {
        if (this.currentState === newState) return; // No change if the same state
        // Enter logic for the new state
        this.currentState = newState;
        switch(this.currentState){
            case "PASSIVE":
                this._onPassive();
                break;
            case "SPIN":
                this._onSpin();
                break;
            case "AUTOPLAY":
                this._onAutoplay();
                break;
        }
    }
}



parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");

var $ee07c0706c0b40a6$export$a77114b319a84ee = /*#__PURE__*/ function(AutoplayButtonState) {
    AutoplayButtonState["IDLE"] = "IDLE";
    AutoplayButtonState["STOP"] = "STOP";
    AutoplayButtonState["PASSIVE"] = "PASSIVE";
    return AutoplayButtonState;
}({});
class $ee07c0706c0b40a6$export$960291b15bc980b7 extends $eicwU.Container {
    get Sprite() {
        return this.sprite;
    }
    constructor(){
        super(), this.currentState = "IDLE";
        this.sprite = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["autoplayButton.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);
        this.addChild(this.sprite);
    }
    _handleClick() {
        switch(this.currentState){
            case "PASSIVE":
                break;
            case "IDLE":
                this.emit("autoplay");
                break;
            case "STOP":
                this.emit("stop");
                this._changeState("PASSIVE");
                break;
        }
    }
    resize(data) {}
    _onSpin() {
        this.sprite.alpha = 1;
        this.sprite.interactive = true;
    }
    _onStop() {}
    _onPassive() {
        this.sprite.alpha = 0.4;
        this.sprite.interactive = false;
    }
    _changeState(newState) {
        if (this.currentState === newState) return; // No change if the same state
        // Enter logic for the new state
        this.currentState = newState;
        switch(this.currentState){
            case "PASSIVE":
                this._onPassive();
                break;
            case "IDLE":
                this._onSpin();
                break;
            case "STOP":
                this._onStop();
                break;
        }
    }
}



parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");
var $gc0ip = parcelRequire("gc0ip");

var $86fb9f2a2ba2abb2$export$a77114b319a84ee = /*#__PURE__*/ function(AutoplayButtonState) {
    AutoplayButtonState["IDLE"] = "IDLE";
    AutoplayButtonState["STOP"] = "STOP";
    AutoplayButtonState["PASSIVE"] = "PASSIVE";
    return AutoplayButtonState;
}({});
class $86fb9f2a2ba2abb2$export$21728b98b44081a9 extends $eicwU.Container {
    get Sprite() {
        return this.sprite;
    }
    constructor(){
        super(), this.isLandscape = true, this.currentState = "IDLE";
        this.sprite = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["betButton.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);
        this.addChild(this.sprite);
        this.title = new $gc0ip.Text({
            text: "Bet",
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: 40,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2
                }
            }
        });
        this.addChild(this.title);
        // Initialize title
        this.betAmount = new $gc0ip.Text({
            text: "100",
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: 40,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2
                }
            }
        });
        this.betAmount.position.set(-this.betAmount.width / 2, -30);
        this.addChild(this.betAmount);
    }
    _handleClick() {
        switch(this.currentState){
            case "PASSIVE":
                break;
            case "IDLE":
                this.emit("selectBet");
                break;
        }
    }
    enable() {
        this.visible = true;
        this.sprite.interactive = true;
    }
    disable() {
        this.sprite.interactive = false;
    }
    setBet(amount) {
        this.betAmount.text = amount;
        this.betAmount.position.set(-this.betAmount.width / 2, -30);
    }
    onPortrait() {
        this.isLandscape = false;
        this._updatePosition();
    }
    onLandscape() {
        this.isLandscape = true;
        this._updatePosition();
    }
    _updatePosition() {
        if (this.isLandscape) this.title.position.set(-this.sprite.width / 2 - this.title.width, -this.title.height / 2);
        else this.title.position.set(-this.title.width / 2, -this.sprite.height / 2 - this.title.height);
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");


var $0a41d2d8b6836d8d$export$12587ab1f826eb15 = /*#__PURE__*/ function(FastButtonState) {
    FastButtonState["ACTIVE"] = "ACTIVE";
    FastButtonState["PASSIVE"] = "PASSIVE";
    return FastButtonState;
}({});
class $0a41d2d8b6836d8d$export$b02a886edfbdc5d5 extends $eicwU.Container {
    get Sprite() {
        return this.sprite;
    }
    constructor(){
        super(), this.currentState = "PASSIVE";
        this.sprite = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["fastOff.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);
        this.addChild(this.sprite);
    }
    _handleClick() {
        switch(this.currentState){
            case "ACTIVE":
                this._changeState("PASSIVE");
                break;
            case "PASSIVE":
                this._changeState("ACTIVE");
                break;
        }
    }
    _onPassive() {
        this.sprite.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["fastOff.webp"];
        (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
            fastOn: false
        });
    }
    _onActive() {
        this.sprite.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["fastOn.webp"];
        (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
            fastOn: true
        });
    }
    _changeState(newState) {
        if (this.currentState === newState) return; // No change if the same state
        // Enter logic for the new state
        this.currentState = newState;
        switch(this.currentState){
            case "PASSIVE":
                this._onPassive();
                break;
            case "ACTIVE":
                this._onActive();
                break;
        }
    }
}


parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");



var $daba53b4cb6e4612$export$798ff324ff745291 = /*#__PURE__*/ function(SoundButtonState) {
    SoundButtonState["ACTIVE"] = "ACTIVE";
    SoundButtonState["PASSIVE"] = "PASSIVE";
    return SoundButtonState;
}({});
class $daba53b4cb6e4612$export$95aafd20808390d5 extends $eicwU.Container {
    get Sprite() {
        return this.sprite;
    }
    constructor(){
        super(), this.currentState = "PASSIVE";
        this.sprite = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["soundOff.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);
        this.addChild(this.sprite);
        this._changeState("ACTIVE"); // Set initial state to ACTIVE
    }
    _handleClick() {
        switch(this.currentState){
            case "ACTIVE":
                this._changeState("PASSIVE");
                break;
            case "PASSIVE":
                this._changeState("ACTIVE");
                break;
        }
    }
    _onPassive() {
        (0, $bbd3d886140ad386$export$402b940662af5211).setMuted(true);
        this.sprite.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["soundOff.webp"];
        (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
            soundOn: false
        });
    }
    _onActive() {
        (0, $bbd3d886140ad386$export$402b940662af5211).setMuted(false);
        this.sprite.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["soundOn.webp"];
        (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
            soundOn: true
        });
    }
    _changeState(newState) {
        if (this.currentState === newState) return; // No change if the same state
        // Enter logic for the new state
        this.currentState = newState;
        switch(this.currentState){
            case "PASSIVE":
                this._onPassive();
                break;
            case "ACTIVE":
                this._onActive();
                break;
        }
    }
}


// There can only be one InfoPopup
class $0babc81d9126a9d0$export$fa4290cbf89215ed {
    static{
        this._popupCloseEvent = new CustomEvent("infoPopupClosed");
    }
    static{
        this.MAX_SIZE_LANDSCAPE_PX = "750px";
    }
    static{
        this.MAX_SIZE_PORTRAIT_PX = "350px";
    }
    static{
        this.FONT_SIZE_LANDSCAPE_REM = "3rem";
    }
    static{
        this.FONT_SIZE_PORTRAIT_REM = "1.25rem";
    }
    static init() {
        this._popup = document.createElement("div");
        this._closePanel = document.createElement("div");
        this._popup.id = "info-popup";
        const width = window.innerWidth;
        const height = window.innerHeight;
        const ratio = width / height;
        const virtualHeightMax = ratio < 1 ? this.MAX_SIZE_PORTRAIT_PX : this.MAX_SIZE_LANDSCAPE_PX;
        const virtualHeightPreferred = ratio < 1 ? "50vh" : "60vh";
        const virtualFontSizeMax = ratio < 1 ? this.FONT_SIZE_PORTRAIT_REM : this.FONT_SIZE_LANDSCAPE_REM;
        const virtualFontSizePreferred = ratio < 1 ? "2vh" : "3vh";
        Object.assign(this._popup.style, {
            display: "none",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            height: `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`,
            width: `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`,
            background: "rgba(0, 0, 0, 0.85)",
            borderRadius: "20px",
            zIndex: "9998",
            fontFamily: "Arial",
            fontWeight: "bold",
            fontSize: `clamp(0.5rem, ${virtualFontSizePreferred}, ${virtualFontSizeMax})`
        });
        Object.assign(this._closePanel.style, {
            display: "none",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            height: "100%",
            zIndex: "9997"
        });
        document.body.appendChild(this._popup);
        document.body.appendChild(this._closePanel);
        this._setupResizeHandler();
        this._setupPopupCloseHandler();
    }
    static _setupResizeHandler() {
        window.addEventListener("resize", ()=>this._resize());
    }
    static _setupPopupCloseHandler() {
        this._closePanel.addEventListener("click", ()=>this.hide());
    }
    static _resize() {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const ratio = width / height;
        const virtualHeightMax = ratio < 1 ? this.MAX_SIZE_PORTRAIT_PX : this.MAX_SIZE_LANDSCAPE_PX;
        const virtualHeightPreferred = ratio < 1 ? "50vh" : "60vh";
        const virtualFontSizeMax = ratio < 1 ? this.FONT_SIZE_PORTRAIT_REM : this.FONT_SIZE_LANDSCAPE_REM;
        const virtualFontSizePreferred = ratio < 1 ? "2vh" : "3vh";
        this._popup.style.height = `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`;
        this._popup.style.width = `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`;
        this._popup.style.fontSize = `clamp(0.5rem, ${virtualFontSizePreferred}, ${virtualFontSizeMax})`;
    }
    static setContent(content) {
        this._popup.innerHTML = "";
        this._popup.appendChild(content);
    }
    static show() {
        this._popup.style.display = "block";
        // For some reason both elements get clicked at the same time if you don't 
        // use a timeout
        setTimeout(()=>{
            this._closePanel.style.display = "block";
        }, 100);
    // console.log("shown info popup");
    }
    static hide() {
        this._popup.style.display = "none";
        this._closePanel.style.display = "none";
        // console.log("hidden info popup");
        document.dispatchEvent(this._popupCloseEvent);
    }
    static getComputedStyle() {
        return window.getComputedStyle(this._popup);
    }
}



var $7597d59b9a63cf86$export$32d6e6630321d5dc = /*#__PURE__*/ function(UIState) {
    UIState["SPIN"] = "SPIN";
    UIState["STOP"] = "STOP";
    UIState["PASSIVE"] = "PASSIVE";
    UIState["BET_POPUP"] = "BET_POPUP";
    UIState["AUTOPLAY_POPUP"] = "AUTOPLAY_POPUP";
    UIState["INFO_POPUP"] = "INFO_POPUP";
    UIState["CHEAT_POPUP"] = "CHEAT_POPUP";
    UIState["LOCK"] = "LOCK";
    return UIState;
}({});
var $7597d59b9a63cf86$export$91ab86cd70a2cb07 = /*#__PURE__*/ function(UIEvent) {
    UIEvent["SCREEN_CLICK"] = "SCREEN_CLICK";
    return UIEvent;
}({});
class $7597d59b9a63cf86$export$4b08aed5f1ec6952 extends $eicwU.Container {
    constructor(){
        super(), this.currentState = "LOCK", this.isFreespins = false, this.autoplayAmount = 0;
        this.buttonClickEvent = new CustomEvent("buttonClicked");
        this.specialButtonClickEvent = new CustomEvent("specialButtonClicked");
        // Create a fullscreen interactive object
        this.screenInteractiveArea = new $3cebA.Graphics();
        this.screenInteractiveArea.rect(-960, -960, 1920, 1920);
        this.screenInteractiveArea.fill({
            color: 0xffffff,
            alpha: 1
        });
        this.screenInteractiveArea.interactive = true; // Enable interaction
        this.screenInteractiveArea.alpha = 0;
        this.screenInteractiveArea.zIndex = 0;
        this.bottomBlackCoverArea = new $3cebA.Graphics();
        this.bottomBlackCoverArea.zIndex = 1;
        // Add to the stage
        (0, $1207aae49fb03bed$export$2e2bcd8739ae039).getInstance().app.stage.addChild(this.screenInteractiveArea);
        (0, $1207aae49fb03bed$export$2e2bcd8739ae039).getInstance().app.stage.addChild(this.bottomBlackCoverArea);
        this.screenInteractiveArea.on("pointerup", this.onScreenClick, this);
        window.addEventListener("keyup", this.handleKeyDown.bind(this));
        this.menuBar = new $eicwU.Container();
        this.addChild(this.menuBar);
        this.bottomBar = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["bottomBar.webp"]);
        this.bottomBar.anchor.set(0.5);
        this.menuBar.addChild(this.bottomBar);
        (0, $1207aae49fb03bed$export$2e2bcd8739ae039).getInstance().app.stage.on("resize", this.resize, this);
        this.content = new $eicwU.Container();
        this.addChild(this.content);
        const spacing = 20;
        this.balanceContent = new (0, $210bcc0c0eb80dea$export$bb3bb25c9b1d4262)("Balance", (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().balance), 30, spacing);
        this.menuBar.addChild(this.balanceContent);
        this.winContent = new (0, $210bcc0c0eb80dea$export$bb3bb25c9b1d4262)("Win", (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(0), 30, spacing);
        this.menuBar.addChild(this.winContent);
        this.autoplayButton = new (0, $ee07c0706c0b40a6$export$960291b15bc980b7)();
        this.autoplayButton.on("autoplay", this._onAutoplayClick, this);
        this.fastButton = new (0, $0a41d2d8b6836d8d$export$b02a886edfbdc5d5)();
        this.soundButton = new (0, $daba53b4cb6e4612$export$95aafd20808390d5)();
        this.spinButton = new (0, $e6a480e9d61a9d4a$export$40bd1878c35e891c)();
        this.spinButton.on("spin", this._onSpin, this);
        this.spinButton.on("autoplayStart", this._onAutoplayStart, this);
        this.spinButton.on("autoplayStop", this._onAutoplayStop, this);
        this.selectBetButton = new (0, $86fb9f2a2ba2abb2$export$21728b98b44081a9)();
        this.selectBetButton.setBet((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().bet));
        this.selectBetButton.on("selectBet", this._onBetClick, this);
        this.cheatButton = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["buyButton.webp"]);
        this.cheatButton.anchor.set(0.5, 0.5);
        this.cheatButton.interactive = true;
        this.cheatButton.on("pointerup", this._onCheatClick, this);
        this.buyButton = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.buy);
        this.buyButton.anchor.set(0.5, 0.5);
        this.buyButton.scale.set(0.5);
        this.buyButton.interactive = true;
        this.buyButton.on("pointerup", this._onBuy, this);
        this.homeButton = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.homeButton);
        this.homeButton.anchor.set(0.5, 0.5);
        this.infoButton = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["info.webp"]);
        this.infoButton.scale.set(0.5);
        this.infoButton.anchor.set(0.5, 0.5);
        this.infoButton.interactive = true;
        this.infoButton.on("pointerup", ()=>{
            (0, $0babc81d9126a9d0$export$fa4290cbf89215ed).show();
            this._onInfoClick();
        }, this);
        this.questionButton = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.questionButton);
        this.questionButton.anchor.set(0.5, 0.5);
        this.menuButton = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.menuButton);
        this.menuButton.anchor.set(0.5, 0.5);
        this.content.addChild(this.autoplayButton);
        this.content.addChild(this.fastButton);
        this.content.addChild(this.soundButton);
        this.content.addChild(this.spinButton);
        this.content.addChild(this.selectBetButton);
        this.content.addChild(this.cheatButton);
        this.content.addChild(this.buyButton);
        // this.addChild(this.homeButton);
        this.content.addChild(this.infoButton);
        // this.addChild(this.questionButton);
        // this.addChild(this.soundButton);
        // this.addChild(this.menuButton);
        // Create and display the popup
        this.betPopup = new (0, $7b62bc00dfc2a3de$export$33bcfd34e1344020)(4); // 3 rows, 3 columns
        this.betPopup.position.set(0, 0); // Centered in the app (optional)
        this.betPopup.setBetAmounts((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getLoadResponse().bets);
        this.betPopup.on("betUpdated", this.updateBet, this);
        this.addChild(this.betPopup);
        (0, $0babc81d9126a9d0$export$fa4290cbf89215ed).init();
        document.addEventListener("infoPopupClosed", ()=>{
            this._onInfoHide();
        });
        this.cheatPopup = new (0, $17fe5bbd6d1085ab$export$cd1f2414be8b21df)(); // 3 rows, 3 columns
        this.cheatPopup.position.set(0, 0); // Centered in the app (optional)
        this.cheatPopup.on("rigSelected", this.rigSelected, this);
        this.addChild(this.cheatPopup);
        this.autoplayPopup = new (0, $d2e79a271e959999$export$fb03b928fc8a3e10)(3); // 3 rows, 3 columns
        this.autoplayPopup.position.set(0, 0); // Centered in the app (optional)
        this.autoplayPopup.setData([
            10,
            20,
            30,
            50,
            100,
            250,
            500,
            -1
        ]);
        this.autoplayPopup.on("autoplaySelected", this.autoplaySelected, this);
        this.addChild(this.autoplayPopup);
        this.betPopup.hide();
        this.cheatPopup.hide();
        this.autoplayPopup.hide();
        const buttons = [
            this.cheatButton,
            this.infoButton,
            this.fastButton.Sprite,
            // this.homeButton,
            // this.menuButton,
            this.autoplayButton.Sprite,
            this.soundButton.Sprite,
            this.selectBetButton.Sprite,
            // this.questionButton,
            this.spinButton.Sprite
        ];
        const specialButtons = [];
        for (let button of buttons)button.on("pointerup", ()=>{
            document.dispatchEvent(this.buttonClickEvent);
        }, this);
        for (let button of specialButtons)button.on("pointerup", ()=>{
            document.dispatchEvent(this.specialButtonClickEvent);
        }, this);
        this.onLandscape(1.5);
        this._changeState("SPIN");
    }
    hideBar() {
        this.menuBar.visible = false;
    }
    showBar() {
        this.menuBar.visible = true;
    }
    lock() {
        this._changeState("LOCK");
    }
    onScreenClick() {
        switch(this.currentState){
            case "LOCK":
                this.emit("SCREEN_CLICK");
                break;
            case "SPIN":
                break;
            case "STOP":
                this._onStop();
                break;
            case "PASSIVE":
                break;
            case "BET_POPUP":
                this._changeState("SPIN");
                break;
            case "CHEAT_POPUP":
                this._changeState("SPIN");
                break;
            case "AUTOPLAY_POPUP":
                this.autoplayAmount = 0;
                this.spinButton.setAutoplay(this.autoplayAmount);
                this._changeState("SPIN");
                break;
        }
    }
    handleKeyDown(event) {
        switch(event.code){
            case "Space":
            case "Enter":
                switch(this.currentState){
                    case "LOCK":
                        this.emit("SCREEN_CLICK");
                        this.autoplayPopup.hide();
                        this.betPopup.hide();
                        this.cheatPopup.hide();
                        break;
                    case "SPIN":
                        this.autoplayPopup.hide();
                        this.betPopup.hide();
                        this.cheatPopup.hide();
                        this.spinButton.onClick();
                        break;
                    case "STOP":
                        this._onStop();
                        break;
                    case "PASSIVE":
                        break;
                }
                break;
        }
    }
    _changeState(newState) {
        if (this.currentState === newState) return; // No change if the same state
        // Enter logic for the new state
        this.currentState = newState;
        switch(this.currentState){
            case "LOCK":
                this.spinButton.visible = false;
                this.autoplayButton.visible = false;
                this.selectBetButton.disable();
                this.cheatButton.visible = false;
                this.buyButton.visible = false;
                break;
            case "INFO_POPUP":
                this.autoplayPopup.hide();
                this.betPopup.hide();
                this.cheatPopup.hide();
                break;
            case "SPIN":
                this.autoplayPopup.hide();
                this.betPopup.hide();
                this.cheatPopup.hide();
                if (this.isFreespins) {
                    this.autoplayButton.visible = false;
                    this.selectBetButton.disable();
                    this.cheatButton.visible = false;
                    this.buyButton.visible = false;
                } else {
                    this.autoplayButton.visible = true;
                    this.selectBetButton.enable();
                    this.cheatButton.visible = true;
                    this.buyButton.visible = true;
                }
                this.spinButton.visible = true;
                this.fastButton.visible = true;
                this.soundButton.visible = true;
                this.spinButton.resetButton();
                break;
            case "STOP":
                this.autoplayButton.visible = false;
                // this.fastButton.visible = false;
                // this.soundButton.visible = false;
                this.selectBetButton.disable();
                this.cheatButton.visible = false;
                this.buyButton.visible = false;
                this.betPopup.hide();
                this.cheatPopup.hide();
                this.autoplayPopup.hide();
                break;
            case "BET_POPUP":
                this.betPopup.show();
                this.cheatPopup.hide();
                this.autoplayPopup.hide();
                break;
            case "AUTOPLAY_POPUP":
                this.autoplayPopup.show();
                this.betPopup.hide();
                this.cheatPopup.hide();
                break;
            case "CHEAT_POPUP":
                this.cheatPopup.show();
                this.betPopup.hide();
                this.autoplayPopup.hide();
                break;
        }
    }
    onPortrait(data) {
        this.bottomBar.y = 800;
        this.bottomBar.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["bottomBarPortrait.webp"];
        this.bottomBar.width = 1920 * data.ratio;
        this.balanceContent.onPortrait();
        this.balanceContent.setFontSize(40);
        this.balanceContent.position.set(-320, 880);
        this.balanceContent.scale.set(1);
        this.winContent.onPortrait();
        this.winContent.setFontSize(40);
        this.winContent.position.set(0, 880);
        this.winContent.scale.set(1);
        this.selectBetButton.onPortrait();
        this.selectBetButton.scale.set(1);
        this.selectBetButton.position.set(350, 880);
        const offsetY = 650;
        this.betPopup.scale.set(1.3);
        this.autoplayPopup.scale.set(1.3);
        this.autoplayButton.scale.set(2);
        this.fastButton.scale.set(2);
        this.soundButton.scale.set(2);
        this.spinButton.scale.set(1.5);
        this.cheatButton.scale.set(1.3);
        this.autoplayButton.position.set(-210, offsetY);
        this.fastButton.position.set(380, offsetY);
        this.soundButton.position.set(-390, offsetY);
        this.spinButton.position.set(0, offsetY);
        this.cheatButton.position.set(220, offsetY);
        // this.buyButton.position.set(-300, -800);
        const bottomY = 740;
        this.homeButton.position.set(-350, bottomY);
        this.infoButton.position.set(-300, bottomY);
        this.infoButton.scale.set(0.5);
        this.questionButton.position.set(-190, bottomY);
        this.menuButton.position.set(190, bottomY);
        this.bottomBlackCoverArea.clear();
        this.bottomBlackCoverArea.rect(-2048, 950, 4096, 512).fill({
            color: 0x000000,
            alpha: 2
        });
    }
    onLandscape(data) {
        this.bottomBar.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["bottomBar.webp"];
        this.bottomBar.width = 2600;
        const k = Math.max(1.7 / data.ratio, 1) * 1.1;
        const xOffset = 700;
        this.betPopup.scale.set(1);
        this.autoplayPopup.scale.set(1);
        this.autoplayButton.scale.set(1);
        this.fastButton.scale.set(1);
        this.soundButton.scale.set(1);
        this.spinButton.scale.set(1);
        this.cheatButton.scale.set(1);
        this.fastButton.position.set(550 / k, 500);
        this.soundButton.position.set(-800 / k, 450);
        this.infoButton.position.set(-890 / k, 450);
        this.infoButton.scale.set(0.32);
        this.autoplayButton.position.set(650 / k, 500);
        this.spinButton.position.set(900 / k, 450);
        this.selectBetButton.position.set(340 / k, 515);
        this.selectBetButton.scale.set(0.7);
        this.selectBetButton.onLandscape();
        this.cheatButton.position.set(900 / k, 300);
        this.winContent.onLandscape();
        this.balanceContent.onLandscape();
        this.bottomBar.y = 470;
        this.bottomBar.texture = (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.uiAtlas.textures["bottomBar.webp"];
        this.balanceContent.position.set(-750 / k, 515);
        this.balanceContent.setFontSize(40);
        this.balanceContent.scale.set(0.7);
        this.winContent.setFontSize(40);
        this.winContent.position.set(0, 515);
        this.winContent.scale.set(0.7);
        this.bottomBlackCoverArea.clear();
        this.bottomBlackCoverArea.rect(-2048, 540, 4096, 512).fill({
            color: 0x000000,
            alpha: 2
        });
    }
    _onBetClick() {
        if (this.currentState === "SPIN" || this.currentState === "AUTOPLAY_POPUP") this._changeState("BET_POPUP");
    }
    _onCheatClick() {
        if (this.currentState === "SPIN" || this.currentState === "AUTOPLAY_POPUP") this._changeState("CHEAT_POPUP");
    }
    _onAutoplayClick() {
        if (this.currentState === "SPIN" || this.currentState === "BET_POPUP") this._changeState("AUTOPLAY_POPUP");
    }
    _onInfoClick() {
        this._changeState("INFO_POPUP");
    }
    _onInfoHide() {
        this._changeState("SPIN");
    }
    _onBuy() {
        this._changeState("STOP");
        this.spinButton.setPassive();
        this.emit("buy");
    }
    _onSpin() {
        this._changeState("STOP");
        this.emit("spin");
        if ((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().fastOn) this._onStop();
    }
    _onAutoplayStart() {
        this._changeState("STOP");
    }
    _onAutoplayStop() {
        this._changeState("STOP");
    }
    _onStop() {
        this.emit("stop");
        this._changeState("PASSIVE");
    }
    resetSpinButton(isFreespins = false) {
        this.isFreespins = isFreespins;
        this._changeState("SPIN");
    }
    setStopButton() {
        this._changeState("STOP");
    }
    resize(data) {
        if (data.ratio < 1.4) this.onPortrait(data);
        else this.onLandscape(data);
    }
    updateBet() {
        document.dispatchEvent(this.buttonClickEvent);
        this.selectBetButton.setBet((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().bet));
    }
    rigSelected(data) {
        document.dispatchEvent(this.buttonClickEvent);
        (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).publish("rigSelected", data);
        this._changeState("SPIN");
        this.spinButton.onClick();
    }
    autoplaySelected(amount) {
        document.dispatchEvent(this.buttonClickEvent);
        this.autoplayAmount = amount;
        this.spinButton.setAutoplay(amount);
    }
    updateVisualBalance() {
        this.balanceContent.setText((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().balance));
    }
    setWin(win) {
        this.winContent.setText((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getFormatter().format(win));
    }
}






class $3d7595cac94e0caa$export$b19c5de2fd1b675d extends $eicwU.Container {
    constructor(){
        super(), this.gameState = (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN;
        (0, $587a15fb35551ac3$export$b6ae1bc530f4c149).on('gameActionResponse', this.onSpinResponse.bind(this));
        this.app = (0, $1207aae49fb03bed$export$2e2bcd8739ae039).getInstance().app;
        this.app.stage.on('resize', this.resize, this);
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
        this.content = new $eicwU.Container();
        this.addChild(this.content);
        this.background = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.mainBg);
        this.background.anchor.set(0.5);
        this.fsBackground = new $4rhnu.Sprite((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.fsBg);
        this.fsBackground.anchor.set(0.5);
        this.fsBackground.visible = false;
        this.panel = new (0, $edbde9f8ce289a9d$export$2ddb90ad54e5f587)();
        this.panel.zIndex = 3;
        this.panel.on((0, $edbde9f8ce289a9d$export$1f169da95b171b20).IDLE, this.onPanelIdle, this);
        this.panel.on((0, $edbde9f8ce289a9d$export$1f169da95b171b20).CASCADE, this.onCascade, this);
        this.panel.on('resetQuickStop', this.onResetQuickStop, this);
        this.panel.on('showRandomWilds', this.zoomIn, this);
        this.UI = new (0, $7597d59b9a63cf86$export$4b08aed5f1ec6952)();
        this.UI.on('spin', this.onSpin, this);
        this.UI.on('stop', this.onQuickStop, this);
        this.UI.updateVisualBalance();
        this.UI.setWin(0);
        this.UI.resetSpinButton();
        this.addComponentsOnStage();
        // this.UI.lock();
        // this.UI.hideBar();
        // this.UI.once(UIEvent.SCREEN_CLICK, this.onIntroClick.bind(this));
        this.content.visible = true;
        this.UI.resetSpinButton();
        this.UI.showBar();
        this.panel.init((0, $7502dfc019795313$export$4193d9976a2c789).getInstance().getLoadResponse());
    }
    onPortrait(data) {
        this.background.scale.set(2.4);
        this.fsBackground.scale.set(2.4);
        this.background.y = -600;
        this.fsBackground.y = -600;
        this.panel.onPortrait(data);
    }
    onLandscape(data) {
        this.background.scale.set(1.1);
        this.background.y = -80;
        this.fsBackground.scale.set(1.1);
        this.fsBackground.y = -80;
        this.panel.onLandscape(data);
    }
    addComponentsOnStage() {
        this.content.addChild(this.background);
        this.content.addChild(this.fsBackground);
        this.content.addChild(this.panel);
        this.addChild(this.UI);
    }
    handleKeyDown(event) {
        event.code;
    }
    async onPanelIdle() {
        switch((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().state){
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN:
                this.UI.setWin(this.response.totalWin);
                this.UI.updateVisualBalance();
                this.UI.resetSpinButton();
                break;
        }
    }
    onResetQuickStop() {
        this.UI.setStopButton();
    }
    onCascade() {
        if ((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().state === (0, $852805a52f1deab9$export$eb5ccdbd077479c).BONUS && this.response.totalWin) this.UI.setWin(this.response.totalWin);
        else this.UI.setWin(this.response.roundWin);
        (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().gameActionRequest();
    }
    async onSpin() {
        switch((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().state){
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN:
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN_TO_BONUS:
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).BONUS_TO_MAIN:
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).BONUS:
                (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().gameActionRequest();
                this.startSpin();
                this.UI.setWin(0);
                break;
        }
    }
    async onSpinResponse(response) {
        this.response = response;
        this.panel.setData(this.response);
    }
    zoomIn() {
        this.timeline = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline().to(this.content.scale, {
            x: 1.1,
            y: 1.1,
            duration: 2,
            ease: "power2.out"
        }).to(this.content.scale, {
            x: 1,
            y: 1,
            duration: 1,
            ease: "power2.out"
        });
    }
    onQuickStop() {
        switch((0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().state){
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN_TO_BONUS:
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).BONUS_TO_MAIN:
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).MAIN:
            case (0, $852805a52f1deab9$export$eb5ccdbd077479c).BONUS:
                // Stop and kill the existing timeline if it exists
                if (this.timeline) {
                    this.timeline.kill();
                    this.content.scale.set(1, 1);
                    this.timeline = null; // Clear reference
                }
                this.panel.quickStop();
                break;
        }
    }
    resize(data) {
        if (data.ratio < 1.4) this.onPortrait(data);
        else this.onLandscape(data);
    }
    startSpin(isBuy = false) {
        if (this.panel.getState() === (0, $edbde9f8ce289a9d$export$1f169da95b171b20).IDLE) {
            (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().updateState({
                balance: (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().balance - (0, $852805a52f1deab9$export$937f7100a7ce63f2).getInstance().bet
            });
            this.UI.updateVisualBalance();
            this.panel.spin();
        }
    }
}



// Define the game rules for this specific game

const $4ee0c75a4c6267c4$export$b6340ac26c877cc = ()=>{
    const root = document.createElement("div");
    Object.assign(root.style, {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        alignItems: "center",
        padding: "20px",
        position: "relative",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "100%",
        zIndex: "9998"
    });
    const createHorizontalRuler = ()=>{
        let horizontalRuler = document.createElement("hr");
        Object.assign(horizontalRuler.style, {
            // Ensure flex layout won't shrink our hr-s
            flexShrink: "0",
            width: "100%",
            height: "2px",
            background: "linear-gradient(to right, #00000000 0%, #555 33%, #555 66%, #00000000 100%)",
            border: "0px",
            zIndex: "9998"
        });
        return horizontalRuler;
    };
    const createHeader = (text)=>{
        const header = document.createElement("h4");
        Object.assign(header.style, {
            display: "block",
            position: "relative",
            margin: "0.25em 0em 0.25em 0em",
            color: "rgb(255, 133, 49)",
            zIndex: "9998"
        });
        header.textContent = text.replace(/\s+/g, " ");
        return header;
    };
    const createParagraph = (text)=>{
        const paragraph = document.createElement("p");
        Object.assign(paragraph.style, {
            display: "block",
            position: "relative",
            fontSize: "0.7em",
            textAlign: "center",
            color: "white",
            zIndex: "9998"
        });
        text = text.trim();
        paragraph.innerHTML = text;
        return paragraph;
    };
    const createBulletList = (points, showBullets = true, padding = "0", textAlign = "left")=>{
        const bulletList = document.createElement("ul");
        Object.assign(bulletList.style, {
            display: "block",
            padding: padding,
            margin: "0",
            position: "relative",
            fontSize: "0.7em",
            listStyleType: showBullets ? "disc" : "none",
            color: "white",
            textAlign: textAlign,
            zIndex: "9998"
        });
        points.forEach((point)=>{
            const bulletPoint = document.createElement("li");
            bulletPoint.innerHTML = point;
            bulletList.appendChild(bulletPoint);
        });
        return bulletList;
    };
    const createImage = (path, width = "auto", height = "6em", margin = "0")=>{
        const image = document.createElement("img");
        Object.assign(image.style, {
            display: "block",
            position: "relative",
            margin: margin,
            width: width,
            height: height,
            maxWidth: "100%",
            maxHeight: "100%",
            aspectRatio: "auto",
            objectFit: "contain",
            zIndex: "9998"
        });
        image.src = path;
        return image;
    };
    // const createGrid: (
    //   elements: HTMLElement[],
    //   rows: number,
    //   columns: number,
    // ) => HTMLElement = (
    //   elements: HTMLElement[],
    //   rows: number,
    //   columns: number,
    // ) => {
    //   const grid: HTMLElement = document.createElement("div");
    //   Object.assign(grid.style, {
    //     display: "grid",
    //     justifyContent: "center",
    //     gap: "0px",
    //     gridTemplateRows: `repeat(${rows}, 1fr)`,
    //     gridTemplateColumns: `repeat(${columns}, 1fr)`,
    //     position: "relative",
    //     zIndex: "9998",
    //   });
    //   elements.forEach((element: HTMLElement) => {
    //     grid.appendChild(element);
    //   });
    //   return grid;
    // };
    const createHorizontalElementSequence = (elements, width, elementWidth)=>{
        const container = document.createElement("div");
        Object.assign(container.style, {
            display: "flex",
            width: width,
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "baseline",
            position: "relative",
            zIndex: "9998"
        });
        elements.forEach((element)=>{
            Object.assign(element.style, {
                width: elementWidth
            });
            container.appendChild(element);
        });
        return container;
    };
    const createCard = (elements)=>{
        const card = document.createElement("div");
        Object.assign(card.style, {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
            boxSizing: "border-box",
            zIndex: "9998",
            margin: "0.5em"
        });
        elements.forEach((element)=>{
            card.appendChild(element);
        });
        return card;
    };
    root.appendChild(createHorizontalRuler());
    root.appendChild(createHeader("Paytable"));
    root.appendChild(createParagraph(`Rising Cup is a classic 5x3 video slot with 10 Bet lines.<br>
        The maximum win is 1000x bet!`));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createHeader("Wild Symbol"));
    root.appendChild(createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.wildsDemo.label));
    root.appendChild(createParagraph(`Wild symbol can appear on reels 2, 3, 4, and they always expand.<br>`));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createHeader("Symbols Pay (EUR)"));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createHeader("Scatter Symbols"));
    root.appendChild(createHorizontalElementSequence([
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.dollarSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>100</span>",
                "4: <span style='color: orange'>20</span>",
                "3: <span style='color: orange'>5</span>"
            ], false)
        ]),
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.starSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "1st, 3rd, and 5th reels:",
                "3: <span style='color: orange'>20</span>"
            ], false)
        ])
    ], "100%", "25%"));
    root.appendChild(createHorizontalElementSequence([
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.sevenSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>500</span>",
                "4: <span style='color: orange'>25</span>",
                "3: <span style='color: orange'>5</span>",
                "2: <span style='color: orange'>1</span>"
            ], false)
        ])
    ], "100%", "25%"));
    root.appendChild(createHorizontalElementSequence([
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.grapesSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>70</span>",
                "4: <span style='color: orange'>12</span>",
                "3: <span style='color: orange'>4</span>"
            ], false)
        ]),
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.watermelonSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>70</span>",
                "4: <span style='color: orange'>12</span>",
                "3: <span style='color: orange'>4</span>"
            ], false)
        ]),
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.bellSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>20</span>",
                "4: <span style='color: orange'>4</span>",
                "3: <span style='color: orange'>2</span>"
            ], false)
        ])
    ], "100%", "25%"));
    root.appendChild(createHorizontalElementSequence([
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.plumSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>15</span>",
                "4: <span style='color: orange'>3</span>",
                "3: <span style='color: orange'>1</span>"
            ], false)
        ]),
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.orangeSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>15</span>",
                "4: <span style='color: orange'>3</span>",
                "3: <span style='color: orange'>1</span>"
            ], false)
        ])
    ], "100%", "25%"));
    root.appendChild(createHorizontalElementSequence([
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.lemonSymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>15</span>",
                "4: <span style='color: orange'>3</span>",
                "3: <span style='color: orange'>1</span>"
            ], false)
        ]),
        createCard([
            createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.cherrySymbol.label, "100%", "5em", "0.2em"),
            createBulletList([
                "5: <span style='color: orange'>15</span>",
                "4: <span style='color: orange'>3</span>",
                "3: <span style='color: orange'>1</span>"
            ], false)
        ])
    ], "100%", "25%"));
    root.appendChild(createParagraph("A symbol's pay reflects current bet configuration."));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createHeader("Bet Lines"));
    root.appendChild(createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.betwaysDemo.label, "100%", "8em"));
    root.appendChild(createParagraph(`Winning combinations are formed from left to right on adjacent reels, beginning from the leftmost reel.\n<br>
        Only the highest winning combination is paid per line.`));
    // rgb(255, 133, 49) orange
    root.appendChild(createHorizontalRuler());
    root.appendChild(createCard([
        createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.spinButtonNew.label, "auto", "3em", "0.5em"),
        createBulletList([
            "Spin button."
        ], false, "0", "center")
    ]));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createCard([
        createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.buyButtonNew.label, "auto", "3em", "0.5em"),
        createBulletList([
            "Cheat button."
        ], false, "0", "center")
    ]));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createCard([
        createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.soundButtonOn.label, "auto", "3em", "0.5em"),
        createBulletList([
            "Sound toggle on/off."
        ], false, "0", "center")
    ]));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createCard([
        createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.autoplayButton.label, "auto", "3em", "0.5em"),
        createBulletList([
            "Allows specifying the amount of times autoplay will be executed."
        ], false, "0", "center")
    ]));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createCard([
        createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.fastButtonOn.label, "auto", "3em", "0.5em"),
        createBulletList([
            "Makes the spins faster."
        ], false, "0", "center")
    ]));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createCard([
        createImage((0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures.betDemo.label, "auto", "2em", "0.5em"),
        createBulletList([
            "Allows setting a custom bet amount. Cannot be changed during a spin. Max bet allowed is 100 EUR."
        ], false, "0", "center")
    ]));
    root.appendChild(createHorizontalRuler());
    root.appendChild(createHeader("Rules & Information"));
    root.appendChild(createBulletList([
        "The theoretical pay-out (RTP) is 96.08% and maximum win is 1000x bet.",
        "Bets are made in the casino currency, and there are 15 bet levels.",
        "The bet level cannot be changed during a game round.",
        "All wins are displayed and paid in the casino currency in accordance with the paytable.",
        "If a game round is interrupted, all information and bets will be displayed when the game is relaunched",
        "Wins from uninterrupted game rounds may be forfeited if they are not claimed within a certain period. Please see operator specific terms and conditions for details",
        "Malfunction voids all plays and pays"
    ], true, "1em"));
    return root;
};



parcelRequire("iuB9z");
var $9Gm4h = parcelRequire("9Gm4h");
parcelRequire("iuB9z");
var $9Gm4h = parcelRequire("9Gm4h");
var $fl08K = parcelRequire("fl08K");
var $58WFl = parcelRequire("58WFl");


// This only exists because Parcel and Pixi don't play well together
class $baaff11700c0735d$var$BundlingUtils {
    static getInstance() {
        if (!this._instance) this._instance = new $baaff11700c0735d$var$BundlingUtils();
        return this._instance;
    }
    /*
     * atlasPath - the json path
     */ async createSpritesheet(atlasJsonPath, atlasImgPath) {
        // Manually create the atlas
        const atlasResponse = await fetch(atlasJsonPath);
        const atlasData = await atlasResponse.json();
        // console.log("before");
        // console.log(atlasData);
        atlasData.meta.image = atlasImgPath;
        // console.log("after");
        // console.log(atlasData);
        // Load the PNG texture and create spritesheet
        const baseTexture = await (0, $9Gm4h.Assets).load(atlasImgPath);
        const spritesheet = new $58WFl.Spritesheet(baseTexture, atlasData);
        await spritesheet.parse();
        return spritesheet;
    }
    async createSpineAtlas(atlasPath, atlasImgPath) {
        const atlasResponse = await fetch(atlasPath);
        const atlasText = await atlasResponse.text();
        const lines = atlasText.split("\n");
        const imageName = atlasImgPath.split("/").pop();
        lines[0] = imageName || lines[0];
        const cleanedLines = lines.filter((line)=>!line.trim().startsWith("#"));
        const fixedAtlasText = cleanedLines.join("\n");
        const pixiTexture = await (0, $9Gm4h.Assets).load(atlasImgPath);
        // Import the required classes
        const { TextureAtlas: TextureAtlas } = await Promise.resolve((parcelRequire("6DlDK")));
        const { SpineTexture: SpineTexture } = await Promise.resolve((parcelRequire("logJB")));
        // Create the TextureAtlas
        const atlas = new TextureAtlas(fixedAtlasText);
        // Create the proper SpineTexture from the PIXI texture source
        const spineTexture = SpineTexture.from(pixiTexture.source);
        // Set the SpineTexture on all pages using the setTexture method
        atlas.pages.forEach((page)=>{
            page.setTexture(spineTexture);
        });
        return atlas;
    }
    // Preferable to use .fnt, xml currently not supported
    async createBitmapFont(fontPath, fontImgPath, fontName) {
        const fontText = await fetch(fontPath).then((res)=>res.text());
        const fontTexture = await (0, $9Gm4h.Assets).load(fontImgPath);
        const fontData = this._parseBMFontText(fontText, fontImgPath);
        // Debug: Log what characters we have
        // console.log('Available characters:', Object.keys(fontData.chars));
        // console.log('Font data:', fontData);
        const bitmapFont = new $fl08K.BitmapFont({
            data: fontData,
            textures: [
                fontTexture
            ]
        }, fontName);
        // console.log(bitmapFont);
        // Register it in PIXI's font cache
        $9Gm4h.Assets.cache.set(fontName, bitmapFont);
    }
    _parseBMFontText(fontText, imagePath) {
        // Retrieve data item
        const items = fontText.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        if (!items) throw new Error('Invalid font data');
        for(let i = 0; i < items.length; i++){
            // Extract item name
            const nameMatch = items[i].match(/^[a-z]+/gm);
            if (!nameMatch) continue;
            const name = nameMatch[0];
            // Extract item attribute list as string ex.: "width=10"
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            if (!attributeList) continue;
            // Convert attribute list into an object
            const itemData = {};
            for(let j = 0; j < attributeList.length; j++){
                // Split key-value pairs
                const split = attributeList[j].split('=');
                const key = split[0];
                // Remove eventual quotes from value
                const strValue = split[1].replace(/"/gm, '');
                // Try to convert value into float
                const floatValue = parseFloat(strValue);
                // Use string value case float value is NaN
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            // Push current item to the resulting data
            if (rawData[name]) rawData[name].push(itemData);
        }
        const font = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: '',
            distanceField: undefined,
            baseLineOffset: 0
        };
        const info = rawData.info?.[0];
        const common = rawData.common?.[0];
        const distanceField = rawData.distanceField?.[0];
        if (distanceField) font.distanceField = {
            range: parseInt(distanceField.distanceRange, 10),
            type: distanceField.fieldType
        };
        if (info) {
            font.fontSize = parseInt(info.size, 10);
            font.fontFamily = info.face;
        }
        if (common) {
            font.lineHeight = parseInt(common.lineHeight, 10);
            font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
        }
        const pages = rawData.page || [];
        for(let i = 0; i < pages.length; i++)font.pages.push({
            id: parseInt(pages[i].id, 10) || 0,
            file: pages[i].file
        });
        const map = {};
        const chars = rawData.char || [];
        for(let i = 0; i < chars.length; i++){
            const charNode = chars[i];
            const id = parseInt(charNode.id, 10);
            let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
            if (letter === 'space') letter = ' ';
            map[id] = letter;
            font.chars[letter] = {
                id: id,
                letter: letter,
                page: parseInt(charNode.page, 10) || 0,
                x: parseInt(charNode.x, 10),
                y: parseInt(charNode.y, 10),
                width: parseInt(charNode.width, 10),
                height: parseInt(charNode.height, 10),
                xOffset: parseInt(charNode.xoffset, 10),
                yOffset: parseInt(charNode.yoffset, 10),
                xAdvance: parseInt(charNode.xadvance, 10),
                kerning: {}
            };
        }
        // console.log('Final character map:', font.chars); // Debug log
        const kernings = rawData.kerning || [];
        for(let i = 0; i < kernings.length; i++){
            const first = parseInt(kernings[i].first, 10);
            const second = parseInt(kernings[i].second, 10);
            const amount = parseInt(kernings[i].amount, 10);
            if (font.chars[map[second]]) font.chars[map[second]].kerning[map[first]] = amount;
        }
        return font;
    }
}
const $baaff11700c0735d$export$3d44ee8fe8cc2628 = $baaff11700c0735d$var$BundlingUtils.getInstance();



var $6a26e0d21de83201$exports = {};
$6a26e0d21de83201$exports = import.meta.resolve("1CHjk");


var $da07b9343150bf0f$exports = {};
$da07b9343150bf0f$exports = import.meta.resolve("k5QSD");


var $514d97009c10bc1d$exports = {};
$514d97009c10bc1d$exports = import.meta.resolve("h3B4A");


var $9b19a37ed4c999d5$exports = {};
$9b19a37ed4c999d5$exports = import.meta.resolve("581hw");


var $7064e6f7ebe1e3eb$exports = {};
$7064e6f7ebe1e3eb$exports = import.meta.resolve("esjut");


var $55cb5a33b7ed5f75$exports = {};
$55cb5a33b7ed5f75$exports = import.meta.resolve("lLorJ");


var $426f974e20e99600$exports = {};
$426f974e20e99600$exports = import.meta.resolve("98mXi");


var $3507ddad093191b2$exports = {};
$3507ddad093191b2$exports = import.meta.resolve("fsOaW");


var $add02afb9a2a23e6$exports = {};
$add02afb9a2a23e6$exports = import.meta.resolve("2jlva");


var $e25e341c37a7ae8d$exports = {};
$e25e341c37a7ae8d$exports = import.meta.resolve("gZ2Yy");


var $28c2cc860b463149$exports = {};
$28c2cc860b463149$exports = import.meta.resolve("fwugm");


var $60797f1edc0693f5$exports = {};
$60797f1edc0693f5$exports = import.meta.resolve("f35PW");


var $a9334729710e446b$exports = {};
$a9334729710e446b$exports = import.meta.resolve("3vjRY");


var $aa21d9f6cb6c0e16$exports = {};
$aa21d9f6cb6c0e16$exports = import.meta.resolve("kpPg3");


var $22a246ae5960cd75$exports = {};
$22a246ae5960cd75$exports = import.meta.resolve("dOVaN");


var $54a0c0d1c972f9d7$exports = {};
$54a0c0d1c972f9d7$exports = import.meta.resolve("g6mZY");


var $cdd5d082a36cbcce$exports = {};
$cdd5d082a36cbcce$exports = import.meta.resolve("jk5Gr");


var $97a4b2336f7a9d8b$exports = {};
$97a4b2336f7a9d8b$exports = import.meta.resolve("3wFyV");


var $d5fbf0fc6ab27d76$exports = {};
$d5fbf0fc6ab27d76$exports = import.meta.resolve("5M9eU");


var $2f6925e711032d58$exports = {};
$2f6925e711032d58$exports = import.meta.resolve("1kJs1");


var $d17cf5d085096bdf$exports = {};
$d17cf5d085096bdf$exports = import.meta.resolve("1sWga");


var $8a94799204323313$exports = {};
$8a94799204323313$exports = import.meta.resolve("guYIn");


var $cc07d8ad44833980$exports = {};
$cc07d8ad44833980$exports = import.meta.resolve("e5Y7Q");


var $88d81540fb9b131c$exports = {};
$88d81540fb9b131c$exports = import.meta.resolve("9Mr8S");


var $f312dfaa6eaf5839$exports = {};
$f312dfaa6eaf5839$exports = import.meta.resolve("gj5JC");


var $43598aa938984ae6$exports = {};
$43598aa938984ae6$exports = import.meta.resolve("cyX43");


var $7079f7784e410a27$exports = {};
$7079f7784e410a27$exports = import.meta.resolve("kDCnT");


var $4c8278a5e7ad95bd$exports = {};
$4c8278a5e7ad95bd$exports = import.meta.resolve("5BOjD");


var $a1e962ff2d09082d$exports = {};
$a1e962ff2d09082d$exports = import.meta.resolve("gDBcp");


var $5cd3288346377261$exports = {};
$5cd3288346377261$exports = import.meta.resolve("gnvYe");


var $3d6b61f529185a7c$exports = {};
$3d6b61f529185a7c$exports = import.meta.resolve("2UgxS");


var $b260df433f8fefec$exports = {};
$b260df433f8fefec$exports = import.meta.resolve("mwHs1");


var $443650ebe1cbcfc5$exports = {};
$443650ebe1cbcfc5$exports = import.meta.resolve("83ayv");


var $6b249fb924178ced$exports = {};
$6b249fb924178ced$exports = import.meta.resolve("bejn7");


var $13b89b9f7c12fa49$exports = {};
$13b89b9f7c12fa49$exports = import.meta.resolve("f7BNw");


var $d34cf9eb8d6eae48$exports = {};
$d34cf9eb8d6eae48$exports = import.meta.resolve("1OJYS");


var $624e33886cf4db52$exports = {};
$624e33886cf4db52$exports = import.meta.resolve("lkkrE");


var $14afbc50ddc97022$exports = {};
$14afbc50ddc97022$exports = import.meta.resolve("iSYm2");


var $ed87541405d31a47$exports = {};
$ed87541405d31a47$exports = import.meta.resolve("6csiy");


var $39f1db122b0bd96a$exports = {};
$39f1db122b0bd96a$exports = import.meta.resolve("5g0Qs");


var $7d99dd6ba748b957$exports = {};
$7d99dd6ba748b957$exports = import.meta.resolve("fyUt5");


var $3d8f8fa4fbe543ae$exports = {};
$3d8f8fa4fbe543ae$exports = import.meta.resolve("eQOQe");


var $e555455c01eeeafa$exports = {};
$e555455c01eeeafa$exports = import.meta.resolve("5T2mf");


var $e3d3b0e2155cbf18$exports = {};
$e3d3b0e2155cbf18$exports = import.meta.resolve("9Dfbu");


var $8b981e1cd2df6968$exports = {};
$8b981e1cd2df6968$exports = import.meta.resolve("ljVpu");


var $1deef681c157f16e$exports = {};
$1deef681c157f16e$exports = import.meta.resolve("kYIgT");


var $5929031e3268abfc$exports = {};
$5929031e3268abfc$exports = import.meta.resolve("kGAg9");


var $35b05bee1fe8e4ef$exports = {};
$35b05bee1fe8e4ef$exports = import.meta.resolve("jwZFn");


var $db1b4c3d2a15c122$exports = {};
$db1b4c3d2a15c122$exports = import.meta.resolve("9S2Yx");


var $7d69faf0cc3bdd2c$exports = {};
$7d69faf0cc3bdd2c$exports = import.meta.resolve("6NZAK");


var $16a4aee4ba9197a9$exports = {};
$16a4aee4ba9197a9$exports = import.meta.resolve("8dhuO");


var $6a25d4c0d5289e42$exports = {};
$6a25d4c0d5289e42$exports = import.meta.resolve("7F88g");


var $eebed1e35c1ddcce$exports = {};
$eebed1e35c1ddcce$exports = import.meta.resolve("dv7bd");


var $ea3aecdca8fa9b17$exports = {};
$ea3aecdca8fa9b17$exports = import.meta.resolve("a3vPf");


var $0138965787ab40cb$exports = {};
$0138965787ab40cb$exports = import.meta.resolve("k7mEa");


var $7af159c289ffa129$exports = {};
$7af159c289ffa129$exports = import.meta.resolve("hHUZf");


var $1dad4e80f25b3d40$exports = {};
$1dad4e80f25b3d40$exports = import.meta.resolve("35yO6");


var $53e3e8b428ff3436$exports = {};
$53e3e8b428ff3436$exports = import.meta.resolve("ceCaO");


var $ba0037ba0b503d96$exports = {};
$ba0037ba0b503d96$exports = import.meta.resolve("hH3wk");


var $92c80c4c4aee5374$exports = {};
$92c80c4c4aee5374$exports = import.meta.resolve("lSYxV");


var $fe180c8a72276f9e$exports = {};
$fe180c8a72276f9e$exports = import.meta.resolve("kKOuB");


var $5755962a0af1c47e$exports = {};
$5755962a0af1c47e$exports = import.meta.resolve("8XZfm");


var $e419fb16512f3850$exports = {};
$e419fb16512f3850$exports = import.meta.resolve("73uX5");


var $7660bb2f3ade84b7$exports = {};
$7660bb2f3ade84b7$exports = import.meta.resolve("8RGlz");


var $9dcde0d580d4ac95$exports = {};
$9dcde0d580d4ac95$exports = import.meta.resolve("3zUSb");


var $1dcac37c49351ea2$exports = {};
$1dcac37c49351ea2$exports = import.meta.resolve("9463E");


var $e1eff5f598244cd7$exports = {};
$e1eff5f598244cd7$exports = import.meta.resolve("2I0ep");


var $b5568c616a3682e8$exports = {};
$b5568c616a3682e8$exports = import.meta.resolve("1aeso");


var $e98a0981af08e5ed$exports = {};
$e98a0981af08e5ed$exports = import.meta.resolve("gnPza");


var $988e0f37d766996a$exports = {};
$988e0f37d766996a$exports = import.meta.resolve("hhcnk");


var $8fbab532af9fc9c9$exports = {};
$8fbab532af9fc9c9$exports = import.meta.resolve("fOg7c");


var $e80e286584138d24$exports = {};
$e80e286584138d24$exports = import.meta.resolve("cAw8e");


var $d4416af710017d51$exports = {};
$d4416af710017d51$exports = import.meta.resolve("dqaH6");


var $b5d3919d74c57640$exports = {};
$b5d3919d74c57640$exports = import.meta.resolve("364Nb");


var $b9461a9181957022$exports = {};
$b9461a9181957022$exports = import.meta.resolve("5t42z");


var $e29789d3fc93a36c$exports = {};
$e29789d3fc93a36c$exports = import.meta.resolve("ap6XL");


var $c05724e847d18c16$exports = {};
$c05724e847d18c16$exports = import.meta.resolve("4xHa9");


var $9cdcc714482ebd96$exports = {};
$9cdcc714482ebd96$exports = import.meta.resolve("hxfbM");


var $2ea950490651a88d$exports = {};
$2ea950490651a88d$exports = import.meta.resolve("jRAuu");


var $cd0e82701f14e71f$exports = {};
$cd0e82701f14e71f$exports = import.meta.resolve("h3NUw");


var $8df39048bc09d462$exports = {};
$8df39048bc09d462$exports = import.meta.resolve("g4xJP");


var $060de3de77c36a78$exports = {};
$060de3de77c36a78$exports = import.meta.resolve("9acER");


var $be8cfe2654bdec11$exports = {};
$be8cfe2654bdec11$exports = import.meta.resolve("kkoA4");


var $18241dcca24dca38$exports = {};
$18241dcca24dca38$exports = import.meta.resolve("62epa");


var $c1b285eb59d5da02$exports = {};
$c1b285eb59d5da02$exports = import.meta.resolve("8e1pg");


var $adf4c51a6ff45ae1$exports = {};
$adf4c51a6ff45ae1$exports = import.meta.resolve("dYbpM");


var $3281b7566e625145$exports = {};
$3281b7566e625145$exports = import.meta.resolve("iLOpO");


var $3feeda1d8f1921f4$exports = {};
$3feeda1d8f1921f4$exports = import.meta.resolve("j5TWg");


var $bccca18f0cc29908$exports = {};
$bccca18f0cc29908$exports = import.meta.resolve("bXfiN");


var $e36fab9e25bb827b$exports = {};
$e36fab9e25bb827b$exports = import.meta.resolve("3ZYHK");


var $eab39e32074cba0f$exports = {};
$eab39e32074cba0f$exports = import.meta.resolve("at2yw");


var $f89ef2c37ca475d5$exports = {};
$f89ef2c37ca475d5$exports = import.meta.resolve("2POk8");


var $b8f651b4346ddf19$exports = {};
$b8f651b4346ddf19$exports = import.meta.resolve("04qKZ");


var $356f0d7dd2bafc5c$exports = {};
$356f0d7dd2bafc5c$exports = import.meta.resolve("dLI0G");


var $2c02faa669b48476$exports = {};
$2c02faa669b48476$exports = import.meta.resolve("l5b6w");


var $c74cb93fd8988b84$exports = {};
$c74cb93fd8988b84$exports = import.meta.resolve("jvDAC");



// NOTE: The files that need manual processing must not be added to any bundle, and must be created and processed manually
// I.e. createSpineAtlas, createBitmapFont, createSpritesheet
class $468255eb61580ecc$var$GameAssetManager {
    static getInstance() {
        if (!this._instance) this._instance = new $468255eb61580ecc$var$GameAssetManager();
        return this._instance;
    }
    createGameAssetBundles() {
        console.log("Adding loading bundle...");
        // Loading assets
        (0, $9Gm4h.Assets).addBundle("loading", {
            introBg: (0, (/*@__PURE__*/$parcel$interopDefault($9b19a37ed4c999d5$exports)))
        });
        console.log("Loading bundle added successfully!");
        console.log("Adding textures bundle...");
        // Texture assets
        (0, $9Gm4h.Assets).addBundle("textures", {
            mainBg: (0, (/*@__PURE__*/$parcel$interopDefault($7064e6f7ebe1e3eb$exports))),
            panel: (0, (/*@__PURE__*/$parcel$interopDefault($514d97009c10bc1d$exports))),
            fastButtonOn: (0, (/*@__PURE__*/$parcel$interopDefault($60797f1edc0693f5$exports))),
            fastButtonOff: (0, (/*@__PURE__*/$parcel$interopDefault($a9334729710e446b$exports))),
            spinButtonNew: (0, (/*@__PURE__*/$parcel$interopDefault($aa21d9f6cb6c0e16$exports))),
            buyButtonNew: (0, (/*@__PURE__*/$parcel$interopDefault($22a246ae5960cd75$exports))),
            betButtonNew: (0, (/*@__PURE__*/$parcel$interopDefault($54a0c0d1c972f9d7$exports))),
            bottomBarNew: (0, (/*@__PURE__*/$parcel$interopDefault($cdd5d082a36cbcce$exports))),
            bottomBarPortrait: (0, (/*@__PURE__*/$parcel$interopDefault($97a4b2336f7a9d8b$exports))),
            autoplayButton: (0, (/*@__PURE__*/$parcel$interopDefault($d5fbf0fc6ab27d76$exports))),
            amountBackground: (0, (/*@__PURE__*/$parcel$interopDefault($2f6925e711032d58$exports))),
            stopButtonNew: (0, (/*@__PURE__*/$parcel$interopDefault($d17cf5d085096bdf$exports))),
            soundButtonOn: (0, (/*@__PURE__*/$parcel$interopDefault($8a94799204323313$exports))),
            soundButtonOff: (0, (/*@__PURE__*/$parcel$interopDefault($cc07d8ad44833980$exports))),
            infoButton: (0, (/*@__PURE__*/$parcel$interopDefault($88d81540fb9b131c$exports))),
            starSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($c1b285eb59d5da02$exports))),
            dollarSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($18241dcca24dca38$exports))),
            sevenSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($adf4c51a6ff45ae1$exports))),
            grapesSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($3281b7566e625145$exports))),
            watermelonSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($3feeda1d8f1921f4$exports))),
            bellSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($bccca18f0cc29908$exports))),
            plumSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($e36fab9e25bb827b$exports))),
            orangeSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($eab39e32074cba0f$exports))),
            lemonSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($f89ef2c37ca475d5$exports))),
            cherrySymbol: (0, (/*@__PURE__*/$parcel$interopDefault($b8f651b4346ddf19$exports))),
            wildsDemo: (0, (/*@__PURE__*/$parcel$interopDefault($356f0d7dd2bafc5c$exports))),
            betDemo: (0, (/*@__PURE__*/$parcel$interopDefault($2c02faa669b48476$exports))),
            betwaysDemo: (0, (/*@__PURE__*/$parcel$interopDefault($c74cb93fd8988b84$exports)))
        });
        console.log("Textures bundle added successfully!");
        console.log("Adding spines bundle...");
        // Spine assets
        (0, $9Gm4h.Assets).addBundle("spines", {
            winsJson: (0, (/*@__PURE__*/$parcel$interopDefault($db1b4c3d2a15c122$exports))),
            bellJson: (0, (/*@__PURE__*/$parcel$interopDefault($4c8278a5e7ad95bd$exports))),
            cloverJson: (0, (/*@__PURE__*/$parcel$interopDefault($3d6b61f529185a7c$exports))),
            crownJson: (0, (/*@__PURE__*/$parcel$interopDefault($624e33886cf4db52$exports))),
            dollarJson: (0, (/*@__PURE__*/$parcel$interopDefault($39f1db122b0bd96a$exports))),
            lowsJson: (0, (/*@__PURE__*/$parcel$interopDefault($e555455c01eeeafa$exports))),
            sevenJson: (0, (/*@__PURE__*/$parcel$interopDefault($f312dfaa6eaf5839$exports))),
            starJson: (0, (/*@__PURE__*/$parcel$interopDefault($6b249fb924178ced$exports))),
            wildJson: (0, (/*@__PURE__*/$parcel$interopDefault($1deef681c157f16e$exports))),
            paylinesJson: (0, (/*@__PURE__*/$parcel$interopDefault($6a25d4c0d5289e42$exports))),
            bulbsJson: (0, (/*@__PURE__*/$parcel$interopDefault($0138965787ab40cb$exports))),
            logoJson: (0, (/*@__PURE__*/$parcel$interopDefault($53e3e8b428ff3436$exports))),
            anticipationJson: (0, (/*@__PURE__*/$parcel$interopDefault($fe180c8a72276f9e$exports)))
        });
        console.log("Spines bundle added successfully!");
        console.log("Adding audio bundle...");
        // Audio assets
        (0, $9Gm4h.Assets).addBundle("audio", {
            coinLoop: (0, (/*@__PURE__*/$parcel$interopDefault($7660bb2f3ade84b7$exports))),
            musicMain: (0, (/*@__PURE__*/$parcel$interopDefault($9dcde0d580d4ac95$exports))),
            winBig: (0, (/*@__PURE__*/$parcel$interopDefault($e1eff5f598244cd7$exports))),
            winMega: (0, (/*@__PURE__*/$parcel$interopDefault($b5568c616a3682e8$exports))),
            winNormal: (0, (/*@__PURE__*/$parcel$interopDefault($e98a0981af08e5ed$exports))),
            winSmall: (0, (/*@__PURE__*/$parcel$interopDefault($988e0f37d766996a$exports))),
            winSuper: (0, (/*@__PURE__*/$parcel$interopDefault($8fbab532af9fc9c9$exports))),
            winEnd: (0, (/*@__PURE__*/$parcel$interopDefault($e80e286584138d24$exports))),
            buttonClick: (0, (/*@__PURE__*/$parcel$interopDefault($d4416af710017d51$exports))),
            paylineShow: (0, (/*@__PURE__*/$parcel$interopDefault($b5d3919d74c57640$exports))),
            matchShow: (0, (/*@__PURE__*/$parcel$interopDefault($b9461a9181957022$exports))),
            reelSpinLoop: (0, (/*@__PURE__*/$parcel$interopDefault($e29789d3fc93a36c$exports))),
            reelStop: (0, (/*@__PURE__*/$parcel$interopDefault($c05724e847d18c16$exports))),
            anticipation: (0, (/*@__PURE__*/$parcel$interopDefault($9cdcc714482ebd96$exports))),
            appearingWild: (0, (/*@__PURE__*/$parcel$interopDefault($2ea950490651a88d$exports))),
            expandingWild: (0, (/*@__PURE__*/$parcel$interopDefault($cd0e82701f14e71f$exports)))
        });
        console.log("Audio bundle added successfully!");
    }
    /**
   * Load assets required for the loading screen.
   */ async loadLoadingScreenAssets() {
        await (0, $bbd3d886140ad386$export$402b940662af5211).createSound({
            url: (0, (/*@__PURE__*/$parcel$interopDefault($1dcac37c49351ea2$exports))),
            key: "startGame"
        });
        const loadingAssets = await (0, $9Gm4h.Assets).loadBundle("loading");
        // Add the spritesheet to loading assets
        loadingAssets.loadingAtlas = await (0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpritesheet((0, (/*@__PURE__*/$parcel$interopDefault($6a26e0d21de83201$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($da07b9343150bf0f$exports))));
        (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).loading = loadingAssets;
    }
    /**
   * Load custom fonts for the game.
   */ async loadFonts() {
        const font = new FontFace("UIFont", `url(${(0, (/*@__PURE__*/$parcel$interopDefault($8df39048bc09d462$exports)))})`);
        const textFont = new FontFace("TextFont", `url(${(0, (/*@__PURE__*/$parcel$interopDefault($060de3de77c36a78$exports)))})`);
        const lcdFont = new FontFace("LcdFont", `url(${(0, (/*@__PURE__*/$parcel$interopDefault($be8cfe2654bdec11$exports)))})`);
        try {
            await font.load();
            await textFont.load();
            await lcdFont.load();
            document.fonts.add(font);
            document.fonts.add(textFont);
            document.fonts.add(lcdFont);
        } catch (err) {
            console.error("Failed to load fonts:", err);
        }
    }
    /**
   * Load game assets and track loading progress.
   */ async loadGameAssets(progressCallback, completeCallback) {
        let soundLoadingProgress = 0;
        let customAssetsProgress = 0;
        const updateProgress = ()=>{
            const combinedProgress = (this._totalProgress.textures + this._totalProgress.skeletons + this._totalProgress.audio + soundLoadingProgress + customAssetsProgress) / 5;
            progressCallback?.(combinedProgress);
        };
        const textures = await (0, $9Gm4h.Assets).loadBundle("textures", (progress)=>{
            this._totalProgress.textures = progress;
            updateProgress();
        });
        const skeletons = await (0, $9Gm4h.Assets).loadBundle("spines", (progress)=>{
            this._totalProgress.skeletons = progress;
            updateProgress();
        });
        const audio = await (0, $9Gm4h.Assets).loadBundle("audio", (progress)=>{
            this._totalProgress.audio = progress;
            updateProgress();
        });
        await this._loadSounds((progress)=>{
            soundLoadingProgress = progress;
            updateProgress();
        });
        await this._loadCustomGameAssets(textures, skeletons, (progress)=>{
            customAssetsProgress = progress;
            updateProgress();
        });
        // Register ALL spine assets in PIXI's cache
        Object.keys(skeletons).forEach((key)=>{
            $9Gm4h.Assets.cache.set(key, skeletons[key]);
        });
        (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).textures = textures;
        (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).skeletons = skeletons;
        (0, $b1e2b63f4c00c05f$export$2f9cf3b1fe5e98c6).audio = audio;
        completeCallback?.();
    }
    async _loadCustomGameAssets(textures, skeletons, callback) {
        const assetDefs = [
            // {
            //     key: "gameAtlas",
            //     createFunction: () => bundlingUtils.createSpritesheet(gameAtlasUrl, gameAtlasPngUrl),
            //     bundle: textures,
            // },
            {
                key: "uiAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpritesheet((0, (/*@__PURE__*/$parcel$interopDefault($3507ddad093191b2$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($add02afb9a2a23e6$exports)))),
                bundle: textures
            },
            {
                key: "coinAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpritesheet((0, (/*@__PURE__*/$parcel$interopDefault($55cb5a33b7ed5f75$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($426f974e20e99600$exports)))),
                bundle: textures
            },
            {
                key: "winsAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($7d69faf0cc3bdd2c$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($16a4aee4ba9197a9$exports)))),
                bundle: skeletons
            },
            {
                key: "bellAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($a1e962ff2d09082d$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($5cd3288346377261$exports)))),
                bundle: skeletons
            },
            {
                key: "cloverAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($b260df433f8fefec$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($443650ebe1cbcfc5$exports)))),
                bundle: skeletons
            },
            {
                key: "crownAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($14afbc50ddc97022$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ed87541405d31a47$exports)))),
                bundle: skeletons
            },
            {
                key: "dollarAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($7d99dd6ba748b957$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3d8f8fa4fbe543ae$exports)))),
                bundle: skeletons
            },
            {
                key: "lowsAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($e3d3b0e2155cbf18$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($8b981e1cd2df6968$exports)))),
                bundle: skeletons
            },
            {
                key: "sevenAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($43598aa938984ae6$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($7079f7784e410a27$exports)))),
                bundle: skeletons
            },
            {
                key: "starAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($13b89b9f7c12fa49$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($d34cf9eb8d6eae48$exports)))),
                bundle: skeletons
            },
            {
                key: "wildAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($5929031e3268abfc$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($35b05bee1fe8e4ef$exports)))),
                bundle: skeletons
            },
            {
                key: "paylinesAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($eebed1e35c1ddcce$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ea3aecdca8fa9b17$exports)))),
                bundle: skeletons
            },
            {
                key: "bulbsAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($7af159c289ffa129$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($1dad4e80f25b3d40$exports)))),
                bundle: skeletons
            },
            {
                key: "logoAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($ba0037ba0b503d96$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($92c80c4c4aee5374$exports)))),
                bundle: skeletons
            },
            {
                key: "anticipationAtlas",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createSpineAtlas((0, (/*@__PURE__*/$parcel$interopDefault($5755962a0af1c47e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($e419fb16512f3850$exports)))),
                bundle: skeletons
            },
            {
                key: "font",
                createFunction: ()=>(0, $baaff11700c0735d$export$3d44ee8fe8cc2628).createBitmapFont((0, (/*@__PURE__*/$parcel$interopDefault($e25e341c37a7ae8d$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($28c2cc860b463149$exports))), "WinFont"),
                bundle: null
            }
        ];
        const total = assetDefs.length;
        let completed = 0;
        const wrappedPromises = assetDefs.map((data)=>data.createFunction().then((result)=>{
                if (data.bundle) data.bundle[data.key] = result;
                completed++;
                callback(completed / total);
            }));
        await Promise.all(wrappedPromises);
    }
    async _loadSounds(callback) {
        const soundDefs = [
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($9dcde0d580d4ac95$exports))),
                key: "musicMain",
                loop: true,
                volume: 0.6
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($e1eff5f598244cd7$exports))),
                key: "winBig"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($b5568c616a3682e8$exports))),
                key: "winMega"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($e98a0981af08e5ed$exports))),
                key: "winNormal"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($8fbab532af9fc9c9$exports))),
                key: "winSuper"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($988e0f37d766996a$exports))),
                key: "winSmall"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($e80e286584138d24$exports))),
                key: "winEnd"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($d4416af710017d51$exports))),
                key: "buttonClick"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($b5d3919d74c57640$exports))),
                key: "paylineShow"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($b9461a9181957022$exports))),
                key: "matchShow",
                volume: 0.7
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($e29789d3fc93a36c$exports))),
                key: "reelSpinLoop",
                loop: true,
                volume: 0.5
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($c05724e847d18c16$exports))),
                key: "reelStop",
                volume: 0.5
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($7660bb2f3ade84b7$exports))),
                key: "coinLoop",
                loop: true
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($9cdcc714482ebd96$exports))),
                key: "anticipation"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($2ea950490651a88d$exports))),
                key: "appearingWild"
            },
            {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($cd0e82701f14e71f$exports))),
                key: "expandingWild"
            }
        ];
        const total = soundDefs.length;
        let completed = 0;
        const wrappedPromises = soundDefs.map((loadConfig)=>(0, $bbd3d886140ad386$export$402b940662af5211).createSound(loadConfig).then(()=>{
                completed++;
                callback(completed / total);
            }));
        await Promise.all(wrappedPromises);
    }
    constructor(){
        this._totalProgress = {
            textures: 0,
            skeletons: 0,
            audio: 0
        };
    }
}
const $468255eb61580ecc$export$95c6fd5f90333ae1 = $468255eb61580ecc$var$GameAssetManager.getInstance();




class $b4e14b6b8da86996$var$GameApp {
    constructor(){
        // Constants for aspect ratio and screen dimensions
        this.MAX_ASPECT_RATIO = 20 / 9;
        this.HEIGHT_LANDSCAPE = 1080;
        this.HEIGHT_PORTRAIT = 1920;
        // Intro view and loading progress tracking
        this._introView = null;
        // Use the singleton instance of PIXI.Application
        const appSingleton = (0, $1207aae49fb03bed$export$2e2bcd8739ae039).getInstance();
        this._app = appSingleton.app;
    }
    /**
   * Launch the game application.
   */ async launch() {
        await this.initApp();
        (0, $468255eb61580ecc$export$95c6fd5f90333ae1).createGameAssetBundles();
        await (0, $468255eb61580ecc$export$95c6fd5f90333ae1).loadLoadingScreenAssets();
        await (0, $468255eb61580ecc$export$95c6fd5f90333ae1).loadFonts();
        // await soundManager.playSound("startGame");
        this.setupIntro();
        await (0, $468255eb61580ecc$export$95c6fd5f90333ae1).loadGameAssets((progress)=>{
            this._introView?.updateProgress(progress);
        }, ()=>{
            this._introView?.showTapText();
        });
        this.setupResizeHandler();
        await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("startGame", {
            volume: 0.2
        });
        document.addEventListener("buttonClicked", async (_)=>{
            await (0, $bbd3d886140ad386$export$402b940662af5211).playSound("buttonClick");
        });
    }
    /**
   * Initialize the PIXI application.
   */ async initApp() {
        await this._app.init({
            background: "#000",
            resizeTo: window,
            resolution: window.devicePixelRatio,
            autoDensity: true
        });
        // Append the canvas to the document body
        document.body.appendChild(this._app.canvas);
    }
    /**
   * Set up the intro screen and start loading game assets.
   */ setupIntro() {
        this._introView = new (0, $a132e74cb7d48d50$export$2d669a97455aff47)();
        this._introView.on("onScreenClick", this.onIntroComplete.bind(this));
        this._app.stage.addChild(this._introView);
        this.resize();
    }
    /**
   * Set up the resize event handler.
   */ setupResizeHandler() {
        window.addEventListener("resize", ()=>this.resize());
    }
    /**
   * Handle window resizing and adjust the stage accordingly.
   */ resize() {
        const width = window.innerWidth;
        let height = window.innerHeight;
        // Detect mobile device (include iPad on iPadOS which may report as Mac)
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isIos = /iPad|iPhone|iPod/.test(ua) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        const isAndroid = /Android/.test(ua);
        const isMobile = /Mobi|Opera Mini|IEMobile/.test(ua) || isIos || isAndroid;
        if (isMobile) height *= 0.96; // Add 50px bottom padding for mobile
        this._app.renderer.resolution = window.devicePixelRatio || 1;
        this._app.stage.x = width / 2;
        this._app.stage.y = height / 2;
        const ratio = width / height;
        const scale = height / (ratio < 1.4 ? this.HEIGHT_PORTRAIT : this.HEIGHT_LANDSCAPE);
        this._app.stage.scale.set(scale);
        this._app.renderer.resize(width, height);
        this._app.stage.emit("resize", {
            scale: scale,
            ratio: ratio
        });
    }
    /**
   * Handle the completion of the intro screen.
   */ async onIntroComplete() {
        this._app.stage.removeChildren();
        await this.initializeGameComponents();
        const gameView = new (0, $3d7595cac94e0caa$export$b19c5de2fd1b675d)();
        this._app.stage.addChild(gameView);
        await (0, $5c4dd7c86681d247$export$69b20b9d7ca9f56e).updateBgMusic("gameStart");
        (0, $0babc81d9126a9d0$export$fa4290cbf89215ed).setContent((0, $4ee0c75a4c6267c4$export$b6340ac26c877cc)());
        this.resize();
    }
    /**
   * Initialize game components like symbols, paylines, and particles.
   */ async initializeGameComponents() {
        await (0, $7502dfc019795313$export$4193d9976a2c789).getInstance().init();
        (0, $4706fae892b9b431$export$3e25e887b7a5b37b).createPool(60);
        (0, $ea6ab95c0dda9d47$export$dd7da141bf57a565).createPool(5);
    }
}
// Launch the game
const $b4e14b6b8da86996$var$gameApp = new $b4e14b6b8da86996$var$GameApp();
$b4e14b6b8da86996$var$gameApp.launch();
var $b4e14b6b8da86996$export$2e2bcd8739ae039 = $b4e14b6b8da86996$var$gameApp;


//# sourceMappingURL=slot-risingcup.927672c3.js.map
